(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb68c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb68c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kkC0S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAuthApi = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");
class $ecd32988692237ac$var$BaseAuthApi {
    /**
     * Creates a user action challenge
     */ static async createUserActionChallenge(request, options) {
        const response = await (0, $cZ5A6.simpleFetch)('/auth/action/init', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Sign a user action challenge
     */ static async signUserActionChallenge(request, options) {
        const response = await (0, $cZ5A6.simpleFetch)('/auth/action', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Initiates user login, by creating a challenge that will need to be signed by the user Credentials.
     */ static async createUserLoginChallenge(request, options) {
        const response = await (0, $cZ5A6.simpleFetch)('/auth/login/init', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Completes user login by sending the signed login challenge.
     */ static async createUserLogin(request, options) {
        const response = await (0, $cZ5A6.simpleFetch)('/auth/login', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Completes user logout by sending the user auth token.
     */ static async userLogout(options) {
        if (!options.authToken) throw new Error('authToken is required');
        const response = await (0, $cZ5A6.simpleFetch)('/auth/logout', {
            method: 'PUT',
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Initiates Registration by creating a challenge that will need to be signed by a new set of Credentials.
     */ static async createUserRegistrationChallenge(request, options) {
        const response = await (0, $cZ5A6.simpleFetch)('/auth/registration/init', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Completes Registration by sending the signed registration challenge, containing the new Credential identity created.
     */ static async createUserRegistration(request, options) {
        const response = await (0, $cZ5A6.simpleFetch)('/auth/registration', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
    /**
     * Completes Recovery by sending the signed recovery challenge, containing the new Credential identity created.
     */ async createUserRecovery(request, options) {
        const response = await (0, $cZ5A6.simpleFetch)('/auth/recover/user', {
            method: 'POST',
            body: request,
            apiOptions: options
        });
        return response.json();
    }
}
module.exports.BaseAuthApi = $ecd32988692237ac$var$BaseAuthApi;

});
parcelRegister("cZ5A6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.simpleFetch = module.exports.dfnsAuth = module.exports.catchPolicyPending = module.exports.errorHandler = module.exports.formDataSerializer = module.exports.jsonSerializer = module.exports.fullUrl = void 0;

var $3N3x2 = parcelRequire("3N3x2");

var $gSZ2x = parcelRequire("gSZ2x");

var $dfApp = parcelRequire("dfApp");

var $cLNTu = parcelRequire("cLNTu");
const $973f82dc439d29ac$var$DEFAULT_DFNS_BASE_URL = 'https://api.dfns.io';

var $ceSi5 = parcelRequire("ceSi5");
const $973f82dc439d29ac$var$fullUrl = (fetch)=>{
    return async (resource, options)=>{
        const baseUrl = options.apiOptions.baseUrl || $973f82dc439d29ac$var$DEFAULT_DFNS_BASE_URL;
        resource = new URL(resource, baseUrl);
        return fetch(resource, options);
    };
};
module.exports.fullUrl = $973f82dc439d29ac$var$fullUrl;
const $973f82dc439d29ac$var$jsonSerializer = (fetch)=>{
    return async (resource, options)=>{
        if (options.body && !(options.body instanceof FormData)) {
            options.body = JSON.stringify(options.body);
            options.headers = {
                'content-type': 'application/json',
                ...options.headers ?? {}
            };
        }
        return fetch(resource, options);
    };
};
module.exports.jsonSerializer = $973f82dc439d29ac$var$jsonSerializer;
const $973f82dc439d29ac$var$formDataSerializer = (fetch)=>{
    return async (resource, options)=>{
        if (!options.file) return fetch(resource, options);
        const { bytes: bytes, name: name } = options.file;
        const fileChecksum = await (0, $cLNTu.sha256)(bytes);
        const body = {
            ...options.body ?? {},
            fileChecksum: fileChecksum
        };
        const form = new FormData();
        form.append('data', JSON.stringify(body));
        form.append('file', new Blob([
            bytes
        ]), name);
        return fetch(resource, {
            ...options,
            body: form
        });
    };
};
module.exports.formDataSerializer = $973f82dc439d29ac$var$formDataSerializer;
const $973f82dc439d29ac$var$errorHandler = (fetch)=>{
    return async (resource, options)=>{
        const response = await fetch(resource, options);
        if (response.ok) return response;
        else {
            const body = await response.json();
            const message = body?.error?.message ?? body?.message;
            throw new $gSZ2x.DfnsError(response.status, message, {
                url: response.url,
                headers: response.headers,
                body: body
            });
        }
    };
};
module.exports.errorHandler = $973f82dc439d29ac$var$errorHandler;
// raise a 202 response by policy execution as error
const $973f82dc439d29ac$var$catchPolicyPending = (fetch)=>{
    return async (resource, options)=>{
        const response = await fetch(resource, options);
        if (response.status === $gSZ2x.PolicyPendingError.HTTP_ACCEPTED) throw new $gSZ2x.PolicyPendingError(await response.json());
        else return response;
    };
};
module.exports.catchPolicyPending = $973f82dc439d29ac$var$catchPolicyPending;
const $973f82dc439d29ac$var$dfnsAuth = (fetch)=>{
    return async (resource, options)=>{
        const { orgId: orgId, authToken: authToken } = options.apiOptions;
        if (authToken && orgId) (0, $dfApp.assertAuthTokenIsSameOrg)({
            orgId: orgId,
            authToken: authToken
        });
        const authorization = authToken ? {
            authorization: `Bearer ${authToken}`
        } : {};
        options.headers = {
            'x-dfns-sdk-version': $ceSi5.version,
            ...authorization,
            ...options.headers ?? {}
        };
        return fetch(resource, options);
    };
};
module.exports.dfnsAuth = $973f82dc439d29ac$var$dfnsAuth;
module.exports.simpleFetch = (0, module.exports.fullUrl)((0, module.exports.jsonSerializer)((0, module.exports.dfnsAuth)((0, module.exports.catchPolicyPending)((0, module.exports.errorHandler)($3N3x2.fetch)))));

});
parcelRegister("3N3x2", function(module, exports) {
var global = typeof self !== 'undefined' ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: 'URLSearchParams' in self1,
            iterable: 'Symbol' in self1 && 'iterator' in Symbol,
            blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in self1,
            arrayBuffer: 'ArrayBuffer' in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException('Aborted', 'AbortError'));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("gSZ2x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PolicyPendingError = module.exports.DfnsError = void 0;
class $c4b109b906842aab$var$DfnsError extends Error {
    constructor(httpStatus, message, context){
        super(message);
        this.httpStatus = httpStatus;
        this.context = context;
        this.name = 'DfnsError';
    }
    toString() {
        return JSON.stringify({
            httpStatus: this.httpStatus,
            message: this.message,
            ...this.context && this.context
        }, null, 2);
    }
}
module.exports.DfnsError = $c4b109b906842aab$var$DfnsError;
class $c4b109b906842aab$var$PolicyPendingError extends $c4b109b906842aab$var$DfnsError {
    constructor(context){
        super($c4b109b906842aab$var$PolicyPendingError.HTTP_ACCEPTED, 'Operation triggered a policy pending approval', context);
    }
}
module.exports.PolicyPendingError = $c4b109b906842aab$var$PolicyPendingError;
$c4b109b906842aab$var$PolicyPendingError.HTTP_ACCEPTED = 202;

});

parcelRegister("dfApp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertAuthTokenIsSameOrg = module.exports.JWT_CUSTOM_DATA_CLAIM = void 0;

var $b3jWV = parcelRequire("b3jWV");
module.exports.JWT_CUSTOM_DATA_CLAIM = 'https://custom/app_metadata';
const $9a58eb19cd0fdbf4$var$assertAuthTokenIsSameOrg = ({ authToken: authToken, orgId: orgId })=>{
    const tokenBody = authToken.split('.')?.[1] || '';
    let decoded;
    try {
        decoded = JSON.parse((0, $b3jWV.fromBase64)(tokenBody).toString('utf-8'));
    } catch (error) {
        throw new Error('Provided auth token could not be properly parsed');
    }
    const tokenOrgId = decoded?.[module.exports.JWT_CUSTOM_DATA_CLAIM]?.['orgId'];
    if (tokenOrgId !== orgId) throw new Error(`Provided auth token is not scoped to org ID ${orgId}`);
};
module.exports.assertAuthTokenIsSameOrg = $9a58eb19cd0fdbf4$var$assertAuthTokenIsSameOrg;

});
parcelRegister("b3jWV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64Url = module.exports.toBase64Url = module.exports.fromBase64 = module.exports.toBase64 = void 0;

var $B0S8N = parcelRequire("B0S8N");
const $80bf7312b6227263$var$pad = (topad)=>{
    const padLength = 4 - topad.length % 4;
    if (padLength < 4) topad += '='.repeat(padLength);
    return topad;
};
const $80bf7312b6227263$var$toBase64 = (buffer)=>{
    if (typeof buffer === 'string') buffer = $B0S8N.Buffer.from(buffer);
    return buffer.toString('base64');
};
module.exports.toBase64 = $80bf7312b6227263$var$toBase64;
const $80bf7312b6227263$var$fromBase64 = (encoded)=>{
    return $B0S8N.Buffer.from($80bf7312b6227263$var$pad(encoded), 'base64');
};
module.exports.fromBase64 = $80bf7312b6227263$var$fromBase64;
const $80bf7312b6227263$var$toBase64Url = (buffer)=>{
    return (0, module.exports.toBase64)(buffer).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};
module.exports.toBase64Url = $80bf7312b6227263$var$toBase64Url;
const $80bf7312b6227263$var$fromBase64Url = (encoded)=>{
    encoded = $80bf7312b6227263$var$pad(encoded).replace(/\-/g, '+').replace(/_/g, '/');
    return $B0S8N.Buffer.from(encoded, 'base64');
};
module.exports.fromBase64Url = $80bf7312b6227263$var$fromBase64Url;

});
parcelRegister("B0S8N", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $06f422066f8a6854$export$a143d493d941bafc, (v) => $06f422066f8a6854$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $06f422066f8a6854$export$f99ded8fe4b79145, (v) => $06f422066f8a6854$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $06f422066f8a6854$export$a143d493d941bafc;
var $06f422066f8a6854$export$e4cf37d7f6fb9e0a;
var $06f422066f8a6854$export$f99ded8fe4b79145;
var $06f422066f8a6854$export$599f31c3813fae4d;
'use strict';

var $3I1Rb = parcelRequire("3I1Rb");

var $f6JmG = parcelRequire("f6JmG");
const $06f422066f8a6854$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$06f422066f8a6854$export$a143d493d941bafc = $06f422066f8a6854$var$Buffer;
$06f422066f8a6854$export$e4cf37d7f6fb9e0a = $06f422066f8a6854$var$SlowBuffer;
$06f422066f8a6854$export$f99ded8fe4b79145 = 50;
const $06f422066f8a6854$var$K_MAX_LENGTH = 0x7fffffff;
$06f422066f8a6854$export$599f31c3813fae4d = $06f422066f8a6854$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $06f422066f8a6854$var$Buffer.TYPED_ARRAY_SUPPORT = $06f422066f8a6854$var$typedArraySupport();
if (!$06f422066f8a6854$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $06f422066f8a6854$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($06f422066f8a6854$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$06f422066f8a6854$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($06f422066f8a6854$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$06f422066f8a6854$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $06f422066f8a6854$var$createBuffer(length) {
    if (length > $06f422066f8a6854$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $06f422066f8a6854$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $06f422066f8a6854$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $06f422066f8a6854$var$allocUnsafe(arg);
    }
    return $06f422066f8a6854$var$from(arg, encodingOrOffset, length);
}
$06f422066f8a6854$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $06f422066f8a6854$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $06f422066f8a6854$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $06f422066f8a6854$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($06f422066f8a6854$var$isInstance(value, ArrayBuffer) || value && $06f422066f8a6854$var$isInstance(value.buffer, ArrayBuffer)) return $06f422066f8a6854$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($06f422066f8a6854$var$isInstance(value, SharedArrayBuffer) || value && $06f422066f8a6854$var$isInstance(value.buffer, SharedArrayBuffer))) return $06f422066f8a6854$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $06f422066f8a6854$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $06f422066f8a6854$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $06f422066f8a6854$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $06f422066f8a6854$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $06f422066f8a6854$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($06f422066f8a6854$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($06f422066f8a6854$var$Buffer, Uint8Array);
function $06f422066f8a6854$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $06f422066f8a6854$var$alloc(size, fill, encoding) {
    $06f422066f8a6854$var$assertSize(size);
    if (size <= 0) return $06f422066f8a6854$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $06f422066f8a6854$var$createBuffer(size).fill(fill, encoding) : $06f422066f8a6854$var$createBuffer(size).fill(fill);
    return $06f422066f8a6854$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $06f422066f8a6854$var$Buffer.alloc = function(size, fill, encoding) {
    return $06f422066f8a6854$var$alloc(size, fill, encoding);
};
function $06f422066f8a6854$var$allocUnsafe(size) {
    $06f422066f8a6854$var$assertSize(size);
    return $06f422066f8a6854$var$createBuffer(size < 0 ? 0 : $06f422066f8a6854$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $06f422066f8a6854$var$Buffer.allocUnsafe = function(size) {
    return $06f422066f8a6854$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $06f422066f8a6854$var$Buffer.allocUnsafeSlow = function(size) {
    return $06f422066f8a6854$var$allocUnsafe(size);
};
function $06f422066f8a6854$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$06f422066f8a6854$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $06f422066f8a6854$var$byteLength(string, encoding) | 0;
    let buf = $06f422066f8a6854$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $06f422066f8a6854$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $06f422066f8a6854$var$checked(array.length) | 0;
    const buf = $06f422066f8a6854$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $06f422066f8a6854$var$fromArrayView(arrayView) {
    if ($06f422066f8a6854$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $06f422066f8a6854$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $06f422066f8a6854$var$fromArrayLike(arrayView);
}
function $06f422066f8a6854$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $06f422066f8a6854$var$Buffer.prototype);
    return buf;
}
function $06f422066f8a6854$var$fromObject(obj) {
    if ($06f422066f8a6854$var$Buffer.isBuffer(obj)) {
        const len = $06f422066f8a6854$var$checked(obj.length) | 0;
        const buf = $06f422066f8a6854$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $06f422066f8a6854$var$numberIsNaN(obj.length)) return $06f422066f8a6854$var$createBuffer(0);
        return $06f422066f8a6854$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $06f422066f8a6854$var$fromArrayLike(obj.data);
}
function $06f422066f8a6854$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $06f422066f8a6854$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $06f422066f8a6854$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $06f422066f8a6854$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $06f422066f8a6854$var$Buffer.alloc(+length);
}
$06f422066f8a6854$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $06f422066f8a6854$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$06f422066f8a6854$var$Buffer.compare = function compare(a, b) {
    if ($06f422066f8a6854$var$isInstance(a, Uint8Array)) a = $06f422066f8a6854$var$Buffer.from(a, a.offset, a.byteLength);
    if ($06f422066f8a6854$var$isInstance(b, Uint8Array)) b = $06f422066f8a6854$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$06f422066f8a6854$var$Buffer.isBuffer(a) || !$06f422066f8a6854$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$06f422066f8a6854$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$06f422066f8a6854$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $06f422066f8a6854$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $06f422066f8a6854$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($06f422066f8a6854$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$06f422066f8a6854$var$Buffer.isBuffer(buf)) buf = $06f422066f8a6854$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$06f422066f8a6854$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $06f422066f8a6854$var$byteLength(string, encoding) {
    if ($06f422066f8a6854$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $06f422066f8a6854$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $06f422066f8a6854$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $06f422066f8a6854$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $06f422066f8a6854$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$06f422066f8a6854$var$Buffer.byteLength = $06f422066f8a6854$var$byteLength;
function $06f422066f8a6854$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $06f422066f8a6854$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $06f422066f8a6854$var$utf8Slice(this, start, end);
        case 'ascii':
            return $06f422066f8a6854$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $06f422066f8a6854$var$latin1Slice(this, start, end);
        case 'base64':
            return $06f422066f8a6854$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $06f422066f8a6854$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$06f422066f8a6854$var$Buffer.prototype._isBuffer = true;
function $06f422066f8a6854$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$06f422066f8a6854$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$06f422066f8a6854$var$swap(this, i, i + 1);
    return this;
};
$06f422066f8a6854$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $06f422066f8a6854$var$swap(this, i, i + 3);
        $06f422066f8a6854$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$06f422066f8a6854$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $06f422066f8a6854$var$swap(this, i, i + 7);
        $06f422066f8a6854$var$swap(this, i + 1, i + 6);
        $06f422066f8a6854$var$swap(this, i + 2, i + 5);
        $06f422066f8a6854$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$06f422066f8a6854$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $06f422066f8a6854$var$utf8Slice(this, 0, length);
    return $06f422066f8a6854$var$slowToString.apply(this, arguments);
};
$06f422066f8a6854$var$Buffer.prototype.toLocaleString = $06f422066f8a6854$var$Buffer.prototype.toString;
$06f422066f8a6854$var$Buffer.prototype.equals = function equals(b) {
    if (!$06f422066f8a6854$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $06f422066f8a6854$var$Buffer.compare(this, b) === 0;
};
$06f422066f8a6854$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $06f422066f8a6854$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($06f422066f8a6854$var$customInspectSymbol) $06f422066f8a6854$var$Buffer.prototype[$06f422066f8a6854$var$customInspectSymbol] = $06f422066f8a6854$var$Buffer.prototype.inspect;
$06f422066f8a6854$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($06f422066f8a6854$var$isInstance(target, Uint8Array)) target = $06f422066f8a6854$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$06f422066f8a6854$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $06f422066f8a6854$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($06f422066f8a6854$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $06f422066f8a6854$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($06f422066f8a6854$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $06f422066f8a6854$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $06f422066f8a6854$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $06f422066f8a6854$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$06f422066f8a6854$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$06f422066f8a6854$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $06f422066f8a6854$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$06f422066f8a6854$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $06f422066f8a6854$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $06f422066f8a6854$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($06f422066f8a6854$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $06f422066f8a6854$var$utf8Write(buf, string, offset, length) {
    return $06f422066f8a6854$var$blitBuffer($06f422066f8a6854$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $06f422066f8a6854$var$asciiWrite(buf, string, offset, length) {
    return $06f422066f8a6854$var$blitBuffer($06f422066f8a6854$var$asciiToBytes(string), buf, offset, length);
}
function $06f422066f8a6854$var$base64Write(buf, string, offset, length) {
    return $06f422066f8a6854$var$blitBuffer($06f422066f8a6854$var$base64ToBytes(string), buf, offset, length);
}
function $06f422066f8a6854$var$ucs2Write(buf, string, offset, length) {
    return $06f422066f8a6854$var$blitBuffer($06f422066f8a6854$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$06f422066f8a6854$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $06f422066f8a6854$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $06f422066f8a6854$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $06f422066f8a6854$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $06f422066f8a6854$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $06f422066f8a6854$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$06f422066f8a6854$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $06f422066f8a6854$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3I1Rb.fromByteArray(buf);
    else return $3I1Rb.fromByteArray(buf.slice(start, end));
}
function $06f422066f8a6854$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $06f422066f8a6854$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $06f422066f8a6854$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $06f422066f8a6854$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $06f422066f8a6854$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $06f422066f8a6854$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $06f422066f8a6854$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $06f422066f8a6854$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $06f422066f8a6854$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $06f422066f8a6854$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $06f422066f8a6854$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$06f422066f8a6854$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $06f422066f8a6854$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $06f422066f8a6854$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$06f422066f8a6854$var$Buffer.prototype.readUintLE = $06f422066f8a6854$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$06f422066f8a6854$var$Buffer.prototype.readUintBE = $06f422066f8a6854$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$06f422066f8a6854$var$Buffer.prototype.readUint8 = $06f422066f8a6854$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$06f422066f8a6854$var$Buffer.prototype.readUint16LE = $06f422066f8a6854$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$06f422066f8a6854$var$Buffer.prototype.readUint16BE = $06f422066f8a6854$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$06f422066f8a6854$var$Buffer.prototype.readUint32LE = $06f422066f8a6854$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$06f422066f8a6854$var$Buffer.prototype.readUint32BE = $06f422066f8a6854$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$06f422066f8a6854$var$Buffer.prototype.readBigUInt64LE = $06f422066f8a6854$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $06f422066f8a6854$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $06f422066f8a6854$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$06f422066f8a6854$var$Buffer.prototype.readBigUInt64BE = $06f422066f8a6854$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $06f422066f8a6854$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $06f422066f8a6854$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$06f422066f8a6854$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$06f422066f8a6854$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$06f422066f8a6854$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$06f422066f8a6854$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$06f422066f8a6854$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$06f422066f8a6854$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$06f422066f8a6854$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$06f422066f8a6854$var$Buffer.prototype.readBigInt64LE = $06f422066f8a6854$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $06f422066f8a6854$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $06f422066f8a6854$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$06f422066f8a6854$var$Buffer.prototype.readBigInt64BE = $06f422066f8a6854$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $06f422066f8a6854$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $06f422066f8a6854$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$06f422066f8a6854$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 4, this.length);
    return $f6JmG.read(this, offset, true, 23, 4);
};
$06f422066f8a6854$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 4, this.length);
    return $f6JmG.read(this, offset, false, 23, 4);
};
$06f422066f8a6854$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 8, this.length);
    return $f6JmG.read(this, offset, true, 52, 8);
};
$06f422066f8a6854$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkOffset(offset, 8, this.length);
    return $f6JmG.read(this, offset, false, 52, 8);
};
function $06f422066f8a6854$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$06f422066f8a6854$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$06f422066f8a6854$var$Buffer.prototype.writeUintLE = $06f422066f8a6854$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $06f422066f8a6854$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$06f422066f8a6854$var$Buffer.prototype.writeUintBE = $06f422066f8a6854$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $06f422066f8a6854$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$06f422066f8a6854$var$Buffer.prototype.writeUint8 = $06f422066f8a6854$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$06f422066f8a6854$var$Buffer.prototype.writeUint16LE = $06f422066f8a6854$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$06f422066f8a6854$var$Buffer.prototype.writeUint16BE = $06f422066f8a6854$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$06f422066f8a6854$var$Buffer.prototype.writeUint32LE = $06f422066f8a6854$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$06f422066f8a6854$var$Buffer.prototype.writeUint32BE = $06f422066f8a6854$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $06f422066f8a6854$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $06f422066f8a6854$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $06f422066f8a6854$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $06f422066f8a6854$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$06f422066f8a6854$var$Buffer.prototype.writeBigUInt64LE = $06f422066f8a6854$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $06f422066f8a6854$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$06f422066f8a6854$var$Buffer.prototype.writeBigUInt64BE = $06f422066f8a6854$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $06f422066f8a6854$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$06f422066f8a6854$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $06f422066f8a6854$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$06f422066f8a6854$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $06f422066f8a6854$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$06f422066f8a6854$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$06f422066f8a6854$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$06f422066f8a6854$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$06f422066f8a6854$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$06f422066f8a6854$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$06f422066f8a6854$var$Buffer.prototype.writeBigInt64LE = $06f422066f8a6854$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $06f422066f8a6854$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$06f422066f8a6854$var$Buffer.prototype.writeBigInt64BE = $06f422066f8a6854$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $06f422066f8a6854$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $06f422066f8a6854$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $06f422066f8a6854$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $f6JmG.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$06f422066f8a6854$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $06f422066f8a6854$var$writeFloat(this, value, offset, true, noAssert);
};
$06f422066f8a6854$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $06f422066f8a6854$var$writeFloat(this, value, offset, false, noAssert);
};
function $06f422066f8a6854$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $06f422066f8a6854$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $f6JmG.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$06f422066f8a6854$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $06f422066f8a6854$var$writeDouble(this, value, offset, true, noAssert);
};
$06f422066f8a6854$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $06f422066f8a6854$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$06f422066f8a6854$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$06f422066f8a6854$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$06f422066f8a6854$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$06f422066f8a6854$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $06f422066f8a6854$var$Buffer.isBuffer(val) ? val : $06f422066f8a6854$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $06f422066f8a6854$var$errors = {};
function $06f422066f8a6854$var$E(sym, getMessage, Base) {
    $06f422066f8a6854$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$06f422066f8a6854$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$06f422066f8a6854$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$06f422066f8a6854$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $06f422066f8a6854$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $06f422066f8a6854$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $06f422066f8a6854$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $06f422066f8a6854$var$checkBounds(buf, offset, byteLength) {
    $06f422066f8a6854$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $06f422066f8a6854$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $06f422066f8a6854$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $06f422066f8a6854$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $06f422066f8a6854$var$checkBounds(buf, offset, byteLength);
}
function $06f422066f8a6854$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $06f422066f8a6854$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $06f422066f8a6854$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $06f422066f8a6854$var$validateNumber(value, type);
        throw new $06f422066f8a6854$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $06f422066f8a6854$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $06f422066f8a6854$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $06f422066f8a6854$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $06f422066f8a6854$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($06f422066f8a6854$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $06f422066f8a6854$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $06f422066f8a6854$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $06f422066f8a6854$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $06f422066f8a6854$var$base64ToBytes(str) {
    return $3I1Rb.toByteArray($06f422066f8a6854$var$base64clean(str));
}
function $06f422066f8a6854$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $06f422066f8a6854$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $06f422066f8a6854$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $06f422066f8a6854$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $06f422066f8a6854$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $06f422066f8a6854$var$BufferBigIntNotDefined : fn;
}
function $06f422066f8a6854$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("3I1Rb", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $2b36ebdc81f099f9$export$d622b2ad8d90c771, (v) => $2b36ebdc81f099f9$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $2b36ebdc81f099f9$export$6100ba28696e12de, (v) => $2b36ebdc81f099f9$export$6100ba28696e12de = v);
var $2b36ebdc81f099f9$export$a48f0734ac7c2329;
var $2b36ebdc81f099f9$export$d622b2ad8d90c771;
var $2b36ebdc81f099f9$export$6100ba28696e12de;
'use strict';
$2b36ebdc81f099f9$export$a48f0734ac7c2329 = $2b36ebdc81f099f9$var$byteLength;
$2b36ebdc81f099f9$export$d622b2ad8d90c771 = $2b36ebdc81f099f9$var$toByteArray;
$2b36ebdc81f099f9$export$6100ba28696e12de = $2b36ebdc81f099f9$var$fromByteArray;
var $2b36ebdc81f099f9$var$lookup = [];
var $2b36ebdc81f099f9$var$revLookup = [];
var $2b36ebdc81f099f9$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $2b36ebdc81f099f9$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $2b36ebdc81f099f9$var$i = 0, $2b36ebdc81f099f9$var$len = $2b36ebdc81f099f9$var$code.length; $2b36ebdc81f099f9$var$i < $2b36ebdc81f099f9$var$len; ++$2b36ebdc81f099f9$var$i){
    $2b36ebdc81f099f9$var$lookup[$2b36ebdc81f099f9$var$i] = $2b36ebdc81f099f9$var$code[$2b36ebdc81f099f9$var$i];
    $2b36ebdc81f099f9$var$revLookup[$2b36ebdc81f099f9$var$code.charCodeAt($2b36ebdc81f099f9$var$i)] = $2b36ebdc81f099f9$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$2b36ebdc81f099f9$var$revLookup['-'.charCodeAt(0)] = 62;
$2b36ebdc81f099f9$var$revLookup['_'.charCodeAt(0)] = 63;
function $2b36ebdc81f099f9$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $2b36ebdc81f099f9$var$byteLength(b64) {
    var lens = $2b36ebdc81f099f9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $2b36ebdc81f099f9$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $2b36ebdc81f099f9$var$toByteArray(b64) {
    var tmp;
    var lens = $2b36ebdc81f099f9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $2b36ebdc81f099f9$var$Arr($2b36ebdc81f099f9$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i)] << 18 | $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i)] << 2 | $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i)] << 10 | $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $2b36ebdc81f099f9$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $2b36ebdc81f099f9$var$tripletToBase64(num) {
    return $2b36ebdc81f099f9$var$lookup[num >> 18 & 0x3F] + $2b36ebdc81f099f9$var$lookup[num >> 12 & 0x3F] + $2b36ebdc81f099f9$var$lookup[num >> 6 & 0x3F] + $2b36ebdc81f099f9$var$lookup[num & 0x3F];
}
function $2b36ebdc81f099f9$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($2b36ebdc81f099f9$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $2b36ebdc81f099f9$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($2b36ebdc81f099f9$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($2b36ebdc81f099f9$var$lookup[tmp >> 2] + $2b36ebdc81f099f9$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($2b36ebdc81f099f9$var$lookup[tmp >> 10] + $2b36ebdc81f099f9$var$lookup[tmp >> 4 & 0x3F] + $2b36ebdc81f099f9$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("f6JmG", function(module, exports) {

$parcel$export(module.exports, "read", () => $affa9b134a635647$export$aafa59e2e03f2942, (v) => $affa9b134a635647$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $affa9b134a635647$export$68d8715fc104d294, (v) => $affa9b134a635647$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $affa9b134a635647$export$aafa59e2e03f2942;
var $affa9b134a635647$export$68d8715fc104d294;
$affa9b134a635647$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$affa9b134a635647$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("cLNTu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha256 = void 0;

var $iAroj = parcelRequire("iAroj");
const $94c093b839c381cf$var$sha256 = async (bytes)=>{
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    return (0, $iAroj.toHex)(digest);
};
module.exports.sha256 = $94c093b839c381cf$var$sha256;

});
parcelRegister("iAroj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toHex = module.exports.splitString = void 0;
const $d880d61629fe711b$var$splitString = (text, maxLineLength = 64)=>{
    const regex = new RegExp(`(.{1,${maxLineLength}})`, 'g');
    const matches = text.matchAll(regex);
    const lines = [];
    for (const match of matches)lines.push(match[1]);
    return lines;
};
module.exports.splitString = $d880d61629fe711b$var$splitString;
const $d880d61629fe711b$var$toHex = (buffer)=>{
    const view = new Uint8Array(buffer);
    let hexString = "";
    for (const byte of view){
        const hexByte = byte.toString(16);
        hexString += hexByte.padStart(2, "0");
    }
    return hexString.toLowerCase();
};
module.exports.toHex = $d880d61629fe711b$var$toHex;

});


parcelRegister("ceSi5", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@dfns/sdk\",\"version\":\"0.8.21\",\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/dfns/dfns-sdk-ts.git\",\"directory\":\"packages/sdk\"},\"dependencies\":{\"buffer\":\"^6.0.3\",\"cross-fetch\":\"^3.1.6\"},\"main\":\"./index.js\",\"type\":\"commonjs\"}");

});



parcelRegister("7NNEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DfnsApiClient = void 0;

var $8AKy6 = parcelRequire("8AKy6");

var $8VgRn = parcelRequire("8VgRn");

var $eeNb6 = parcelRequire("eeNb6");

var $6SM1g = parcelRequire("6SM1g");

var $HS1HW = parcelRequire("HS1HW");

var $4slbO = parcelRequire("4slbO");

var $kXHdH = parcelRequire("kXHdH");

var $a46CN = parcelRequire("a46CN");

var $heFHH = parcelRequire("heFHH");

var $cYj75 = parcelRequire("cYj75");

var $hahI2 = parcelRequire("hahI2");

var $afHNt = parcelRequire("afHNt");

var $6beEe = parcelRequire("6beEe");

var $8fuVG = parcelRequire("8fuVG");

var $1xEvM = parcelRequire("1xEvM");
class $5ae3a09827c97fec$var$DfnsApiClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    get agreements() {
        return new $8AKy6.AgreementsClient(this.apiOptions);
    }
    get allocations() {
        return new $8VgRn.AllocationsClient(this.apiOptions);
    }
    get auth() {
        return new $eeNb6.AuthClient(this.apiOptions);
    }
    get exchanges() {
        return new $6SM1g.ExchangesClient(this.apiOptions);
    }
    get feeSponsors() {
        return new $HS1HW.FeeSponsorsClient(this.apiOptions);
    }
    get keys() {
        return new $4slbO.KeysClient(this.apiOptions);
    }
    get networks() {
        return new $kXHdH.NetworksClient(this.apiOptions);
    }
    get payouts() {
        return new $a46CN.PayoutsClient(this.apiOptions);
    }
    get permissions() {
        return new $heFHH.PermissionsClient(this.apiOptions);
    }
    get policies() {
        return new $cYj75.PoliciesClient(this.apiOptions);
    }
    get signers() {
        return new $hahI2.SignersClient(this.apiOptions);
    }
    get staking() {
        return new $afHNt.StakingClient(this.apiOptions);
    }
    get swaps() {
        return new $6beEe.SwapsClient(this.apiOptions);
    }
    get wallets() {
        return new $8fuVG.WalletsClient(this.apiOptions);
    }
    get webhooks() {
        return new $1xEvM.WebhooksClient(this.apiOptions);
    }
}
module.exports.DfnsApiClient = $5ae3a09827c97fec$var$DfnsApiClient;

});
parcelRegister("8AKy6", function(module, exports) {
"use strict";
var $6415cb3191300e6d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6415cb3191300e6d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6415cb3191300e6d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6415cb3191300e6d$var$__exportStar((parcelRequire("aiOFQ")), module.exports);

$6415cb3191300e6d$var$__exportStar((parcelRequire("ihKBv")), module.exports);

$6415cb3191300e6d$var$__exportStar((parcelRequire("7wng4")), module.exports);

});
parcelRegister("aiOFQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ihKBv", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AgreementsClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $d4fdf716d7f2d669$var$AgreementsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async getLatestUnacceptedAgreement(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/agreements/latest-unaccepted', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async recordAgreementAcceptance(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/agreements/:agreementId/accept', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.AgreementsClient = $d4fdf716d7f2d669$var$AgreementsClient;

});
parcelRegister("51rbI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.userActionFetch = void 0;

var $3N3x2 = parcelRequire("3N3x2");

var $cZ5A6 = parcelRequire("cZ5A6");

var $kkC0S = parcelRequire("kkC0S");

var $gSZ2x = parcelRequire("gSZ2x");
const $3a8222b142a2eab0$var$userAction = (fetch)=>{
    return async (resource, options)=>{
        if (options.method !== 'GET') {
            const apiOptions = {
                ...options.apiOptions,
                baseUrl: options.apiOptions.baseAuthUrl || options.apiOptions.baseUrl
            };
            if (!apiOptions.signer) throw new $gSZ2x.DfnsError(-1, 'A "signer" needs to be passed to Dfns client.', {
                detail: `Most non-readonly endpoints require "User Action Signing" flow.` + ` During that flow, the credential "signer" that you passed will handle signing` + ` the user action challenge, using your credential.`
            });
            const body = (options.body instanceof FormData ? options.body.get('data') : options.body) ?? '';
            if (typeof body !== 'string') throw new $gSZ2x.DfnsError(-1, 'unexpected fetch body for user action signing', {
                details: {
                    type: typeof body
                }
            });
            const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
                userActionPayload: body,
                userActionHttpMethod: options.method,
                userActionHttpPath: resource.pathname,
                userActionServerKind: apiOptions?.userActionServerKind || 'Api'
            }, apiOptions);
            const assertion = await apiOptions.signer.sign(challenge);
            const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge({
                challengeIdentifier: challenge.challengeIdentifier,
                firstFactor: assertion
            }, apiOptions);
            options.headers = {
                'x-dfns-useraction': userAction,
                ...options.headers ?? {}
            };
        }
        return fetch(resource, options);
    };
};
module.exports.userActionFetch = (0, $cZ5A6.fullUrl)((0, $cZ5A6.formDataSerializer)((0, $cZ5A6.jsonSerializer)((0, $cZ5A6.dfnsAuth)($3a8222b142a2eab0$var$userAction((0, $cZ5A6.catchPolicyPending)((0, $cZ5A6.errorHandler)($3N3x2.fetch)))))));

});

parcelRegister("g7vJF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildPathAndQuery = void 0;
const $bbc5eacdcc682e70$var$buildPathAndQuery = (pattern, params)=>{
    let path = pattern;
    const paramsToReplace = (path.match(new RegExp(`:[a-zA-Z]+`, 'g')) || []).map((v)=>v.replace(/^:/, ''));
    for (const key of paramsToReplace)path = path.replace(new RegExp(`:${key}`, 'g'), encodeURIComponent(params.path[key]));
    const query = Object.entries(params.query).flatMap(([key, value])=>{
        if (Array.isArray(value)) return value.map((item)=>`${key}=${encodeURIComponent(item)}`);
        else if (!value) return [];
        else return [
            `${key}=${encodeURIComponent(value.toString())}`
        ];
    }).join('&');
    return query === '' ? path : `${path}?${query}`;
};
module.exports.buildPathAndQuery = $bbc5eacdcc682e70$var$buildPathAndQuery;

});


parcelRegister("7wng4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedAgreementsClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $579d90234069632f$var$DelegatedAgreementsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async getLatestUnacceptedAgreement(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/agreements/latest-unaccepted', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async recordAgreementAcceptanceInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/agreements/:agreementId/accept', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async recordAgreementAcceptanceComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/agreements/:agreementId/accept', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedAgreementsClient = $579d90234069632f$var$DelegatedAgreementsClient;

});


parcelRegister("8VgRn", function(module, exports) {
"use strict";
var $67f0b9a298244425$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $67f0b9a298244425$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $67f0b9a298244425$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$67f0b9a298244425$var$__exportStar((parcelRequire("lqiGt")), module.exports);

$67f0b9a298244425$var$__exportStar((parcelRequire("3Kw9P")), module.exports);

$67f0b9a298244425$var$__exportStar((parcelRequire("lhNKb")), module.exports);

});
parcelRegister("lqiGt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3Kw9P", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AllocationsClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $2bae9cc9f368bab8$var$AllocationsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createAllocation(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createAllocationAction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getAllocation(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations/:allocationId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAllocationActions(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAllocations(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.AllocationsClient = $2bae9cc9f368bab8$var$AllocationsClient;

});

parcelRegister("lhNKb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedAllocationsClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $f7f1c598f1aa5756$var$DelegatedAllocationsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createAllocationInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createAllocationComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createAllocationActionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createAllocationActionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getAllocation(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations/:allocationId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAllocationActions(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations/:allocationId/actions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAllocations(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/allocations', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedAllocationsClient = $f7f1c598f1aa5756$var$DelegatedAllocationsClient;

});


parcelRegister("eeNb6", function(module, exports) {
"use strict";
var $a5d88537ad94e97c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a5d88537ad94e97c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a5d88537ad94e97c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a5d88537ad94e97c$var$__exportStar((parcelRequire("dl6I1")), module.exports);

$a5d88537ad94e97c$var$__exportStar((parcelRequire("kFyD9")), module.exports);

$a5d88537ad94e97c$var$__exportStar((parcelRequire("1VKsM")), module.exports);

});
parcelRegister("dl6I1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kFyD9", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $f0c27fdaef673f97$var$AuthClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async activateCredential(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activatePersonalAccessToken(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateServiceAccount(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archivePersonalAccessToken(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archiveServiceAccount(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archiveUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredential(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createCredential instead */ async createUserCredential(request) {
        return this.createCredential(request);
    }
    async createCredentialChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createCredentialChallenge instead */ async createUserCredentialChallenge(request) {
        return this.createCredentialChallenge(request);
    }
    async createCredentialChallengeWithCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/code/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialWithCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/code/verify', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createDelegatedRecoveryChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user/delegated', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createDelegatedRecoveryChallenge instead */ async createDelegatedUserRecovery(request) {
        return this.createDelegatedRecoveryChallenge(request);
    }
    async createDelegatedRegistrationChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/delegated', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createDelegatedRegistrationChallenge instead */ async createDelegatedUserRegistration(request) {
        return this.createDelegatedRegistrationChallenge(request);
    }
    async createLoginChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPersonalAccessToken(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createRecoveryChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createRegistrationChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createServiceAccount(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createSocialRegistrationChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/social', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createUserActionChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/action/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createUserActionChallenge instead */ async createUserActionSignatureChallenge(request) {
        return this.createUserActionChallenge(request);
    }
    async createUserActionSignature(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/action', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateCredential(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivatePersonalAccessToken(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateServiceAccount(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegatedLogin(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/delegated', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use delegatedLogin instead */ async createDelegatedUserLogin(request) {
        return this.delegatedLogin(request);
    }
    async getApplication(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/apps/:appId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getAuditLog(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/action/logs/:id', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPersonalAccessToken(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getServiceAccount(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listApplications() {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/apps', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAuditLogs(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/action/logs', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listCredentials() {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use listCredentials instead */ async listUserCredentials() {
        return this.listCredentials();
    }
    async listPersonalAccessTokens() {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listServiceAccounts() {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listUsers(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async login(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async logout(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/logout', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request?.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async recover(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use recover instead */ async createUserRecovery(request) {
        return this.recover(request);
    }
    async register(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use register instead */ async createUserRegistration(request) {
        return this.register(request);
    }
    async registerEndUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/enduser', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async resendRegistrationCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async sendLoginCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async sendRecoveryCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async socialLogin(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/social', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async ssoLogin(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/sso', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async ssoLoginInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/sso/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePersonalAccessToken(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateServiceAccount(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.AuthClient = $f0c27fdaef673f97$var$AuthClient;

});

parcelRegister("1VKsM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedAuthClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $167f27ecf8924392$var$DelegatedAuthClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async activateCredentialInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateCredentialComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activatePersonalAccessTokenInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activatePersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateServiceAccountInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateServiceAccountComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateUserInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateUserComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archivePersonalAccessTokenInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archivePersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archiveServiceAccountInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archiveServiceAccountComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async archiveUserInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archiveUserComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createCredentialComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createCredentialChallenge instead */ async createUserCredentialChallenge(request) {
        return this.createCredentialChallenge(request);
    }
    async createCredentialChallengeWithCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/code/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialCodeInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/code', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createCredentialCodeComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/code', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCredentialWithCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/code/verify', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createDelegatedRecoveryChallengeInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user/delegated', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createDelegatedRecoveryChallengeComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user/delegated', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createDelegatedRegistrationChallengeInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/delegated', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createDelegatedRegistrationChallengeComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/delegated', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createLoginChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPersonalAccessTokenInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createRecoveryChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createRegistrationChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createServiceAccountInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createServiceAccountComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createSocialRegistrationChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/social', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createUserInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createUserComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createUserActionChallenge(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/action/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use createUserActionChallenge instead */ async createUserActionSignatureChallenge(request) {
        return this.createUserActionChallenge(request);
    }
    async createUserActionSignature(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/action', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateCredentialInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivateCredentialComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivatePersonalAccessTokenInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivatePersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateServiceAccountInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivateServiceAccountComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateUserInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivateUserComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegatedLoginInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/delegated', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async delegatedLoginComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/delegated', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getApplication(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/apps/:appId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getAuditLog(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/action/logs/:id', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPersonalAccessToken(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getServiceAccount(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listApplications() {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/apps', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAuditLogs(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/action/logs', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listCredentials() {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/credentials', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use listCredentials instead */ async listUserCredentials() {
        return this.listCredentials();
    }
    async listPersonalAccessTokens() {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listServiceAccounts() {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listUsers(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async login(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async logout(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/logout', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request?.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async recover(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use recover instead */ async createUserRecovery(request) {
        return this.recover(request);
    }
    async register(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    /** @deprecated, use register instead */ async createUserRegistration(request) {
        return this.register(request);
    }
    async registerEndUser(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/enduser', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async resendRegistrationCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/registration/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async sendLoginCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async sendRecoveryCode(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/recover/user/code', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async socialLogin(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/social', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async ssoLogin(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/sso', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async ssoLoginInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/login/sso/init', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePersonalAccessTokenInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updatePersonalAccessTokenComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/pats/:tokenId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateServiceAccountInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateServiceAccountComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/service-accounts/:serviceAccountId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateUserInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateUserComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/auth/users/:userId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedAuthClient = $167f27ecf8924392$var$DelegatedAuthClient;

});


parcelRegister("6SM1g", function(module, exports) {
"use strict";
var $502d08dab4e18911$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $502d08dab4e18911$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $502d08dab4e18911$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$502d08dab4e18911$var$__exportStar((parcelRequire("4KTn2")), module.exports);

$502d08dab4e18911$var$__exportStar((parcelRequire("iGwQf")), module.exports);

$502d08dab4e18911$var$__exportStar((parcelRequire("n90aD")), module.exports);

});
parcelRegister("4KTn2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iGwQf", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExchangesClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $d9a59fe99fa022fb$var$ExchangesClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createDeposit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/deposits', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createExchange(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createWithdrawal(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/withdrawals', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteExchange(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getExchange(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAccountAssets(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/assets', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAccounts(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAssetWithdrawalNetworks(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/assets/:asset/withdrawal-networks', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listExchanges(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.ExchangesClient = $d9a59fe99fa022fb$var$ExchangesClient;

});

parcelRegister("n90aD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedExchangesClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $045921a8512f3b28$var$DelegatedExchangesClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createDepositInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/deposits', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createDepositComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/deposits', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createExchangeInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createExchangeComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createWithdrawalInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/withdrawals', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createWithdrawalComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/withdrawals', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteExchangeInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteExchangeComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getExchange(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAccountAssets(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/assets', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAccounts(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAssetWithdrawalNetworks(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges/:exchangeId/accounts/:accountId/assets/:asset/withdrawal-networks', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listExchanges(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/exchanges', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedExchangesClient = $045921a8512f3b28$var$DelegatedExchangesClient;

});


parcelRegister("HS1HW", function(module, exports) {
"use strict";
var $083decd04b5f6252$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $083decd04b5f6252$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $083decd04b5f6252$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$083decd04b5f6252$var$__exportStar((parcelRequire("aGDNT")), module.exports);

$083decd04b5f6252$var$__exportStar((parcelRequire("4RiUB")), module.exports);

$083decd04b5f6252$var$__exportStar((parcelRequire("6MoP9")), module.exports);

});
parcelRegister("aGDNT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4RiUB", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeeSponsorsClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $389ac82ec963721d$var$FeeSponsorsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async activateFeeSponsor(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createFeeSponsor(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateFeeSponsor(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteFeeSponsor(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getFeeSponsor(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listFeeSponsors(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSponsoredFees(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/fees', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.FeeSponsorsClient = $389ac82ec963721d$var$FeeSponsorsClient;

});

parcelRegister("6MoP9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedFeeSponsorsClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $4efa7b487abd3084$var$DelegatedFeeSponsorsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async activateFeeSponsorInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateFeeSponsorComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createFeeSponsorInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createFeeSponsorComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deactivateFeeSponsorInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deactivateFeeSponsorComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/deactivate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteFeeSponsorInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteFeeSponsorComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getFeeSponsor(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listFeeSponsors(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSponsoredFees(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/fee-sponsors/:feeSponsorId/fees', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedFeeSponsorsClient = $4efa7b487abd3084$var$DelegatedFeeSponsorsClient;

});


parcelRegister("4slbO", function(module, exports) {
"use strict";
var $33ea36b9cae24df7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $33ea36b9cae24df7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $33ea36b9cae24df7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$33ea36b9cae24df7$var$__exportStar((parcelRequire("adrTo")), module.exports);

$33ea36b9cae24df7$var$__exportStar((parcelRequire("7zMNC")), module.exports);

$33ea36b9cae24df7$var$__exportStar((parcelRequire("eQ75V")), module.exports);

});
parcelRegister("adrTo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7zMNC", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeysClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $5841a7cda2dfc591$var$KeysClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegateKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/delegate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deriveKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/derive', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async exportKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/export', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async generateSignature(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSignature(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/signatures/:signatureId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async importKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/import', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listKeys(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSignatures(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.KeysClient = $5841a7cda2dfc591$var$KeysClient;

});

parcelRegister("eQ75V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedKeysClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $acdb6ce0221364b0$var$DelegatedKeysClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createKeyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createKeyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegateKeyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/delegate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async delegateKeyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/delegate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteKeyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteKeyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deriveKeyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/derive', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deriveKeyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/derive', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async exportKeyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/export', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async exportKeyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/export', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async generateSignatureInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async generateSignatureComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getKey(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSignature(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/signatures/:signatureId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async importKeyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/import', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async importKeyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/import', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listKeys(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSignatures(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId/signatures', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateKeyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateKeyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/keys/:keyId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedKeysClient = $acdb6ce0221364b0$var$DelegatedKeysClient;

});


parcelRegister("kXHdH", function(module, exports) {
"use strict";
var $f42ad7ea688d17b3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f42ad7ea688d17b3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f42ad7ea688d17b3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f42ad7ea688d17b3$var$__exportStar((parcelRequire("hxXMw")), module.exports);

$f42ad7ea688d17b3$var$__exportStar((parcelRequire("fS1PU")), module.exports);

$f42ad7ea688d17b3$var$__exportStar((parcelRequire("5dq2E")), module.exports);

});
parcelRegister("hxXMw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fS1PU", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworksClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $b8dd52d0f55ecd0f$var$NetworksClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async callFunction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/call-function', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCantonValidator(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteCantonValidator(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getCantonValidator(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getFees(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/fees', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listCantonValidators(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateCantonValidator(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.NetworksClient = $b8dd52d0f55ecd0f$var$NetworksClient;

});

parcelRegister("5dq2E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedNetworksClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $3cc25dfd8bd7cded$var$DelegatedNetworksClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async callFunction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/call-function', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createCantonValidatorInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createCantonValidatorComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteCantonValidatorInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteCantonValidatorComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getCantonValidator(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getFees(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/fees', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listCantonValidators(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateCantonValidatorInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateCantonValidatorComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/networks/:network/validators/:validatorId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedNetworksClient = $3cc25dfd8bd7cded$var$DelegatedNetworksClient;

});


parcelRegister("a46CN", function(module, exports) {
"use strict";
var $753f6aa4ebbef715$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $753f6aa4ebbef715$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $753f6aa4ebbef715$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$753f6aa4ebbef715$var$__exportStar((parcelRequire("chDUY")), module.exports);

$753f6aa4ebbef715$var$__exportStar((parcelRequire("li9Fv")), module.exports);

$753f6aa4ebbef715$var$__exportStar((parcelRequire("ca76c")), module.exports);

});
parcelRegister("chDUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("li9Fv", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PayoutsClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $f802c75a88813b99$var$PayoutsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createPayout(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPayoutAction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts/:payoutId/action', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPayoutQuote(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts/quote', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPayout(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts/:payoutId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPayouts(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.PayoutsClient = $f802c75a88813b99$var$PayoutsClient;

});

parcelRegister("ca76c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedPayoutsClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $8dabece9cda70488$var$DelegatedPayoutsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createPayoutInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPayoutComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPayoutActionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts/:payoutId/action', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPayoutActionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts/:payoutId/action', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPayoutQuote(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts/quote', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPayout(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts/:payoutId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPayouts(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/payouts', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedPayoutsClient = $8dabece9cda70488$var$DelegatedPayoutsClient;

});


parcelRegister("heFHH", function(module, exports) {
"use strict";
var $c8c41801f6bfe973$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c8c41801f6bfe973$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c8c41801f6bfe973$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c8c41801f6bfe973$var$__exportStar((parcelRequire("e9BuX")), module.exports);

$c8c41801f6bfe973$var$__exportStar((parcelRequire("3jtAs")), module.exports);

$c8c41801f6bfe973$var$__exportStar((parcelRequire("jogoa")), module.exports);

});
parcelRegister("e9BuX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3jtAs", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PermissionsClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $269a18cd7ca87e73$var$PermissionsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async archivePermission(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createAssignment(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPermission(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteAssignment(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/assignments/:assignmentId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
    }
    async getPermission(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAssignments(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPermissions(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePermission(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.PermissionsClient = $269a18cd7ca87e73$var$PermissionsClient;

});

parcelRegister("jogoa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedPermissionsClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $e1dcf8b3d99d0bec$var$DelegatedPermissionsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async archivePermissionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archivePermissionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createAssignmentInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createAssignmentComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPermissionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPermissionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteAssignmentInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/assignments/:assignmentId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteAssignmentComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/assignments/:assignmentId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
    }
    async getPermission(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listAssignments(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId/assignments', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPermissions(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePermissionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updatePermissionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/permissions/:permissionId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedPermissionsClient = $e1dcf8b3d99d0bec$var$DelegatedPermissionsClient;

});


parcelRegister("cYj75", function(module, exports) {
"use strict";
var $9719ea2927e5266c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9719ea2927e5266c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9719ea2927e5266c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9719ea2927e5266c$var$__exportStar((parcelRequire("klXX7")), module.exports);

$9719ea2927e5266c$var$__exportStar((parcelRequire("cFn7l")), module.exports);

$9719ea2927e5266c$var$__exportStar((parcelRequire("5pnmT")), module.exports);

});
parcelRegister("klXX7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cFn7l", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PoliciesClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $938b3f0778d8ed9b$var$PoliciesClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async archivePolicy(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createApprovalDecision(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policy-approvals/:approvalId/decisions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPolicy(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getApproval(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policy-approvals/:approvalId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPolicy(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listApprovals(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policy-approvals', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPolicies(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePolicy(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.PoliciesClient = $938b3f0778d8ed9b$var$PoliciesClient;

});

parcelRegister("5pnmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedPoliciesClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $3f016a0285081cd0$var$DelegatedPoliciesClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async archivePolicyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async archivePolicyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createApprovalDecisionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policy-approvals/:approvalId/decisions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createApprovalDecisionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policy-approvals/:approvalId/decisions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createPolicyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createPolicyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getApproval(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policy-approvals/:approvalId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getPolicy(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listApprovals(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policy-approvals', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listPolicies(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updatePolicyInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updatePolicyComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedPoliciesClient = $3f016a0285081cd0$var$DelegatedPoliciesClient;

});


parcelRegister("hahI2", function(module, exports) {
"use strict";
var $c7f11b84322054ab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c7f11b84322054ab$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c7f11b84322054ab$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c7f11b84322054ab$var$__exportStar((parcelRequire("C4rB3")), module.exports);

$c7f11b84322054ab$var$__exportStar((parcelRequire("6vIPJ")), module.exports);

$c7f11b84322054ab$var$__exportStar((parcelRequire("kDW7E")), module.exports);

});
parcelRegister("C4rB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6vIPJ", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignersClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $4bd86a52cbac229c$var$SignersClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createCloneInput(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/clone/input', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createGenesisInput(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/genesis/input', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createOnchainSignInput(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/onchain-sign/input', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createProofOfControlInput(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/proof-of-control/input', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listKeyStores() {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSigners() {
        const path = (0, $g7vJF.buildPathAndQuery)('/signers', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async submitCloneOutput(request, file) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/clone/output', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            file: file,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async submitGenesisOutput(request, file) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/genesis/output', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            file: file,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async submitOnchainSignOutput(request, file) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/onchain-sign/output', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            file: file,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async submitProofOfControlOutput(request, file) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/proof-of-control/output', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            file: file,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.SignersClient = $4bd86a52cbac229c$var$SignersClient;

});

parcelRegister("kDW7E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedSignersClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $f074890dd25283b7$var$DelegatedSignersClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createCloneInputInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/clone/input', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createCloneInputComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/clone/input', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createGenesisInputInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/genesis/input', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createGenesisInputComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/genesis/input', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createOnchainSignInputInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/onchain-sign/input', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createOnchainSignInputComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/onchain-sign/input', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createProofOfControlInputInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/proof-of-control/input', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createProofOfControlInputComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores/:storeId/proof-of-control/input', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listKeyStores() {
        const path = (0, $g7vJF.buildPathAndQuery)('/key-stores', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSigners() {
        const path = (0, $g7vJF.buildPathAndQuery)('/signers', {
            path: {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedSignersClient = $f074890dd25283b7$var$DelegatedSignersClient;

});


parcelRegister("afHNt", function(module, exports) {
"use strict";
var $776d473ed7a4bb9b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $776d473ed7a4bb9b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $776d473ed7a4bb9b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$776d473ed7a4bb9b$var$__exportStar((parcelRequire("ldIbY")), module.exports);

$776d473ed7a4bb9b$var$__exportStar((parcelRequire("lCztB")), module.exports);

$776d473ed7a4bb9b$var$__exportStar((parcelRequire("39njv")), module.exports);

});
parcelRegister("ldIbY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lCztB", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StakingClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $fbd8aa7ed1b5d563$var$StakingClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createStake(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createStakeAction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getStakeRewards(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId/rewards', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getStakes(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listStakeActions(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listStakes(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.StakingClient = $fbd8aa7ed1b5d563$var$StakingClient;

});

parcelRegister("39njv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedStakingClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $24b44bf60ad59e36$var$DelegatedStakingClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createStakeInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createStakeComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createStakeActionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createStakeActionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getStakeRewards(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId/rewards', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getStakes(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listStakeActions(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes/:stakeId/actions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listStakes(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/staking/stakes', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedStakingClient = $24b44bf60ad59e36$var$DelegatedStakingClient;

});


parcelRegister("6beEe", function(module, exports) {
"use strict";
var $47ff21e83ae10f20$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $47ff21e83ae10f20$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $47ff21e83ae10f20$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$47ff21e83ae10f20$var$__exportStar((parcelRequire("32Qb6")), module.exports);

$47ff21e83ae10f20$var$__exportStar((parcelRequire("eSXlB")), module.exports);

$47ff21e83ae10f20$var$__exportStar((parcelRequire("cG2ru")), module.exports);

});
parcelRegister("32Qb6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eSXlB", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SwapsClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $ad642505510bdfdc$var$SwapsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createSwap(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createSwapQuote(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps/quotes', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSwap(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps/:swapId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSwapQuote(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps/quotes/:quoteId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSwaps(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.SwapsClient = $ad642505510bdfdc$var$SwapsClient;

});

parcelRegister("cG2ru", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedSwapsClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $93ab4d4b31729144$var$DelegatedSwapsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createSwapInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createSwapComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createSwapQuote(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps/quotes', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSwap(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps/:swapId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSwapQuote(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps/quotes/:quoteId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSwaps(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/swaps', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedSwapsClient = $93ab4d4b31729144$var$DelegatedSwapsClient;

});


parcelRegister("8fuVG", function(module, exports) {
"use strict";
var $6017b76270f66011$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6017b76270f66011$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6017b76270f66011$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6017b76270f66011$var$__exportStar((parcelRequire("ceeMH")), module.exports);

$6017b76270f66011$var$__exportStar((parcelRequire("jXSlU")), module.exports);

$6017b76270f66011$var$__exportStar((parcelRequire("hvlWe")), module.exports);

});
parcelRegister("ceeMH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jXSlU", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletsClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $e88db03c363251ec$var$WalletsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async abortTransaction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/abort', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async abortTransfer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/abort', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async acceptOffer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/accept', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/activate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async broadcastTransaction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cancelTransaction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/cancel', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cancelTransfer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/cancel', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cantonLedgerApiProxy(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/canton/ledger-api', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegateWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/delegate', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async exportWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/export', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async generateSignature(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getOffer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers/:offerId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSignature(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/signatures/:signatureId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getTransaction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getTransfer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletAssets(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/assets', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletHistory(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/history', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletNfts(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/nfts', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async importWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/import', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listOffers(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listOrgWalletHistory(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/all/history', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSignatures(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listTransactions(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listTransfers(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWallets(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async rejectOffer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/reject', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async speedUpTransaction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async speedUpTransfer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async tagWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async transferAsset(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async untagWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.WalletsClient = $e88db03c363251ec$var$WalletsClient;

});

parcelRegister("hvlWe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedWalletsClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $cbe6595fbdcf9210$var$DelegatedWalletsClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async abortTransactionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/abort', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async abortTransactionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/abort', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async abortTransferInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/abort', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async abortTransferComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/abort', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async acceptOfferInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/accept', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async acceptOfferComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/accept', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async activateWalletInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/activate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async activateWalletComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/activate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async broadcastTransactionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async broadcastTransactionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cancelTransactionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/cancel', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async cancelTransactionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/cancel', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cancelTransferInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/cancel', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async cancelTransferComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/cancel', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async cantonLedgerApiProxy(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/canton/ledger-api', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async createWalletInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createWalletComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async delegateWalletInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/delegate', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async delegateWalletComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/delegate', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async exportWalletInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/export', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async exportWalletComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/export', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async generateSignatureInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async generateSignatureComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getOffer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers/:offerId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getSignature(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/signatures/:signatureId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getTransaction(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getTransfer(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWallet(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletAssets(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/assets', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletHistory(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/history', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWalletNfts(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/nfts', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async importWalletInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/import', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async importWalletComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/import', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listOffers(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listOrgWalletHistory(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/all/history', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listSignatures(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/signatures', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listTransactions(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listTransfers(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWallets(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async rejectOfferInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/reject', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async rejectOfferComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/offers/:offerId/reject', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async speedUpTransactionInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async speedUpTransactionComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transactions/:transactionId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async speedUpTransferInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async speedUpTransferComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers/:transferId/speed-up', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async tagWalletInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async tagWalletComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async transferAssetInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async transferAssetComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/transfers', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async untagWalletInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async untagWalletComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId/tags', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateWalletInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateWalletComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/wallets/:walletId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedWalletsClient = $cbe6595fbdcf9210$var$DelegatedWalletsClient;

});


parcelRegister("1xEvM", function(module, exports) {
"use strict";
var $11f84c40425c7e27$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $11f84c40425c7e27$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $11f84c40425c7e27$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$11f84c40425c7e27$var$__exportStar((parcelRequire("dE0ZN")), module.exports);

$11f84c40425c7e27$var$__exportStar((parcelRequire("acj1M")), module.exports);

$11f84c40425c7e27$var$__exportStar((parcelRequire("gWgOH")), module.exports);

});
parcelRegister("dE0ZN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("acj1M", function(module, exports) {
"use strict";
/* eslint @typescript-eslint/no-unused-vars: 0 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebhooksClient = void 0;

var $cZ5A6 = parcelRequire("cZ5A6");

var $51rbI = parcelRequire("51rbI");

var $g7vJF = parcelRequire("g7vJF");
class $76c9c8e783b29297$var$WebhooksClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createWebhook(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteWebhook(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWebhook(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWebhookEvent(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId/events/:webhookEventId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWebhookEvents(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId/events', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWebhooks(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async pingWebhook(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId/ping', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'POST',
            body: {},
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateWebhook(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $51rbI.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.WebhooksClient = $76c9c8e783b29297$var$WebhooksClient;

});

parcelRegister("gWgOH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegatedWebhooksClient = void 0;

var $kkC0S = parcelRequire("kkC0S");

var $cZ5A6 = parcelRequire("cZ5A6");

var $g7vJF = parcelRequire("g7vJF");
class $c54f1b94c1cf7bdf$var$DelegatedWebhooksClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async createWebhookInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async createWebhookComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async deleteWebhookInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async deleteWebhookComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWebhook(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async getWebhookEvent(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId/events/:webhookEventId', {
            path: request ?? {},
            query: {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWebhookEvents(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId/events', {
            path: request ?? {},
            query: request.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async listWebhooks(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks', {
            path: request ?? {},
            query: request?.query ?? {}
        });
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async pingWebhookInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId/ping', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async pingWebhookComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId/ping', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'POST',
            body: {},
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
    async updateWebhookInit(request) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const challenge = await $kkC0S.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api'
        }, this.apiOptions);
        return challenge;
    }
    async updateWebhookComplete(request, signedChallenge) {
        const path = (0, $g7vJF.buildPathAndQuery)('/webhooks/:webhookId', {
            path: request ?? {},
            query: {}
        });
        const { userAction: userAction } = await $kkC0S.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, $cZ5A6.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: {
                'x-dfns-useraction': userAction
            },
            apiOptions: this.apiOptions
        });
        return response.json();
    }
}
module.exports.DelegatedWebhooksClient = $c54f1b94c1cf7bdf$var$DelegatedWebhooksClient;

});



parcelRegister("g9Bvu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DfnsAuthenticator = void 0;

var $kkC0S = parcelRequire("kkC0S");
class $bc2a94b305e25d75$var$DfnsAuthenticator {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    async login(request) {
        const challenge = await $kkC0S.BaseAuthApi.createUserLoginChallenge(request, this.apiOptions);
        const assertion = await this.apiOptions.signer.sign(challenge);
        return $kkC0S.BaseAuthApi.createUserLogin({
            challengeIdentifier: challenge.challengeIdentifier,
            firstFactor: assertion
        }, this.apiOptions);
    }
    async register(request) {
        if (!this.apiOptions.signer.create) throw new Error(`Provided signer does not implement 'create'`);
        const challenge = await $kkC0S.BaseAuthApi.createUserRegistrationChallenge(request, this.apiOptions);
        const attestation = await this.apiOptions.signer.create(challenge);
        return $kkC0S.BaseAuthApi.createUserRegistration({
            firstFactorCredential: attestation
        }, {
            ...this.apiOptions,
            authToken: challenge.temporaryAuthenticationToken
        });
    }
}
module.exports.DfnsAuthenticator = $bc2a94b305e25d75$var$DfnsAuthenticator;

});

parcelRegister("jkgHv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DfnsDelegatedApiClient = void 0;

var $8AKy6 = parcelRequire("8AKy6");

var $8VgRn = parcelRequire("8VgRn");

var $eeNb6 = parcelRequire("eeNb6");

var $6SM1g = parcelRequire("6SM1g");

var $HS1HW = parcelRequire("HS1HW");

var $4slbO = parcelRequire("4slbO");

var $kXHdH = parcelRequire("kXHdH");

var $a46CN = parcelRequire("a46CN");

var $heFHH = parcelRequire("heFHH");

var $cYj75 = parcelRequire("cYj75");

var $hahI2 = parcelRequire("hahI2");

var $afHNt = parcelRequire("afHNt");

var $6beEe = parcelRequire("6beEe");

var $8fuVG = parcelRequire("8fuVG");

var $1xEvM = parcelRequire("1xEvM");
class $e11cd6f9c9098827$var$DfnsDelegatedApiClient {
    constructor(apiOptions){
        this.apiOptions = apiOptions;
    }
    get agreements() {
        return new $8AKy6.DelegatedAgreementsClient(this.apiOptions);
    }
    get allocations() {
        return new $8VgRn.DelegatedAllocationsClient(this.apiOptions);
    }
    get auth() {
        return new $eeNb6.DelegatedAuthClient(this.apiOptions);
    }
    get exchanges() {
        return new $6SM1g.DelegatedExchangesClient(this.apiOptions);
    }
    get feeSponsors() {
        return new $HS1HW.DelegatedFeeSponsorsClient(this.apiOptions);
    }
    get keys() {
        return new $4slbO.DelegatedKeysClient(this.apiOptions);
    }
    get networks() {
        return new $kXHdH.DelegatedNetworksClient(this.apiOptions);
    }
    get payouts() {
        return new $a46CN.DelegatedPayoutsClient(this.apiOptions);
    }
    get permissions() {
        return new $heFHH.DelegatedPermissionsClient(this.apiOptions);
    }
    get policies() {
        return new $cYj75.DelegatedPoliciesClient(this.apiOptions);
    }
    get staking() {
        return new $afHNt.DelegatedStakingClient(this.apiOptions);
    }
    get swaps() {
        return new $6beEe.DelegatedSwapsClient(this.apiOptions);
    }
    get signers() {
        return new $hahI2.DelegatedSignersClient(this.apiOptions);
    }
    get wallets() {
        return new $8fuVG.DelegatedWalletsClient(this.apiOptions);
    }
    get webhooks() {
        return new $1xEvM.DelegatedWebhooksClient(this.apiOptions);
    }
}
module.exports.DfnsDelegatedApiClient = $e11cd6f9c9098827$var$DfnsDelegatedApiClient;

});

parcelRegister("i3JNf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bQsdO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8nnYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minimizeBigInt = void 0;
const $61931276c14e9847$var$minimizeBigInt = (value)=>{
    const minValue = [
        0,
        ...value
    ];
    for(let i = 0; i < minValue.length; ++i){
        if (minValue[i] === 0) continue;
        if (minValue[i] > 0x7f) return new Uint8Array(minValue.slice(i - 1));
        return new Uint8Array(minValue.slice(i));
    }
    return new Uint8Array([
        0
    ]);
};
module.exports.minimizeBigInt = $61931276c14e9847$var$minimizeBigInt;

});

parcelRegister("6GiKw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rawSignatureToAns1 = module.exports.exportPublicKeyInPemFormatBrowser = void 0;

var $B0S8N = parcelRequire("B0S8N");

var $b3jWV = parcelRequire("b3jWV");

var $iAroj = parcelRequire("iAroj");

var $8nnYL = parcelRequire("8nnYL");
// Using crypto.subtle in order to run this in the browser
// Adding `Browser` in the function name to distinguish with native node crypto module usage
const $4dd5358e685bfede$var$exportPublicKeyInPemFormatBrowser = async (key)=>{
    const exported = await crypto.subtle.exportKey('spki', key.publicKey);
    const b64Exported = (0, $b3jWV.toBase64)($B0S8N.Buffer.from(exported));
    const pem = `-----BEGIN PUBLIC KEY-----\n${(0, $iAroj.splitString)(b64Exported).join("\n")}\n-----END PUBLIC KEY-----`;
    return pem;
};
module.exports.exportPublicKeyInPemFormatBrowser = $4dd5358e685bfede$var$exportPublicKeyInPemFormatBrowser;
const $4dd5358e685bfede$var$rawSignatureToAns1 = (rawSignature)=>{
    const r = rawSignature.slice(0, 32);
    const s = rawSignature.slice(32);
    const minR = (0, $8nnYL.minimizeBigInt)(r);
    const minS = (0, $8nnYL.minimizeBigInt)(s);
    return new Uint8Array([
        0x30,
        minR.length + minS.length + 4,
        0x02,
        minR.length,
        ...minR,
        0x02,
        minS.length,
        ...minS
    ]);
};
module.exports.rawSignatureToAns1 = $4dd5358e685bfede$var$rawSignatureToAns1;

});

parcelRegister("6QUUT", function(module, exports) {

module.exports = (parcelRequire("kD7Up"))($parcel$resolve("fuoMb")).then(()=>parcelRequire('2Fa7W'));

});
parcelRegister("kD7Up", function(module, exports) {
"use strict";

var $67QRm = parcelRequire("67QRm");
module.exports = $67QRm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("67QRm", function(module, exports) {
"use strict";
var $475c665d4d61f019$var$cachedBundles = {};
var $475c665d4d61f019$var$cachedPreloads = {};
var $475c665d4d61f019$var$cachedPrefetches = {};
function $475c665d4d61f019$var$getCache(type) {
    switch(type){
        case 'preload':
            return $475c665d4d61f019$var$cachedPreloads;
        case 'prefetch':
            return $475c665d4d61f019$var$cachedPrefetches;
        default:
            return $475c665d4d61f019$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $475c665d4d61f019$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $71767dbb272d6e29$exports = {};
$parcel$extendImportMap({
    "fuoMb": "esm.64148e96.js",
    "ghWye": "service-worker.js"
});

/*!
Turbo 8.0.23
Copyright © 2026 37signals LLC
 */ const $fb0d47f64ee363ae$export$65f98fefe20dbcb6 = {
    eager: "eager",
    lazy: "lazy"
};
/**
 * Contains a fragment of HTML which is updated based on navigation within
 * it (e.g. via links or form submissions).
 *
 * @customElement turbo-frame
 * @example
 *   <turbo-frame id="messages">
 *     <a href="/messages/expanded">
 *       Show all expanded messages in this frame.
 *     </a>
 *
 *     <form action="/messages">
 *       Show response from this form within this frame.
 *     </form>
 *   </turbo-frame>
 */ class $fb0d47f64ee363ae$export$f464a8f0ffa32c44 extends HTMLElement {
    static delegateConstructor = undefined;
    loaded = Promise.resolve();
    static get observedAttributes() {
        return [
            "disabled",
            "loading",
            "src"
        ];
    }
    constructor(){
        super();
        this.delegate = new $fb0d47f64ee363ae$export$f464a8f0ffa32c44.delegateConstructor(this);
    }
    connectedCallback() {
        this.delegate.connect();
    }
    disconnectedCallback() {
        this.delegate.disconnect();
    }
    reload() {
        return this.delegate.sourceURLReloaded();
    }
    attributeChangedCallback(name) {
        if (name == "loading") this.delegate.loadingStyleChanged();
        else if (name == "src") this.delegate.sourceURLChanged();
        else if (name == "disabled") this.delegate.disabledChanged();
    }
    /**
   * Gets the URL to lazily load source HTML from
   */ get src() {
        return this.getAttribute("src");
    }
    /**
   * Sets the URL to lazily load source HTML from
   */ set src(value) {
        if (value) this.setAttribute("src", value);
        else this.removeAttribute("src");
    }
    /**
   * Gets the refresh mode for the frame.
   */ get refresh() {
        return this.getAttribute("refresh");
    }
    /**
   * Sets the refresh mode for the frame.
   */ set refresh(value) {
        if (value) this.setAttribute("refresh", value);
        else this.removeAttribute("refresh");
    }
    get shouldReloadWithMorph() {
        return this.src && this.refresh === "morph";
    }
    /**
   * Determines if the element is loading
   */ get loading() {
        return $fb0d47f64ee363ae$var$frameLoadingStyleFromString(this.getAttribute("loading") || "");
    }
    /**
   * Sets the value of if the element is loading
   */ set loading(value) {
        if (value) this.setAttribute("loading", value);
        else this.removeAttribute("loading");
    }
    /**
   * Gets the disabled state of the frame.
   *
   * If disabled, no requests will be intercepted by the frame.
   */ get disabled() {
        return this.hasAttribute("disabled");
    }
    /**
   * Sets the disabled state of the frame.
   *
   * If disabled, no requests will be intercepted by the frame.
   */ set disabled(value) {
        if (value) this.setAttribute("disabled", "");
        else this.removeAttribute("disabled");
    }
    /**
   * Gets the autoscroll state of the frame.
   *
   * If true, the frame will be scrolled into view automatically on update.
   */ get autoscroll() {
        return this.hasAttribute("autoscroll");
    }
    /**
   * Sets the autoscroll state of the frame.
   *
   * If true, the frame will be scrolled into view automatically on update.
   */ set autoscroll(value) {
        if (value) this.setAttribute("autoscroll", "");
        else this.removeAttribute("autoscroll");
    }
    /**
   * Determines if the element has finished loading
   */ get complete() {
        return !this.delegate.isLoading;
    }
    /**
   * Gets the active state of the frame.
   *
   * If inactive, source changes will not be observed.
   */ get isActive() {
        return this.ownerDocument === document && !this.isPreview;
    }
    /**
   * Sets the active state of the frame.
   *
   * If inactive, source changes will not be observed.
   */ get isPreview() {
        return this.ownerDocument?.documentElement?.hasAttribute("data-turbo-preview");
    }
}
function $fb0d47f64ee363ae$var$frameLoadingStyleFromString(style) {
    switch(style.toLowerCase()){
        case "lazy":
            return $fb0d47f64ee363ae$export$65f98fefe20dbcb6.lazy;
        default:
            return $fb0d47f64ee363ae$export$65f98fefe20dbcb6.eager;
    }
}
const $fb0d47f64ee363ae$var$drive = {
    enabled: true,
    progressBarDelay: 500,
    unvisitableExtensions: new Set([
        ".7z",
        ".aac",
        ".apk",
        ".avi",
        ".bmp",
        ".bz2",
        ".css",
        ".csv",
        ".deb",
        ".dmg",
        ".doc",
        ".docx",
        ".exe",
        ".gif",
        ".gz",
        ".heic",
        ".heif",
        ".ico",
        ".iso",
        ".jpeg",
        ".jpg",
        ".js",
        ".json",
        ".m4a",
        ".mkv",
        ".mov",
        ".mp3",
        ".mp4",
        ".mpeg",
        ".mpg",
        ".msi",
        ".ogg",
        ".ogv",
        ".pdf",
        ".pkg",
        ".png",
        ".ppt",
        ".pptx",
        ".rar",
        ".rtf",
        ".svg",
        ".tar",
        ".tif",
        ".tiff",
        ".txt",
        ".wav",
        ".webm",
        ".webp",
        ".wma",
        ".wmv",
        ".xls",
        ".xlsx",
        ".xml",
        ".zip"
    ])
};
function $fb0d47f64ee363ae$var$activateScriptElement(element) {
    if (element.getAttribute("data-turbo-eval") == "false") return element;
    else {
        const createdScriptElement = document.createElement("script");
        const cspNonce = $fb0d47f64ee363ae$var$getCspNonce();
        if (cspNonce) createdScriptElement.nonce = cspNonce;
        createdScriptElement.textContent = element.textContent;
        createdScriptElement.async = false;
        $fb0d47f64ee363ae$var$copyElementAttributes(createdScriptElement, element);
        return createdScriptElement;
    }
}
function $fb0d47f64ee363ae$var$copyElementAttributes(destinationElement, sourceElement) {
    for (const { name: name, value: value } of sourceElement.attributes)destinationElement.setAttribute(name, value);
}
function $fb0d47f64ee363ae$var$createDocumentFragment(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    return template.content;
}
function $fb0d47f64ee363ae$var$dispatch(eventName, { target: target, cancelable: cancelable, detail: detail } = {}) {
    const event = new CustomEvent(eventName, {
        cancelable: cancelable,
        bubbles: true,
        composed: true,
        detail: detail
    });
    if (target && target.isConnected) target.dispatchEvent(event);
    else document.documentElement.dispatchEvent(event);
    return event;
}
function $fb0d47f64ee363ae$var$cancelEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
function $fb0d47f64ee363ae$var$nextRepaint() {
    if (document.visibilityState === "hidden") return $fb0d47f64ee363ae$var$nextEventLoopTick();
    else return $fb0d47f64ee363ae$var$nextAnimationFrame();
}
function $fb0d47f64ee363ae$var$nextAnimationFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}
function $fb0d47f64ee363ae$var$nextEventLoopTick() {
    return new Promise((resolve)=>setTimeout(()=>resolve(), 0));
}
function $fb0d47f64ee363ae$var$parseHTMLDocument(html = "") {
    return new DOMParser().parseFromString(html, "text/html");
}
function $fb0d47f64ee363ae$var$unindent(strings, ...values) {
    const lines = $fb0d47f64ee363ae$var$interpolate(strings, values).replace(/^\n/, "").split("\n");
    const match = lines[0].match(/^\s+/);
    const indent = match ? match[0].length : 0;
    return lines.map((line)=>line.slice(indent)).join("\n");
}
function $fb0d47f64ee363ae$var$interpolate(strings, values) {
    return strings.reduce((result, string, i)=>{
        const value = values[i] == undefined ? "" : values[i];
        return result + string + value;
    }, "");
}
function $fb0d47f64ee363ae$var$uuid() {
    return Array.from({
        length: 36
    }).map((_, i)=>{
        if (i == 8 || i == 13 || i == 18 || i == 23) return "-";
        else if (i == 14) return "4";
        else if (i == 19) return (Math.floor(Math.random() * 4) + 8).toString(16);
        else return Math.floor(Math.random() * 16).toString(16);
    }).join("");
}
function $fb0d47f64ee363ae$var$getAttribute(attributeName, ...elements) {
    for (const value of elements.map((element)=>element?.getAttribute(attributeName))){
        if (typeof value == "string") return value;
    }
    return null;
}
function $fb0d47f64ee363ae$var$hasAttribute(attributeName, ...elements) {
    return elements.some((element)=>element && element.hasAttribute(attributeName));
}
function $fb0d47f64ee363ae$var$markAsBusy(...elements) {
    for (const element of elements){
        if (element.localName == "turbo-frame") element.setAttribute("busy", "");
        element.setAttribute("aria-busy", "true");
    }
}
function $fb0d47f64ee363ae$var$clearBusyState(...elements) {
    for (const element of elements){
        if (element.localName == "turbo-frame") element.removeAttribute("busy");
        element.removeAttribute("aria-busy");
    }
}
function $fb0d47f64ee363ae$var$waitForLoad(element, timeoutInMilliseconds = 2000) {
    return new Promise((resolve)=>{
        const onComplete = ()=>{
            element.removeEventListener("error", onComplete);
            element.removeEventListener("load", onComplete);
            resolve();
        };
        element.addEventListener("load", onComplete, {
            once: true
        });
        element.addEventListener("error", onComplete, {
            once: true
        });
        setTimeout(resolve, timeoutInMilliseconds);
    });
}
function $fb0d47f64ee363ae$var$getHistoryMethodForAction(action) {
    switch(action){
        case "replace":
            return history.replaceState;
        case "advance":
        case "restore":
            return history.pushState;
    }
}
function $fb0d47f64ee363ae$var$isAction(action) {
    return action == "advance" || action == "replace" || action == "restore";
}
function $fb0d47f64ee363ae$var$getVisitAction(...elements) {
    const action = $fb0d47f64ee363ae$var$getAttribute("data-turbo-action", ...elements);
    return $fb0d47f64ee363ae$var$isAction(action) ? action : null;
}
function $fb0d47f64ee363ae$var$getMetaElement(name) {
    return document.querySelector(`meta[name="${name}"]`);
}
function $fb0d47f64ee363ae$var$getMetaContent(name) {
    const element = $fb0d47f64ee363ae$var$getMetaElement(name);
    return element && element.content;
}
function $fb0d47f64ee363ae$var$getCspNonce() {
    const element = $fb0d47f64ee363ae$var$getMetaElement("csp-nonce");
    if (element) {
        const { nonce: nonce, content: content } = element;
        return nonce == "" ? content : nonce;
    }
}
function $fb0d47f64ee363ae$var$setMetaContent(name, content) {
    let element = $fb0d47f64ee363ae$var$getMetaElement(name);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
    return element;
}
function $fb0d47f64ee363ae$var$findClosestRecursively(element, selector) {
    if (element instanceof Element) return element.closest(selector) || $fb0d47f64ee363ae$var$findClosestRecursively(element.assignedSlot || element.getRootNode()?.host, selector);
}
function $fb0d47f64ee363ae$var$elementIsFocusable(element) {
    const inertDisabledOrHidden = "[inert], :disabled, [hidden], details:not([open]), dialog:not([open])";
    return !!element && element.closest(inertDisabledOrHidden) == null && typeof element.focus == "function";
}
function $fb0d47f64ee363ae$var$queryAutofocusableElement(elementOrDocumentFragment) {
    return Array.from(elementOrDocumentFragment.querySelectorAll("[autofocus]")).find($fb0d47f64ee363ae$var$elementIsFocusable);
}
async function $fb0d47f64ee363ae$var$around(callback, reader) {
    const before = reader();
    callback();
    await $fb0d47f64ee363ae$var$nextAnimationFrame();
    const after = reader();
    return [
        before,
        after
    ];
}
function $fb0d47f64ee363ae$var$doesNotTargetIFrame(name) {
    if (name === "_blank") return false;
    else if (name) {
        for (const element of document.getElementsByName(name)){
            if (element instanceof HTMLIFrameElement) return false;
        }
        return true;
    } else return true;
}
function $fb0d47f64ee363ae$var$findLinkFromClickTarget(target) {
    const link = $fb0d47f64ee363ae$var$findClosestRecursively(target, "a[href], a[xlink\\:href]");
    if (!link) return null;
    if (link.href.startsWith("#")) return null;
    if (link.hasAttribute("download")) return null;
    const linkTarget = link.getAttribute("target");
    if (linkTarget && linkTarget !== "_self") return null;
    return link;
}
function $fb0d47f64ee363ae$var$debounce(fn, delay) {
    let timeoutId = null;
    return (...args)=>{
        const callback = ()=>fn.apply(this, args);
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, delay);
    };
}
const $fb0d47f64ee363ae$var$submitter = {
    "aria-disabled": {
        beforeSubmit: (submitter)=>{
            submitter.setAttribute("aria-disabled", "true");
            submitter.addEventListener("click", $fb0d47f64ee363ae$var$cancelEvent);
        },
        afterSubmit: (submitter)=>{
            submitter.removeAttribute("aria-disabled");
            submitter.removeEventListener("click", $fb0d47f64ee363ae$var$cancelEvent);
        }
    },
    "disabled": {
        beforeSubmit: (submitter)=>submitter.disabled = true,
        afterSubmit: (submitter)=>submitter.disabled = false
    }
};
class $fb0d47f64ee363ae$var$Config {
    #submitter = null;
    constructor(config){
        Object.assign(this, config);
    }
    get submitter() {
        return this.#submitter;
    }
    set submitter(value) {
        this.#submitter = $fb0d47f64ee363ae$var$submitter[value] || value;
    }
}
const $fb0d47f64ee363ae$var$forms = new $fb0d47f64ee363ae$var$Config({
    mode: "on",
    submitter: "disabled"
});
const $fb0d47f64ee363ae$export$e506a1d27d1eaa20 = {
    drive: $fb0d47f64ee363ae$var$drive,
    forms: $fb0d47f64ee363ae$var$forms
};
function $fb0d47f64ee363ae$var$expandURL(locatable) {
    return new URL(locatable.toString(), document.baseURI);
}
function $fb0d47f64ee363ae$var$getAnchor(url) {
    let anchorMatch;
    if (url.hash) return url.hash.slice(1);
    else if (anchorMatch = url.href.match(/#(.*)$/)) return anchorMatch[1];
}
function $fb0d47f64ee363ae$var$getAction$1(form, submitter) {
    const action = submitter?.getAttribute("formaction") || form.getAttribute("action") || form.action;
    return $fb0d47f64ee363ae$var$expandURL(action);
}
function $fb0d47f64ee363ae$var$getExtension(url) {
    return ($fb0d47f64ee363ae$var$getLastPathComponent(url).match(/\.[^.]*$/) || [])[0] || "";
}
function $fb0d47f64ee363ae$var$isPrefixedBy(baseURL, url) {
    const prefix = $fb0d47f64ee363ae$var$addTrailingSlash(url.origin + url.pathname);
    return $fb0d47f64ee363ae$var$addTrailingSlash(baseURL.href) === prefix || baseURL.href.startsWith(prefix);
}
function $fb0d47f64ee363ae$var$locationIsVisitable(location1, rootLocation) {
    return $fb0d47f64ee363ae$var$isPrefixedBy(location1, rootLocation) && !$fb0d47f64ee363ae$export$e506a1d27d1eaa20.drive.unvisitableExtensions.has($fb0d47f64ee363ae$var$getExtension(location1));
}
function $fb0d47f64ee363ae$var$getLocationForLink(link) {
    return $fb0d47f64ee363ae$var$expandURL(link.getAttribute("href") || "");
}
function $fb0d47f64ee363ae$var$getRequestURL(url) {
    const anchor = $fb0d47f64ee363ae$var$getAnchor(url);
    return anchor != null ? url.href.slice(0, -(anchor.length + 1)) : url.href;
}
function $fb0d47f64ee363ae$var$toCacheKey(url) {
    return $fb0d47f64ee363ae$var$getRequestURL(url);
}
function $fb0d47f64ee363ae$var$urlsAreEqual(left, right) {
    return $fb0d47f64ee363ae$var$expandURL(left).href == $fb0d47f64ee363ae$var$expandURL(right).href;
}
function $fb0d47f64ee363ae$var$getPathComponents(url) {
    return url.pathname.split("/").slice(1);
}
function $fb0d47f64ee363ae$var$getLastPathComponent(url) {
    return $fb0d47f64ee363ae$var$getPathComponents(url).slice(-1)[0];
}
function $fb0d47f64ee363ae$var$addTrailingSlash(value) {
    return value.endsWith("/") ? value : value + "/";
}
class $fb0d47f64ee363ae$export$3ae09bba5b6b906e {
    constructor(response){
        this.response = response;
    }
    get succeeded() {
        return this.response.ok;
    }
    get failed() {
        return !this.succeeded;
    }
    get clientError() {
        return this.statusCode >= 400 && this.statusCode <= 499;
    }
    get serverError() {
        return this.statusCode >= 500 && this.statusCode <= 599;
    }
    get redirected() {
        return this.response.redirected;
    }
    get location() {
        return $fb0d47f64ee363ae$var$expandURL(this.response.url);
    }
    get isHTML() {
        return this.contentType && this.contentType.match(/^(?:text\/([^\s;,]+\b)?html|application\/xhtml\+xml)\b/);
    }
    get statusCode() {
        return this.response.status;
    }
    get contentType() {
        return this.header("Content-Type");
    }
    get responseText() {
        return this.response.clone().text();
    }
    get responseHTML() {
        if (this.isHTML) return this.response.clone().text();
        else return Promise.resolve(undefined);
    }
    header(name) {
        return this.response.headers.get(name);
    }
}
class $fb0d47f64ee363ae$var$LimitedSet extends Set {
    constructor(maxSize){
        super();
        this.maxSize = maxSize;
    }
    add(value) {
        if (this.size >= this.maxSize) {
            const iterator = this.values();
            const oldestValue = iterator.next().value;
            this.delete(oldestValue);
        }
        super.add(value);
    }
}
const $fb0d47f64ee363ae$var$recentRequests = new $fb0d47f64ee363ae$var$LimitedSet(20);
function $fb0d47f64ee363ae$export$e7aa7bc5c1b3cfb3(url, options = {}) {
    const modifiedHeaders = new Headers(options.headers || {});
    const requestUID = $fb0d47f64ee363ae$var$uuid();
    $fb0d47f64ee363ae$var$recentRequests.add(requestUID);
    modifiedHeaders.append("X-Turbo-Request-Id", requestUID);
    return window.fetch(url, {
        ...options,
        headers: modifiedHeaders
    });
}
function $fb0d47f64ee363ae$export$4d71dd6e9f25af75(method) {
    switch(method.toLowerCase()){
        case "get":
            return $fb0d47f64ee363ae$export$76f6869e29ff06ee.get;
        case "post":
            return $fb0d47f64ee363ae$export$76f6869e29ff06ee.post;
        case "put":
            return $fb0d47f64ee363ae$export$76f6869e29ff06ee.put;
        case "patch":
            return $fb0d47f64ee363ae$export$76f6869e29ff06ee.patch;
        case "delete":
            return $fb0d47f64ee363ae$export$76f6869e29ff06ee.delete;
    }
}
const $fb0d47f64ee363ae$export$76f6869e29ff06ee = {
    get: "get",
    post: "post",
    put: "put",
    patch: "patch",
    delete: "delete"
};
function $fb0d47f64ee363ae$export$4894fff9b16f993d(encoding) {
    switch(encoding.toLowerCase()){
        case $fb0d47f64ee363ae$export$12bb94f0959cac5.multipart:
            return $fb0d47f64ee363ae$export$12bb94f0959cac5.multipart;
        case $fb0d47f64ee363ae$export$12bb94f0959cac5.plain:
            return $fb0d47f64ee363ae$export$12bb94f0959cac5.plain;
        default:
            return $fb0d47f64ee363ae$export$12bb94f0959cac5.urlEncoded;
    }
}
const $fb0d47f64ee363ae$export$12bb94f0959cac5 = {
    urlEncoded: "application/x-www-form-urlencoded",
    multipart: "multipart/form-data",
    plain: "text/plain"
};
class $fb0d47f64ee363ae$export$319b96fe59834522 {
    abortController = new AbortController();
    #resolveRequestPromise = (_value)=>{};
    constructor(delegate, method, location1, requestBody = new URLSearchParams(), target = null, enctype = $fb0d47f64ee363ae$export$12bb94f0959cac5.urlEncoded){
        const [url, body] = $fb0d47f64ee363ae$var$buildResourceAndBody($fb0d47f64ee363ae$var$expandURL(location1), method, requestBody, enctype);
        this.delegate = delegate;
        this.url = url;
        this.target = target;
        this.fetchOptions = {
            credentials: "same-origin",
            redirect: "follow",
            method: method.toUpperCase(),
            headers: {
                ...this.defaultHeaders
            },
            body: body,
            signal: this.abortSignal,
            referrer: this.delegate.referrer?.href
        };
        this.enctype = enctype;
    }
    get method() {
        return this.fetchOptions.method;
    }
    set method(value) {
        const fetchBody = this.isSafe ? this.url.searchParams : this.fetchOptions.body || new FormData();
        const fetchMethod = $fb0d47f64ee363ae$export$4d71dd6e9f25af75(value) || $fb0d47f64ee363ae$export$76f6869e29ff06ee.get;
        this.url.search = "";
        const [url, body] = $fb0d47f64ee363ae$var$buildResourceAndBody(this.url, fetchMethod, fetchBody, this.enctype);
        this.url = url;
        this.fetchOptions.body = body;
        this.fetchOptions.method = fetchMethod.toUpperCase();
    }
    get headers() {
        return this.fetchOptions.headers;
    }
    set headers(value) {
        this.fetchOptions.headers = value;
    }
    get body() {
        if (this.isSafe) return this.url.searchParams;
        else return this.fetchOptions.body;
    }
    set body(value) {
        this.fetchOptions.body = value;
    }
    get location() {
        return this.url;
    }
    get params() {
        return this.url.searchParams;
    }
    get entries() {
        return this.body ? Array.from(this.body.entries()) : [];
    }
    cancel() {
        this.abortController.abort();
    }
    async perform() {
        const { fetchOptions: fetchOptions } = this;
        this.delegate.prepareRequest(this);
        const event = await this.#allowRequestToBeIntercepted(fetchOptions);
        try {
            this.delegate.requestStarted(this);
            if (event.detail.fetchRequest) this.response = event.detail.fetchRequest.response;
            else this.response = $fb0d47f64ee363ae$export$e7aa7bc5c1b3cfb3(this.url.href, fetchOptions);
            const response = await this.response;
            return await this.receive(response);
        } catch (error) {
            if (error.name !== "AbortError") {
                if (this.#willDelegateErrorHandling(error)) this.delegate.requestErrored(this, error);
                throw error;
            }
        } finally{
            this.delegate.requestFinished(this);
        }
    }
    async receive(response) {
        const fetchResponse = new $fb0d47f64ee363ae$export$3ae09bba5b6b906e(response);
        const event = $fb0d47f64ee363ae$var$dispatch("turbo:before-fetch-response", {
            cancelable: true,
            detail: {
                fetchResponse: fetchResponse
            },
            target: this.target
        });
        if (event.defaultPrevented) this.delegate.requestPreventedHandlingResponse(this, fetchResponse);
        else if (fetchResponse.succeeded) this.delegate.requestSucceededWithResponse(this, fetchResponse);
        else this.delegate.requestFailedWithResponse(this, fetchResponse);
        return fetchResponse;
    }
    get defaultHeaders() {
        return {
            Accept: "text/html, application/xhtml+xml"
        };
    }
    get isSafe() {
        return $fb0d47f64ee363ae$export$26e0721b40973527(this.method);
    }
    get abortSignal() {
        return this.abortController.signal;
    }
    acceptResponseType(mimeType) {
        this.headers["Accept"] = [
            mimeType,
            this.headers["Accept"]
        ].join(", ");
    }
    async #allowRequestToBeIntercepted(fetchOptions) {
        const requestInterception = new Promise((resolve)=>this.#resolveRequestPromise = resolve);
        const event = $fb0d47f64ee363ae$var$dispatch("turbo:before-fetch-request", {
            cancelable: true,
            detail: {
                fetchOptions: fetchOptions,
                url: this.url,
                resume: this.#resolveRequestPromise
            },
            target: this.target
        });
        this.url = event.detail.url;
        if (event.defaultPrevented) await requestInterception;
        return event;
    }
    #willDelegateErrorHandling(error) {
        const event = $fb0d47f64ee363ae$var$dispatch("turbo:fetch-request-error", {
            target: this.target,
            cancelable: true,
            detail: {
                request: this,
                error: error
            }
        });
        return !event.defaultPrevented;
    }
}
function $fb0d47f64ee363ae$export$26e0721b40973527(fetchMethod) {
    return $fb0d47f64ee363ae$export$4d71dd6e9f25af75(fetchMethod) == $fb0d47f64ee363ae$export$76f6869e29ff06ee.get;
}
function $fb0d47f64ee363ae$var$buildResourceAndBody(resource, method, requestBody, enctype) {
    const searchParams = Array.from(requestBody).length > 0 ? new URLSearchParams($fb0d47f64ee363ae$var$entriesExcludingFiles(requestBody)) : resource.searchParams;
    if ($fb0d47f64ee363ae$export$26e0721b40973527(method)) return [
        $fb0d47f64ee363ae$var$mergeIntoURLSearchParams(resource, searchParams),
        null
    ];
    else if (enctype == $fb0d47f64ee363ae$export$12bb94f0959cac5.urlEncoded) return [
        resource,
        searchParams
    ];
    else return [
        resource,
        requestBody
    ];
}
function $fb0d47f64ee363ae$var$entriesExcludingFiles(requestBody) {
    const entries = [];
    for (const [name, value] of requestBody){
        if (value instanceof File) continue;
        else entries.push([
            name,
            value
        ]);
    }
    return entries;
}
function $fb0d47f64ee363ae$var$mergeIntoURLSearchParams(url, requestBody) {
    const searchParams = new URLSearchParams($fb0d47f64ee363ae$var$entriesExcludingFiles(requestBody));
    url.search = searchParams.toString();
    return url;
}
class $fb0d47f64ee363ae$var$AppearanceObserver {
    started = false;
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
        this.intersectionObserver = new IntersectionObserver(this.intersect);
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.intersectionObserver.observe(this.element);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.intersectionObserver.unobserve(this.element);
        }
    }
    intersect = (entries)=>{
        const lastEntry = entries.slice(-1)[0];
        if (lastEntry?.isIntersecting) this.delegate.elementAppearedInViewport(this.element);
    };
}
class $fb0d47f64ee363ae$var$StreamMessage {
    static contentType = "text/vnd.turbo-stream.html";
    static wrap(message) {
        if (typeof message == "string") return new this($fb0d47f64ee363ae$var$createDocumentFragment(message));
        else return message;
    }
    constructor(fragment){
        this.fragment = $fb0d47f64ee363ae$var$importStreamElements(fragment);
    }
}
function $fb0d47f64ee363ae$var$importStreamElements(fragment) {
    for (const element of fragment.querySelectorAll("turbo-stream")){
        const streamElement = document.importNode(element, true);
        for (const inertScriptElement of streamElement.templateElement.content.querySelectorAll("script"))inertScriptElement.replaceWith($fb0d47f64ee363ae$var$activateScriptElement(inertScriptElement));
        element.replaceWith(streamElement);
    }
    return fragment;
}
const $fb0d47f64ee363ae$var$identity = (key)=>key;
class $fb0d47f64ee363ae$var$LRUCache {
    keys = [];
    entries = {};
    #toCacheKey;
    constructor(size, toCacheKey = $fb0d47f64ee363ae$var$identity){
        this.size = size;
        this.#toCacheKey = toCacheKey;
    }
    has(key) {
        return this.#toCacheKey(key) in this.entries;
    }
    get(key) {
        if (this.has(key)) {
            const entry = this.read(key);
            this.touch(key);
            return entry;
        }
    }
    put(key, entry) {
        this.write(key, entry);
        this.touch(key);
        return entry;
    }
    clear() {
        for (const key of Object.keys(this.entries))this.evict(key);
    }
    // Private
    read(key) {
        return this.entries[this.#toCacheKey(key)];
    }
    write(key, entry) {
        this.entries[this.#toCacheKey(key)] = entry;
    }
    touch(key) {
        key = this.#toCacheKey(key);
        const index = this.keys.indexOf(key);
        if (index > -1) this.keys.splice(index, 1);
        this.keys.unshift(key);
        this.trim();
    }
    trim() {
        for (const key of this.keys.splice(this.size))this.evict(key);
    }
    evict(key) {
        delete this.entries[key];
    }
}
const $fb0d47f64ee363ae$var$PREFETCH_DELAY = 100;
class $fb0d47f64ee363ae$var$PrefetchCache extends $fb0d47f64ee363ae$var$LRUCache {
    #prefetchTimeout = null;
    #maxAges = {};
    constructor(size = 1, prefetchDelay = $fb0d47f64ee363ae$var$PREFETCH_DELAY){
        super(size, $fb0d47f64ee363ae$var$toCacheKey);
        this.prefetchDelay = prefetchDelay;
    }
    putLater(url, request, ttl) {
        this.#prefetchTimeout = setTimeout(()=>{
            request.perform();
            this.put(url, request, ttl);
            this.#prefetchTimeout = null;
        }, this.prefetchDelay);
    }
    put(url, request, ttl = $fb0d47f64ee363ae$var$cacheTtl) {
        super.put(url, request);
        this.#maxAges[$fb0d47f64ee363ae$var$toCacheKey(url)] = new Date(new Date().getTime() + ttl);
    }
    clear() {
        super.clear();
        if (this.#prefetchTimeout) clearTimeout(this.#prefetchTimeout);
    }
    evict(key) {
        super.evict(key);
        delete this.#maxAges[key];
    }
    has(key) {
        if (super.has(key)) {
            const maxAge = this.#maxAges[$fb0d47f64ee363ae$var$toCacheKey(key)];
            return maxAge && maxAge > Date.now();
        } else return false;
    }
}
const $fb0d47f64ee363ae$var$cacheTtl = 10000;
const $fb0d47f64ee363ae$var$prefetchCache = new $fb0d47f64ee363ae$var$PrefetchCache();
const $fb0d47f64ee363ae$var$FormSubmissionState = {
    initialized: "initialized",
    requesting: "requesting",
    waiting: "waiting",
    receiving: "receiving",
    stopping: "stopping",
    stopped: "stopped"
};
class $fb0d47f64ee363ae$var$FormSubmission {
    state = $fb0d47f64ee363ae$var$FormSubmissionState.initialized;
    static confirmMethod(message) {
        return Promise.resolve(confirm(message));
    }
    constructor(delegate, formElement, submitter, mustRedirect = false){
        const method = $fb0d47f64ee363ae$var$getMethod(formElement, submitter);
        const action = $fb0d47f64ee363ae$var$getAction($fb0d47f64ee363ae$var$getFormAction(formElement, submitter), method);
        const body = $fb0d47f64ee363ae$var$buildFormData(formElement, submitter);
        const enctype = $fb0d47f64ee363ae$var$getEnctype(formElement, submitter);
        this.delegate = delegate;
        this.formElement = formElement;
        this.submitter = submitter;
        this.fetchRequest = new $fb0d47f64ee363ae$export$319b96fe59834522(this, method, action, body, formElement, enctype);
        this.mustRedirect = mustRedirect;
    }
    get method() {
        return this.fetchRequest.method;
    }
    set method(value) {
        this.fetchRequest.method = value;
    }
    get action() {
        return this.fetchRequest.url.toString();
    }
    set action(value) {
        this.fetchRequest.url = $fb0d47f64ee363ae$var$expandURL(value);
    }
    get body() {
        return this.fetchRequest.body;
    }
    get enctype() {
        return this.fetchRequest.enctype;
    }
    get isSafe() {
        return this.fetchRequest.isSafe;
    }
    get location() {
        return this.fetchRequest.url;
    }
    // The submission process
    async start() {
        const { initialized: initialized, requesting: requesting } = $fb0d47f64ee363ae$var$FormSubmissionState;
        const confirmationMessage = $fb0d47f64ee363ae$var$getAttribute("data-turbo-confirm", this.submitter, this.formElement);
        if (typeof confirmationMessage === "string") {
            const confirmMethod = typeof $fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.confirm === "function" ? $fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.confirm : $fb0d47f64ee363ae$var$FormSubmission.confirmMethod;
            const answer = await confirmMethod(confirmationMessage, this.formElement, this.submitter);
            if (!answer) return;
        }
        if (this.state == initialized) {
            this.state = requesting;
            return this.fetchRequest.perform();
        }
    }
    stop() {
        const { stopping: stopping, stopped: stopped } = $fb0d47f64ee363ae$var$FormSubmissionState;
        if (this.state != stopping && this.state != stopped) {
            this.state = stopping;
            this.fetchRequest.cancel();
            return true;
        }
    }
    // Fetch request delegate
    prepareRequest(request) {
        if (!request.isSafe) {
            const token = $fb0d47f64ee363ae$var$getCookieValue($fb0d47f64ee363ae$var$getMetaContent("csrf-param")) || $fb0d47f64ee363ae$var$getMetaContent("csrf-token");
            if (token) request.headers["X-CSRF-Token"] = token;
        }
        if (this.requestAcceptsTurboStreamResponse(request)) request.acceptResponseType($fb0d47f64ee363ae$var$StreamMessage.contentType);
    }
    requestStarted(_request) {
        this.state = $fb0d47f64ee363ae$var$FormSubmissionState.waiting;
        if (this.submitter) $fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.submitter.beforeSubmit(this.submitter);
        this.setSubmitsWith();
        $fb0d47f64ee363ae$var$markAsBusy(this.formElement);
        $fb0d47f64ee363ae$var$dispatch("turbo:submit-start", {
            target: this.formElement,
            detail: {
                formSubmission: this
            }
        });
        this.delegate.formSubmissionStarted(this);
    }
    requestPreventedHandlingResponse(request, response) {
        $fb0d47f64ee363ae$var$prefetchCache.clear();
        this.result = {
            success: response.succeeded,
            fetchResponse: response
        };
    }
    requestSucceededWithResponse(request, response) {
        if (response.clientError || response.serverError) {
            this.delegate.formSubmissionFailedWithResponse(this, response);
            return;
        }
        $fb0d47f64ee363ae$var$prefetchCache.clear();
        if (this.requestMustRedirect(request) && $fb0d47f64ee363ae$var$responseSucceededWithoutRedirect(response)) {
            const error = new Error("Form responses must redirect to another location");
            this.delegate.formSubmissionErrored(this, error);
        } else {
            this.state = $fb0d47f64ee363ae$var$FormSubmissionState.receiving;
            this.result = {
                success: true,
                fetchResponse: response
            };
            this.delegate.formSubmissionSucceededWithResponse(this, response);
        }
    }
    requestFailedWithResponse(request, response) {
        this.result = {
            success: false,
            fetchResponse: response
        };
        this.delegate.formSubmissionFailedWithResponse(this, response);
    }
    requestErrored(request, error) {
        this.result = {
            success: false,
            error: error
        };
        this.delegate.formSubmissionErrored(this, error);
    }
    requestFinished(_request) {
        this.state = $fb0d47f64ee363ae$var$FormSubmissionState.stopped;
        if (this.submitter) $fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.submitter.afterSubmit(this.submitter);
        this.resetSubmitterText();
        $fb0d47f64ee363ae$var$clearBusyState(this.formElement);
        $fb0d47f64ee363ae$var$dispatch("turbo:submit-end", {
            target: this.formElement,
            detail: {
                formSubmission: this,
                ...this.result
            }
        });
        this.delegate.formSubmissionFinished(this);
    }
    // Private
    setSubmitsWith() {
        if (!this.submitter || !this.submitsWith) return;
        if (this.submitter.matches("button")) {
            this.originalSubmitText = this.submitter.innerHTML;
            this.submitter.innerHTML = this.submitsWith;
        } else if (this.submitter.matches("input")) {
            const input = this.submitter;
            this.originalSubmitText = input.value;
            input.value = this.submitsWith;
        }
    }
    resetSubmitterText() {
        if (!this.submitter || !this.originalSubmitText) return;
        if (this.submitter.matches("button")) this.submitter.innerHTML = this.originalSubmitText;
        else if (this.submitter.matches("input")) {
            const input = this.submitter;
            input.value = this.originalSubmitText;
        }
    }
    requestMustRedirect(request) {
        return !request.isSafe && this.mustRedirect;
    }
    requestAcceptsTurboStreamResponse(request) {
        return !request.isSafe || $fb0d47f64ee363ae$var$hasAttribute("data-turbo-stream", this.submitter, this.formElement);
    }
    get submitsWith() {
        return this.submitter?.getAttribute("data-turbo-submits-with");
    }
}
function $fb0d47f64ee363ae$var$buildFormData(formElement, submitter) {
    const formData = new FormData(formElement);
    const name = submitter?.getAttribute("name");
    const value = submitter?.getAttribute("value");
    if (name) formData.append(name, value || "");
    return formData;
}
function $fb0d47f64ee363ae$var$getCookieValue(cookieName) {
    if (cookieName != null) {
        const cookies = document.cookie ? document.cookie.split("; ") : [];
        const cookie = cookies.find((cookie)=>cookie.startsWith(cookieName));
        if (cookie) {
            const value = cookie.split("=").slice(1).join("=");
            return value ? decodeURIComponent(value) : undefined;
        }
    }
}
function $fb0d47f64ee363ae$var$responseSucceededWithoutRedirect(response) {
    return response.statusCode == 200 && !response.redirected;
}
function $fb0d47f64ee363ae$var$getFormAction(formElement, submitter) {
    const formElementAction = typeof formElement.action === "string" ? formElement.action : null;
    if (submitter?.hasAttribute("formaction")) return submitter.getAttribute("formaction") || "";
    else return formElement.getAttribute("action") || formElementAction || "";
}
function $fb0d47f64ee363ae$var$getAction(formAction, fetchMethod) {
    const action = $fb0d47f64ee363ae$var$expandURL(formAction);
    if ($fb0d47f64ee363ae$export$26e0721b40973527(fetchMethod)) action.search = "";
    return action;
}
function $fb0d47f64ee363ae$var$getMethod(formElement, submitter) {
    const method = submitter?.getAttribute("formmethod") || formElement.getAttribute("method") || "";
    return $fb0d47f64ee363ae$export$4d71dd6e9f25af75(method.toLowerCase()) || $fb0d47f64ee363ae$export$76f6869e29ff06ee.get;
}
function $fb0d47f64ee363ae$var$getEnctype(formElement, submitter) {
    return $fb0d47f64ee363ae$export$4894fff9b16f993d(submitter?.getAttribute("formenctype") || formElement.enctype);
}
class $fb0d47f64ee363ae$var$Snapshot {
    constructor(element){
        this.element = element;
    }
    get activeElement() {
        return this.element.ownerDocument.activeElement;
    }
    get children() {
        return [
            ...this.element.children
        ];
    }
    hasAnchor(anchor) {
        return this.getElementForAnchor(anchor) != null;
    }
    getElementForAnchor(anchor) {
        return anchor ? this.element.querySelector(`[id='${anchor}'], a[name='${anchor}']`) : null;
    }
    get isConnected() {
        return this.element.isConnected;
    }
    get firstAutofocusableElement() {
        return $fb0d47f64ee363ae$var$queryAutofocusableElement(this.element);
    }
    get permanentElements() {
        return $fb0d47f64ee363ae$var$queryPermanentElementsAll(this.element);
    }
    getPermanentElementById(id) {
        return $fb0d47f64ee363ae$var$getPermanentElementById(this.element, id);
    }
    getPermanentElementMapForSnapshot(snapshot) {
        const permanentElementMap = {};
        for (const currentPermanentElement of this.permanentElements){
            const { id: id } = currentPermanentElement;
            const newPermanentElement = snapshot.getPermanentElementById(id);
            if (newPermanentElement) permanentElementMap[id] = [
                currentPermanentElement,
                newPermanentElement
            ];
        }
        return permanentElementMap;
    }
}
function $fb0d47f64ee363ae$var$getPermanentElementById(node, id) {
    return node.querySelector(`#${id}[data-turbo-permanent]`);
}
function $fb0d47f64ee363ae$var$queryPermanentElementsAll(node) {
    return node.querySelectorAll("[id][data-turbo-permanent]");
}
class $fb0d47f64ee363ae$var$FormSubmitObserver {
    started = false;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("submit", this.submitCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("submit", this.submitCaptured, true);
            this.started = false;
        }
    }
    submitCaptured = ()=>{
        this.eventTarget.removeEventListener("submit", this.submitBubbled, false);
        this.eventTarget.addEventListener("submit", this.submitBubbled, false);
    };
    submitBubbled = (event)=>{
        if (!event.defaultPrevented) {
            const form = event.target instanceof HTMLFormElement ? event.target : undefined;
            const submitter = event.submitter || undefined;
            if (form && $fb0d47f64ee363ae$var$submissionDoesNotDismissDialog(form, submitter) && $fb0d47f64ee363ae$var$submissionDoesNotTargetIFrame(form, submitter) && this.delegate.willSubmitForm(form, submitter)) {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.delegate.formSubmitted(form, submitter);
            }
        }
    };
}
function $fb0d47f64ee363ae$var$submissionDoesNotDismissDialog(form, submitter) {
    const method = submitter?.getAttribute("formmethod") || form.getAttribute("method");
    return method != "dialog";
}
function $fb0d47f64ee363ae$var$submissionDoesNotTargetIFrame(form, submitter) {
    const target = submitter?.getAttribute("formtarget") || form.getAttribute("target");
    return $fb0d47f64ee363ae$var$doesNotTargetIFrame(target);
}
class $fb0d47f64ee363ae$var$View {
    #resolveRenderPromise = (_value)=>{};
    #resolveInterceptionPromise = (_value)=>{};
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
    }
    // Scrolling
    scrollToAnchor(anchor) {
        const element = this.snapshot.getElementForAnchor(anchor);
        if (element) {
            this.focusElement(element);
            this.scrollToElement(element);
        } else this.scrollToPosition({
            x: 0,
            y: 0
        });
    }
    scrollToAnchorFromLocation(location1) {
        this.scrollToAnchor($fb0d47f64ee363ae$var$getAnchor(location1));
    }
    scrollToElement(element) {
        element.scrollIntoView();
    }
    focusElement(element) {
        if (element instanceof HTMLElement) {
            if (element.hasAttribute("tabindex")) element.focus();
            else {
                element.setAttribute("tabindex", "-1");
                element.focus();
                element.removeAttribute("tabindex");
            }
        }
    }
    scrollToPosition({ x: x, y: y }) {
        this.scrollRoot.scrollTo(x, y);
    }
    scrollToTop() {
        this.scrollToPosition({
            x: 0,
            y: 0
        });
    }
    get scrollRoot() {
        return window;
    }
    // Rendering
    async render(renderer) {
        const { isPreview: isPreview, shouldRender: shouldRender, willRender: willRender, newSnapshot: snapshot } = renderer;
        // A workaround to ignore tracked element mismatch reloads when performing
        // a promoted Visit from a frame navigation
        const shouldInvalidate = willRender;
        if (shouldRender) try {
            this.renderPromise = new Promise((resolve)=>this.#resolveRenderPromise = resolve);
            this.renderer = renderer;
            await this.prepareToRenderSnapshot(renderer);
            const renderInterception = new Promise((resolve)=>this.#resolveInterceptionPromise = resolve);
            const options = {
                resume: this.#resolveInterceptionPromise,
                render: this.renderer.renderElement,
                renderMethod: this.renderer.renderMethod
            };
            const immediateRender = this.delegate.allowsImmediateRender(snapshot, options);
            if (!immediateRender) await renderInterception;
            await this.renderSnapshot(renderer);
            this.delegate.viewRenderedSnapshot(snapshot, isPreview, this.renderer.renderMethod);
            this.delegate.preloadOnLoadLinksForView(this.element);
            this.finishRenderingSnapshot(renderer);
        } finally{
            delete this.renderer;
            this.#resolveRenderPromise(undefined);
            delete this.renderPromise;
        }
        else if (shouldInvalidate) this.invalidate(renderer.reloadReason);
    }
    invalidate(reason) {
        this.delegate.viewInvalidated(reason);
    }
    async prepareToRenderSnapshot(renderer) {
        this.markAsPreview(renderer.isPreview);
        await renderer.prepareToRender();
    }
    markAsPreview(isPreview) {
        if (isPreview) this.element.setAttribute("data-turbo-preview", "");
        else this.element.removeAttribute("data-turbo-preview");
    }
    markVisitDirection(direction) {
        this.element.setAttribute("data-turbo-visit-direction", direction);
    }
    unmarkVisitDirection() {
        this.element.removeAttribute("data-turbo-visit-direction");
    }
    async renderSnapshot(renderer) {
        await renderer.render();
    }
    finishRenderingSnapshot(renderer) {
        renderer.finishRendering();
    }
}
class $fb0d47f64ee363ae$var$FrameView extends $fb0d47f64ee363ae$var$View {
    missing() {
        this.element.innerHTML = `<strong class="turbo-frame-error">Content missing</strong>`;
    }
    get snapshot() {
        return new $fb0d47f64ee363ae$var$Snapshot(this.element);
    }
}
class $fb0d47f64ee363ae$var$LinkInterceptor {
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
    }
    start() {
        this.element.addEventListener("click", this.clickBubbled);
        document.addEventListener("turbo:click", this.linkClicked);
        document.addEventListener("turbo:before-visit", this.willVisit);
    }
    stop() {
        this.element.removeEventListener("click", this.clickBubbled);
        document.removeEventListener("turbo:click", this.linkClicked);
        document.removeEventListener("turbo:before-visit", this.willVisit);
    }
    clickBubbled = (event)=>{
        if (this.clickEventIsSignificant(event)) this.clickEvent = event;
        else delete this.clickEvent;
    };
    linkClicked = (event)=>{
        if (this.clickEvent && this.clickEventIsSignificant(event)) {
            if (this.delegate.shouldInterceptLinkClick(event.target, event.detail.url, event.detail.originalEvent)) {
                this.clickEvent.preventDefault();
                event.preventDefault();
                this.delegate.linkClickIntercepted(event.target, event.detail.url, event.detail.originalEvent);
            }
        }
        delete this.clickEvent;
    };
    willVisit = (_event)=>{
        delete this.clickEvent;
    };
    clickEventIsSignificant(event) {
        const target = event.composed ? event.target?.parentElement : event.target;
        const element = $fb0d47f64ee363ae$var$findLinkFromClickTarget(target) || target;
        return element instanceof Element && element.closest("turbo-frame, html") == this.element;
    }
}
class $fb0d47f64ee363ae$var$LinkClickObserver {
    started = false;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("click", this.clickCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("click", this.clickCaptured, true);
            this.started = false;
        }
    }
    clickCaptured = ()=>{
        this.eventTarget.removeEventListener("click", this.clickBubbled, false);
        this.eventTarget.addEventListener("click", this.clickBubbled, false);
    };
    clickBubbled = (event)=>{
        if (event instanceof MouseEvent && this.clickEventIsSignificant(event)) {
            const target = event.composedPath && event.composedPath()[0] || event.target;
            const link = $fb0d47f64ee363ae$var$findLinkFromClickTarget(target);
            if (link && $fb0d47f64ee363ae$var$doesNotTargetIFrame(link.target)) {
                const location1 = $fb0d47f64ee363ae$var$getLocationForLink(link);
                if (this.delegate.willFollowLinkToLocation(link, location1, event)) {
                    event.preventDefault();
                    this.delegate.followedLinkToLocation(link, location1);
                }
            }
        }
    };
    clickEventIsSignificant(event) {
        return !(event.target && event.target.isContentEditable || event.defaultPrevented || event.which > 1 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
    }
}
class $fb0d47f64ee363ae$var$FormLinkClickObserver {
    constructor(delegate, element){
        this.delegate = delegate;
        this.linkInterceptor = new $fb0d47f64ee363ae$var$LinkClickObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
    }
    stop() {
        this.linkInterceptor.stop();
    }
    // Link hover observer delegate
    canPrefetchRequestToLocation(link, location1) {
        return false;
    }
    prefetchAndCacheRequestToLocation(link, location1) {
        return;
    }
    // Link click observer delegate
    willFollowLinkToLocation(link, location1, originalEvent) {
        return this.delegate.willSubmitFormLinkToLocation(link, location1, originalEvent) && (link.hasAttribute("data-turbo-method") || link.hasAttribute("data-turbo-stream"));
    }
    followedLinkToLocation(link, location1) {
        const form = document.createElement("form");
        const type = "hidden";
        for (const [name, value] of location1.searchParams)form.append(Object.assign(document.createElement("input"), {
            type: type,
            name: name,
            value: value
        }));
        const action = Object.assign(location1, {
            search: ""
        });
        form.setAttribute("data-turbo", "true");
        form.setAttribute("action", action.href);
        form.setAttribute("hidden", "");
        const method = link.getAttribute("data-turbo-method");
        if (method) form.setAttribute("method", method);
        const turboFrame = link.getAttribute("data-turbo-frame");
        if (turboFrame) form.setAttribute("data-turbo-frame", turboFrame);
        const turboAction = $fb0d47f64ee363ae$var$getVisitAction(link);
        if (turboAction) form.setAttribute("data-turbo-action", turboAction);
        const turboConfirm = link.getAttribute("data-turbo-confirm");
        if (turboConfirm) form.setAttribute("data-turbo-confirm", turboConfirm);
        const turboStream = link.hasAttribute("data-turbo-stream");
        if (turboStream) form.setAttribute("data-turbo-stream", "");
        this.delegate.submittedFormLinkToLocation(link, location1, form);
        document.body.appendChild(form);
        form.addEventListener("turbo:submit-end", ()=>form.remove(), {
            once: true
        });
        requestAnimationFrame(()=>form.requestSubmit());
    }
}
class $fb0d47f64ee363ae$var$Bardo {
    static async preservingPermanentElements(delegate, permanentElementMap, callback) {
        const bardo = new this(delegate, permanentElementMap);
        bardo.enter();
        await callback();
        bardo.leave();
    }
    constructor(delegate, permanentElementMap){
        this.delegate = delegate;
        this.permanentElementMap = permanentElementMap;
    }
    enter() {
        for(const id in this.permanentElementMap){
            const [currentPermanentElement, newPermanentElement] = this.permanentElementMap[id];
            this.delegate.enteringBardo(currentPermanentElement, newPermanentElement);
            this.replaceNewPermanentElementWithPlaceholder(newPermanentElement);
        }
    }
    leave() {
        for(const id in this.permanentElementMap){
            const [currentPermanentElement] = this.permanentElementMap[id];
            this.replaceCurrentPermanentElementWithClone(currentPermanentElement);
            this.replacePlaceholderWithPermanentElement(currentPermanentElement);
            this.delegate.leavingBardo(currentPermanentElement);
        }
    }
    replaceNewPermanentElementWithPlaceholder(permanentElement) {
        const placeholder = $fb0d47f64ee363ae$var$createPlaceholderForPermanentElement(permanentElement);
        permanentElement.replaceWith(placeholder);
    }
    replaceCurrentPermanentElementWithClone(permanentElement) {
        const clone = permanentElement.cloneNode(true);
        permanentElement.replaceWith(clone);
    }
    replacePlaceholderWithPermanentElement(permanentElement) {
        const placeholder = this.getPlaceholderById(permanentElement.id);
        placeholder?.replaceWith(permanentElement);
    }
    getPlaceholderById(id) {
        return this.placeholders.find((element)=>element.content == id);
    }
    get placeholders() {
        return [
            ...document.querySelectorAll("meta[name=turbo-permanent-placeholder][content]")
        ];
    }
}
function $fb0d47f64ee363ae$var$createPlaceholderForPermanentElement(permanentElement) {
    const element = document.createElement("meta");
    element.setAttribute("name", "turbo-permanent-placeholder");
    element.setAttribute("content", permanentElement.id);
    return element;
}
class $fb0d47f64ee363ae$var$Renderer {
    #activeElement = null;
    static renderElement(currentElement, newElement) {
    // Abstract method
    }
    constructor(currentSnapshot, newSnapshot, isPreview, willRender = true){
        this.currentSnapshot = currentSnapshot;
        this.newSnapshot = newSnapshot;
        this.isPreview = isPreview;
        this.willRender = willRender;
        this.renderElement = this.constructor.renderElement;
        this.promise = new Promise((resolve, reject)=>this.resolvingFunctions = {
                resolve: resolve,
                reject: reject
            });
    }
    get shouldRender() {
        return true;
    }
    get shouldAutofocus() {
        return true;
    }
    get reloadReason() {
        return;
    }
    prepareToRender() {
        return;
    }
    render() {
    // Abstract method
    }
    finishRendering() {
        if (this.resolvingFunctions) {
            this.resolvingFunctions.resolve();
            delete this.resolvingFunctions;
        }
    }
    async preservingPermanentElements(callback) {
        await $fb0d47f64ee363ae$var$Bardo.preservingPermanentElements(this, this.permanentElementMap, callback);
    }
    focusFirstAutofocusableElement() {
        if (this.shouldAutofocus) {
            const element = this.connectedSnapshot.firstAutofocusableElement;
            if (element) element.focus();
        }
    }
    // Bardo delegate
    enteringBardo(currentPermanentElement) {
        if (this.#activeElement) return;
        if (currentPermanentElement.contains(this.currentSnapshot.activeElement)) this.#activeElement = this.currentSnapshot.activeElement;
    }
    leavingBardo(currentPermanentElement) {
        if (currentPermanentElement.contains(this.#activeElement) && this.#activeElement instanceof HTMLElement) {
            this.#activeElement.focus();
            this.#activeElement = null;
        }
    }
    get connectedSnapshot() {
        return this.newSnapshot.isConnected ? this.newSnapshot : this.currentSnapshot;
    }
    get currentElement() {
        return this.currentSnapshot.element;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    get permanentElementMap() {
        return this.currentSnapshot.getPermanentElementMapForSnapshot(this.newSnapshot);
    }
    get renderMethod() {
        return "replace";
    }
}
class $fb0d47f64ee363ae$export$f09c4165d16bb2b7 extends $fb0d47f64ee363ae$var$Renderer {
    static renderElement(currentElement, newElement) {
        const destinationRange = document.createRange();
        destinationRange.selectNodeContents(currentElement);
        destinationRange.deleteContents();
        const frameElement = newElement;
        const sourceRange = frameElement.ownerDocument?.createRange();
        if (sourceRange) {
            sourceRange.selectNodeContents(frameElement);
            currentElement.appendChild(sourceRange.extractContents());
        }
    }
    constructor(delegate, currentSnapshot, newSnapshot, renderElement, isPreview, willRender = true){
        super(currentSnapshot, newSnapshot, renderElement, isPreview, willRender);
        this.delegate = delegate;
    }
    get shouldRender() {
        return true;
    }
    async render() {
        await $fb0d47f64ee363ae$var$nextRepaint();
        this.preservingPermanentElements(()=>{
            this.loadFrameElement();
        });
        this.scrollFrameIntoView();
        await $fb0d47f64ee363ae$var$nextRepaint();
        this.focusFirstAutofocusableElement();
        await $fb0d47f64ee363ae$var$nextRepaint();
        this.activateScriptElements();
    }
    loadFrameElement() {
        this.delegate.willRenderFrame(this.currentElement, this.newElement);
        this.renderElement(this.currentElement, this.newElement);
    }
    scrollFrameIntoView() {
        if (this.currentElement.autoscroll || this.newElement.autoscroll) {
            const element = this.currentElement.firstElementChild;
            const block = $fb0d47f64ee363ae$var$readScrollLogicalPosition(this.currentElement.getAttribute("data-autoscroll-block"), "end");
            const behavior = $fb0d47f64ee363ae$var$readScrollBehavior(this.currentElement.getAttribute("data-autoscroll-behavior"), "auto");
            if (element) {
                element.scrollIntoView({
                    block: block,
                    behavior: behavior
                });
                return true;
            }
        }
        return false;
    }
    activateScriptElements() {
        for (const inertScriptElement of this.newScriptElements){
            const activatedScriptElement = $fb0d47f64ee363ae$var$activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    get newScriptElements() {
        return this.currentElement.querySelectorAll("script");
    }
}
function $fb0d47f64ee363ae$var$readScrollLogicalPosition(value, defaultValue) {
    if (value == "end" || value == "start" || value == "center" || value == "nearest") return value;
    else return defaultValue;
}
function $fb0d47f64ee363ae$var$readScrollBehavior(value, defaultValue) {
    if (value == "auto" || value == "smooth") return value;
    else return defaultValue;
}
/**
 * @typedef {object} ConfigHead
 *
 * @property {'merge' | 'append' | 'morph' | 'none'} [style]
 * @property {boolean} [block]
 * @property {boolean} [ignore]
 * @property {function(Element): boolean} [shouldPreserve]
 * @property {function(Element): boolean} [shouldReAppend]
 * @property {function(Element): boolean} [shouldRemove]
 * @property {function(Element, {added: Node[], kept: Element[], removed: Element[]}): void} [afterHeadMorphed]
 */ /**
 * @typedef {object} ConfigCallbacks
 *
 * @property {function(Node): boolean} [beforeNodeAdded]
 * @property {function(Node): void} [afterNodeAdded]
 * @property {function(Element, Node): boolean} [beforeNodeMorphed]
 * @property {function(Element, Node): void} [afterNodeMorphed]
 * @property {function(Element): boolean} [beforeNodeRemoved]
 * @property {function(Element): void} [afterNodeRemoved]
 * @property {function(string, Element, "update" | "remove"): boolean} [beforeAttributeUpdated]
 */ /**
 * @typedef {object} Config
 *
 * @property {'outerHTML' | 'innerHTML'} [morphStyle]
 * @property {boolean} [ignoreActive]
 * @property {boolean} [ignoreActiveValue]
 * @property {boolean} [restoreFocus]
 * @property {ConfigCallbacks} [callbacks]
 * @property {ConfigHead} [head]
 */ /**
 * @typedef {function} NoOp
 *
 * @returns {void}
 */ /**
 * @typedef {object} ConfigHeadInternal
 *
 * @property {'merge' | 'append' | 'morph' | 'none'} style
 * @property {boolean} [block]
 * @property {boolean} [ignore]
 * @property {(function(Element): boolean) | NoOp} shouldPreserve
 * @property {(function(Element): boolean) | NoOp} shouldReAppend
 * @property {(function(Element): boolean) | NoOp} shouldRemove
 * @property {(function(Element, {added: Node[], kept: Element[], removed: Element[]}): void) | NoOp} afterHeadMorphed
 */ /**
 * @typedef {object} ConfigCallbacksInternal
 *
 * @property {(function(Node): boolean) | NoOp} beforeNodeAdded
 * @property {(function(Node): void) | NoOp} afterNodeAdded
 * @property {(function(Node, Node): boolean) | NoOp} beforeNodeMorphed
 * @property {(function(Node, Node): void) | NoOp} afterNodeMorphed
 * @property {(function(Node): boolean) | NoOp} beforeNodeRemoved
 * @property {(function(Node): void) | NoOp} afterNodeRemoved
 * @property {(function(string, Element, "update" | "remove"): boolean) | NoOp} beforeAttributeUpdated
 */ /**
 * @typedef {object} ConfigInternal
 *
 * @property {'outerHTML' | 'innerHTML'} morphStyle
 * @property {boolean} [ignoreActive]
 * @property {boolean} [ignoreActiveValue]
 * @property {boolean} [restoreFocus]
 * @property {ConfigCallbacksInternal} callbacks
 * @property {ConfigHeadInternal} head
 */ /**
 * @typedef {Object} IdSets
 * @property {Set<string>} persistentIds
 * @property {Map<Node, Set<string>>} idMap
 */ /**
 * @typedef {Function} Morph
 *
 * @param {Element | Document} oldNode
 * @param {Element | Node | HTMLCollection | Node[] | string | null} newContent
 * @param {Config} [config]
 * @returns {undefined | Node[]}
 */ // base IIFE to define idiomorph
/**
 *
 * @type {{defaults: ConfigInternal, morph: Morph}}
 */ var $fb0d47f64ee363ae$var$Idiomorph = function() {
    /**
   * @typedef {object} MorphContext
   *
   * @property {Element} target
   * @property {Element} newContent
   * @property {ConfigInternal} config
   * @property {ConfigInternal['morphStyle']} morphStyle
   * @property {ConfigInternal['ignoreActive']} ignoreActive
   * @property {ConfigInternal['ignoreActiveValue']} ignoreActiveValue
   * @property {ConfigInternal['restoreFocus']} restoreFocus
   * @property {Map<Node, Set<string>>} idMap
   * @property {Set<string>} persistentIds
   * @property {ConfigInternal['callbacks']} callbacks
   * @property {ConfigInternal['head']} head
   * @property {HTMLDivElement} pantry
   * @property {Element[]} activeElementAndParents
   */ //=============================================================================
    // AND NOW IT BEGINS...
    //=============================================================================
    const noOp = ()=>{};
    /**
   * Default configuration values, updatable by users now
   * @type {ConfigInternal}
   */ const defaults = {
        morphStyle: "outerHTML",
        callbacks: {
            beforeNodeAdded: noOp,
            afterNodeAdded: noOp,
            beforeNodeMorphed: noOp,
            afterNodeMorphed: noOp,
            beforeNodeRemoved: noOp,
            afterNodeRemoved: noOp,
            beforeAttributeUpdated: noOp
        },
        head: {
            style: "merge",
            shouldPreserve: (elt)=>elt.getAttribute("im-preserve") === "true",
            shouldReAppend: (elt)=>elt.getAttribute("im-re-append") === "true",
            shouldRemove: noOp,
            afterHeadMorphed: noOp
        },
        restoreFocus: true
    };
    /**
   * Core idiomorph function for morphing one DOM tree to another
   *
   * @param {Element | Document} oldNode
   * @param {Element | Node | HTMLCollection | Node[] | string | null} newContent
   * @param {Config} [config]
   * @returns {Promise<Node[]> | Node[]}
   */ function morph(oldNode, newContent, config = {}) {
        oldNode = normalizeElement(oldNode);
        const newNode = normalizeParent(newContent);
        const ctx = createMorphContext(oldNode, newNode, config);
        const morphedNodes = saveAndRestoreFocus(ctx, ()=>{
            return withHeadBlocking(ctx, oldNode, newNode, /** @param {MorphContext} ctx */ (ctx)=>{
                if (ctx.morphStyle === "innerHTML") {
                    morphChildren(ctx, oldNode, newNode);
                    return Array.from(oldNode.childNodes);
                } else return morphOuterHTML(ctx, oldNode, newNode);
            });
        });
        ctx.pantry.remove();
        return morphedNodes;
    }
    /**
   * Morph just the outerHTML of the oldNode to the newContent
   * We have to be careful because the oldNode could have siblings which need to be untouched
   * @param {MorphContext} ctx
   * @param {Element} oldNode
   * @param {Element} newNode
   * @returns {Node[]}
   */ function morphOuterHTML(ctx, oldNode, newNode) {
        const oldParent = normalizeParent(oldNode);
        morphChildren(ctx, oldParent, newNode, // these two optional params are the secret sauce
        oldNode, oldNode.nextSibling);
        // this is safe even with siblings, because normalizeParent returns a SlicedParentNode if needed.
        return Array.from(oldParent.childNodes);
    }
    /**
   * @param {MorphContext} ctx
   * @param {Function} fn
   * @returns {Promise<Node[]> | Node[]}
   */ function saveAndRestoreFocus(ctx, fn) {
        if (!ctx.config.restoreFocus) return fn();
        let activeElement = /** @type {HTMLInputElement|HTMLTextAreaElement|null} */ document.activeElement;
        // don't bother if the active element is not an input or textarea
        if (!(activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement)) return fn();
        const { id: activeElementId, selectionStart: selectionStart, selectionEnd: selectionEnd } = activeElement;
        const results = fn();
        if (activeElementId && activeElementId !== document.activeElement?.getAttribute("id")) {
            activeElement = ctx.target.querySelector(`[id="${activeElementId}"]`);
            activeElement?.focus();
        }
        if (activeElement && !activeElement.selectionEnd && selectionEnd) activeElement.setSelectionRange(selectionStart, selectionEnd);
        return results;
    }
    const morphChildren = function() {
        /**
     * This is the core algorithm for matching up children.  The idea is to use id sets to try to match up
     * nodes as faithfully as possible.  We greedily match, which allows us to keep the algorithm fast, but
     * by using id sets, we are able to better match up with content deeper in the DOM.
     *
     * Basic algorithm:
     * - for each node in the new content:
     *   - search self and siblings for an id set match, falling back to a soft match
     *   - if match found
     *     - remove any nodes up to the match:
     *       - pantry persistent nodes
     *       - delete the rest
     *     - morph the match
     *   - elsif no match found, and node is persistent
     *     - find its match by querying the old root (future) and pantry (past)
     *     - move it and its children here
     *     - morph it
     *   - else
     *     - create a new node from scratch as a last result
     *
     * @param {MorphContext} ctx the merge context
     * @param {Element} oldParent the old content that we are merging the new content into
     * @param {Element} newParent the parent element of the new content
     * @param {Node|null} [insertionPoint] the point in the DOM we start morphing at (defaults to first child)
     * @param {Node|null} [endPoint] the point in the DOM we stop morphing at (defaults to after last child)
     */ function morphChildren(ctx, oldParent, newParent, insertionPoint = null, endPoint = null) {
            // normalize
            if (oldParent instanceof HTMLTemplateElement && newParent instanceof HTMLTemplateElement) {
                // @ts-ignore we can pretend the DocumentFragment is an Element
                oldParent = oldParent.content;
                // @ts-ignore ditto
                newParent = newParent.content;
            }
            insertionPoint ||= oldParent.firstChild;
            // run through all the new content
            for (const newChild of newParent.childNodes){
                // once we reach the end of the old parent content skip to the end and insert the rest
                if (insertionPoint && insertionPoint != endPoint) {
                    const bestMatch = findBestMatch(ctx, newChild, insertionPoint, endPoint);
                    if (bestMatch) {
                        // if the node to morph is not at the insertion point then remove/move up to it
                        if (bestMatch !== insertionPoint) removeNodesBetween(ctx, insertionPoint, bestMatch);
                        morphNode(bestMatch, newChild, ctx);
                        insertionPoint = bestMatch.nextSibling;
                        continue;
                    }
                }
                // if the matching node is elsewhere in the original content
                if (newChild instanceof Element) {
                    // we can pretend the id is non-null because the next `.has` line will reject it if not
                    const newChildId = /** @type {String} */ newChild.getAttribute("id");
                    if (ctx.persistentIds.has(newChildId)) {
                        // move it and all its children here and morph
                        const movedChild = moveBeforeById(oldParent, newChildId, insertionPoint, ctx);
                        morphNode(movedChild, newChild, ctx);
                        insertionPoint = movedChild.nextSibling;
                        continue;
                    }
                }
                // last resort: insert the new node from scratch
                const insertedNode = createNode(oldParent, newChild, insertionPoint, ctx);
                // could be null if beforeNodeAdded prevented insertion
                if (insertedNode) insertionPoint = insertedNode.nextSibling;
            }
            // remove any remaining old nodes that didn't match up with new content
            while(insertionPoint && insertionPoint != endPoint){
                const tempNode = insertionPoint;
                insertionPoint = insertionPoint.nextSibling;
                removeNode(ctx, tempNode);
            }
        }
        /**
     * This performs the action of inserting a new node while handling situations where the node contains
     * elements with persistent ids and possible state info we can still preserve by moving in and then morphing
     *
     * @param {Element} oldParent
     * @param {Node} newChild
     * @param {Node|null} insertionPoint
     * @param {MorphContext} ctx
     * @returns {Node|null}
     */ function createNode(oldParent, newChild, insertionPoint, ctx) {
            if (ctx.callbacks.beforeNodeAdded(newChild) === false) return null;
            if (ctx.idMap.has(newChild)) {
                // node has children with ids with possible state so create a dummy elt of same type and apply full morph algorithm
                const newEmptyChild = document.createElement(/** @type {Element} */ newChild.tagName);
                oldParent.insertBefore(newEmptyChild, insertionPoint);
                morphNode(newEmptyChild, newChild, ctx);
                ctx.callbacks.afterNodeAdded(newEmptyChild);
                return newEmptyChild;
            } else {
                // optimisation: no id state to preserve so we can just insert a clone of the newChild and its descendants
                const newClonedChild = document.importNode(newChild, true); // importNode to not mutate newParent
                oldParent.insertBefore(newClonedChild, insertionPoint);
                ctx.callbacks.afterNodeAdded(newClonedChild);
                return newClonedChild;
            }
        }
        //=============================================================================
        // Matching Functions
        //=============================================================================
        const findBestMatch = function() {
            /**
       * Scans forward from the startPoint to the endPoint looking for a match
       * for the node. It looks for an id set match first, then a soft match.
       * We abort softmatching if we find two future soft matches, to reduce churn.
       * @param {Node} node
       * @param {MorphContext} ctx
       * @param {Node | null} startPoint
       * @param {Node | null} endPoint
       * @returns {Node | null}
       */ function findBestMatch(ctx, node, startPoint, endPoint) {
                let softMatch = null;
                let nextSibling = node.nextSibling;
                let siblingSoftMatchCount = 0;
                let cursor = startPoint;
                while(cursor && cursor != endPoint){
                    // soft matching is a prerequisite for id set matching
                    if (isSoftMatch(cursor, node)) {
                        if (isIdSetMatch(ctx, cursor, node)) return cursor; // found an id set match, we're done!
                        // we haven't yet saved a soft match fallback
                        if (softMatch === null) // the current soft match will hard match something else in the future, leave it
                        {
                            if (!ctx.idMap.has(cursor)) // save this as the fallback if we get through the loop without finding a hard match
                            softMatch = cursor;
                        }
                    }
                    if (softMatch === null && nextSibling && isSoftMatch(cursor, nextSibling)) {
                        // The next new node has a soft match with this node, so
                        // increment the count of future soft matches
                        siblingSoftMatchCount++;
                        nextSibling = nextSibling.nextSibling;
                        // If there are two future soft matches, block soft matching for this node to allow
                        // future siblings to soft match. This is to reduce churn in the DOM when an element
                        // is prepended.
                        if (siblingSoftMatchCount >= 2) softMatch = undefined;
                    }
                    // if the current node contains active element, stop looking for better future matches,
                    // because if one is found, this node will be moved to the pantry, reparenting it and thus losing focus
                    // @ts-ignore pretend cursor is Element rather than Node, we're just testing for array inclusion
                    if (ctx.activeElementAndParents.includes(cursor)) break;
                    cursor = cursor.nextSibling;
                }
                return softMatch || null;
            }
            /**
       *
       * @param {MorphContext} ctx
       * @param {Node} oldNode
       * @param {Node} newNode
       * @returns {boolean}
       */ function isIdSetMatch(ctx, oldNode, newNode) {
                let oldSet = ctx.idMap.get(oldNode);
                let newSet = ctx.idMap.get(newNode);
                if (!newSet || !oldSet) return false;
                for (const id of oldSet){
                    // a potential match is an id in the new and old nodes that
                    // has not already been merged into the DOM
                    // But the newNode content we call this on has not been
                    // merged yet and we don't allow duplicate IDs so it is simple
                    if (newSet.has(id)) return true;
                }
                return false;
            }
            /**
       *
       * @param {Node} oldNode
       * @param {Node} newNode
       * @returns {boolean}
       */ function isSoftMatch(oldNode, newNode) {
                // ok to cast: if one is not element, `id` and `tagName` will be undefined and we'll just compare that.
                const oldElt = /** @type {Element} */ oldNode;
                const newElt = /** @type {Element} */ newNode;
                return oldElt.nodeType === newElt.nodeType && oldElt.tagName === newElt.tagName && // If oldElt has an `id` with possible state and it doesn't match newElt.id then avoid morphing.
                // We'll still match an anonymous node with an IDed newElt, though, because if it got this far,
                // its not persistent, and new nodes can't have any hidden state.
                // We can't use .id because of form input shadowing, and we can't count on .getAttribute's presence because it could be a document-fragment
                (!oldElt.getAttribute?.("id") || oldElt.getAttribute?.("id") === newElt.getAttribute?.("id"));
            }
            return findBestMatch;
        }();
        //=============================================================================
        // DOM Manipulation Functions
        //=============================================================================
        /**
     * Gets rid of an unwanted DOM node; strategy depends on nature of its reuse:
     * - Persistent nodes will be moved to the pantry for later reuse
     * - Other nodes will have their hooks called, and then are removed
     * @param {MorphContext} ctx
     * @param {Node} node
     */ function removeNode(ctx, node) {
            // are we going to id set match this later?
            if (ctx.idMap.has(node)) // skip callbacks and move to pantry
            moveBefore(ctx.pantry, node, null);
            else {
                // remove for realsies
                if (ctx.callbacks.beforeNodeRemoved(node) === false) return;
                node.parentNode?.removeChild(node);
                ctx.callbacks.afterNodeRemoved(node);
            }
        }
        /**
     * Remove nodes between the start and end nodes
     * @param {MorphContext} ctx
     * @param {Node} startInclusive
     * @param {Node} endExclusive
     * @returns {Node|null}
     */ function removeNodesBetween(ctx, startInclusive, endExclusive) {
            /** @type {Node | null} */ let cursor = startInclusive;
            // remove nodes until the endExclusive node
            while(cursor && cursor !== endExclusive){
                let tempNode = /** @type {Node} */ cursor;
                cursor = cursor.nextSibling;
                removeNode(ctx, tempNode);
            }
            return cursor;
        }
        /**
     * Search for an element by id within the document and pantry, and move it using moveBefore.
     *
     * @param {Element} parentNode - The parent node to which the element will be moved.
     * @param {string} id - The ID of the element to be moved.
     * @param {Node | null} after - The reference node to insert the element before.
     *                              If `null`, the element is appended as the last child.
     * @param {MorphContext} ctx
     * @returns {Element} The found element
     */ function moveBeforeById(parentNode, id, after, ctx) {
            const target = /** @type {Element} - will always be found */ // ctx.target.id unsafe because of form input shadowing
            // ctx.target could be a document fragment which doesn't have `getAttribute`
            ctx.target.getAttribute?.("id") === id && ctx.target || ctx.target.querySelector(`[id="${id}"]`) || ctx.pantry.querySelector(`[id="${id}"]`);
            removeElementFromAncestorsIdMaps(target, ctx);
            moveBefore(parentNode, target, after);
            return target;
        }
        /**
     * Removes an element from its ancestors' id maps. This is needed when an element is moved from the
     * "future" via `moveBeforeId`. Otherwise, its erstwhile ancestors could be mistakenly moved to the
     * pantry rather than being deleted, preventing their removal hooks from being called.
     *
     * @param {Element} element - element to remove from its ancestors' id maps
     * @param {MorphContext} ctx
     */ function removeElementFromAncestorsIdMaps(element, ctx) {
            // we know id is non-null String, because this function is only called on elements with ids
            const id = /** @type {String} */ element.getAttribute("id");
            /** @ts-ignore - safe to loop in this way **/ while(element = element.parentNode){
                let idSet = ctx.idMap.get(element);
                if (idSet) {
                    idSet.delete(id);
                    if (!idSet.size) ctx.idMap.delete(element);
                }
            }
        }
        /**
     * Moves an element before another element within the same parent.
     * Uses the proposed `moveBefore` API if available (and working), otherwise falls back to `insertBefore`.
     * This is essentialy a forward-compat wrapper.
     *
     * @param {Element} parentNode - The parent node containing the after element.
     * @param {Node} element - The element to be moved.
     * @param {Node | null} after - The reference node to insert `element` before.
     *                              If `null`, `element` is appended as the last child.
     */ function moveBefore(parentNode, element, after) {
            // @ts-ignore - use proposed moveBefore feature
            if (parentNode.moveBefore) try {
                // @ts-ignore - use proposed moveBefore feature
                parentNode.moveBefore(element, after);
            } catch (e) {
                // fall back to insertBefore as some browsers may fail on moveBefore when trying to move Dom disconnected nodes to pantry
                parentNode.insertBefore(element, after);
            }
            else parentNode.insertBefore(element, after);
        }
        return morphChildren;
    }();
    //=============================================================================
    // Single Node Morphing Code
    //=============================================================================
    const morphNode = function() {
        /**
     * @param {Node} oldNode root node to merge content into
     * @param {Node} newContent new content to merge
     * @param {MorphContext} ctx the merge context
     * @returns {Node | null} the element that ended up in the DOM
     */ function morphNode(oldNode, newContent, ctx) {
            if (ctx.ignoreActive && oldNode === document.activeElement) // don't morph focused element
            return null;
            if (ctx.callbacks.beforeNodeMorphed(oldNode, newContent) === false) return oldNode;
            if (oldNode instanceof HTMLHeadElement && ctx.head.ignore) ;
            else if (oldNode instanceof HTMLHeadElement && ctx.head.style !== "morph") // ok to cast: if newContent wasn't also a <head>, it would've got caught in the `!isSoftMatch` branch above
            handleHeadElement(oldNode, /** @type {HTMLHeadElement} */ newContent, ctx);
            else {
                morphAttributes(oldNode, newContent, ctx);
                if (!ignoreValueOfActiveElement(oldNode, ctx)) // @ts-ignore newContent can be a node here because .firstChild will be null
                morphChildren(ctx, oldNode, newContent);
            }
            ctx.callbacks.afterNodeMorphed(oldNode, newContent);
            return oldNode;
        }
        /**
     * syncs the oldNode to the newNode, copying over all attributes and
     * inner element state from the newNode to the oldNode
     *
     * @param {Node} oldNode the node to copy attributes & state to
     * @param {Node} newNode the node to copy attributes & state from
     * @param {MorphContext} ctx the merge context
     */ function morphAttributes(oldNode, newNode, ctx) {
            let type = newNode.nodeType;
            // if is an element type, sync the attributes from the
            // new node into the new node
            if (type === 1 /* element type */ ) {
                const oldElt = /** @type {Element} */ oldNode;
                const newElt = /** @type {Element} */ newNode;
                const oldAttributes = oldElt.attributes;
                const newAttributes = newElt.attributes;
                for (const newAttribute of newAttributes){
                    if (ignoreAttribute(newAttribute.name, oldElt, "update", ctx)) continue;
                    if (oldElt.getAttribute(newAttribute.name) !== newAttribute.value) oldElt.setAttribute(newAttribute.name, newAttribute.value);
                }
                // iterate backwards to avoid skipping over items when a delete occurs
                for(let i = oldAttributes.length - 1; 0 <= i; i--){
                    const oldAttribute = oldAttributes[i];
                    // toAttributes is a live NamedNodeMap, so iteration+mutation is unsafe
                    // e.g. custom element attribute callbacks can remove other attributes
                    if (!oldAttribute) continue;
                    if (!newElt.hasAttribute(oldAttribute.name)) {
                        if (ignoreAttribute(oldAttribute.name, oldElt, "remove", ctx)) continue;
                        oldElt.removeAttribute(oldAttribute.name);
                    }
                }
                if (!ignoreValueOfActiveElement(oldElt, ctx)) syncInputValue(oldElt, newElt, ctx);
            }
            // sync text nodes
            if (type === 8 /* comment */  || type === 3 /* text */ ) {
                if (oldNode.nodeValue !== newNode.nodeValue) oldNode.nodeValue = newNode.nodeValue;
            }
        }
        /**
     * NB: many bothans died to bring us information:
     *
     *  https://github.com/patrick-steele-idem/morphdom/blob/master/src/specialElHandlers.js
     *  https://github.com/choojs/nanomorph/blob/master/lib/morph.jsL113
     *
     * @param {Element} oldElement the element to sync the input value to
     * @param {Element} newElement the element to sync the input value from
     * @param {MorphContext} ctx the merge context
     */ function syncInputValue(oldElement, newElement, ctx) {
            if (oldElement instanceof HTMLInputElement && newElement instanceof HTMLInputElement && newElement.type !== "file") {
                let newValue = newElement.value;
                let oldValue = oldElement.value;
                // sync boolean attributes
                syncBooleanAttribute(oldElement, newElement, "checked", ctx);
                syncBooleanAttribute(oldElement, newElement, "disabled", ctx);
                if (!newElement.hasAttribute("value")) {
                    if (!ignoreAttribute("value", oldElement, "remove", ctx)) {
                        oldElement.value = "";
                        oldElement.removeAttribute("value");
                    }
                } else if (oldValue !== newValue) {
                    if (!ignoreAttribute("value", oldElement, "update", ctx)) {
                        oldElement.setAttribute("value", newValue);
                        oldElement.value = newValue;
                    }
                }
            // TODO: QUESTION(1cg): this used to only check `newElement` unlike the other branches -- why?
            // did I break something?
            } else if (oldElement instanceof HTMLOptionElement && newElement instanceof HTMLOptionElement) syncBooleanAttribute(oldElement, newElement, "selected", ctx);
            else if (oldElement instanceof HTMLTextAreaElement && newElement instanceof HTMLTextAreaElement) {
                let newValue = newElement.value;
                let oldValue = oldElement.value;
                if (ignoreAttribute("value", oldElement, "update", ctx)) return;
                if (newValue !== oldValue) oldElement.value = newValue;
                if (oldElement.firstChild && oldElement.firstChild.nodeValue !== newValue) oldElement.firstChild.nodeValue = newValue;
            }
        }
        /**
     * @param {Element} oldElement element to write the value to
     * @param {Element} newElement element to read the value from
     * @param {string} attributeName the attribute name
     * @param {MorphContext} ctx the merge context
     */ function syncBooleanAttribute(oldElement, newElement, attributeName, ctx) {
            // @ts-ignore this function is only used on boolean attrs that are reflected as dom properties
            const newLiveValue = newElement[attributeName], // @ts-ignore ditto
            oldLiveValue = oldElement[attributeName];
            if (newLiveValue !== oldLiveValue) {
                const ignoreUpdate = ignoreAttribute(attributeName, oldElement, "update", ctx);
                if (!ignoreUpdate) // update attribute's associated DOM property
                // @ts-ignore this function is only used on boolean attrs that are reflected as dom properties
                oldElement[attributeName] = newElement[attributeName];
                if (newLiveValue) {
                    if (!ignoreUpdate) // https://developer.mozilla.org/en-US/docs/Glossary/Boolean/HTML
                    // this is the correct way to set a boolean attribute to "true"
                    oldElement.setAttribute(attributeName, "");
                } else if (!ignoreAttribute(attributeName, oldElement, "remove", ctx)) oldElement.removeAttribute(attributeName);
            }
        }
        /**
     * @param {string} attr the attribute to be mutated
     * @param {Element} element the element that is going to be updated
     * @param {"update" | "remove"} updateType
     * @param {MorphContext} ctx the merge context
     * @returns {boolean} true if the attribute should be ignored, false otherwise
     */ function ignoreAttribute(attr, element, updateType, ctx) {
            if (attr === "value" && ctx.ignoreActiveValue && element === document.activeElement) return true;
            return ctx.callbacks.beforeAttributeUpdated(attr, element, updateType) === false;
        }
        /**
     * @param {Node} possibleActiveElement
     * @param {MorphContext} ctx
     * @returns {boolean}
     */ function ignoreValueOfActiveElement(possibleActiveElement, ctx) {
            return !!ctx.ignoreActiveValue && possibleActiveElement === document.activeElement && possibleActiveElement !== document.body;
        }
        return morphNode;
    }();
    //=============================================================================
    // Head Management Functions
    //=============================================================================
    /**
   * @param {MorphContext} ctx
   * @param {Element} oldNode
   * @param {Element} newNode
   * @param {function} callback
   * @returns {Node[] | Promise<Node[]>}
   */ function withHeadBlocking(ctx, oldNode, newNode, callback) {
        if (ctx.head.block) {
            const oldHead = oldNode.querySelector("head");
            const newHead = newNode.querySelector("head");
            if (oldHead && newHead) {
                const promises = handleHeadElement(oldHead, newHead, ctx);
                // when head promises resolve, proceed ignoring the head tag
                return Promise.all(promises).then(()=>{
                    const newCtx = Object.assign(ctx, {
                        head: {
                            block: false,
                            ignore: true
                        }
                    });
                    return callback(newCtx);
                });
            }
        }
        // just proceed if we not head blocking
        return callback(ctx);
    }
    /**
   *  The HEAD tag can be handled specially, either w/ a 'merge' or 'append' style
   *
   * @param {Element} oldHead
   * @param {Element} newHead
   * @param {MorphContext} ctx
   * @returns {Promise<void>[]}
   */ function handleHeadElement(oldHead, newHead, ctx) {
        let added = [];
        let removed = [];
        let preserved = [];
        let nodesToAppend = [];
        // put all new head elements into a Map, by their outerHTML
        let srcToNewHeadNodes = new Map();
        for (const newHeadChild of newHead.children)srcToNewHeadNodes.set(newHeadChild.outerHTML, newHeadChild);
        // for each elt in the current head
        for (const currentHeadElt of oldHead.children){
            // If the current head element is in the map
            let inNewContent = srcToNewHeadNodes.has(currentHeadElt.outerHTML);
            let isReAppended = ctx.head.shouldReAppend(currentHeadElt);
            let isPreserved = ctx.head.shouldPreserve(currentHeadElt);
            if (inNewContent || isPreserved) {
                if (isReAppended) // remove the current version and let the new version replace it and re-execute
                removed.push(currentHeadElt);
                else {
                    // this element already exists and should not be re-appended, so remove it from
                    // the new content map, preserving it in the DOM
                    srcToNewHeadNodes.delete(currentHeadElt.outerHTML);
                    preserved.push(currentHeadElt);
                }
            } else {
                if (ctx.head.style === "append") // we are appending and this existing element is not new content
                // so if and only if it is marked for re-append do we do anything
                {
                    if (isReAppended) {
                        removed.push(currentHeadElt);
                        nodesToAppend.push(currentHeadElt);
                    }
                } else // if this is a merge, we remove this content since it is not in the new head
                if (ctx.head.shouldRemove(currentHeadElt) !== false) removed.push(currentHeadElt);
            }
        }
        // Push the remaining new head elements in the Map into the
        // nodes to append to the head tag
        nodesToAppend.push(...srcToNewHeadNodes.values());
        let promises = [];
        for (const newNode of nodesToAppend){
            // TODO: This could theoretically be null, based on type
            let newElt = /** @type {ChildNode} */ document.createRange().createContextualFragment(newNode.outerHTML).firstChild;
            if (ctx.callbacks.beforeNodeAdded(newElt) !== false) {
                if ("href" in newElt && newElt.href || "src" in newElt && newElt.src) {
                    /** @type {(result?: any) => void} */ let resolve;
                    let promise = new Promise(function(_resolve) {
                        resolve = _resolve;
                    });
                    newElt.addEventListener("load", function() {
                        resolve();
                    });
                    promises.push(promise);
                }
                oldHead.appendChild(newElt);
                ctx.callbacks.afterNodeAdded(newElt);
                added.push(newElt);
            }
        }
        // remove all removed elements, after we have appended the new elements to avoid
        // additional network requests for things like style sheets
        for (const removedElement of removed)if (ctx.callbacks.beforeNodeRemoved(removedElement) !== false) {
            oldHead.removeChild(removedElement);
            ctx.callbacks.afterNodeRemoved(removedElement);
        }
        ctx.head.afterHeadMorphed(oldHead, {
            added: added,
            kept: preserved,
            removed: removed
        });
        return promises;
    }
    //=============================================================================
    // Create Morph Context Functions
    //=============================================================================
    const createMorphContext = function() {
        /**
     *
     * @param {Element} oldNode
     * @param {Element} newContent
     * @param {Config} config
     * @returns {MorphContext}
     */ function createMorphContext(oldNode, newContent, config) {
            const { persistentIds: persistentIds, idMap: idMap } = createIdMaps(oldNode, newContent);
            const mergedConfig = mergeDefaults(config);
            const morphStyle = mergedConfig.morphStyle || "outerHTML";
            if (![
                "innerHTML",
                "outerHTML"
            ].includes(morphStyle)) throw `Do not understand how to morph style ${morphStyle}`;
            return {
                target: oldNode,
                newContent: newContent,
                config: mergedConfig,
                morphStyle: morphStyle,
                ignoreActive: mergedConfig.ignoreActive,
                ignoreActiveValue: mergedConfig.ignoreActiveValue,
                restoreFocus: mergedConfig.restoreFocus,
                idMap: idMap,
                persistentIds: persistentIds,
                pantry: createPantry(),
                activeElementAndParents: createActiveElementAndParents(oldNode),
                callbacks: mergedConfig.callbacks,
                head: mergedConfig.head
            };
        }
        /**
     * Deep merges the config object and the Idiomorph.defaults object to
     * produce a final configuration object
     * @param {Config} config
     * @returns {ConfigInternal}
     */ function mergeDefaults(config) {
            let finalConfig = Object.assign({}, defaults);
            // copy top level stuff into final config
            Object.assign(finalConfig, config);
            // copy callbacks into final config (do this to deep merge the callbacks)
            finalConfig.callbacks = Object.assign({}, defaults.callbacks, config.callbacks);
            // copy head config into final config  (do this to deep merge the head)
            finalConfig.head = Object.assign({}, defaults.head, config.head);
            return finalConfig;
        }
        /**
     * @returns {HTMLDivElement}
     */ function createPantry() {
            const pantry = document.createElement("div");
            pantry.hidden = true;
            document.body.insertAdjacentElement("afterend", pantry);
            return pantry;
        }
        /**
     * @param {Element} oldNode
     * @returns {Element[]}
     */ function createActiveElementAndParents(oldNode) {
            /** @type {Element[]} */ let activeElementAndParents = [];
            let elt = document.activeElement;
            if (elt?.tagName !== "BODY" && oldNode.contains(elt)) while(elt){
                activeElementAndParents.push(elt);
                if (elt === oldNode) break;
                elt = elt.parentElement;
            }
            return activeElementAndParents;
        }
        /**
     * Returns all elements with an ID contained within the root element and its descendants
     *
     * @param {Element} root
     * @returns {Element[]}
     */ function findIdElements(root) {
            let elements = Array.from(root.querySelectorAll("[id]"));
            // root could be a document fragment which doesn't have `getAttribute`
            if (root.getAttribute?.("id")) elements.push(root);
            return elements;
        }
        /**
     * A bottom-up algorithm that populates a map of Element -> IdSet.
     * The idSet for a given element is the set of all IDs contained within its subtree.
     * As an optimzation, we filter these IDs through the given list of persistent IDs,
     * because we don't need to bother considering IDed elements that won't be in the new content.
     *
     * @param {Map<Node, Set<string>>} idMap
     * @param {Set<string>} persistentIds
     * @param {Element} root
     * @param {Element[]} elements
     */ function populateIdMapWithTree(idMap, persistentIds, root, elements) {
            for (const elt of elements){
                // we can pretend id is non-null String, because the .has line will reject it immediately if not
                const id = /** @type {String} */ elt.getAttribute("id");
                if (persistentIds.has(id)) {
                    /** @type {Element|null} */ let current = elt;
                    // walk up the parent hierarchy of that element, adding the id
                    // of element to the parent's id set
                    while(current){
                        let idSet = idMap.get(current);
                        // if the id set doesn't exist, create it and insert it in the map
                        if (idSet == null) {
                            idSet = new Set();
                            idMap.set(current, idSet);
                        }
                        idSet.add(id);
                        if (current === root) break;
                        current = current.parentElement;
                    }
                }
            }
        }
        /**
     * This function computes a map of nodes to all ids contained within that node (inclusive of the
     * node).  This map can be used to ask if two nodes have intersecting sets of ids, which allows
     * for a looser definition of "matching" than tradition id matching, and allows child nodes
     * to contribute to a parent nodes matching.
     *
     * @param {Element} oldContent  the old content that will be morphed
     * @param {Element} newContent  the new content to morph to
     * @returns {IdSets}
     */ function createIdMaps(oldContent, newContent) {
            const oldIdElements = findIdElements(oldContent);
            const newIdElements = findIdElements(newContent);
            const persistentIds = createPersistentIds(oldIdElements, newIdElements);
            /** @type {Map<Node, Set<string>>} */ let idMap = new Map();
            populateIdMapWithTree(idMap, persistentIds, oldContent, oldIdElements);
            /** @ts-ignore - if newContent is a duck-typed parent, pass its single child node as the root to halt upwards iteration */ const newRoot = newContent.__idiomorphRoot || newContent;
            populateIdMapWithTree(idMap, persistentIds, newRoot, newIdElements);
            return {
                persistentIds: persistentIds,
                idMap: idMap
            };
        }
        /**
     * This function computes the set of ids that persist between the two contents excluding duplicates
     *
     * @param {Element[]} oldIdElements
     * @param {Element[]} newIdElements
     * @returns {Set<string>}
     */ function createPersistentIds(oldIdElements, newIdElements) {
            let duplicateIds = new Set();
            /** @type {Map<string, string>} */ let oldIdTagNameMap = new Map();
            for (const { id: id, tagName: tagName } of oldIdElements)if (oldIdTagNameMap.has(id)) duplicateIds.add(id);
            else oldIdTagNameMap.set(id, tagName);
            let persistentIds = new Set();
            for (const { id: id, tagName: tagName } of newIdElements){
                if (persistentIds.has(id)) duplicateIds.add(id);
                else if (oldIdTagNameMap.get(id) === tagName) persistentIds.add(id);
            // skip if tag types mismatch because its not possible to morph one tag into another
            }
            for (const id of duplicateIds)persistentIds.delete(id);
            return persistentIds;
        }
        return createMorphContext;
    }();
    //=============================================================================
    // HTML Normalization Functions
    //=============================================================================
    const { normalizeElement: normalizeElement, normalizeParent: normalizeParent } = function() {
        /** @type {WeakSet<Node>} */ const generatedByIdiomorph = new WeakSet();
        /**
     *
     * @param {Element | Document} content
     * @returns {Element}
     */ function normalizeElement(content) {
            if (content instanceof Document) return content.documentElement;
            else return content;
        }
        /**
     *
     * @param {null | string | Node | HTMLCollection | Node[] | Document & {generatedByIdiomorph:boolean}} newContent
     * @returns {Element}
     */ function normalizeParent(newContent) {
            if (newContent == null) return document.createElement("div"); // dummy parent element
            else if (typeof newContent === "string") return normalizeParent(parseContent(newContent));
            else if (generatedByIdiomorph.has(/** @type {Element} */ newContent)) // the template tag created by idiomorph parsing can serve as a dummy parent
            return /** @type {Element} */ newContent;
            else if (newContent instanceof Node) {
                if (newContent.parentNode) // we can't use the parent directly because newContent may have siblings
                // that we don't want in the morph, and reparenting might be expensive (TODO is it?),
                // so instead we create a fake parent node that only sees a slice of its children.
                /** @type {Element} */ return /** @type {any} */ new SlicedParentNode(newContent);
                else {
                    // a single node is added as a child to a dummy parent
                    const dummyParent = document.createElement("div");
                    dummyParent.append(newContent);
                    return dummyParent;
                }
            } else {
                // all nodes in the array or HTMLElement collection are consolidated under
                // a single dummy parent element
                const dummyParent = document.createElement("div");
                for (const elt of [
                    ...newContent
                ])dummyParent.append(elt);
                return dummyParent;
            }
        }
        /**
     * A fake duck-typed parent element to wrap a single node, without actually reparenting it.
     * This is useful because the node may have siblings that we don't want in the morph, and it may also be moved
     * or replaced with one or more elements during the morph. This class effectively allows us a window into
     * a slice of a node's children.
     * "If it walks like a duck, and quacks like a duck, then it must be a duck!" -- James Whitcomb Riley (1849–1916)
     */ class SlicedParentNode {
            /** @param {Node} node */ constructor(node){
                this.originalNode = node;
                this.realParentNode = /** @type {Element} */ node.parentNode;
                this.previousSibling = node.previousSibling;
                this.nextSibling = node.nextSibling;
            }
            /** @returns {Node[]} */ get childNodes() {
                // return slice of realParent's current childNodes, based on previousSibling and nextSibling
                const nodes = [];
                let cursor = this.previousSibling ? this.previousSibling.nextSibling : this.realParentNode.firstChild;
                while(cursor && cursor != this.nextSibling){
                    nodes.push(cursor);
                    cursor = cursor.nextSibling;
                }
                return nodes;
            }
            /**
       * @param {string} selector
       * @returns {Element[]}
       */ querySelectorAll(selector) {
                return this.childNodes.reduce((results, node)=>{
                    if (node instanceof Element) {
                        if (node.matches(selector)) results.push(node);
                        const nodeList = node.querySelectorAll(selector);
                        for(let i = 0; i < nodeList.length; i++)results.push(nodeList[i]);
                    }
                    return results;
                }, /** @type {Element[]} */ []);
            }
            /**
       * @param {Node} node
       * @param {Node} referenceNode
       * @returns {Node}
       */ insertBefore(node, referenceNode) {
                return this.realParentNode.insertBefore(node, referenceNode);
            }
            /**
       * @param {Node} node
       * @param {Node} referenceNode
       * @returns {Node}
       */ moveBefore(node, referenceNode) {
                // @ts-ignore - use new moveBefore feature
                return this.realParentNode.moveBefore(node, referenceNode);
            }
            /**
       * for later use with populateIdMapWithTree to halt upwards iteration
       * @returns {Node}
       */ get __idiomorphRoot() {
                return this.originalNode;
            }
        }
        /**
     *
     * @param {string} newContent
     * @returns {Node | null | DocumentFragment}
     */ function parseContent(newContent) {
            let parser = new DOMParser();
            // remove svgs to avoid false-positive matches on head, etc.
            let contentWithSvgsRemoved = newContent.replace(/<svg(\s[^>]*>|>)([\s\S]*?)<\/svg>/gim, "");
            // if the newContent contains a html, head or body tag, we can simply parse it w/o wrapping
            if (contentWithSvgsRemoved.match(/<\/html>/) || contentWithSvgsRemoved.match(/<\/head>/) || contentWithSvgsRemoved.match(/<\/body>/)) {
                let content = parser.parseFromString(newContent, "text/html");
                // if it is a full HTML document, return the document itself as the parent container
                if (contentWithSvgsRemoved.match(/<\/html>/)) {
                    generatedByIdiomorph.add(content);
                    return content;
                } else {
                    // otherwise return the html element as the parent container
                    let htmlElement = content.firstChild;
                    if (htmlElement) generatedByIdiomorph.add(htmlElement);
                    return htmlElement;
                }
            } else {
                // if it is partial HTML, wrap it in a template tag to provide a parent element and also to help
                // deal with touchy tags like tr, tbody, etc.
                let responseDoc = parser.parseFromString("<body><template>" + newContent + "</template></body>", "text/html");
                let content = /** @type {HTMLTemplateElement} */ responseDoc.body.querySelector("template").content;
                generatedByIdiomorph.add(content);
                return content;
            }
        }
        return {
            normalizeElement: normalizeElement,
            normalizeParent: normalizeParent
        };
    }();
    //=============================================================================
    // This is what ends up becoming the Idiomorph global object
    //=============================================================================
    return {
        morph: morph,
        defaults: defaults
    };
}();
/**
 * Morph the state of the currentElement based on the attributes and contents of
 * the newElement. Morphing may dispatch turbo:before-morph-element,
 * turbo:before-morph-attribute, and turbo:morph-element events.
 *
 * @param currentElement Element destination of morphing changes
 * @param newElement Element source of morphing changes
 */ function $fb0d47f64ee363ae$export$dc74801294c91b10(currentElement, newElement, { callbacks: callbacks, ...options } = {}) {
    $fb0d47f64ee363ae$var$Idiomorph.morph(currentElement, newElement, {
        ...options,
        callbacks: new $fb0d47f64ee363ae$var$DefaultIdiomorphCallbacks(callbacks)
    });
}
/**
 * Morph the child elements of the currentElement based on the child elements of
 * the newElement. Morphing children may dispatch turbo:before-morph-element,
 * turbo:before-morph-attribute, and turbo:morph-element events.
 *
 * @param currentElement Element destination of morphing children changes
 * @param newElement Element source of morphing children changes
 */ function $fb0d47f64ee363ae$export$e0eeaf5bc84bd47b(currentElement, newElement, options = {}) {
    $fb0d47f64ee363ae$export$dc74801294c91b10(currentElement, newElement.childNodes, {
        ...options,
        morphStyle: "innerHTML"
    });
}
function $fb0d47f64ee363ae$var$shouldRefreshFrameWithMorphing(currentFrame, newFrame) {
    return currentFrame instanceof $fb0d47f64ee363ae$export$f464a8f0ffa32c44 && currentFrame.shouldReloadWithMorph && (!newFrame || $fb0d47f64ee363ae$var$areFramesCompatibleForRefreshing(currentFrame, newFrame)) && !currentFrame.closest("[data-turbo-permanent]");
}
function $fb0d47f64ee363ae$var$areFramesCompatibleForRefreshing(currentFrame, newFrame) {
    // newFrame cannot yet be an instance of FrameElement because custom
    // elements don't get initialized until they're attached to the DOM, so
    // test its Element#nodeName instead
    return newFrame instanceof Element && newFrame.nodeName === "TURBO-FRAME" && currentFrame.id === newFrame.id && (!newFrame.getAttribute("src") || $fb0d47f64ee363ae$var$urlsAreEqual(currentFrame.src, newFrame.getAttribute("src")));
}
function $fb0d47f64ee363ae$var$closestFrameReloadableWithMorphing(node) {
    return node.parentElement.closest("turbo-frame[src][refresh=morph]");
}
class $fb0d47f64ee363ae$var$DefaultIdiomorphCallbacks {
    #beforeNodeMorphed;
    constructor({ beforeNodeMorphed: beforeNodeMorphed } = {}){
        this.#beforeNodeMorphed = beforeNodeMorphed || (()=>true);
    }
    beforeNodeAdded = (node)=>{
        return !(node.id && node.hasAttribute("data-turbo-permanent") && document.getElementById(node.id));
    };
    beforeNodeMorphed = (currentElement, newElement)=>{
        if (currentElement instanceof Element) {
            if (!currentElement.hasAttribute("data-turbo-permanent") && this.#beforeNodeMorphed(currentElement, newElement)) {
                const event = $fb0d47f64ee363ae$var$dispatch("turbo:before-morph-element", {
                    cancelable: true,
                    target: currentElement,
                    detail: {
                        currentElement: currentElement,
                        newElement: newElement
                    }
                });
                return !event.defaultPrevented;
            } else return false;
        }
    };
    beforeAttributeUpdated = (attributeName, target, mutationType)=>{
        const event = $fb0d47f64ee363ae$var$dispatch("turbo:before-morph-attribute", {
            cancelable: true,
            target: target,
            detail: {
                attributeName: attributeName,
                mutationType: mutationType
            }
        });
        return !event.defaultPrevented;
    };
    beforeNodeRemoved = (node)=>{
        return this.beforeNodeMorphed(node);
    };
    afterNodeMorphed = (currentElement, newElement)=>{
        if (currentElement instanceof Element) $fb0d47f64ee363ae$var$dispatch("turbo:morph-element", {
            target: currentElement,
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
    };
}
class $fb0d47f64ee363ae$var$MorphingFrameRenderer extends $fb0d47f64ee363ae$export$f09c4165d16bb2b7 {
    static renderElement(currentElement, newElement) {
        $fb0d47f64ee363ae$var$dispatch("turbo:before-frame-morph", {
            target: currentElement,
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
        $fb0d47f64ee363ae$export$e0eeaf5bc84bd47b(currentElement, newElement, {
            callbacks: {
                beforeNodeMorphed: (node, newNode)=>{
                    if ($fb0d47f64ee363ae$var$shouldRefreshFrameWithMorphing(node, newNode) && $fb0d47f64ee363ae$var$closestFrameReloadableWithMorphing(node) === currentElement) {
                        node.reload();
                        return false;
                    }
                    return true;
                }
            }
        });
    }
    async preservingPermanentElements(callback) {
        return await callback();
    }
}
class $fb0d47f64ee363ae$var$ProgressBar {
    static animationDuration = 300 /*ms*/ ;
    static get defaultCSS() {
        return $fb0d47f64ee363ae$var$unindent`
      .turbo-progress-bar {
        position: fixed;
        display: block;
        top: 0;
        left: 0;
        height: 3px;
        background: #0076ff;
        z-index: 2147483647;
        transition:
          width ${$fb0d47f64ee363ae$var$ProgressBar.animationDuration}ms ease-out,
          opacity ${$fb0d47f64ee363ae$var$ProgressBar.animationDuration / 2}ms ${$fb0d47f64ee363ae$var$ProgressBar.animationDuration / 2}ms ease-in;
        transform: translate3d(0, 0, 0);
      }
    `;
    }
    hiding = false;
    value = 0;
    visible = false;
    constructor(){
        this.stylesheetElement = this.createStylesheetElement();
        this.progressElement = this.createProgressElement();
        this.installStylesheetElement();
        this.setValue(0);
    }
    show() {
        if (!this.visible) {
            this.visible = true;
            this.installProgressElement();
            this.startTrickling();
        }
    }
    hide() {
        if (this.visible && !this.hiding) {
            this.hiding = true;
            this.fadeProgressElement(()=>{
                this.uninstallProgressElement();
                this.stopTrickling();
                this.visible = false;
                this.hiding = false;
            });
        }
    }
    setValue(value) {
        this.value = value;
        this.refresh();
    }
    // Private
    installStylesheetElement() {
        document.head.insertBefore(this.stylesheetElement, document.head.firstChild);
    }
    installProgressElement() {
        this.progressElement.style.width = "0";
        this.progressElement.style.opacity = "1";
        document.documentElement.insertBefore(this.progressElement, document.body);
        this.refresh();
    }
    fadeProgressElement(callback) {
        this.progressElement.style.opacity = "0";
        setTimeout(callback, $fb0d47f64ee363ae$var$ProgressBar.animationDuration * 1.5);
    }
    uninstallProgressElement() {
        if (this.progressElement.parentNode) document.documentElement.removeChild(this.progressElement);
    }
    startTrickling() {
        if (!this.trickleInterval) this.trickleInterval = window.setInterval(this.trickle, $fb0d47f64ee363ae$var$ProgressBar.animationDuration);
    }
    stopTrickling() {
        window.clearInterval(this.trickleInterval);
        delete this.trickleInterval;
    }
    trickle = ()=>{
        this.setValue(this.value + Math.random() / 100);
    };
    refresh() {
        requestAnimationFrame(()=>{
            this.progressElement.style.width = `${10 + this.value * 90}%`;
        });
    }
    createStylesheetElement() {
        const element = document.createElement("style");
        element.type = "text/css";
        element.textContent = $fb0d47f64ee363ae$var$ProgressBar.defaultCSS;
        const cspNonce = $fb0d47f64ee363ae$var$getCspNonce();
        if (cspNonce) element.nonce = cspNonce;
        return element;
    }
    createProgressElement() {
        const element = document.createElement("div");
        element.className = "turbo-progress-bar";
        return element;
    }
}
class $fb0d47f64ee363ae$var$HeadSnapshot extends $fb0d47f64ee363ae$var$Snapshot {
    detailsByOuterHTML = this.children.filter((element)=>!$fb0d47f64ee363ae$var$elementIsNoscript(element)).map((element)=>$fb0d47f64ee363ae$var$elementWithoutNonce(element)).reduce((result, element)=>{
        const { outerHTML: outerHTML } = element;
        const details = outerHTML in result ? result[outerHTML] : {
            type: $fb0d47f64ee363ae$var$elementType(element),
            tracked: $fb0d47f64ee363ae$var$elementIsTracked(element),
            elements: []
        };
        return {
            ...result,
            [outerHTML]: {
                ...details,
                elements: [
                    ...details.elements,
                    element
                ]
            }
        };
    }, {});
    get trackedElementSignature() {
        return Object.keys(this.detailsByOuterHTML).filter((outerHTML)=>this.detailsByOuterHTML[outerHTML].tracked).join("");
    }
    getScriptElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("script", snapshot);
    }
    getStylesheetElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("stylesheet", snapshot);
    }
    getElementsMatchingTypeNotInSnapshot(matchedType, snapshot) {
        return Object.keys(this.detailsByOuterHTML).filter((outerHTML)=>!(outerHTML in snapshot.detailsByOuterHTML)).map((outerHTML)=>this.detailsByOuterHTML[outerHTML]).filter(({ type: type })=>type == matchedType).map(({ elements: [element] })=>element);
    }
    get provisionalElements() {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML)=>{
            const { type: type, tracked: tracked, elements: elements } = this.detailsByOuterHTML[outerHTML];
            if (type == null && !tracked) return [
                ...result,
                ...elements
            ];
            else if (elements.length > 1) return [
                ...result,
                ...elements.slice(1)
            ];
            else return result;
        }, []);
    }
    getMetaValue(name) {
        const element = this.findMetaElementByName(name);
        return element ? element.getAttribute("content") : null;
    }
    findMetaElementByName(name) {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML)=>{
            const { elements: [element] } = this.detailsByOuterHTML[outerHTML];
            return $fb0d47f64ee363ae$var$elementIsMetaElementWithName(element, name) ? element : result;
        }, 0);
    }
}
function $fb0d47f64ee363ae$var$elementType(element) {
    if ($fb0d47f64ee363ae$var$elementIsScript(element)) return "script";
    else if ($fb0d47f64ee363ae$var$elementIsStylesheet(element)) return "stylesheet";
}
function $fb0d47f64ee363ae$var$elementIsTracked(element) {
    return element.getAttribute("data-turbo-track") == "reload";
}
function $fb0d47f64ee363ae$var$elementIsScript(element) {
    const tagName = element.localName;
    return tagName == "script";
}
function $fb0d47f64ee363ae$var$elementIsNoscript(element) {
    const tagName = element.localName;
    return tagName == "noscript";
}
function $fb0d47f64ee363ae$var$elementIsStylesheet(element) {
    const tagName = element.localName;
    return tagName == "style" || tagName == "link" && element.getAttribute("rel") == "stylesheet";
}
function $fb0d47f64ee363ae$var$elementIsMetaElementWithName(element, name) {
    const tagName = element.localName;
    return tagName == "meta" && element.getAttribute("name") == name;
}
function $fb0d47f64ee363ae$var$elementWithoutNonce(element) {
    if (element.hasAttribute("nonce")) element.setAttribute("nonce", "");
    return element;
}
class $fb0d47f64ee363ae$export$4f11b95e473fd113 extends $fb0d47f64ee363ae$var$Snapshot {
    static fromHTMLString(html = "") {
        return this.fromDocument($fb0d47f64ee363ae$var$parseHTMLDocument(html));
    }
    static fromElement(element) {
        return this.fromDocument(element.ownerDocument);
    }
    static fromDocument({ documentElement: documentElement, body: body, head: head }) {
        return new this(documentElement, body, new $fb0d47f64ee363ae$var$HeadSnapshot(head));
    }
    constructor(documentElement, body, headSnapshot){
        super(body);
        this.documentElement = documentElement;
        this.headSnapshot = headSnapshot;
    }
    clone() {
        const clonedElement = this.element.cloneNode(true);
        const selectElements = this.element.querySelectorAll("select");
        const clonedSelectElements = clonedElement.querySelectorAll("select");
        for (const [index, source] of selectElements.entries()){
            const clone = clonedSelectElements[index];
            for (const option of clone.selectedOptions)option.selected = false;
            for (const option of source.selectedOptions)clone.options[option.index].selected = true;
        }
        for (const clonedPasswordInput of clonedElement.querySelectorAll('input[type="password"]'))clonedPasswordInput.value = "";
        for (const clonedNoscriptElement of clonedElement.querySelectorAll("noscript"))clonedNoscriptElement.remove();
        return new $fb0d47f64ee363ae$export$4f11b95e473fd113(this.documentElement, clonedElement, this.headSnapshot);
    }
    get lang() {
        return this.documentElement.getAttribute("lang");
    }
    get dir() {
        return this.documentElement.getAttribute("dir");
    }
    get headElement() {
        return this.headSnapshot.element;
    }
    get rootLocation() {
        const root = this.getSetting("root") ?? "/";
        return $fb0d47f64ee363ae$var$expandURL(root);
    }
    get cacheControlValue() {
        return this.getSetting("cache-control");
    }
    get isPreviewable() {
        return this.cacheControlValue != "no-preview";
    }
    get isCacheable() {
        return this.cacheControlValue != "no-cache";
    }
    get isVisitable() {
        return this.getSetting("visit-control") != "reload";
    }
    get prefersViewTransitions() {
        const viewTransitionEnabled = this.getSetting("view-transition") === "true" || this.headSnapshot.getMetaValue("view-transition") === "same-origin";
        return viewTransitionEnabled && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    get refreshMethod() {
        return this.getSetting("refresh-method");
    }
    get refreshScroll() {
        return this.getSetting("refresh-scroll");
    }
    // Private
    getSetting(name) {
        return this.headSnapshot.getMetaValue(`turbo-${name}`);
    }
}
class $fb0d47f64ee363ae$var$ViewTransitioner {
    #viewTransitionStarted = false;
    #lastOperation = Promise.resolve();
    renderChange(useViewTransition, render) {
        if (useViewTransition && this.viewTransitionsAvailable && !this.#viewTransitionStarted) {
            this.#viewTransitionStarted = true;
            this.#lastOperation = this.#lastOperation.then(async ()=>{
                await document.startViewTransition(render).finished;
            });
        } else this.#lastOperation = this.#lastOperation.then(render);
        return this.#lastOperation;
    }
    get viewTransitionsAvailable() {
        return document.startViewTransition;
    }
}
const $fb0d47f64ee363ae$var$defaultOptions = {
    action: "advance",
    historyChanged: false,
    visitCachedSnapshot: ()=>{},
    willRender: true,
    updateHistory: true,
    shouldCacheSnapshot: true,
    acceptsStreamResponse: false,
    refresh: {}
};
const $fb0d47f64ee363ae$var$TimingMetric = {
    visitStart: "visitStart",
    requestStart: "requestStart",
    requestEnd: "requestEnd",
    visitEnd: "visitEnd"
};
const $fb0d47f64ee363ae$var$VisitState = {
    initialized: "initialized",
    started: "started",
    canceled: "canceled",
    failed: "failed",
    completed: "completed"
};
const $fb0d47f64ee363ae$var$SystemStatusCode = {
    networkFailure: 0,
    timeoutFailure: -1,
    contentTypeMismatch: -2
};
const $fb0d47f64ee363ae$var$Direction = {
    advance: "forward",
    restore: "back",
    replace: "none"
};
class $fb0d47f64ee363ae$var$Visit {
    identifier = $fb0d47f64ee363ae$var$uuid() // Required by turbo-ios
    ;
    timingMetrics = {};
    followedRedirect = false;
    historyChanged = false;
    scrolled = false;
    shouldCacheSnapshot = true;
    acceptsStreamResponse = false;
    snapshotCached = false;
    state = $fb0d47f64ee363ae$var$VisitState.initialized;
    viewTransitioner = new $fb0d47f64ee363ae$var$ViewTransitioner();
    constructor(delegate, location1, restorationIdentifier, options = {}){
        this.delegate = delegate;
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier || $fb0d47f64ee363ae$var$uuid();
        const { action: action, historyChanged: historyChanged, referrer: referrer, snapshot: snapshot, snapshotHTML: snapshotHTML, response: response, visitCachedSnapshot: visitCachedSnapshot, willRender: willRender, updateHistory: updateHistory, shouldCacheSnapshot: shouldCacheSnapshot, acceptsStreamResponse: acceptsStreamResponse, direction: direction, refresh: refresh } = {
            ...$fb0d47f64ee363ae$var$defaultOptions,
            ...options
        };
        this.action = action;
        this.historyChanged = historyChanged;
        this.referrer = referrer;
        this.snapshot = snapshot;
        this.snapshotHTML = snapshotHTML;
        this.response = response;
        this.isPageRefresh = this.view.isPageRefresh(this);
        this.visitCachedSnapshot = visitCachedSnapshot;
        this.willRender = willRender;
        this.updateHistory = updateHistory;
        this.scrolled = !willRender;
        this.shouldCacheSnapshot = shouldCacheSnapshot;
        this.acceptsStreamResponse = acceptsStreamResponse;
        this.direction = direction || $fb0d47f64ee363ae$var$Direction[action];
        this.refresh = refresh;
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get history() {
        return this.delegate.history;
    }
    get restorationData() {
        return this.history.getRestorationDataForIdentifier(this.restorationIdentifier);
    }
    start() {
        if (this.state == $fb0d47f64ee363ae$var$VisitState.initialized) {
            this.recordTimingMetric($fb0d47f64ee363ae$var$TimingMetric.visitStart);
            this.state = $fb0d47f64ee363ae$var$VisitState.started;
            this.adapter.visitStarted(this);
            this.delegate.visitStarted(this);
        }
    }
    cancel() {
        if (this.state == $fb0d47f64ee363ae$var$VisitState.started) {
            if (this.request) this.request.cancel();
            this.cancelRender();
            this.state = $fb0d47f64ee363ae$var$VisitState.canceled;
        }
    }
    complete() {
        if (this.state == $fb0d47f64ee363ae$var$VisitState.started) {
            this.recordTimingMetric($fb0d47f64ee363ae$var$TimingMetric.visitEnd);
            this.adapter.visitCompleted(this);
            this.state = $fb0d47f64ee363ae$var$VisitState.completed;
            this.followRedirect();
            if (!this.followedRedirect) this.delegate.visitCompleted(this);
        }
    }
    fail() {
        if (this.state == $fb0d47f64ee363ae$var$VisitState.started) {
            this.state = $fb0d47f64ee363ae$var$VisitState.failed;
            this.adapter.visitFailed(this);
            this.delegate.visitCompleted(this);
        }
    }
    changeHistory() {
        if (!this.historyChanged && this.updateHistory) {
            const actionForHistory = this.location.href === this.referrer?.href ? "replace" : this.action;
            const method = $fb0d47f64ee363ae$var$getHistoryMethodForAction(actionForHistory);
            this.history.update(method, this.location, this.restorationIdentifier);
            this.historyChanged = true;
        }
    }
    issueRequest() {
        if (this.hasPreloadedResponse()) this.simulateRequest();
        else if (this.shouldIssueRequest() && !this.request) {
            this.request = new $fb0d47f64ee363ae$export$319b96fe59834522(this, $fb0d47f64ee363ae$export$76f6869e29ff06ee.get, this.location);
            this.request.perform();
        }
    }
    simulateRequest() {
        if (this.response) {
            this.startRequest();
            this.recordResponse();
            this.finishRequest();
        }
    }
    startRequest() {
        this.recordTimingMetric($fb0d47f64ee363ae$var$TimingMetric.requestStart);
        this.adapter.visitRequestStarted(this);
    }
    recordResponse(response = this.response) {
        this.response = response;
        if (response) {
            const { statusCode: statusCode } = response;
            if ($fb0d47f64ee363ae$var$isSuccessful(statusCode)) this.adapter.visitRequestCompleted(this);
            else this.adapter.visitRequestFailedWithStatusCode(this, statusCode);
        }
    }
    finishRequest() {
        this.recordTimingMetric($fb0d47f64ee363ae$var$TimingMetric.requestEnd);
        this.adapter.visitRequestFinished(this);
    }
    loadResponse() {
        if (this.response) {
            const { statusCode: statusCode, responseHTML: responseHTML } = this.response;
            this.render(async ()=>{
                if (this.shouldCacheSnapshot) this.cacheSnapshot();
                if (this.view.renderPromise) await this.view.renderPromise;
                if ($fb0d47f64ee363ae$var$isSuccessful(statusCode) && responseHTML != null) {
                    const snapshot = $fb0d47f64ee363ae$export$4f11b95e473fd113.fromHTMLString(responseHTML);
                    await this.renderPageSnapshot(snapshot, false);
                    this.adapter.visitRendered(this);
                    this.complete();
                } else {
                    await this.view.renderError($fb0d47f64ee363ae$export$4f11b95e473fd113.fromHTMLString(responseHTML), this);
                    this.adapter.visitRendered(this);
                    this.fail();
                }
            });
        }
    }
    getCachedSnapshot() {
        const snapshot = this.view.getCachedSnapshotForLocation(this.location) || this.getPreloadedSnapshot();
        if (snapshot && (!$fb0d47f64ee363ae$var$getAnchor(this.location) || snapshot.hasAnchor($fb0d47f64ee363ae$var$getAnchor(this.location)))) {
            if (this.action == "restore" || snapshot.isPreviewable) return snapshot;
        }
    }
    getPreloadedSnapshot() {
        if (this.snapshotHTML) return $fb0d47f64ee363ae$export$4f11b95e473fd113.fromHTMLString(this.snapshotHTML);
    }
    hasCachedSnapshot() {
        return this.getCachedSnapshot() != null;
    }
    loadCachedSnapshot() {
        const snapshot = this.getCachedSnapshot();
        if (snapshot) {
            const isPreview = this.shouldIssueRequest();
            this.render(async ()=>{
                this.cacheSnapshot();
                if (this.isPageRefresh) this.adapter.visitRendered(this);
                else {
                    if (this.view.renderPromise) await this.view.renderPromise;
                    await this.renderPageSnapshot(snapshot, isPreview);
                    this.adapter.visitRendered(this);
                    if (!isPreview) this.complete();
                }
            });
        }
    }
    followRedirect() {
        if (this.redirectedToLocation && !this.followedRedirect && this.response?.redirected) {
            this.adapter.visitProposedToLocation(this.redirectedToLocation, {
                action: "replace",
                response: this.response,
                shouldCacheSnapshot: false,
                willRender: false
            });
            this.followedRedirect = true;
        }
    }
    // Fetch request delegate
    prepareRequest(request) {
        if (this.acceptsStreamResponse) request.acceptResponseType($fb0d47f64ee363ae$var$StreamMessage.contentType);
    }
    requestStarted() {
        this.startRequest();
    }
    requestPreventedHandlingResponse(_request, _response) {}
    async requestSucceededWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected: redirected, statusCode: statusCode } = response;
        if (responseHTML == undefined) this.recordResponse({
            statusCode: $fb0d47f64ee363ae$var$SystemStatusCode.contentTypeMismatch,
            redirected: redirected
        });
        else {
            this.redirectedToLocation = response.redirected ? response.location : undefined;
            this.recordResponse({
                statusCode: statusCode,
                responseHTML: responseHTML,
                redirected: redirected
            });
        }
    }
    async requestFailedWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected: redirected, statusCode: statusCode } = response;
        if (responseHTML == undefined) this.recordResponse({
            statusCode: $fb0d47f64ee363ae$var$SystemStatusCode.contentTypeMismatch,
            redirected: redirected
        });
        else this.recordResponse({
            statusCode: statusCode,
            responseHTML: responseHTML,
            redirected: redirected
        });
    }
    requestErrored(_request, _error) {
        this.recordResponse({
            statusCode: $fb0d47f64ee363ae$var$SystemStatusCode.networkFailure,
            redirected: false
        });
    }
    requestFinished() {
        this.finishRequest();
    }
    // Scrolling
    performScroll() {
        if (!this.scrolled && !this.view.forceReloaded && !this.view.shouldPreserveScrollPosition(this)) {
            if (this.action == "restore") this.scrollToRestoredPosition() || this.scrollToAnchor() || this.view.scrollToTop();
            else this.scrollToAnchor() || this.view.scrollToTop();
            this.scrolled = true;
        }
    }
    scrollToRestoredPosition() {
        const { scrollPosition: scrollPosition } = this.restorationData;
        if (scrollPosition) {
            this.view.scrollToPosition(scrollPosition);
            return true;
        }
    }
    scrollToAnchor() {
        const anchor = $fb0d47f64ee363ae$var$getAnchor(this.location);
        if (anchor != null) {
            this.view.scrollToAnchor(anchor);
            return true;
        }
    }
    // Instrumentation
    recordTimingMetric(metric) {
        this.timingMetrics[metric] = new Date().getTime();
    }
    getTimingMetrics() {
        return {
            ...this.timingMetrics
        };
    }
    // Private
    hasPreloadedResponse() {
        return typeof this.response == "object";
    }
    shouldIssueRequest() {
        if (this.action == "restore") return !this.hasCachedSnapshot();
        else return this.willRender;
    }
    cacheSnapshot() {
        if (!this.snapshotCached) {
            this.view.cacheSnapshot(this.snapshot).then((snapshot)=>snapshot && this.visitCachedSnapshot(snapshot));
            this.snapshotCached = true;
        }
    }
    async render(callback) {
        this.cancelRender();
        await new Promise((resolve)=>{
            this.frame = document.visibilityState === "hidden" ? setTimeout(()=>resolve(), 0) : requestAnimationFrame(()=>resolve());
        });
        await callback();
        delete this.frame;
    }
    async renderPageSnapshot(snapshot, isPreview) {
        await this.viewTransitioner.renderChange(this.view.shouldTransitionTo(snapshot), async ()=>{
            await this.view.renderPage(snapshot, isPreview, this.willRender, this);
            this.performScroll();
        });
    }
    cancelRender() {
        if (this.frame) {
            cancelAnimationFrame(this.frame);
            delete this.frame;
        }
    }
}
function $fb0d47f64ee363ae$var$isSuccessful(statusCode) {
    return statusCode >= 200 && statusCode < 300;
}
class $fb0d47f64ee363ae$var$BrowserAdapter {
    progressBar = new $fb0d47f64ee363ae$var$ProgressBar();
    constructor(session){
        this.session = session;
    }
    visitProposedToLocation(location1, options) {
        if ($fb0d47f64ee363ae$var$locationIsVisitable(location1, this.navigator.rootLocation)) this.navigator.startVisit(location1, options?.restorationIdentifier || $fb0d47f64ee363ae$var$uuid(), options);
        else window.location.href = location1.toString();
    }
    visitStarted(visit) {
        this.location = visit.location;
        this.redirectedToLocation = null;
        visit.loadCachedSnapshot();
        visit.issueRequest();
    }
    visitRequestStarted(visit) {
        this.progressBar.setValue(0);
        if (visit.hasCachedSnapshot() || visit.action != "restore") this.showVisitProgressBarAfterDelay();
        else this.showProgressBar();
    }
    visitRequestCompleted(visit) {
        visit.loadResponse();
        if (visit.response.redirected) this.redirectedToLocation = visit.redirectedToLocation;
    }
    visitRequestFailedWithStatusCode(visit, statusCode) {
        switch(statusCode){
            case $fb0d47f64ee363ae$var$SystemStatusCode.networkFailure:
            case $fb0d47f64ee363ae$var$SystemStatusCode.timeoutFailure:
            case $fb0d47f64ee363ae$var$SystemStatusCode.contentTypeMismatch:
                return this.reload({
                    reason: "request_failed",
                    context: {
                        statusCode: statusCode
                    }
                });
            default:
                return visit.loadResponse();
        }
    }
    visitRequestFinished(_visit) {}
    visitCompleted(_visit) {
        this.progressBar.setValue(1);
        this.hideVisitProgressBar();
    }
    pageInvalidated(reason) {
        this.reload(reason);
    }
    visitFailed(_visit) {
        this.progressBar.setValue(1);
        this.hideVisitProgressBar();
    }
    visitRendered(_visit) {}
    // Link prefetching
    linkPrefetchingIsEnabledForLocation(location1) {
        return true;
    }
    // Form Submission Delegate
    formSubmissionStarted(_formSubmission) {
        this.progressBar.setValue(0);
        this.showFormProgressBarAfterDelay();
    }
    formSubmissionFinished(_formSubmission) {
        this.progressBar.setValue(1);
        this.hideFormProgressBar();
    }
    // Private
    showVisitProgressBarAfterDelay() {
        this.visitProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideVisitProgressBar() {
        this.progressBar.hide();
        if (this.visitProgressBarTimeout != null) {
            window.clearTimeout(this.visitProgressBarTimeout);
            delete this.visitProgressBarTimeout;
        }
    }
    showFormProgressBarAfterDelay() {
        if (this.formProgressBarTimeout == null) this.formProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideFormProgressBar() {
        this.progressBar.hide();
        if (this.formProgressBarTimeout != null) {
            window.clearTimeout(this.formProgressBarTimeout);
            delete this.formProgressBarTimeout;
        }
    }
    showProgressBar = ()=>{
        this.progressBar.show();
    };
    reload(reason) {
        $fb0d47f64ee363ae$var$dispatch("turbo:reload", {
            detail: reason
        });
        window.location.href = (this.redirectedToLocation || this.location)?.toString() || window.location.href;
    }
    get navigator() {
        return this.session.navigator;
    }
}
class $fb0d47f64ee363ae$var$CacheObserver {
    selector = "[data-turbo-temporary]";
    started = false;
    start() {
        if (!this.started) {
            this.started = true;
            addEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            removeEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    removeTemporaryElements = (_event)=>{
        for (const element of this.temporaryElements)element.remove();
    };
    get temporaryElements() {
        return [
            ...document.querySelectorAll(this.selector)
        ];
    }
}
class $fb0d47f64ee363ae$var$FrameRedirector {
    constructor(session, element){
        this.session = session;
        this.element = element;
        this.linkInterceptor = new $fb0d47f64ee363ae$var$LinkInterceptor(this, element);
        this.formSubmitObserver = new $fb0d47f64ee363ae$var$FormSubmitObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
        this.formSubmitObserver.start();
    }
    stop() {
        this.linkInterceptor.stop();
        this.formSubmitObserver.stop();
    }
    // Link interceptor delegate
    shouldInterceptLinkClick(element, _location, _event) {
        return this.#shouldRedirect(element);
    }
    linkClickIntercepted(element, url, event) {
        const frame = this.#findFrameElement(element);
        if (frame) frame.delegate.linkClickIntercepted(element, url, event);
    }
    // Form submit observer delegate
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == null && this.#shouldSubmit(element, submitter) && this.#shouldRedirect(element, submitter);
    }
    formSubmitted(element, submitter) {
        const frame = this.#findFrameElement(element, submitter);
        if (frame) frame.delegate.formSubmitted(element, submitter);
    }
    #shouldSubmit(form, submitter) {
        const action = $fb0d47f64ee363ae$var$getAction$1(form, submitter);
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const rootLocation = $fb0d47f64ee363ae$var$expandURL(meta?.content ?? "/");
        return this.#shouldRedirect(form, submitter) && $fb0d47f64ee363ae$var$locationIsVisitable(action, rootLocation);
    }
    #shouldRedirect(element, submitter) {
        const isNavigatable = element instanceof HTMLFormElement ? this.session.submissionIsNavigatable(element, submitter) : this.session.elementIsNavigatable(element);
        if (isNavigatable) {
            const frame = this.#findFrameElement(element, submitter);
            return frame ? frame != element.closest("turbo-frame") : false;
        } else return false;
    }
    #findFrameElement(element, submitter) {
        const id = submitter?.getAttribute("data-turbo-frame") || element.getAttribute("data-turbo-frame");
        if (id && id != "_top") {
            const frame = this.element.querySelector(`#${id}:not([disabled])`);
            if (frame instanceof $fb0d47f64ee363ae$export$f464a8f0ffa32c44) return frame;
        }
    }
}
class $fb0d47f64ee363ae$var$History {
    location;
    restorationIdentifier = $fb0d47f64ee363ae$var$uuid();
    restorationData = {};
    started = false;
    currentIndex = 0;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("popstate", this.onPopState, false);
            this.currentIndex = history.state?.turbo?.restorationIndex || 0;
            this.started = true;
            this.replace(new URL(window.location.href));
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("popstate", this.onPopState, false);
            this.started = false;
        }
    }
    push(location1, restorationIdentifier) {
        this.update(history.pushState, location1, restorationIdentifier);
    }
    replace(location1, restorationIdentifier) {
        this.update(history.replaceState, location1, restorationIdentifier);
    }
    update(method, location1, restorationIdentifier = $fb0d47f64ee363ae$var$uuid()) {
        if (method === history.pushState) ++this.currentIndex;
        const state = {
            turbo: {
                restorationIdentifier: restorationIdentifier,
                restorationIndex: this.currentIndex
            }
        };
        method.call(history, state, "", location1.href);
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier;
    }
    // Restoration data
    getRestorationDataForIdentifier(restorationIdentifier) {
        return this.restorationData[restorationIdentifier] || {};
    }
    updateRestorationData(additionalData) {
        const { restorationIdentifier: restorationIdentifier } = this;
        const restorationData = this.restorationData[restorationIdentifier];
        this.restorationData[restorationIdentifier] = {
            ...restorationData,
            ...additionalData
        };
    }
    // Scroll restoration
    assumeControlOfScrollRestoration() {
        if (!this.previousScrollRestoration) {
            this.previousScrollRestoration = history.scrollRestoration ?? "auto";
            history.scrollRestoration = "manual";
        }
    }
    relinquishControlOfScrollRestoration() {
        if (this.previousScrollRestoration) {
            history.scrollRestoration = this.previousScrollRestoration;
            delete this.previousScrollRestoration;
        }
    }
    // Event handlers
    onPopState = (event)=>{
        const { turbo: turbo } = event.state || {};
        this.location = new URL(window.location.href);
        if (turbo) {
            const { restorationIdentifier: restorationIdentifier, restorationIndex: restorationIndex } = turbo;
            this.restorationIdentifier = restorationIdentifier;
            const direction = restorationIndex > this.currentIndex ? "forward" : "back";
            this.delegate.historyPoppedToLocationWithRestorationIdentifierAndDirection(this.location, restorationIdentifier, direction);
            this.currentIndex = restorationIndex;
        } else {
            this.currentIndex++;
            this.delegate.historyPoppedWithEmptyState(this.location);
        }
    };
}
class $fb0d47f64ee363ae$var$LinkPrefetchObserver {
    started = false;
    #prefetchedLink = null;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (this.started) return;
        if (this.eventTarget.readyState === "loading") this.eventTarget.addEventListener("DOMContentLoaded", this.#enable, {
            once: true
        });
        else this.#enable();
    }
    stop() {
        if (!this.started) return;
        this.eventTarget.removeEventListener("mouseenter", this.#tryToPrefetchRequest, {
            capture: true,
            passive: true
        });
        this.eventTarget.removeEventListener("mouseleave", this.#cancelRequestIfObsolete, {
            capture: true,
            passive: true
        });
        this.eventTarget.removeEventListener("turbo:before-fetch-request", this.#tryToUsePrefetchedRequest, true);
        this.started = false;
    }
    #enable = ()=>{
        this.eventTarget.addEventListener("mouseenter", this.#tryToPrefetchRequest, {
            capture: true,
            passive: true
        });
        this.eventTarget.addEventListener("mouseleave", this.#cancelRequestIfObsolete, {
            capture: true,
            passive: true
        });
        this.eventTarget.addEventListener("turbo:before-fetch-request", this.#tryToUsePrefetchedRequest, true);
        this.started = true;
    };
    #tryToPrefetchRequest = (event)=>{
        if ($fb0d47f64ee363ae$var$getMetaContent("turbo-prefetch") === "false") return;
        const target = event.target;
        const isLink = target.matches && target.matches("a[href]:not([target^=_]):not([download])");
        if (isLink && this.#isPrefetchable(target)) {
            const link = target;
            const location1 = $fb0d47f64ee363ae$var$getLocationForLink(link);
            if (this.delegate.canPrefetchRequestToLocation(link, location1)) {
                this.#prefetchedLink = link;
                const fetchRequest = new $fb0d47f64ee363ae$export$319b96fe59834522(this, $fb0d47f64ee363ae$export$76f6869e29ff06ee.get, location1, new URLSearchParams(), target);
                fetchRequest.fetchOptions.priority = "low";
                $fb0d47f64ee363ae$var$prefetchCache.putLater(location1, fetchRequest, this.#cacheTtl);
            }
        }
    };
    #cancelRequestIfObsolete = (event)=>{
        if (event.target === this.#prefetchedLink) this.#cancelPrefetchRequest();
    };
    #cancelPrefetchRequest = ()=>{
        $fb0d47f64ee363ae$var$prefetchCache.clear();
        this.#prefetchedLink = null;
    };
    #tryToUsePrefetchedRequest = (event)=>{
        if (event.target.tagName !== "FORM" && event.detail.fetchOptions.method === "GET") {
            const cached = $fb0d47f64ee363ae$var$prefetchCache.get(event.detail.url);
            if (cached) // User clicked link, use cache response
            event.detail.fetchRequest = cached;
            $fb0d47f64ee363ae$var$prefetchCache.clear();
        }
    };
    prepareRequest(request) {
        const link = request.target;
        request.headers["X-Sec-Purpose"] = "prefetch";
        const turboFrame = link.closest("turbo-frame");
        const turboFrameTarget = link.getAttribute("data-turbo-frame") || turboFrame?.getAttribute("target") || turboFrame?.id;
        if (turboFrameTarget && turboFrameTarget !== "_top") request.headers["Turbo-Frame"] = turboFrameTarget;
    }
    // Fetch request interface
    requestSucceededWithResponse() {}
    requestStarted(fetchRequest) {}
    requestErrored(fetchRequest) {}
    requestFinished(fetchRequest) {}
    requestPreventedHandlingResponse(fetchRequest, fetchResponse) {}
    requestFailedWithResponse(fetchRequest, fetchResponse) {}
    get #cacheTtl() {
        return Number($fb0d47f64ee363ae$var$getMetaContent("turbo-prefetch-cache-time")) || $fb0d47f64ee363ae$var$cacheTtl;
    }
    #isPrefetchable(link) {
        const href = link.getAttribute("href");
        if (!href) return false;
        if ($fb0d47f64ee363ae$var$unfetchableLink(link)) return false;
        if ($fb0d47f64ee363ae$var$linkToTheSamePage(link)) return false;
        if ($fb0d47f64ee363ae$var$linkOptsOut(link)) return false;
        if ($fb0d47f64ee363ae$var$nonSafeLink(link)) return false;
        if ($fb0d47f64ee363ae$var$eventPrevented(link)) return false;
        return true;
    }
}
const $fb0d47f64ee363ae$var$unfetchableLink = (link)=>{
    return link.origin !== document.location.origin || ![
        "http:",
        "https:"
    ].includes(link.protocol) || link.hasAttribute("target");
};
const $fb0d47f64ee363ae$var$linkToTheSamePage = (link)=>{
    return link.pathname + link.search === document.location.pathname + document.location.search || link.href.startsWith("#");
};
const $fb0d47f64ee363ae$var$linkOptsOut = (link)=>{
    if (link.getAttribute("data-turbo-prefetch") === "false") return true;
    if (link.getAttribute("data-turbo") === "false") return true;
    const turboPrefetchParent = $fb0d47f64ee363ae$var$findClosestRecursively(link, "[data-turbo-prefetch]");
    if (turboPrefetchParent && turboPrefetchParent.getAttribute("data-turbo-prefetch") === "false") return true;
    return false;
};
const $fb0d47f64ee363ae$var$nonSafeLink = (link)=>{
    const turboMethod = link.getAttribute("data-turbo-method");
    if (turboMethod && turboMethod.toLowerCase() !== "get") return true;
    if ($fb0d47f64ee363ae$var$isUJS(link)) return true;
    if (link.hasAttribute("data-turbo-confirm")) return true;
    if (link.hasAttribute("data-turbo-stream")) return true;
    return false;
};
const $fb0d47f64ee363ae$var$isUJS = (link)=>{
    return link.hasAttribute("data-remote") || link.hasAttribute("data-behavior") || link.hasAttribute("data-confirm") || link.hasAttribute("data-method");
};
const $fb0d47f64ee363ae$var$eventPrevented = (link)=>{
    const event = $fb0d47f64ee363ae$var$dispatch("turbo:before-prefetch", {
        target: link,
        cancelable: true
    });
    return event.defaultPrevented;
};
class $fb0d47f64ee363ae$var$Navigator {
    constructor(delegate){
        this.delegate = delegate;
    }
    proposeVisit(location1, options = {}) {
        if (this.delegate.allowsVisitingLocationWithAction(location1, options.action)) this.delegate.visitProposedToLocation(location1, options);
    }
    startVisit(locatable, restorationIdentifier, options = {}) {
        this.stop();
        this.currentVisit = new $fb0d47f64ee363ae$var$Visit(this, $fb0d47f64ee363ae$var$expandURL(locatable), restorationIdentifier, {
            referrer: this.location,
            ...options
        });
        this.currentVisit.start();
    }
    submitForm(form, submitter) {
        this.stop();
        this.formSubmission = new $fb0d47f64ee363ae$var$FormSubmission(this, form, submitter, true);
        this.formSubmission.start();
    }
    stop() {
        if (this.formSubmission) {
            this.formSubmission.stop();
            delete this.formSubmission;
        }
        if (this.currentVisit) {
            this.currentVisit.cancel();
            delete this.currentVisit;
        }
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get rootLocation() {
        return this.view.snapshot.rootLocation;
    }
    get history() {
        return this.delegate.history;
    }
    // Form submission delegate
    formSubmissionStarted(formSubmission) {
        // Not all adapters implement formSubmissionStarted
        if (typeof this.adapter.formSubmissionStarted === "function") this.adapter.formSubmissionStarted(formSubmission);
    }
    async formSubmissionSucceededWithResponse(formSubmission, fetchResponse) {
        if (formSubmission == this.formSubmission) {
            const responseHTML = await fetchResponse.responseHTML;
            if (responseHTML) {
                const shouldCacheSnapshot = formSubmission.isSafe;
                if (!shouldCacheSnapshot) this.view.clearSnapshotCache();
                const { statusCode: statusCode, redirected: redirected } = fetchResponse;
                const action = this.#getActionForFormSubmission(formSubmission, fetchResponse);
                const visitOptions = {
                    action: action,
                    shouldCacheSnapshot: shouldCacheSnapshot,
                    response: {
                        statusCode: statusCode,
                        responseHTML: responseHTML,
                        redirected: redirected
                    }
                };
                this.proposeVisit(fetchResponse.location, visitOptions);
            }
        }
    }
    async formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        const responseHTML = await fetchResponse.responseHTML;
        if (responseHTML) {
            const snapshot = $fb0d47f64ee363ae$export$4f11b95e473fd113.fromHTMLString(responseHTML);
            if (fetchResponse.serverError) await this.view.renderError(snapshot, this.currentVisit);
            else await this.view.renderPage(snapshot, false, true, this.currentVisit);
            if (snapshot.refreshScroll !== "preserve") this.view.scrollToTop();
            this.view.clearSnapshotCache();
        }
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished(formSubmission) {
        // Not all adapters implement formSubmissionFinished
        if (typeof this.adapter.formSubmissionFinished === "function") this.adapter.formSubmissionFinished(formSubmission);
    }
    // Link prefetching
    linkPrefetchingIsEnabledForLocation(location1) {
        // Not all adapters implement linkPrefetchingIsEnabledForLocation
        if (typeof this.adapter.linkPrefetchingIsEnabledForLocation === "function") return this.adapter.linkPrefetchingIsEnabledForLocation(location1);
        return true;
    }
    // Visit delegate
    visitStarted(visit) {
        this.delegate.visitStarted(visit);
    }
    visitCompleted(visit) {
        this.delegate.visitCompleted(visit);
        delete this.currentVisit;
    }
    // Same-page links are no longer handled with a Visit.
    // This method is still needed for Turbo Native adapters.
    locationWithActionIsSamePage(location1, action) {
        return false;
    }
    // Visits
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    #getActionForFormSubmission(formSubmission, fetchResponse) {
        const { submitter: submitter, formElement: formElement } = formSubmission;
        return $fb0d47f64ee363ae$var$getVisitAction(submitter, formElement) || this.#getDefaultAction(fetchResponse);
    }
    #getDefaultAction(fetchResponse) {
        const sameLocationRedirect = fetchResponse.redirected && fetchResponse.location.href === this.location?.href;
        return sameLocationRedirect ? "replace" : "advance";
    }
}
const $fb0d47f64ee363ae$var$PageStage = {
    initial: 0,
    loading: 1,
    interactive: 2,
    complete: 3
};
class $fb0d47f64ee363ae$var$PageObserver {
    stage = $fb0d47f64ee363ae$var$PageStage.initial;
    started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            if (this.stage == $fb0d47f64ee363ae$var$PageStage.initial) this.stage = $fb0d47f64ee363ae$var$PageStage.loading;
            document.addEventListener("readystatechange", this.interpretReadyState, false);
            addEventListener("pagehide", this.pageWillUnload, false);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            document.removeEventListener("readystatechange", this.interpretReadyState, false);
            removeEventListener("pagehide", this.pageWillUnload, false);
            this.started = false;
        }
    }
    interpretReadyState = ()=>{
        const { readyState: readyState } = this;
        if (readyState == "interactive") this.pageIsInteractive();
        else if (readyState == "complete") this.pageIsComplete();
    };
    pageIsInteractive() {
        if (this.stage == $fb0d47f64ee363ae$var$PageStage.loading) {
            this.stage = $fb0d47f64ee363ae$var$PageStage.interactive;
            this.delegate.pageBecameInteractive();
        }
    }
    pageIsComplete() {
        this.pageIsInteractive();
        if (this.stage == $fb0d47f64ee363ae$var$PageStage.interactive) {
            this.stage = $fb0d47f64ee363ae$var$PageStage.complete;
            this.delegate.pageLoaded();
        }
    }
    pageWillUnload = ()=>{
        this.delegate.pageWillUnload();
    };
    get readyState() {
        return document.readyState;
    }
}
class $fb0d47f64ee363ae$var$ScrollObserver {
    started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("scroll", this.onScroll, false);
            this.onScroll();
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("scroll", this.onScroll, false);
            this.started = false;
        }
    }
    onScroll = ()=>{
        this.updatePosition({
            x: window.pageXOffset,
            y: window.pageYOffset
        });
    };
    // Private
    updatePosition(position) {
        this.delegate.scrollPositionChanged(position);
    }
}
class $fb0d47f64ee363ae$var$StreamMessageRenderer {
    render({ fragment: fragment }) {
        $fb0d47f64ee363ae$var$Bardo.preservingPermanentElements(this, $fb0d47f64ee363ae$var$getPermanentElementMapForFragment(fragment), ()=>{
            $fb0d47f64ee363ae$var$withAutofocusFromFragment(fragment, ()=>{
                $fb0d47f64ee363ae$var$withPreservedFocus(()=>{
                    document.documentElement.appendChild(fragment);
                });
            });
        });
    }
    // Bardo delegate
    enteringBardo(currentPermanentElement, newPermanentElement) {
        newPermanentElement.replaceWith(currentPermanentElement.cloneNode(true));
    }
    leavingBardo() {}
}
function $fb0d47f64ee363ae$var$getPermanentElementMapForFragment(fragment) {
    const permanentElementsInDocument = $fb0d47f64ee363ae$var$queryPermanentElementsAll(document.documentElement);
    const permanentElementMap = {};
    for (const permanentElementInDocument of permanentElementsInDocument){
        const { id: id } = permanentElementInDocument;
        for (const streamElement of fragment.querySelectorAll("turbo-stream")){
            const elementInStream = $fb0d47f64ee363ae$var$getPermanentElementById(streamElement.templateElement.content, id);
            if (elementInStream) permanentElementMap[id] = [
                permanentElementInDocument,
                elementInStream
            ];
        }
    }
    return permanentElementMap;
}
async function $fb0d47f64ee363ae$var$withAutofocusFromFragment(fragment, callback) {
    const generatedID = `turbo-stream-autofocus-${$fb0d47f64ee363ae$var$uuid()}`;
    const turboStreams = fragment.querySelectorAll("turbo-stream");
    const elementWithAutofocus = $fb0d47f64ee363ae$var$firstAutofocusableElementInStreams(turboStreams);
    let willAutofocusId = null;
    if (elementWithAutofocus) {
        if (elementWithAutofocus.id) willAutofocusId = elementWithAutofocus.id;
        else willAutofocusId = generatedID;
        elementWithAutofocus.id = willAutofocusId;
    }
    callback();
    await $fb0d47f64ee363ae$var$nextRepaint();
    const hasNoActiveElement = document.activeElement == null || document.activeElement == document.body;
    if (hasNoActiveElement && willAutofocusId) {
        const elementToAutofocus = document.getElementById(willAutofocusId);
        if ($fb0d47f64ee363ae$var$elementIsFocusable(elementToAutofocus)) elementToAutofocus.focus();
        if (elementToAutofocus && elementToAutofocus.id == generatedID) elementToAutofocus.removeAttribute("id");
    }
}
async function $fb0d47f64ee363ae$var$withPreservedFocus(callback) {
    const [activeElementBeforeRender, activeElementAfterRender] = await $fb0d47f64ee363ae$var$around(callback, ()=>document.activeElement);
    const restoreFocusTo = activeElementBeforeRender && activeElementBeforeRender.id;
    if (restoreFocusTo) {
        const elementToFocus = document.getElementById(restoreFocusTo);
        if ($fb0d47f64ee363ae$var$elementIsFocusable(elementToFocus) && elementToFocus != activeElementAfterRender) elementToFocus.focus();
    }
}
function $fb0d47f64ee363ae$var$firstAutofocusableElementInStreams(nodeListOfStreamElements) {
    for (const streamElement of nodeListOfStreamElements){
        const elementWithAutofocus = $fb0d47f64ee363ae$var$queryAutofocusableElement(streamElement.templateElement.content);
        if (elementWithAutofocus) return elementWithAutofocus;
    }
    return null;
}
class $fb0d47f64ee363ae$var$StreamObserver {
    sources = new Set();
    #started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.#started) {
            this.#started = true;
            addEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    stop() {
        if (this.#started) {
            this.#started = false;
            removeEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    connectStreamSource(source) {
        if (!this.streamSourceIsConnected(source)) {
            this.sources.add(source);
            source.addEventListener("message", this.receiveMessageEvent, false);
        }
    }
    disconnectStreamSource(source) {
        if (this.streamSourceIsConnected(source)) {
            this.sources.delete(source);
            source.removeEventListener("message", this.receiveMessageEvent, false);
        }
    }
    streamSourceIsConnected(source) {
        return this.sources.has(source);
    }
    inspectFetchResponse = (event)=>{
        const response = $fb0d47f64ee363ae$var$fetchResponseFromEvent(event);
        if (response && $fb0d47f64ee363ae$var$fetchResponseIsStream(response)) {
            event.preventDefault();
            this.receiveMessageResponse(response);
        }
    };
    receiveMessageEvent = (event)=>{
        if (this.#started && typeof event.data == "string") this.receiveMessageHTML(event.data);
    };
    async receiveMessageResponse(response) {
        const html = await response.responseHTML;
        if (html) this.receiveMessageHTML(html);
    }
    receiveMessageHTML(html) {
        this.delegate.receivedMessageFromStream($fb0d47f64ee363ae$var$StreamMessage.wrap(html));
    }
}
function $fb0d47f64ee363ae$var$fetchResponseFromEvent(event) {
    const fetchResponse = event.detail?.fetchResponse;
    if (fetchResponse instanceof $fb0d47f64ee363ae$export$3ae09bba5b6b906e) return fetchResponse;
}
function $fb0d47f64ee363ae$var$fetchResponseIsStream(response) {
    const contentType = response.contentType ?? "";
    return contentType.startsWith($fb0d47f64ee363ae$var$StreamMessage.contentType);
}
class $fb0d47f64ee363ae$var$ErrorRenderer extends $fb0d47f64ee363ae$var$Renderer {
    static renderElement(currentElement, newElement) {
        const { documentElement: documentElement, body: body } = document;
        documentElement.replaceChild(newElement, body);
    }
    async render() {
        this.replaceHeadAndBody();
        this.activateScriptElements();
    }
    replaceHeadAndBody() {
        const { documentElement: documentElement, head: head } = document;
        documentElement.replaceChild(this.newHead, head);
        this.renderElement(this.currentElement, this.newElement);
    }
    activateScriptElements() {
        for (const replaceableElement of this.scriptElements){
            const parentNode = replaceableElement.parentNode;
            if (parentNode) {
                const element = $fb0d47f64ee363ae$var$activateScriptElement(replaceableElement);
                parentNode.replaceChild(element, replaceableElement);
            }
        }
    }
    get newHead() {
        return this.newSnapshot.headSnapshot.element;
    }
    get scriptElements() {
        return document.documentElement.querySelectorAll("script");
    }
}
class $fb0d47f64ee363ae$export$ac9642242cf7b3ce extends $fb0d47f64ee363ae$var$Renderer {
    static renderElement(currentElement, newElement) {
        if (document.body && newElement instanceof HTMLBodyElement) document.body.replaceWith(newElement);
        else document.documentElement.appendChild(newElement);
    }
    get shouldRender() {
        return this.newSnapshot.isVisitable && this.trackedElementsAreIdentical;
    }
    get reloadReason() {
        if (!this.newSnapshot.isVisitable) return {
            reason: "turbo_visit_control_is_reload"
        };
        if (!this.trackedElementsAreIdentical) return {
            reason: "tracked_element_mismatch"
        };
    }
    async prepareToRender() {
        this.#setLanguage();
        await this.mergeHead();
    }
    async render() {
        if (this.willRender) await this.replaceBody();
    }
    finishRendering() {
        super.finishRendering();
        if (!this.isPreview) this.focusFirstAutofocusableElement();
    }
    get currentHeadSnapshot() {
        return this.currentSnapshot.headSnapshot;
    }
    get newHeadSnapshot() {
        return this.newSnapshot.headSnapshot;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    #setLanguage() {
        const { documentElement: documentElement } = this.currentSnapshot;
        const { dir: dir, lang: lang } = this.newSnapshot;
        if (lang) documentElement.setAttribute("lang", lang);
        else documentElement.removeAttribute("lang");
        if (dir) documentElement.setAttribute("dir", dir);
        else documentElement.removeAttribute("dir");
    }
    async mergeHead() {
        const mergedHeadElements = this.mergeProvisionalElements();
        const newStylesheetElements = this.copyNewHeadStylesheetElements();
        this.copyNewHeadScriptElements();
        await mergedHeadElements;
        await newStylesheetElements;
        if (this.willRender) this.removeUnusedDynamicStylesheetElements();
    }
    async replaceBody() {
        await this.preservingPermanentElements(async ()=>{
            this.activateNewBody();
            await this.assignNewBody();
        });
    }
    get trackedElementsAreIdentical() {
        return this.currentHeadSnapshot.trackedElementSignature == this.newHeadSnapshot.trackedElementSignature;
    }
    async copyNewHeadStylesheetElements() {
        const loadingElements = [];
        for (const element of this.newHeadStylesheetElements){
            loadingElements.push($fb0d47f64ee363ae$var$waitForLoad(element));
            document.head.appendChild(element);
        }
        await Promise.all(loadingElements);
    }
    copyNewHeadScriptElements() {
        for (const element of this.newHeadScriptElements)document.head.appendChild($fb0d47f64ee363ae$var$activateScriptElement(element));
    }
    removeUnusedDynamicStylesheetElements() {
        for (const element of this.unusedDynamicStylesheetElements)document.head.removeChild(element);
    }
    async mergeProvisionalElements() {
        const newHeadElements = [
            ...this.newHeadProvisionalElements
        ];
        for (const element of this.currentHeadProvisionalElements)if (!this.isCurrentElementInElementList(element, newHeadElements)) document.head.removeChild(element);
        for (const element of newHeadElements)document.head.appendChild(element);
    }
    isCurrentElementInElementList(element, elementList) {
        for (const [index, newElement] of elementList.entries()){
            // if title element...
            if (element.tagName == "TITLE") {
                if (newElement.tagName != "TITLE") continue;
                if (element.innerHTML == newElement.innerHTML) {
                    elementList.splice(index, 1);
                    return true;
                }
            }
            // if any other element...
            if (newElement.isEqualNode(element)) {
                elementList.splice(index, 1);
                return true;
            }
        }
        return false;
    }
    removeCurrentHeadProvisionalElements() {
        for (const element of this.currentHeadProvisionalElements)document.head.removeChild(element);
    }
    copyNewHeadProvisionalElements() {
        for (const element of this.newHeadProvisionalElements)document.head.appendChild(element);
    }
    activateNewBody() {
        document.adoptNode(this.newElement);
        this.removeNoscriptElements();
        this.activateNewBodyScriptElements();
    }
    removeNoscriptElements() {
        for (const noscriptElement of this.newElement.querySelectorAll("noscript"))noscriptElement.remove();
    }
    activateNewBodyScriptElements() {
        for (const inertScriptElement of this.newBodyScriptElements){
            const activatedScriptElement = $fb0d47f64ee363ae$var$activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    async assignNewBody() {
        await this.renderElement(this.currentElement, this.newElement);
    }
    get unusedDynamicStylesheetElements() {
        return this.oldHeadStylesheetElements.filter((element)=>{
            return element.getAttribute("data-turbo-track") === "dynamic";
        });
    }
    get oldHeadStylesheetElements() {
        return this.currentHeadSnapshot.getStylesheetElementsNotInSnapshot(this.newHeadSnapshot);
    }
    get newHeadStylesheetElements() {
        return this.newHeadSnapshot.getStylesheetElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get newHeadScriptElements() {
        return this.newHeadSnapshot.getScriptElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get currentHeadProvisionalElements() {
        return this.currentHeadSnapshot.provisionalElements;
    }
    get newHeadProvisionalElements() {
        return this.newHeadSnapshot.provisionalElements;
    }
    get newBodyScriptElements() {
        return this.newElement.querySelectorAll("script");
    }
}
class $fb0d47f64ee363ae$var$MorphingPageRenderer extends $fb0d47f64ee363ae$export$ac9642242cf7b3ce {
    static renderElement(currentElement, newElement) {
        $fb0d47f64ee363ae$export$dc74801294c91b10(currentElement, newElement, {
            callbacks: {
                beforeNodeMorphed: (node, newNode)=>{
                    if ($fb0d47f64ee363ae$var$shouldRefreshFrameWithMorphing(node, newNode) && !$fb0d47f64ee363ae$var$closestFrameReloadableWithMorphing(node)) {
                        node.reload();
                        return false;
                    }
                    return true;
                }
            }
        });
        $fb0d47f64ee363ae$var$dispatch("turbo:morph", {
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
    }
    async preservingPermanentElements(callback) {
        return await callback();
    }
    get renderMethod() {
        return "morph";
    }
    get shouldAutofocus() {
        return false;
    }
}
class $fb0d47f64ee363ae$var$SnapshotCache extends $fb0d47f64ee363ae$var$LRUCache {
    constructor(size){
        super(size, $fb0d47f64ee363ae$var$toCacheKey);
    }
    get snapshots() {
        return this.entries;
    }
}
class $fb0d47f64ee363ae$var$PageView extends $fb0d47f64ee363ae$var$View {
    snapshotCache = new $fb0d47f64ee363ae$var$SnapshotCache(10);
    lastRenderedLocation = new URL(location.href);
    forceReloaded = false;
    shouldTransitionTo(newSnapshot) {
        return this.snapshot.prefersViewTransitions && newSnapshot.prefersViewTransitions;
    }
    renderPage(snapshot, isPreview = false, willRender = true, visit) {
        const shouldMorphPage = this.isPageRefresh(visit) && (visit?.refresh?.method || this.snapshot.refreshMethod) === "morph";
        const rendererClass = shouldMorphPage ? $fb0d47f64ee363ae$var$MorphingPageRenderer : $fb0d47f64ee363ae$export$ac9642242cf7b3ce;
        const renderer = new rendererClass(this.snapshot, snapshot, isPreview, willRender);
        if (!renderer.shouldRender) this.forceReloaded = true;
        else visit?.changeHistory();
        return this.render(renderer);
    }
    renderError(snapshot, visit) {
        visit?.changeHistory();
        const renderer = new $fb0d47f64ee363ae$var$ErrorRenderer(this.snapshot, snapshot, false);
        return this.render(renderer);
    }
    clearSnapshotCache() {
        this.snapshotCache.clear();
    }
    async cacheSnapshot(snapshot = this.snapshot) {
        if (snapshot.isCacheable) {
            this.delegate.viewWillCacheSnapshot();
            const { lastRenderedLocation: location1 } = this;
            await $fb0d47f64ee363ae$var$nextEventLoopTick();
            const cachedSnapshot = snapshot.clone();
            this.snapshotCache.put(location1, cachedSnapshot);
            return cachedSnapshot;
        }
    }
    getCachedSnapshotForLocation(location1) {
        return this.snapshotCache.get(location1);
    }
    isPageRefresh(visit) {
        return !visit || this.lastRenderedLocation.pathname === visit.location.pathname && visit.action === "replace";
    }
    shouldPreserveScrollPosition(visit) {
        return this.isPageRefresh(visit) && (visit?.refresh?.scroll || this.snapshot.refreshScroll) === "preserve";
    }
    get snapshot() {
        return $fb0d47f64ee363ae$export$4f11b95e473fd113.fromElement(this.element);
    }
}
class $fb0d47f64ee363ae$var$Preloader {
    selector = "a[data-turbo-preload]";
    constructor(delegate, snapshotCache){
        this.delegate = delegate;
        this.snapshotCache = snapshotCache;
    }
    start() {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", this.#preloadAll);
        else this.preloadOnLoadLinksForView(document.body);
    }
    stop() {
        document.removeEventListener("DOMContentLoaded", this.#preloadAll);
    }
    preloadOnLoadLinksForView(element) {
        for (const link of element.querySelectorAll(this.selector))if (this.delegate.shouldPreloadLink(link)) this.preloadURL(link);
    }
    async preloadURL(link) {
        const location1 = new URL(link.href);
        if (this.snapshotCache.has(location1)) return;
        const fetchRequest = new $fb0d47f64ee363ae$export$319b96fe59834522(this, $fb0d47f64ee363ae$export$76f6869e29ff06ee.get, location1, new URLSearchParams(), link);
        await fetchRequest.perform();
    }
    // Fetch request delegate
    prepareRequest(fetchRequest) {
        fetchRequest.headers["X-Sec-Purpose"] = "prefetch";
    }
    async requestSucceededWithResponse(fetchRequest, fetchResponse) {
        try {
            const responseHTML = await fetchResponse.responseHTML;
            const snapshot = $fb0d47f64ee363ae$export$4f11b95e473fd113.fromHTMLString(responseHTML);
            this.snapshotCache.put(fetchRequest.url, snapshot);
        } catch (_) {
        // If we cannot preload that is ok!
        }
    }
    requestStarted(fetchRequest) {}
    requestErrored(fetchRequest) {}
    requestFinished(fetchRequest) {}
    requestPreventedHandlingResponse(fetchRequest, fetchResponse) {}
    requestFailedWithResponse(fetchRequest, fetchResponse) {}
    #preloadAll = ()=>{
        this.preloadOnLoadLinksForView(document.body);
    };
}
class $fb0d47f64ee363ae$var$Cache {
    constructor(session){
        this.session = session;
    }
    clear() {
        this.session.clearCache();
    }
    resetCacheControl() {
        this.#setCacheControl("");
    }
    exemptPageFromCache() {
        this.#setCacheControl("no-cache");
    }
    exemptPageFromPreview() {
        this.#setCacheControl("no-preview");
    }
    #setCacheControl(value) {
        $fb0d47f64ee363ae$var$setMetaContent("turbo-cache-control", value);
    }
}
class $fb0d47f64ee363ae$var$Session {
    navigator = new $fb0d47f64ee363ae$var$Navigator(this);
    history = new $fb0d47f64ee363ae$var$History(this);
    view = new $fb0d47f64ee363ae$var$PageView(this, document.documentElement);
    adapter = new $fb0d47f64ee363ae$var$BrowserAdapter(this);
    pageObserver = new $fb0d47f64ee363ae$var$PageObserver(this);
    cacheObserver = new $fb0d47f64ee363ae$var$CacheObserver();
    linkPrefetchObserver = new $fb0d47f64ee363ae$var$LinkPrefetchObserver(this, document);
    linkClickObserver = new $fb0d47f64ee363ae$var$LinkClickObserver(this, window);
    formSubmitObserver = new $fb0d47f64ee363ae$var$FormSubmitObserver(this, document);
    scrollObserver = new $fb0d47f64ee363ae$var$ScrollObserver(this);
    streamObserver = new $fb0d47f64ee363ae$var$StreamObserver(this);
    formLinkClickObserver = new $fb0d47f64ee363ae$var$FormLinkClickObserver(this, document.documentElement);
    frameRedirector = new $fb0d47f64ee363ae$var$FrameRedirector(this, document.documentElement);
    streamMessageRenderer = new $fb0d47f64ee363ae$var$StreamMessageRenderer();
    cache = new $fb0d47f64ee363ae$var$Cache(this);
    enabled = true;
    started = false;
    #pageRefreshDebouncePeriod = 150;
    constructor(recentRequests){
        this.recentRequests = recentRequests;
        this.preloader = new $fb0d47f64ee363ae$var$Preloader(this, this.view.snapshotCache);
        this.debouncedRefresh = this.refresh;
        this.pageRefreshDebouncePeriod = this.pageRefreshDebouncePeriod;
    }
    start() {
        if (!this.started) {
            this.pageObserver.start();
            this.cacheObserver.start();
            this.linkPrefetchObserver.start();
            this.formLinkClickObserver.start();
            this.linkClickObserver.start();
            this.formSubmitObserver.start();
            this.scrollObserver.start();
            this.streamObserver.start();
            this.frameRedirector.start();
            this.history.start();
            this.preloader.start();
            this.started = true;
            this.enabled = true;
        }
    }
    disable() {
        this.enabled = false;
    }
    stop() {
        if (this.started) {
            this.pageObserver.stop();
            this.cacheObserver.stop();
            this.linkPrefetchObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkClickObserver.stop();
            this.formSubmitObserver.stop();
            this.scrollObserver.stop();
            this.streamObserver.stop();
            this.frameRedirector.stop();
            this.history.stop();
            this.preloader.stop();
            this.started = false;
        }
    }
    registerAdapter(adapter) {
        this.adapter = adapter;
    }
    visit(location1, options = {}) {
        const frameElement = options.frame ? document.getElementById(options.frame) : null;
        if (frameElement instanceof $fb0d47f64ee363ae$export$f464a8f0ffa32c44) {
            const action = options.action || $fb0d47f64ee363ae$var$getVisitAction(frameElement);
            frameElement.delegate.proposeVisitIfNavigatedWithAction(frameElement, action);
            frameElement.src = location1.toString();
        } else this.navigator.proposeVisit($fb0d47f64ee363ae$var$expandURL(location1), options);
    }
    refresh(url, options = {}) {
        options = typeof options === "string" ? {
            requestId: options
        } : options;
        const { method: method, requestId: requestId, scroll: scroll } = options;
        const isRecentRequest = requestId && this.recentRequests.has(requestId);
        const isCurrentUrl = url === document.baseURI;
        if (!isRecentRequest && !this.navigator.currentVisit && isCurrentUrl) this.visit(url, {
            action: "replace",
            shouldCacheSnapshot: false,
            refresh: {
                method: method,
                scroll: scroll
            }
        });
    }
    connectStreamSource(source) {
        this.streamObserver.connectStreamSource(source);
    }
    disconnectStreamSource(source) {
        this.streamObserver.disconnectStreamSource(source);
    }
    renderStreamMessage(message) {
        this.streamMessageRenderer.render($fb0d47f64ee363ae$var$StreamMessage.wrap(message));
    }
    clearCache() {
        this.view.clearSnapshotCache();
    }
    setProgressBarDelay(delay) {
        console.warn("Please replace `session.setProgressBarDelay(delay)` with `session.progressBarDelay = delay`. The function is deprecated and will be removed in a future version of Turbo.`");
        this.progressBarDelay = delay;
    }
    set progressBarDelay(delay) {
        $fb0d47f64ee363ae$export$e506a1d27d1eaa20.drive.progressBarDelay = delay;
    }
    get progressBarDelay() {
        return $fb0d47f64ee363ae$export$e506a1d27d1eaa20.drive.progressBarDelay;
    }
    set drive(value) {
        $fb0d47f64ee363ae$export$e506a1d27d1eaa20.drive.enabled = value;
    }
    get drive() {
        return $fb0d47f64ee363ae$export$e506a1d27d1eaa20.drive.enabled;
    }
    set formMode(value) {
        $fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.mode = value;
    }
    get formMode() {
        return $fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.mode;
    }
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    get pageRefreshDebouncePeriod() {
        return this.#pageRefreshDebouncePeriod;
    }
    set pageRefreshDebouncePeriod(value) {
        this.refresh = $fb0d47f64ee363ae$var$debounce(this.debouncedRefresh.bind(this), value);
        this.#pageRefreshDebouncePeriod = value;
    }
    // Preloader delegate
    shouldPreloadLink(element) {
        const isUnsafe = element.hasAttribute("data-turbo-method");
        const isStream = element.hasAttribute("data-turbo-stream");
        const frameTarget = element.getAttribute("data-turbo-frame");
        const frame = frameTarget == "_top" ? null : document.getElementById(frameTarget) || $fb0d47f64ee363ae$var$findClosestRecursively(element, "turbo-frame:not([disabled])");
        if (isUnsafe || isStream || frame instanceof $fb0d47f64ee363ae$export$f464a8f0ffa32c44) return false;
        else {
            const location1 = new URL(element.href);
            return this.elementIsNavigatable(element) && $fb0d47f64ee363ae$var$locationIsVisitable(location1, this.snapshot.rootLocation);
        }
    }
    // History delegate
    historyPoppedToLocationWithRestorationIdentifierAndDirection(location1, restorationIdentifier, direction) {
        if (this.enabled) this.navigator.startVisit(location1, restorationIdentifier, {
            action: "restore",
            historyChanged: true,
            direction: direction
        });
        else this.adapter.pageInvalidated({
            reason: "turbo_disabled"
        });
    }
    historyPoppedWithEmptyState(location1) {
        this.history.replace(location1);
        this.view.lastRenderedLocation = location1;
        this.view.cacheSnapshot();
    }
    // Scroll observer delegate
    scrollPositionChanged(position) {
        this.history.updateRestorationData({
            scrollPosition: position
        });
    }
    // Form click observer delegate
    willSubmitFormLinkToLocation(link, location1) {
        return this.elementIsNavigatable(link) && $fb0d47f64ee363ae$var$locationIsVisitable(location1, this.snapshot.rootLocation);
    }
    submittedFormLinkToLocation() {}
    // Link hover observer delegate
    canPrefetchRequestToLocation(link, location1) {
        return this.elementIsNavigatable(link) && $fb0d47f64ee363ae$var$locationIsVisitable(location1, this.snapshot.rootLocation) && this.navigator.linkPrefetchingIsEnabledForLocation(location1);
    }
    // Link click observer delegate
    willFollowLinkToLocation(link, location1, event) {
        return this.elementIsNavigatable(link) && $fb0d47f64ee363ae$var$locationIsVisitable(location1, this.snapshot.rootLocation) && this.applicationAllowsFollowingLinkToLocation(link, location1, event);
    }
    followedLinkToLocation(link, location1) {
        const action = this.getActionForLink(link);
        const acceptsStreamResponse = link.hasAttribute("data-turbo-stream");
        this.visit(location1.href, {
            action: action,
            acceptsStreamResponse: acceptsStreamResponse
        });
    }
    // Navigator delegate
    allowsVisitingLocationWithAction(location1, action) {
        return this.applicationAllowsVisitingLocation(location1);
    }
    visitProposedToLocation(location1, options) {
        $fb0d47f64ee363ae$var$extendURLWithDeprecatedProperties(location1);
        this.adapter.visitProposedToLocation(location1, options);
    }
    // Visit delegate
    visitStarted(visit) {
        if (!visit.acceptsStreamResponse) {
            $fb0d47f64ee363ae$var$markAsBusy(document.documentElement);
            this.view.markVisitDirection(visit.direction);
        }
        $fb0d47f64ee363ae$var$extendURLWithDeprecatedProperties(visit.location);
        this.notifyApplicationAfterVisitingLocation(visit.location, visit.action);
    }
    visitCompleted(visit) {
        this.view.unmarkVisitDirection();
        $fb0d47f64ee363ae$var$clearBusyState(document.documentElement);
        this.notifyApplicationAfterPageLoad(visit.getTimingMetrics());
    }
    // Form submit observer delegate
    willSubmitForm(form, submitter) {
        const action = $fb0d47f64ee363ae$var$getAction$1(form, submitter);
        return this.submissionIsNavigatable(form, submitter) && $fb0d47f64ee363ae$var$locationIsVisitable($fb0d47f64ee363ae$var$expandURL(action), this.snapshot.rootLocation);
    }
    formSubmitted(form, submitter) {
        this.navigator.submitForm(form, submitter);
    }
    // Page observer delegate
    pageBecameInteractive() {
        this.view.lastRenderedLocation = this.location;
        this.notifyApplicationAfterPageLoad();
    }
    pageLoaded() {
        this.history.assumeControlOfScrollRestoration();
    }
    pageWillUnload() {
        this.history.relinquishControlOfScrollRestoration();
    }
    // Stream observer delegate
    receivedMessageFromStream(message) {
        this.renderStreamMessage(message);
    }
    // Page view delegate
    viewWillCacheSnapshot() {
        this.notifyApplicationBeforeCachingSnapshot();
    }
    allowsImmediateRender({ element: element }, options) {
        const event = this.notifyApplicationBeforeRender(element, options);
        const { defaultPrevented: defaultPrevented, detail: { render: render } } = event;
        if (this.view.renderer && render) this.view.renderer.renderElement = render;
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview, renderMethod) {
        this.view.lastRenderedLocation = this.history.location;
        this.notifyApplicationAfterRender(renderMethod);
    }
    preloadOnLoadLinksForView(element) {
        this.preloader.preloadOnLoadLinksForView(element);
    }
    viewInvalidated(reason) {
        this.adapter.pageInvalidated(reason);
    }
    // Frame element
    frameLoaded(frame) {
        this.notifyApplicationAfterFrameLoad(frame);
    }
    frameRendered(fetchResponse, frame) {
        this.notifyApplicationAfterFrameRender(fetchResponse, frame);
    }
    // Application events
    applicationAllowsFollowingLinkToLocation(link, location1, ev) {
        const event = this.notifyApplicationAfterClickingLinkToLocation(link, location1, ev);
        return !event.defaultPrevented;
    }
    applicationAllowsVisitingLocation(location1) {
        const event = this.notifyApplicationBeforeVisitingLocation(location1);
        return !event.defaultPrevented;
    }
    notifyApplicationAfterClickingLinkToLocation(link, location1, event) {
        return $fb0d47f64ee363ae$var$dispatch("turbo:click", {
            target: link,
            detail: {
                url: location1.href,
                originalEvent: event
            },
            cancelable: true
        });
    }
    notifyApplicationBeforeVisitingLocation(location1) {
        return $fb0d47f64ee363ae$var$dispatch("turbo:before-visit", {
            detail: {
                url: location1.href
            },
            cancelable: true
        });
    }
    notifyApplicationAfterVisitingLocation(location1, action) {
        return $fb0d47f64ee363ae$var$dispatch("turbo:visit", {
            detail: {
                url: location1.href,
                action: action
            }
        });
    }
    notifyApplicationBeforeCachingSnapshot() {
        return $fb0d47f64ee363ae$var$dispatch("turbo:before-cache");
    }
    notifyApplicationBeforeRender(newBody, options) {
        return $fb0d47f64ee363ae$var$dispatch("turbo:before-render", {
            detail: {
                newBody: newBody,
                ...options
            },
            cancelable: true
        });
    }
    notifyApplicationAfterRender(renderMethod) {
        return $fb0d47f64ee363ae$var$dispatch("turbo:render", {
            detail: {
                renderMethod: renderMethod
            }
        });
    }
    notifyApplicationAfterPageLoad(timing = {}) {
        return $fb0d47f64ee363ae$var$dispatch("turbo:load", {
            detail: {
                url: this.location.href,
                timing: timing
            }
        });
    }
    notifyApplicationAfterFrameLoad(frame) {
        return $fb0d47f64ee363ae$var$dispatch("turbo:frame-load", {
            target: frame
        });
    }
    notifyApplicationAfterFrameRender(fetchResponse, frame) {
        return $fb0d47f64ee363ae$var$dispatch("turbo:frame-render", {
            detail: {
                fetchResponse: fetchResponse
            },
            target: frame,
            cancelable: true
        });
    }
    // Helpers
    submissionIsNavigatable(form, submitter) {
        if ($fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.mode == "off") return false;
        else {
            const submitterIsNavigatable = submitter ? this.elementIsNavigatable(submitter) : true;
            if ($fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.mode == "optin") return submitterIsNavigatable && form.closest('[data-turbo="true"]') != null;
            else return submitterIsNavigatable && this.elementIsNavigatable(form);
        }
    }
    elementIsNavigatable(element) {
        const container = $fb0d47f64ee363ae$var$findClosestRecursively(element, "[data-turbo]");
        const withinFrame = $fb0d47f64ee363ae$var$findClosestRecursively(element, "turbo-frame");
        // Check if Drive is enabled on the session or we're within a Frame.
        if ($fb0d47f64ee363ae$export$e506a1d27d1eaa20.drive.enabled || withinFrame) {
            // Element is navigatable by default, unless `data-turbo="false"`.
            if (container) return container.getAttribute("data-turbo") != "false";
            else return true;
        } else {
            // Element isn't navigatable by default, unless `data-turbo="true"`.
            if (container) return container.getAttribute("data-turbo") == "true";
            else return false;
        }
    }
    // Private
    getActionForLink(link) {
        return $fb0d47f64ee363ae$var$getVisitAction(link) || "advance";
    }
    get snapshot() {
        return this.view.snapshot;
    }
}
// Older versions of the Turbo Native adapters referenced the
// `Location#absoluteURL` property in their implementations of
// the `Adapter#visitProposedToLocation()` and `#visitStarted()`
// methods. The Location class has since been removed in favor
// of the DOM URL API, and accordingly all Adapter methods now
// receive URL objects.
//
// We alias #absoluteURL to #toString() here to avoid crashing
// older adapters which do not expect URL objects. We should
// consider removing this support at some point in the future.
function $fb0d47f64ee363ae$var$extendURLWithDeprecatedProperties(url) {
    Object.defineProperties(url, $fb0d47f64ee363ae$var$deprecatedLocationPropertyDescriptors);
}
const $fb0d47f64ee363ae$var$deprecatedLocationPropertyDescriptors = {
    absoluteURL: {
        get () {
            return this.toString();
        }
    }
};
const $fb0d47f64ee363ae$export$55427e926be628d4 = new $fb0d47f64ee363ae$var$Session($fb0d47f64ee363ae$var$recentRequests);
// Rename `navigator` to avoid shadowing `window.navigator`
const { cache: $fb0d47f64ee363ae$export$69a3209f1a06c04d, navigator: $fb0d47f64ee363ae$export$ec7c8efa7f5790ae } = $fb0d47f64ee363ae$export$55427e926be628d4;
/**
 * Starts the main session.
 * This initialises any necessary observers such as those to monitor
 * link interactions.
 */ function $fb0d47f64ee363ae$export$b3571188c770cc5a() {
    $fb0d47f64ee363ae$export$55427e926be628d4.start();
}
/**
 * Registers an adapter for the main session.
 *
 * @param adapter Adapter to register
 */ function $fb0d47f64ee363ae$export$ddf4d3602a252674(adapter) {
    $fb0d47f64ee363ae$export$55427e926be628d4.registerAdapter(adapter);
}
/**
 * Performs an application visit to the given location.
 *
 * @param location Location to visit (a URL or path)
 * @param options Options to apply
 * @param options.action Type of history navigation to apply ("restore",
 * "replace" or "advance")
 * @param options.historyChanged Specifies whether the browser history has
 * already been changed for this visit or not
 * @param options.referrer Specifies the referrer of this visit such that
 * navigations to the same page will not result in a new history entry.
 * @param options.snapshotHTML Cached snapshot to render
 * @param options.response Response of the specified location
 */ function $fb0d47f64ee363ae$export$bf638b60ea8b89b7(location1, options) {
    $fb0d47f64ee363ae$export$55427e926be628d4.visit(location1, options);
}
/**
 * Connects a stream source to the main session.
 *
 * @param source Stream source to connect
 */ function $fb0d47f64ee363ae$export$83667c2845c80463(source) {
    $fb0d47f64ee363ae$export$55427e926be628d4.connectStreamSource(source);
}
/**
 * Disconnects a stream source from the main session.
 *
 * @param source Stream source to disconnect
 */ function $fb0d47f64ee363ae$export$26c56c74e3b67c59(source) {
    $fb0d47f64ee363ae$export$55427e926be628d4.disconnectStreamSource(source);
}
/**
 * Renders a stream message to the main session by appending it to the
 * current document.
 *
 * @param message Message to render
 */ function $fb0d47f64ee363ae$export$ebdee272e46e11d9(message) {
    $fb0d47f64ee363ae$export$55427e926be628d4.renderStreamMessage(message);
}
/**
 * Sets the delay after which the progress bar will appear during navigation.
 *
 * The progress bar appears after 500ms by default.
 *
 * Note that this method has no effect when used with the iOS or Android
 * adapters.
 *
 * @param delay Time to delay in milliseconds
 */ function $fb0d47f64ee363ae$export$ddcc6947144c476c(delay) {
    console.warn("Please replace `Turbo.setProgressBarDelay(delay)` with `Turbo.config.drive.progressBarDelay = delay`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $fb0d47f64ee363ae$export$e506a1d27d1eaa20.drive.progressBarDelay = delay;
}
function $fb0d47f64ee363ae$export$4696f1315e6aae7c(confirmMethod) {
    console.warn("Please replace `Turbo.setConfirmMethod(confirmMethod)` with `Turbo.config.forms.confirm = confirmMethod`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.confirm = confirmMethod;
}
function $fb0d47f64ee363ae$export$a94cfbb71d90abbd(mode) {
    console.warn("Please replace `Turbo.setFormMode(mode)` with `Turbo.config.forms.mode = mode`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $fb0d47f64ee363ae$export$e506a1d27d1eaa20.forms.mode = mode;
}
/**
 * Morph the state of the currentBody based on the attributes and contents of
 * the newBody. Morphing body elements may dispatch turbo:morph,
 * turbo:before-morph-element, turbo:before-morph-attribute, and
 * turbo:morph-element events.
 *
 * @param currentBody HTMLBodyElement destination of morphing changes
 * @param newBody HTMLBodyElement source of morphing changes
 */ function $fb0d47f64ee363ae$export$3692fe532534b56a(currentBody, newBody) {
    $fb0d47f64ee363ae$var$MorphingPageRenderer.renderElement(currentBody, newBody);
}
/**
 * Morph the child elements of the currentFrame based on the child elements of
 * the newFrame. Morphing turbo-frame elements may dispatch turbo:before-frame-morph,
 * turbo:before-morph-element, turbo:before-morph-attribute, and
 * turbo:morph-element events.
 *
 * @param currentFrame FrameElement destination of morphing children changes
 * @param newFrame FrameElement source of morphing children changes
 */ function $fb0d47f64ee363ae$export$e23c491af5621dca(currentFrame, newFrame) {
    $fb0d47f64ee363ae$var$MorphingFrameRenderer.renderElement(currentFrame, newFrame);
}
var $fb0d47f64ee363ae$var$Turbo = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    PageRenderer: $fb0d47f64ee363ae$export$ac9642242cf7b3ce,
    PageSnapshot: $fb0d47f64ee363ae$export$4f11b95e473fd113,
    FrameRenderer: $fb0d47f64ee363ae$export$f09c4165d16bb2b7,
    fetch: $fb0d47f64ee363ae$export$e7aa7bc5c1b3cfb3,
    config: $fb0d47f64ee363ae$export$e506a1d27d1eaa20,
    session: $fb0d47f64ee363ae$export$55427e926be628d4,
    cache: $fb0d47f64ee363ae$export$69a3209f1a06c04d,
    navigator: $fb0d47f64ee363ae$export$ec7c8efa7f5790ae,
    start: $fb0d47f64ee363ae$export$b3571188c770cc5a,
    registerAdapter: $fb0d47f64ee363ae$export$ddf4d3602a252674,
    visit: $fb0d47f64ee363ae$export$bf638b60ea8b89b7,
    connectStreamSource: $fb0d47f64ee363ae$export$83667c2845c80463,
    disconnectStreamSource: $fb0d47f64ee363ae$export$26c56c74e3b67c59,
    renderStreamMessage: $fb0d47f64ee363ae$export$ebdee272e46e11d9,
    setProgressBarDelay: $fb0d47f64ee363ae$export$ddcc6947144c476c,
    setConfirmMethod: $fb0d47f64ee363ae$export$4696f1315e6aae7c,
    setFormMode: $fb0d47f64ee363ae$export$a94cfbb71d90abbd,
    morphBodyElements: $fb0d47f64ee363ae$export$3692fe532534b56a,
    morphTurboFrameElements: $fb0d47f64ee363ae$export$e23c491af5621dca,
    morphChildren: $fb0d47f64ee363ae$export$e0eeaf5bc84bd47b,
    morphElements: $fb0d47f64ee363ae$export$dc74801294c91b10
});
class $fb0d47f64ee363ae$var$TurboFrameMissingError extends Error {
}
class $fb0d47f64ee363ae$var$FrameController {
    fetchResponseLoaded = (_fetchResponse)=>Promise.resolve();
    #currentFetchRequest = null;
    #resolveVisitPromise = ()=>{};
    #connected = false;
    #hasBeenLoaded = false;
    #ignoredAttributes = new Set();
    #shouldMorphFrame = false;
    action = null;
    constructor(element){
        this.element = element;
        this.view = new $fb0d47f64ee363ae$var$FrameView(this, this.element);
        this.appearanceObserver = new $fb0d47f64ee363ae$var$AppearanceObserver(this, this.element);
        this.formLinkClickObserver = new $fb0d47f64ee363ae$var$FormLinkClickObserver(this, this.element);
        this.linkInterceptor = new $fb0d47f64ee363ae$var$LinkInterceptor(this, this.element);
        this.restorationIdentifier = $fb0d47f64ee363ae$var$uuid();
        this.formSubmitObserver = new $fb0d47f64ee363ae$var$FormSubmitObserver(this, this.element);
    }
    // Frame delegate
    connect() {
        if (!this.#connected) {
            this.#connected = true;
            if (this.loadingStyle == $fb0d47f64ee363ae$export$65f98fefe20dbcb6.lazy) this.appearanceObserver.start();
            else this.#loadSourceURL();
            this.formLinkClickObserver.start();
            this.linkInterceptor.start();
            this.formSubmitObserver.start();
        }
    }
    disconnect() {
        if (this.#connected) {
            this.#connected = false;
            this.appearanceObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkInterceptor.stop();
            this.formSubmitObserver.stop();
            if (!this.element.hasAttribute("recurse")) this.#currentFetchRequest?.cancel();
        }
    }
    disabledChanged() {
        if (this.disabled) this.#currentFetchRequest?.cancel();
        else if (this.loadingStyle == $fb0d47f64ee363ae$export$65f98fefe20dbcb6.eager) this.#loadSourceURL();
    }
    sourceURLChanged() {
        if (this.#isIgnoringChangesTo("src")) return;
        if (!this.sourceURL) this.#currentFetchRequest?.cancel();
        if (this.element.isConnected) this.complete = false;
        if (this.loadingStyle == $fb0d47f64ee363ae$export$65f98fefe20dbcb6.eager || this.#hasBeenLoaded) this.#loadSourceURL();
    }
    sourceURLReloaded() {
        const { refresh: refresh, src: src } = this.element;
        this.#shouldMorphFrame = src && refresh === "morph";
        this.element.removeAttribute("complete");
        this.element.src = null;
        this.element.src = src;
        return this.element.loaded;
    }
    loadingStyleChanged() {
        if (this.loadingStyle == $fb0d47f64ee363ae$export$65f98fefe20dbcb6.lazy) this.appearanceObserver.start();
        else {
            this.appearanceObserver.stop();
            this.#loadSourceURL();
        }
    }
    async #loadSourceURL() {
        if (this.enabled && this.isActive && !this.complete && this.sourceURL) {
            this.element.loaded = this.#visit($fb0d47f64ee363ae$var$expandURL(this.sourceURL));
            this.appearanceObserver.stop();
            await this.element.loaded;
            this.#hasBeenLoaded = true;
        }
    }
    async loadResponse(fetchResponse) {
        if (fetchResponse.redirected || fetchResponse.succeeded && fetchResponse.isHTML) this.sourceURL = fetchResponse.response.url;
        try {
            const html = await fetchResponse.responseHTML;
            if (html) {
                const document1 = $fb0d47f64ee363ae$var$parseHTMLDocument(html);
                const pageSnapshot = $fb0d47f64ee363ae$export$4f11b95e473fd113.fromDocument(document1);
                if (pageSnapshot.isVisitable) await this.#loadFrameResponse(fetchResponse, document1);
                else await this.#handleUnvisitableFrameResponse(fetchResponse);
            }
        } finally{
            this.#shouldMorphFrame = false;
            this.fetchResponseLoaded = ()=>Promise.resolve();
        }
    }
    // Appearance observer delegate
    elementAppearedInViewport(element) {
        this.proposeVisitIfNavigatedWithAction(element, $fb0d47f64ee363ae$var$getVisitAction(element));
        this.#loadSourceURL();
    }
    // Form link click observer delegate
    willSubmitFormLinkToLocation(link) {
        return this.#shouldInterceptNavigation(link);
    }
    submittedFormLinkToLocation(link, _location, form) {
        const frame = this.#findFrameElement(link);
        if (frame) form.setAttribute("data-turbo-frame", frame.id);
    }
    // Link interceptor delegate
    shouldInterceptLinkClick(element, _location, _event) {
        return this.#shouldInterceptNavigation(element);
    }
    linkClickIntercepted(element, location1) {
        this.#navigateFrame(element, location1);
    }
    // Form submit observer delegate
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == this.element && this.#shouldInterceptNavigation(element, submitter);
    }
    formSubmitted(element, submitter) {
        if (this.formSubmission) this.formSubmission.stop();
        this.formSubmission = new $fb0d47f64ee363ae$var$FormSubmission(this, element, submitter);
        const { fetchRequest: fetchRequest } = this.formSubmission;
        const frame = this.#findFrameElement(element, submitter);
        this.prepareRequest(fetchRequest, frame);
        this.formSubmission.start();
    }
    // Fetch request delegate
    prepareRequest(request, frame = this) {
        request.headers["Turbo-Frame"] = frame.id;
        if (this.currentNavigationElement?.hasAttribute("data-turbo-stream")) request.acceptResponseType($fb0d47f64ee363ae$var$StreamMessage.contentType);
    }
    requestStarted(_request) {
        $fb0d47f64ee363ae$var$markAsBusy(this.element);
    }
    requestPreventedHandlingResponse(_request, _response) {
        this.#resolveVisitPromise();
    }
    async requestSucceededWithResponse(request, response) {
        await this.loadResponse(response);
        this.#resolveVisitPromise();
    }
    async requestFailedWithResponse(request, response) {
        await this.loadResponse(response);
        this.#resolveVisitPromise();
    }
    requestErrored(request, error) {
        console.error(error);
        this.#resolveVisitPromise();
    }
    requestFinished(_request) {
        $fb0d47f64ee363ae$var$clearBusyState(this.element);
    }
    // Form submission delegate
    formSubmissionStarted({ formElement: formElement }) {
        $fb0d47f64ee363ae$var$markAsBusy(formElement, this.#findFrameElement(formElement));
    }
    formSubmissionSucceededWithResponse(formSubmission, response) {
        const frame = this.#findFrameElement(formSubmission.formElement, formSubmission.submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, $fb0d47f64ee363ae$var$getVisitAction(formSubmission.submitter, formSubmission.formElement, frame));
        frame.delegate.loadResponse(response);
        if (!formSubmission.isSafe) $fb0d47f64ee363ae$export$55427e926be628d4.clearCache();
    }
    formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        this.element.delegate.loadResponse(fetchResponse);
        $fb0d47f64ee363ae$export$55427e926be628d4.clearCache();
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished({ formElement: formElement }) {
        $fb0d47f64ee363ae$var$clearBusyState(formElement, this.#findFrameElement(formElement));
    }
    // View delegate
    allowsImmediateRender({ element: newFrame }, options) {
        const event = $fb0d47f64ee363ae$var$dispatch("turbo:before-frame-render", {
            target: this.element,
            detail: {
                newFrame: newFrame,
                ...options
            },
            cancelable: true
        });
        const { defaultPrevented: defaultPrevented, detail: { render: render } } = event;
        if (this.view.renderer && render) this.view.renderer.renderElement = render;
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview, _renderMethod) {}
    preloadOnLoadLinksForView(element) {
        $fb0d47f64ee363ae$export$55427e926be628d4.preloadOnLoadLinksForView(element);
    }
    viewInvalidated() {}
    // Frame renderer delegate
    willRenderFrame(currentElement, _newElement) {
        this.previousFrameElement = currentElement.cloneNode(true);
    }
    visitCachedSnapshot = ({ element: element })=>{
        const frame = element.querySelector("#" + this.element.id);
        if (frame && this.previousFrameElement) frame.replaceChildren(...this.previousFrameElement.children);
        delete this.previousFrameElement;
    };
    // Private
    async #loadFrameResponse(fetchResponse, document1) {
        const newFrameElement = await this.extractForeignFrameElement(document1.body);
        const rendererClass = this.#shouldMorphFrame ? $fb0d47f64ee363ae$var$MorphingFrameRenderer : $fb0d47f64ee363ae$export$f09c4165d16bb2b7;
        if (newFrameElement) {
            const snapshot = new $fb0d47f64ee363ae$var$Snapshot(newFrameElement);
            const renderer = new rendererClass(this, this.view.snapshot, snapshot, false, false);
            if (this.view.renderPromise) await this.view.renderPromise;
            this.changeHistory();
            await this.view.render(renderer);
            this.complete = true;
            $fb0d47f64ee363ae$export$55427e926be628d4.frameRendered(fetchResponse, this.element);
            $fb0d47f64ee363ae$export$55427e926be628d4.frameLoaded(this.element);
            await this.fetchResponseLoaded(fetchResponse);
        } else if (this.#willHandleFrameMissingFromResponse(fetchResponse)) this.#handleFrameMissingFromResponse(fetchResponse);
    }
    async #visit(url) {
        const request = new $fb0d47f64ee363ae$export$319b96fe59834522(this, $fb0d47f64ee363ae$export$76f6869e29ff06ee.get, url, new URLSearchParams(), this.element);
        this.#currentFetchRequest?.cancel();
        this.#currentFetchRequest = request;
        return new Promise((resolve)=>{
            this.#resolveVisitPromise = ()=>{
                this.#resolveVisitPromise = ()=>{};
                this.#currentFetchRequest = null;
                resolve();
            };
            request.perform();
        });
    }
    #navigateFrame(element, url, submitter) {
        const frame = this.#findFrameElement(element, submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, $fb0d47f64ee363ae$var$getVisitAction(submitter, element, frame));
        this.#withCurrentNavigationElement(element, ()=>{
            frame.src = url;
        });
    }
    proposeVisitIfNavigatedWithAction(frame, action = null) {
        this.action = action;
        if (this.action) {
            const pageSnapshot = $fb0d47f64ee363ae$export$4f11b95e473fd113.fromElement(frame).clone();
            const { visitCachedSnapshot: visitCachedSnapshot } = frame.delegate;
            frame.delegate.fetchResponseLoaded = async (fetchResponse)=>{
                if (frame.src) {
                    const { statusCode: statusCode, redirected: redirected } = fetchResponse;
                    const responseHTML = await fetchResponse.responseHTML;
                    const response = {
                        statusCode: statusCode,
                        redirected: redirected,
                        responseHTML: responseHTML
                    };
                    const options = {
                        response: response,
                        visitCachedSnapshot: visitCachedSnapshot,
                        willRender: false,
                        updateHistory: false,
                        restorationIdentifier: this.restorationIdentifier,
                        snapshot: pageSnapshot
                    };
                    if (this.action) options.action = this.action;
                    $fb0d47f64ee363ae$export$55427e926be628d4.visit(frame.src, options);
                }
            };
        }
    }
    changeHistory() {
        if (this.action) {
            const method = $fb0d47f64ee363ae$var$getHistoryMethodForAction(this.action);
            $fb0d47f64ee363ae$export$55427e926be628d4.history.update(method, $fb0d47f64ee363ae$var$expandURL(this.element.src || ""), this.restorationIdentifier);
        }
    }
    async #handleUnvisitableFrameResponse(fetchResponse) {
        console.warn(`The response (${fetchResponse.statusCode}) from <turbo-frame id="${this.element.id}"> is performing a full page visit due to turbo-visit-control.`);
        await this.#visitResponse(fetchResponse.response);
    }
    #willHandleFrameMissingFromResponse(fetchResponse) {
        this.element.setAttribute("complete", "");
        const response = fetchResponse.response;
        const visit = async (url, options)=>{
            if (url instanceof Response) this.#visitResponse(url);
            else $fb0d47f64ee363ae$export$55427e926be628d4.visit(url, options);
        };
        const event = $fb0d47f64ee363ae$var$dispatch("turbo:frame-missing", {
            target: this.element,
            detail: {
                response: response,
                visit: visit
            },
            cancelable: true
        });
        return !event.defaultPrevented;
    }
    #handleFrameMissingFromResponse(fetchResponse) {
        this.view.missing();
        this.#throwFrameMissingError(fetchResponse);
    }
    #throwFrameMissingError(fetchResponse) {
        const message = `The response (${fetchResponse.statusCode}) did not contain the expected <turbo-frame id="${this.element.id}"> and will be ignored. To perform a full page visit instead, set turbo-visit-control to reload.`;
        throw new $fb0d47f64ee363ae$var$TurboFrameMissingError(message);
    }
    async #visitResponse(response) {
        const wrapped = new $fb0d47f64ee363ae$export$3ae09bba5b6b906e(response);
        const responseHTML = await wrapped.responseHTML;
        const { location: location1, redirected: redirected, statusCode: statusCode } = wrapped;
        return $fb0d47f64ee363ae$export$55427e926be628d4.visit(location1, {
            response: {
                redirected: redirected,
                statusCode: statusCode,
                responseHTML: responseHTML
            }
        });
    }
    #findFrameElement(element, submitter) {
        const id = $fb0d47f64ee363ae$var$getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        const target = this.#getFrameElementById(id);
        return target instanceof $fb0d47f64ee363ae$export$f464a8f0ffa32c44 ? target : this.element;
    }
    async extractForeignFrameElement(container) {
        let element;
        const id = CSS.escape(this.id);
        try {
            element = $fb0d47f64ee363ae$var$activateElement(container.querySelector(`turbo-frame#${id}`), this.sourceURL);
            if (element) return element;
            element = $fb0d47f64ee363ae$var$activateElement(container.querySelector(`turbo-frame[src][recurse~=${id}]`), this.sourceURL);
            if (element) {
                await element.loaded;
                return await this.extractForeignFrameElement(element);
            }
        } catch (error) {
            console.error(error);
            return new $fb0d47f64ee363ae$export$f464a8f0ffa32c44();
        }
        return null;
    }
    #formActionIsVisitable(form, submitter) {
        const action = $fb0d47f64ee363ae$var$getAction$1(form, submitter);
        return $fb0d47f64ee363ae$var$locationIsVisitable($fb0d47f64ee363ae$var$expandURL(action), this.rootLocation);
    }
    #shouldInterceptNavigation(element, submitter) {
        const id = $fb0d47f64ee363ae$var$getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        if (element instanceof HTMLFormElement && !this.#formActionIsVisitable(element, submitter)) return false;
        if (!this.enabled || id == "_top") return false;
        if (id) {
            const frameElement = this.#getFrameElementById(id);
            if (frameElement) return !frameElement.disabled;
            else if (id == "_parent") return false;
        }
        if (!$fb0d47f64ee363ae$export$55427e926be628d4.elementIsNavigatable(element)) return false;
        if (submitter && !$fb0d47f64ee363ae$export$55427e926be628d4.elementIsNavigatable(submitter)) return false;
        return true;
    }
    // Computed properties
    get id() {
        return this.element.id;
    }
    get disabled() {
        return this.element.disabled;
    }
    get enabled() {
        return !this.disabled;
    }
    get sourceURL() {
        if (this.element.src) return this.element.src;
    }
    set sourceURL(sourceURL) {
        this.#ignoringChangesToAttribute("src", ()=>{
            this.element.src = sourceURL ?? null;
        });
    }
    get loadingStyle() {
        return this.element.loading;
    }
    get isLoading() {
        return this.formSubmission !== undefined || this.#resolveVisitPromise() !== undefined;
    }
    get complete() {
        return this.element.hasAttribute("complete");
    }
    set complete(value) {
        if (value) this.element.setAttribute("complete", "");
        else this.element.removeAttribute("complete");
    }
    get isActive() {
        return this.element.isActive && this.#connected;
    }
    get rootLocation() {
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const root = meta?.content ?? "/";
        return $fb0d47f64ee363ae$var$expandURL(root);
    }
    #isIgnoringChangesTo(attributeName) {
        return this.#ignoredAttributes.has(attributeName);
    }
    #ignoringChangesToAttribute(attributeName, callback) {
        this.#ignoredAttributes.add(attributeName);
        callback();
        this.#ignoredAttributes.delete(attributeName);
    }
    #withCurrentNavigationElement(element, callback) {
        this.currentNavigationElement = element;
        callback();
        delete this.currentNavigationElement;
    }
    #getFrameElementById(id) {
        if (id != null) {
            const element = id === "_parent" ? this.element.parentElement.closest("turbo-frame") : document.getElementById(id);
            if (element instanceof $fb0d47f64ee363ae$export$f464a8f0ffa32c44) return element;
        }
    }
}
function $fb0d47f64ee363ae$var$activateElement(element, currentURL) {
    if (element) {
        const src = element.getAttribute("src");
        if (src != null && currentURL != null && $fb0d47f64ee363ae$var$urlsAreEqual(src, currentURL)) throw new Error(`Matching <turbo-frame id="${element.id}"> element has a source URL which references itself`);
        if (element.ownerDocument !== document) element = document.importNode(element, true);
        if (element instanceof $fb0d47f64ee363ae$export$f464a8f0ffa32c44) {
            element.connectedCallback();
            element.disconnectedCallback();
            return element;
        }
    }
}
const $fb0d47f64ee363ae$export$1b814a67c3a57eeb = {
    after () {
        this.removeDuplicateTargetSiblings();
        this.targetElements.forEach((e)=>e.parentElement?.insertBefore(this.templateContent, e.nextSibling));
    },
    append () {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e)=>e.append(this.templateContent));
    },
    before () {
        this.removeDuplicateTargetSiblings();
        this.targetElements.forEach((e)=>e.parentElement?.insertBefore(this.templateContent, e));
    },
    prepend () {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e)=>e.prepend(this.templateContent));
    },
    remove () {
        this.targetElements.forEach((e)=>e.remove());
    },
    replace () {
        const method = this.getAttribute("method");
        this.targetElements.forEach((targetElement)=>{
            if (method === "morph") $fb0d47f64ee363ae$export$dc74801294c91b10(targetElement, this.templateContent);
            else targetElement.replaceWith(this.templateContent);
        });
    },
    update () {
        const method = this.getAttribute("method");
        this.targetElements.forEach((targetElement)=>{
            if (method === "morph") $fb0d47f64ee363ae$export$e0eeaf5bc84bd47b(targetElement, this.templateContent);
            else {
                targetElement.innerHTML = "";
                targetElement.append(this.templateContent);
            }
        });
    },
    refresh () {
        const method = this.getAttribute("method");
        const requestId = this.requestId;
        const scroll = this.getAttribute("scroll");
        $fb0d47f64ee363ae$export$55427e926be628d4.refresh(this.baseURI, {
            method: method,
            requestId: requestId,
            scroll: scroll
        });
    }
};
// <turbo-stream action=replace target=id><template>...
/**
 * Renders updates to the page from a stream of messages.
 *
 * Using the `action` attribute, this can be configured one of eight ways:
 *
 * - `after` - inserts the result after the target
 * - `append` - appends the result to the target
 * - `before` - inserts the result before the target
 * - `prepend` - prepends the result to the target
 * - `refresh` - initiates a page refresh
 * - `remove` - removes the target
 * - `replace` - replaces the outer HTML of the target
 * - `update` - replaces the inner HTML of the target
 *
 * @customElement turbo-stream
 * @example
 *   <turbo-stream action="append" target="dom_id">
 *     <template>
 *       Content to append to target designated with the dom_id.
 *     </template>
 *   </turbo-stream>
 */ class $fb0d47f64ee363ae$export$144d499d37929ea8 extends HTMLElement {
    static async renderElement(newElement) {
        await newElement.performAction();
    }
    async connectedCallback() {
        try {
            await this.render();
        } catch (error) {
            console.error(error);
        } finally{
            this.disconnect();
        }
    }
    async render() {
        return this.renderPromise ??= (async ()=>{
            const event = this.beforeRenderEvent;
            if (this.dispatchEvent(event)) {
                await $fb0d47f64ee363ae$var$nextRepaint();
                await event.detail.render(this);
            }
        })();
    }
    disconnect() {
        try {
            this.remove();
        // eslint-disable-next-line no-empty
        } catch  {}
    }
    /**
   * Removes duplicate children (by ID)
   */ removeDuplicateTargetChildren() {
        this.duplicateChildren.forEach((c)=>c.remove());
    }
    /**
   * Gets the list of duplicate children (i.e. those with the same ID)
   */ get duplicateChildren() {
        const existingChildren = this.targetElements.flatMap((e)=>[
                ...e.children
            ]).filter((c)=>!!c.getAttribute("id"));
        const newChildrenIds = [
            ...this.templateContent?.children || []
        ].filter((c)=>!!c.getAttribute("id")).map((c)=>c.getAttribute("id"));
        return existingChildren.filter((c)=>newChildrenIds.includes(c.getAttribute("id")));
    }
    /**
  * Removes duplicate siblings (by ID)
  */ removeDuplicateTargetSiblings() {
        this.duplicateSiblings.forEach((c)=>c.remove());
    }
    /**
  * Gets the list of duplicate siblings (i.e. those with the same ID)
  */ get duplicateSiblings() {
        const existingChildren = this.targetElements.flatMap((e)=>[
                ...e.parentElement.children
            ]).filter((c)=>!!c.id);
        const newChildrenIds = [
            ...this.templateContent?.children || []
        ].filter((c)=>!!c.id).map((c)=>c.id);
        return existingChildren.filter((c)=>newChildrenIds.includes(c.id));
    }
    /**
   * Gets the action function to be performed.
   */ get performAction() {
        if (this.action) {
            const actionFunction = $fb0d47f64ee363ae$export$1b814a67c3a57eeb[this.action];
            if (actionFunction) return actionFunction;
            this.#raise("unknown action");
        }
        this.#raise("action attribute is missing");
    }
    /**
   * Gets the target elements which the template will be rendered to.
   */ get targetElements() {
        if (this.target) return this.targetElementsById;
        else if (this.targets) return this.targetElementsByQuery;
        else this.#raise("target or targets attribute is missing");
    }
    /**
   * Gets the contents of the main `<template>`.
   */ get templateContent() {
        return this.templateElement.content.cloneNode(true);
    }
    /**
   * Gets the main `<template>` used for rendering
   */ get templateElement() {
        if (this.firstElementChild === null) {
            const template = this.ownerDocument.createElement("template");
            this.appendChild(template);
            return template;
        } else if (this.firstElementChild instanceof HTMLTemplateElement) return this.firstElementChild;
        this.#raise("first child element must be a <template> element");
    }
    /**
   * Gets the current action.
   */ get action() {
        return this.getAttribute("action");
    }
    /**
   * Gets the current target (an element ID) to which the result will
   * be rendered.
   */ get target() {
        return this.getAttribute("target");
    }
    /**
   * Gets the current "targets" selector (a CSS selector)
   */ get targets() {
        return this.getAttribute("targets");
    }
    /**
   * Reads the request-id attribute
   */ get requestId() {
        return this.getAttribute("request-id");
    }
    #raise(message) {
        throw new Error(`${this.description}: ${message}`);
    }
    get description() {
        return (this.outerHTML.match(/<[^>]+>/) ?? [])[0] ?? "<turbo-stream>";
    }
    get beforeRenderEvent() {
        return new CustomEvent("turbo:before-stream-render", {
            bubbles: true,
            cancelable: true,
            detail: {
                newStream: this,
                render: $fb0d47f64ee363ae$export$144d499d37929ea8.renderElement
            }
        });
    }
    get targetElementsById() {
        const element = this.ownerDocument?.getElementById(this.target);
        if (element !== null) return [
            element
        ];
        else return [];
    }
    get targetElementsByQuery() {
        const elements = this.ownerDocument?.querySelectorAll(this.targets);
        if (elements.length !== 0) return Array.prototype.slice.call(elements);
        else return [];
    }
}
class $fb0d47f64ee363ae$export$e87d51a4385a3903 extends HTMLElement {
    streamSource = null;
    connectedCallback() {
        this.streamSource = this.src.match(/^ws{1,2}:/) ? new WebSocket(this.src) : new EventSource(this.src);
        $fb0d47f64ee363ae$export$83667c2845c80463(this.streamSource);
    }
    disconnectedCallback() {
        if (this.streamSource) {
            this.streamSource.close();
            $fb0d47f64ee363ae$export$26c56c74e3b67c59(this.streamSource);
        }
    }
    get src() {
        return this.getAttribute("src") || "";
    }
}
$fb0d47f64ee363ae$export$f464a8f0ffa32c44.delegateConstructor = $fb0d47f64ee363ae$var$FrameController;
if (customElements.get("turbo-frame") === undefined) customElements.define("turbo-frame", $fb0d47f64ee363ae$export$f464a8f0ffa32c44);
if (customElements.get("turbo-stream") === undefined) customElements.define("turbo-stream", $fb0d47f64ee363ae$export$144d499d37929ea8);
if (customElements.get("turbo-stream-source") === undefined) customElements.define("turbo-stream-source", $fb0d47f64ee363ae$export$e87d51a4385a3903);
(()=>{
    const scriptElement = document.currentScript;
    if (!scriptElement) return;
    if (scriptElement.hasAttribute("data-turbo-suppress-warning")) return;
    let element = scriptElement.parentElement;
    while(element){
        if (element == document.body) return console.warn($fb0d47f64ee363ae$var$unindent`
        You are loading Turbo from a <script> element inside the <body> element. This is probably not what you meant to do!

        Load your application’s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.

        For more information, see: https://turbo.hotwired.dev/handbook/building#working-with-script-elements

        ——
        Suppress this warning by adding a "data-turbo-suppress-warning" attribute to: %s
      `, scriptElement.outerHTML);
        element = element.parentElement;
    }
})();
window.Turbo = {
    ...$fb0d47f64ee363ae$var$Turbo,
    StreamActions: $fb0d47f64ee363ae$export$1b814a67c3a57eeb
};
$fb0d47f64ee363ae$export$b3571188c770cc5a();


// debugUtils.js
const $c0e0e410f6c5ef5d$var$DEBUG = true;
function $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e(...args) {
    if ($c0e0e410f6c5ef5d$var$DEBUG) console.log(...args);
}
function $c0e0e410f6c5ef5d$export$280f90b954565303(...args) {
    if ($c0e0e410f6c5ef5d$var$DEBUG) console.error(...args);
}


function $6adb56df0e842c64$var$valueCheck(functionName, value, expectedValue) {
    if (typeof value !== expectedValue) throw new Error(`${functionName} function expected ${expectedValue} as one of its parameters.`);
}
function $6adb56df0e842c64$export$4e80b7f9eaacb389() {
    return window.location.host.includes("coinsub.io");
}
function $6adb56df0e842c64$export$6b814e5b0ae65c19(value) {
    const inputValue = Number(value);
    $6adb56df0e842c64$var$valueCheck('countDecimals', inputValue, 'number');
    if (Math.floor(value) !== value) return value.toString().split(".")[1].length || 0;
    return 0;
}
function $6adb56df0e842c64$export$2a9472a6b44892b6(url) {
    return url.endsWith('/') ? url.slice(0, -1) : url;
}
function $6adb56df0e842c64$export$ccf64f7f116a94f(seconds) {
    if (!seconds || seconds < 0 || typeof seconds !== 'number') return "0:00";
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec.toString().padStart(2, '0')}`;
}
function $6adb56df0e842c64$export$18148d12c805c5b0(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
function $6adb56df0e842c64$export$705595419525bb37(address) {
    // Ethereum address regex: 0x followed by 40 hexadecimal characters
    const ethereumAddressRegex = /^0x[a-fA-F0-9]{40}$/;
    return ethereumAddressRegex.test(address);
}
function $6adb56df0e842c64$export$9190b396abd133e8(address, addressValidation) {
    if (!address || address.trim() === "") return false;
    if (!addressValidation || addressValidation.trim() === "") return false;
    const trimmedAddress = address.trim();
    try {
        const regex = new RegExp(addressValidation);
        return regex.test(trimmedAddress);
    } catch (error) {
        console.error("Invalid regex pattern from houdini_tokens:", addressValidation, error);
        return false;
    }
}
function $6adb56df0e842c64$export$c9bcf07e1a7784a6(domain) {
    if (domain === "localhost") return domain;
    // Split by dots and take the last two parts for most cases
    const parts = domain.split(".");
    if (parts.length <= 2) return domain;
    // Handle special cases like .co.uk, .com.au etc.
    const specialTlds = [
        "co",
        "com",
        "org",
        "net",
        "edu",
        "gov"
    ];
    if (parts.length === 3 && specialTlds.includes(parts[parts.length - 2])) return parts.slice(-3).join(".");
    return parts.slice(-2).join(".");
}
async function $6adb56df0e842c64$export$1b9ace636d5b82cc() {
    try {
        const response = await fetch("/verify/domain-data", {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) throw new Error("Failed to fetch domain data");
        const data = await response.json();
        const domain = data.domain === "local" ? "localhost" : data.domain;
        const rootDomain = $6adb56df0e842c64$export$c9bcf07e1a7784a6(domain);
        debugLog("getDomainData:", data);
        return {
            ...data,
            domain: rootDomain
        };
    } catch (error) {
        console.error("Error fetching domain data:", error);
    }
}
function $6adb56df0e842c64$export$61fc7d43ac8f84b0(fn, timeout = 300) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            fn.apply(this, args);
            timer = undefined;
        }, timeout);
    };
}
function $6adb56df0e842c64$export$44f917bf91becd01() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
function $6adb56df0e842c64$export$f1768d02d4612c4() {
    const w = Math.max(document.documentElement?.clientWidth || 0, window.innerWidth || 0);
    if (w > 0 && w < 768) return "mobile";
    if (w >= 768 && w < 1024) return "tablet";
    return "desktop";
}


/*
Stimulus 3.2.1
Copyright © 2023 Basecamp, LLC
 */ class $ffdf60ebf0144301$var$EventListener {
    constructor(eventTarget, eventName, eventOptions){
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    connect() {
        this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
    }
    disconnect() {
        this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
    }
    bindingConnected(binding) {
        this.unorderedBindings.add(binding);
    }
    bindingDisconnected(binding) {
        this.unorderedBindings.delete(binding);
    }
    handleEvent(event) {
        const extendedEvent = $ffdf60ebf0144301$var$extendEvent(event);
        for (const binding of this.bindings){
            if (extendedEvent.immediatePropagationStopped) break;
            else binding.handleEvent(extendedEvent);
        }
    }
    hasBindings() {
        return this.unorderedBindings.size > 0;
    }
    get bindings() {
        return Array.from(this.unorderedBindings).sort((left, right)=>{
            const leftIndex = left.index, rightIndex = right.index;
            return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
        });
    }
}
function $ffdf60ebf0144301$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        const { stopImmediatePropagation: stopImmediatePropagation } = event;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation () {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
class $ffdf60ebf0144301$var$Dispatcher {
    constructor(application){
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.eventListeners.forEach((eventListener)=>eventListener.connect());
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.eventListeners.forEach((eventListener)=>eventListener.disconnect());
        }
    }
    get eventListeners() {
        return Array.from(this.eventListenerMaps.values()).reduce((listeners, map)=>listeners.concat(Array.from(map.values())), []);
    }
    bindingConnected(binding) {
        this.fetchEventListenerForBinding(binding).bindingConnected(binding);
    }
    bindingDisconnected(binding, clearEventListeners = false) {
        this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
        if (clearEventListeners) this.clearEventListenersForBinding(binding);
    }
    handleError(error, message, detail = {}) {
        this.application.handleError(error, `Error ${message}`, detail);
    }
    clearEventListenersForBinding(binding) {
        const eventListener = this.fetchEventListenerForBinding(binding);
        if (!eventListener.hasBindings()) {
            eventListener.disconnect();
            this.removeMappedEventListenerFor(binding);
        }
    }
    removeMappedEventListenerFor(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        eventListenerMap.delete(cacheKey);
        if (eventListenerMap.size == 0) this.eventListenerMaps.delete(eventTarget);
    }
    fetchEventListenerForBinding(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        return this.fetchEventListener(eventTarget, eventName, eventOptions);
    }
    fetchEventListener(eventTarget, eventName, eventOptions) {
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        let eventListener = eventListenerMap.get(cacheKey);
        if (!eventListener) {
            eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
            eventListenerMap.set(cacheKey, eventListener);
        }
        return eventListener;
    }
    createEventListener(eventTarget, eventName, eventOptions) {
        const eventListener = new $ffdf60ebf0144301$var$EventListener(eventTarget, eventName, eventOptions);
        if (this.started) eventListener.connect();
        return eventListener;
    }
    fetchEventListenerMapForEventTarget(eventTarget) {
        let eventListenerMap = this.eventListenerMaps.get(eventTarget);
        if (!eventListenerMap) {
            eventListenerMap = new Map();
            this.eventListenerMaps.set(eventTarget, eventListenerMap);
        }
        return eventListenerMap;
    }
    cacheKey(eventName, eventOptions) {
        const parts = [
            eventName
        ];
        Object.keys(eventOptions).sort().forEach((key)=>{
            parts.push(`${eventOptions[key] ? "" : "!"}${key}`);
        });
        return parts.join(":");
    }
}
const $ffdf60ebf0144301$var$defaultActionDescriptorFilters = {
    stop ({ event: event, value: value }) {
        if (value) event.stopPropagation();
        return true;
    },
    prevent ({ event: event, value: value }) {
        if (value) event.preventDefault();
        return true;
    },
    self ({ event: event, value: value, element: element }) {
        if (value) return element === event.target;
        else return true;
    }
};
const $ffdf60ebf0144301$var$descriptorPattern = /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function $ffdf60ebf0144301$var$parseActionDescriptorString(descriptorString) {
    const source = descriptorString.trim();
    const matches = source.match($ffdf60ebf0144301$var$descriptorPattern) || [];
    let eventName = matches[2];
    let keyFilter = matches[3];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += `.${keyFilter}`;
        keyFilter = "";
    }
    return {
        eventTarget: $ffdf60ebf0144301$var$parseEventTarget(matches[4]),
        eventName: eventName,
        eventOptions: matches[7] ? $ffdf60ebf0144301$var$parseEventOptions(matches[7]) : {},
        identifier: matches[5],
        methodName: matches[6],
        keyFilter: matches[1] || keyFilter
    };
}
function $ffdf60ebf0144301$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $ffdf60ebf0144301$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce((options, token)=>Object.assign(options, {
            [token.replace(/^!/, "")]: !/^!/.test(token)
        }), {});
}
function $ffdf60ebf0144301$var$stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function $ffdf60ebf0144301$var$camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, (_, char)=>char.toUpperCase());
}
function $ffdf60ebf0144301$var$namespaceCamelize(value) {
    return $ffdf60ebf0144301$var$camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function $ffdf60ebf0144301$var$capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $ffdf60ebf0144301$var$dasherize(value) {
    return value.replace(/([A-Z])/g, (_, char)=>`-${char.toLowerCase()}`);
}
function $ffdf60ebf0144301$var$tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
function $ffdf60ebf0144301$var$isSomething(object) {
    return object !== null && object !== undefined;
}
function $ffdf60ebf0144301$var$hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
const $ffdf60ebf0144301$var$allModifiers = [
    "meta",
    "ctrl",
    "alt",
    "shift"
];
class $ffdf60ebf0144301$var$Action {
    constructor(element, index, descriptor, schema){
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $ffdf60ebf0144301$var$getDefaultEventNameForElement(element) || $ffdf60ebf0144301$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $ffdf60ebf0144301$var$error("missing identifier");
        this.methodName = descriptor.methodName || $ffdf60ebf0144301$var$error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    static forToken(token, schema) {
        return new this(token.element, token.index, $ffdf60ebf0144301$var$parseActionDescriptorString(token.content), schema);
    }
    toString() {
        const eventFilter = this.keyFilter ? `.${this.keyFilter}` : "";
        const eventTarget = this.eventTargetName ? `@${this.eventTargetName}` : "";
        return `${this.eventName}${eventFilter}${eventTarget}->${this.identifier}#${this.methodName}`;
    }
    shouldIgnoreKeyboardEvent(event) {
        if (!this.keyFilter) return false;
        const filters = this.keyFilter.split("+");
        if (this.keyFilterDissatisfied(event, filters)) return true;
        const standardFilter = filters.filter((key)=>!$ffdf60ebf0144301$var$allModifiers.includes(key))[0];
        if (!standardFilter) return false;
        if (!$ffdf60ebf0144301$var$hasProperty(this.keyMappings, standardFilter)) $ffdf60ebf0144301$var$error(`contains unknown key filter: ${this.keyFilter}`);
        return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
    }
    shouldIgnoreMouseEvent(event) {
        if (!this.keyFilter) return false;
        const filters = [
            this.keyFilter
        ];
        if (this.keyFilterDissatisfied(event, filters)) return true;
        return false;
    }
    get params() {
        const params = {};
        const pattern = new RegExp(`^data-${this.identifier}-(.+)-param$`, "i");
        for (const { name: name, value: value } of Array.from(this.element.attributes)){
            const match = name.match(pattern);
            const key = match && match[1];
            if (key) params[$ffdf60ebf0144301$var$camelize(key)] = $ffdf60ebf0144301$var$typecast(value);
        }
        return params;
    }
    get eventTargetName() {
        return $ffdf60ebf0144301$var$stringifyEventTarget(this.eventTarget);
    }
    get keyMappings() {
        return this.schema.keyMappings;
    }
    keyFilterDissatisfied(event, filters) {
        const [meta, ctrl, alt, shift] = $ffdf60ebf0144301$var$allModifiers.map((modifier)=>filters.includes(modifier));
        return event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift;
    }
}
const $ffdf60ebf0144301$var$defaultEventNames = {
    a: ()=>"click",
    button: ()=>"click",
    form: ()=>"submit",
    details: ()=>"toggle",
    input: (e)=>e.getAttribute("type") == "submit" ? "click" : "input",
    select: ()=>"change",
    textarea: ()=>"input"
};
function $ffdf60ebf0144301$var$getDefaultEventNameForElement(element) {
    const tagName = element.tagName.toLowerCase();
    if (tagName in $ffdf60ebf0144301$var$defaultEventNames) return $ffdf60ebf0144301$var$defaultEventNames[tagName](element);
}
function $ffdf60ebf0144301$var$error(message) {
    throw new Error(message);
}
function $ffdf60ebf0144301$var$typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
class $ffdf60ebf0144301$var$Binding {
    constructor(context, action){
        this.context = context;
        this.action = action;
    }
    get index() {
        return this.action.index;
    }
    get eventTarget() {
        return this.action.eventTarget;
    }
    get eventOptions() {
        return this.action.eventOptions;
    }
    get identifier() {
        return this.context.identifier;
    }
    handleEvent(event) {
        const actionEvent = this.prepareActionEvent(event);
        if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(actionEvent)) this.invokeWithEvent(actionEvent);
    }
    get eventName() {
        return this.action.eventName;
    }
    get method() {
        const method = this.controller[this.methodName];
        if (typeof method == "function") return method;
        throw new Error(`Action "${this.action}" references undefined method "${this.methodName}"`);
    }
    applyEventModifiers(event) {
        const { element: element } = this.action;
        const { actionDescriptorFilters: actionDescriptorFilters } = this.context.application;
        const { controller: controller } = this.context;
        let passes = true;
        for (const [name, value] of Object.entries(this.eventOptions)){
            if (name in actionDescriptorFilters) {
                const filter = actionDescriptorFilters[name];
                passes = passes && filter({
                    name: name,
                    value: value,
                    event: event,
                    element: element,
                    controller: controller
                });
            } else continue;
        }
        return passes;
    }
    prepareActionEvent(event) {
        return Object.assign(event, {
            params: this.action.params
        });
    }
    invokeWithEvent(event) {
        const { target: target, currentTarget: currentTarget } = event;
        try {
            this.method.call(this.controller, event);
            this.context.logDebugActivity(this.methodName, {
                event: event,
                target: target,
                currentTarget: currentTarget,
                action: this.methodName
            });
        } catch (error) {
            const { identifier: identifier, controller: controller, element: element, index: index } = this;
            const detail = {
                identifier: identifier,
                controller: controller,
                element: element,
                index: index,
                event: event
            };
            this.context.handleError(error, `invoking action "${this.action}"`, detail);
        }
    }
    willBeInvokedByEvent(event) {
        const eventTarget = event.target;
        if (event instanceof KeyboardEvent && this.action.shouldIgnoreKeyboardEvent(event)) return false;
        if (event instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(event)) return false;
        if (this.element === eventTarget) return true;
        else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
        else return this.scope.containsElement(this.action.element);
    }
    get controller() {
        return this.context.controller;
    }
    get methodName() {
        return this.action.methodName;
    }
    get element() {
        return this.scope.element;
    }
    get scope() {
        return this.context.scope;
    }
}
class $ffdf60ebf0144301$export$12e07a2a9f87578a {
    constructor(element, delegate){
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.refresh();
        }
    }
    pause(callback) {
        if (this.started) {
            this.mutationObserver.disconnect();
            this.started = false;
        }
        callback();
        if (!this.started) {
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) {
            const matches = new Set(this.matchElementsInTree());
            for (const element of Array.from(this.elements))if (!matches.has(element)) this.removeElement(element);
            for (const element of Array.from(matches))this.addElement(element);
        }
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
        else if (mutation.type == "childList") {
            this.processRemovedNodes(mutation.removedNodes);
            this.processAddedNodes(mutation.addedNodes);
        }
    }
    processAttributeChange(element, attributeName) {
        if (this.elements.has(element)) {
            if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
            else this.removeElement(element);
        } else if (this.matchElement(element)) this.addElement(element);
    }
    processRemovedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element) this.processTree(element, this.removeElement);
        }
    }
    processAddedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
        }
    }
    matchElement(element) {
        return this.delegate.matchElement(element);
    }
    matchElementsInTree(tree = this.element) {
        return this.delegate.matchElementsInTree(tree);
    }
    processTree(tree, processor) {
        for (const element of this.matchElementsInTree(tree))processor.call(this, element);
    }
    elementFromNode(node) {
        if (node.nodeType == Node.ELEMENT_NODE) return node;
    }
    elementIsActive(element) {
        if (element.isConnected != this.element.isConnected) return false;
        else return this.element.contains(element);
    }
    addElement(element) {
        if (!this.elements.has(element)) {
            if (this.elementIsActive(element)) {
                this.elements.add(element);
                if (this.delegate.elementMatched) this.delegate.elementMatched(element);
            }
        }
    }
    removeElement(element) {
        if (this.elements.has(element)) {
            this.elements.delete(element);
            if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
        }
    }
}
class $ffdf60ebf0144301$export$fe68319d413d05cb {
    constructor(element, attributeName, delegate){
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new $ffdf60ebf0144301$export$12e07a2a9f87578a(element, this);
    }
    get element() {
        return this.elementObserver.element;
    }
    get selector() {
        return `[${this.attributeName}]`;
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get started() {
        return this.elementObserver.started;
    }
    matchElement(element) {
        return element.hasAttribute(this.attributeName);
    }
    matchElementsInTree(tree) {
        const match = this.matchElement(tree) ? [
            tree
        ] : [];
        const matches = Array.from(tree.querySelectorAll(this.selector));
        return match.concat(matches);
    }
    elementMatched(element) {
        if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
    }
    elementUnmatched(element) {
        if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
    }
    elementAttributeChanged(element, attributeName) {
        if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
    }
}
function $ffdf60ebf0144301$export$e16d8520af44a096(map, key, value) {
    $ffdf60ebf0144301$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $ffdf60ebf0144301$export$1d2f21e549771e67(map, key, value) {
    $ffdf60ebf0144301$export$e7aa7bc5c1b3cfb3(map, key).delete(value);
    $ffdf60ebf0144301$export$d6cf75919f12ca5a(map, key);
}
function $ffdf60ebf0144301$export$e7aa7bc5c1b3cfb3(map, key) {
    let values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $ffdf60ebf0144301$export$d6cf75919f12ca5a(map, key) {
    const values = map.get(key);
    if (values != null && values.size == 0) map.delete(key);
}
class $ffdf60ebf0144301$export$8bd4ad37b76db6ba {
    constructor(){
        this.valuesByKey = new Map();
    }
    get keys() {
        return Array.from(this.valuesByKey.keys());
    }
    get values() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((values, set)=>values.concat(Array.from(set)), []);
    }
    get size() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((size, set)=>size + set.size, 0);
    }
    add(key, value) {
        $ffdf60ebf0144301$export$e16d8520af44a096(this.valuesByKey, key, value);
    }
    delete(key, value) {
        $ffdf60ebf0144301$export$1d2f21e549771e67(this.valuesByKey, key, value);
    }
    has(key, value) {
        const values = this.valuesByKey.get(key);
        return values != null && values.has(value);
    }
    hasKey(key) {
        return this.valuesByKey.has(key);
    }
    hasValue(value) {
        const sets = Array.from(this.valuesByKey.values());
        return sets.some((set)=>set.has(value));
    }
    getValuesForKey(key) {
        const values = this.valuesByKey.get(key);
        return values ? Array.from(values) : [];
    }
    getKeysForValue(value) {
        return Array.from(this.valuesByKey).filter(([_key, values])=>values.has(value)).map(([key, _values])=>key);
    }
}
class $ffdf60ebf0144301$export$a7c3d2c2552a674d extends $ffdf60ebf0144301$export$8bd4ad37b76db6ba {
    constructor(){
        super();
        this.keysByValue = new Map();
    }
    get values() {
        return Array.from(this.keysByValue.keys());
    }
    add(key, value) {
        super.add(key, value);
        $ffdf60ebf0144301$export$e16d8520af44a096(this.keysByValue, value, key);
    }
    delete(key, value) {
        super.delete(key, value);
        $ffdf60ebf0144301$export$1d2f21e549771e67(this.keysByValue, value, key);
    }
    hasValue(value) {
        return this.keysByValue.has(value);
    }
    getKeysForValue(value) {
        const set = this.keysByValue.get(value);
        return set ? Array.from(set) : [];
    }
}
class $ffdf60ebf0144301$export$116e0b48509995b {
    constructor(element, selector, delegate, details){
        this._selector = selector;
        this.details = details;
        this.elementObserver = new $ffdf60ebf0144301$export$12e07a2a9f87578a(element, this);
        this.delegate = delegate;
        this.matchesByElement = new $ffdf60ebf0144301$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.elementObserver.started;
    }
    get selector() {
        return this._selector;
    }
    set selector(selector) {
        this._selector = selector;
        this.refresh();
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get element() {
        return this.elementObserver.element;
    }
    matchElement(element) {
        const { selector: selector } = this;
        if (selector) {
            const matches = element.matches(selector);
            if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
            return matches;
        } else return false;
    }
    matchElementsInTree(tree) {
        const { selector: selector } = this;
        if (selector) {
            const match = this.matchElement(tree) ? [
                tree
            ] : [];
            const matches = Array.from(tree.querySelectorAll(selector)).filter((match)=>this.matchElement(match));
            return match.concat(matches);
        } else return [];
    }
    elementMatched(element) {
        const { selector: selector } = this;
        if (selector) this.selectorMatched(element, selector);
    }
    elementUnmatched(element) {
        const selectors = this.matchesByElement.getKeysForValue(element);
        for (const selector of selectors)this.selectorUnmatched(element, selector);
    }
    elementAttributeChanged(element, _attributeName) {
        const { selector: selector } = this;
        if (selector) {
            const matches = this.matchElement(element);
            const matchedBefore = this.matchesByElement.has(selector, element);
            if (matches && !matchedBefore) this.selectorMatched(element, selector);
            else if (!matches && matchedBefore) this.selectorUnmatched(element, selector);
        }
    }
    selectorMatched(element, selector) {
        this.delegate.selectorMatched(element, selector, this.details);
        this.matchesByElement.add(selector, element);
    }
    selectorUnmatched(element, selector) {
        this.delegate.selectorUnmatched(element, selector, this.details);
        this.matchesByElement.delete(selector, element);
    }
}
class $ffdf60ebf0144301$export$da226bebbf7f6caa {
    constructor(element, delegate){
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, {
                attributes: true,
                attributeOldValue: true
            });
            this.refresh();
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) for (const attributeName of this.knownAttributeNames)this.refreshAttribute(attributeName, null);
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        const attributeName = mutation.attributeName;
        if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
    }
    refreshAttribute(attributeName, oldValue) {
        const key = this.delegate.getStringMapKeyForAttribute(attributeName);
        if (key != null) {
            if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
            const value = this.element.getAttribute(attributeName);
            if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
            if (value == null) {
                const oldValue = this.stringMap.get(attributeName);
                this.stringMap.delete(attributeName);
                if (oldValue) this.stringMapKeyRemoved(key, attributeName, oldValue);
            } else this.stringMap.set(attributeName, value);
        }
    }
    stringMapKeyAdded(key, attributeName) {
        if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
    }
    stringMapValueChanged(value, key, oldValue) {
        if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
    }
    get knownAttributeNames() {
        return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
    }
    get currentAttributeNames() {
        return Array.from(this.element.attributes).map((attribute)=>attribute.name);
    }
    get recordedAttributeNames() {
        return Array.from(this.stringMap.keys());
    }
}
class $ffdf60ebf0144301$export$3aa21c2f03ef6b3b {
    constructor(element, attributeName, delegate){
        this.attributeObserver = new $ffdf60ebf0144301$export$fe68319d413d05cb(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new $ffdf60ebf0144301$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.attributeObserver.started;
    }
    start() {
        this.attributeObserver.start();
    }
    pause(callback) {
        this.attributeObserver.pause(callback);
    }
    stop() {
        this.attributeObserver.stop();
    }
    refresh() {
        this.attributeObserver.refresh();
    }
    get element() {
        return this.attributeObserver.element;
    }
    get attributeName() {
        return this.attributeObserver.attributeName;
    }
    elementMatchedAttribute(element) {
        this.tokensMatched(this.readTokensForElement(element));
    }
    elementAttributeValueChanged(element) {
        const [unmatchedTokens, matchedTokens] = this.refreshTokensForElement(element);
        this.tokensUnmatched(unmatchedTokens);
        this.tokensMatched(matchedTokens);
    }
    elementUnmatchedAttribute(element) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
    }
    tokensMatched(tokens) {
        tokens.forEach((token)=>this.tokenMatched(token));
    }
    tokensUnmatched(tokens) {
        tokens.forEach((token)=>this.tokenUnmatched(token));
    }
    tokenMatched(token) {
        this.delegate.tokenMatched(token);
        this.tokensByElement.add(token.element, token);
    }
    tokenUnmatched(token) {
        this.delegate.tokenUnmatched(token);
        this.tokensByElement.delete(token.element, token);
    }
    refreshTokensForElement(element) {
        const previousTokens = this.tokensByElement.getValuesForKey(element);
        const currentTokens = this.readTokensForElement(element);
        const firstDifferingIndex = $ffdf60ebf0144301$var$zip(previousTokens, currentTokens).findIndex(([previousToken, currentToken])=>!$ffdf60ebf0144301$var$tokensAreEqual(previousToken, currentToken));
        if (firstDifferingIndex == -1) return [
            [],
            []
        ];
        else return [
            previousTokens.slice(firstDifferingIndex),
            currentTokens.slice(firstDifferingIndex)
        ];
    }
    readTokensForElement(element) {
        const attributeName = this.attributeName;
        const tokenString = element.getAttribute(attributeName) || "";
        return $ffdf60ebf0144301$var$parseTokenString(tokenString, element, attributeName);
    }
}
function $ffdf60ebf0144301$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter((content)=>content.length).map((content, index)=>({
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        }));
}
function $ffdf60ebf0144301$var$zip(left, right) {
    const length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, (_, index)=>[
            left[index],
            right[index]
        ]);
}
function $ffdf60ebf0144301$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
class $ffdf60ebf0144301$export$d27fa4c7330a452e {
    constructor(element, attributeName, delegate){
        this.tokenListObserver = new $ffdf60ebf0144301$export$3aa21c2f03ef6b3b(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    get started() {
        return this.tokenListObserver.started;
    }
    start() {
        this.tokenListObserver.start();
    }
    stop() {
        this.tokenListObserver.stop();
    }
    refresh() {
        this.tokenListObserver.refresh();
    }
    get element() {
        return this.tokenListObserver.element;
    }
    get attributeName() {
        return this.tokenListObserver.attributeName;
    }
    tokenMatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).set(token, value);
            this.delegate.elementMatchedValue(element, value);
        }
    }
    tokenUnmatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).delete(token);
            this.delegate.elementUnmatchedValue(element, value);
        }
    }
    fetchParseResultForToken(token) {
        let parseResult = this.parseResultsByToken.get(token);
        if (!parseResult) {
            parseResult = this.parseToken(token);
            this.parseResultsByToken.set(token, parseResult);
        }
        return parseResult;
    }
    fetchValuesByTokenForElement(element) {
        let valuesByToken = this.valuesByTokenByElement.get(element);
        if (!valuesByToken) {
            valuesByToken = new Map();
            this.valuesByTokenByElement.set(element, valuesByToken);
        }
        return valuesByToken;
    }
    parseToken(token) {
        try {
            const value = this.delegate.parseValueForToken(token);
            return {
                value: value
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }
}
class $ffdf60ebf0144301$var$BindingObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    start() {
        if (!this.valueListObserver) {
            this.valueListObserver = new $ffdf60ebf0144301$export$d27fa4c7330a452e(this.element, this.actionAttribute, this);
            this.valueListObserver.start();
        }
    }
    stop() {
        if (this.valueListObserver) {
            this.valueListObserver.stop();
            delete this.valueListObserver;
            this.disconnectAllActions();
        }
    }
    get element() {
        return this.context.element;
    }
    get identifier() {
        return this.context.identifier;
    }
    get actionAttribute() {
        return this.schema.actionAttribute;
    }
    get schema() {
        return this.context.schema;
    }
    get bindings() {
        return Array.from(this.bindingsByAction.values());
    }
    connectAction(action) {
        const binding = new $ffdf60ebf0144301$var$Binding(this.context, action);
        this.bindingsByAction.set(action, binding);
        this.delegate.bindingConnected(binding);
    }
    disconnectAction(action) {
        const binding = this.bindingsByAction.get(action);
        if (binding) {
            this.bindingsByAction.delete(action);
            this.delegate.bindingDisconnected(binding);
        }
    }
    disconnectAllActions() {
        this.bindings.forEach((binding)=>this.delegate.bindingDisconnected(binding, true));
        this.bindingsByAction.clear();
    }
    parseValueForToken(token) {
        const action = $ffdf60ebf0144301$var$Action.forToken(token, this.schema);
        if (action.identifier == this.identifier) return action;
    }
    elementMatchedValue(element, action) {
        this.connectAction(action);
    }
    elementUnmatchedValue(element, action) {
        this.disconnectAction(action);
    }
}
class $ffdf60ebf0144301$var$ValueObserver {
    constructor(context, receiver){
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new $ffdf60ebf0144301$export$da226bebbf7f6caa(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    start() {
        this.stringMapObserver.start();
        this.invokeChangedCallbacksForDefaultValues();
    }
    stop() {
        this.stringMapObserver.stop();
    }
    get element() {
        return this.context.element;
    }
    get controller() {
        return this.context.controller;
    }
    getStringMapKeyForAttribute(attributeName) {
        if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
    }
    stringMapKeyAdded(key, attributeName) {
        const descriptor = this.valueDescriptorMap[attributeName];
        if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
    }
    stringMapValueChanged(value, name, oldValue) {
        const descriptor = this.valueDescriptorNameMap[name];
        if (value === null) return;
        if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
        this.invokeChangedCallback(name, value, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        const descriptor = this.valueDescriptorNameMap[key];
        if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
        else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
    }
    invokeChangedCallbacksForDefaultValues() {
        for (const { key: key, name: name, defaultValue: defaultValue, writer: writer } of this.valueDescriptors)if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
    }
    invokeChangedCallback(name, rawValue, rawOldValue) {
        const changedMethodName = `${name}Changed`;
        const changedMethod = this.receiver[changedMethodName];
        if (typeof changedMethod == "function") {
            const descriptor = this.valueDescriptorNameMap[name];
            try {
                const value = descriptor.reader(rawValue);
                let oldValue = rawOldValue;
                if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                changedMethod.call(this.receiver, value, oldValue);
            } catch (error) {
                if (error instanceof TypeError) error.message = `Stimulus Value "${this.context.identifier}.${descriptor.name}" - ${error.message}`;
                throw error;
            }
        }
    }
    get valueDescriptors() {
        const { valueDescriptorMap: valueDescriptorMap } = this;
        return Object.keys(valueDescriptorMap).map((key)=>valueDescriptorMap[key]);
    }
    get valueDescriptorNameMap() {
        const descriptors = {};
        Object.keys(this.valueDescriptorMap).forEach((key)=>{
            const descriptor = this.valueDescriptorMap[key];
            descriptors[descriptor.name] = descriptor;
        });
        return descriptors;
    }
    hasValue(attributeName) {
        const descriptor = this.valueDescriptorNameMap[attributeName];
        const hasMethodName = `has${$ffdf60ebf0144301$var$capitalize(descriptor.name)}`;
        return this.receiver[hasMethodName];
    }
}
class $ffdf60ebf0144301$var$TargetObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new $ffdf60ebf0144301$export$8bd4ad37b76db6ba();
    }
    start() {
        if (!this.tokenListObserver) {
            this.tokenListObserver = new $ffdf60ebf0144301$export$3aa21c2f03ef6b3b(this.element, this.attributeName, this);
            this.tokenListObserver.start();
        }
    }
    stop() {
        if (this.tokenListObserver) {
            this.disconnectAllTargets();
            this.tokenListObserver.stop();
            delete this.tokenListObserver;
        }
    }
    tokenMatched({ element: element, content: name }) {
        if (this.scope.containsElement(element)) this.connectTarget(element, name);
    }
    tokenUnmatched({ element: element, content: name }) {
        this.disconnectTarget(element, name);
    }
    connectTarget(element, name) {
        var _a;
        if (!this.targetsByName.has(name, element)) {
            this.targetsByName.add(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetConnected(element, name));
        }
    }
    disconnectTarget(element, name) {
        var _a;
        if (this.targetsByName.has(name, element)) {
            this.targetsByName.delete(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetDisconnected(element, name));
        }
    }
    disconnectAllTargets() {
        for (const name of this.targetsByName.keys)for (const element of this.targetsByName.getValuesForKey(name))this.disconnectTarget(element, name);
    }
    get attributeName() {
        return `data-${this.context.identifier}-target`;
    }
    get element() {
        return this.context.element;
    }
    get scope() {
        return this.context.scope;
    }
}
function $ffdf60ebf0144301$var$readInheritableStaticArrayValues(constructor, propertyName) {
    const ancestors = $ffdf60ebf0144301$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce((values, constructor)=>{
        $ffdf60ebf0144301$var$getOwnStaticArrayValues(constructor, propertyName).forEach((name)=>values.add(name));
        return values;
    }, new Set()));
}
function $ffdf60ebf0144301$var$readInheritableStaticObjectPairs(constructor, propertyName) {
    const ancestors = $ffdf60ebf0144301$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce((pairs, constructor)=>{
        pairs.push(...$ffdf60ebf0144301$var$getOwnStaticObjectPairs(constructor, propertyName));
        return pairs;
    }, []);
}
function $ffdf60ebf0144301$var$getAncestorsForConstructor(constructor) {
    const ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $ffdf60ebf0144301$var$getOwnStaticArrayValues(constructor, propertyName) {
    const definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $ffdf60ebf0144301$var$getOwnStaticObjectPairs(constructor, propertyName) {
    const definition = constructor[propertyName];
    return definition ? Object.keys(definition).map((key)=>[
            key,
            definition[key]
        ]) : [];
}
class $ffdf60ebf0144301$var$OutletObserver {
    constructor(context, delegate){
        this.started = false;
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new $ffdf60ebf0144301$export$8bd4ad37b76db6ba();
        this.outletElementsByName = new $ffdf60ebf0144301$export$8bd4ad37b76db6ba();
        this.selectorObserverMap = new Map();
        this.attributeObserverMap = new Map();
    }
    start() {
        if (!this.started) {
            this.outletDefinitions.forEach((outletName)=>{
                this.setupSelectorObserverForOutlet(outletName);
                this.setupAttributeObserverForOutlet(outletName);
            });
            this.started = true;
            this.dependentContexts.forEach((context)=>context.refresh());
        }
    }
    refresh() {
        this.selectorObserverMap.forEach((observer)=>observer.refresh());
        this.attributeObserverMap.forEach((observer)=>observer.refresh());
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.disconnectAllOutlets();
            this.stopSelectorObservers();
            this.stopAttributeObservers();
        }
    }
    stopSelectorObservers() {
        if (this.selectorObserverMap.size > 0) {
            this.selectorObserverMap.forEach((observer)=>observer.stop());
            this.selectorObserverMap.clear();
        }
    }
    stopAttributeObservers() {
        if (this.attributeObserverMap.size > 0) {
            this.attributeObserverMap.forEach((observer)=>observer.stop());
            this.attributeObserverMap.clear();
        }
    }
    selectorMatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutlet(element, outletName);
        if (outlet) this.connectOutlet(outlet, element, outletName);
    }
    selectorUnmatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutletFromMap(element, outletName);
        if (outlet) this.disconnectOutlet(outlet, element, outletName);
    }
    selectorMatchElement(element, { outletName: outletName }) {
        const selector = this.selector(outletName);
        const hasOutlet = this.hasOutlet(element, outletName);
        const hasOutletController = element.matches(`[${this.schema.controllerAttribute}~=${outletName}]`);
        if (selector) return hasOutlet && hasOutletController && element.matches(selector);
        else return false;
    }
    elementMatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementAttributeValueChanged(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementUnmatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    connectOutlet(outlet, element, outletName) {
        var _a;
        if (!this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.add(outletName, outlet);
            this.outletElementsByName.add(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletConnected(outlet, element, outletName));
        }
    }
    disconnectOutlet(outlet, element, outletName) {
        var _a;
        if (this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.delete(outletName, outlet);
            this.outletElementsByName.delete(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletDisconnected(outlet, element, outletName));
        }
    }
    disconnectAllOutlets() {
        for (const outletName of this.outletElementsByName.keys){
            for (const element of this.outletElementsByName.getValuesForKey(outletName))for (const outlet of this.outletsByName.getValuesForKey(outletName))this.disconnectOutlet(outlet, element, outletName);
        }
    }
    updateSelectorObserverForOutlet(outletName) {
        const observer = this.selectorObserverMap.get(outletName);
        if (observer) observer.selector = this.selector(outletName);
    }
    setupSelectorObserverForOutlet(outletName) {
        const selector = this.selector(outletName);
        const selectorObserver = new $ffdf60ebf0144301$export$116e0b48509995b(document.body, selector, this, {
            outletName: outletName
        });
        this.selectorObserverMap.set(outletName, selectorObserver);
        selectorObserver.start();
    }
    setupAttributeObserverForOutlet(outletName) {
        const attributeName = this.attributeNameForOutletName(outletName);
        const attributeObserver = new $ffdf60ebf0144301$export$fe68319d413d05cb(this.scope.element, attributeName, this);
        this.attributeObserverMap.set(outletName, attributeObserver);
        attributeObserver.start();
    }
    selector(outletName) {
        return this.scope.outlets.getSelectorForOutletName(outletName);
    }
    attributeNameForOutletName(outletName) {
        return this.scope.schema.outletAttributeForScope(this.identifier, outletName);
    }
    getOutletNameFromOutletAttributeName(attributeName) {
        return this.outletDefinitions.find((outletName)=>this.attributeNameForOutletName(outletName) === attributeName);
    }
    get outletDependencies() {
        const dependencies = new $ffdf60ebf0144301$export$8bd4ad37b76db6ba();
        this.router.modules.forEach((module)=>{
            const constructor = module.definition.controllerConstructor;
            const outlets = $ffdf60ebf0144301$var$readInheritableStaticArrayValues(constructor, "outlets");
            outlets.forEach((outlet)=>dependencies.add(outlet, module.identifier));
        });
        return dependencies;
    }
    get outletDefinitions() {
        return this.outletDependencies.getKeysForValue(this.identifier);
    }
    get dependentControllerIdentifiers() {
        return this.outletDependencies.getValuesForKey(this.identifier);
    }
    get dependentContexts() {
        const identifiers = this.dependentControllerIdentifiers;
        return this.router.contexts.filter((context)=>identifiers.includes(context.identifier));
    }
    hasOutlet(element, outletName) {
        return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
    }
    getOutlet(element, outletName) {
        return this.application.getControllerForElementAndIdentifier(element, outletName);
    }
    getOutletFromMap(element, outletName) {
        return this.outletsByName.getValuesForKey(outletName).find((outlet)=>outlet.element === element);
    }
    get scope() {
        return this.context.scope;
    }
    get schema() {
        return this.context.schema;
    }
    get identifier() {
        return this.context.identifier;
    }
    get application() {
        return this.context.application;
    }
    get router() {
        return this.application.router;
    }
}
class $ffdf60ebf0144301$export$841858b892ce1f4c {
    constructor(module, scope){
        this.logDebugActivity = (functionName, detail = {})=>{
            const { identifier: identifier, controller: controller, element: element } = this;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            this.application.logDebugActivity(this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new $ffdf60ebf0144301$var$BindingObserver(this, this.dispatcher);
        this.valueObserver = new $ffdf60ebf0144301$var$ValueObserver(this, this.controller);
        this.targetObserver = new $ffdf60ebf0144301$var$TargetObserver(this, this);
        this.outletObserver = new $ffdf60ebf0144301$var$OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    connect() {
        this.bindingObserver.start();
        this.valueObserver.start();
        this.targetObserver.start();
        this.outletObserver.start();
        try {
            this.controller.connect();
            this.logDebugActivity("connect");
        } catch (error) {
            this.handleError(error, "connecting controller");
        }
    }
    refresh() {
        this.outletObserver.refresh();
    }
    disconnect() {
        try {
            this.controller.disconnect();
            this.logDebugActivity("disconnect");
        } catch (error) {
            this.handleError(error, "disconnecting controller");
        }
        this.outletObserver.stop();
        this.targetObserver.stop();
        this.valueObserver.stop();
        this.bindingObserver.stop();
    }
    get application() {
        return this.module.application;
    }
    get identifier() {
        return this.module.identifier;
    }
    get schema() {
        return this.application.schema;
    }
    get dispatcher() {
        return this.application.dispatcher;
    }
    get element() {
        return this.scope.element;
    }
    get parentElement() {
        return this.element.parentElement;
    }
    handleError(error, message, detail = {}) {
        const { identifier: identifier, controller: controller, element: element } = this;
        detail = Object.assign({
            identifier: identifier,
            controller: controller,
            element: element
        }, detail);
        this.application.handleError(error, `Error ${message}`, detail);
    }
    targetConnected(element, name) {
        this.invokeControllerMethod(`${name}TargetConnected`, element);
    }
    targetDisconnected(element, name) {
        this.invokeControllerMethod(`${name}TargetDisconnected`, element);
    }
    outletConnected(outlet, element, name) {
        this.invokeControllerMethod(`${$ffdf60ebf0144301$var$namespaceCamelize(name)}OutletConnected`, outlet, element);
    }
    outletDisconnected(outlet, element, name) {
        this.invokeControllerMethod(`${$ffdf60ebf0144301$var$namespaceCamelize(name)}OutletDisconnected`, outlet, element);
    }
    invokeControllerMethod(methodName, ...args) {
        const controller = this.controller;
        if (typeof controller[methodName] == "function") controller[methodName](...args);
    }
}
function $ffdf60ebf0144301$var$bless(constructor) {
    return $ffdf60ebf0144301$var$shadow(constructor, $ffdf60ebf0144301$var$getBlessedProperties(constructor));
}
function $ffdf60ebf0144301$var$shadow(constructor, properties) {
    const shadowConstructor = $ffdf60ebf0144301$var$extend(constructor);
    const shadowProperties = $ffdf60ebf0144301$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $ffdf60ebf0144301$var$getBlessedProperties(constructor) {
    const blessings = $ffdf60ebf0144301$var$readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce((blessedProperties, blessing)=>{
        const properties = blessing(constructor);
        for(const key in properties){
            const descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $ffdf60ebf0144301$var$getShadowProperties(prototype, properties) {
    return $ffdf60ebf0144301$var$getOwnKeys(properties).reduce((shadowProperties, key)=>{
        const descriptor = $ffdf60ebf0144301$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, {
            [key]: descriptor
        });
        return shadowProperties;
    }, {});
}
function $ffdf60ebf0144301$var$getShadowedDescriptor(prototype, properties, key) {
    const shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    const shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        const descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
const $ffdf60ebf0144301$var$getOwnKeys = (()=>{
    if (typeof Object.getOwnPropertySymbols == "function") return (object)=>[
            ...Object.getOwnPropertyNames(object),
            ...Object.getOwnPropertySymbols(object)
        ];
    else return Object.getOwnPropertyNames;
})();
const $ffdf60ebf0144301$var$extend = (()=>{
    function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, new.target);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    }
    function testReflectExtension() {
        const a = function() {
            this.a.call(this);
        };
        const b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    }
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return (constructor)=>class extended extends constructor {
            };
    }
})();
function $ffdf60ebf0144301$var$blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: $ffdf60ebf0144301$var$bless(definition.controllerConstructor)
    };
}
class $ffdf60ebf0144301$var$Module {
    constructor(application, definition){
        this.application = application;
        this.definition = $ffdf60ebf0144301$var$blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    get identifier() {
        return this.definition.identifier;
    }
    get controllerConstructor() {
        return this.definition.controllerConstructor;
    }
    get contexts() {
        return Array.from(this.connectedContexts);
    }
    connectContextForScope(scope) {
        const context = this.fetchContextForScope(scope);
        this.connectedContexts.add(context);
        context.connect();
    }
    disconnectContextForScope(scope) {
        const context = this.contextsByScope.get(scope);
        if (context) {
            this.connectedContexts.delete(context);
            context.disconnect();
        }
    }
    fetchContextForScope(scope) {
        let context = this.contextsByScope.get(scope);
        if (!context) {
            context = new $ffdf60ebf0144301$export$841858b892ce1f4c(this, scope);
            this.contextsByScope.set(scope, context);
        }
        return context;
    }
}
class $ffdf60ebf0144301$var$ClassMap {
    constructor(scope){
        this.scope = scope;
    }
    has(name) {
        return this.data.has(this.getDataKey(name));
    }
    get(name) {
        return this.getAll(name)[0];
    }
    getAll(name) {
        const tokenString = this.data.get(this.getDataKey(name)) || "";
        return $ffdf60ebf0144301$var$tokenize(tokenString);
    }
    getAttributeName(name) {
        return this.data.getAttributeNameForKey(this.getDataKey(name));
    }
    getDataKey(name) {
        return `${name}-class`;
    }
    get data() {
        return this.scope.data;
    }
}
class $ffdf60ebf0144301$var$DataMap {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.getAttribute(name);
    }
    set(key, value) {
        const name = this.getAttributeNameForKey(key);
        this.element.setAttribute(name, value);
        return this.get(key);
    }
    has(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.hasAttribute(name);
    }
    delete(key) {
        if (this.has(key)) {
            const name = this.getAttributeNameForKey(key);
            this.element.removeAttribute(name);
            return true;
        } else return false;
    }
    getAttributeNameForKey(key) {
        return `data-${this.identifier}-${$ffdf60ebf0144301$var$dasherize(key)}`;
    }
}
class $ffdf60ebf0144301$var$Guide {
    constructor(logger){
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    warn(object, key, message) {
        let warnedKeys = this.warnedKeysByObject.get(object);
        if (!warnedKeys) {
            warnedKeys = new Set();
            this.warnedKeysByObject.set(object, warnedKeys);
        }
        if (!warnedKeys.has(key)) {
            warnedKeys.add(key);
            this.logger.warn(message, object);
        }
    }
}
function $ffdf60ebf0144301$var$attributeValueContainsToken(attributeName, token) {
    return `[${attributeName}~="${token}"]`;
}
class $ffdf60ebf0144301$var$TargetSet {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(targetName) {
        return this.find(targetName) != null;
    }
    find(...targetNames) {
        return targetNames.reduce((target, targetName)=>target || this.findTarget(targetName) || this.findLegacyTarget(targetName), undefined);
    }
    findAll(...targetNames) {
        return targetNames.reduce((targets, targetName)=>[
                ...targets,
                ...this.findAllTargets(targetName),
                ...this.findAllLegacyTargets(targetName)
            ], []);
    }
    findTarget(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findElement(selector);
    }
    findAllTargets(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findAllElements(selector);
    }
    getSelectorForTargetName(targetName) {
        const attributeName = this.schema.targetAttributeForScope(this.identifier);
        return $ffdf60ebf0144301$var$attributeValueContainsToken(attributeName, targetName);
    }
    findLegacyTarget(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.deprecate(this.scope.findElement(selector), targetName);
    }
    findAllLegacyTargets(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.scope.findAllElements(selector).map((element)=>this.deprecate(element, targetName));
    }
    getLegacySelectorForTargetName(targetName) {
        const targetDescriptor = `${this.identifier}.${targetName}`;
        return $ffdf60ebf0144301$var$attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
    }
    deprecate(element, targetName) {
        if (element) {
            const { identifier: identifier } = this;
            const attributeName = this.schema.targetAttribute;
            const revisedAttributeName = this.schema.targetAttributeForScope(identifier);
            this.guide.warn(element, `target:${targetName}`, `Please replace ${attributeName}="${identifier}.${targetName}" with ${revisedAttributeName}="${targetName}". ` + `The ${attributeName} attribute is deprecated and will be removed in a future version of Stimulus.`);
        }
        return element;
    }
    get guide() {
        return this.scope.guide;
    }
}
class $ffdf60ebf0144301$var$OutletSet {
    constructor(scope, controllerElement){
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(outletName) {
        return this.find(outletName) != null;
    }
    find(...outletNames) {
        return outletNames.reduce((outlet, outletName)=>outlet || this.findOutlet(outletName), undefined);
    }
    findAll(...outletNames) {
        return outletNames.reduce((outlets, outletName)=>[
                ...outlets,
                ...this.findAllOutlets(outletName)
            ], []);
    }
    getSelectorForOutletName(outletName) {
        const attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
        return this.controllerElement.getAttribute(attributeName);
    }
    findOutlet(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        if (selector) return this.findElement(selector, outletName);
    }
    findAllOutlets(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        return selector ? this.findAllElements(selector, outletName) : [];
    }
    findElement(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName))[0];
    }
    findAllElements(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName));
    }
    matchesElement(element, selector, outletName) {
        const controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
        return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
    }
}
class $ffdf60ebf0144301$var$Scope {
    constructor(schema, element, identifier, logger){
        this.targets = new $ffdf60ebf0144301$var$TargetSet(this);
        this.classes = new $ffdf60ebf0144301$var$ClassMap(this);
        this.data = new $ffdf60ebf0144301$var$DataMap(this);
        this.containsElement = (element)=>{
            return element.closest(this.controllerSelector) === this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new $ffdf60ebf0144301$var$Guide(logger);
        this.outlets = new $ffdf60ebf0144301$var$OutletSet(this.documentScope, element);
    }
    findElement(selector) {
        return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
    }
    findAllElements(selector) {
        return [
            ...this.element.matches(selector) ? [
                this.element
            ] : [],
            ...this.queryElements(selector).filter(this.containsElement)
        ];
    }
    queryElements(selector) {
        return Array.from(this.element.querySelectorAll(selector));
    }
    get controllerSelector() {
        return $ffdf60ebf0144301$var$attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
    }
    get isDocumentScope() {
        return this.element === document.documentElement;
    }
    get documentScope() {
        return this.isDocumentScope ? this : new $ffdf60ebf0144301$var$Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
    }
}
class $ffdf60ebf0144301$var$ScopeObserver {
    constructor(element, schema, delegate){
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new $ffdf60ebf0144301$export$d27fa4c7330a452e(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    start() {
        this.valueListObserver.start();
    }
    stop() {
        this.valueListObserver.stop();
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    parseValueForToken(token) {
        const { element: element, content: identifier } = token;
        return this.parseValueForElementAndIdentifier(element, identifier);
    }
    parseValueForElementAndIdentifier(element, identifier) {
        const scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
        let scope = scopesByIdentifier.get(identifier);
        if (!scope) {
            scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
            scopesByIdentifier.set(identifier, scope);
        }
        return scope;
    }
    elementMatchedValue(element, value) {
        const referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
        this.scopeReferenceCounts.set(value, referenceCount);
        if (referenceCount == 1) this.delegate.scopeConnected(value);
    }
    elementUnmatchedValue(element, value) {
        const referenceCount = this.scopeReferenceCounts.get(value);
        if (referenceCount) {
            this.scopeReferenceCounts.set(value, referenceCount - 1);
            if (referenceCount == 1) this.delegate.scopeDisconnected(value);
        }
    }
    fetchScopesByIdentifierForElement(element) {
        let scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
        if (!scopesByIdentifier) {
            scopesByIdentifier = new Map();
            this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
        }
        return scopesByIdentifier;
    }
}
class $ffdf60ebf0144301$var$Router {
    constructor(application){
        this.application = application;
        this.scopeObserver = new $ffdf60ebf0144301$var$ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new $ffdf60ebf0144301$export$8bd4ad37b76db6ba();
        this.modulesByIdentifier = new Map();
    }
    get element() {
        return this.application.element;
    }
    get schema() {
        return this.application.schema;
    }
    get logger() {
        return this.application.logger;
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    get modules() {
        return Array.from(this.modulesByIdentifier.values());
    }
    get contexts() {
        return this.modules.reduce((contexts, module)=>contexts.concat(module.contexts), []);
    }
    start() {
        this.scopeObserver.start();
    }
    stop() {
        this.scopeObserver.stop();
    }
    loadDefinition(definition) {
        this.unloadIdentifier(definition.identifier);
        const module = new $ffdf60ebf0144301$var$Module(this.application, definition);
        this.connectModule(module);
        const afterLoad = definition.controllerConstructor.afterLoad;
        if (afterLoad) afterLoad.call(definition.controllerConstructor, definition.identifier, this.application);
    }
    unloadIdentifier(identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) this.disconnectModule(module);
    }
    getContextForElementAndIdentifier(element, identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) return module.contexts.find((context)=>context.element == element);
    }
    proposeToConnectScopeForElementAndIdentifier(element, identifier) {
        const scope = this.scopeObserver.parseValueForElementAndIdentifier(element, identifier);
        if (scope) this.scopeObserver.elementMatchedValue(scope.element, scope);
        else console.error(`Couldn't find or create scope for identifier: "${identifier}" and element:`, element);
    }
    handleError(error, message, detail) {
        this.application.handleError(error, message, detail);
    }
    createScopeForElementAndIdentifier(element, identifier) {
        return new $ffdf60ebf0144301$var$Scope(this.schema, element, identifier, this.logger);
    }
    scopeConnected(scope) {
        this.scopesByIdentifier.add(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.connectContextForScope(scope);
    }
    scopeDisconnected(scope) {
        this.scopesByIdentifier.delete(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.disconnectContextForScope(scope);
    }
    connectModule(module) {
        this.modulesByIdentifier.set(module.identifier, module);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.connectContextForScope(scope));
    }
    disconnectModule(module) {
        this.modulesByIdentifier.delete(module.identifier);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.disconnectContextForScope(scope));
    }
}
const $ffdf60ebf0144301$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: (identifier)=>`data-${identifier}-target`,
    outletAttributeForScope: (identifier, outlet)=>`data-${identifier}-${outlet}-outlet`,
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End",
        page_up: "PageUp",
        page_down: "PageDown"
    }, $ffdf60ebf0144301$var$objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map((c)=>[
            c,
            c
        ]))), $ffdf60ebf0144301$var$objectFromEntries("0123456789".split("").map((n)=>[
            n,
            n
        ])))
};
function $ffdf60ebf0144301$var$objectFromEntries(array) {
    return array.reduce((memo, [k, v])=>Object.assign(Object.assign({}, memo), {
            [k]: v
        }), {});
}
class $ffdf60ebf0144301$export$16975c34e60e1e61 {
    constructor(element = document.documentElement, schema = $ffdf60ebf0144301$export$1db618b7b2275ea1){
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = (identifier, functionName, detail = {})=>{
            if (this.debug) this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new $ffdf60ebf0144301$var$Dispatcher(this);
        this.router = new $ffdf60ebf0144301$var$Router(this);
        this.actionDescriptorFilters = Object.assign({}, $ffdf60ebf0144301$var$defaultActionDescriptorFilters);
    }
    static start(element, schema) {
        const application = new this(element, schema);
        application.start();
        return application;
    }
    async start() {
        await $ffdf60ebf0144301$var$domReady();
        this.logDebugActivity("application", "starting");
        this.dispatcher.start();
        this.router.start();
        this.logDebugActivity("application", "start");
    }
    stop() {
        this.logDebugActivity("application", "stopping");
        this.dispatcher.stop();
        this.router.stop();
        this.logDebugActivity("application", "stop");
    }
    register(identifier, controllerConstructor) {
        this.load({
            identifier: identifier,
            controllerConstructor: controllerConstructor
        });
    }
    registerActionOption(name, filter) {
        this.actionDescriptorFilters[name] = filter;
    }
    load(head, ...rest) {
        const definitions = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        definitions.forEach((definition)=>{
            if (definition.controllerConstructor.shouldLoad) this.router.loadDefinition(definition);
        });
    }
    unload(head, ...rest) {
        const identifiers = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        identifiers.forEach((identifier)=>this.router.unloadIdentifier(identifier));
    }
    get controllers() {
        return this.router.contexts.map((context)=>context.controller);
    }
    getControllerForElementAndIdentifier(element, identifier) {
        const context = this.router.getContextForElementAndIdentifier(element, identifier);
        return context ? context.controller : null;
    }
    handleError(error, message, detail) {
        var _a;
        this.logger.error(`%s\n\n%o\n\n%o`, message, error, detail);
        (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
    }
    logFormattedMessage(identifier, functionName, detail = {}) {
        detail = Object.assign({
            application: this
        }, detail);
        this.logger.groupCollapsed(`${identifier} #${functionName}`);
        this.logger.log("details:", Object.assign({}, detail));
        this.logger.groupEnd();
    }
}
function $ffdf60ebf0144301$var$domReady() {
    return new Promise((resolve)=>{
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", ()=>resolve());
        else resolve();
    });
}
function $ffdf60ebf0144301$var$ClassPropertiesBlessing(constructor) {
    const classes = $ffdf60ebf0144301$var$readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce((properties, classDefinition)=>{
        return Object.assign(properties, $ffdf60ebf0144301$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $ffdf60ebf0144301$var$propertiesForClassDefinition(key) {
    return {
        [`${key}Class`]: {
            get () {
                const { classes: classes } = this;
                if (classes.has(key)) return classes.get(key);
                else {
                    const attribute = classes.getAttributeName(key);
                    throw new Error(`Missing attribute "${attribute}"`);
                }
            }
        },
        [`${key}Classes`]: {
            get () {
                return this.classes.getAll(key);
            }
        },
        [`has${$ffdf60ebf0144301$var$capitalize(key)}Class`]: {
            get () {
                return this.classes.has(key);
            }
        }
    };
}
function $ffdf60ebf0144301$var$OutletPropertiesBlessing(constructor) {
    const outlets = $ffdf60ebf0144301$var$readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce((properties, outletDefinition)=>{
        return Object.assign(properties, $ffdf60ebf0144301$var$propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function $ffdf60ebf0144301$var$getOutletController(controller, element, identifier) {
    return controller.application.getControllerForElementAndIdentifier(element, identifier);
}
function $ffdf60ebf0144301$var$getControllerAndEnsureConnectedScope(controller, element, outletName) {
    let outletController = $ffdf60ebf0144301$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
    controller.application.router.proposeToConnectScopeForElementAndIdentifier(element, outletName);
    outletController = $ffdf60ebf0144301$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
}
function $ffdf60ebf0144301$var$propertiesForOutletDefinition(name) {
    const camelizedName = $ffdf60ebf0144301$var$namespaceCamelize(name);
    return {
        [`${camelizedName}Outlet`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) {
                    const outletController = $ffdf60ebf0144301$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    throw new Error(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`);
                }
                throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}Outlets`]: {
            get () {
                const outlets = this.outlets.findAll(name);
                if (outlets.length > 0) return outlets.map((outletElement)=>{
                    const outletController = $ffdf60ebf0144301$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    console.warn(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`, outletElement);
                }).filter((controller)=>controller);
                return [];
            }
        },
        [`${camelizedName}OutletElement`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) return outletElement;
                else throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}OutletElements`]: {
            get () {
                return this.outlets.findAll(name);
            }
        },
        [`has${$ffdf60ebf0144301$var$capitalize(camelizedName)}Outlet`]: {
            get () {
                return this.outlets.has(name);
            }
        }
    };
}
function $ffdf60ebf0144301$var$TargetPropertiesBlessing(constructor) {
    const targets = $ffdf60ebf0144301$var$readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce((properties, targetDefinition)=>{
        return Object.assign(properties, $ffdf60ebf0144301$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $ffdf60ebf0144301$var$propertiesForTargetDefinition(name) {
    return {
        [`${name}Target`]: {
            get () {
                const target = this.targets.find(name);
                if (target) return target;
                else throw new Error(`Missing target element "${name}" for "${this.identifier}" controller`);
            }
        },
        [`${name}Targets`]: {
            get () {
                return this.targets.findAll(name);
            }
        },
        [`has${$ffdf60ebf0144301$var$capitalize(name)}Target`]: {
            get () {
                return this.targets.has(name);
            }
        }
    };
}
function $ffdf60ebf0144301$var$ValuePropertiesBlessing(constructor) {
    const valueDefinitionPairs = $ffdf60ebf0144301$var$readInheritableStaticObjectPairs(constructor, "values");
    const propertyDescriptorMap = {
        valueDescriptorMap: {
            get () {
                return valueDefinitionPairs.reduce((result, valueDefinitionPair)=>{
                    const valueDescriptor = $ffdf60ebf0144301$var$parseValueDefinitionPair(valueDefinitionPair, this.identifier);
                    const attributeName = this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, {
                        [attributeName]: valueDescriptor
                    });
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce((properties, valueDefinitionPair)=>{
        return Object.assign(properties, $ffdf60ebf0144301$var$propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $ffdf60ebf0144301$var$propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    const definition = $ffdf60ebf0144301$var$parseValueDefinitionPair(valueDefinitionPair, controller);
    const { key: key, name: name, reader: read, writer: write } = definition;
    return {
        [name]: {
            get () {
                const value = this.data.get(key);
                if (value !== null) return read(value);
                else return definition.defaultValue;
            },
            set (value) {
                if (value === undefined) this.data.delete(key);
                else this.data.set(key, write(value));
            }
        },
        [`has${$ffdf60ebf0144301$var$capitalize(name)}`]: {
            get () {
                return this.data.has(key) || definition.hasCustomDefaultValue;
            }
        }
    };
}
function $ffdf60ebf0144301$var$parseValueDefinitionPair([token, typeDefinition], controller) {
    return $ffdf60ebf0144301$var$valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function $ffdf60ebf0144301$var$parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function $ffdf60ebf0144301$var$parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function $ffdf60ebf0144301$var$parseValueTypeObject(payload) {
    const { controller: controller, token: token, typeObject: typeObject } = payload;
    const hasType = $ffdf60ebf0144301$var$isSomething(typeObject.type);
    const hasDefault = $ffdf60ebf0144301$var$isSomething(typeObject.default);
    const fullObject = hasType && hasDefault;
    const onlyType = hasType && !hasDefault;
    const onlyDefault = !hasType && hasDefault;
    const typeFromObject = $ffdf60ebf0144301$var$parseValueTypeConstant(typeObject.type);
    const typeFromDefaultValue = $ffdf60ebf0144301$var$parseValueTypeDefault(payload.typeObject.default);
    if (onlyType) return typeFromObject;
    if (onlyDefault) return typeFromDefaultValue;
    if (typeFromObject !== typeFromDefaultValue) {
        const propertyPath = controller ? `${controller}.${token}` : token;
        throw new Error(`The specified default value for the Stimulus Value "${propertyPath}" must match the defined type "${typeFromObject}". The provided default value of "${typeObject.default}" is of type "${typeFromDefaultValue}".`);
    }
    if (fullObject) return typeFromObject;
}
function $ffdf60ebf0144301$var$parseValueTypeDefinition(payload) {
    const { controller: controller, token: token, typeDefinition: typeDefinition } = payload;
    const typeObject = {
        controller: controller,
        token: token,
        typeObject: typeDefinition
    };
    const typeFromObject = $ffdf60ebf0144301$var$parseValueTypeObject(typeObject);
    const typeFromDefaultValue = $ffdf60ebf0144301$var$parseValueTypeDefault(typeDefinition);
    const typeFromConstant = $ffdf60ebf0144301$var$parseValueTypeConstant(typeDefinition);
    const type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    const propertyPath = controller ? `${controller}.${typeDefinition}` : token;
    throw new Error(`Unknown value type "${propertyPath}" for "${token}" value`);
}
function $ffdf60ebf0144301$var$defaultValueForDefinition(typeDefinition) {
    const constant = $ffdf60ebf0144301$var$parseValueTypeConstant(typeDefinition);
    if (constant) return $ffdf60ebf0144301$var$defaultValuesByType[constant];
    const hasDefault = $ffdf60ebf0144301$var$hasProperty(typeDefinition, "default");
    const hasType = $ffdf60ebf0144301$var$hasProperty(typeDefinition, "type");
    const typeObject = typeDefinition;
    if (hasDefault) return typeObject.default;
    if (hasType) {
        const { type: type } = typeObject;
        const constantFromType = $ffdf60ebf0144301$var$parseValueTypeConstant(type);
        if (constantFromType) return $ffdf60ebf0144301$var$defaultValuesByType[constantFromType];
    }
    return typeDefinition;
}
function $ffdf60ebf0144301$var$valueDescriptorForTokenAndTypeDefinition(payload) {
    const { token: token, typeDefinition: typeDefinition } = payload;
    const key = `${$ffdf60ebf0144301$var$dasherize(token)}-value`;
    const type = $ffdf60ebf0144301$var$parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: $ffdf60ebf0144301$var$camelize(key),
        get defaultValue () {
            return $ffdf60ebf0144301$var$defaultValueForDefinition(typeDefinition);
        },
        get hasCustomDefaultValue () {
            return $ffdf60ebf0144301$var$parseValueTypeDefault(typeDefinition) !== undefined;
        },
        reader: $ffdf60ebf0144301$var$readers[type],
        writer: $ffdf60ebf0144301$var$writers[type] || $ffdf60ebf0144301$var$writers.default
    };
}
const $ffdf60ebf0144301$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
const $ffdf60ebf0144301$var$readers = {
    array (value) {
        const array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError(`expected value of type "array" but instead got value "${value}" of type "${$ffdf60ebf0144301$var$parseValueTypeDefault(array)}"`);
        return array;
    },
    boolean (value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number (value) {
        return Number(value.replace(/_/g, ""));
    },
    object (value) {
        const object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError(`expected value of type "object" but instead got value "${value}" of type "${$ffdf60ebf0144301$var$parseValueTypeDefault(object)}"`);
        return object;
    },
    string (value) {
        return value;
    }
};
const $ffdf60ebf0144301$var$writers = {
    default: $ffdf60ebf0144301$var$writeString,
    array: $ffdf60ebf0144301$var$writeJSON,
    object: $ffdf60ebf0144301$var$writeJSON
};
function $ffdf60ebf0144301$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $ffdf60ebf0144301$var$writeString(value) {
    return `${value}`;
}
class $ffdf60ebf0144301$export$bd0bf19f25da8474 {
    constructor(context){
        this.context = context;
    }
    static get shouldLoad() {
        return true;
    }
    static afterLoad(_identifier, _application) {
        return;
    }
    get application() {
        return this.context.application;
    }
    get scope() {
        return this.context.scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get targets() {
        return this.scope.targets;
    }
    get outlets() {
        return this.scope.outlets;
    }
    get classes() {
        return this.scope.classes;
    }
    get data() {
        return this.scope.data;
    }
    initialize() {}
    connect() {}
    disconnect() {}
    dispatch(eventName, { target: target = this.element, detail: detail = {}, prefix: prefix = this.identifier, bubbles: bubbles = true, cancelable: cancelable = true } = {}) {
        const type = prefix ? `${prefix}:${eventName}` : eventName;
        const event = new CustomEvent(type, {
            detail: detail,
            bubbles: bubbles,
            cancelable: cancelable
        });
        target.dispatchEvent(event);
        return event;
    }
}
$ffdf60ebf0144301$export$bd0bf19f25da8474.blessings = [
    $ffdf60ebf0144301$var$ClassPropertiesBlessing,
    $ffdf60ebf0144301$var$TargetPropertiesBlessing,
    $ffdf60ebf0144301$var$ValuePropertiesBlessing,
    $ffdf60ebf0144301$var$OutletPropertiesBlessing
];
$ffdf60ebf0144301$export$bd0bf19f25da8474.targets = [];
$ffdf60ebf0144301$export$bd0bf19f25da8474.outlets = [];
$ffdf60ebf0144301$export$bd0bf19f25da8474.values = {};




class $0fe7b0a7d9b54c4f$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "noteForm",
        "noteInput",
        "charCounter",
        "error"
    ];
    connect() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ActivityDetailsController: Connected");
        this.autosaveDisabled = false;
        if (this.hasCharCounterTarget) this.charCounterTarget.classList.add("hidden");
        this.initialValue = this.hasNoteInputTarget ? this.noteInputTarget.value.trim() : "";
    }
    submitNote() {
        if (!this.hasNoteInputTarget || !this.hasNoteFormTarget) return;
        const currentValue = this.noteInputTarget.value.trim();
        if (this.autosaveDisabled) {
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Autosave disabled due to validation error");
            return;
        }
        if (currentValue === this.initialValue) {
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("No changes detected, skipping submit");
            return;
        }
        this.noteFormTarget.requestSubmit();
        this.initialValue = currentValue;
    }
    updateCounter() {
        if (!this.hasNoteInputTarget) return;
        const max = 200;
        const length = this.noteInputTarget.value.length;
        if (this.hasCharCounterTarget) {
            const counter = this.charCounterTarget;
            counter.textContent = `${length}/${max}`;
            counter.classList.toggle("hidden", length <= 175);
            counter.classList.toggle("text-red-600", max - length <= 20);
        }
        const overLimit = length >= max;
        if (this.hasErrorTarget) this.errorTarget.classList.toggle("hidden", !overLimit);
        this.autosaveDisabled = overLimit;
    }
}


// controllers/bottom_sheet_controller.js


class $0d2393a740ce2a5b$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "backdrop",
        "sheet",
        "container",
        "scrollIndicator"
    ];
    static values = {
        closeModalDeltaY: {
            type: Number,
            default: 100
        },
        redirectUrl: {
            type: String,
            default: ""
        }
    };
    connect() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("BottomSheetController: Connected");
        // Bind once so removeEventListener works
        this._onTouchStart = this.handleTouchStart.bind(this);
        this._onTouchMove = this.handleTouchMove.bind(this);
        this._onTouchEnd = this.handleTouchEnd.bind(this);
        this._onKeydown = this._handleKeydown.bind(this);
        if ((0, $6adb56df0e842c64$export$44f917bf91becd01)()) {
            this.setupScrollToClose();
            if (this.hasScrollIndicatorTarget) this.scrollIndicatorTarget.classList.remove("hidden");
        }
        this.animateIn();
        // Optional: allow Esc to close
        document.addEventListener("keydown", this._onKeydown);
    }
    disconnect() {
        this.removeScrollToClose();
        document.removeEventListener("keydown", this._onKeydown);
    }
    animateIn() {
        if (this.hasBackdropTarget) this.backdropTarget.classList.add("opacity-0");
        if (this.hasSheetTarget) {
            this.sheetTarget.style.transform = "translateY(16px)";
            this.sheetTarget.style.opacity = "0";
        }
        requestAnimationFrame(()=>{
            if (this.hasBackdropTarget) this.backdropTarget.classList.remove("opacity-0");
            if (this.hasSheetTarget) {
                this.sheetTarget.style.transform = "translateY(0)";
                this.sheetTarget.style.opacity = "1";
            }
        });
    }
    setupScrollToClose() {
        if (!this.hasContainerTarget && !this.hasSheetTarget) return;
        this.touchStartY = 0;
        this.touchStartTime = 0;
        this.isScrolling = false;
        // Listen on both container and sheet (same as your working behavior)
        const elements = [
            this.containerTarget,
            this.sheetTarget
        ];
        elements.forEach((el)=>{
            if (!el) return;
            el.addEventListener("touchstart", this._onTouchStart, {
                passive: true
            });
            el.addEventListener("touchmove", this._onTouchMove, {
                passive: true
            });
            el.addEventListener("touchend", this._onTouchEnd, {
                passive: true
            });
        });
    }
    removeScrollToClose() {
        if (!this.hasContainerTarget && !this.hasSheetTarget) return;
        const elements = [
            this.containerTarget,
            this.sheetTarget
        ];
        elements.forEach((el)=>{
            if (!el) return;
            el.removeEventListener("touchstart", this._onTouchStart);
            el.removeEventListener("touchmove", this._onTouchMove);
            el.removeEventListener("touchend", this._onTouchEnd);
        });
    }
    handleTouchStart(event) {
        this.touchStartY = event.touches[0].clientY;
        this.touchStartTime = Date.now();
        this.isScrolling = false;
        this.touchTarget = event.target;
    }
    handleTouchMove(event) {
        if (!this.touchStartY) return;
        const currentY = event.touches[0].clientY;
        const deltaY = currentY - this.touchStartY;
        // Mark as scrolling once pulled down a bit
        if (deltaY > 50) this.isScrolling = true;
        // Visual nudge once past threshold (use transform instead of top)
        if (deltaY > this.closeModalDeltaYValue) this.sheetTarget.style.transform = "translateY(20px)";
    }
    handleTouchEnd(event) {
        if (!this.touchStartY) return;
        const touchEndTime = Date.now();
        const touchDuration = touchEndTime - this.touchStartTime;
        const currentY = event.changedTouches[0].clientY;
        const deltaY = currentY - this.touchStartY;
        // Close if pulled down past threshold for at least 250ms
        if (this.isScrolling && deltaY > this.closeModalDeltaYValue && touchDuration > 250) this.closeModal();
        // Reset
        this.touchStartY = 0;
        this.touchStartTime = 0;
        this.isScrolling = false;
        this.touchTarget = null;
        this.sheetTarget.style.transform = ""; // reset transform (was "top" before)
    }
    closeModal() {
        if (this.hasContainerTarget) {
            this.containerTarget.setAttribute("inert", "");
            this.containerTarget.setAttribute("aria-hidden", "true");
            this.containerTarget.classList.add("hidden");
        }
    }
    closeModalAndRedirect() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("BottomSheetController: Closing modal and redirecting");
        this.closeModal();
        if (this.redirectUrlValue) {
            Turbo.visit(this.redirectUrlValue);
            return;
        }
    }
    closeModalAndGoHome() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("BottomSheetController: Closing modal and going home");
        this.closeModal();
        Turbo.visit("/home");
    }
    close() {
        this.closeModal();
    }
    // Optional: Esc key to close
    _handleKeydown(e) {
        if (e.key === "Escape") this.closeModal();
    }
}



class $2de639c5274864bf$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        text: String
    };
    async copy() {
        const text = this.textValue;
        if (!text) return;
        try {
            await navigator.clipboard.writeText(text);
            this.flash("Copied!");
        } catch  {
            // fallback for older browsers
            const ta = document.createElement("textarea");
            ta.value = text;
            ta.style.position = "fixed";
            ta.style.left = "-9999px";
            document.body.appendChild(ta);
            ta.select();
            try {
                document.execCommand("copy");
            } catch  {}
            document.body.removeChild(ta);
            this.flash("Copied!");
        }
    }
    flash(msg) {
        const el = document.createElement("div");
        el.textContent = msg;
        el.setAttribute("role", "status");
        el.className = [
            "fixed bottom-6 left-1/2 -translate-x-1/2",
            "z-[9999]",
            "rounded-full bg-black/80 text-white",
            "px-3 py-1 text-sm pointer-events-none",
            "shadow-lg"
        ].join(" ");
        document.body.appendChild(el);
        setTimeout(()=>el.remove(), 1200);
    }
}



class $09dac291a2d3c419$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "menuLink"
    ];
    connect() {
        const platform = this.detectPlatform();
        this.addPlatformParam(platform);
    }
    addPlatformParam(platform) {
        if (platform === "other") return;
        const link = this.menuLinkTarget;
        const url = new URL(link.href, window.location.origin);
        if (!url.searchParams.has("platform")) {
            url.searchParams.set("platform", platform);
            link.href = url.toString();
        }
    }
    detectPlatform() {
        const ua = navigator.userAgent.toLowerCase();
        if (/android/.test(ua)) return "android";
        if (/iphone|ipad|ipod/.test(ua)) return "ios";
        return "other" // desktop, Mac, Windows, Linux, itd.
        ;
    }
}




class $d44da964cbbc9d19$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "note",
        "charCounter",
        "error",
        "confirmButton"
    ];
    static values = {
        max: {
            type: Number,
            default: 200
        }
    };
    connect() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("NoteLimitController: Connected");
        if (this.hasCharCounterTarget) this.charCounterTarget.classList.add("hidden");
    }
    update(event) {
        if (!this.hasNoteTarget) return;
        const length = this.noteTarget.value.length;
        const max = this.maxValue;
        if (this.hasCharCounterTarget) {
            const counter = this.charCounterTarget;
            counter.textContent = `${length}/${max}`;
            counter.classList.toggle("hidden", length <= 175);
            counter.classList.toggle("text-red-400", max - length <= 20);
        }
        const overLimit = length > max;
        if (this.hasErrorTarget) this.errorTarget.classList.toggle("hidden", !overLimit);
        if (this.hasConfirmButtonTarget) {
            const btn = this.confirmButtonTarget;
            btn.disabled = overLimit;
            btn.classList.toggle("opacity-50", overLimit);
            btn.classList.toggle("cursor-not-allowed", overLimit);
            btn.classList.toggle("pointer-events-none", overLimit);
        }
        if (overLimit) event.stopImmediatePropagation();
    }
}




const $7698590c42a3bf25$var$SESSION_STORAGE_KEY = "rr_sid";
function $7698590c42a3bf25$var$getSessionToken() {
    if (window.RR_SESSION) return window.RR_SESSION;
    try {
        return window.sessionStorage.getItem($7698590c42a3bf25$var$SESSION_STORAGE_KEY) || "";
    } catch  {
        return "";
    }
}
function $7698590c42a3bf25$var$isEmbedded() {
    try {
        return window.top !== window.self;
    } catch  {
        return true;
    }
}
function $7698590c42a3bf25$export$18b31d9eba2a1098(input, init = {}) {
    const options = {
        ...init
    };
    const headers = new Headers(init && init.headers ? init.headers : {});
    if ($7698590c42a3bf25$var$isEmbedded()) headers.set("X-RR-Embed", "1");
    const token = $7698590c42a3bf25$var$getSessionToken();
    if (token) headers.set("X-Session", token);
    const tier = (0, $6adb56df0e842c64$export$f1768d02d4612c4)();
    headers.set("X-RR-Device", tier);
    options.headers = headers;
    return fetch(input, options);
}


class $2a866666cc7fe055$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "marquee"
    ];
    connect() {
        // Fade-in
        requestAnimationFrame(()=>{
            this.element.classList.remove("opacity-0", "translate-y-5");
            this.element.classList.add("opacity-100", "translate-y-0");
        });
    }
    close() {
        (0, $7698590c42a3bf25$export$18b31d9eba2a1098)("/close-notification", {
            method: "GET",
            headers: {
                "X-Requested-With": "Turbo"
            },
            credentials: "same-origin"
        });
        this.element.classList.add("opacity-0", "translate-y-5");
        this.element.classList.remove("opacity-100", "translate-y-0");
        setTimeout(()=>this.element.remove(), 300);
    }
}




class $dfa73c3fc15fa86c$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "input",
        "dot",
        "submitButton",
        "form"
    ];
    connect() {
        this.updateDots();
        this.inputTarget.addEventListener("input", this.updateDots.bind(this));
        // Listen for form submission errors
        this.formTarget.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this));
    }
    disconnect() {
        this.inputTarget.removeEventListener("input", this.updateDots.bind(this));
        this.formTarget.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this));
    }
    handleSubmitEnd(event) {
        // If submission failed (non-2xx response), clear the PIN
        if (!event.detail.success) this.clearPin();
    }
    clearPin() {
        // Clear the input value
        this.inputTarget.value = "";
        // Update dots to show empty state
        this.updateDots();
        // Optional: Add shake animation
        this.dotTargets.forEach((dot)=>{
            dot.classList.add("animate-shake");
            setTimeout(()=>{
                dot.classList.remove("animate-shake");
            }, 500);
        });
    }
    updateDots() {
        const value = this.inputTarget.value || "";
        const length = value.length;
        this.dotTargets.forEach((dot, i)=>{
            const circle = dot.querySelector("circle");
            if (i < length) circle.setAttribute("opacity", "1");
            else circle.setAttribute("opacity", "0.5");
        });
        // enable/disable button
        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = length !== 4;
            if (!this.submitButtonTarget.disabled) this.formTarget.requestSubmit();
        // if (this.submitButtonTarget.disabled) {
        //     this.submitButtonTarget.classList.remove("bg-black")
        //     this.submitButtonTarget.classList.add("bg-black/15")
        // }
        // else {
        //     this.submitButtonTarget.classList.remove("bg-black/15")
        //     this.submitButtonTarget.classList.add("bg-black")
        // }
        }
    }
}




class $48e235641eb2db9b$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "note",
        "form",
        "hiddenNote"
    ];
    connect() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ProcessTransferController: connected");
    }
    attachNote() {
        if (!this.hasNoteTarget) return;
        const noteValue = this.noteTarget?.value?.trim() || "";
        if (this.hasHiddenNoteTarget) this.hiddenNoteTarget.value = noteValue;
    }
}



const $67507a6d7a4c301d$var$INDICATOR_ID = 'pull-to-refresh-indicator';
const $67507a6d7a4c301d$var$SPINNER_HEIGHT = 60;
const $67507a6d7a4c301d$var$CONTENT_OFFSET_MAX = 40;
const $67507a6d7a4c301d$var$DEFAULT_FRAME = 'content';
const $67507a6d7a4c301d$var$TRANSITION_DURATION = '0.5s';
const $67507a6d7a4c301d$var$TRANSITION_EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
const $67507a6d7a4c301d$var$HIDE_DELAY = 400;
const $67507a6d7a4c301d$var$REFRESH_DELAY = 500;
const $67507a6d7a4c301d$var$PULL_RESISTANCE = 0.5 // Higher = more resistance (0-1)
;
const $67507a6d7a4c301d$var$MIN_PULL_DISTANCE = 30 // Small threshold before drag starts (prevents accidental triggers)
;
class $67507a6d7a4c301d$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "bottomSheetContainer",
        "indicator"
    ];
    static values = {
        threshold: {
            type: Number,
            default: 180
        },
        disabled: {
            type: Boolean,
            default: false
        },
        path: {
            type: String,
            default: ""
        },
        frame: {
            type: String,
            default: $67507a6d7a4c301d$var$DEFAULT_FRAME
        },
        target: {
            type: String,
            default: ""
        }
    };
    connect() {
        this.startY = 0;
        this.currentY = 0;
        this.isRefreshing = false;
        this.isZooming = false;
        this.hasVibratedThisPull = false;
        this.initialTouchDistance = 0;
        this.timeoutIds = [];
        this.indicator = null;
        this.contentFrame = null;
        this.scrollableContent = null;
        this.gradientDiv = null;
        this.boundHandleTouchStart = this.handleTouchStart.bind(this);
        this.boundHandleTouchMove = this.handleTouchMove.bind(this);
        this.boundHandleTouchEnd = this.handleTouchEnd.bind(this);
        this.boundHandleFrameLoad = this.handleFrameLoad.bind(this);
        document.addEventListener('touchstart', this.boundHandleTouchStart, {
            passive: true
        });
        document.addEventListener('touchmove', this.boundHandleTouchMove, {
            passive: false
        });
        document.addEventListener('touchend', this.boundHandleTouchEnd, {
            passive: true
        });
        document.addEventListener('turbo:frame-load', this.boundHandleFrameLoad);
    }
    handleFrameLoad() {
        this.resetCache();
    }
    resetCache() {
        this.contentFrame = null;
        this.scrollableContent = null;
        this.gradientDiv = null;
    }
    disconnect() {
        document.removeEventListener('touchstart', this.boundHandleTouchStart);
        document.removeEventListener('touchmove', this.boundHandleTouchMove);
        document.removeEventListener('touchend', this.boundHandleTouchEnd);
        document.removeEventListener('turbo:frame-load', this.boundHandleFrameLoad);
        this.clearAllTimeouts();
        this.hideIndicator();
        this.resetContentPosition();
        this.resetCache();
    }
    clearAllTimeouts() {
        this.timeoutIds.forEach((id)=>clearTimeout(id));
        this.timeoutIds = [];
    }
    setManagedTimeout(callback, delay) {
        const id = setTimeout(()=>{
            callback();
            this.timeoutIds = this.timeoutIds.filter((timeoutId)=>timeoutId !== id);
        }, delay);
        this.timeoutIds.push(id);
        return id;
    }
    handleTouchStart(event) {
        // Detect multi-touch (pinch-to-zoom)
        if (event.touches.length > 1) {
            this.isZooming = true;
            this.initialTouchDistance = this.calculateTouchDistance(event.touches);
            return;
        }
        if (!this.canStartPull(event)) return;
        this.startY = event.touches[0].clientY;
    }
    calculateTouchDistance(touches) {
        if (touches.length < 2) return 0;
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.hypot(dx * dx + dy * dy);
    }
    handleTouchMove(event) {
        // Detect multi-touch (zoom gesture)
        if (event.touches.length > 1) {
            this.isZooming = true;
            return;
        }
        // Don't pull-to-refresh during or after zoom
        if (this.isZooming) return;
        if (!this.startY || this.isRefreshing || !this.hasValidTouch(event)) return;
        // Check if pull-to-refresh should be disabled
        if (this.isBottomSheetOpen() || this.canScrollUp()) return;
        this.currentY = event.touches[0].clientY;
        const pullDistance = this.currentY - this.startY;
        // Start smooth drag after small threshold (30px) to prevent accidental triggers
        if (pullDistance > $67507a6d7a4c301d$var$MIN_PULL_DISTANCE && this.isAtTop()) {
            event.preventDefault();
            const progress = this.calculateProgress(pullDistance);
            this.updateIndicator(progress, pullDistance);
            this.moveContentDown(pullDistance);
            // Vibrate when threshold reached (haptic feedback)
            if (pullDistance >= this.thresholdValue && !this.hasVibratedThisPull) {
                // Try vibration (works on Android)
                if (navigator.vibrate) navigator.vibrate(50);
                this.hasVibratedThisPull = true;
            }
        } else if (pullDistance > 0 && this.isAtTop()) // Allow pull but don't show indicator until minimum distance
        event.preventDefault();
    }
    handleTouchEnd() {
        if (!this.startY) {
            this.resetTouchState();
            return;
        }
        const pullDistance = this.currentY - this.startY;
        if (pullDistance >= this.thresholdValue && !this.isRefreshing && !this.isZooming) this.refresh();
        else {
            this.hideIndicator();
            this.resetContentPosition();
        }
        this.resetTouchState();
    }
    canStartPull(event) {
        return this.isEnabled() && this.isAtTop() && !this.isRefreshing && this.hasValidTouch(event) && !this.isBottomSheetOpen() && !this.canScrollUp();
    }
    isAtTop() {
        const scrollableContent = this.getScrollableContent();
        if (scrollableContent) // Check if scrollable content is at the top
        return scrollableContent.scrollTop === 0;
        // Fallback to window scroll position
        return globalThis.scrollY === 0;
    }
    hasValidTouch(event) {
        return event.touches && event.touches.length > 0;
    }
    calculateProgress(distance) {
        return Math.min(distance / this.thresholdValue, 1);
    }
    resetTouchState() {
        this.startY = 0;
        this.currentY = 0;
        this.isZooming = false;
        this.hasVibratedThisPull = false;
        this.initialTouchDistance = 0;
    }
    getIndicator() {
        // Use Stimulus target if available
        if (this.hasIndicatorTarget) return this.indicatorTarget;
        // Fallback: cache and return if already found
        if (this.indicator && this.indicator.isConnected) return this.indicator;
        const contentFrame = this.getContentFrame();
        if (!contentFrame) return null;
        // Fallback: query for the indicator element by ID
        this.indicator = contentFrame.querySelector(`#${$67507a6d7a4c301d$var$INDICATOR_ID}`);
        return this.indicator;
    }
    updateIndicator(progress, distance) {
        const indicator = this.getIndicator();
        if (!indicator) return;
        const resistedDistance = this.applyPullResistance(distance);
        const progressRatio = this.normalizeDistance(resistedDistance);
        const atOrPastThreshold = progress >= 1;
        const rotation = atOrPastThreshold ? 360 : progress * 360;
        const scale = atOrPastThreshold ? 1 : 0.8 + progress * 0.2;
        const opacity = atOrPastThreshold ? 1 : Math.min(progressRatio * 1.5, 1);
        const easedProgress = 1 - Math.pow(1 - Math.min(progressRatio, 1), 2);
        const translateY = atOrPastThreshold ? 0 : -$67507a6d7a4c301d$var$SPINNER_HEIGHT + easedProgress * $67507a6d7a4c301d$var$SPINNER_HEIGHT;
        this.updateSpinnerContent(indicator, rotation, scale, progress, atOrPastThreshold);
        indicator.style.opacity = opacity.toString();
        indicator.style.transform = `translateY(${translateY}px)`;
        indicator.style.transition = 'none';
    }
    updateSpinnerContent(indicator, rotation, scale, progress, atOrPastThreshold) {
        if (!indicator.querySelector('svg')) indicator.innerHTML = this.buildSpinnerHTML(rotation, scale);
        const svg = indicator.querySelector('svg');
        const container = indicator.querySelector('div');
        if (svg) {
            svg.classList.remove('animate-spin');
            svg.style.animation = '';
            svg.style.transform = `rotate(${rotation}deg)`;
        }
        if (container) {
            container.style.transform = `scale(${scale})`;
            const minOpacity = 0.2;
            const maxOpacity = 0.7;
            const backdropOpacity = atOrPastThreshold ? maxOpacity : minOpacity + progress * (maxOpacity - minOpacity);
            container.style.backgroundColor = `rgba(255, 255, 255, ${backdropOpacity})`;
        }
    }
    buildSpinnerHTML(rotation, scale) {
        return `
            <div class="bg-white/20 backdrop-blur-sm rounded-full p-3"
                 style="transform: scale(${scale});">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
                     style="transform: rotate(${rotation}deg); transition: transform 0.15s ease-out;">
                    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8M21 8v-5M21 8h-5M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16M21 16v5M21 16h-5"/>
                </svg>
            </div>
        `;
    }
    normalizeDistance(distance) {
        const normalized = Math.min(Math.max(distance, 0), this.thresholdValue) / this.thresholdValue;
        // Apply smooth easing with resistance; clamp output to [0, 1]
        const eased = 1 - Math.pow(1 - normalized, 3);
        return Math.max(0, Math.min(1, eased));
    }
    applyPullResistance(distance) {
        const maxDistance = this.thresholdValue * 1.5;
        if (distance <= this.thresholdValue) return distance;
        const excess = distance - this.thresholdValue;
        const range = maxDistance - this.thresholdValue;
        const resistance = Math.max(0, 1 - excess / range * $67507a6d7a4c301d$var$PULL_RESISTANCE);
        const resisted = this.thresholdValue + excess * resistance;
        return Math.min(Math.max(resisted, 0), maxDistance);
    }
    hideIndicator() {
        const indicator = this.getIndicator();
        if (!indicator) return;
        // Smooth fade out and slide up
        indicator.style.transition = `opacity 0.5s ${$67507a6d7a4c301d$var$TRANSITION_EASING}, transform 0.5s ${$67507a6d7a4c301d$var$TRANSITION_EASING}`;
        indicator.style.opacity = '0';
        indicator.style.transform = `translateY(-${$67507a6d7a4c301d$var$SPINNER_HEIGHT}px)`;
        // Reset the spinner animation
        const svg = indicator.querySelector('svg');
        if (svg) {
            svg.classList.remove('animate-spin');
            svg.style.animation = '';
        }
        const container = indicator.querySelector('div');
        if (container) container.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
    }
    getContentFrame() {
        if (this.contentFrame && this.contentFrame.isConnected) return this.contentFrame;
        if (this.hasTargetValue && this.targetValue) {
            // Prefer this.element.querySelector over document.querySelector (Stimulus best practice)
            this.contentFrame = this.element.querySelector(this.targetValue);
            if (this.contentFrame) return this.contentFrame;
        }
        const frameId = this.frameValue || $67507a6d7a4c301d$var$DEFAULT_FRAME;
        // Prefer this.element.querySelector and getElementById over document.querySelector
        this.contentFrame = this.element.querySelector(`#${frameId}`) || this.element.querySelector(`turbo-frame#${frameId}`) || document.getElementById(frameId) || this.element.querySelector('turbo-frame:not([src=""])');
        return this.contentFrame;
    }
    getScrollableContent() {
        if (this.scrollableContent && this.scrollableContent.isConnected) return this.scrollableContent;
        const contentFrame = this.getContentFrame();
        if (!contentFrame) return null;
        // Find the scrollable section (waas-modal) inside the frame
        this.scrollableContent = contentFrame.querySelector('#waas-modal.waas-modal') || contentFrame.querySelector('dialog.waas-modal') || contentFrame.querySelector('.waas-modal');
        return this.scrollableContent;
    }
    getGradientDiv() {
        if (this.gradientDiv && this.gradientDiv.isConnected) return this.gradientDiv;
        const contentFrame = this.getContentFrame();
        if (contentFrame) this.gradientDiv = contentFrame.querySelector('.bg-wallet-gradient');
        return this.gradientDiv;
    }
    getRefreshPath() {
        return this.hasPathValue && this.pathValue ? this.pathValue : globalThis.location?.pathname || '';
    }
    getRefreshFrame() {
        return this.frameValue || $67507a6d7a4c301d$var$DEFAULT_FRAME;
    }
    moveContentDown(distance) {
        const scrollableContent = this.getScrollableContent();
        if (!scrollableContent) return;
        // Apply progressive resistance to make pull feel natural
        const resistedDistance = this.applyPullResistance(distance);
        const progressRatio = this.normalizeDistance(resistedDistance);
        // Use smooth easing curve for content offset; clamp so we never translate off-screen
        const easedProgress = Math.max(0, Math.min(1, 1 - Math.pow(1 - progressRatio, 2)));
        const contentOffset = Math.max(0, Math.min($67507a6d7a4c301d$var$CONTENT_OFFSET_MAX, easedProgress * $67507a6d7a4c301d$var$CONTENT_OFFSET_MAX));
        // Move only the scrollable content, not the frame
        scrollableContent.style.transform = `translateY(${contentOffset}px)`;
        scrollableContent.style.transition = 'none';
    }
    resetContentPosition() {
        const scrollableContent = this.getScrollableContent();
        if (!scrollableContent) return;
        // Smooth transition back
        const transition = `transform ${$67507a6d7a4c301d$var$TRANSITION_DURATION} ${$67507a6d7a4c301d$var$TRANSITION_EASING}`;
        scrollableContent.style.transition = transition;
        scrollableContent.style.transform = 'translateY(0)';
        this.setManagedTimeout(()=>{
            if (scrollableContent) scrollableContent.style.transition = '';
        }, 500);
    }
    async refresh() {
        if (!this.isEnabled()) return;
        this.isRefreshing = true;
        // Do not call showSpinner() — indicator is already visible and spinning
        const refreshPath = this.getRefreshPath();
        const refreshFrame = this.getRefreshFrame();
        if (refreshPath && globalThis.Turbo) globalThis.Turbo.visit(refreshPath, {
            frame: refreshFrame,
            action: 'replace'
        });
        // Hide indicator first, then reset content, then allow new pulls
        this.setManagedTimeout(()=>{
            this.hideIndicator();
            this.setManagedTimeout(()=>{
                this.resetContentPosition();
                this.isRefreshing = false;
            }, $67507a6d7a4c301d$var$HIDE_DELAY);
        }, $67507a6d7a4c301d$var$REFRESH_DELAY);
    }
    showSpinner() {
        const indicator = this.getIndicator();
        if (!indicator) return;
        const svg = indicator.querySelector('svg');
        if (svg) {
            svg.classList.add('animate-spin');
            // Smooth spin animation - slower
            svg.style.animation = 'spin 1.2s linear infinite';
            svg.style.transition = 'transform 0.3s ease-out';
        }
        // Smooth transition to visible state
        indicator.style.transition = `opacity ${$67507a6d7a4c301d$var$TRANSITION_DURATION} ${$67507a6d7a4c301d$var$TRANSITION_EASING}, transform ${$67507a6d7a4c301d$var$TRANSITION_DURATION} ${$67507a6d7a4c301d$var$TRANSITION_EASING}`;
        indicator.style.opacity = '1';
        indicator.style.transform = 'translateY(0)';
    }
    isEnabled() {
        return !this.disabledValue;
    }
    isBottomSheetOpen() {
        // Use Stimulus API to get bottom sheet controller instead of querySelector
        // Try to find bottom sheet container element (prefer target, fallback to getElementById)
        let bottomSheetElement = null;
        if (this.hasBottomSheetContainerTarget) bottomSheetElement = this.bottomSheetContainerTarget;
        else bottomSheetElement = document.getElementById('bottomsheet-container');
        if (!bottomSheetElement) return false;
        // Get bottom sheet controller using Stimulus API
        const bottomSheetController = this.application.getControllerForElementAndIdentifier(bottomSheetElement, 'bottom-sheet');
        if (!bottomSheetController) return false;
        // Check if bottom sheet has sheet target and is visible
        if (!bottomSheetController.hasSheetTarget) return false;
        const sheet = bottomSheetController.sheetTarget;
        const style = globalThis.getComputedStyle(sheet);
        // Check if bottom sheet is actually visible (not hidden by display:none or opacity:0)
        return style.display !== 'none' && style.opacity !== '0' && style.visibility !== 'hidden' && bottomSheetElement.children.length > 0;
    }
    canScrollUp() {
        const scrollableContent = this.getScrollableContent();
        if (scrollableContent) // If scrollable content can scroll up (scrollTop > 0), disable pull-to-refresh
        return scrollableContent.scrollTop > 0;
        // Fallback: check window scroll
        return globalThis.scrollY > 0;
    }
}




class $40a841ce98f90850$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static installPromptEvent = null;
    connect() {
        if (window._pwaDeferredPrompt) this.constructor.installPromptEvent = window._pwaDeferredPrompt;
        window.addEventListener("beforeinstallprompt", (event)=>{
            event.preventDefault();
            this.constructor.installPromptEvent = event;
            window._pwaDeferredPrompt = event;
        });
    }
    async addToAndroidScreen() {
        const promptEvent = this.constructor.installPromptEvent;
        if (!promptEvent) {
            console.warn("[PWA] No install prompt event found yet!");
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("No install prompt event found");
            alert("Your browser does not support PWA installation or the event hasn\u2019t fired yet.");
            return;
        }
        try {
            promptEvent.prompt();
            const { outcome: outcome } = await promptEvent.userChoice;
        } catch (err) {
            console.error("[PWA] Error showing prompt:", err);
        } finally{
            this.constructor.installPromptEvent = null;
            console.log("[PWA] installPromptEvent reset to null");
        }
    }
}




class $fd1e3425a7cbbc5e$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "installLink"
    ];
    connect() {
        const platform = this.detectPlatform();
        const isPWA = this.isPWAInstalled();
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)(`Platform: ${platform}`);
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)(`Is PWA Installed: ${isPWA}`);
        if (isPWA || platform === "other") {
            this.element.classList.add("hidden");
            return;
        }
        if (this.hasInstallLinkTarget) this.addPlatformParam(platform);
    }
    detectPlatform() {
        const ua = navigator.userAgent.toLowerCase();
        if (/android/.test(ua)) return "android";
        if (/iphone|ipad|ipod/.test(ua)) return "ios";
        return "other" // desktop, Mac, Windows, Linux, itd.
        ;
    }
    isPWAInstalled() {
        // iOS PWA check
        if (window.navigator.standalone === true) return true;
        // Android / Chrome PWA check
        if (window.matchMedia("(display-mode: standalone)").matches) return true;
        return false;
    }
    addPlatformParam(platform) {
        if (platform === "other") return;
        const link = this.installLinkTarget;
        const url = new URL(link.href, window.location.origin);
        if (!url.searchParams.has("platform")) {
            url.searchParams.set("platform", platform);
            link.href = url.toString();
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)(`Updated href \u{2192} ${link.href}`);
        }
    }
}


// controllers/qrcode_controller.js

var $9f2374f19df7e0a5$exports = {};

var $B0S8N = parcelRequire("B0S8N");
var $9f2374f19df7e0a5$require$Buffer = $B0S8N.Buffer;
!function(t, e) {
    $9f2374f19df7e0a5$exports = e();
}($9f2374f19df7e0a5$exports, ()=>(()=>{
        var t = {
            873: (t, e)=>{
                var i, r, n = function() {
                    var t = function(t, e) {
                        var i = t, r = s[e], n = null, o = 0, h = null, p = [], v = {}, m = function(t, e) {
                            n = function(t) {
                                for(var e = new Array(t), i = 0; i < t; i += 1){
                                    e[i] = new Array(t);
                                    for(var r = 0; r < t; r += 1)e[i][r] = null;
                                }
                                return e;
                            }(o = 4 * i + 17), b(0, 0), b(o - 7, 0), b(0, o - 7), x(), y(), C(t, e), i >= 7 && S(t), null == h && (h = M(i, r, p)), A(h, e);
                        }, b = function(t, e) {
                            for(var i = -1; i <= 7; i += 1)if (!(t + i <= -1 || o <= t + i)) for(var r = -1; r <= 7; r += 1)e + r <= -1 || o <= e + r || (n[t + i][e + r] = 0 <= i && i <= 6 && (0 == r || 6 == r) || 0 <= r && r <= 6 && (0 == i || 6 == i) || 2 <= i && i <= 4 && 2 <= r && r <= 4);
                        }, y = function() {
                            for(var t = 8; t < o - 8; t += 1)null == n[t][6] && (n[t][6] = t % 2 == 0);
                            for(var e = 8; e < o - 8; e += 1)null == n[6][e] && (n[6][e] = e % 2 == 0);
                        }, x = function() {
                            for(var t = a.getPatternPosition(i), e = 0; e < t.length; e += 1)for(var r = 0; r < t.length; r += 1){
                                var o = t[e], s = t[r];
                                if (null == n[o][s]) for(var h = -2; h <= 2; h += 1)for(var d = -2; d <= 2; d += 1)n[o + h][s + d] = -2 == h || 2 == h || -2 == d || 2 == d || 0 == h && 0 == d;
                            }
                        }, S = function(t) {
                            for(var e = a.getBCHTypeNumber(i), r = 0; r < 18; r += 1){
                                var s = !t && 1 == (e >> r & 1);
                                n[Math.floor(r / 3)][r % 3 + o - 8 - 3] = s;
                            }
                            for(r = 0; r < 18; r += 1)s = !t && 1 == (e >> r & 1), n[r % 3 + o - 8 - 3][Math.floor(r / 3)] = s;
                        }, C = function(t, e) {
                            for(var i = r << 3 | e, s = a.getBCHTypeInfo(i), h = 0; h < 15; h += 1){
                                var d = !t && 1 == (s >> h & 1);
                                h < 6 ? n[h][8] = d : h < 8 ? n[h + 1][8] = d : n[o - 15 + h][8] = d;
                            }
                            for(h = 0; h < 15; h += 1)d = !t && 1 == (s >> h & 1), h < 8 ? n[8][o - h - 1] = d : h < 9 ? n[8][15 - h - 1 + 1] = d : n[8][15 - h - 1] = d;
                            n[o - 8][8] = !t;
                        }, A = function(t, e) {
                            for(var i = -1, r = o - 1, s = 7, h = 0, d = a.getMaskFunction(e), u = o - 1; u > 0; u -= 2)for(6 == u && (u -= 1);;){
                                for(var c = 0; c < 2; c += 1)if (null == n[r][u - c]) {
                                    var l = !1;
                                    h < t.length && (l = 1 == (t[h] >>> s & 1)), d(r, u - c) && (l = !l), n[r][u - c] = l, -1 == (s -= 1) && (h += 1, s = 7);
                                }
                                if ((r += i) < 0 || o <= r) {
                                    r -= i, i = -i;
                                    break;
                                }
                            }
                        }, M = function(t, e, i) {
                            for(var r = u.getRSBlocks(t, e), n = c(), o = 0; o < i.length; o += 1){
                                var s = i[o];
                                n.put(s.getMode(), 4), n.put(s.getLength(), a.getLengthInBits(s.getMode(), t)), s.write(n);
                            }
                            var h = 0;
                            for(o = 0; o < r.length; o += 1)h += r[o].dataCount;
                            if (n.getLengthInBits() > 8 * h) throw "code length overflow. (" + n.getLengthInBits() + ">" + 8 * h + ")";
                            for(n.getLengthInBits() + 4 <= 8 * h && n.put(0, 4); n.getLengthInBits() % 8 != 0;)n.putBit(!1);
                            for(; !(n.getLengthInBits() >= 8 * h || (n.put(236, 8), n.getLengthInBits() >= 8 * h));)n.put(17, 8);
                            return function(t, e) {
                                for(var i = 0, r = 0, n = 0, o = new Array(e.length), s = new Array(e.length), h = 0; h < e.length; h += 1){
                                    var u = e[h].dataCount, c = e[h].totalCount - u;
                                    r = Math.max(r, u), n = Math.max(n, c), o[h] = new Array(u);
                                    for(var l = 0; l < o[h].length; l += 1)o[h][l] = 255 & t.getBuffer()[l + i];
                                    i += u;
                                    var g = a.getErrorCorrectPolynomial(c), f = d(o[h], g.getLength() - 1).mod(g);
                                    for(s[h] = new Array(g.getLength() - 1), l = 0; l < s[h].length; l += 1){
                                        var w = l + f.getLength() - s[h].length;
                                        s[h][l] = w >= 0 ? f.getAt(w) : 0;
                                    }
                                }
                                var p = 0;
                                for(l = 0; l < e.length; l += 1)p += e[l].totalCount;
                                var v = new Array(p), _ = 0;
                                for(l = 0; l < r; l += 1)for(h = 0; h < e.length; h += 1)l < o[h].length && (v[_] = o[h][l], _ += 1);
                                for(l = 0; l < n; l += 1)for(h = 0; h < e.length; h += 1)l < s[h].length && (v[_] = s[h][l], _ += 1);
                                return v;
                            }(n, r);
                        };
                        v.addData = function(t, e) {
                            var i = null;
                            switch(e = e || "Byte"){
                                case "Numeric":
                                    i = l(t);
                                    break;
                                case "Alphanumeric":
                                    i = g(t);
                                    break;
                                case "Byte":
                                    i = f(t);
                                    break;
                                case "Kanji":
                                    i = w(t);
                                    break;
                                default:
                                    throw "mode:" + e;
                            }
                            p.push(i), h = null;
                        }, v.isDark = function(t, e) {
                            if (t < 0 || o <= t || e < 0 || o <= e) throw t + "," + e;
                            return n[t][e];
                        }, v.getModuleCount = function() {
                            return o;
                        }, v.make = function() {
                            if (i < 1) {
                                for(var t = 1; t < 40; t++){
                                    for(var e = u.getRSBlocks(t, r), n = c(), o = 0; o < p.length; o++){
                                        var s = p[o];
                                        n.put(s.getMode(), 4), n.put(s.getLength(), a.getLengthInBits(s.getMode(), t)), s.write(n);
                                    }
                                    var h = 0;
                                    for(o = 0; o < e.length; o++)h += e[o].dataCount;
                                    if (n.getLengthInBits() <= 8 * h) break;
                                }
                                i = t;
                            }
                            m(!1, function() {
                                for(var t = 0, e = 0, i = 0; i < 8; i += 1){
                                    m(!0, i);
                                    var r = a.getLostPoint(v);
                                    (0 == i || t > r) && (t = r, e = i);
                                }
                                return e;
                            }());
                        }, v.createTableTag = function(t, e) {
                            t = t || 2;
                            var i = "";
                            i += '<table style="', i += " border-width: 0px; border-style: none;", i += " border-collapse: collapse;", i += " padding: 0px; margin: " + (e = void 0 === e ? 4 * t : e) + "px;", i += '">', i += "<tbody>";
                            for(var r = 0; r < v.getModuleCount(); r += 1){
                                i += "<tr>";
                                for(var n = 0; n < v.getModuleCount(); n += 1)i += '<td style="', i += " border-width: 0px; border-style: none;", i += " border-collapse: collapse;", i += " padding: 0px; margin: 0px;", i += " width: " + t + "px;", i += " height: " + t + "px;", i += " background-color: ", i += v.isDark(r, n) ? "#000000" : "#ffffff", i += ";", i += '"/>';
                                i += "</tr>";
                            }
                            return (i += "</tbody>") + "</table>";
                        }, v.createSvgTag = function(t, e, i, r) {
                            var n = {};
                            "object" == typeof arguments[0] && (t = (n = arguments[0]).cellSize, e = n.margin, i = n.alt, r = n.title), t = t || 2, e = void 0 === e ? 4 * t : e, (i = "string" == typeof i ? {
                                text: i
                            } : i || {}).text = i.text || null, i.id = i.text ? i.id || "qrcode-description" : null, (r = "string" == typeof r ? {
                                text: r
                            } : r || {}).text = r.text || null, r.id = r.text ? r.id || "qrcode-title" : null;
                            var o, s, a, h, d = v.getModuleCount() * t + 2 * e, u = "";
                            for(h = "l" + t + ",0 0," + t + " -" + t + ",0 0,-" + t + "z ", u += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"', u += n.scalable ? "" : ' width="' + d + 'px" height="' + d + 'px"', u += ' viewBox="0 0 ' + d + " " + d + '" ', u += ' preserveAspectRatio="xMinYMin meet"', u += r.text || i.text ? ' role="img" aria-labelledby="' + $([
                                r.id,
                                i.id
                            ].join(" ").trim()) + '"' : "", u += ">", u += r.text ? '<title id="' + $(r.id) + '">' + $(r.text) + "</title>" : "", u += i.text ? '<description id="' + $(i.id) + '">' + $(i.text) + "</description>" : "", u += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>', u += '<path d="', s = 0; s < v.getModuleCount(); s += 1)for(a = s * t + e, o = 0; o < v.getModuleCount(); o += 1)v.isDark(s, o) && (u += "M" + (o * t + e) + "," + a + h);
                            return (u += '" stroke="transparent" fill="black"/>') + "</svg>";
                        }, v.createDataURL = function(t, e) {
                            t = t || 2, e = void 0 === e ? 4 * t : e;
                            var i = v.getModuleCount() * t + 2 * e, r = e, n = i - e;
                            return _(i, i, function(e, i) {
                                if (r <= e && e < n && r <= i && i < n) {
                                    var o = Math.floor((e - r) / t), s = Math.floor((i - r) / t);
                                    return v.isDark(s, o) ? 0 : 1;
                                }
                                return 1;
                            });
                        }, v.createImgTag = function(t, e, i) {
                            t = t || 2, e = void 0 === e ? 4 * t : e;
                            var r = v.getModuleCount() * t + 2 * e, n = "";
                            return n += "<img", n += ' src="', n += v.createDataURL(t, e), n += '"', n += ' width="', n += r, n += '"', n += ' height="', n += r, n += '"', i && (n += ' alt="', n += $(i), n += '"'), n + "/>";
                        };
                        var $ = function(t) {
                            for(var e = "", i = 0; i < t.length; i += 1){
                                var r = t.charAt(i);
                                switch(r){
                                    case "<":
                                        e += "&lt;";
                                        break;
                                    case ">":
                                        e += "&gt;";
                                        break;
                                    case "&":
                                        e += "&amp;";
                                        break;
                                    case '"':
                                        e += "&quot;";
                                        break;
                                    default:
                                        e += r;
                                }
                            }
                            return e;
                        };
                        return v.createASCII = function(t, e) {
                            if ((t = t || 1) < 2) return function(t) {
                                t = void 0 === t ? 2 : t;
                                var e, i, r, n, o, s = 1 * v.getModuleCount() + 2 * t, a = t, h = s - t, d = {
                                    "\u2588\u2588": "\u2588",
                                    "\u2588 ": "\u2580",
                                    " \u2588": "\u2584",
                                    "  ": " "
                                }, u = {
                                    "\u2588\u2588": "\u2580",
                                    "\u2588 ": "\u2580",
                                    " \u2588": " ",
                                    "  ": " "
                                }, c = "";
                                for(e = 0; e < s; e += 2){
                                    for(r = Math.floor((e - a) / 1), n = Math.floor((e + 1 - a) / 1), i = 0; i < s; i += 1)o = "\u2588", a <= i && i < h && a <= e && e < h && v.isDark(r, Math.floor((i - a) / 1)) && (o = " "), a <= i && i < h && a <= e + 1 && e + 1 < h && v.isDark(n, Math.floor((i - a) / 1)) ? o += " " : o += "\u2588", c += t < 1 && e + 1 >= h ? u[o] : d[o];
                                    c += "\n";
                                }
                                return s % 2 && t > 0 ? c.substring(0, c.length - s - 1) + Array(s + 1).join("\u2580") : c.substring(0, c.length - 1);
                            }(e);
                            t -= 1, e = void 0 === e ? 2 * t : e;
                            var i, r, n, o, s = v.getModuleCount() * t + 2 * e, a = e, h = s - e, d = Array(t + 1).join("\u2588\u2588"), u = Array(t + 1).join("  "), c = "", l = "";
                            for(i = 0; i < s; i += 1){
                                for(n = Math.floor((i - a) / t), l = "", r = 0; r < s; r += 1)o = 1, a <= r && r < h && a <= i && i < h && v.isDark(n, Math.floor((r - a) / t)) && (o = 0), l += o ? d : u;
                                for(n = 0; n < t; n += 1)c += l + "\n";
                            }
                            return c.substring(0, c.length - 1);
                        }, v.renderTo2dContext = function(t, e) {
                            e = e || 2;
                            for(var i = v.getModuleCount(), r = 0; r < i; r++)for(var n = 0; n < i; n++)t.fillStyle = v.isDark(r, n) ? "black" : "white", t.fillRect(r * e, n * e, e, e);
                        }, v;
                    };
                    t.stringToBytes = (t.stringToBytesFuncs = {
                        default: function(t) {
                            for(var e = [], i = 0; i < t.length; i += 1){
                                var r = t.charCodeAt(i);
                                e.push(255 & r);
                            }
                            return e;
                        }
                    }).default, t.createStringToBytes = function(t, e) {
                        var i = function() {
                            for(var i = v(t), r = function() {
                                var t = i.read();
                                if (-1 == t) throw "eof";
                                return t;
                            }, n = 0, o = {};;){
                                var s = i.read();
                                if (-1 == s) break;
                                var a = r(), h = r() << 8 | r();
                                o[String.fromCharCode(s << 8 | a)] = h, n += 1;
                            }
                            if (n != e) throw n + " != " + e;
                            return o;
                        }(), r = "?".charCodeAt(0);
                        return function(t) {
                            for(var e = [], n = 0; n < t.length; n += 1){
                                var o = t.charCodeAt(n);
                                if (o < 128) e.push(o);
                                else {
                                    var s = i[t.charAt(n)];
                                    "number" == typeof s ? (255 & s) == s ? e.push(s) : (e.push(s >>> 8), e.push(255 & s)) : e.push(r);
                                }
                            }
                            return e;
                        };
                    };
                    var e, i, r, n, o, s = {
                        L: 1,
                        M: 0,
                        Q: 3,
                        H: 2
                    }, a = (e = [
                        [],
                        [
                            6,
                            18
                        ],
                        [
                            6,
                            22
                        ],
                        [
                            6,
                            26
                        ],
                        [
                            6,
                            30
                        ],
                        [
                            6,
                            34
                        ],
                        [
                            6,
                            22,
                            38
                        ],
                        [
                            6,
                            24,
                            42
                        ],
                        [
                            6,
                            26,
                            46
                        ],
                        [
                            6,
                            28,
                            50
                        ],
                        [
                            6,
                            30,
                            54
                        ],
                        [
                            6,
                            32,
                            58
                        ],
                        [
                            6,
                            34,
                            62
                        ],
                        [
                            6,
                            26,
                            46,
                            66
                        ],
                        [
                            6,
                            26,
                            48,
                            70
                        ],
                        [
                            6,
                            26,
                            50,
                            74
                        ],
                        [
                            6,
                            30,
                            54,
                            78
                        ],
                        [
                            6,
                            30,
                            56,
                            82
                        ],
                        [
                            6,
                            30,
                            58,
                            86
                        ],
                        [
                            6,
                            34,
                            62,
                            90
                        ],
                        [
                            6,
                            28,
                            50,
                            72,
                            94
                        ],
                        [
                            6,
                            26,
                            50,
                            74,
                            98
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102
                        ],
                        [
                            6,
                            28,
                            54,
                            80,
                            106
                        ],
                        [
                            6,
                            32,
                            58,
                            84,
                            110
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114
                        ],
                        [
                            6,
                            34,
                            62,
                            90,
                            118
                        ],
                        [
                            6,
                            26,
                            50,
                            74,
                            98,
                            122
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102,
                            126
                        ],
                        [
                            6,
                            26,
                            52,
                            78,
                            104,
                            130
                        ],
                        [
                            6,
                            30,
                            56,
                            82,
                            108,
                            134
                        ],
                        [
                            6,
                            34,
                            60,
                            86,
                            112,
                            138
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114,
                            142
                        ],
                        [
                            6,
                            34,
                            62,
                            90,
                            118,
                            146
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102,
                            126,
                            150
                        ],
                        [
                            6,
                            24,
                            50,
                            76,
                            102,
                            128,
                            154
                        ],
                        [
                            6,
                            28,
                            54,
                            80,
                            106,
                            132,
                            158
                        ],
                        [
                            6,
                            32,
                            58,
                            84,
                            110,
                            136,
                            162
                        ],
                        [
                            6,
                            26,
                            54,
                            82,
                            110,
                            138,
                            166
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114,
                            142,
                            170
                        ]
                    ], i = 1335, r = 7973, o = function(t) {
                        for(var e = 0; 0 != t;)e += 1, t >>>= 1;
                        return e;
                    }, (n = {}).getBCHTypeInfo = function(t) {
                        for(var e = t << 10; o(e) - o(i) >= 0;)e ^= i << o(e) - o(i);
                        return 21522 ^ (t << 10 | e);
                    }, n.getBCHTypeNumber = function(t) {
                        for(var e = t << 12; o(e) - o(r) >= 0;)e ^= r << o(e) - o(r);
                        return t << 12 | e;
                    }, n.getPatternPosition = function(t) {
                        return e[t - 1];
                    }, n.getMaskFunction = function(t) {
                        switch(t){
                            case 0:
                                return function(t, e) {
                                    return (t + e) % 2 == 0;
                                };
                            case 1:
                                return function(t, e) {
                                    return t % 2 == 0;
                                };
                            case 2:
                                return function(t, e) {
                                    return e % 3 == 0;
                                };
                            case 3:
                                return function(t, e) {
                                    return (t + e) % 3 == 0;
                                };
                            case 4:
                                return function(t, e) {
                                    return (Math.floor(t / 2) + Math.floor(e / 3)) % 2 == 0;
                                };
                            case 5:
                                return function(t, e) {
                                    return t * e % 2 + t * e % 3 == 0;
                                };
                            case 6:
                                return function(t, e) {
                                    return (t * e % 2 + t * e % 3) % 2 == 0;
                                };
                            case 7:
                                return function(t, e) {
                                    return (t * e % 3 + (t + e) % 2) % 2 == 0;
                                };
                            default:
                                throw "bad maskPattern:" + t;
                        }
                    }, n.getErrorCorrectPolynomial = function(t) {
                        for(var e = d([
                            1
                        ], 0), i = 0; i < t; i += 1)e = e.multiply(d([
                            1,
                            h.gexp(i)
                        ], 0));
                        return e;
                    }, n.getLengthInBits = function(t, e) {
                        if (1 <= e && e < 10) switch(t){
                            case 1:
                                return 10;
                            case 2:
                                return 9;
                            case 4:
                            case 8:
                                return 8;
                            default:
                                throw "mode:" + t;
                        }
                        else if (e < 27) switch(t){
                            case 1:
                                return 12;
                            case 2:
                                return 11;
                            case 4:
                                return 16;
                            case 8:
                                return 10;
                            default:
                                throw "mode:" + t;
                        }
                        else {
                            if (!(e < 41)) throw "type:" + e;
                            switch(t){
                                case 1:
                                    return 14;
                                case 2:
                                    return 13;
                                case 4:
                                    return 16;
                                case 8:
                                    return 12;
                                default:
                                    throw "mode:" + t;
                            }
                        }
                    }, n.getLostPoint = function(t) {
                        for(var e = t.getModuleCount(), i = 0, r = 0; r < e; r += 1)for(var n = 0; n < e; n += 1){
                            for(var o = 0, s = t.isDark(r, n), a = -1; a <= 1; a += 1)if (!(r + a < 0 || e <= r + a)) for(var h = -1; h <= 1; h += 1)n + h < 0 || e <= n + h || 0 == a && 0 == h || s == t.isDark(r + a, n + h) && (o += 1);
                            o > 5 && (i += 3 + o - 5);
                        }
                        for(r = 0; r < e - 1; r += 1)for(n = 0; n < e - 1; n += 1){
                            var d = 0;
                            t.isDark(r, n) && (d += 1), t.isDark(r + 1, n) && (d += 1), t.isDark(r, n + 1) && (d += 1), t.isDark(r + 1, n + 1) && (d += 1), 0 != d && 4 != d || (i += 3);
                        }
                        for(r = 0; r < e; r += 1)for(n = 0; n < e - 6; n += 1)t.isDark(r, n) && !t.isDark(r, n + 1) && t.isDark(r, n + 2) && t.isDark(r, n + 3) && t.isDark(r, n + 4) && !t.isDark(r, n + 5) && t.isDark(r, n + 6) && (i += 40);
                        for(n = 0; n < e; n += 1)for(r = 0; r < e - 6; r += 1)t.isDark(r, n) && !t.isDark(r + 1, n) && t.isDark(r + 2, n) && t.isDark(r + 3, n) && t.isDark(r + 4, n) && !t.isDark(r + 5, n) && t.isDark(r + 6, n) && (i += 40);
                        var u = 0;
                        for(n = 0; n < e; n += 1)for(r = 0; r < e; r += 1)t.isDark(r, n) && (u += 1);
                        return i + Math.abs(100 * u / e / e - 50) / 5 * 10;
                    }, n), h = function() {
                        for(var t = new Array(256), e = new Array(256), i = 0; i < 8; i += 1)t[i] = 1 << i;
                        for(i = 8; i < 256; i += 1)t[i] = t[i - 4] ^ t[i - 5] ^ t[i - 6] ^ t[i - 8];
                        for(i = 0; i < 255; i += 1)e[t[i]] = i;
                        return {
                            glog: function(t) {
                                if (t < 1) throw "glog(" + t + ")";
                                return e[t];
                            },
                            gexp: function(e) {
                                for(; e < 0;)e += 255;
                                for(; e >= 256;)e -= 255;
                                return t[e];
                            }
                        };
                    }();
                    function d(t, e) {
                        if (void 0 === t.length) throw t.length + "/" + e;
                        var i = function() {
                            for(var i = 0; i < t.length && 0 == t[i];)i += 1;
                            for(var r = new Array(t.length - i + e), n = 0; n < t.length - i; n += 1)r[n] = t[n + i];
                            return r;
                        }(), r = {
                            getAt: function(t) {
                                return i[t];
                            },
                            getLength: function() {
                                return i.length;
                            },
                            multiply: function(t) {
                                for(var e = new Array(r.getLength() + t.getLength() - 1), i = 0; i < r.getLength(); i += 1)for(var n = 0; n < t.getLength(); n += 1)e[i + n] ^= h.gexp(h.glog(r.getAt(i)) + h.glog(t.getAt(n)));
                                return d(e, 0);
                            },
                            mod: function(t) {
                                if (r.getLength() - t.getLength() < 0) return r;
                                for(var e = h.glog(r.getAt(0)) - h.glog(t.getAt(0)), i = new Array(r.getLength()), n = 0; n < r.getLength(); n += 1)i[n] = r.getAt(n);
                                for(n = 0; n < t.getLength(); n += 1)i[n] ^= h.gexp(h.glog(t.getAt(n)) + e);
                                return d(i, 0).mod(t);
                            }
                        };
                        return r;
                    }
                    var u = function() {
                        var t = [
                            [
                                1,
                                26,
                                19
                            ],
                            [
                                1,
                                26,
                                16
                            ],
                            [
                                1,
                                26,
                                13
                            ],
                            [
                                1,
                                26,
                                9
                            ],
                            [
                                1,
                                44,
                                34
                            ],
                            [
                                1,
                                44,
                                28
                            ],
                            [
                                1,
                                44,
                                22
                            ],
                            [
                                1,
                                44,
                                16
                            ],
                            [
                                1,
                                70,
                                55
                            ],
                            [
                                1,
                                70,
                                44
                            ],
                            [
                                2,
                                35,
                                17
                            ],
                            [
                                2,
                                35,
                                13
                            ],
                            [
                                1,
                                100,
                                80
                            ],
                            [
                                2,
                                50,
                                32
                            ],
                            [
                                2,
                                50,
                                24
                            ],
                            [
                                4,
                                25,
                                9
                            ],
                            [
                                1,
                                134,
                                108
                            ],
                            [
                                2,
                                67,
                                43
                            ],
                            [
                                2,
                                33,
                                15,
                                2,
                                34,
                                16
                            ],
                            [
                                2,
                                33,
                                11,
                                2,
                                34,
                                12
                            ],
                            [
                                2,
                                86,
                                68
                            ],
                            [
                                4,
                                43,
                                27
                            ],
                            [
                                4,
                                43,
                                19
                            ],
                            [
                                4,
                                43,
                                15
                            ],
                            [
                                2,
                                98,
                                78
                            ],
                            [
                                4,
                                49,
                                31
                            ],
                            [
                                2,
                                32,
                                14,
                                4,
                                33,
                                15
                            ],
                            [
                                4,
                                39,
                                13,
                                1,
                                40,
                                14
                            ],
                            [
                                2,
                                121,
                                97
                            ],
                            [
                                2,
                                60,
                                38,
                                2,
                                61,
                                39
                            ],
                            [
                                4,
                                40,
                                18,
                                2,
                                41,
                                19
                            ],
                            [
                                4,
                                40,
                                14,
                                2,
                                41,
                                15
                            ],
                            [
                                2,
                                146,
                                116
                            ],
                            [
                                3,
                                58,
                                36,
                                2,
                                59,
                                37
                            ],
                            [
                                4,
                                36,
                                16,
                                4,
                                37,
                                17
                            ],
                            [
                                4,
                                36,
                                12,
                                4,
                                37,
                                13
                            ],
                            [
                                2,
                                86,
                                68,
                                2,
                                87,
                                69
                            ],
                            [
                                4,
                                69,
                                43,
                                1,
                                70,
                                44
                            ],
                            [
                                6,
                                43,
                                19,
                                2,
                                44,
                                20
                            ],
                            [
                                6,
                                43,
                                15,
                                2,
                                44,
                                16
                            ],
                            [
                                4,
                                101,
                                81
                            ],
                            [
                                1,
                                80,
                                50,
                                4,
                                81,
                                51
                            ],
                            [
                                4,
                                50,
                                22,
                                4,
                                51,
                                23
                            ],
                            [
                                3,
                                36,
                                12,
                                8,
                                37,
                                13
                            ],
                            [
                                2,
                                116,
                                92,
                                2,
                                117,
                                93
                            ],
                            [
                                6,
                                58,
                                36,
                                2,
                                59,
                                37
                            ],
                            [
                                4,
                                46,
                                20,
                                6,
                                47,
                                21
                            ],
                            [
                                7,
                                42,
                                14,
                                4,
                                43,
                                15
                            ],
                            [
                                4,
                                133,
                                107
                            ],
                            [
                                8,
                                59,
                                37,
                                1,
                                60,
                                38
                            ],
                            [
                                8,
                                44,
                                20,
                                4,
                                45,
                                21
                            ],
                            [
                                12,
                                33,
                                11,
                                4,
                                34,
                                12
                            ],
                            [
                                3,
                                145,
                                115,
                                1,
                                146,
                                116
                            ],
                            [
                                4,
                                64,
                                40,
                                5,
                                65,
                                41
                            ],
                            [
                                11,
                                36,
                                16,
                                5,
                                37,
                                17
                            ],
                            [
                                11,
                                36,
                                12,
                                5,
                                37,
                                13
                            ],
                            [
                                5,
                                109,
                                87,
                                1,
                                110,
                                88
                            ],
                            [
                                5,
                                65,
                                41,
                                5,
                                66,
                                42
                            ],
                            [
                                5,
                                54,
                                24,
                                7,
                                55,
                                25
                            ],
                            [
                                11,
                                36,
                                12,
                                7,
                                37,
                                13
                            ],
                            [
                                5,
                                122,
                                98,
                                1,
                                123,
                                99
                            ],
                            [
                                7,
                                73,
                                45,
                                3,
                                74,
                                46
                            ],
                            [
                                15,
                                43,
                                19,
                                2,
                                44,
                                20
                            ],
                            [
                                3,
                                45,
                                15,
                                13,
                                46,
                                16
                            ],
                            [
                                1,
                                135,
                                107,
                                5,
                                136,
                                108
                            ],
                            [
                                10,
                                74,
                                46,
                                1,
                                75,
                                47
                            ],
                            [
                                1,
                                50,
                                22,
                                15,
                                51,
                                23
                            ],
                            [
                                2,
                                42,
                                14,
                                17,
                                43,
                                15
                            ],
                            [
                                5,
                                150,
                                120,
                                1,
                                151,
                                121
                            ],
                            [
                                9,
                                69,
                                43,
                                4,
                                70,
                                44
                            ],
                            [
                                17,
                                50,
                                22,
                                1,
                                51,
                                23
                            ],
                            [
                                2,
                                42,
                                14,
                                19,
                                43,
                                15
                            ],
                            [
                                3,
                                141,
                                113,
                                4,
                                142,
                                114
                            ],
                            [
                                3,
                                70,
                                44,
                                11,
                                71,
                                45
                            ],
                            [
                                17,
                                47,
                                21,
                                4,
                                48,
                                22
                            ],
                            [
                                9,
                                39,
                                13,
                                16,
                                40,
                                14
                            ],
                            [
                                3,
                                135,
                                107,
                                5,
                                136,
                                108
                            ],
                            [
                                3,
                                67,
                                41,
                                13,
                                68,
                                42
                            ],
                            [
                                15,
                                54,
                                24,
                                5,
                                55,
                                25
                            ],
                            [
                                15,
                                43,
                                15,
                                10,
                                44,
                                16
                            ],
                            [
                                4,
                                144,
                                116,
                                4,
                                145,
                                117
                            ],
                            [
                                17,
                                68,
                                42
                            ],
                            [
                                17,
                                50,
                                22,
                                6,
                                51,
                                23
                            ],
                            [
                                19,
                                46,
                                16,
                                6,
                                47,
                                17
                            ],
                            [
                                2,
                                139,
                                111,
                                7,
                                140,
                                112
                            ],
                            [
                                17,
                                74,
                                46
                            ],
                            [
                                7,
                                54,
                                24,
                                16,
                                55,
                                25
                            ],
                            [
                                34,
                                37,
                                13
                            ],
                            [
                                4,
                                151,
                                121,
                                5,
                                152,
                                122
                            ],
                            [
                                4,
                                75,
                                47,
                                14,
                                76,
                                48
                            ],
                            [
                                11,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                16,
                                45,
                                15,
                                14,
                                46,
                                16
                            ],
                            [
                                6,
                                147,
                                117,
                                4,
                                148,
                                118
                            ],
                            [
                                6,
                                73,
                                45,
                                14,
                                74,
                                46
                            ],
                            [
                                11,
                                54,
                                24,
                                16,
                                55,
                                25
                            ],
                            [
                                30,
                                46,
                                16,
                                2,
                                47,
                                17
                            ],
                            [
                                8,
                                132,
                                106,
                                4,
                                133,
                                107
                            ],
                            [
                                8,
                                75,
                                47,
                                13,
                                76,
                                48
                            ],
                            [
                                7,
                                54,
                                24,
                                22,
                                55,
                                25
                            ],
                            [
                                22,
                                45,
                                15,
                                13,
                                46,
                                16
                            ],
                            [
                                10,
                                142,
                                114,
                                2,
                                143,
                                115
                            ],
                            [
                                19,
                                74,
                                46,
                                4,
                                75,
                                47
                            ],
                            [
                                28,
                                50,
                                22,
                                6,
                                51,
                                23
                            ],
                            [
                                33,
                                46,
                                16,
                                4,
                                47,
                                17
                            ],
                            [
                                8,
                                152,
                                122,
                                4,
                                153,
                                123
                            ],
                            [
                                22,
                                73,
                                45,
                                3,
                                74,
                                46
                            ],
                            [
                                8,
                                53,
                                23,
                                26,
                                54,
                                24
                            ],
                            [
                                12,
                                45,
                                15,
                                28,
                                46,
                                16
                            ],
                            [
                                3,
                                147,
                                117,
                                10,
                                148,
                                118
                            ],
                            [
                                3,
                                73,
                                45,
                                23,
                                74,
                                46
                            ],
                            [
                                4,
                                54,
                                24,
                                31,
                                55,
                                25
                            ],
                            [
                                11,
                                45,
                                15,
                                31,
                                46,
                                16
                            ],
                            [
                                7,
                                146,
                                116,
                                7,
                                147,
                                117
                            ],
                            [
                                21,
                                73,
                                45,
                                7,
                                74,
                                46
                            ],
                            [
                                1,
                                53,
                                23,
                                37,
                                54,
                                24
                            ],
                            [
                                19,
                                45,
                                15,
                                26,
                                46,
                                16
                            ],
                            [
                                5,
                                145,
                                115,
                                10,
                                146,
                                116
                            ],
                            [
                                19,
                                75,
                                47,
                                10,
                                76,
                                48
                            ],
                            [
                                15,
                                54,
                                24,
                                25,
                                55,
                                25
                            ],
                            [
                                23,
                                45,
                                15,
                                25,
                                46,
                                16
                            ],
                            [
                                13,
                                145,
                                115,
                                3,
                                146,
                                116
                            ],
                            [
                                2,
                                74,
                                46,
                                29,
                                75,
                                47
                            ],
                            [
                                42,
                                54,
                                24,
                                1,
                                55,
                                25
                            ],
                            [
                                23,
                                45,
                                15,
                                28,
                                46,
                                16
                            ],
                            [
                                17,
                                145,
                                115
                            ],
                            [
                                10,
                                74,
                                46,
                                23,
                                75,
                                47
                            ],
                            [
                                10,
                                54,
                                24,
                                35,
                                55,
                                25
                            ],
                            [
                                19,
                                45,
                                15,
                                35,
                                46,
                                16
                            ],
                            [
                                17,
                                145,
                                115,
                                1,
                                146,
                                116
                            ],
                            [
                                14,
                                74,
                                46,
                                21,
                                75,
                                47
                            ],
                            [
                                29,
                                54,
                                24,
                                19,
                                55,
                                25
                            ],
                            [
                                11,
                                45,
                                15,
                                46,
                                46,
                                16
                            ],
                            [
                                13,
                                145,
                                115,
                                6,
                                146,
                                116
                            ],
                            [
                                14,
                                74,
                                46,
                                23,
                                75,
                                47
                            ],
                            [
                                44,
                                54,
                                24,
                                7,
                                55,
                                25
                            ],
                            [
                                59,
                                46,
                                16,
                                1,
                                47,
                                17
                            ],
                            [
                                12,
                                151,
                                121,
                                7,
                                152,
                                122
                            ],
                            [
                                12,
                                75,
                                47,
                                26,
                                76,
                                48
                            ],
                            [
                                39,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                22,
                                45,
                                15,
                                41,
                                46,
                                16
                            ],
                            [
                                6,
                                151,
                                121,
                                14,
                                152,
                                122
                            ],
                            [
                                6,
                                75,
                                47,
                                34,
                                76,
                                48
                            ],
                            [
                                46,
                                54,
                                24,
                                10,
                                55,
                                25
                            ],
                            [
                                2,
                                45,
                                15,
                                64,
                                46,
                                16
                            ],
                            [
                                17,
                                152,
                                122,
                                4,
                                153,
                                123
                            ],
                            [
                                29,
                                74,
                                46,
                                14,
                                75,
                                47
                            ],
                            [
                                49,
                                54,
                                24,
                                10,
                                55,
                                25
                            ],
                            [
                                24,
                                45,
                                15,
                                46,
                                46,
                                16
                            ],
                            [
                                4,
                                152,
                                122,
                                18,
                                153,
                                123
                            ],
                            [
                                13,
                                74,
                                46,
                                32,
                                75,
                                47
                            ],
                            [
                                48,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                42,
                                45,
                                15,
                                32,
                                46,
                                16
                            ],
                            [
                                20,
                                147,
                                117,
                                4,
                                148,
                                118
                            ],
                            [
                                40,
                                75,
                                47,
                                7,
                                76,
                                48
                            ],
                            [
                                43,
                                54,
                                24,
                                22,
                                55,
                                25
                            ],
                            [
                                10,
                                45,
                                15,
                                67,
                                46,
                                16
                            ],
                            [
                                19,
                                148,
                                118,
                                6,
                                149,
                                119
                            ],
                            [
                                18,
                                75,
                                47,
                                31,
                                76,
                                48
                            ],
                            [
                                34,
                                54,
                                24,
                                34,
                                55,
                                25
                            ],
                            [
                                20,
                                45,
                                15,
                                61,
                                46,
                                16
                            ]
                        ], e = function(t, e) {
                            var i = {};
                            return i.totalCount = t, i.dataCount = e, i;
                        }, i = {
                            getRSBlocks: function(i, r) {
                                var n = function(e, i) {
                                    switch(i){
                                        case s.L:
                                            return t[4 * (e - 1) + 0];
                                        case s.M:
                                            return t[4 * (e - 1) + 1];
                                        case s.Q:
                                            return t[4 * (e - 1) + 2];
                                        case s.H:
                                            return t[4 * (e - 1) + 3];
                                        default:
                                            return;
                                    }
                                }(i, r);
                                if (void 0 === n) throw "bad rs block @ typeNumber:" + i + "/errorCorrectionLevel:" + r;
                                for(var o = n.length / 3, a = [], h = 0; h < o; h += 1)for(var d = n[3 * h + 0], u = n[3 * h + 1], c = n[3 * h + 2], l = 0; l < d; l += 1)a.push(e(u, c));
                                return a;
                            }
                        };
                        return i;
                    }(), c = function() {
                        var t = [], e = 0, i = {
                            getBuffer: function() {
                                return t;
                            },
                            getAt: function(e) {
                                var i = Math.floor(e / 8);
                                return 1 == (t[i] >>> 7 - e % 8 & 1);
                            },
                            put: function(t, e) {
                                for(var r = 0; r < e; r += 1)i.putBit(1 == (t >>> e - r - 1 & 1));
                            },
                            getLengthInBits: function() {
                                return e;
                            },
                            putBit: function(i) {
                                var r = Math.floor(e / 8);
                                t.length <= r && t.push(0), i && (t[r] |= 128 >>> e % 8), e += 1;
                            }
                        };
                        return i;
                    }, l = function(t) {
                        var e = t, i = {
                            getMode: function() {
                                return 1;
                            },
                            getLength: function(t) {
                                return e.length;
                            },
                            write: function(t) {
                                for(var i = e, n = 0; n + 2 < i.length;)t.put(r(i.substring(n, n + 3)), 10), n += 3;
                                n < i.length && (i.length - n == 1 ? t.put(r(i.substring(n, n + 1)), 4) : i.length - n == 2 && t.put(r(i.substring(n, n + 2)), 7));
                            }
                        }, r = function(t) {
                            for(var e = 0, i = 0; i < t.length; i += 1)e = 10 * e + n(t.charAt(i));
                            return e;
                        }, n = function(t) {
                            if ("0" <= t && t <= "9") return t.charCodeAt(0) - "0".charCodeAt(0);
                            throw "illegal char :" + t;
                        };
                        return i;
                    }, g = function(t) {
                        var e = t, i = {
                            getMode: function() {
                                return 2;
                            },
                            getLength: function(t) {
                                return e.length;
                            },
                            write: function(t) {
                                for(var i = e, n = 0; n + 1 < i.length;)t.put(45 * r(i.charAt(n)) + r(i.charAt(n + 1)), 11), n += 2;
                                n < i.length && t.put(r(i.charAt(n)), 6);
                            }
                        }, r = function(t) {
                            if ("0" <= t && t <= "9") return t.charCodeAt(0) - "0".charCodeAt(0);
                            if ("A" <= t && t <= "Z") return t.charCodeAt(0) - "A".charCodeAt(0) + 10;
                            switch(t){
                                case " ":
                                    return 36;
                                case "$":
                                    return 37;
                                case "%":
                                    return 38;
                                case "*":
                                    return 39;
                                case "+":
                                    return 40;
                                case "-":
                                    return 41;
                                case ".":
                                    return 42;
                                case "/":
                                    return 43;
                                case ":":
                                    return 44;
                                default:
                                    throw "illegal char :" + t;
                            }
                        };
                        return i;
                    }, f = function(e) {
                        var i = t.stringToBytes(e);
                        return {
                            getMode: function() {
                                return 4;
                            },
                            getLength: function(t) {
                                return i.length;
                            },
                            write: function(t) {
                                for(var e = 0; e < i.length; e += 1)t.put(i[e], 8);
                            }
                        };
                    }, w = function(e) {
                        var i = t.stringToBytesFuncs.SJIS;
                        if (!i) throw "sjis not supported.";
                        !function() {
                            var t = i("\u53CB");
                            if (2 != t.length || 38726 != (t[0] << 8 | t[1])) throw "sjis not supported.";
                        }();
                        var r = i(e), n = {
                            getMode: function() {
                                return 8;
                            },
                            getLength: function(t) {
                                return ~~(r.length / 2);
                            },
                            write: function(t) {
                                for(var e = r, i = 0; i + 1 < e.length;){
                                    var n = (255 & e[i]) << 8 | 255 & e[i + 1];
                                    if (33088 <= n && n <= 40956) n -= 33088;
                                    else {
                                        if (!(57408 <= n && n <= 60351)) throw "illegal char at " + (i + 1) + "/" + n;
                                        n -= 49472;
                                    }
                                    n = 192 * (n >>> 8 & 255) + (255 & n), t.put(n, 13), i += 2;
                                }
                                if (i < e.length) throw "illegal char at " + (i + 1);
                            }
                        };
                        return n;
                    }, p = function() {
                        var t = [], e = {
                            writeByte: function(e) {
                                t.push(255 & e);
                            },
                            writeShort: function(t) {
                                e.writeByte(t), e.writeByte(t >>> 8);
                            },
                            writeBytes: function(t, i, r) {
                                i = i || 0, r = r || t.length;
                                for(var n = 0; n < r; n += 1)e.writeByte(t[n + i]);
                            },
                            writeString: function(t) {
                                for(var i = 0; i < t.length; i += 1)e.writeByte(t.charCodeAt(i));
                            },
                            toByteArray: function() {
                                return t;
                            },
                            toString: function() {
                                var e = "";
                                e += "[";
                                for(var i = 0; i < t.length; i += 1)i > 0 && (e += ","), e += t[i];
                                return e + "]";
                            }
                        };
                        return e;
                    }, v = function(t) {
                        var e = t, i = 0, r = 0, n = 0, o = {
                            read: function() {
                                for(; n < 8;){
                                    if (i >= e.length) {
                                        if (0 == n) return -1;
                                        throw "unexpected end of file./" + n;
                                    }
                                    var t = e.charAt(i);
                                    if (i += 1, "=" == t) return n = 0, -1;
                                    t.match(/^\s$/) || (r = r << 6 | s(t.charCodeAt(0)), n += 6);
                                }
                                var o = r >>> n - 8 & 255;
                                return n -= 8, o;
                            }
                        }, s = function(t) {
                            if (65 <= t && t <= 90) return t - 65;
                            if (97 <= t && t <= 122) return t - 97 + 26;
                            if (48 <= t && t <= 57) return t - 48 + 52;
                            if (43 == t) return 62;
                            if (47 == t) return 63;
                            throw "c:" + t;
                        };
                        return o;
                    }, _ = function(t, e, i) {
                        for(var r = function(t, e) {
                            var i = t, r = e, n = new Array(t * e), o = {
                                setPixel: function(t, e, r) {
                                    n[e * i + t] = r;
                                },
                                write: function(t) {
                                    t.writeString("GIF87a"), t.writeShort(i), t.writeShort(r), t.writeByte(128), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(255), t.writeByte(255), t.writeByte(255), t.writeString(","), t.writeShort(0), t.writeShort(0), t.writeShort(i), t.writeShort(r), t.writeByte(0);
                                    var e = s(2);
                                    t.writeByte(2);
                                    for(var n = 0; e.length - n > 255;)t.writeByte(255), t.writeBytes(e, n, 255), n += 255;
                                    t.writeByte(e.length - n), t.writeBytes(e, n, e.length - n), t.writeByte(0), t.writeString(";");
                                }
                            }, s = function(t) {
                                for(var e = 1 << t, i = 1 + (1 << t), r = t + 1, o = a(), s = 0; s < e; s += 1)o.add(String.fromCharCode(s));
                                o.add(String.fromCharCode(e)), o.add(String.fromCharCode(i));
                                var h, d, u, c = p(), l = (h = c, d = 0, u = 0, {
                                    write: function(t, e) {
                                        if (t >>> e != 0) throw "length over";
                                        for(; d + e >= 8;)h.writeByte(255 & (t << d | u)), e -= 8 - d, t >>>= 8 - d, u = 0, d = 0;
                                        u |= t << d, d += e;
                                    },
                                    flush: function() {
                                        d > 0 && h.writeByte(u);
                                    }
                                });
                                l.write(e, r);
                                var g = 0, f = String.fromCharCode(n[g]);
                                for(g += 1; g < n.length;){
                                    var w = String.fromCharCode(n[g]);
                                    g += 1, o.contains(f + w) ? f += w : (l.write(o.indexOf(f), r), o.size() < 4095 && (o.size() == 1 << r && (r += 1), o.add(f + w)), f = w);
                                }
                                return l.write(o.indexOf(f), r), l.write(i, r), l.flush(), c.toByteArray();
                            }, a = function() {
                                var t = {}, e = 0, i = {
                                    add: function(r) {
                                        if (i.contains(r)) throw "dup key:" + r;
                                        t[r] = e, e += 1;
                                    },
                                    size: function() {
                                        return e;
                                    },
                                    indexOf: function(e) {
                                        return t[e];
                                    },
                                    contains: function(e) {
                                        return void 0 !== t[e];
                                    }
                                };
                                return i;
                            };
                            return o;
                        }(t, e), n = 0; n < e; n += 1)for(var o = 0; o < t; o += 1)r.setPixel(o, n, i(o, n));
                        var s = p();
                        r.write(s);
                        for(var a = function() {
                            var t = 0, e = 0, i = 0, r = "", n = {}, o = function(t) {
                                r += String.fromCharCode(s(63 & t));
                            }, s = function(t) {
                                if (t < 0) ;
                                else {
                                    if (t < 26) return 65 + t;
                                    if (t < 52) return t - 26 + 97;
                                    if (t < 62) return t - 52 + 48;
                                    if (62 == t) return 43;
                                    if (63 == t) return 47;
                                }
                                throw "n:" + t;
                            };
                            return n.writeByte = function(r) {
                                for(t = t << 8 | 255 & r, e += 8, i += 1; e >= 6;)o(t >>> e - 6), e -= 6;
                            }, n.flush = function() {
                                if (e > 0 && (o(t << 6 - e), t = 0, e = 0), i % 3 != 0) for(var n = 3 - i % 3, s = 0; s < n; s += 1)r += "=";
                            }, n.toString = function() {
                                return r;
                            }, n;
                        }(), h = s.toByteArray(), d = 0; d < h.length; d += 1)a.writeByte(h[d]);
                        return a.flush(), "data:image/gif;base64," + a;
                    };
                    return t;
                }();
                n.stringToBytesFuncs["UTF-8"] = function(t) {
                    return function(t) {
                        for(var e = [], i = 0; i < t.length; i++){
                            var r = t.charCodeAt(i);
                            r < 128 ? e.push(r) : r < 2048 ? e.push(192 | r >> 6, 128 | 63 & r) : r < 55296 || r >= 57344 ? e.push(224 | r >> 12, 128 | r >> 6 & 63, 128 | 63 & r) : (i++, r = 65536 + ((1023 & r) << 10 | 1023 & t.charCodeAt(i)), e.push(240 | r >> 18, 128 | r >> 12 & 63, 128 | r >> 6 & 63, 128 | 63 & r));
                        }
                        return e;
                    }(t);
                }, void 0 === (r = "function" == typeof (i = function() {
                    return n;
                }) ? i.apply(e, []) : i) || (t.exports = r);
            }
        }, e = {};
        function i(r) {
            var n = e[r];
            if (void 0 !== n) return n.exports;
            var o = e[r] = {
                exports: {}
            };
            return t[r](o, o.exports, i), o.exports;
        }
        i.n = (t)=>{
            var e = t && t.__esModule ? ()=>t.default : ()=>t;
            return i.d(e, {
                a: e
            }), e;
        }, i.d = (t, e)=>{
            for(var r in e)i.o(e, r) && !i.o(t, r) && Object.defineProperty(t, r, {
                enumerable: !0,
                get: e[r]
            });
        }, i.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        var r = {};
        return (()=>{
            "use strict";
            i.d(r, {
                default: ()=>$
            });
            const t = (t)=>!!t && "object" == typeof t && !Array.isArray(t);
            function e(i, ...r) {
                if (!r.length) return i;
                const n = r.shift();
                return void 0 !== n && t(i) && t(n) ? (i = Object.assign({}, i), Object.keys(n).forEach((r)=>{
                    const o = i[r], s = n[r];
                    Array.isArray(o) && Array.isArray(s) ? i[r] = s : t(o) && t(s) ? i[r] = e(Object.assign({}, o), s) : i[r] = s;
                }), e(i, ...r)) : i;
            }
            function n(t, e) {
                const i = document.createElement("a");
                i.download = e, i.href = t, document.body.appendChild(i), i.click(), document.body.removeChild(i);
            }
            const o = {
                L: .07,
                M: .15,
                Q: .25,
                H: .3
            };
            class s {
                constructor({ svg: t, type: e, window: i }){
                    this._svg = t, this._type = e, this._window = i;
                }
                draw(t, e, i, r) {
                    let n;
                    switch(this._type){
                        case "dots":
                            n = this._drawDot;
                            break;
                        case "classy":
                            n = this._drawClassy;
                            break;
                        case "classy-rounded":
                            n = this._drawClassyRounded;
                            break;
                        case "rounded":
                            n = this._drawRounded;
                            break;
                        case "extra-rounded":
                            n = this._drawExtraRounded;
                            break;
                        default:
                            n = this._drawSquare;
                    }
                    n.call(this, {
                        x: t,
                        y: e,
                        size: i,
                        getNeighbor: r
                    });
                }
                _rotateFigure({ x: t, y: e, size: i, rotation: r = 0, draw: n }) {
                    var o;
                    const s = t + i / 2, a = e + i / 2;
                    n(), null === (o = this._element) || void 0 === o || o.setAttribute("transform", `rotate(${180 * r / Math.PI},${s},${a})`);
                }
                _basicDot(t) {
                    const { size: e, x: i, y: r } = t;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "circle"), this._element.setAttribute("cx", String(i + e / 2)), this._element.setAttribute("cy", String(r + e / 2)), this._element.setAttribute("r", String(e / 2));
                        }
                    }));
                }
                _basicSquare(t) {
                    const { size: e, x: i, y: r } = t;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "rect"), this._element.setAttribute("x", String(i)), this._element.setAttribute("y", String(r)), this._element.setAttribute("width", String(e)), this._element.setAttribute("height", String(e));
                        }
                    }));
                }
                _basicSideRounded(t) {
                    const { size: e, x: i, y: r } = t;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this._element.setAttribute("d", `M ${i} ${r}v ${e}h ` + e / 2 + `a ${e / 2} ${e / 2}, 0, 0, 0, 0 ${-e}`);
                        }
                    }));
                }
                _basicCornerRounded(t) {
                    const { size: e, x: i, y: r } = t;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this._element.setAttribute("d", `M ${i} ${r}v ${e}h ${e}v ` + -e / 2 + `a ${e / 2} ${e / 2}, 0, 0, 0, ${-e / 2} ${-e / 2}`);
                        }
                    }));
                }
                _basicCornerExtraRounded(t) {
                    const { size: e, x: i, y: r } = t;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this._element.setAttribute("d", `M ${i} ${r}v ${e}h ${e}a ${e} ${e}, 0, 0, 0, ${-e} ${-e}`);
                        }
                    }));
                }
                _basicCornersRounded(t) {
                    const { size: e, x: i, y: r } = t;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this._element.setAttribute("d", `M ${i} ${r}v ` + e / 2 + `a ${e / 2} ${e / 2}, 0, 0, 0, ${e / 2} ${e / 2}h ` + e / 2 + "v " + -e / 2 + `a ${e / 2} ${e / 2}, 0, 0, 0, ${-e / 2} ${-e / 2}`);
                        }
                    }));
                }
                _drawDot({ x: t, y: e, size: i }) {
                    this._basicDot({
                        x: t,
                        y: e,
                        size: i,
                        rotation: 0
                    });
                }
                _drawSquare({ x: t, y: e, size: i }) {
                    this._basicSquare({
                        x: t,
                        y: e,
                        size: i,
                        rotation: 0
                    });
                }
                _drawRounded({ x: t, y: e, size: i, getNeighbor: r }) {
                    const n = r ? +r(-1, 0) : 0, o = r ? +r(1, 0) : 0, s = r ? +r(0, -1) : 0, a = r ? +r(0, 1) : 0, h = n + o + s + a;
                    if (0 !== h) {
                        if (h > 2 || n && o || s && a) this._basicSquare({
                            x: t,
                            y: e,
                            size: i,
                            rotation: 0
                        });
                        else {
                            if (2 === h) {
                                let r = 0;
                                return n && s ? r = Math.PI / 2 : s && o ? r = Math.PI : o && a && (r = -Math.PI / 2), void this._basicCornerRounded({
                                    x: t,
                                    y: e,
                                    size: i,
                                    rotation: r
                                });
                            }
                            if (1 === h) {
                                let r = 0;
                                return s ? r = Math.PI / 2 : o ? r = Math.PI : a && (r = -Math.PI / 2), void this._basicSideRounded({
                                    x: t,
                                    y: e,
                                    size: i,
                                    rotation: r
                                });
                            }
                        }
                    } else this._basicDot({
                        x: t,
                        y: e,
                        size: i,
                        rotation: 0
                    });
                }
                _drawExtraRounded({ x: t, y: e, size: i, getNeighbor: r }) {
                    const n = r ? +r(-1, 0) : 0, o = r ? +r(1, 0) : 0, s = r ? +r(0, -1) : 0, a = r ? +r(0, 1) : 0, h = n + o + s + a;
                    if (0 !== h) {
                        if (h > 2 || n && o || s && a) this._basicSquare({
                            x: t,
                            y: e,
                            size: i,
                            rotation: 0
                        });
                        else {
                            if (2 === h) {
                                let r = 0;
                                return n && s ? r = Math.PI / 2 : s && o ? r = Math.PI : o && a && (r = -Math.PI / 2), void this._basicCornerExtraRounded({
                                    x: t,
                                    y: e,
                                    size: i,
                                    rotation: r
                                });
                            }
                            if (1 === h) {
                                let r = 0;
                                return s ? r = Math.PI / 2 : o ? r = Math.PI : a && (r = -Math.PI / 2), void this._basicSideRounded({
                                    x: t,
                                    y: e,
                                    size: i,
                                    rotation: r
                                });
                            }
                        }
                    } else this._basicDot({
                        x: t,
                        y: e,
                        size: i,
                        rotation: 0
                    });
                }
                _drawClassy({ x: t, y: e, size: i, getNeighbor: r }) {
                    const n = r ? +r(-1, 0) : 0, o = r ? +r(1, 0) : 0, s = r ? +r(0, -1) : 0, a = r ? +r(0, 1) : 0;
                    0 !== n + o + s + a ? n || s ? o || a ? this._basicSquare({
                        x: t,
                        y: e,
                        size: i,
                        rotation: 0
                    }) : this._basicCornerRounded({
                        x: t,
                        y: e,
                        size: i,
                        rotation: Math.PI / 2
                    }) : this._basicCornerRounded({
                        x: t,
                        y: e,
                        size: i,
                        rotation: -Math.PI / 2
                    }) : this._basicCornersRounded({
                        x: t,
                        y: e,
                        size: i,
                        rotation: Math.PI / 2
                    });
                }
                _drawClassyRounded({ x: t, y: e, size: i, getNeighbor: r }) {
                    const n = r ? +r(-1, 0) : 0, o = r ? +r(1, 0) : 0, s = r ? +r(0, -1) : 0, a = r ? +r(0, 1) : 0;
                    0 !== n + o + s + a ? n || s ? o || a ? this._basicSquare({
                        x: t,
                        y: e,
                        size: i,
                        rotation: 0
                    }) : this._basicCornerExtraRounded({
                        x: t,
                        y: e,
                        size: i,
                        rotation: Math.PI / 2
                    }) : this._basicCornerExtraRounded({
                        x: t,
                        y: e,
                        size: i,
                        rotation: -Math.PI / 2
                    }) : this._basicCornersRounded({
                        x: t,
                        y: e,
                        size: i,
                        rotation: Math.PI / 2
                    });
                }
            }
            const a = {
                dot: "dot",
                square: "square",
                extraRounded: "extra-rounded"
            }, h = Object.values(a);
            class d {
                constructor({ svg: t, type: e, window: i }){
                    this._svg = t, this._type = e, this._window = i;
                }
                draw(t, e, i, r) {
                    let n;
                    switch(this._type){
                        case a.square:
                            n = this._drawSquare;
                            break;
                        case a.extraRounded:
                            n = this._drawExtraRounded;
                            break;
                        default:
                            n = this._drawDot;
                    }
                    n.call(this, {
                        x: t,
                        y: e,
                        size: i,
                        rotation: r
                    });
                }
                _rotateFigure({ x: t, y: e, size: i, rotation: r = 0, draw: n }) {
                    var o;
                    const s = t + i / 2, a = e + i / 2;
                    n(), null === (o = this._element) || void 0 === o || o.setAttribute("transform", `rotate(${180 * r / Math.PI},${s},${a})`);
                }
                _basicDot(t) {
                    const { size: e, x: i, y: r } = t, n = e / 7;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this._element.setAttribute("clip-rule", "evenodd"), this._element.setAttribute("d", `M ${i + e / 2} ${r}a ${e / 2} ${e / 2} 0 1 0 0.1 0zm 0 ${n}a ${e / 2 - n} ${e / 2 - n} 0 1 1 -0.1 0Z`);
                        }
                    }));
                }
                _basicSquare(t) {
                    const { size: e, x: i, y: r } = t, n = e / 7;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this._element.setAttribute("clip-rule", "evenodd"), this._element.setAttribute("d", `M ${i} ${r}v ${e}h ${e}v ` + -e + "z" + `M ${i + n} ${r + n}h ` + (e - 2 * n) + "v " + (e - 2 * n) + "h " + (2 * n - e) + "z");
                        }
                    }));
                }
                _basicExtraRounded(t) {
                    const { size: e, x: i, y: r } = t, n = e / 7;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this._element.setAttribute("clip-rule", "evenodd"), this._element.setAttribute("d", `M ${i} ${r + 2.5 * n}v ` + 2 * n + `a ${2.5 * n} ${2.5 * n}, 0, 0, 0, ${2.5 * n} ${2.5 * n}h ` + 2 * n + `a ${2.5 * n} ${2.5 * n}, 0, 0, 0, ${2.5 * n} ${2.5 * -n}v ` + -2 * n + `a ${2.5 * n} ${2.5 * n}, 0, 0, 0, ${2.5 * -n} ${2.5 * -n}h ` + -2 * n + `a ${2.5 * n} ${2.5 * n}, 0, 0, 0, ${2.5 * -n} ${2.5 * n}` + `M ${i + 2.5 * n} ${r + n}h ` + 2 * n + `a ${1.5 * n} ${1.5 * n}, 0, 0, 1, ${1.5 * n} ${1.5 * n}v ` + 2 * n + `a ${1.5 * n} ${1.5 * n}, 0, 0, 1, ${1.5 * -n} ${1.5 * n}h ` + -2 * n + `a ${1.5 * n} ${1.5 * n}, 0, 0, 1, ${1.5 * -n} ${1.5 * -n}v ` + -2 * n + `a ${1.5 * n} ${1.5 * n}, 0, 0, 1, ${1.5 * n} ${1.5 * -n}`);
                        }
                    }));
                }
                _drawDot({ x: t, y: e, size: i, rotation: r }) {
                    this._basicDot({
                        x: t,
                        y: e,
                        size: i,
                        rotation: r
                    });
                }
                _drawSquare({ x: t, y: e, size: i, rotation: r }) {
                    this._basicSquare({
                        x: t,
                        y: e,
                        size: i,
                        rotation: r
                    });
                }
                _drawExtraRounded({ x: t, y: e, size: i, rotation: r }) {
                    this._basicExtraRounded({
                        x: t,
                        y: e,
                        size: i,
                        rotation: r
                    });
                }
            }
            const u = {
                dot: "dot",
                square: "square"
            }, c = Object.values(u);
            class l {
                constructor({ svg: t, type: e, window: i }){
                    this._svg = t, this._type = e, this._window = i;
                }
                draw(t, e, i, r) {
                    let n;
                    n = this._type === u.square ? this._drawSquare : this._drawDot, n.call(this, {
                        x: t,
                        y: e,
                        size: i,
                        rotation: r
                    });
                }
                _rotateFigure({ x: t, y: e, size: i, rotation: r = 0, draw: n }) {
                    var o;
                    const s = t + i / 2, a = e + i / 2;
                    n(), null === (o = this._element) || void 0 === o || o.setAttribute("transform", `rotate(${180 * r / Math.PI},${s},${a})`);
                }
                _basicDot(t) {
                    const { size: e, x: i, y: r } = t;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "circle"), this._element.setAttribute("cx", String(i + e / 2)), this._element.setAttribute("cy", String(r + e / 2)), this._element.setAttribute("r", String(e / 2));
                        }
                    }));
                }
                _basicSquare(t) {
                    const { size: e, x: i, y: r } = t;
                    this._rotateFigure(Object.assign(Object.assign({}, t), {
                        draw: ()=>{
                            this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "rect"), this._element.setAttribute("x", String(i)), this._element.setAttribute("y", String(r)), this._element.setAttribute("width", String(e)), this._element.setAttribute("height", String(e));
                        }
                    }));
                }
                _drawDot({ x: t, y: e, size: i, rotation: r }) {
                    this._basicDot({
                        x: t,
                        y: e,
                        size: i,
                        rotation: r
                    });
                }
                _drawSquare({ x: t, y: e, size: i, rotation: r }) {
                    this._basicSquare({
                        x: t,
                        y: e,
                        size: i,
                        rotation: r
                    });
                }
            }
            const g = "circle", f = [
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ], w = [
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    1,
                    1,
                    1,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    1,
                    1,
                    1,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    1,
                    1,
                    1,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ];
            class p {
                constructor(t, e){
                    this._roundSize = (t)=>this._options.dotsOptions.roundSize ? Math.floor(t) : t, this._window = e, this._element = this._window.document.createElementNS("http://www.w3.org/2000/svg", "svg"), this._element.setAttribute("width", String(t.width)), this._element.setAttribute("height", String(t.height)), this._element.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), t.dotsOptions.roundSize || this._element.setAttribute("shape-rendering", "crispEdges"), this._element.setAttribute("viewBox", `0 0 ${t.width} ${t.height}`), this._defs = this._window.document.createElementNS("http://www.w3.org/2000/svg", "defs"), this._element.appendChild(this._defs), this._imageUri = t.image, this._instanceId = p.instanceCount++, this._options = t;
                }
                get width() {
                    return this._options.width;
                }
                get height() {
                    return this._options.height;
                }
                getElement() {
                    return this._element;
                }
                async drawQR(t) {
                    const e = t.getModuleCount(), i = Math.min(this._options.width, this._options.height) - 2 * this._options.margin, r = this._options.shape === g ? i / Math.sqrt(2) : i, n = this._roundSize(r / e);
                    let s = {
                        hideXDots: 0,
                        hideYDots: 0,
                        width: 0,
                        height: 0
                    };
                    if (this._qr = t, this._options.image) {
                        if (await this.loadImage(), !this._image) return;
                        const { imageOptions: t, qrOptions: i } = this._options, r = t.imageSize * o[i.errorCorrectionLevel], a = Math.floor(r * e * e);
                        s = function({ originalHeight: t, originalWidth: e, maxHiddenDots: i, maxHiddenAxisDots: r, dotSize: n }) {
                            const o = {
                                x: 0,
                                y: 0
                            }, s = {
                                x: 0,
                                y: 0
                            };
                            if (t <= 0 || e <= 0 || i <= 0 || n <= 0) return {
                                height: 0,
                                width: 0,
                                hideYDots: 0,
                                hideXDots: 0
                            };
                            const a = t / e;
                            return o.x = Math.floor(Math.sqrt(i / a)), o.x <= 0 && (o.x = 1), r && r < o.x && (o.x = r), o.x % 2 == 0 && o.x--, s.x = o.x * n, o.y = 1 + 2 * Math.ceil((o.x * a - 1) / 2), s.y = Math.round(s.x * a), (o.y * o.x > i || r && r < o.y) && (r && r < o.y ? (o.y = r, o.y % 2 == 0 && o.x--) : o.y -= 2, s.y = o.y * n, o.x = 1 + 2 * Math.ceil((o.y / a - 1) / 2), s.x = Math.round(s.y / a)), {
                                height: s.y,
                                width: s.x,
                                hideYDots: o.y,
                                hideXDots: o.x
                            };
                        }({
                            originalWidth: this._image.width,
                            originalHeight: this._image.height,
                            maxHiddenDots: a,
                            maxHiddenAxisDots: e - 14,
                            dotSize: n
                        });
                    }
                    this.drawBackground(), this.drawDots((t, i)=>{
                        var r, n, o, a, h, d;
                        return !(this._options.imageOptions.hideBackgroundDots && t >= (e - s.hideYDots) / 2 && t < (e + s.hideYDots) / 2 && i >= (e - s.hideXDots) / 2 && i < (e + s.hideXDots) / 2 || (null === (r = f[t]) || void 0 === r ? void 0 : r[i]) || (null === (n = f[t - e + 7]) || void 0 === n ? void 0 : n[i]) || (null === (o = f[t]) || void 0 === o ? void 0 : o[i - e + 7]) || (null === (a = w[t]) || void 0 === a ? void 0 : a[i]) || (null === (h = w[t - e + 7]) || void 0 === h ? void 0 : h[i]) || (null === (d = w[t]) || void 0 === d ? void 0 : d[i - e + 7]));
                    }), this.drawCorners(), this._options.image && await this.drawImage({
                        width: s.width,
                        height: s.height,
                        count: e,
                        dotSize: n
                    });
                }
                drawBackground() {
                    var t, e, i;
                    const r = this._element, n = this._options;
                    if (r) {
                        const r = null === (t = n.backgroundOptions) || void 0 === t ? void 0 : t.gradient, o = null === (e = n.backgroundOptions) || void 0 === e ? void 0 : e.color;
                        let s = n.height, a = n.width;
                        if (r || o) {
                            const t = this._window.document.createElementNS("http://www.w3.org/2000/svg", "rect");
                            this._backgroundClipPath = this._window.document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), this._backgroundClipPath.setAttribute("id", `clip-path-background-color-${this._instanceId}`), this._defs.appendChild(this._backgroundClipPath), (null === (i = n.backgroundOptions) || void 0 === i ? void 0 : i.round) && (s = a = Math.min(n.width, n.height), t.setAttribute("rx", String(s / 2 * n.backgroundOptions.round))), t.setAttribute("x", String(this._roundSize((n.width - a) / 2))), t.setAttribute("y", String(this._roundSize((n.height - s) / 2))), t.setAttribute("width", String(a)), t.setAttribute("height", String(s)), this._backgroundClipPath.appendChild(t), this._createColor({
                                options: r,
                                color: o,
                                additionalRotation: 0,
                                x: 0,
                                y: 0,
                                height: n.height,
                                width: n.width,
                                name: `background-color-${this._instanceId}`
                            });
                        }
                    }
                }
                drawDots(t) {
                    var e, i;
                    if (!this._qr) throw "QR code is not defined";
                    const r = this._options, n = this._qr.getModuleCount();
                    if (n > r.width || n > r.height) throw "The canvas is too small.";
                    const o = Math.min(r.width, r.height) - 2 * r.margin, a = r.shape === g ? o / Math.sqrt(2) : o, h = this._roundSize(a / n), d = this._roundSize((r.width - n * h) / 2), u = this._roundSize((r.height - n * h) / 2), c = new s({
                        svg: this._element,
                        type: r.dotsOptions.type,
                        window: this._window
                    });
                    this._dotsClipPath = this._window.document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), this._dotsClipPath.setAttribute("id", `clip-path-dot-color-${this._instanceId}`), this._defs.appendChild(this._dotsClipPath), this._createColor({
                        options: null === (e = r.dotsOptions) || void 0 === e ? void 0 : e.gradient,
                        color: r.dotsOptions.color,
                        additionalRotation: 0,
                        x: 0,
                        y: 0,
                        height: r.height,
                        width: r.width,
                        name: `dot-color-${this._instanceId}`
                    });
                    for(let e = 0; e < n; e++)for(let r = 0; r < n; r++)t && !t(e, r) || (null === (i = this._qr) || void 0 === i ? void 0 : i.isDark(e, r)) && (c.draw(d + r * h, u + e * h, h, (i, o)=>!(r + i < 0 || e + o < 0 || r + i >= n || e + o >= n) && !(t && !t(e + o, r + i)) && !!this._qr && this._qr.isDark(e + o, r + i)), c._element && this._dotsClipPath && this._dotsClipPath.appendChild(c._element));
                    if (r.shape === g) {
                        const t = this._roundSize((o / h - n) / 2), e = n + 2 * t, i = d - t * h, r = u - t * h, s = [], a = this._roundSize(e / 2);
                        for(let i = 0; i < e; i++){
                            s[i] = [];
                            for(let r = 0; r < e; r++)i >= t - 1 && i <= e - t && r >= t - 1 && r <= e - t || Math.sqrt((i - a) * (i - a) + (r - a) * (r - a)) > a ? s[i][r] = 0 : s[i][r] = this._qr.isDark(r - 2 * t < 0 ? r : r >= n ? r - 2 * t : r - t, i - 2 * t < 0 ? i : i >= n ? i - 2 * t : i - t) ? 1 : 0;
                        }
                        for(let t = 0; t < e; t++)for(let n = 0; n < e; n++)s[t][n] && (c.draw(i + n * h, r + t * h, h, (e, i)=>{
                            var r;
                            return !!(null === (r = s[t + i]) || void 0 === r ? void 0 : r[n + e]);
                        }), c._element && this._dotsClipPath && this._dotsClipPath.appendChild(c._element));
                    }
                }
                drawCorners() {
                    if (!this._qr) throw "QR code is not defined";
                    const t = this._element, e = this._options;
                    if (!t) throw "Element code is not defined";
                    const i = this._qr.getModuleCount(), r = Math.min(e.width, e.height) - 2 * e.margin, n = e.shape === g ? r / Math.sqrt(2) : r, o = this._roundSize(n / i), a = 7 * o, u = 3 * o, p = this._roundSize((e.width - i * o) / 2), v = this._roundSize((e.height - i * o) / 2);
                    [
                        [
                            0,
                            0,
                            0
                        ],
                        [
                            1,
                            0,
                            Math.PI / 2
                        ],
                        [
                            0,
                            1,
                            -Math.PI / 2
                        ]
                    ].forEach(([t, r, n])=>{
                        var g, _, m, b, y, x, S, C, A, M, $, O, D, k;
                        const z = p + t * o * (i - 7), B = v + r * o * (i - 7);
                        let P = this._dotsClipPath, I = this._dotsClipPath;
                        if (((null === (g = e.cornersSquareOptions) || void 0 === g ? void 0 : g.gradient) || (null === (_ = e.cornersSquareOptions) || void 0 === _ ? void 0 : _.color)) && (P = this._window.document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), P.setAttribute("id", `clip-path-corners-square-color-${t}-${r}-${this._instanceId}`), this._defs.appendChild(P), this._cornersSquareClipPath = this._cornersDotClipPath = I = P, this._createColor({
                            options: null === (m = e.cornersSquareOptions) || void 0 === m ? void 0 : m.gradient,
                            color: null === (b = e.cornersSquareOptions) || void 0 === b ? void 0 : b.color,
                            additionalRotation: n,
                            x: z,
                            y: B,
                            height: a,
                            width: a,
                            name: `corners-square-color-${t}-${r}-${this._instanceId}`
                        })), (null === (y = e.cornersSquareOptions) || void 0 === y ? void 0 : y.type) && h.includes(e.cornersSquareOptions.type)) {
                            const t = new d({
                                svg: this._element,
                                type: e.cornersSquareOptions.type,
                                window: this._window
                            });
                            t.draw(z, B, a, n), t._element && P && P.appendChild(t._element);
                        } else {
                            const t = new s({
                                svg: this._element,
                                type: (null === (x = e.cornersSquareOptions) || void 0 === x ? void 0 : x.type) || e.dotsOptions.type,
                                window: this._window
                            });
                            for(let e = 0; e < f.length; e++)for(let i = 0; i < f[e].length; i++)(null === (S = f[e]) || void 0 === S ? void 0 : S[i]) && (t.draw(z + i * o, B + e * o, o, (t, r)=>{
                                var n;
                                return !!(null === (n = f[e + r]) || void 0 === n ? void 0 : n[i + t]);
                            }), t._element && P && P.appendChild(t._element));
                        }
                        if (((null === (C = e.cornersDotOptions) || void 0 === C ? void 0 : C.gradient) || (null === (A = e.cornersDotOptions) || void 0 === A ? void 0 : A.color)) && (I = this._window.document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), I.setAttribute("id", `clip-path-corners-dot-color-${t}-${r}-${this._instanceId}`), this._defs.appendChild(I), this._cornersDotClipPath = I, this._createColor({
                            options: null === (M = e.cornersDotOptions) || void 0 === M ? void 0 : M.gradient,
                            color: null === ($ = e.cornersDotOptions) || void 0 === $ ? void 0 : $.color,
                            additionalRotation: n,
                            x: z + 2 * o,
                            y: B + 2 * o,
                            height: u,
                            width: u,
                            name: `corners-dot-color-${t}-${r}-${this._instanceId}`
                        })), (null === (O = e.cornersDotOptions) || void 0 === O ? void 0 : O.type) && c.includes(e.cornersDotOptions.type)) {
                            const t = new l({
                                svg: this._element,
                                type: e.cornersDotOptions.type,
                                window: this._window
                            });
                            t.draw(z + 2 * o, B + 2 * o, u, n), t._element && I && I.appendChild(t._element);
                        } else {
                            const t = new s({
                                svg: this._element,
                                type: (null === (D = e.cornersDotOptions) || void 0 === D ? void 0 : D.type) || e.dotsOptions.type,
                                window: this._window
                            });
                            for(let e = 0; e < w.length; e++)for(let i = 0; i < w[e].length; i++)(null === (k = w[e]) || void 0 === k ? void 0 : k[i]) && (t.draw(z + i * o, B + e * o, o, (t, r)=>{
                                var n;
                                return !!(null === (n = w[e + r]) || void 0 === n ? void 0 : n[i + t]);
                            }), t._element && I && I.appendChild(t._element));
                        }
                    });
                }
                loadImage() {
                    return new Promise((t, e)=>{
                        var i;
                        const r = this._options;
                        if (!r.image) return e("Image is not defined");
                        if (null === (i = r.nodeCanvas) || void 0 === i ? void 0 : i.loadImage) r.nodeCanvas.loadImage(r.image).then((e)=>{
                            var i, n;
                            if (this._image = e, this._options.imageOptions.saveAsBlob) {
                                const t = null === (i = r.nodeCanvas) || void 0 === i ? void 0 : i.createCanvas(this._image.width, this._image.height);
                                null === (n = null == t ? void 0 : t.getContext("2d")) || void 0 === n || n.drawImage(e, 0, 0), this._imageUri = null == t ? void 0 : t.toDataURL();
                            }
                            t();
                        }).catch(e);
                        else {
                            const e = new this._window.Image;
                            "string" == typeof r.imageOptions.crossOrigin && (e.crossOrigin = r.imageOptions.crossOrigin), this._image = e, e.onload = async ()=>{
                                this._options.imageOptions.saveAsBlob && (this._imageUri = await async function(t, e) {
                                    return new Promise((i)=>{
                                        const r = new e.XMLHttpRequest;
                                        r.onload = function() {
                                            const t = new e.FileReader;
                                            t.onloadend = function() {
                                                i(t.result);
                                            }, t.readAsDataURL(r.response);
                                        }, r.open("GET", t), r.responseType = "blob", r.send();
                                    });
                                }(r.image || "", this._window)), t();
                            }, e.src = r.image;
                        }
                    });
                }
                async drawImage({ width: t, height: e, count: i, dotSize: r }) {
                    const n = this._options, o = this._roundSize((n.width - i * r) / 2), s = this._roundSize((n.height - i * r) / 2), a = o + this._roundSize(n.imageOptions.margin + (i * r - t) / 2), h = s + this._roundSize(n.imageOptions.margin + (i * r - e) / 2), d = t - 2 * n.imageOptions.margin, u = e - 2 * n.imageOptions.margin, c = this._window.document.createElementNS("http://www.w3.org/2000/svg", "image");
                    c.setAttribute("href", this._imageUri || ""), c.setAttribute("xlink:href", this._imageUri || ""), c.setAttribute("x", String(a)), c.setAttribute("y", String(h)), c.setAttribute("width", `${d}px`), c.setAttribute("height", `${u}px`), this._element.appendChild(c);
                }
                _createColor({ options: t, color: e, additionalRotation: i, x: r, y: n, height: o, width: s, name: a }) {
                    const h = s > o ? s : o, d = this._window.document.createElementNS("http://www.w3.org/2000/svg", "rect");
                    if (d.setAttribute("x", String(r)), d.setAttribute("y", String(n)), d.setAttribute("height", String(o)), d.setAttribute("width", String(s)), d.setAttribute("clip-path", `url('#clip-path-${a}')`), t) {
                        let e;
                        if ("radial" === t.type) e = this._window.document.createElementNS("http://www.w3.org/2000/svg", "radialGradient"), e.setAttribute("id", a), e.setAttribute("gradientUnits", "userSpaceOnUse"), e.setAttribute("fx", String(r + s / 2)), e.setAttribute("fy", String(n + o / 2)), e.setAttribute("cx", String(r + s / 2)), e.setAttribute("cy", String(n + o / 2)), e.setAttribute("r", String(h / 2));
                        else {
                            const h = ((t.rotation || 0) + i) % (2 * Math.PI), d = (h + 2 * Math.PI) % (2 * Math.PI);
                            let u = r + s / 2, c = n + o / 2, l = r + s / 2, g = n + o / 2;
                            d >= 0 && d <= .25 * Math.PI || d > 1.75 * Math.PI && d <= 2 * Math.PI ? (u -= s / 2, c -= o / 2 * Math.tan(h), l += s / 2, g += o / 2 * Math.tan(h)) : d > .25 * Math.PI && d <= .75 * Math.PI ? (c -= o / 2, u -= s / 2 / Math.tan(h), g += o / 2, l += s / 2 / Math.tan(h)) : d > .75 * Math.PI && d <= 1.25 * Math.PI ? (u += s / 2, c += o / 2 * Math.tan(h), l -= s / 2, g -= o / 2 * Math.tan(h)) : d > 1.25 * Math.PI && d <= 1.75 * Math.PI && (c += o / 2, u += s / 2 / Math.tan(h), g -= o / 2, l -= s / 2 / Math.tan(h)), e = this._window.document.createElementNS("http://www.w3.org/2000/svg", "linearGradient"), e.setAttribute("id", a), e.setAttribute("gradientUnits", "userSpaceOnUse"), e.setAttribute("x1", String(Math.round(u))), e.setAttribute("y1", String(Math.round(c))), e.setAttribute("x2", String(Math.round(l))), e.setAttribute("y2", String(Math.round(g)));
                        }
                        t.colorStops.forEach(({ offset: t, color: i })=>{
                            const r = this._window.document.createElementNS("http://www.w3.org/2000/svg", "stop");
                            r.setAttribute("offset", 100 * t + "%"), r.setAttribute("stop-color", i), e.appendChild(r);
                        }), d.setAttribute("fill", `url('#${a}')`), this._defs.appendChild(e);
                    } else e && d.setAttribute("fill", e);
                    this._element.appendChild(d);
                }
            }
            p.instanceCount = 0;
            const v = p, _ = "canvas", m = {};
            for(let t = 0; t <= 40; t++)m[t] = t;
            const b = {
                type: _,
                shape: "square",
                width: 300,
                height: 300,
                data: "",
                margin: 0,
                qrOptions: {
                    typeNumber: m[0],
                    mode: void 0,
                    errorCorrectionLevel: "Q"
                },
                imageOptions: {
                    saveAsBlob: !0,
                    hideBackgroundDots: !0,
                    imageSize: .4,
                    crossOrigin: void 0,
                    margin: 0
                },
                dotsOptions: {
                    type: "square",
                    color: "#000",
                    roundSize: !0
                },
                backgroundOptions: {
                    round: 0,
                    color: "#fff"
                }
            };
            function y(t) {
                const e = Object.assign({}, t);
                if (!e.colorStops || !e.colorStops.length) throw "Field 'colorStops' is required in gradient";
                return e.rotation ? e.rotation = Number(e.rotation) : e.rotation = 0, e.colorStops = e.colorStops.map((t)=>Object.assign(Object.assign({}, t), {
                        offset: Number(t.offset)
                    })), e;
            }
            function x(t) {
                const e = Object.assign({}, t);
                return e.width = Number(e.width), e.height = Number(e.height), e.margin = Number(e.margin), e.imageOptions = Object.assign(Object.assign({}, e.imageOptions), {
                    hideBackgroundDots: Boolean(e.imageOptions.hideBackgroundDots),
                    imageSize: Number(e.imageOptions.imageSize),
                    margin: Number(e.imageOptions.margin)
                }), e.margin > Math.min(e.width, e.height) && (e.margin = Math.min(e.width, e.height)), e.dotsOptions = Object.assign({}, e.dotsOptions), e.dotsOptions.gradient && (e.dotsOptions.gradient = y(e.dotsOptions.gradient)), e.cornersSquareOptions && (e.cornersSquareOptions = Object.assign({}, e.cornersSquareOptions), e.cornersSquareOptions.gradient && (e.cornersSquareOptions.gradient = y(e.cornersSquareOptions.gradient))), e.cornersDotOptions && (e.cornersDotOptions = Object.assign({}, e.cornersDotOptions), e.cornersDotOptions.gradient && (e.cornersDotOptions.gradient = y(e.cornersDotOptions.gradient))), e.backgroundOptions && (e.backgroundOptions = Object.assign({}, e.backgroundOptions), e.backgroundOptions.gradient && (e.backgroundOptions.gradient = y(e.backgroundOptions.gradient))), e;
            }
            var S = i(873), C = i.n(S);
            function A(t) {
                if (!t) throw new Error("Extension must be defined");
                "." === t[0] && (t = t.substring(1));
                const e = {
                    bmp: "image/bmp",
                    gif: "image/gif",
                    ico: "image/vnd.microsoft.icon",
                    jpeg: "image/jpeg",
                    jpg: "image/jpeg",
                    png: "image/png",
                    svg: "image/svg+xml",
                    tif: "image/tiff",
                    tiff: "image/tiff",
                    webp: "image/webp",
                    pdf: "application/pdf"
                }[t.toLowerCase()];
                if (!e) throw new Error(`Extension "${t}" is not supported`);
                return e;
            }
            class M {
                constructor(t){
                    (null == t ? void 0 : t.jsdom) ? this._window = new t.jsdom("", {
                        resources: "usable"
                    }).window : this._window = window, this._options = t ? x(e(b, t)) : b, this.update();
                }
                static _clearContainer(t) {
                    t && (t.innerHTML = "");
                }
                _setupSvg() {
                    if (!this._qr) return;
                    const t = new v(this._options, this._window);
                    this._svg = t.getElement(), this._svgDrawingPromise = t.drawQR(this._qr).then(()=>{
                        var e;
                        this._svg && (null === (e = this._extension) || void 0 === e || e.call(this, t.getElement(), this._options));
                    });
                }
                _setupCanvas() {
                    var t, e;
                    this._qr && ((null === (t = this._options.nodeCanvas) || void 0 === t ? void 0 : t.createCanvas) ? (this._nodeCanvas = this._options.nodeCanvas.createCanvas(this._options.width, this._options.height), this._nodeCanvas.width = this._options.width, this._nodeCanvas.height = this._options.height) : (this._domCanvas = document.createElement("canvas"), this._domCanvas.width = this._options.width, this._domCanvas.height = this._options.height), this._setupSvg(), this._canvasDrawingPromise = null === (e = this._svgDrawingPromise) || void 0 === e ? void 0 : e.then(()=>{
                        var t;
                        if (!this._svg) return;
                        const e = this._svg, i = (new this._window.XMLSerializer).serializeToString(e), r = btoa(i), n = `data:${A("svg")};base64,${r}`;
                        if (null === (t = this._options.nodeCanvas) || void 0 === t ? void 0 : t.loadImage) return this._options.nodeCanvas.loadImage(n).then((t)=>{
                            var e, i;
                            t.width = this._options.width, t.height = this._options.height, null === (i = null === (e = this._nodeCanvas) || void 0 === e ? void 0 : e.getContext("2d")) || void 0 === i || i.drawImage(t, 0, 0);
                        });
                        {
                            const t = new this._window.Image;
                            return new Promise((e)=>{
                                t.onload = ()=>{
                                    var i, r;
                                    null === (r = null === (i = this._domCanvas) || void 0 === i ? void 0 : i.getContext("2d")) || void 0 === r || r.drawImage(t, 0, 0), e();
                                }, t.src = n;
                            });
                        }
                    }));
                }
                async _getElement(t = "png") {
                    if (!this._qr) throw "QR code is empty";
                    return "svg" === t.toLowerCase() ? (this._svg && this._svgDrawingPromise || this._setupSvg(), await this._svgDrawingPromise, this._svg) : ((this._domCanvas || this._nodeCanvas) && this._canvasDrawingPromise || this._setupCanvas(), await this._canvasDrawingPromise, this._domCanvas || this._nodeCanvas);
                }
                update(t) {
                    M._clearContainer(this._container), this._options = t ? x(e(this._options, t)) : this._options, this._options.data && (this._qr = C()(this._options.qrOptions.typeNumber, this._options.qrOptions.errorCorrectionLevel), this._qr.addData(this._options.data, this._options.qrOptions.mode || function(t) {
                        switch(!0){
                            case /^[0-9]*$/.test(t):
                                return "Numeric";
                            case /^[0-9A-Z $%*+\-./:]*$/.test(t):
                                return "Alphanumeric";
                            default:
                                return "Byte";
                        }
                    }(this._options.data)), this._qr.make(), this._options.type === _ ? this._setupCanvas() : this._setupSvg(), this.append(this._container));
                }
                append(t) {
                    if (t) {
                        if ("function" != typeof t.appendChild) throw "Container should be a single DOM node";
                        this._options.type === _ ? this._domCanvas && t.appendChild(this._domCanvas) : this._svg && t.appendChild(this._svg), this._container = t;
                    }
                }
                applyExtension(t) {
                    if (!t) throw "Extension function should be defined.";
                    this._extension = t, this.update();
                }
                deleteExtension() {
                    this._extension = void 0, this.update();
                }
                async getRawData(t = "png") {
                    if (!this._qr) throw "QR code is empty";
                    const e = await this._getElement(t), i = A(t);
                    if (!e) return null;
                    if ("svg" === t.toLowerCase()) {
                        const t = `<?xml version="1.0" standalone="no"?>\r\n${(new this._window.XMLSerializer).serializeToString(e)}`;
                        return "undefined" == typeof Blob || this._options.jsdom ? $9f2374f19df7e0a5$require$Buffer.from(t) : new Blob([
                            t
                        ], {
                            type: i
                        });
                    }
                    return new Promise((t)=>{
                        const r = e;
                        if ("toBuffer" in r) {
                            if ("image/png" === i) t(r.toBuffer(i));
                            else if ("image/jpeg" === i) t(r.toBuffer(i));
                            else {
                                if ("application/pdf" !== i) throw Error("Unsupported extension");
                                t(r.toBuffer(i));
                            }
                        } else "toBlob" in r && r.toBlob(t, i, 1);
                    });
                }
                async download(t) {
                    if (!this._qr) throw "QR code is empty";
                    if ("undefined" == typeof Blob) throw "Cannot download in Node.js, call getRawData instead.";
                    let e = "png", i = "qr";
                    "string" == typeof t ? (e = t, console.warn("Extension is deprecated as argument for 'download' method, please pass object { name: '...', extension: '...' } as argument")) : "object" == typeof t && null !== t && (t.name && (i = t.name), t.extension && (e = t.extension));
                    const r = await this._getElement(e);
                    if (r) {
                        if ("svg" === e.toLowerCase()) {
                            let t = (new XMLSerializer).serializeToString(r);
                            t = '<?xml version="1.0" standalone="no"?>\r\n' + t, n(`data:${A(e)};charset=utf-8,${encodeURIComponent(t)}`, `${i}.svg`);
                        } else n(r.toDataURL(A(e)), `${i}.${e}`);
                    }
                }
            }
            const $ = M;
        })(), r.default;
    })());


class $e64d571cb2472c1b$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "container"
    ];
    static values = {
        url: String,
        size: {
            type: Number,
            default: 224
        },
        logo: String,
        renderer: {
            type: String,
            default: "canvas"
        }
    };
    connect() {
        this.qr = new (0, (/*@__PURE__*/$parcel$interopDefault($9f2374f19df7e0a5$exports)))({
            width: this.sizeValue,
            height: this.sizeValue,
            type: this.rendererValue,
            data: this.urlValue || window.location.href,
            margin: 0,
            qrOptions: {
                typeNumber: 0,
                mode: "Byte",
                errorCorrectionLevel: "Q"
            },
            dotsOptions: {
                type: "square",
                color: "#000000",
                roundSize: true
            },
            backgroundOptions: {
                color: "#ffffff"
            },
            image: this.logoValue || undefined,
            imageOptions: {
                hideBackgroundDots: true,
                imageSize: 0.4,
                margin: 9,
                crossOrigin: "anonymous" // important for canvas + export
            },
            cornersSquareOptions: {
                type: "extra-rounded",
                color: "#000000"
            },
            cornersDotOptions: {
                type: "dot",
                color: "#000000"
            }
        });
        this.containerTarget.innerHTML = "";
        this.qr.append(this.containerTarget);
    }
}



class $bd07b205d506109d$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "panel",
        "chevron",
        "text"
    ];
    connect() {
        this.open = false;
    }
    toggle() {
        this.open = !this.open;
        if (this.open == true) this.textTarget.textContent = "Hide QR";
        else this.textTarget.textContent = "Show QR";
        this.panelTarget.classList.toggle("max-h-0", !this.open);
        this.panelTarget.classList.toggle("opacity-0", !this.open);
        this.panelTarget.classList.toggle("max-h-96", this.open);
        this.panelTarget.classList.toggle("opacity-100", this.open);
        this.chevronTarget.classList.toggle("rotate-180", this.open);
    }
}




const $489688dce298f7de$var$SESSION_STORAGE_KEY = "rr_sid";
class $489688dce298f7de$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        session: String
    };
    connect() {
        let token = this.sessionValue;
        if (!token) {
            token = this.readFromSessionStorage();
            if (token) this.sessionValue = token;
        }
        this.viewport = (0, $6adb56df0e842c64$export$f1768d02d4612c4)();
        this.beforeFetchHandler = this.beforeFetchHandler || this.beforeFetch.bind(this);
        document.addEventListener("turbo:before-fetch-request", this.beforeFetchHandler);
    }
    disconnect() {
        if (this.beforeFetchHandler) document.removeEventListener("turbo:before-fetch-request", this.beforeFetchHandler);
    }
    beforeFetch(event) {
        const { fetchOptions: fetchOptions, url: url } = event.detail;
        if (!fetchOptions.headers) fetchOptions.headers = {};
        const requestUrl = (url || fetchOptions.url || "").toString();
        if (requestUrl.includes("/logout")) {
            try {
                if (window.top !== window.self) fetchOptions.headers["X-RR-Embed"] = "1";
            } catch (err) {
                fetchOptions.headers["X-RR-Embed"] = "1";
            }
            this.sessionValue = "";
            try {
                window.sessionStorage.removeItem($489688dce298f7de$var$SESSION_STORAGE_KEY);
            } catch (e) {
            // ignore
            }
            return;
        }
        try {
            if (window.top !== window.self) fetchOptions.headers["X-RR-Embed"] = "1";
        } catch (err) {
            fetchOptions.headers["X-RR-Embed"] = "1";
        }
        if (!this.sessionValue) return;
        fetchOptions.headers["X-Requested-With"] = "Turbo";
        fetchOptions.headers["X-Session"] = this.sessionValue;
        fetchOptions.headers["X-RR-Device"] = this.viewport;
    }
    readFromSessionStorage() {
        try {
            return window.sessionStorage.getItem($489688dce298f7de$var$SESSION_STORAGE_KEY) || "";
        } catch (e) {
            return "";
        }
    }
    sessionValueChanged(newValue, oldValue) {
        if (!newValue) {
            try {
                window.sessionStorage.removeItem($489688dce298f7de$var$SESSION_STORAGE_KEY);
            } catch (e) {}
            return;
        }
        try {
            window.sessionStorage.setItem($489688dce298f7de$var$SESSION_STORAGE_KEY, newValue);
        } catch (e) {}
    }
}



var $a624709dd034fdf4$exports = {};
/*!
 * Pusher JavaScript Library v8.5.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $a624709dd034fdf4$exports = factory();
})(self, ()=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ 594 (__unused_webpack_module, exports) {
                "use strict";
                // Copyright (C) 2016 Dmitry Chestnykh
                // MIT License. See LICENSE file for details.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /**
 * Package base64 implements Base64 encoding and decoding.
 */ // Invalid character used in decoding to indicate
                // that the character to decode is out of range of
                // alphabet and cannot be decoded.
                var INVALID_BYTE = 256;
                /**
 * Implements standard Base64 encoding.
 *
 * Operates in constant time.
 */ var Coder = /** @class */ function() {
                    // TODO(dchest): methods to encode chunk-by-chunk.
                    function Coder(_paddingCharacter) {
                        if (_paddingCharacter === void 0) _paddingCharacter = "=";
                        this._paddingCharacter = _paddingCharacter;
                    }
                    Coder.prototype.encodedLength = function(length) {
                        if (!this._paddingCharacter) return (length * 8 + 5) / 6 | 0;
                        return (length + 2) / 3 * 4 | 0;
                    };
                    Coder.prototype.encode = function(data) {
                        var out = "";
                        var i = 0;
                        for(; i < data.length - 2; i += 3){
                            var c = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                            out += this._encodeByte(c >>> 18 & 63);
                            out += this._encodeByte(c >>> 12 & 63);
                            out += this._encodeByte(c >>> 6 & 63);
                            out += this._encodeByte(c >>> 0 & 63);
                        }
                        var left = data.length - i;
                        if (left > 0) {
                            var c = data[i] << 16 | (left === 2 ? data[i + 1] << 8 : 0);
                            out += this._encodeByte(c >>> 18 & 63);
                            out += this._encodeByte(c >>> 12 & 63);
                            if (left === 2) out += this._encodeByte(c >>> 6 & 63);
                            else out += this._paddingCharacter || "";
                            out += this._paddingCharacter || "";
                        }
                        return out;
                    };
                    Coder.prototype.maxDecodedLength = function(length) {
                        if (!this._paddingCharacter) return (length * 6 + 7) / 8 | 0;
                        return length / 4 * 3 | 0;
                    };
                    Coder.prototype.decodedLength = function(s) {
                        return this.maxDecodedLength(s.length - this._getPaddingLength(s));
                    };
                    Coder.prototype.decode = function(s) {
                        if (s.length === 0) return new Uint8Array(0);
                        var paddingLength = this._getPaddingLength(s);
                        var length = s.length - paddingLength;
                        var out = new Uint8Array(this.maxDecodedLength(length));
                        var op = 0;
                        var i = 0;
                        var haveBad = 0;
                        var v0 = 0, v1 = 0, v2 = 0, v3 = 0;
                        for(; i < length - 4; i += 4){
                            v0 = this._decodeChar(s.charCodeAt(i + 0));
                            v1 = this._decodeChar(s.charCodeAt(i + 1));
                            v2 = this._decodeChar(s.charCodeAt(i + 2));
                            v3 = this._decodeChar(s.charCodeAt(i + 3));
                            out[op++] = v0 << 2 | v1 >>> 4;
                            out[op++] = v1 << 4 | v2 >>> 2;
                            out[op++] = v2 << 6 | v3;
                            haveBad |= v0 & INVALID_BYTE;
                            haveBad |= v1 & INVALID_BYTE;
                            haveBad |= v2 & INVALID_BYTE;
                            haveBad |= v3 & INVALID_BYTE;
                        }
                        if (i < length - 1) {
                            v0 = this._decodeChar(s.charCodeAt(i));
                            v1 = this._decodeChar(s.charCodeAt(i + 1));
                            out[op++] = v0 << 2 | v1 >>> 4;
                            haveBad |= v0 & INVALID_BYTE;
                            haveBad |= v1 & INVALID_BYTE;
                        }
                        if (i < length - 2) {
                            v2 = this._decodeChar(s.charCodeAt(i + 2));
                            out[op++] = v1 << 4 | v2 >>> 2;
                            haveBad |= v2 & INVALID_BYTE;
                        }
                        if (i < length - 3) {
                            v3 = this._decodeChar(s.charCodeAt(i + 3));
                            out[op++] = v2 << 6 | v3;
                            haveBad |= v3 & INVALID_BYTE;
                        }
                        if (haveBad !== 0) throw new Error("Base64Coder: incorrect characters for decoding");
                        return out;
                    };
                    // Standard encoding have the following encoded/decoded ranges,
                    // which we need to convert between.
                    //
                    // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  +   /
                    // Index:   0 - 25                    26 - 51              52 - 61   62  63
                    // ASCII:  65 - 90                    97 - 122             48 - 57   43  47
                    //
                    // Encode 6 bits in b into a new character.
                    Coder.prototype._encodeByte = function(b) {
                        // Encoding uses constant time operations as follows:
                        //
                        // 1. Define comparison of A with B using (A - B) >>> 8:
                        //          if A > B, then result is positive integer
                        //          if A <= B, then result is 0
                        //
                        // 2. Define selection of C or 0 using bitwise AND: X & C:
                        //          if X == 0, then result is 0
                        //          if X != 0, then result is C
                        //
                        // 3. Start with the smallest comparison (b >= 0), which is always
                        //    true, so set the result to the starting ASCII value (65).
                        //
                        // 4. Continue comparing b to higher ASCII values, and selecting
                        //    zero if comparison isn't true, otherwise selecting a value
                        //    to add to result, which:
                        //
                        //          a) undoes the previous addition
                        //          b) provides new value to add
                        //
                        var result = b;
                        // b >= 0
                        result += 65;
                        // b > 25
                        result += 25 - b >>> 8 & 6;
                        // b > 51
                        result += 51 - b >>> 8 & -75;
                        // b > 61
                        result += 61 - b >>> 8 & -15;
                        // b > 62
                        result += 62 - b >>> 8 & 3;
                        return String.fromCharCode(result);
                    };
                    // Decode a character code into a byte.
                    // Must return 256 if character is out of alphabet range.
                    Coder.prototype._decodeChar = function(c) {
                        // Decoding works similar to encoding: using the same comparison
                        // function, but now it works on ranges: result is always incremented
                        // by value, but this value becomes zero if the range is not
                        // satisfied.
                        //
                        // Decoding starts with invalid value, 256, which is then
                        // subtracted when the range is satisfied. If none of the ranges
                        // apply, the function returns 256, which is then checked by
                        // the caller to throw error.
                        var result = INVALID_BYTE; // start with invalid character
                        // c == 43 (c > 42 and c < 44)
                        result += (42 - c & c - 44) >>> 8 & -INVALID_BYTE + c - 43 + 62;
                        // c == 47 (c > 46 and c < 48)
                        result += (46 - c & c - 48) >>> 8 & -INVALID_BYTE + c - 47 + 63;
                        // c > 47 and c < 58
                        result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                        // c > 64 and c < 91
                        result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                        // c > 96 and c < 123
                        result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                        return result;
                    };
                    Coder.prototype._getPaddingLength = function(s) {
                        var paddingLength = 0;
                        if (this._paddingCharacter) {
                            for(var i = s.length - 1; i >= 0; i--){
                                if (s[i] !== this._paddingCharacter) break;
                                paddingLength++;
                            }
                            if (s.length < 4 || paddingLength > 2) throw new Error("Base64Coder: incorrect padding");
                        }
                        return paddingLength;
                    };
                    return Coder;
                }();
                exports.Coder = Coder;
                var stdCoder = new Coder();
                function encode(data) {
                    return stdCoder.encode(data);
                }
                exports.encode = encode;
                function decode(s) {
                    return stdCoder.decode(s);
                }
                exports.decode = decode;
                /**
 * Implements URL-safe Base64 encoding.
 * (Same as Base64, but '+' is replaced with '-', and '/' with '_').
 *
 * Operates in constant time.
 */ var URLSafeCoder = /** @class */ function(_super) {
                    __extends(URLSafeCoder, _super);
                    function URLSafeCoder() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    // URL-safe encoding have the following encoded/decoded ranges:
                    //
                    // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  -   _
                    // Index:   0 - 25                    26 - 51              52 - 61   62  63
                    // ASCII:  65 - 90                    97 - 122             48 - 57   45  95
                    //
                    URLSafeCoder.prototype._encodeByte = function(b) {
                        var result = b;
                        // b >= 0
                        result += 65;
                        // b > 25
                        result += 25 - b >>> 8 & 6;
                        // b > 51
                        result += 51 - b >>> 8 & -75;
                        // b > 61
                        result += 61 - b >>> 8 & -13;
                        // b > 62
                        result += 62 - b >>> 8 & 49;
                        return String.fromCharCode(result);
                    };
                    URLSafeCoder.prototype._decodeChar = function(c) {
                        var result = INVALID_BYTE;
                        // c == 45 (c > 44 and c < 46)
                        result += (44 - c & c - 46) >>> 8 & -INVALID_BYTE + c - 45 + 62;
                        // c == 95 (c > 94 and c < 96)
                        result += (94 - c & c - 96) >>> 8 & -INVALID_BYTE + c - 95 + 63;
                        // c > 47 and c < 58
                        result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                        // c > 64 and c < 91
                        result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                        // c > 96 and c < 123
                        result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                        return result;
                    };
                    return URLSafeCoder;
                }(Coder);
                exports.URLSafeCoder = URLSafeCoder;
                var urlSafeCoder = new URLSafeCoder();
                function encodeURLSafe(data) {
                    return urlSafeCoder.encode(data);
                }
                exports.encodeURLSafe = encodeURLSafe;
                function decodeURLSafe(s) {
                    return urlSafeCoder.decode(s);
                }
                exports.decodeURLSafe = decodeURLSafe;
                exports.encodedLength = function(length) {
                    return stdCoder.encodedLength(length);
                };
                exports.maxDecodedLength = function(length) {
                    return stdCoder.maxDecodedLength(length);
                };
                exports.decodedLength = function(s) {
                    return stdCoder.decodedLength(s);
                };
            /***/ },
            /***/ 978 (__unused_webpack_module, exports) {
                "use strict";
                var __webpack_unused_export__;
                // Copyright (C) 2016 Dmitry Chestnykh
                // MIT License. See LICENSE file for details.
                __webpack_unused_export__ = {
                    value: true
                };
                /**
 * Package utf8 implements UTF-8 encoding and decoding.
 */ var INVALID_UTF16 = "utf8: invalid string";
                var INVALID_UTF8 = "utf8: invalid source encoding";
                /**
 * Encodes the given string into UTF-8 byte array.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encode(s) {
                    // Calculate result length and allocate output array.
                    // encodedLength() also validates string and throws errors,
                    // so we don't need repeat validation here.
                    var arr = new Uint8Array(encodedLength(s));
                    var pos = 0;
                    for(var i = 0; i < s.length; i++){
                        var c = s.charCodeAt(i);
                        if (c < 0x80) arr[pos++] = c;
                        else if (c < 0x800) {
                            arr[pos++] = 0xc0 | c >> 6;
                            arr[pos++] = 0x80 | c & 0x3f;
                        } else if (c < 0xd800) {
                            arr[pos++] = 0xe0 | c >> 12;
                            arr[pos++] = 0x80 | c >> 6 & 0x3f;
                            arr[pos++] = 0x80 | c & 0x3f;
                        } else {
                            i++; // get one more character
                            c = (c & 0x3ff) << 10;
                            c |= s.charCodeAt(i) & 0x3ff;
                            c += 0x10000;
                            arr[pos++] = 0xf0 | c >> 18;
                            arr[pos++] = 0x80 | c >> 12 & 0x3f;
                            arr[pos++] = 0x80 | c >> 6 & 0x3f;
                            arr[pos++] = 0x80 | c & 0x3f;
                        }
                    }
                    return arr;
                }
                __webpack_unused_export__ = encode;
                /**
 * Returns the number of bytes required to encode the given string into UTF-8.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encodedLength(s) {
                    var result = 0;
                    for(var i = 0; i < s.length; i++){
                        var c = s.charCodeAt(i);
                        if (c < 0x80) result += 1;
                        else if (c < 0x800) result += 2;
                        else if (c < 0xd800) result += 3;
                        else if (c <= 0xdfff) {
                            if (i >= s.length - 1) throw new Error(INVALID_UTF16);
                            i++; // "eat" next character
                            result += 4;
                        } else throw new Error(INVALID_UTF16);
                    }
                    return result;
                }
                __webpack_unused_export__ = encodedLength;
                /**
 * Decodes the given byte array from UTF-8 into a string.
 * Throws if encoding is invalid.
 */ function decode(arr) {
                    var chars = [];
                    for(var i = 0; i < arr.length; i++){
                        var b = arr[i];
                        if (b & 0x80) {
                            var min = void 0;
                            if (b < 0xe0) {
                                // Need 1 more byte.
                                if (i >= arr.length) throw new Error(INVALID_UTF8);
                                var n1 = arr[++i];
                                if ((n1 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                                b = (b & 0x1f) << 6 | n1 & 0x3f;
                                min = 0x80;
                            } else if (b < 0xf0) {
                                // Need 2 more bytes.
                                if (i >= arr.length - 1) throw new Error(INVALID_UTF8);
                                var n1 = arr[++i];
                                var n2 = arr[++i];
                                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                                b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | n2 & 0x3f;
                                min = 0x800;
                            } else if (b < 0xf8) {
                                // Need 3 more bytes.
                                if (i >= arr.length - 2) throw new Error(INVALID_UTF8);
                                var n1 = arr[++i];
                                var n2 = arr[++i];
                                var n3 = arr[++i];
                                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                                b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | n3 & 0x3f;
                                min = 0x10000;
                            } else throw new Error(INVALID_UTF8);
                            if (b < min || b >= 0xd800 && b <= 0xdfff) throw new Error(INVALID_UTF8);
                            if (b >= 0x10000) {
                                // Surrogate pair.
                                if (b > 0x10ffff) throw new Error(INVALID_UTF8);
                                b -= 0x10000;
                                chars.push(String.fromCharCode(0xd800 | b >> 10));
                                b = 0xdc00 | b & 0x3ff;
                            }
                        }
                        chars.push(String.fromCharCode(b));
                    }
                    return chars.join("");
                }
                exports.D4 = decode;
            /***/ },
            /***/ 721 (module1, __unused_webpack_exports, __webpack_require__) {
                // required so we don't have to do require('pusher').default etc.
                module1.exports = __webpack_require__(207)["default"];
            /***/ },
            /***/ 207 (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": ()=>/* binding */ pusher
                });
                class ScriptReceiverFactory {
                    constructor(prefix, name){
                        this.lastId = 0;
                        this.prefix = prefix;
                        this.name = name;
                    }
                    create(callback) {
                        this.lastId++;
                        var number = this.lastId;
                        var id = this.prefix + number;
                        var name = this.name + '[' + number + ']';
                        var called = false;
                        var callbackWrapper = function() {
                            if (!called) {
                                callback.apply(null, arguments);
                                called = true;
                            }
                        };
                        this[number] = callbackWrapper;
                        return {
                            number: number,
                            id: id,
                            name: name,
                            callback: callbackWrapper
                        };
                    }
                    remove(receiver) {
                        delete this[receiver.number];
                    }
                }
                var ScriptReceivers = new ScriptReceiverFactory('_pusher_script_', 'Pusher.ScriptReceivers');
                var Defaults = {
                    VERSION: "8.5.0",
                    PROTOCOL: 7,
                    wsPort: 80,
                    wssPort: 443,
                    wsPath: '',
                    httpHost: 'sockjs.pusher.com',
                    httpPort: 80,
                    httpsPort: 443,
                    httpPath: '/pusher',
                    stats_host: 'stats.pusher.com',
                    authEndpoint: '/pusher/auth',
                    authTransport: 'ajax',
                    activityTimeout: 120000,
                    pongTimeout: 30000,
                    unavailableTimeout: 10000,
                    userAuthentication: {
                        endpoint: '/pusher/user-auth',
                        transport: 'ajax'
                    },
                    channelAuthorization: {
                        endpoint: '/pusher/auth',
                        transport: 'ajax'
                    },
                    cdn_http: "http://js.pusher.com",
                    cdn_https: "https://js.pusher.com",
                    dependency_suffix: ""
                };
                /* harmony default export */ const defaults = Defaults;
                class DependencyLoader {
                    constructor(options){
                        this.options = options;
                        this.receivers = options.receivers || ScriptReceivers;
                        this.loading = {};
                    }
                    load(name, options, callback) {
                        var self1 = this;
                        if (self1.loading[name] && self1.loading[name].length > 0) self1.loading[name].push(callback);
                        else {
                            self1.loading[name] = [
                                callback
                            ];
                            var request = runtime.createScriptRequest(self1.getPath(name, options));
                            var receiver = self1.receivers.create(function(error) {
                                self1.receivers.remove(receiver);
                                if (self1.loading[name]) {
                                    var callbacks = self1.loading[name];
                                    delete self1.loading[name];
                                    var successCallback = function(wasSuccessful) {
                                        if (!wasSuccessful) request.cleanup();
                                    };
                                    for(var i = 0; i < callbacks.length; i++)callbacks[i](error, successCallback);
                                }
                            });
                            request.send(receiver);
                        }
                    }
                    getRoot(options) {
                        var cdn;
                        var protocol = runtime.getDocument().location.protocol;
                        if (options && options.useTLS || protocol === 'https:') cdn = this.options.cdn_https;
                        else cdn = this.options.cdn_http;
                        return cdn.replace(/\/*$/, '') + '/' + this.options.version;
                    }
                    getPath(name, options) {
                        return this.getRoot(options) + '/' + name + this.options.suffix + '.js';
                    }
                }
                var DependenciesReceivers = new ScriptReceiverFactory('_pusher_dependencies', 'Pusher.DependenciesReceivers');
                var Dependencies = new DependencyLoader({
                    cdn_http: defaults.cdn_http,
                    cdn_https: defaults.cdn_https,
                    version: defaults.VERSION,
                    suffix: defaults.dependency_suffix,
                    receivers: DependenciesReceivers
                });
                const urlStore = {
                    baseUrl: 'https://pusher.com',
                    urls: {
                        authenticationEndpoint: {
                            path: '/docs/channels/server_api/authenticating_users'
                        },
                        authorizationEndpoint: {
                            path: '/docs/channels/server_api/authorizing-users/'
                        },
                        javascriptQuickStart: {
                            path: '/docs/javascript_quick_start'
                        },
                        triggeringClientEvents: {
                            path: '/docs/client_api_guide/client_events#trigger-events'
                        },
                        encryptedChannelSupport: {
                            fullUrl: 'https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support'
                        }
                    }
                };
                const buildLogSuffix = function(key) {
                    const urlPrefix = 'See:';
                    const urlObj = urlStore.urls[key];
                    if (!urlObj) return '';
                    let url;
                    if (urlObj.fullUrl) url = urlObj.fullUrl;
                    else if (urlObj.path) url = urlStore.baseUrl + urlObj.path;
                    if (!url) return '';
                    return `${urlPrefix} ${url}`;
                };
                /* harmony default export */ const url_store = {
                    buildLogSuffix: buildLogSuffix
                };
                var AuthRequestType;
                (function(AuthRequestType) {
                    AuthRequestType["UserAuthentication"] = "user-authentication";
                    AuthRequestType["ChannelAuthorization"] = "channel-authorization";
                })(AuthRequestType || (AuthRequestType = {}));
                class BadEventName extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class BadChannelName extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class RequestTimedOut extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class TransportPriorityTooLow extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class TransportClosed extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class UnsupportedFeature extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class UnsupportedTransport extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class UnsupportedStrategy extends Error {
                    constructor(msg){
                        super(msg);
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                class HTTPAuthError extends Error {
                    constructor(status, msg){
                        super(msg);
                        this.status = status;
                        Object.setPrototypeOf(this, new.target.prototype);
                    }
                }
                const ajax = function(context, query, authOptions, authRequestType, callback) {
                    const xhr = runtime.createXHR();
                    xhr.open('POST', authOptions.endpoint, true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    for(var headerName in authOptions.headers)xhr.setRequestHeader(headerName, authOptions.headers[headerName]);
                    if (authOptions.headersProvider != null) {
                        let dynamicHeaders = authOptions.headersProvider();
                        for(var headerName in dynamicHeaders)xhr.setRequestHeader(headerName, dynamicHeaders[headerName]);
                    }
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                let data;
                                let parsed = false;
                                try {
                                    data = JSON.parse(xhr.responseText);
                                    parsed = true;
                                } catch (e) {
                                    callback(new HTTPAuthError(200, `JSON returned from ${authRequestType.toString()} endpoint was invalid, yet status code was 200. Data was: ${xhr.responseText}`), null);
                                }
                                if (parsed) callback(null, data);
                            } else {
                                let suffix = '';
                                switch(authRequestType){
                                    case AuthRequestType.UserAuthentication:
                                        suffix = url_store.buildLogSuffix('authenticationEndpoint');
                                        break;
                                    case AuthRequestType.ChannelAuthorization:
                                        suffix = `Clients must be authorized to join private or presence channels. ${url_store.buildLogSuffix('authorizationEndpoint')}`;
                                        break;
                                }
                                callback(new HTTPAuthError(xhr.status, `Unable to retrieve auth string from ${authRequestType.toString()} endpoint - ` + `received status: ${xhr.status} from ${authOptions.endpoint}. ${suffix}`), null);
                            }
                        }
                    };
                    xhr.send(query);
                    return xhr;
                };
                /* harmony default export */ const xhr_auth = ajax;
                function encode(s) {
                    return btoa(utob(s));
                }
                var fromCharCode = String.fromCharCode;
                var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var b64tab = {};
                for(var i = 0, l = b64chars.length; i < l; i++)b64tab[b64chars.charAt(i)] = i;
                var cb_utob = function(c) {
                    var cc = c.charCodeAt(0);
                    return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
                };
                var utob = function(u) {
                    return u.replace(/[^\x00-\x7F]/g, cb_utob);
                };
                var cb_encode = function(ccc) {
                    var padlen = [
                        0,
                        2,
                        1
                    ][ccc.length % 3];
                    var ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
                    var chars = [
                        b64chars.charAt(ord >>> 18),
                        b64chars.charAt(ord >>> 12 & 63),
                        padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63),
                        padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
                    ];
                    return chars.join('');
                };
                var btoa = window.btoa || function(b) {
                    return b.replace(/[\s\S]{1,3}/g, cb_encode);
                };
                class Timer {
                    constructor(set, clear, delay, callback){
                        this.clear = clear;
                        this.timer = set(()=>{
                            if (this.timer) this.timer = callback(this.timer);
                        }, delay);
                    }
                    isRunning() {
                        return this.timer !== null;
                    }
                    ensureAborted() {
                        if (this.timer) {
                            this.clear(this.timer);
                            this.timer = null;
                        }
                    }
                }
                /* harmony default export */ const abstract_timer = Timer;
                function timers_clearTimeout(timer) {
                    window.clearTimeout(timer);
                }
                function timers_clearInterval(timer) {
                    window.clearInterval(timer);
                }
                class OneOffTimer extends abstract_timer {
                    constructor(delay, callback){
                        super(setTimeout, timers_clearTimeout, delay, function(timer) {
                            callback();
                            return null;
                        });
                    }
                }
                class PeriodicTimer extends abstract_timer {
                    constructor(delay, callback){
                        super(setInterval, timers_clearInterval, delay, function(timer) {
                            callback();
                            return timer;
                        });
                    }
                }
                var Util = {
                    now () {
                        if (Date.now) return Date.now();
                        else return new Date().valueOf();
                    },
                    defer (callback) {
                        return new OneOffTimer(0, callback);
                    },
                    method (name, ...args) {
                        var boundArguments = Array.prototype.slice.call(arguments, 1);
                        return function(object) {
                            return object[name].apply(object, boundArguments.concat(arguments));
                        };
                    }
                };
                /* harmony default export */ const util = Util;
                function extend(target, ...sources) {
                    for(var i = 0; i < sources.length; i++){
                        var extensions = sources[i];
                        for(var property in extensions)if (extensions[property] && extensions[property].constructor && extensions[property].constructor === Object) target[property] = extend(target[property] || {}, extensions[property]);
                        else target[property] = extensions[property];
                    }
                    return target;
                }
                function stringify() {
                    var m = [
                        'Pusher'
                    ];
                    for(var i = 0; i < arguments.length; i++)if (typeof arguments[i] === 'string') m.push(arguments[i]);
                    else m.push(safeJSONStringify(arguments[i]));
                    return m.join(' : ');
                }
                function arrayIndexOf(array, item) {
                    var nativeIndexOf = Array.prototype.indexOf;
                    if (array === null) return -1;
                    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item);
                    for(var i = 0, l = array.length; i < l; i++){
                        if (array[i] === item) return i;
                    }
                    return -1;
                }
                function objectApply(object, f) {
                    for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) f(object[key], key, object);
                }
                function keys(object) {
                    var keys = [];
                    objectApply(object, function(_, key) {
                        keys.push(key);
                    });
                    return keys;
                }
                function values(object) {
                    var values = [];
                    objectApply(object, function(value) {
                        values.push(value);
                    });
                    return values;
                }
                function apply(array, f, context) {
                    for(var i = 0; i < array.length; i++)f.call(context || window, array[i], i, array);
                }
                function map(array, f) {
                    var result = [];
                    for(var i = 0; i < array.length; i++)result.push(f(array[i], i, array, result));
                    return result;
                }
                function mapObject(object, f) {
                    var result = {};
                    objectApply(object, function(value, key) {
                        result[key] = f(value);
                    });
                    return result;
                }
                function filter(array, test) {
                    test = test || function(value) {
                        return !!value;
                    };
                    var result = [];
                    for(var i = 0; i < array.length; i++)if (test(array[i], i, array, result)) result.push(array[i]);
                    return result;
                }
                function filterObject(object, test) {
                    var result = {};
                    objectApply(object, function(value, key) {
                        if (test && test(value, key, object, result) || Boolean(value)) result[key] = value;
                    });
                    return result;
                }
                function flatten(object) {
                    var result = [];
                    objectApply(object, function(value, key) {
                        result.push([
                            key,
                            value
                        ]);
                    });
                    return result;
                }
                function any(array, test) {
                    for(var i = 0; i < array.length; i++){
                        if (test(array[i], i, array)) return true;
                    }
                    return false;
                }
                function collections_all(array, test) {
                    for(var i = 0; i < array.length; i++){
                        if (!test(array[i], i, array)) return false;
                    }
                    return true;
                }
                function encodeParamsObject(data) {
                    return mapObject(data, function(value) {
                        if (typeof value === 'object') value = safeJSONStringify(value);
                        return encodeURIComponent(encode(value.toString()));
                    });
                }
                function buildQueryString(data) {
                    var params = filterObject(data, function(value) {
                        return value !== undefined;
                    });
                    var query = map(flatten(encodeParamsObject(params)), util.method('join', '=')).join('&');
                    return query;
                }
                function decycleObject(object) {
                    var objects = [], paths = [];
                    return function derez(value, path) {
                        var i, name, nu;
                        switch(typeof value){
                            case 'object':
                                if (!value) return null;
                                for(i = 0; i < objects.length; i += 1){
                                    if (objects[i] === value) return {
                                        $ref: paths[i]
                                    };
                                }
                                objects.push(value);
                                paths.push(path);
                                if (Object.prototype.toString.apply(value) === '[object Array]') {
                                    nu = [];
                                    for(i = 0; i < value.length; i += 1)nu[i] = derez(value[i], path + '[' + i + ']');
                                } else {
                                    nu = {};
                                    for(name in value)if (Object.prototype.hasOwnProperty.call(value, name)) nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']');
                                }
                                return nu;
                            case 'number':
                            case 'string':
                            case 'boolean':
                                return value;
                        }
                    }(object, '$');
                }
                function safeJSONStringify(source) {
                    try {
                        return JSON.stringify(source);
                    } catch (e) {
                        return JSON.stringify(decycleObject(source));
                    }
                }
                class Logger {
                    constructor(){
                        this.globalLog = (message)=>{
                            if (window.console && window.console.log) window.console.log(message);
                        };
                    }
                    debug(...args) {
                        this.log(this.globalLog, args);
                    }
                    warn(...args) {
                        this.log(this.globalLogWarn, args);
                    }
                    error(...args) {
                        this.log(this.globalLogError, args);
                    }
                    globalLogWarn(message) {
                        if (window.console && window.console.warn) window.console.warn(message);
                        else this.globalLog(message);
                    }
                    globalLogError(message) {
                        if (window.console && window.console.error) window.console.error(message);
                        else this.globalLogWarn(message);
                    }
                    log(defaultLoggingFunction, ...args) {
                        var message = stringify.apply(this, arguments);
                        if (pusher.log) pusher.log(message);
                        else if (pusher.logToConsole) {
                            const log = defaultLoggingFunction.bind(this);
                            log(message);
                        }
                    }
                }
                /* harmony default export */ const logger = new Logger();
                var jsonp = function(context, query, authOptions, authRequestType, callback) {
                    if (authOptions.headers !== undefined || authOptions.headersProvider != null) logger.warn(`To send headers with the ${authRequestType.toString()} request, you must use AJAX, rather than JSONP.`);
                    var callbackName = context.nextAuthCallbackID.toString();
                    context.nextAuthCallbackID++;
                    var document1 = context.getDocument();
                    var script = document1.createElement('script');
                    context.auth_callbacks[callbackName] = function(data) {
                        callback(null, data);
                    };
                    var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
                    script.src = authOptions.endpoint + '?callback=' + encodeURIComponent(callback_name) + '&' + query;
                    var head = document1.getElementsByTagName('head')[0] || document1.documentElement;
                    head.insertBefore(script, head.firstChild);
                };
                /* harmony default export */ const jsonp_auth = jsonp;
                class ScriptRequest {
                    constructor(src){
                        this.src = src;
                    }
                    send(receiver) {
                        var self1 = this;
                        var errorString = 'Error loading ' + self1.src;
                        self1.script = document.createElement('script');
                        self1.script.id = receiver.id;
                        self1.script.src = self1.src;
                        self1.script.type = 'text/javascript';
                        self1.script.charset = 'UTF-8';
                        if (self1.script.addEventListener) {
                            self1.script.onerror = function() {
                                receiver.callback(errorString);
                            };
                            self1.script.onload = function() {
                                receiver.callback(null);
                            };
                        } else self1.script.onreadystatechange = function() {
                            if (self1.script.readyState === 'loaded' || self1.script.readyState === 'complete') receiver.callback(null);
                        };
                        if (self1.script.async === undefined && document.attachEvent && /opera/i.test(navigator.userAgent)) {
                            self1.errorScript = document.createElement('script');
                            self1.errorScript.id = receiver.id + '_error';
                            self1.errorScript.text = receiver.name + "('" + errorString + "');";
                            self1.script.async = self1.errorScript.async = false;
                        } else self1.script.async = true;
                        var head = document.getElementsByTagName('head')[0];
                        head.insertBefore(self1.script, head.firstChild);
                        if (self1.errorScript) head.insertBefore(self1.errorScript, self1.script.nextSibling);
                    }
                    cleanup() {
                        if (this.script) {
                            this.script.onload = this.script.onerror = null;
                            this.script.onreadystatechange = null;
                        }
                        if (this.script && this.script.parentNode) this.script.parentNode.removeChild(this.script);
                        if (this.errorScript && this.errorScript.parentNode) this.errorScript.parentNode.removeChild(this.errorScript);
                        this.script = null;
                        this.errorScript = null;
                    }
                }
                class JSONPRequest {
                    constructor(url, data){
                        this.url = url;
                        this.data = data;
                    }
                    send(receiver) {
                        if (this.request) return;
                        var query = buildQueryString(this.data);
                        var url = this.url + '/' + receiver.number + '?' + query;
                        this.request = runtime.createScriptRequest(url);
                        this.request.send(receiver);
                    }
                    cleanup() {
                        if (this.request) this.request.cleanup();
                    }
                }
                var getAgent = function(sender, useTLS) {
                    return function(data, callback) {
                        var scheme = 'http' + (useTLS ? 's' : '') + '://';
                        var url = scheme + (sender.host || sender.options.host) + sender.options.path;
                        var request = runtime.createJSONPRequest(url, data);
                        var receiver = runtime.ScriptReceivers.create(function(error, result) {
                            ScriptReceivers.remove(receiver);
                            request.cleanup();
                            if (result && result.host) sender.host = result.host;
                            if (callback) callback(error, result);
                        });
                        request.send(receiver);
                    };
                };
                var jsonp_timeline_jsonp = {
                    name: 'jsonp',
                    getAgent: getAgent
                };
                /* harmony default export */ const jsonp_timeline = jsonp_timeline_jsonp;
                function getGenericURL(baseScheme, params, path) {
                    var scheme = baseScheme + (params.useTLS ? 's' : '');
                    var host = params.useTLS ? params.hostTLS : params.hostNonTLS;
                    return scheme + '://' + host + path;
                }
                function getGenericPath(key, queryString) {
                    var path = '/app/' + key;
                    var query = '?protocol=' + defaults.PROTOCOL + '&client=js' + '&version=' + defaults.VERSION + (queryString ? '&' + queryString : '');
                    return path + query;
                }
                var ws = {
                    getInitial: function(key, params) {
                        var path = (params.httpPath || '') + getGenericPath(key, 'flash=false');
                        return getGenericURL('ws', params, path);
                    }
                };
                var http = {
                    getInitial: function(key, params) {
                        var path = (params.httpPath || '/pusher') + getGenericPath(key);
                        return getGenericURL('http', params, path);
                    }
                };
                var sockjs = {
                    getInitial: function(key, params) {
                        return getGenericURL('http', params, params.httpPath || '/pusher');
                    },
                    getPath: function(key, params) {
                        return getGenericPath(key);
                    }
                };
                class CallbackRegistry {
                    constructor(){
                        this._callbacks = {};
                    }
                    get(name) {
                        return this._callbacks[prefix(name)];
                    }
                    add(name, callback, context) {
                        var prefixedEventName = prefix(name);
                        this._callbacks[prefixedEventName] = this._callbacks[prefixedEventName] || [];
                        this._callbacks[prefixedEventName].push({
                            fn: callback,
                            context: context
                        });
                    }
                    remove(name, callback, context) {
                        if (!name && !callback && !context) {
                            this._callbacks = {};
                            return;
                        }
                        var names = name ? [
                            prefix(name)
                        ] : keys(this._callbacks);
                        if (callback || context) this.removeCallback(names, callback, context);
                        else this.removeAllCallbacks(names);
                    }
                    removeCallback(names, callback, context) {
                        apply(names, function(name) {
                            this._callbacks[name] = filter(this._callbacks[name] || [], function(binding) {
                                return callback && callback !== binding.fn || context && context !== binding.context;
                            });
                            if (this._callbacks[name].length === 0) delete this._callbacks[name];
                        }, this);
                    }
                    removeAllCallbacks(names) {
                        apply(names, function(name) {
                            delete this._callbacks[name];
                        }, this);
                    }
                }
                function prefix(name) {
                    return '_' + name;
                }
                class Dispatcher {
                    constructor(failThrough){
                        this.callbacks = new CallbackRegistry();
                        this.global_callbacks = [];
                        this.failThrough = failThrough;
                    }
                    bind(eventName, callback, context) {
                        this.callbacks.add(eventName, callback, context);
                        return this;
                    }
                    bind_global(callback) {
                        this.global_callbacks.push(callback);
                        return this;
                    }
                    unbind(eventName, callback, context) {
                        this.callbacks.remove(eventName, callback, context);
                        return this;
                    }
                    unbind_global(callback) {
                        if (!callback) {
                            this.global_callbacks = [];
                            return this;
                        }
                        this.global_callbacks = filter(this.global_callbacks || [], (c)=>c !== callback);
                        return this;
                    }
                    unbind_all() {
                        this.unbind();
                        this.unbind_global();
                        return this;
                    }
                    emit(eventName, data, metadata) {
                        for(var i = 0; i < this.global_callbacks.length; i++)this.global_callbacks[i](eventName, data);
                        var callbacks = this.callbacks.get(eventName);
                        var args = [];
                        if (metadata) args.push(data, metadata);
                        else if (data) args.push(data);
                        if (callbacks && callbacks.length > 0) for(var i = 0; i < callbacks.length; i++)callbacks[i].fn.apply(callbacks[i].context || window, args);
                        else if (this.failThrough) this.failThrough(eventName, data);
                        return this;
                    }
                }
                class TransportConnection extends Dispatcher {
                    constructor(hooks, name, priority, key, options){
                        super();
                        this.initialize = runtime.transportConnectionInitializer;
                        this.hooks = hooks;
                        this.name = name;
                        this.priority = priority;
                        this.key = key;
                        this.options = options;
                        this.state = 'new';
                        this.timeline = options.timeline;
                        this.activityTimeout = options.activityTimeout;
                        this.id = this.timeline.generateUniqueID();
                    }
                    handlesActivityChecks() {
                        return Boolean(this.hooks.handlesActivityChecks);
                    }
                    supportsPing() {
                        return Boolean(this.hooks.supportsPing);
                    }
                    connect() {
                        if (this.socket || this.state !== 'initialized') return false;
                        var url = this.hooks.urls.getInitial(this.key, this.options);
                        try {
                            this.socket = this.hooks.getSocket(url, this.options);
                        } catch (e) {
                            util.defer(()=>{
                                this.onError(e);
                                this.changeState('closed');
                            });
                            return false;
                        }
                        this.bindListeners();
                        logger.debug('Connecting', {
                            transport: this.name,
                            url: url
                        });
                        this.changeState('connecting');
                        return true;
                    }
                    close() {
                        if (this.socket) {
                            this.socket.close();
                            return true;
                        } else return false;
                    }
                    send(data) {
                        if (this.state === 'open') {
                            util.defer(()=>{
                                if (this.socket) this.socket.send(data);
                            });
                            return true;
                        } else return false;
                    }
                    ping() {
                        if (this.state === 'open' && this.supportsPing()) this.socket.ping();
                    }
                    onOpen() {
                        if (this.hooks.beforeOpen) this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
                        this.changeState('open');
                        this.socket.onopen = undefined;
                    }
                    onError(error) {
                        this.emit('error', {
                            type: 'WebSocketError',
                            error: error
                        });
                        this.timeline.error(this.buildTimelineMessage({
                            error: error.toString()
                        }));
                    }
                    onClose(closeEvent) {
                        if (closeEvent) this.changeState('closed', {
                            code: closeEvent.code,
                            reason: closeEvent.reason,
                            wasClean: closeEvent.wasClean
                        });
                        else this.changeState('closed');
                        this.unbindListeners();
                        this.socket = undefined;
                    }
                    onMessage(message) {
                        this.emit('message', message);
                    }
                    onActivity() {
                        this.emit('activity');
                    }
                    bindListeners() {
                        this.socket.onopen = ()=>{
                            this.onOpen();
                        };
                        this.socket.onerror = (error)=>{
                            this.onError(error);
                        };
                        this.socket.onclose = (closeEvent)=>{
                            this.onClose(closeEvent);
                        };
                        this.socket.onmessage = (message)=>{
                            this.onMessage(message);
                        };
                        if (this.supportsPing()) this.socket.onactivity = ()=>{
                            this.onActivity();
                        };
                    }
                    unbindListeners() {
                        if (this.socket) {
                            this.socket.onopen = undefined;
                            this.socket.onerror = undefined;
                            this.socket.onclose = undefined;
                            this.socket.onmessage = undefined;
                            if (this.supportsPing()) this.socket.onactivity = undefined;
                        }
                    }
                    changeState(state, params) {
                        this.state = state;
                        this.timeline.info(this.buildTimelineMessage({
                            state: state,
                            params: params
                        }));
                        this.emit(state, params);
                    }
                    buildTimelineMessage(message) {
                        return extend({
                            cid: this.id
                        }, message);
                    }
                }
                class Transport {
                    constructor(hooks){
                        this.hooks = hooks;
                    }
                    isSupported(environment) {
                        return this.hooks.isSupported(environment);
                    }
                    createConnection(name, priority, key, options) {
                        return new TransportConnection(this.hooks, name, priority, key, options);
                    }
                }
                var WSTransport = new Transport({
                    urls: ws,
                    handlesActivityChecks: false,
                    supportsPing: false,
                    isInitialized: function() {
                        return Boolean(runtime.getWebSocketAPI());
                    },
                    isSupported: function() {
                        return Boolean(runtime.getWebSocketAPI());
                    },
                    getSocket: function(url) {
                        return runtime.createWebSocket(url);
                    }
                });
                var httpConfiguration = {
                    urls: http,
                    handlesActivityChecks: false,
                    supportsPing: true,
                    isInitialized: function() {
                        return true;
                    }
                };
                var streamingConfiguration = extend({
                    getSocket: function(url) {
                        return runtime.HTTPFactory.createStreamingSocket(url);
                    }
                }, httpConfiguration);
                var pollingConfiguration = extend({
                    getSocket: function(url) {
                        return runtime.HTTPFactory.createPollingSocket(url);
                    }
                }, httpConfiguration);
                var xhrConfiguration = {
                    isSupported: function() {
                        return runtime.isXHRSupported();
                    }
                };
                var XHRStreamingTransport = new Transport(extend({}, streamingConfiguration, xhrConfiguration));
                var XHRPollingTransport = new Transport(extend({}, pollingConfiguration, xhrConfiguration));
                var Transports = {
                    ws: WSTransport,
                    xhr_streaming: XHRStreamingTransport,
                    xhr_polling: XHRPollingTransport
                };
                /* harmony default export */ const transports = Transports;
                var SockJSTransport = new Transport({
                    file: 'sockjs',
                    urls: sockjs,
                    handlesActivityChecks: true,
                    supportsPing: false,
                    isSupported: function() {
                        return true;
                    },
                    isInitialized: function() {
                        return window.SockJS !== undefined;
                    },
                    getSocket: function(url, options) {
                        return new window.SockJS(url, null, {
                            js_path: Dependencies.getPath('sockjs', {
                                useTLS: options.useTLS
                            }),
                            ignore_null_origin: options.ignoreNullOrigin
                        });
                    },
                    beforeOpen: function(socket, path) {
                        socket.send(JSON.stringify({
                            path: path
                        }));
                    }
                });
                var xdrConfiguration = {
                    isSupported: function(environment) {
                        var yes = runtime.isXDRSupported(environment.useTLS);
                        return yes;
                    }
                };
                var XDRStreamingTransport = new Transport(extend({}, streamingConfiguration, xdrConfiguration));
                var XDRPollingTransport = new Transport(extend({}, pollingConfiguration, xdrConfiguration));
                transports.xdr_streaming = XDRStreamingTransport;
                transports.xdr_polling = XDRPollingTransport;
                transports.sockjs = SockJSTransport;
                /* harmony default export */ const transports_transports = transports;
                class NetInfo extends Dispatcher {
                    constructor(){
                        super();
                        var self1 = this;
                        if (window.addEventListener !== undefined) {
                            window.addEventListener('online', function() {
                                self1.emit('online');
                            }, false);
                            window.addEventListener('offline', function() {
                                self1.emit('offline');
                            }, false);
                        }
                    }
                    isOnline() {
                        if (window.navigator.onLine === undefined) return true;
                        else return window.navigator.onLine;
                    }
                }
                var Network = new NetInfo();
                class AssistantToTheTransportManager {
                    constructor(manager, transport, options){
                        this.manager = manager;
                        this.transport = transport;
                        this.minPingDelay = options.minPingDelay;
                        this.maxPingDelay = options.maxPingDelay;
                        this.pingDelay = undefined;
                    }
                    createConnection(name, priority, key, options) {
                        options = extend({}, options, {
                            activityTimeout: this.pingDelay
                        });
                        var connection = this.transport.createConnection(name, priority, key, options);
                        var openTimestamp = null;
                        var onOpen = function() {
                            connection.unbind('open', onOpen);
                            connection.bind('closed', onClosed);
                            openTimestamp = util.now();
                        };
                        var onClosed = (closeEvent)=>{
                            connection.unbind('closed', onClosed);
                            if (closeEvent.code === 1002 || closeEvent.code === 1003) this.manager.reportDeath();
                            else if (!closeEvent.wasClean && openTimestamp) {
                                var lifespan = util.now() - openTimestamp;
                                if (lifespan < 2 * this.maxPingDelay) {
                                    this.manager.reportDeath();
                                    this.pingDelay = Math.max(lifespan / 2, this.minPingDelay);
                                }
                            }
                        };
                        connection.bind('open', onOpen);
                        return connection;
                    }
                    isSupported(environment) {
                        return this.manager.isAlive() && this.transport.isSupported(environment);
                    }
                }
                const Protocol = {
                    decodeMessage: function(messageEvent) {
                        try {
                            var messageData = JSON.parse(messageEvent.data);
                            var pusherEventData = messageData.data;
                            if (typeof pusherEventData === 'string') try {
                                pusherEventData = JSON.parse(messageData.data);
                            } catch (e) {}
                            var pusherEvent = {
                                event: messageData.event,
                                channel: messageData.channel,
                                data: pusherEventData
                            };
                            if (messageData.user_id) pusherEvent.user_id = messageData.user_id;
                            return pusherEvent;
                        } catch (e) {
                            throw {
                                type: 'MessageParseError',
                                error: e,
                                data: messageEvent.data
                            };
                        }
                    },
                    encodeMessage: function(event) {
                        return JSON.stringify(event);
                    },
                    processHandshake: function(messageEvent) {
                        var message = Protocol.decodeMessage(messageEvent);
                        if (message.event === 'pusher:connection_established') {
                            if (!message.data.activity_timeout) throw 'No activity timeout specified in handshake';
                            return {
                                action: 'connected',
                                id: message.data.socket_id,
                                activityTimeout: message.data.activity_timeout * 1000
                            };
                        } else if (message.event === 'pusher:error') return {
                            action: this.getCloseAction(message.data),
                            error: this.getCloseError(message.data)
                        };
                        else throw 'Invalid handshake';
                    },
                    getCloseAction: function(closeEvent) {
                        if (closeEvent.code < 4000) {
                            if (closeEvent.code >= 1002 && closeEvent.code <= 1004) return 'backoff';
                            else return null;
                        } else if (closeEvent.code === 4000) return 'tls_only';
                        else if (closeEvent.code < 4100) return 'refused';
                        else if (closeEvent.code < 4200) return 'backoff';
                        else if (closeEvent.code < 4300) return 'retry';
                        else return 'refused';
                    },
                    getCloseError: function(closeEvent) {
                        if (closeEvent.code !== 1000 && closeEvent.code !== 1001) return {
                            type: 'PusherError',
                            data: {
                                code: closeEvent.code,
                                message: closeEvent.reason || closeEvent.message
                            }
                        };
                        else return null;
                    }
                };
                /* harmony default export */ const protocol = Protocol;
                class Connection extends Dispatcher {
                    constructor(id, transport){
                        super();
                        this.id = id;
                        this.transport = transport;
                        this.activityTimeout = transport.activityTimeout;
                        this.bindListeners();
                    }
                    handlesActivityChecks() {
                        return this.transport.handlesActivityChecks();
                    }
                    send(data) {
                        return this.transport.send(data);
                    }
                    send_event(name, data, channel) {
                        var event = {
                            event: name,
                            data: data
                        };
                        if (channel) event.channel = channel;
                        logger.debug('Event sent', event);
                        return this.send(protocol.encodeMessage(event));
                    }
                    ping() {
                        if (this.transport.supportsPing()) this.transport.ping();
                        else this.send_event('pusher:ping', {});
                    }
                    close() {
                        this.transport.close();
                    }
                    bindListeners() {
                        var listeners = {
                            message: (messageEvent)=>{
                                var pusherEvent;
                                try {
                                    pusherEvent = protocol.decodeMessage(messageEvent);
                                } catch (e) {
                                    this.emit('error', {
                                        type: 'MessageParseError',
                                        error: e,
                                        data: messageEvent.data
                                    });
                                }
                                if (pusherEvent !== undefined) {
                                    logger.debug('Event recd', pusherEvent);
                                    switch(pusherEvent.event){
                                        case 'pusher:error':
                                            this.emit('error', {
                                                type: 'PusherError',
                                                data: pusherEvent.data
                                            });
                                            break;
                                        case 'pusher:ping':
                                            this.emit('ping');
                                            break;
                                        case 'pusher:pong':
                                            this.emit('pong');
                                            break;
                                    }
                                    this.emit('message', pusherEvent);
                                }
                            },
                            activity: ()=>{
                                this.emit('activity');
                            },
                            error: (error)=>{
                                this.emit('error', error);
                            },
                            closed: (closeEvent)=>{
                                unbindListeners();
                                if (closeEvent && closeEvent.code) this.handleCloseEvent(closeEvent);
                                this.transport = null;
                                this.emit('closed');
                            }
                        };
                        var unbindListeners = ()=>{
                            objectApply(listeners, (listener, event)=>{
                                this.transport.unbind(event, listener);
                            });
                        };
                        objectApply(listeners, (listener, event)=>{
                            this.transport.bind(event, listener);
                        });
                    }
                    handleCloseEvent(closeEvent) {
                        var action = protocol.getCloseAction(closeEvent);
                        var error = protocol.getCloseError(closeEvent);
                        if (error) this.emit('error', error);
                        if (action) this.emit(action, {
                            action: action,
                            error: error
                        });
                    }
                }
                class Handshake {
                    constructor(transport, callback){
                        this.transport = transport;
                        this.callback = callback;
                        this.bindListeners();
                    }
                    close() {
                        this.unbindListeners();
                        this.transport.close();
                    }
                    bindListeners() {
                        this.onMessage = (m)=>{
                            this.unbindListeners();
                            var result;
                            try {
                                result = protocol.processHandshake(m);
                            } catch (e) {
                                this.finish('error', {
                                    error: e
                                });
                                this.transport.close();
                                return;
                            }
                            if (result.action === 'connected') this.finish('connected', {
                                connection: new Connection(result.id, this.transport),
                                activityTimeout: result.activityTimeout
                            });
                            else {
                                this.finish(result.action, {
                                    error: result.error
                                });
                                this.transport.close();
                            }
                        };
                        this.onClosed = (closeEvent)=>{
                            this.unbindListeners();
                            var action = protocol.getCloseAction(closeEvent) || 'backoff';
                            var error = protocol.getCloseError(closeEvent);
                            this.finish(action, {
                                error: error
                            });
                        };
                        this.transport.bind('message', this.onMessage);
                        this.transport.bind('closed', this.onClosed);
                    }
                    unbindListeners() {
                        this.transport.unbind('message', this.onMessage);
                        this.transport.unbind('closed', this.onClosed);
                    }
                    finish(action, params) {
                        this.callback(extend({
                            transport: this.transport,
                            action: action
                        }, params));
                    }
                }
                class TimelineSender {
                    constructor(timeline, options){
                        this.timeline = timeline;
                        this.options = options || {};
                    }
                    send(useTLS, callback) {
                        if (this.timeline.isEmpty()) return;
                        this.timeline.send(runtime.TimelineTransport.getAgent(this, useTLS), callback);
                    }
                }
                class Channel extends Dispatcher {
                    constructor(name, pusher){
                        super(function(event, data) {
                            logger.debug('No callbacks on ' + name + ' for ' + event);
                        });
                        this.name = name;
                        this.pusher = pusher;
                        this.subscribed = false;
                        this.subscriptionPending = false;
                        this.subscriptionCancelled = false;
                    }
                    authorize(socketId, callback) {
                        return callback(null, {
                            auth: ''
                        });
                    }
                    trigger(event, data) {
                        if (event.indexOf('client-') !== 0) throw new BadEventName("Event '" + event + "' does not start with 'client-'");
                        if (!this.subscribed) {
                            var suffix = url_store.buildLogSuffix('triggeringClientEvents');
                            logger.warn(`Client event triggered before channel 'subscription_succeeded' event . ${suffix}`);
                        }
                        return this.pusher.send_event(event, data, this.name);
                    }
                    disconnect() {
                        this.subscribed = false;
                        this.subscriptionPending = false;
                    }
                    handleEvent(event) {
                        var eventName = event.event;
                        var data = event.data;
                        if (eventName === 'pusher_internal:subscription_succeeded') this.handleSubscriptionSucceededEvent(event);
                        else if (eventName === 'pusher_internal:subscription_count') this.handleSubscriptionCountEvent(event);
                        else if (eventName.indexOf('pusher_internal:') !== 0) {
                            var metadata = {};
                            this.emit(eventName, data, metadata);
                        }
                    }
                    handleSubscriptionSucceededEvent(event) {
                        this.subscriptionPending = false;
                        this.subscribed = true;
                        if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                        else this.emit('pusher:subscription_succeeded', event.data);
                    }
                    handleSubscriptionCountEvent(event) {
                        if (event.data.subscription_count) this.subscriptionCount = event.data.subscription_count;
                        this.emit('pusher:subscription_count', event.data);
                    }
                    subscribe() {
                        if (this.subscribed) return;
                        this.subscriptionPending = true;
                        this.subscriptionCancelled = false;
                        this.authorize(this.pusher.connection.socket_id, (error, data)=>{
                            if (error) {
                                this.subscriptionPending = false;
                                logger.error(error.toString());
                                this.emit('pusher:subscription_error', Object.assign({}, {
                                    type: 'AuthError',
                                    error: error.message
                                }, error instanceof HTTPAuthError ? {
                                    status: error.status
                                } : {}));
                            } else this.pusher.send_event('pusher:subscribe', {
                                auth: data.auth,
                                channel_data: data.channel_data,
                                channel: this.name
                            });
                        });
                    }
                    unsubscribe() {
                        this.subscribed = false;
                        this.pusher.send_event('pusher:unsubscribe', {
                            channel: this.name
                        });
                    }
                    cancelSubscription() {
                        this.subscriptionCancelled = true;
                    }
                    reinstateSubscription() {
                        this.subscriptionCancelled = false;
                    }
                }
                class PrivateChannel extends Channel {
                    authorize(socketId, callback) {
                        return this.pusher.config.channelAuthorizer({
                            channelName: this.name,
                            socketId: socketId
                        }, callback);
                    }
                }
                class Members {
                    constructor(){
                        this.reset();
                    }
                    get(id) {
                        if (Object.prototype.hasOwnProperty.call(this.members, id)) return {
                            id: id,
                            info: this.members[id]
                        };
                        else return null;
                    }
                    each(callback) {
                        objectApply(this.members, (member, id)=>{
                            callback(this.get(id));
                        });
                    }
                    setMyID(id) {
                        this.myID = id;
                    }
                    onSubscription(subscriptionData) {
                        this.members = subscriptionData.presence.hash;
                        this.count = subscriptionData.presence.count;
                        this.me = this.get(this.myID);
                    }
                    addMember(memberData) {
                        if (this.get(memberData.user_id) === null) this.count++;
                        this.members[memberData.user_id] = memberData.user_info;
                        return this.get(memberData.user_id);
                    }
                    removeMember(memberData) {
                        var member = this.get(memberData.user_id);
                        if (member) {
                            delete this.members[memberData.user_id];
                            this.count--;
                        }
                        return member;
                    }
                    reset() {
                        this.members = {};
                        this.count = 0;
                        this.myID = null;
                        this.me = null;
                    }
                }
                var __awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class PresenceChannel extends PrivateChannel {
                    constructor(name, pusher){
                        super(name, pusher);
                        this.members = new Members();
                    }
                    authorize(socketId, callback) {
                        super.authorize(socketId, (error, authData)=>__awaiter(this, void 0, void 0, function*() {
                                if (!error) {
                                    authData;
                                    if (authData.channel_data != null) {
                                        var channelData = JSON.parse(authData.channel_data);
                                        this.members.setMyID(channelData.user_id);
                                    } else {
                                        yield this.pusher.user.signinDonePromise;
                                        if (this.pusher.user.user_data != null) this.members.setMyID(this.pusher.user.user_data.id);
                                        else {
                                            let suffix = url_store.buildLogSuffix('authorizationEndpoint');
                                            logger.error(`Invalid auth response for channel '${this.name}', ` + `expected 'channel_data' field. ${suffix}, ` + `or the user should be signed in.`);
                                            callback('Invalid auth response');
                                            return;
                                        }
                                    }
                                }
                                callback(error, authData);
                            }));
                    }
                    handleEvent(event) {
                        var eventName = event.event;
                        if (eventName.indexOf('pusher_internal:') === 0) this.handleInternalEvent(event);
                        else {
                            var data = event.data;
                            var metadata = {};
                            if (event.user_id) metadata.user_id = event.user_id;
                            this.emit(eventName, data, metadata);
                        }
                    }
                    handleInternalEvent(event) {
                        var eventName = event.event;
                        var data = event.data;
                        switch(eventName){
                            case 'pusher_internal:subscription_succeeded':
                                this.handleSubscriptionSucceededEvent(event);
                                break;
                            case 'pusher_internal:subscription_count':
                                this.handleSubscriptionCountEvent(event);
                                break;
                            case 'pusher_internal:member_added':
                                var addedMember = this.members.addMember(data);
                                this.emit('pusher:member_added', addedMember);
                                break;
                            case 'pusher_internal:member_removed':
                                var removedMember = this.members.removeMember(data);
                                if (removedMember) this.emit('pusher:member_removed', removedMember);
                                break;
                        }
                    }
                    handleSubscriptionSucceededEvent(event) {
                        this.subscriptionPending = false;
                        this.subscribed = true;
                        if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                        else {
                            this.members.onSubscription(event.data);
                            this.emit('pusher:subscription_succeeded', this.members);
                        }
                    }
                    disconnect() {
                        this.members.reset();
                        super.disconnect();
                    }
                }
                // EXTERNAL MODULE: ./node_modules/@stablelib/utf8/lib/utf8.js
                var utf8 = __webpack_require__(978);
                // EXTERNAL MODULE: ./node_modules/@stablelib/base64/lib/base64.js
                var base64 = __webpack_require__(594);
                class EncryptedChannel extends PrivateChannel {
                    constructor(name, pusher, nacl){
                        super(name, pusher);
                        this.key = null;
                        this.nacl = nacl;
                    }
                    authorize(socketId, callback) {
                        super.authorize(socketId, (error, authData)=>{
                            if (error) {
                                callback(error, authData);
                                return;
                            }
                            let sharedSecret = authData['shared_secret'];
                            if (!sharedSecret) {
                                callback(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                                return;
                            }
                            this.key = (0, base64.decode)(sharedSecret);
                            delete authData['shared_secret'];
                            callback(null, authData);
                        });
                    }
                    trigger(event, data) {
                        throw new UnsupportedFeature('Client events are not currently supported for encrypted channels');
                    }
                    handleEvent(event) {
                        var eventName = event.event;
                        var data = event.data;
                        if (eventName.indexOf('pusher_internal:') === 0 || eventName.indexOf('pusher:') === 0) {
                            super.handleEvent(event);
                            return;
                        }
                        this.handleEncryptedEvent(eventName, data);
                    }
                    handleEncryptedEvent(event, data) {
                        if (!this.key) {
                            logger.debug('Received encrypted event before key has been retrieved from the authEndpoint');
                            return;
                        }
                        if (!data.ciphertext || !data.nonce) {
                            logger.error('Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: ' + data);
                            return;
                        }
                        let cipherText = (0, base64.decode)(data.ciphertext);
                        if (cipherText.length < this.nacl.secretbox.overheadLength) {
                            logger.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${cipherText.length}`);
                            return;
                        }
                        let nonce = (0, base64.decode)(data.nonce);
                        if (nonce.length < this.nacl.secretbox.nonceLength) {
                            logger.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${nonce.length}`);
                            return;
                        }
                        let bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                        if (bytes === null) {
                            logger.debug('Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...');
                            this.authorize(this.pusher.connection.socket_id, (error, authData)=>{
                                if (error) {
                                    logger.error(`Failed to make a request to the authEndpoint: ${authData}. Unable to fetch new key, so dropping encrypted event`);
                                    return;
                                }
                                bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                                if (bytes === null) {
                                    logger.error(`Failed to decrypt event with new key. Dropping encrypted event`);
                                    return;
                                }
                                this.emit(event, this.getDataToEmit(bytes));
                                return;
                            });
                            return;
                        }
                        this.emit(event, this.getDataToEmit(bytes));
                    }
                    getDataToEmit(bytes) {
                        let raw = (0, utf8 /* decode */ .D4)(bytes);
                        try {
                            return JSON.parse(raw);
                        } catch (_a) {
                            return raw;
                        }
                    }
                }
                class ConnectionManager extends Dispatcher {
                    constructor(key, options){
                        super();
                        this.state = 'initialized';
                        this.connection = null;
                        this.key = key;
                        this.options = options;
                        this.timeline = this.options.timeline;
                        this.usingTLS = this.options.useTLS;
                        this.errorCallbacks = this.buildErrorCallbacks();
                        this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks);
                        this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
                        var Network = runtime.getNetwork();
                        Network.bind('online', ()=>{
                            this.timeline.info({
                                netinfo: 'online'
                            });
                            if (this.state === 'connecting' || this.state === 'unavailable') this.retryIn(0);
                        });
                        Network.bind('offline', ()=>{
                            this.timeline.info({
                                netinfo: 'offline'
                            });
                            if (this.connection) this.sendActivityCheck();
                        });
                        this.updateStrategy();
                    }
                    switchCluster(key) {
                        this.key = key;
                        this.updateStrategy();
                        this.retryIn(0);
                    }
                    connect() {
                        if (this.connection || this.runner) return;
                        if (!this.strategy.isSupported()) {
                            this.updateState('failed');
                            return;
                        }
                        this.updateState('connecting');
                        this.startConnecting();
                        this.setUnavailableTimer();
                    }
                    send(data) {
                        if (this.connection) return this.connection.send(data);
                        else return false;
                    }
                    send_event(name, data, channel) {
                        if (this.connection) return this.connection.send_event(name, data, channel);
                        else return false;
                    }
                    disconnect() {
                        this.disconnectInternally();
                        this.updateState('disconnected');
                    }
                    isUsingTLS() {
                        return this.usingTLS;
                    }
                    startConnecting() {
                        var callback = (error, handshake)=>{
                            if (error) this.runner = this.strategy.connect(0, callback);
                            else if (handshake.action === 'error') {
                                this.emit('error', {
                                    type: 'HandshakeError',
                                    error: handshake.error
                                });
                                this.timeline.error({
                                    handshakeError: handshake.error
                                });
                            } else {
                                this.abortConnecting();
                                this.handshakeCallbacks[handshake.action](handshake);
                            }
                        };
                        this.runner = this.strategy.connect(0, callback);
                    }
                    abortConnecting() {
                        if (this.runner) {
                            this.runner.abort();
                            this.runner = null;
                        }
                    }
                    disconnectInternally() {
                        this.abortConnecting();
                        this.clearRetryTimer();
                        this.clearUnavailableTimer();
                        if (this.connection) {
                            var connection = this.abandonConnection();
                            connection.close();
                        }
                    }
                    updateStrategy() {
                        this.strategy = this.options.getStrategy({
                            key: this.key,
                            timeline: this.timeline,
                            useTLS: this.usingTLS
                        });
                    }
                    retryIn(delay) {
                        this.timeline.info({
                            action: 'retry',
                            delay: delay
                        });
                        if (delay > 0) this.emit('connecting_in', Math.round(delay / 1000));
                        this.retryTimer = new OneOffTimer(delay || 0, ()=>{
                            this.disconnectInternally();
                            this.connect();
                        });
                    }
                    clearRetryTimer() {
                        if (this.retryTimer) {
                            this.retryTimer.ensureAborted();
                            this.retryTimer = null;
                        }
                    }
                    setUnavailableTimer() {
                        this.unavailableTimer = new OneOffTimer(this.options.unavailableTimeout, ()=>{
                            this.updateState('unavailable');
                        });
                    }
                    clearUnavailableTimer() {
                        if (this.unavailableTimer) this.unavailableTimer.ensureAborted();
                    }
                    sendActivityCheck() {
                        this.stopActivityCheck();
                        this.connection.ping();
                        this.activityTimer = new OneOffTimer(this.options.pongTimeout, ()=>{
                            this.timeline.error({
                                pong_timed_out: this.options.pongTimeout
                            });
                            this.retryIn(0);
                        });
                    }
                    resetActivityCheck() {
                        this.stopActivityCheck();
                        if (this.connection && !this.connection.handlesActivityChecks()) this.activityTimer = new OneOffTimer(this.activityTimeout, ()=>{
                            this.sendActivityCheck();
                        });
                    }
                    stopActivityCheck() {
                        if (this.activityTimer) this.activityTimer.ensureAborted();
                    }
                    buildConnectionCallbacks(errorCallbacks) {
                        return extend({}, errorCallbacks, {
                            message: (message)=>{
                                this.resetActivityCheck();
                                this.emit('message', message);
                            },
                            ping: ()=>{
                                this.send_event('pusher:pong', {});
                            },
                            activity: ()=>{
                                this.resetActivityCheck();
                            },
                            error: (error)=>{
                                this.emit('error', error);
                            },
                            closed: ()=>{
                                this.abandonConnection();
                                if (this.shouldRetry()) this.retryIn(1000);
                            }
                        });
                    }
                    buildHandshakeCallbacks(errorCallbacks) {
                        return extend({}, errorCallbacks, {
                            connected: (handshake)=>{
                                this.activityTimeout = Math.min(this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
                                this.clearUnavailableTimer();
                                this.setConnection(handshake.connection);
                                this.socket_id = this.connection.id;
                                this.updateState('connected', {
                                    socket_id: this.socket_id
                                });
                            }
                        });
                    }
                    buildErrorCallbacks() {
                        let withErrorEmitted = (callback)=>{
                            return (result)=>{
                                if (result.error) this.emit('error', {
                                    type: 'WebSocketError',
                                    error: result.error
                                });
                                callback(result);
                            };
                        };
                        return {
                            tls_only: withErrorEmitted(()=>{
                                this.usingTLS = true;
                                this.updateStrategy();
                                this.retryIn(0);
                            }),
                            refused: withErrorEmitted(()=>{
                                this.disconnect();
                            }),
                            backoff: withErrorEmitted(()=>{
                                this.retryIn(1000);
                            }),
                            retry: withErrorEmitted(()=>{
                                this.retryIn(0);
                            })
                        };
                    }
                    setConnection(connection) {
                        this.connection = connection;
                        for(var event in this.connectionCallbacks)this.connection.bind(event, this.connectionCallbacks[event]);
                        this.resetActivityCheck();
                    }
                    abandonConnection() {
                        if (!this.connection) return;
                        this.stopActivityCheck();
                        for(var event in this.connectionCallbacks)this.connection.unbind(event, this.connectionCallbacks[event]);
                        var connection = this.connection;
                        this.connection = null;
                        return connection;
                    }
                    updateState(newState, data) {
                        var previousState = this.state;
                        this.state = newState;
                        if (previousState !== newState) {
                            var newStateDescription = newState;
                            if (newStateDescription === 'connected') newStateDescription += ' with new socket ID ' + data.socket_id;
                            logger.debug('State changed', previousState + ' -> ' + newStateDescription);
                            this.timeline.info({
                                state: newState,
                                params: data
                            });
                            this.emit('state_change', {
                                previous: previousState,
                                current: newState
                            });
                            this.emit(newState, data);
                        }
                    }
                    shouldRetry() {
                        return this.state === 'connecting' || this.state === 'connected';
                    }
                }
                class Channels {
                    constructor(){
                        this.channels = {};
                    }
                    add(name, pusher) {
                        if (!this.channels[name]) this.channels[name] = createChannel(name, pusher);
                        return this.channels[name];
                    }
                    all() {
                        return values(this.channels);
                    }
                    find(name) {
                        return this.channels[name];
                    }
                    remove(name) {
                        var channel = this.channels[name];
                        delete this.channels[name];
                        return channel;
                    }
                    disconnect() {
                        objectApply(this.channels, function(channel) {
                            channel.disconnect();
                        });
                    }
                }
                function createChannel(name, pusher) {
                    if (name.indexOf('private-encrypted-') === 0) {
                        if (pusher.config.nacl) return factory.createEncryptedChannel(name, pusher, pusher.config.nacl);
                        let errMsg = 'Tried to subscribe to a private-encrypted- channel but no nacl implementation available';
                        let suffix = url_store.buildLogSuffix('encryptedChannelSupport');
                        throw new UnsupportedFeature(`${errMsg}. ${suffix}`);
                    } else if (name.indexOf('private-') === 0) return factory.createPrivateChannel(name, pusher);
                    else if (name.indexOf('presence-') === 0) return factory.createPresenceChannel(name, pusher);
                    else if (name.indexOf('#') === 0) throw new BadChannelName('Cannot create a channel with name "' + name + '".');
                    else return factory.createChannel(name, pusher);
                }
                var Factory = {
                    createChannels () {
                        return new Channels();
                    },
                    createConnectionManager (key, options) {
                        return new ConnectionManager(key, options);
                    },
                    createChannel (name, pusher) {
                        return new Channel(name, pusher);
                    },
                    createPrivateChannel (name, pusher) {
                        return new PrivateChannel(name, pusher);
                    },
                    createPresenceChannel (name, pusher) {
                        return new PresenceChannel(name, pusher);
                    },
                    createEncryptedChannel (name, pusher, nacl) {
                        return new EncryptedChannel(name, pusher, nacl);
                    },
                    createTimelineSender (timeline, options) {
                        return new TimelineSender(timeline, options);
                    },
                    createHandshake (transport, callback) {
                        return new Handshake(transport, callback);
                    },
                    createAssistantToTheTransportManager (manager, transport, options) {
                        return new AssistantToTheTransportManager(manager, transport, options);
                    }
                };
                /* harmony default export */ const factory = Factory;
                class TransportManager {
                    constructor(options){
                        this.options = options || {};
                        this.livesLeft = this.options.lives || Infinity;
                    }
                    getAssistant(transport) {
                        return factory.createAssistantToTheTransportManager(this, transport, {
                            minPingDelay: this.options.minPingDelay,
                            maxPingDelay: this.options.maxPingDelay
                        });
                    }
                    isAlive() {
                        return this.livesLeft > 0;
                    }
                    reportDeath() {
                        this.livesLeft -= 1;
                    }
                }
                class SequentialStrategy {
                    constructor(strategies, options){
                        this.strategies = strategies;
                        this.loop = Boolean(options.loop);
                        this.failFast = Boolean(options.failFast);
                        this.timeout = options.timeout;
                        this.timeoutLimit = options.timeoutLimit;
                    }
                    isSupported() {
                        return any(this.strategies, util.method('isSupported'));
                    }
                    connect(minPriority, callback) {
                        var strategies = this.strategies;
                        var current = 0;
                        var timeout = this.timeout;
                        var runner = null;
                        var tryNextStrategy = (error, handshake)=>{
                            if (handshake) callback(null, handshake);
                            else {
                                current = current + 1;
                                if (this.loop) current = current % strategies.length;
                                if (current < strategies.length) {
                                    if (timeout) {
                                        timeout = timeout * 2;
                                        if (this.timeoutLimit) timeout = Math.min(timeout, this.timeoutLimit);
                                    }
                                    runner = this.tryStrategy(strategies[current], minPriority, {
                                        timeout: timeout,
                                        failFast: this.failFast
                                    }, tryNextStrategy);
                                } else callback(true);
                            }
                        };
                        runner = this.tryStrategy(strategies[current], minPriority, {
                            timeout: timeout,
                            failFast: this.failFast
                        }, tryNextStrategy);
                        return {
                            abort: function() {
                                runner.abort();
                            },
                            forceMinPriority: function(p) {
                                minPriority = p;
                                if (runner) runner.forceMinPriority(p);
                            }
                        };
                    }
                    tryStrategy(strategy, minPriority, options, callback) {
                        var timer = null;
                        var runner = null;
                        if (options.timeout > 0) timer = new OneOffTimer(options.timeout, function() {
                            runner.abort();
                            callback(true);
                        });
                        runner = strategy.connect(minPriority, function(error, handshake) {
                            if (error && timer && timer.isRunning() && !options.failFast) return;
                            if (timer) timer.ensureAborted();
                            callback(error, handshake);
                        });
                        return {
                            abort: function() {
                                if (timer) timer.ensureAborted();
                                runner.abort();
                            },
                            forceMinPriority: function(p) {
                                runner.forceMinPriority(p);
                            }
                        };
                    }
                }
                class BestConnectedEverStrategy {
                    constructor(strategies){
                        this.strategies = strategies;
                    }
                    isSupported() {
                        return any(this.strategies, util.method('isSupported'));
                    }
                    connect(minPriority, callback) {
                        return connect(this.strategies, minPriority, function(i, runners) {
                            return function(error, handshake) {
                                runners[i].error = error;
                                if (error) {
                                    if (allRunnersFailed(runners)) callback(true);
                                    return;
                                }
                                apply(runners, function(runner) {
                                    runner.forceMinPriority(handshake.transport.priority);
                                });
                                callback(null, handshake);
                            };
                        });
                    }
                }
                function connect(strategies, minPriority, callbackBuilder) {
                    var runners = map(strategies, function(strategy, i, _, rs) {
                        return strategy.connect(minPriority, callbackBuilder(i, rs));
                    });
                    return {
                        abort: function() {
                            apply(runners, abortRunner);
                        },
                        forceMinPriority: function(p) {
                            apply(runners, function(runner) {
                                runner.forceMinPriority(p);
                            });
                        }
                    };
                }
                function allRunnersFailed(runners) {
                    return collections_all(runners, function(runner) {
                        return Boolean(runner.error);
                    });
                }
                function abortRunner(runner) {
                    if (!runner.error && !runner.aborted) {
                        runner.abort();
                        runner.aborted = true;
                    }
                }
                class WebSocketPrioritizedCachedStrategy {
                    constructor(strategy, transports, options){
                        this.strategy = strategy;
                        this.transports = transports;
                        this.ttl = options.ttl || 1800000;
                        this.usingTLS = options.useTLS;
                        this.timeline = options.timeline;
                    }
                    isSupported() {
                        return this.strategy.isSupported();
                    }
                    connect(minPriority, callback) {
                        var usingTLS = this.usingTLS;
                        var info = fetchTransportCache(usingTLS);
                        var cacheSkipCount = info && info.cacheSkipCount ? info.cacheSkipCount : 0;
                        var strategies = [
                            this.strategy
                        ];
                        if (info && info.timestamp + this.ttl >= util.now()) {
                            var transport = this.transports[info.transport];
                            if (transport) {
                                if ([
                                    'ws',
                                    'wss'
                                ].includes(info.transport) || cacheSkipCount > 3) {
                                    this.timeline.info({
                                        cached: true,
                                        transport: info.transport,
                                        latency: info.latency
                                    });
                                    strategies.push(new SequentialStrategy([
                                        transport
                                    ], {
                                        timeout: info.latency * 2 + 1000,
                                        failFast: true
                                    }));
                                } else cacheSkipCount++;
                            }
                        }
                        var startTimestamp = util.now();
                        var runner = strategies.pop().connect(minPriority, function cb(error, handshake) {
                            if (error) {
                                flushTransportCache(usingTLS);
                                if (strategies.length > 0) {
                                    startTimestamp = util.now();
                                    runner = strategies.pop().connect(minPriority, cb);
                                } else callback(error);
                            } else {
                                storeTransportCache(usingTLS, handshake.transport.name, util.now() - startTimestamp, cacheSkipCount);
                                callback(null, handshake);
                            }
                        });
                        return {
                            abort: function() {
                                runner.abort();
                            },
                            forceMinPriority: function(p) {
                                minPriority = p;
                                if (runner) runner.forceMinPriority(p);
                            }
                        };
                    }
                }
                function getTransportCacheKey(usingTLS) {
                    return 'pusherTransport' + (usingTLS ? 'TLS' : 'NonTLS');
                }
                function fetchTransportCache(usingTLS) {
                    var storage = runtime.getLocalStorage();
                    if (storage) try {
                        var serializedCache = storage[getTransportCacheKey(usingTLS)];
                        if (serializedCache) return JSON.parse(serializedCache);
                    } catch (e) {
                        flushTransportCache(usingTLS);
                    }
                    return null;
                }
                function storeTransportCache(usingTLS, transport, latency, cacheSkipCount) {
                    var storage = runtime.getLocalStorage();
                    if (storage) try {
                        storage[getTransportCacheKey(usingTLS)] = safeJSONStringify({
                            timestamp: util.now(),
                            transport: transport,
                            latency: latency,
                            cacheSkipCount: cacheSkipCount
                        });
                    } catch (e) {}
                }
                function flushTransportCache(usingTLS) {
                    var storage = runtime.getLocalStorage();
                    if (storage) try {
                        delete storage[getTransportCacheKey(usingTLS)];
                    } catch (e) {}
                }
                class DelayedStrategy {
                    constructor(strategy, { delay: number }){
                        this.strategy = strategy;
                        this.options = {
                            delay: number
                        };
                    }
                    isSupported() {
                        return this.strategy.isSupported();
                    }
                    connect(minPriority, callback) {
                        var strategy = this.strategy;
                        var runner;
                        var timer = new OneOffTimer(this.options.delay, function() {
                            runner = strategy.connect(minPriority, callback);
                        });
                        return {
                            abort: function() {
                                timer.ensureAborted();
                                if (runner) runner.abort();
                            },
                            forceMinPriority: function(p) {
                                minPriority = p;
                                if (runner) runner.forceMinPriority(p);
                            }
                        };
                    }
                }
                class IfStrategy {
                    constructor(test, trueBranch, falseBranch){
                        this.test = test;
                        this.trueBranch = trueBranch;
                        this.falseBranch = falseBranch;
                    }
                    isSupported() {
                        var branch = this.test() ? this.trueBranch : this.falseBranch;
                        return branch.isSupported();
                    }
                    connect(minPriority, callback) {
                        var branch = this.test() ? this.trueBranch : this.falseBranch;
                        return branch.connect(minPriority, callback);
                    }
                }
                class FirstConnectedStrategy {
                    constructor(strategy){
                        this.strategy = strategy;
                    }
                    isSupported() {
                        return this.strategy.isSupported();
                    }
                    connect(minPriority, callback) {
                        var runner = this.strategy.connect(minPriority, function(error, handshake) {
                            if (handshake) runner.abort();
                            callback(error, handshake);
                        });
                        return runner;
                    }
                }
                function testSupportsStrategy(strategy) {
                    return function() {
                        return strategy.isSupported();
                    };
                }
                var getDefaultStrategy = function(config, baseOptions, defineTransport) {
                    var definedTransports = {};
                    function defineTransportStrategy(name, type, priority, options, manager) {
                        var transport = defineTransport(config, name, type, priority, options, manager);
                        definedTransports[name] = transport;
                        return transport;
                    }
                    var ws_options = Object.assign({}, baseOptions, {
                        hostNonTLS: config.wsHost + ':' + config.wsPort,
                        hostTLS: config.wsHost + ':' + config.wssPort,
                        httpPath: config.wsPath
                    });
                    var wss_options = Object.assign({}, ws_options, {
                        useTLS: true
                    });
                    var sockjs_options = Object.assign({}, baseOptions, {
                        hostNonTLS: config.httpHost + ':' + config.httpPort,
                        hostTLS: config.httpHost + ':' + config.httpsPort,
                        httpPath: config.httpPath
                    });
                    var timeouts = {
                        loop: true,
                        timeout: 15000,
                        timeoutLimit: 60000
                    };
                    var ws_manager = new TransportManager({
                        minPingDelay: 10000,
                        maxPingDelay: config.activityTimeout
                    });
                    var streaming_manager = new TransportManager({
                        lives: 2,
                        minPingDelay: 10000,
                        maxPingDelay: config.activityTimeout
                    });
                    var ws_transport = defineTransportStrategy('ws', 'ws', 3, ws_options, ws_manager);
                    var wss_transport = defineTransportStrategy('wss', 'ws', 3, wss_options, ws_manager);
                    var sockjs_transport = defineTransportStrategy('sockjs', 'sockjs', 1, sockjs_options);
                    var xhr_streaming_transport = defineTransportStrategy('xhr_streaming', 'xhr_streaming', 1, sockjs_options, streaming_manager);
                    var xdr_streaming_transport = defineTransportStrategy('xdr_streaming', 'xdr_streaming', 1, sockjs_options, streaming_manager);
                    var xhr_polling_transport = defineTransportStrategy('xhr_polling', 'xhr_polling', 1, sockjs_options);
                    var xdr_polling_transport = defineTransportStrategy('xdr_polling', 'xdr_polling', 1, sockjs_options);
                    var ws_loop = new SequentialStrategy([
                        ws_transport
                    ], timeouts);
                    var wss_loop = new SequentialStrategy([
                        wss_transport
                    ], timeouts);
                    var sockjs_loop = new SequentialStrategy([
                        sockjs_transport
                    ], timeouts);
                    var streaming_loop = new SequentialStrategy([
                        new IfStrategy(testSupportsStrategy(xhr_streaming_transport), xhr_streaming_transport, xdr_streaming_transport)
                    ], timeouts);
                    var polling_loop = new SequentialStrategy([
                        new IfStrategy(testSupportsStrategy(xhr_polling_transport), xhr_polling_transport, xdr_polling_transport)
                    ], timeouts);
                    var http_loop = new SequentialStrategy([
                        new IfStrategy(testSupportsStrategy(streaming_loop), new BestConnectedEverStrategy([
                            streaming_loop,
                            new DelayedStrategy(polling_loop, {
                                delay: 4000
                            })
                        ]), polling_loop)
                    ], timeouts);
                    var http_fallback_loop = new IfStrategy(testSupportsStrategy(http_loop), http_loop, sockjs_loop);
                    var wsStrategy;
                    if (baseOptions.useTLS) wsStrategy = new BestConnectedEverStrategy([
                        ws_loop,
                        new DelayedStrategy(http_fallback_loop, {
                            delay: 2000
                        })
                    ]);
                    else wsStrategy = new BestConnectedEverStrategy([
                        ws_loop,
                        new DelayedStrategy(wss_loop, {
                            delay: 2000
                        }),
                        new DelayedStrategy(http_fallback_loop, {
                            delay: 5000
                        })
                    ]);
                    return new WebSocketPrioritizedCachedStrategy(new FirstConnectedStrategy(new IfStrategy(testSupportsStrategy(ws_transport), wsStrategy, http_fallback_loop)), definedTransports, {
                        ttl: 1800000,
                        timeline: baseOptions.timeline,
                        useTLS: baseOptions.useTLS
                    });
                };
                /* harmony default export */ const default_strategy = getDefaultStrategy;
                /* harmony default export */ function transport_connection_initializer() {
                    var self1 = this;
                    self1.timeline.info(self1.buildTimelineMessage({
                        transport: self1.name + (self1.options.useTLS ? 's' : '')
                    }));
                    if (self1.hooks.isInitialized()) self1.changeState('initialized');
                    else if (self1.hooks.file) {
                        self1.changeState('initializing');
                        Dependencies.load(self1.hooks.file, {
                            useTLS: self1.options.useTLS
                        }, function(error, callback) {
                            if (self1.hooks.isInitialized()) {
                                self1.changeState('initialized');
                                callback(true);
                            } else {
                                if (error) self1.onError(error);
                                self1.onClose();
                                callback(false);
                            }
                        });
                    } else self1.onClose();
                }
                var hooks = {
                    getRequest: function(socket) {
                        var xdr = new window.XDomainRequest();
                        xdr.ontimeout = function() {
                            socket.emit('error', new RequestTimedOut());
                            socket.close();
                        };
                        xdr.onerror = function(e) {
                            socket.emit('error', e);
                            socket.close();
                        };
                        xdr.onprogress = function() {
                            if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                        };
                        xdr.onload = function() {
                            if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                            socket.emit('finished', 200);
                            socket.close();
                        };
                        return xdr;
                    },
                    abortRequest: function(xdr) {
                        xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
                        xdr.abort();
                    }
                };
                /* harmony default export */ const http_xdomain_request = hooks;
                const MAX_BUFFER_LENGTH = 262144;
                class HTTPRequest extends Dispatcher {
                    constructor(hooks, method, url){
                        super();
                        this.hooks = hooks;
                        this.method = method;
                        this.url = url;
                    }
                    start(payload) {
                        this.position = 0;
                        this.xhr = this.hooks.getRequest(this);
                        this.unloader = ()=>{
                            this.close();
                        };
                        runtime.addUnloadListener(this.unloader);
                        this.xhr.open(this.method, this.url, true);
                        if (this.xhr.setRequestHeader) this.xhr.setRequestHeader('Content-Type', 'application/json');
                        this.xhr.send(payload);
                    }
                    close() {
                        if (this.unloader) {
                            runtime.removeUnloadListener(this.unloader);
                            this.unloader = null;
                        }
                        if (this.xhr) {
                            this.hooks.abortRequest(this.xhr);
                            this.xhr = null;
                        }
                    }
                    onChunk(status, data) {
                        while(true){
                            var chunk = this.advanceBuffer(data);
                            if (chunk) this.emit('chunk', {
                                status: status,
                                data: chunk
                            });
                            else break;
                        }
                        if (this.isBufferTooLong(data)) this.emit('buffer_too_long');
                    }
                    advanceBuffer(buffer) {
                        var unreadData = buffer.slice(this.position);
                        var endOfLinePosition = unreadData.indexOf('\n');
                        if (endOfLinePosition !== -1) {
                            this.position += endOfLinePosition + 1;
                            return unreadData.slice(0, endOfLinePosition);
                        } else return null;
                    }
                    isBufferTooLong(buffer) {
                        return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
                    }
                }
                var State;
                (function(State) {
                    State[State["CONNECTING"] = 0] = "CONNECTING";
                    State[State["OPEN"] = 1] = "OPEN";
                    State[State["CLOSED"] = 3] = "CLOSED";
                })(State || (State = {}));
                /* harmony default export */ const state = State;
                var autoIncrement = 1;
                class HTTPSocket {
                    constructor(hooks, url){
                        this.hooks = hooks;
                        this.session = randomNumber(1000) + '/' + randomString(8);
                        this.location = getLocation(url);
                        this.readyState = state.CONNECTING;
                        this.openStream();
                    }
                    send(payload) {
                        return this.sendRaw(JSON.stringify([
                            payload
                        ]));
                    }
                    ping() {
                        this.hooks.sendHeartbeat(this);
                    }
                    close(code, reason) {
                        this.onClose(code, reason, true);
                    }
                    sendRaw(payload) {
                        if (this.readyState === state.OPEN) try {
                            runtime.createSocketRequest('POST', getUniqueURL(getSendURL(this.location, this.session))).start(payload);
                            return true;
                        } catch (e) {
                            return false;
                        }
                        else return false;
                    }
                    reconnect() {
                        this.closeStream();
                        this.openStream();
                    }
                    onClose(code, reason, wasClean) {
                        this.closeStream();
                        this.readyState = state.CLOSED;
                        if (this.onclose) this.onclose({
                            code: code,
                            reason: reason,
                            wasClean: wasClean
                        });
                    }
                    onChunk(chunk) {
                        if (chunk.status !== 200) return;
                        if (this.readyState === state.OPEN) this.onActivity();
                        var payload;
                        var type = chunk.data.slice(0, 1);
                        switch(type){
                            case 'o':
                                payload = JSON.parse(chunk.data.slice(1) || '{}');
                                this.onOpen(payload);
                                break;
                            case 'a':
                                payload = JSON.parse(chunk.data.slice(1) || '[]');
                                for(var i = 0; i < payload.length; i++)this.onEvent(payload[i]);
                                break;
                            case 'm':
                                payload = JSON.parse(chunk.data.slice(1) || 'null');
                                this.onEvent(payload);
                                break;
                            case 'h':
                                this.hooks.onHeartbeat(this);
                                break;
                            case 'c':
                                payload = JSON.parse(chunk.data.slice(1) || '[]');
                                this.onClose(payload[0], payload[1], true);
                                break;
                        }
                    }
                    onOpen(options) {
                        if (this.readyState === state.CONNECTING) {
                            if (options && options.hostname) this.location.base = replaceHost(this.location.base, options.hostname);
                            this.readyState = state.OPEN;
                            if (this.onopen) this.onopen();
                        } else this.onClose(1006, 'Server lost session', true);
                    }
                    onEvent(event) {
                        if (this.readyState === state.OPEN && this.onmessage) this.onmessage({
                            data: event
                        });
                    }
                    onActivity() {
                        if (this.onactivity) this.onactivity();
                    }
                    onError(error) {
                        if (this.onerror) this.onerror(error);
                    }
                    openStream() {
                        this.stream = runtime.createSocketRequest('POST', getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
                        this.stream.bind('chunk', (chunk)=>{
                            this.onChunk(chunk);
                        });
                        this.stream.bind('finished', (status)=>{
                            this.hooks.onFinished(this, status);
                        });
                        this.stream.bind('buffer_too_long', ()=>{
                            this.reconnect();
                        });
                        try {
                            this.stream.start();
                        } catch (error) {
                            util.defer(()=>{
                                this.onError(error);
                                this.onClose(1006, 'Could not start streaming', false);
                            });
                        }
                    }
                    closeStream() {
                        if (this.stream) {
                            this.stream.unbind_all();
                            this.stream.close();
                            this.stream = null;
                        }
                    }
                }
                function getLocation(url) {
                    var parts = /([^\?]*)\/*(\??.*)/.exec(url);
                    return {
                        base: parts[1],
                        queryString: parts[2]
                    };
                }
                function getSendURL(url, session) {
                    return url.base + '/' + session + '/xhr_send';
                }
                function getUniqueURL(url) {
                    var separator = url.indexOf('?') === -1 ? '?' : '&';
                    return url + separator + 't=' + +new Date() + '&n=' + autoIncrement++;
                }
                function replaceHost(url, hostname) {
                    var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
                    return urlParts[1] + hostname + urlParts[3];
                }
                function randomNumber(max) {
                    return runtime.randomInt(max);
                }
                function randomString(length) {
                    var result = [];
                    for(var i = 0; i < length; i++)result.push(randomNumber(32).toString(32));
                    return result.join('');
                }
                /* harmony default export */ const http_socket = HTTPSocket;
                var http_streaming_socket_hooks = {
                    getReceiveURL: function(url, session) {
                        return url.base + '/' + session + '/xhr_streaming' + url.queryString;
                    },
                    onHeartbeat: function(socket) {
                        socket.sendRaw('[]');
                    },
                    sendHeartbeat: function(socket) {
                        socket.sendRaw('[]');
                    },
                    onFinished: function(socket, status) {
                        socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
                    }
                };
                /* harmony default export */ const http_streaming_socket = http_streaming_socket_hooks;
                var http_polling_socket_hooks = {
                    getReceiveURL: function(url, session) {
                        return url.base + '/' + session + '/xhr' + url.queryString;
                    },
                    onHeartbeat: function() {},
                    sendHeartbeat: function(socket) {
                        socket.sendRaw('[]');
                    },
                    onFinished: function(socket, status) {
                        if (status === 200) socket.reconnect();
                        else socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
                    }
                };
                /* harmony default export */ const http_polling_socket = http_polling_socket_hooks;
                var http_xhr_request_hooks = {
                    getRequest: function(socket) {
                        var Constructor = runtime.getXHRAPI();
                        var xhr = new Constructor();
                        xhr.onreadystatechange = xhr.onprogress = function() {
                            switch(xhr.readyState){
                                case 3:
                                    if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                    break;
                                case 4:
                                    if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                    socket.emit('finished', xhr.status);
                                    socket.close();
                                    break;
                            }
                        };
                        return xhr;
                    },
                    abortRequest: function(xhr) {
                        xhr.onreadystatechange = null;
                        xhr.abort();
                    }
                };
                /* harmony default export */ const http_xhr_request = http_xhr_request_hooks;
                var HTTP = {
                    createStreamingSocket (url) {
                        return this.createSocket(http_streaming_socket, url);
                    },
                    createPollingSocket (url) {
                        return this.createSocket(http_polling_socket, url);
                    },
                    createSocket (hooks, url) {
                        return new http_socket(hooks, url);
                    },
                    createXHR (method, url) {
                        return this.createRequest(http_xhr_request, method, url);
                    },
                    createRequest (hooks, method, url) {
                        return new HTTPRequest(hooks, method, url);
                    }
                };
                /* harmony default export */ const http_http = HTTP;
                http_http.createXDR = function(method, url) {
                    return this.createRequest(http_xdomain_request, method, url);
                };
                /* harmony default export */ const web_http_http = http_http;
                var Runtime = {
                    nextAuthCallbackID: 1,
                    auth_callbacks: {},
                    ScriptReceivers: ScriptReceivers,
                    DependenciesReceivers: DependenciesReceivers,
                    getDefaultStrategy: default_strategy,
                    Transports: transports_transports,
                    transportConnectionInitializer: transport_connection_initializer,
                    HTTPFactory: web_http_http,
                    TimelineTransport: jsonp_timeline,
                    getXHRAPI () {
                        return window.XMLHttpRequest;
                    },
                    getWebSocketAPI () {
                        return window.WebSocket || window.MozWebSocket;
                    },
                    setup (PusherClass) {
                        window.Pusher = PusherClass;
                        var initializeOnDocumentBody = ()=>{
                            this.onDocumentBody(PusherClass.ready);
                        };
                        if (!window.JSON) Dependencies.load('json2', {}, initializeOnDocumentBody);
                        else initializeOnDocumentBody();
                    },
                    getDocument () {
                        return document;
                    },
                    getProtocol () {
                        return this.getDocument().location.protocol;
                    },
                    getAuthorizers () {
                        return {
                            ajax: xhr_auth,
                            jsonp: jsonp_auth
                        };
                    },
                    onDocumentBody (callback) {
                        if (document.body) callback();
                        else setTimeout(()=>{
                            this.onDocumentBody(callback);
                        }, 0);
                    },
                    createJSONPRequest (url, data) {
                        return new JSONPRequest(url, data);
                    },
                    createScriptRequest (src) {
                        return new ScriptRequest(src);
                    },
                    getLocalStorage () {
                        try {
                            return window.localStorage;
                        } catch (e) {
                            return undefined;
                        }
                    },
                    createXHR () {
                        if (this.getXHRAPI()) return this.createXMLHttpRequest();
                        else return this.createMicrosoftXHR();
                    },
                    createXMLHttpRequest () {
                        var Constructor = this.getXHRAPI();
                        return new Constructor();
                    },
                    createMicrosoftXHR () {
                        return new ActiveXObject('Microsoft.XMLHTTP');
                    },
                    getNetwork () {
                        return Network;
                    },
                    createWebSocket (url) {
                        var Constructor = this.getWebSocketAPI();
                        return new Constructor(url);
                    },
                    createSocketRequest (method, url) {
                        if (this.isXHRSupported()) return this.HTTPFactory.createXHR(method, url);
                        else if (this.isXDRSupported(url.indexOf('https:') === 0)) return this.HTTPFactory.createXDR(method, url);
                        else throw 'Cross-origin HTTP requests are not supported';
                    },
                    isXHRSupported () {
                        var Constructor = this.getXHRAPI();
                        return Boolean(Constructor) && new Constructor().withCredentials !== undefined;
                    },
                    isXDRSupported (useTLS) {
                        var protocol = useTLS ? 'https:' : 'http:';
                        var documentProtocol = this.getProtocol();
                        return Boolean(window['XDomainRequest']) && documentProtocol === protocol;
                    },
                    addUnloadListener (listener) {
                        if (window.addEventListener !== undefined) window.addEventListener('unload', listener, false);
                        else if (window.attachEvent !== undefined) window.attachEvent('onunload', listener);
                    },
                    removeUnloadListener (listener) {
                        if (window.addEventListener !== undefined) window.removeEventListener('unload', listener, false);
                        else if (window.detachEvent !== undefined) window.detachEvent('onunload', listener);
                    },
                    randomInt (max) {
                        const random = function() {
                            const crypto = window.crypto || window['msCrypto'];
                            const random = crypto.getRandomValues(new Uint32Array(1))[0];
                            return random / Math.pow(2, 32);
                        };
                        return Math.floor(random() * max);
                    }
                };
                /* harmony default export */ const runtime = Runtime;
                var TimelineLevel;
                (function(TimelineLevel) {
                    TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
                    TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
                    TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
                })(TimelineLevel || (TimelineLevel = {}));
                /* harmony default export */ const level = TimelineLevel;
                class Timeline {
                    constructor(key, session, options){
                        this.key = key;
                        this.session = session;
                        this.events = [];
                        this.options = options || {};
                        this.sent = 0;
                        this.uniqueID = 0;
                    }
                    log(level, event) {
                        if (level <= this.options.level) {
                            this.events.push(extend({}, event, {
                                timestamp: util.now()
                            }));
                            if (this.options.limit && this.events.length > this.options.limit) this.events.shift();
                        }
                    }
                    error(event) {
                        this.log(level.ERROR, event);
                    }
                    info(event) {
                        this.log(level.INFO, event);
                    }
                    debug(event) {
                        this.log(level.DEBUG, event);
                    }
                    isEmpty() {
                        return this.events.length === 0;
                    }
                    send(sendfn, callback) {
                        var data = extend({
                            session: this.session,
                            bundle: this.sent + 1,
                            key: this.key,
                            lib: 'js',
                            version: this.options.version,
                            cluster: this.options.cluster,
                            features: this.options.features,
                            timeline: this.events
                        }, this.options.params);
                        this.events = [];
                        sendfn(data, (error, result)=>{
                            if (!error) this.sent++;
                            if (callback) callback(error, result);
                        });
                        return true;
                    }
                    generateUniqueID() {
                        this.uniqueID++;
                        return this.uniqueID;
                    }
                }
                class TransportStrategy {
                    constructor(name, priority, transport, options){
                        this.name = name;
                        this.priority = priority;
                        this.transport = transport;
                        this.options = options || {};
                    }
                    isSupported() {
                        return this.transport.isSupported({
                            useTLS: this.options.useTLS
                        });
                    }
                    connect(minPriority, callback) {
                        if (!this.isSupported()) return failAttempt(new UnsupportedStrategy(), callback);
                        else if (this.priority < minPriority) return failAttempt(new TransportPriorityTooLow(), callback);
                        var connected = false;
                        var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
                        var handshake = null;
                        var onInitialized = function() {
                            transport.unbind('initialized', onInitialized);
                            transport.connect();
                        };
                        var onOpen = function() {
                            handshake = factory.createHandshake(transport, function(result) {
                                connected = true;
                                unbindListeners();
                                callback(null, result);
                            });
                        };
                        var onError = function(error) {
                            unbindListeners();
                            callback(error);
                        };
                        var onClosed = function() {
                            unbindListeners();
                            var serializedTransport;
                            serializedTransport = safeJSONStringify(transport);
                            callback(new TransportClosed(serializedTransport));
                        };
                        var unbindListeners = function() {
                            transport.unbind('initialized', onInitialized);
                            transport.unbind('open', onOpen);
                            transport.unbind('error', onError);
                            transport.unbind('closed', onClosed);
                        };
                        transport.bind('initialized', onInitialized);
                        transport.bind('open', onOpen);
                        transport.bind('error', onError);
                        transport.bind('closed', onClosed);
                        transport.initialize();
                        return {
                            abort: ()=>{
                                if (connected) return;
                                unbindListeners();
                                if (handshake) handshake.close();
                                else transport.close();
                            },
                            forceMinPriority: (p)=>{
                                if (connected) return;
                                if (this.priority < p) {
                                    if (handshake) handshake.close();
                                    else transport.close();
                                }
                            }
                        };
                    }
                }
                function failAttempt(error, callback) {
                    util.defer(function() {
                        callback(error);
                    });
                    return {
                        abort: function() {},
                        forceMinPriority: function() {}
                    };
                }
                const { Transports: strategy_builder_Transports } = runtime;
                var defineTransport = function(config, name, type, priority, options, manager) {
                    var transportClass = strategy_builder_Transports[type];
                    if (!transportClass) throw new UnsupportedTransport(type);
                    var enabled = (!config.enabledTransports || arrayIndexOf(config.enabledTransports, name) !== -1) && (!config.disabledTransports || arrayIndexOf(config.disabledTransports, name) === -1);
                    var transport;
                    if (enabled) {
                        options = Object.assign({
                            ignoreNullOrigin: config.ignoreNullOrigin
                        }, options);
                        transport = new TransportStrategy(name, priority, manager ? manager.getAssistant(transportClass) : transportClass, options);
                    } else transport = strategy_builder_UnsupportedStrategy;
                    return transport;
                };
                var strategy_builder_UnsupportedStrategy = {
                    isSupported: function() {
                        return false;
                    },
                    connect: function(_, callback) {
                        var deferred = util.defer(function() {
                            callback(new UnsupportedStrategy());
                        });
                        return {
                            abort: function() {
                                deferred.ensureAborted();
                            },
                            forceMinPriority: function() {}
                        };
                    }
                };
                function validateOptions(options) {
                    if (options == null) throw 'You must pass an options object';
                    if (options.cluster == null) throw 'Options object must provide a cluster';
                    if ('disableStats' in options) logger.warn('The disableStats option is deprecated in favor of enableStats');
                }
                const composeChannelQuery = (params, authOptions)=>{
                    var query = 'socket_id=' + encodeURIComponent(params.socketId);
                    for(var key in authOptions.params)query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(authOptions.params[key]);
                    if (authOptions.paramsProvider != null) {
                        let dynamicParams = authOptions.paramsProvider();
                        for(var key in dynamicParams)query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(dynamicParams[key]);
                    }
                    return query;
                };
                const UserAuthenticator = (authOptions)=>{
                    if (typeof runtime.getAuthorizers()[authOptions.transport] === 'undefined') throw `'${authOptions.transport}' is not a recognized auth transport`;
                    return (params, callback)=>{
                        const query = composeChannelQuery(params, authOptions);
                        runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.UserAuthentication, callback);
                    };
                };
                /* harmony default export */ const user_authenticator = UserAuthenticator;
                const channel_authorizer_composeChannelQuery = (params, authOptions)=>{
                    var query = 'socket_id=' + encodeURIComponent(params.socketId);
                    query += '&channel_name=' + encodeURIComponent(params.channelName);
                    for(var key in authOptions.params)query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(authOptions.params[key]);
                    if (authOptions.paramsProvider != null) {
                        let dynamicParams = authOptions.paramsProvider();
                        for(var key in dynamicParams)query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(dynamicParams[key]);
                    }
                    return query;
                };
                const ChannelAuthorizer = (authOptions)=>{
                    if (typeof runtime.getAuthorizers()[authOptions.transport] === 'undefined') throw `'${authOptions.transport}' is not a recognized auth transport`;
                    return (params, callback)=>{
                        const query = channel_authorizer_composeChannelQuery(params, authOptions);
                        runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.ChannelAuthorization, callback);
                    };
                };
                /* harmony default export */ const channel_authorizer = ChannelAuthorizer;
                const ChannelAuthorizerProxy = (pusher, authOptions, channelAuthorizerGenerator)=>{
                    const deprecatedAuthorizerOptions = {
                        authTransport: authOptions.transport,
                        authEndpoint: authOptions.endpoint,
                        auth: {
                            params: authOptions.params,
                            headers: authOptions.headers
                        }
                    };
                    return (params, callback)=>{
                        const channel = pusher.channel(params.channelName);
                        const channelAuthorizer = channelAuthorizerGenerator(channel, deprecatedAuthorizerOptions);
                        channelAuthorizer.authorize(params.socketId, callback);
                    };
                };
                function getConfig(opts, pusher) {
                    let config = {
                        activityTimeout: opts.activityTimeout || defaults.activityTimeout,
                        cluster: opts.cluster,
                        httpPath: opts.httpPath || defaults.httpPath,
                        httpPort: opts.httpPort || defaults.httpPort,
                        httpsPort: opts.httpsPort || defaults.httpsPort,
                        pongTimeout: opts.pongTimeout || defaults.pongTimeout,
                        statsHost: opts.statsHost || defaults.stats_host,
                        unavailableTimeout: opts.unavailableTimeout || defaults.unavailableTimeout,
                        wsPath: opts.wsPath || defaults.wsPath,
                        wsPort: opts.wsPort || defaults.wsPort,
                        wssPort: opts.wssPort || defaults.wssPort,
                        enableStats: getEnableStatsConfig(opts),
                        httpHost: getHttpHost(opts),
                        useTLS: shouldUseTLS(opts),
                        wsHost: getWebsocketHost(opts),
                        userAuthenticator: buildUserAuthenticator(opts),
                        channelAuthorizer: buildChannelAuthorizer(opts, pusher)
                    };
                    if ('disabledTransports' in opts) config.disabledTransports = opts.disabledTransports;
                    if ('enabledTransports' in opts) config.enabledTransports = opts.enabledTransports;
                    if ('ignoreNullOrigin' in opts) config.ignoreNullOrigin = opts.ignoreNullOrigin;
                    if ('timelineParams' in opts) config.timelineParams = opts.timelineParams;
                    if ('nacl' in opts) config.nacl = opts.nacl;
                    return config;
                }
                function getHttpHost(opts) {
                    if (opts.httpHost) return opts.httpHost;
                    if (opts.cluster) return `sockjs-${opts.cluster}.pusher.com`;
                    return defaults.httpHost;
                }
                function getWebsocketHost(opts) {
                    if (opts.wsHost) return opts.wsHost;
                    return getWebsocketHostFromCluster(opts.cluster);
                }
                function getWebsocketHostFromCluster(cluster) {
                    return `ws-${cluster}.pusher.com`;
                }
                function shouldUseTLS(opts) {
                    if (runtime.getProtocol() === 'https:') return true;
                    else if (opts.forceTLS === false) return false;
                    return true;
                }
                function getEnableStatsConfig(opts) {
                    if ('enableStats' in opts) return opts.enableStats;
                    if ('disableStats' in opts) return !opts.disableStats;
                    return false;
                }
                const hasCustomHandler = (auth)=>{
                    return 'customHandler' in auth && auth['customHandler'] != null;
                };
                function buildUserAuthenticator(opts) {
                    const userAuthentication = Object.assign(Object.assign({}, defaults.userAuthentication), opts.userAuthentication);
                    if (hasCustomHandler(userAuthentication)) return userAuthentication['customHandler'];
                    return user_authenticator(userAuthentication);
                }
                function buildChannelAuth(opts, pusher) {
                    let channelAuthorization;
                    if ('channelAuthorization' in opts) channelAuthorization = Object.assign(Object.assign({}, defaults.channelAuthorization), opts.channelAuthorization);
                    else {
                        channelAuthorization = {
                            transport: opts.authTransport || defaults.authTransport,
                            endpoint: opts.authEndpoint || defaults.authEndpoint
                        };
                        if ('auth' in opts) {
                            if ('params' in opts.auth) channelAuthorization.params = opts.auth.params;
                            if ('headers' in opts.auth) channelAuthorization.headers = opts.auth.headers;
                        }
                        if ('authorizer' in opts) return {
                            customHandler: ChannelAuthorizerProxy(pusher, channelAuthorization, opts.authorizer)
                        };
                    }
                    return channelAuthorization;
                }
                function buildChannelAuthorizer(opts, pusher) {
                    const channelAuthorization = buildChannelAuth(opts, pusher);
                    if (hasCustomHandler(channelAuthorization)) return channelAuthorization['customHandler'];
                    return channel_authorizer(channelAuthorization);
                }
                class WatchlistFacade extends Dispatcher {
                    constructor(pusher){
                        super(function(eventName, data) {
                            logger.debug(`No callbacks on watchlist events for ${eventName}`);
                        });
                        this.pusher = pusher;
                        this.bindWatchlistInternalEvent();
                    }
                    handleEvent(pusherEvent) {
                        pusherEvent.data.events.forEach((watchlistEvent)=>{
                            this.emit(watchlistEvent.name, watchlistEvent);
                        });
                    }
                    bindWatchlistInternalEvent() {
                        this.pusher.connection.bind('message', (pusherEvent)=>{
                            var eventName = pusherEvent.event;
                            if (eventName === 'pusher_internal:watchlist_events') this.handleEvent(pusherEvent);
                        });
                    }
                }
                function flatPromise() {
                    let resolve, reject;
                    const promise = new Promise((res, rej)=>{
                        resolve = res;
                        reject = rej;
                    });
                    return {
                        promise: promise,
                        resolve: resolve,
                        reject: reject
                    };
                }
                /* harmony default export */ const flat_promise = flatPromise;
                class UserFacade extends Dispatcher {
                    constructor(pusher){
                        super(function(eventName, data) {
                            logger.debug('No callbacks on user for ' + eventName);
                        });
                        this.signin_requested = false;
                        this.user_data = null;
                        this.serverToUserChannel = null;
                        this.signinDonePromise = null;
                        this._signinDoneResolve = null;
                        this._onAuthorize = (err, authData)=>{
                            if (err) {
                                logger.warn(`Error during signin: ${err}`);
                                this._cleanup();
                                return;
                            }
                            this.pusher.send_event('pusher:signin', {
                                auth: authData.auth,
                                user_data: authData.user_data
                            });
                        };
                        this.pusher = pusher;
                        this.pusher.connection.bind('state_change', ({ previous: previous, current: current })=>{
                            if (previous !== 'connected' && current === 'connected') this._signin();
                            if (previous === 'connected' && current !== 'connected') {
                                this._cleanup();
                                this._newSigninPromiseIfNeeded();
                            }
                        });
                        this.watchlist = new WatchlistFacade(pusher);
                        this.pusher.connection.bind('message', (event)=>{
                            var eventName = event.event;
                            if (eventName === 'pusher:signin_success') this._onSigninSuccess(event.data);
                            if (this.serverToUserChannel && this.serverToUserChannel.name === event.channel) this.serverToUserChannel.handleEvent(event);
                        });
                    }
                    signin() {
                        if (this.signin_requested) return;
                        this.signin_requested = true;
                        this._signin();
                    }
                    _signin() {
                        if (!this.signin_requested) return;
                        this._newSigninPromiseIfNeeded();
                        if (this.pusher.connection.state !== 'connected') return;
                        this.pusher.config.userAuthenticator({
                            socketId: this.pusher.connection.socket_id
                        }, this._onAuthorize);
                    }
                    _onSigninSuccess(data) {
                        try {
                            this.user_data = JSON.parse(data.user_data);
                        } catch (e) {
                            logger.error(`Failed parsing user data after signin: ${data.user_data}`);
                            this._cleanup();
                            return;
                        }
                        if (typeof this.user_data.id !== 'string' || this.user_data.id === '') {
                            logger.error(`user_data doesn't contain an id. user_data: ${this.user_data}`);
                            this._cleanup();
                            return;
                        }
                        this._signinDoneResolve();
                        this._subscribeChannels();
                    }
                    _subscribeChannels() {
                        const ensure_subscribed = (channel)=>{
                            if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                            else if (!channel.subscriptionPending && this.pusher.connection.state === 'connected') channel.subscribe();
                        };
                        this.serverToUserChannel = new Channel(`#server-to-user-${this.user_data.id}`, this.pusher);
                        this.serverToUserChannel.bind_global((eventName, data)=>{
                            if (eventName.indexOf('pusher_internal:') === 0 || eventName.indexOf('pusher:') === 0) return;
                            this.emit(eventName, data);
                        });
                        ensure_subscribed(this.serverToUserChannel);
                    }
                    _cleanup() {
                        this.user_data = null;
                        if (this.serverToUserChannel) {
                            this.serverToUserChannel.unbind_all();
                            this.serverToUserChannel.disconnect();
                            this.serverToUserChannel = null;
                        }
                        if (this.signin_requested) this._signinDoneResolve();
                    }
                    _newSigninPromiseIfNeeded() {
                        if (!this.signin_requested) return;
                        if (this.signinDonePromise && !this.signinDonePromise.done) return;
                        const { promise: promise, resolve: resolve, reject: _ } = flat_promise();
                        promise.done = false;
                        const setDone = ()=>{
                            promise.done = true;
                        };
                        promise.then(setDone).catch(setDone);
                        this.signinDonePromise = promise;
                        this._signinDoneResolve = resolve;
                    }
                }
                class Pusher {
                    static ready() {
                        Pusher.isReady = true;
                        for(var i = 0, l = Pusher.instances.length; i < l; i++)Pusher.instances[i].connect();
                    }
                    static getClientFeatures() {
                        return keys(filterObject({
                            ws: runtime.Transports.ws
                        }, function(t) {
                            return t.isSupported({});
                        }));
                    }
                    constructor(app_key, options){
                        checkAppKey(app_key);
                        validateOptions(options);
                        this.key = app_key;
                        this.options = options;
                        this.config = getConfig(this.options, this);
                        this.channels = factory.createChannels();
                        this.global_emitter = new Dispatcher();
                        this.sessionID = runtime.randomInt(1000000000);
                        this.timeline = new Timeline(this.key, this.sessionID, {
                            cluster: this.config.cluster,
                            features: Pusher.getClientFeatures(),
                            params: this.config.timelineParams || {},
                            limit: 50,
                            level: level.INFO,
                            version: defaults.VERSION
                        });
                        if (this.config.enableStats) this.timelineSender = factory.createTimelineSender(this.timeline, {
                            host: this.config.statsHost,
                            path: '/timeline/v2/' + runtime.TimelineTransport.name
                        });
                        var getStrategy = (options)=>{
                            return runtime.getDefaultStrategy(this.config, options, defineTransport);
                        };
                        this.connection = factory.createConnectionManager(this.key, {
                            getStrategy: getStrategy,
                            timeline: this.timeline,
                            activityTimeout: this.config.activityTimeout,
                            pongTimeout: this.config.pongTimeout,
                            unavailableTimeout: this.config.unavailableTimeout,
                            useTLS: Boolean(this.config.useTLS)
                        });
                        this.connection.bind('connected', ()=>{
                            this.subscribeAll();
                            if (this.timelineSender) this.timelineSender.send(this.connection.isUsingTLS());
                        });
                        this.connection.bind('message', (event)=>{
                            var eventName = event.event;
                            var internal = eventName.indexOf('pusher_internal:') === 0;
                            if (event.channel) {
                                var channel = this.channel(event.channel);
                                if (channel) channel.handleEvent(event);
                            }
                            if (!internal) this.global_emitter.emit(event.event, event.data);
                        });
                        this.connection.bind('connecting', ()=>{
                            this.channels.disconnect();
                        });
                        this.connection.bind('disconnected', ()=>{
                            this.channels.disconnect();
                        });
                        this.connection.bind('error', (err)=>{
                            logger.warn(err);
                        });
                        Pusher.instances.push(this);
                        this.timeline.info({
                            instances: Pusher.instances.length
                        });
                        this.user = new UserFacade(this);
                        if (Pusher.isReady) this.connect();
                    }
                    switchCluster(options) {
                        const { appKey: appKey, cluster: cluster } = options;
                        this.key = appKey;
                        this.options = Object.assign(Object.assign({}, this.options), {
                            cluster: cluster
                        });
                        this.config = getConfig(this.options, this);
                        this.connection.switchCluster(this.key);
                    }
                    channel(name) {
                        return this.channels.find(name);
                    }
                    allChannels() {
                        return this.channels.all();
                    }
                    connect() {
                        this.connection.connect();
                        if (this.timelineSender) {
                            if (!this.timelineSenderTimer) {
                                var usingTLS = this.connection.isUsingTLS();
                                var timelineSender = this.timelineSender;
                                this.timelineSenderTimer = new PeriodicTimer(60000, function() {
                                    timelineSender.send(usingTLS);
                                });
                            }
                        }
                    }
                    disconnect() {
                        this.connection.disconnect();
                        if (this.timelineSenderTimer) {
                            this.timelineSenderTimer.ensureAborted();
                            this.timelineSenderTimer = null;
                        }
                    }
                    bind(event_name, callback, context) {
                        this.global_emitter.bind(event_name, callback, context);
                        return this;
                    }
                    unbind(event_name, callback, context) {
                        this.global_emitter.unbind(event_name, callback, context);
                        return this;
                    }
                    bind_global(callback) {
                        this.global_emitter.bind_global(callback);
                        return this;
                    }
                    unbind_global(callback) {
                        this.global_emitter.unbind_global(callback);
                        return this;
                    }
                    unbind_all(callback) {
                        this.global_emitter.unbind_all();
                        return this;
                    }
                    subscribeAll() {
                        var channelName;
                        for(channelName in this.channels.channels)if (this.channels.channels.hasOwnProperty(channelName)) this.subscribe(channelName);
                    }
                    subscribe(channel_name) {
                        var channel = this.channels.add(channel_name, this);
                        if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                        else if (!channel.subscriptionPending && this.connection.state === 'connected') channel.subscribe();
                        return channel;
                    }
                    unsubscribe(channel_name) {
                        var channel = this.channels.find(channel_name);
                        if (channel && channel.subscriptionPending) channel.cancelSubscription();
                        else {
                            channel = this.channels.remove(channel_name);
                            if (channel && channel.subscribed) channel.unsubscribe();
                        }
                    }
                    send_event(event_name, data, channel) {
                        return this.connection.send_event(event_name, data, channel);
                    }
                    shouldUseTLS() {
                        return this.config.useTLS;
                    }
                    signin() {
                        this.user.signin();
                    }
                }
                Pusher.instances = [];
                Pusher.isReady = false;
                Pusher.logToConsole = false;
                Pusher.Runtime = runtime;
                Pusher.ScriptReceivers = runtime.ScriptReceivers;
                Pusher.DependenciesReceivers = runtime.DependenciesReceivers;
                Pusher.auth_callbacks = runtime.auth_callbacks;
                /* harmony default export */ const pusher = Pusher;
                function checkAppKey(key) {
                    if (key === null || key === undefined) throw 'You must pass your app key when you instantiate Pusher.';
                }
                runtime.setup(Pusher);
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module used 'module' so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(721);
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});




(0, (/*@__PURE__*/$parcel$interopDefault($a624709dd034fdf4$exports))).logToConsole = true;
class $99346ee488ca9570$var$ChannelServiceInternal {
    constructor(){
        this.types = {}; // { [type]: { name, channel, status, pendingName, debounceId } }
        this.pusher = new (0, (/*@__PURE__*/$parcel$interopDefault($a624709dd034fdf4$exports)))("59f509846634364760ef", {
            cluster: "us2"
        });
        this.pusher.connection.bind("state_change", (s)=>(0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("pusher state:", s));
        this.pusher.connection.bind("error", (e)=>console.warn("pusher error:", e));
        this.connect(); // meta tag bootstrap
        window.addEventListener("beforeunload", ()=>this.disconnect());
    }
    connect(channel = null) {
        const ch = typeof channel === "string" && channel.trim() || this._readChannelFromDOM();
        if (!ch) return;
        this.subscribeToChannel("stream", ch);
    }
    disconnect() {
        Object.keys(this.types).forEach((type)=>this._forceUnsubscribe(type));
        this.pusher.disconnect();
    }
    _readChannelFromDOM() {
        const el = document.querySelector('meta[name="pusher-channel"]');
        return el?.content?.trim() || null;
    }
    subscribeToChannel(type, identifier) {
        const channelName = (identifier || "").trim();
        if (!channelName) return;
        // simple debounce in case Stimulus connect fires multiple times rapidly
        clearTimeout(this.types[type]?.debounceId);
        this.types[type] = this.types[type] || {
            status: "idle"
        };
        this.types[type].debounceId = setTimeout(()=>this._subscribeCore(type, channelName), 0);
    }
    _subscribeCore(type, channelName) {
        const state = this.types[type] || {
            status: "idle"
        };
        // If already subscribed/subscribing to exactly this name → no-op
        if ((state.status === "subscribed" || state.status === "subscribing") && state.name === channelName) {
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ChannelService: already on channel", {
                type: type,
                channelName: channelName,
                status: state.status
            });
            return;
        }
        // If a subscribe is in-flight to a different name, remember the desired one and switch after
        if (state.status === "subscribing") {
            state.pendingName = channelName;
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ChannelService: queue switch after subscribe", {
                type: type,
                from: state.name,
                to: channelName
            });
            return;
        }
        // If subscribed to a different channel, cleanly unsubscribe first
        if (state.status === "subscribed" && state.name && state.name !== channelName) this._safeUnsubscribe(type);
        // Begin subscribe
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ChannelService: subscribing", {
            type: type,
            channelName: channelName
        });
        const channel = this.pusher.subscribe(channelName);
        // Update local state *before* events arrive
        this.types[type] = {
            name: channelName,
            channel: channel,
            status: "subscribing",
            pendingName: null
        };
        // Pusher lifecycle binds
        channel.bind("pusher:subscription_succeeded", ()=>{
            const curr = this.types[type];
            if (!curr || curr.name !== channelName) return; // stale
            curr.status = "subscribed";
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ChannelService: subscription_succeeded", {
                type: type,
                channelName: channelName
            });
            // If a newer request arrived while subscribing, switch now
            if (curr.pendingName && curr.pendingName !== curr.name) {
                const next = curr.pendingName;
                curr.pendingName = null;
                this._safeUnsubscribe(type, ()=>this._subscribeCore(type, next));
            }
        });
        channel.bind("pusher:subscription_error", (err)=>{
            const curr = this.types[type];
            if (curr && curr.name === channelName) curr.status = "idle";
            console.warn("ChannelService: subscription_error", {
                type: type,
                channelName: channelName,
                err: err
            });
        });
        // --- App events ---
        // Direct Turbo Stream HTML payloads
        channel.bind("html", (data)=>{
            Turbo.renderStreamMessage(data);
        });
        // Simple redirect payloads
        channel.bind("redirect", (data)=>{
            if (data?.url) window.location.href = data.url;
        });
        channel.bind("onramp_received", ()=>{
            this.fetchBottomsheet("/meld/deposit-initiated");
        });
        channel.bind("waas_funded", ()=>{
            this.fetchBottomsheet("/meld/deposit-confirmed");
        });
        channel.bind("onramp_failed", ()=>{
            this.fetchBottomsheet("/meld/deposit-failed");
        });
        // Text messages for simple refresh signals
        channel.bind("text", (data)=>{
            const message = typeof data === "string" ? data : data?.message || data?.type || "";
            if (message === "activity_updated") this.refreshActivityAndBalance();
            else if (message === "refresh_activity") {
                (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Refreshing activity page");
                window.location.reload();
            } else if (data?.type == "deposit_status_updated") {
                const swapId = data.swapId;
                this.refreshPendingDepositStatus(swapId);
            }
        });
    }
    refreshActivity() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Refreshing activity page content");
        // Make a GET request to /activity to refresh the content
        (0, $7698590c42a3bf25$export$18b31d9eba2a1098)('/activity', {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/html'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        }).then((html)=>{
            // Replace the content of the activity frame
            const activityFrame = document.querySelector('[data-controller*="transaction-history"]');
            if (activityFrame) {
                // Parse the returned HTML and extract just the activity content
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newActivityContent = doc.querySelector('[data-controller*="transaction-history"]');
                if (newActivityContent) activityFrame.innerHTML = newActivityContent.innerHTML;
                else (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Could not find activity content in returned HTML");
            } else (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Activity frame not found - user not on activity page, skipping refresh");
        }).catch((error)=>{
            (0, $c0e0e410f6c5ef5d$export$280f90b954565303)("Failed to refresh activity page:", error);
            // Fallback to full page reload
            window.location.reload();
        });
    }
    refreshActivityAndBalance() {
        return (0, $7698590c42a3bf25$export$18b31d9eba2a1098)('/activity/sync-activity-and-balance', {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/vnd.turbo-stream.html'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        }).then((turboStream)=>{
            Turbo.renderStreamMessage(turboStream);
        }).catch((error)=>{
            (0, $c0e0e410f6c5ef5d$export$280f90b954565303)("Failed to sync activity and balance:", error);
            // fallback keeps previous behavior if combined stream fails
            this.refreshActivity();
            this.syncHomeBalance();
        });
    }
    refreshHome() {
        const homeFrame = document.querySelector('.wallet-home');
        if (!homeFrame) {
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Home frame not found - user not on home page, skipping refresh");
            return Promise.resolve();
        }
        // Make a GET request to /home to refresh the content
        return (0, $7698590c42a3bf25$export$18b31d9eba2a1098)('/home', {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/html'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        }).then((html)=>{
            // Replace the content of the home frame - look for the div with wallet-home class
            // Parse the returned HTML and extract just the .wallet-home div's content
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newHomeContent = doc.querySelector('.wallet-home');
            if (newHomeContent) homeFrame.innerHTML = newHomeContent.innerHTML;
            else (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Could not find .wallet-home in returned HTML");
        }).catch((error)=>{
            (0, $c0e0e410f6c5ef5d$export$280f90b954565303)("Failed to refresh home page:", error);
            // Fallback to full page reload
            window.location.reload();
        });
    }
    syncHomeBalance() {
        const balanceEl = document.getElementById("home-balance-amount");
        if (!balanceEl) return Promise.resolve();
        return (0, $7698590c42a3bf25$export$18b31d9eba2a1098)('/home/balance', {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/vnd.turbo-stream.html'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        }).then((turboStream)=>{
            Turbo.renderStreamMessage(turboStream);
        }).catch((error)=>{
            console.error("Failed to sync home balance:", error);
        });
    }
    refreshPendingDepositStatus(swapId) {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Refreshing deposit status", {
            swapId: swapId
        });
        // Check if the target element exists before fetching
        const statusContainer = document.getElementById('deposit-status-container');
        if (!statusContainer) {
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Status container not found - user not on deposit page, skipping update");
            return;
        }
        const containerSwapId = String(statusContainer.dataset.swapId || "").trim();
        const incomingSwapId = String(swapId ?? "").trim();
        if (containerSwapId && incomingSwapId && containerSwapId !== incomingSwapId) {
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Deposit status event for a different swap - skipping", {
                containerSwapId: containerSwapId,
                incomingSwapId: incomingSwapId
            });
            return;
        }
        // Make a GET request to get the updated status turbo-stream
        (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(`/deposit/crypto/order-status/${swapId}`, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/vnd.turbo-stream.html'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        }).then((turboStream)=>{
            const current = document.getElementById('deposit-status-container');
            if (!current) {
                (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Status container removed during fetch - skipping render");
                return;
            }
            const currentSwapId = String(current.dataset.swapId || "").trim();
            if (currentSwapId && incomingSwapId && currentSwapId !== incomingSwapId) {
                (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Status container changed swap during fetch - skipping render", {
                    currentSwapId: currentSwapId,
                    incomingSwapId: incomingSwapId
                });
                return;
            }
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Rendering deposit status turbo-stream", {
                swapId: swapId
            });
            Turbo.renderStreamMessage(turboStream);
        }).catch((error)=>{
            console.error("Failed to refresh deposit status:", error);
        });
    }
    fetchBottomsheet(url) {
        return (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(url, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/vnd.turbo-stream.html'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        }).then((turboStream)=>{
            Turbo.renderStreamMessage(turboStream);
        }).catch((error)=>{
            (0, $c0e0e410f6c5ef5d$export$280f90b954565303)("Failed to fetch bottomsheet:", error);
        });
    }
    _safeUnsubscribe(type, then) {
        const state = this.types[type];
        if (!state?.channel || state.status === "unsubscribing") {
            if (then) then();
            return;
        }
        state.status = "unsubscribing";
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ChannelService: unsubscribing", {
            type: type,
            channelName: state.name
        });
        // Pusher has no explicit callback for client-initiated unsubscribe success; do local cleanup immediately.
        state.channel.unbind_all();
        this.pusher.unsubscribe(state.name);
        // Reset state
        this.types[type] = {
            status: "idle"
        };
        if (then) then();
    }
    _forceUnsubscribe(type) {
        const state = this.types[type];
        if (!state?.channel) return;
        try {
            state.channel.unbind_all();
            this.pusher.unsubscribe(state.name);
        } finally{
            this.types[type] = {
                status: "idle"
            };
        }
    }
}
// Hard singleton export
if (!window.__ChannelService) window.__ChannelService = new $99346ee488ca9570$var$ChannelServiceInternal();
var $99346ee488ca9570$export$2e2bcd8739ae039 = window.__ChannelService;


class $d07f5c1731eecae9$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        channelid: String
    };
    /* when the channel is shifted on the backend,
     the socket controller is loaded on the front-end
   to reconnect. */ connect() {
        console.log("Wallet Socket Controller Loaded");
        (0, $99346ee488ca9570$export$2e2bcd8739ae039).connect(this.channelidValue);
    }
}




class $90bb119766fab176$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "filterBttn",
        "intentRow"
    ];
    static values = {
        activeFilters: Array
    };
    connect() {
        if (!this.hasActiveFiltersValue) this.activeFiltersValue = [];
        this.observeLastRow();
    }
    disconnect() {
        this.cleanupObserver();
    }
    observeLastRow() {
        this.cleanupObserver();
        let lastRow = this.intentRowTargets[this.intentRowTargets.length - 1];
        if (!lastRow) return;
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) this.loadMore();
            });
        });
        this.observer.observe(lastRow);
    }
    cleanupObserver() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
    toggleFilter(event) {
        const filterType = event.currentTarget.dataset.filter;
        const selected = event.currentTarget.dataset.selected === "true";
        if (selected) {
            // Deselect: secondary background, primary text
            event.currentTarget.classList.remove("dark:bg-dark-primary-color", "wdark:bg-wdark-primary-color", "wlight:bg-wlight-primary-color", "dark:text-dark-primary-icon-and-text", "wdark:text-wdark-primary-icon-and-text", "wlight:text-wlight-primary-icon-and-text");
            event.currentTarget.classList.add("dark:bg-dark-secondary-color", "wdark:bg-wdark-secondary-color", "wlight:bg-wlight-secondary-color", "dark:text-dark-primary-color", "wdark:text-wdark-primary-color", "wlight:text-wlight-primary-color");
            event.currentTarget.dataset.selected = "false";
            this.activeFiltersValue = this.activeFiltersValue.filter((f)=>f !== filterType);
            this.applyFilters(filterType);
        } else {
            // Select: primary background, primary icon-and-text
            event.currentTarget.classList.remove("dark:bg-dark-secondary-color", "wdark:bg-wdark-secondary-color", "wlight:bg-wlight-secondary-color", "dark:text-dark-primary-color", "wdark:text-wdark-primary-color", "wlight:text-wlight-primary-color");
            event.currentTarget.classList.add("dark:bg-dark-primary-color", "wdark:bg-wdark-primary-color", "wlight:bg-wlight-primary-color", "dark:text-dark-primary-icon-and-text", "wdark:text-wdark-primary-icon-and-text", "wlight:text-wlight-primary-icon-and-text");
            event.currentTarget.dataset.selected = "true";
            this.activeFiltersValue = [
                ...this.activeFiltersValue,
                filterType
            ];
            this.applyFilters(filterType);
        }
    }
    async applyFilters() {
        const url = `activity/transactions/filter?type=${this.activeFiltersValue.join(",")}`;
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(url, {
            headers: {
                Accept: "text/vnd.turbo-stream.html"
            }
        });
        if (response.ok) {
            const stream = await response.text();
            Turbo.renderStreamMessage(stream);
            requestAnimationFrame(()=>{
                this.observeLastRow();
            });
        }
    }
    async loadMore() {
        const lastIntent = this.intentRowTargets[this.intentRowTargets.length - 1];
        const cursor = lastIntent?.dataset.lastModified;
        if (!cursor) return;
        const url = `activity/transactions/load?type=${this.activeFiltersValue.join(",")}&cursor=${encodeURIComponent(cursor)}&limit=5`;
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(url, {
            headers: {
                Accept: "text/vnd.turbo-stream.html"
            }
        });
        if (response.status === 204) {
            this.cleanupObserver();
            return;
        }
        if (response.ok) {
            const stream = await response.text();
            Turbo.renderStreamMessage(stream);
            this.observeLastRow();
        }
    }
}



class $35747c473823bd1b$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    connect() {
        if (this.isAndroidWebView()) this.showAlert();
    }
    isAndroidWebView() {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isAndroid = /Android/i.test(ua);
        const hasWV = /\bwv\b/.test(ua) || /\bVersion\/[\d.]+/i.test(ua);
        const isInAppBrowser = /(FBAN|FBAV|Instagram|GSA|Gmail|Line|LinkedInApp|Twitter)/i.test(ua);
        return isAndroid && (hasWV || isInAppBrowser);
    }
    showAlert() {
        const div = document.createElement("div");
        div.className = "fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4";
        div.innerHTML = `
      <div class="bg-white rounded-2xl shadow-xl p-6 max-w-sm text-center">
        <h2 class="text-lg font-semibold mb-3 text-gray-900">In-app browser detected</h2>
        <p class="text-sm text-gray-700 mb-5">
          It looks like you're viewing this page inside an app (e.g. Gmail, Instagram).
          For the best experience, please open it directly in Chrome.
        </p>
        <a href="intent://${location.host}${location.pathname}#Intent;scheme=https;package=com.android.chrome;end"
           class="inline-block px-4 py-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition-all">
          Open in Chrome
        </a>
      </div>
    `;
        document.body.appendChild(div);
    }
}



class $1fafb405e7e64de4$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        event: String
    };
    dispatch() {
        window.dispatchEvent(new CustomEvent(this.eventValue));
    }
}



class $ace2e7fb53dfa262$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "item",
        "itemsContainer"
    ];
    connect() {
        const urlParams = new URLSearchParams(window.location.search);
        const selectedToken = urlParams.get("selectedToken") || "";
        const selectedNetwork = urlParams.get("selectedNetwork") || "";
        const storageKey = `addressBook_selected_${selectedToken}_${selectedNetwork}`;
        const savedWalletAddress = sessionStorage.getItem(storageKey);
        if (this.itemTargets.length > 0) {
            // Deselect all items first
            this.itemTargets.forEach((item)=>{
                item.dataset.selected = "false";
            });
            // Try to find and select the previously selected item
            let selectedItem = null;
            if (savedWalletAddress) selectedItem = this.itemTargets.find((item)=>{
                return item.dataset.walletAddress === savedWalletAddress;
            });
            const itemToSelect = selectedItem || this.itemTargets[0];
            itemToSelect.dataset.selected = "true";
        }
    }
    select(event) {
        const item = event.currentTarget;
        this.selectItem(item);
    }
    confirm(event) {
        const item = event.currentTarget;
        this.selectItem(item);
        const walletAddress = item.dataset.walletAddress || "";
        // Set wallet address in crypto-select-asset controller via Stimulus value
        const formElement = document.querySelector('form[data-controller*="crypto-select-asset"]');
        if (formElement && walletAddress) formElement.dataset.cryptoSelectAssetSelectedWalletValue = walletAddress;
        const bottomSheetController = this.application.getControllerForElementAndIdentifier(document.getElementById("bottomsheet-container"), "bottom-sheet");
        if (bottomSheetController) bottomSheetController.close();
    }
    selectItem(item) {
        // Deselect all items
        this.itemTargets.forEach((wallet)=>{
            wallet.dataset.selected = "false";
        });
        item.dataset.selected = "true";
        const walletAddress = item.dataset.walletAddress || "";
        if (walletAddress) {
            const urlParams = new URLSearchParams(window.location.search);
            const selectedToken = urlParams.get("selectedToken") || "";
            const selectedNetwork = urlParams.get("selectedNetwork") || "";
            const storageKey = `addressBook_selected_${selectedToken}_${selectedNetwork}`;
            sessionStorage.setItem(storageKey, walletAddress);
        }
    }
}




// Longest PAN length across major card networks.
const $6ecc5c669173e081$export$8f19505322ae0679 = 19;
const $6ecc5c669173e081$var$EXPIRY_DIGITS = 4;
function $6ecc5c669173e081$export$24c77740129228db(value) {
    return (value || "").replace(/\D/g, "");
}
function $6ecc5c669173e081$var$digitCountBefore(value, caret) {
    return $6ecc5c669173e081$export$24c77740129228db((value || "").slice(0, caret)).length;
}
// Backspace or Delete that removed only a separator removes the digit next to
// it instead; otherwise reformatting puts the separator straight back.
function $6ecc5c669173e081$var$deleteAcrossSeparator(digits, before, inputType, previousDigits) {
    if (digits !== previousDigits) return {
        digits: digits,
        before: before
    };
    if (inputType === "deleteContentBackward" && before > 0) return {
        digits: digits.slice(0, before - 1) + digits.slice(before),
        before: before - 1
    };
    if (inputType === "deleteContentForward") return {
        digits: digits.slice(0, before) + digits.slice(before + 1),
        before: before
    };
    return {
        digits: digits,
        before: before
    };
}
// caretAfterDigits is the position in value just past its nth digit.
function $6ecc5c669173e081$var$caretAfterDigits(value, n) {
    if (n <= 0) return 0;
    let seen = 0;
    for(let i = 0; i < value.length; i++){
        if (/\d/.test(value[i]) && ++seen === n) return i + 1;
    }
    return value.length;
}
function $6ecc5c669173e081$export$383aa7b09afed26d(raw, caret, inputType, previousDigits = "") {
    let { digits: digits, before: before } = $6ecc5c669173e081$var$deleteAcrossSeparator($6ecc5c669173e081$export$24c77740129228db(raw), $6ecc5c669173e081$var$digitCountBefore(raw, caret), inputType, previousDigits);
    digits = digits.slice(0, $6ecc5c669173e081$export$8f19505322ae0679);
    before = Math.min(before, digits.length);
    const value = digits.replace(/(\d{4})(?=\d)/g, "$1 ");
    return {
        digits: digits,
        value: value,
        caret: $6ecc5c669173e081$var$caretAfterDigits(value, before)
    };
}
function $6ecc5c669173e081$export$ffc09ea413dfb02c(raw, caret, inputType, previousDigits = "") {
    let all = $6ecc5c669173e081$export$24c77740129228db(raw);
    if (all.length === 6) all = all.slice(0, 2) + all.slice(4);
    let { digits: digits, before: before } = $6ecc5c669173e081$var$deleteAcrossSeparator(all, $6ecc5c669173e081$var$digitCountBefore(raw, caret), inputType, previousDigits);
    digits = digits.slice(0, $6ecc5c669173e081$var$EXPIRY_DIGITS);
    before = Math.min(before, digits.length);
    const deleting = (inputType || "").startsWith("delete");
    let value = digits;
    if (digits.length > 2) value = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    else if (digits.length === 2 && !deleting) value = `${digits}/`;
    const atMonthEnd = before === 2 && digits.length === 2;
    return {
        digits: digits,
        value: value,
        caret: atMonthEnd ? value.length : $6ecc5c669173e081$var$caretAfterDigits(value, before)
    };
}
function $6ecc5c669173e081$export$7b80ac6c94b77e35(digits) {
    const expected = /^3[47]/.test(digits) ? 15 : 16;
    return digits.length === expected || digits.length === $6ecc5c669173e081$export$8f19505322ae0679;
}
function $6ecc5c669173e081$export$ec3ab71e3ddf8182(digits) {
    if (!/^\d+$/.test(digits)) return false;
    let sum = 0;
    let double = false;
    for(let i = digits.length - 1; i >= 0; i--){
        let d = Number(digits[i]);
        if (double) {
            d *= 2;
            if (d > 9) d -= 9;
        }
        sum += d;
        double = !double;
    }
    return sum % 10 === 0;
}
function $6ecc5c669173e081$export$b61f28319e603000(digits, now = new Date()) {
    if (digits.length < $6ecc5c669173e081$var$EXPIRY_DIGITS) return "incomplete";
    const month = Number(digits.slice(0, 2));
    const year = 2000 + Number(digits.slice(2, 4));
    if (month < 1 || month > 12) return "invalid";
    const currentMonths = now.getFullYear() * 12 + now.getMonth();
    if (year * 12 + month - 1 < currentMonths) return "expired";
    return "valid";
}


// The card check is advisory: past this, Save stops waiting for its answer.
const $223db6323b609d34$var$CHECK_TIMEOUT_MS = 10000;
class $223db6323b609d34$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "cardNumberInput",
        "nameInput",
        "expInput",
        "cardNumberPreview",
        "namePreview",
        "expPreview",
        "cardNumberError",
        "expError",
        "saveButton"
    ];
    static values = {
        checkUrl: String,
        csrfToken: String,
        invalidNumberMessage: String,
        invalidExpiryMessage: String,
        expiredMessage: String
    };
    connect() {
        // A restored page keeps what was typed, so the fields are the source of truth.
        this.cardDigits = (0, $6ecc5c669173e081$export$24c77740129228db)(this.cardNumberInputTarget.value);
        this.expDigits = (0, $6ecc5c669173e081$export$24c77740129228db)(this.expInputTarget.value);
        this.checkedDigits = "";
        this.checkState = "idle";
        this.checkCardNumber(this.cardDigits);
        this.showExpiryError(this.expDigits);
        this.updateSaveButton();
    }
    disconnect() {
        this.abortCheck();
    }
    onCardNumberInput(event) {
        const input = this.cardNumberInputTarget;
        const result = (0, $6ecc5c669173e081$export$383aa7b09afed26d)(input.value, $223db6323b609d34$var$caretOf(input), event?.inputType, this.cardDigits);
        this.cardDigits = result.digits;
        $223db6323b609d34$var$applyFormatted(input, result);
        if (this.hasCardNumberPreviewTarget) {
            // Preview shows only the first 4 typed digits; remaining groups stay masked
            // to match the Add Card Figma spec ("4821 •••• •••• ••••").
            const first4 = result.digits.slice(0, 4).padEnd(4, "\u2022");
            this.cardNumberPreviewTarget.textContent = `${first4} \u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022}`;
        }
        this.checkCardNumber(result.digits);
        this.updateSaveButton();
    }
    onNameInput() {
        if (this.hasNamePreviewTarget) {
            const name = (this.nameInputTarget.value || "").trim().toUpperCase();
            this.namePreviewTarget.textContent = name || "FULL NAME";
        }
        this.updateSaveButton();
    }
    onExpInput(event) {
        const input = this.expInputTarget;
        const result = (0, $6ecc5c669173e081$export$ffc09ea413dfb02c)(input.value, $223db6323b609d34$var$caretOf(input), event?.inputType, this.expDigits);
        this.expDigits = result.digits;
        $223db6323b609d34$var$applyFormatted(input, result);
        if (this.hasExpPreviewTarget) {
            const mm = result.digits.slice(0, 2).padEnd(2, "M");
            const yy = result.digits.slice(2, 4).padEnd(2, "Y");
            this.expPreviewTarget.textContent = `${mm}/${yy}`;
        }
        this.showExpiryError(result.digits);
        this.updateSaveButton();
    }
    // guardSubmit backs up the disabled button: the form never leaves the page
    // until every check has passed.
    guardSubmit(event) {
        if (!this.isFormValid()) event.preventDefault();
    }
    isFormValid() {
        return this.isCardNumberValid() && this.nameInputTarget.value.trim() !== "" && (0, $6ecc5c669173e081$export$b61f28319e603000)(this.expDigits) === "valid";
    }
    // A complete number is held back only while the check is running or after it
    // refused the card. A check that could not answer leaves the decision to Save.
    isCardNumberValid() {
        return (0, $6ecc5c669173e081$export$7b80ac6c94b77e35)(this.cardDigits) && this.checkState !== "pending" && this.checkState !== "rejected";
    }
    updateSaveButton() {
        if (!this.hasSaveButtonTarget) return;
        this.saveButtonTarget.disabled = !this.isFormValid();
    }
    // checkCardNumber runs the card check once the number is complete, so a card
    // we refuse is flagged before the rest of the form is filled. Save checks again.
    checkCardNumber(digits) {
        if (digits === this.checkedDigits) return;
        this.abortCheck();
        this.checkedDigits = digits;
        this.checkState = "idle";
        this.showCardNumberError("");
        if (!(0, $6ecc5c669173e081$export$7b80ac6c94b77e35)(digits)) return;
        if (!(0, $6ecc5c669173e081$export$ec3ab71e3ddf8182)(digits)) {
            this.settleCheck("rejected", this.invalidNumberMessageValue);
            return;
        }
        if (this.hasCheckUrlValue) this.runCheck(digits);
    }
    runCheck(digits) {
        this.checkState = "pending";
        const abort = new AbortController();
        this.checkAbort = abort;
        this.checkTimer = setTimeout(()=>this.settleCheck("unavailable"), $223db6323b609d34$var$CHECK_TIMEOUT_MS);
        (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(this.checkUrlValue, {
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            body: new URLSearchParams({
                card_number: digits,
                csrf_token: this.csrfTokenValue
            }),
            signal: abort.signal
        }).then((response)=>{
            const isJSON = (response.headers.get("Content-Type") || "").includes("application/json");
            return response.ok && isJSON ? response.json() : null;
        }).then((result)=>{
            if (abort.signal.aborted) return;
            if (result?.rejected) this.settleCheck("rejected", result.message);
            else this.settleCheck(result ? "passed" : "unavailable");
        }).catch(()=>{
            // Advisory only: when the check cannot answer, Save decides.
            if (!abort.signal.aborted) this.settleCheck("unavailable");
        });
    }
    // settleCheck records the verdict and stops whatever is still waiting on it.
    settleCheck(state, message = "") {
        this.abortCheck();
        this.checkState = state;
        if (message) this.showCardNumberError(message);
        this.updateSaveButton();
    }
    abortCheck() {
        clearTimeout(this.checkTimer);
        this.checkAbort?.abort();
        this.checkAbort = null;
    }
    showCardNumberError(message) {
        $223db6323b609d34$var$showFieldError(this.cardNumberInputTarget, this.hasCardNumberErrorTarget ? this.cardNumberErrorTarget : null, message);
    }
    showExpiryError(digits) {
        const status = (0, $6ecc5c669173e081$export$b61f28319e603000)(digits);
        let message = "";
        if (status === "invalid") message = this.invalidExpiryMessageValue;
        if (status === "expired") message = this.expiredMessageValue;
        $223db6323b609d34$var$showFieldError(this.expInputTarget, this.hasExpErrorTarget ? this.expErrorTarget : null, message);
    }
}
function $223db6323b609d34$var$caretOf(input) {
    return input.selectionStart ?? input.value.length;
}
function $223db6323b609d34$var$applyFormatted(input, { value: value, caret: caret }) {
    if (input.value === value) return;
    input.value = value;
    if (document.activeElement === input) input.setSelectionRange(caret, caret);
}
function $223db6323b609d34$var$showFieldError(input, errorEl, message) {
    input.setAttribute("aria-invalid", message ? "true" : "false");
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.classList.toggle("hidden", !message);
}



class $de9e13b2e36389b4$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "amount",
        "pill"
    ];
    static values = {
        max: Number
    };
    connect() {
        this._onInput = ()=>this.syncPills();
        if (this.hasAmountTarget) this.amountTarget.addEventListener("input", this._onInput);
        this.syncPills();
    }
    disconnect() {
        if (this.hasAmountTarget && this._onInput) this.amountTarget.removeEventListener("input", this._onInput);
    }
    // setPreset fills the input from a pill's data-amount.
    setPreset(event) {
        event.preventDefault();
        const amount = Number.parseFloat(event.currentTarget.dataset.amount);
        if (!Number.isNaN(amount)) this.setAmount(amount);
    }
    // setMax fills the input with the maximum collectable amount.
    setMax(event) {
        event.preventDefault();
        this.setAmount(this.hasMaxValue ? this.maxValue : 0);
    }
    setAmount(amount) {
        if (!this.hasAmountTarget) return;
        const capped = this.hasMaxValue ? Math.min(amount, this.maxValue) : amount;
        this.amountTarget.value = capped.toFixed(2);
        // Let money/max-amount controllers react (autosize, cap, validation).
        this.amountTarget.dispatchEvent(new Event("input", {
            bubbles: true
        }));
        this.syncPills();
    }
    // syncPills toggles the selected style on the pill matching the current amount.
    syncPills() {
        const amt = this.hasAmountTarget ? Number.parseFloat(this.amountTarget.value) || 0 : 0;
        this.pillTargets.forEach((pill)=>{
            const isMax = pill.dataset.pillMax !== undefined;
            const val = isMax ? this.hasMaxValue ? this.maxValue : NaN : Number.parseFloat(pill.dataset.amount);
            const active = !Number.isNaN(val) && Math.abs(val - amt) < 0.005;
            pill.classList.toggle("cash-pill-active", active);
        });
    }
}



var $b30e2eb3b270edb4$exports = {};
"use strict";
Object.defineProperty($b30e2eb3b270edb4$exports, "__esModule", {
    value: true
});
$b30e2eb3b270edb4$exports.WebAuthnSigner = $b30e2eb3b270edb4$exports.BrowserKeySigner = void 0;
var $931a2127c702ad79$exports = {};
"use strict";
Object.defineProperty($931a2127c702ad79$exports, "__esModule", {
    value: true
});
$931a2127c702ad79$exports.BrowserKeySigner = void 0;
var $fbb1598b194338be$exports = {};
"use strict";
var $fbb1598b194338be$var$__createBinding = $fbb1598b194338be$exports && $fbb1598b194338be$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fbb1598b194338be$var$__exportStar = $fbb1598b194338be$exports && $fbb1598b194338be$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fbb1598b194338be$var$__createBinding(exports1, m, p);
};
Object.defineProperty($fbb1598b194338be$exports, "__esModule", {
    value: true
});

$fbb1598b194338be$var$__exportStar((parcelRequire("kkC0S")), $fbb1598b194338be$exports);

$fbb1598b194338be$var$__exportStar((parcelRequire("7NNEI")), $fbb1598b194338be$exports);

$fbb1598b194338be$var$__exportStar((parcelRequire("g9Bvu")), $fbb1598b194338be$exports);

$fbb1598b194338be$var$__exportStar((parcelRequire("jkgHv")), $fbb1598b194338be$exports);

$fbb1598b194338be$var$__exportStar((parcelRequire("gSZ2x")), $fbb1598b194338be$exports);

$fbb1598b194338be$var$__exportStar((parcelRequire("i3JNf")), $fbb1598b194338be$exports);

$fbb1598b194338be$var$__exportStar((parcelRequire("bQsdO")), $fbb1598b194338be$exports);


var $8994280c22990d52$exports = {};
"use strict";
var $8994280c22990d52$var$__createBinding = $8994280c22990d52$exports && $8994280c22990d52$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8994280c22990d52$var$__exportStar = $8994280c22990d52$exports && $8994280c22990d52$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8994280c22990d52$var$__createBinding(exports1, m, p);
};
Object.defineProperty($8994280c22990d52$exports, "__esModule", {
    value: true
});
$8994280c22990d52$exports.generateRandom = void 0;

$8994280c22990d52$var$__exportStar((parcelRequire("b3jWV")), $8994280c22990d52$exports);

$8994280c22990d52$var$__exportStar((parcelRequire("8nnYL")), $8994280c22990d52$exports);

$8994280c22990d52$var$__exportStar((parcelRequire("6GiKw")), $8994280c22990d52$exports);

$8994280c22990d52$var$__exportStar((parcelRequire("cZ5A6")), $8994280c22990d52$exports);

$8994280c22990d52$var$__exportStar((parcelRequire("iAroj")), $8994280c22990d52$exports);

$8994280c22990d52$var$__exportStar((parcelRequire("g7vJF")), $8994280c22990d52$exports);
const $8994280c22990d52$var$generateRandom = (size)=>{
    const buffer = new Uint8Array(size);
    for(let i = 0; i < size; i++)buffer[i] = Math.floor(Math.random() * 256);
    return buffer;
};
$8994280c22990d52$exports.generateRandom = $8994280c22990d52$var$generateRandom;



var $B0S8N = parcelRequire("B0S8N");
class $931a2127c702ad79$var$BrowserKeySigner {
    constructor(options){
        this.options = options;
    }
    async create(challenge) {
        let credId = this.options.credId;
        if (credId === undefined || credId === '') {
            credId = (0, $8994280c22990d52$exports.toBase64Url)($B0S8N.Buffer.from((0, $8994280c22990d52$exports.generateRandom)(32)));
            this.options.credId = credId;
        }
        const publicKeyPem = await (0, $8994280c22990d52$exports.exportPublicKeyInPemFormatBrowser)(this.options.keyPair);
        const clientData = JSON.stringify({
            type: 'key.create',
            challenge: challenge.challenge
        });
        const clientDataHash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(clientData));
        const clientDataHashHex = (0, $8994280c22990d52$exports.toHex)(clientDataHash);
        const credInfoFingerprint = JSON.stringify({
            clientDataHash: clientDataHashHex,
            publicKey: publicKeyPem
        });
        let rawSignature;
        const algorithm = this.options.keyPair.privateKey.algorithm.name;
        if (algorithm == 'ECDSA') rawSignature = await crypto.subtle.sign({
            name: 'ECDSA',
            hash: {
                name: 'SHA-256'
            }
        }, this.options.keyPair.privateKey, new TextEncoder().encode(credInfoFingerprint));
        else throw new $fbb1598b194338be$exports.DfnsError(-1, `${algorithm} is not supported`);
        const signature = (0, $8994280c22990d52$exports.rawSignatureToAns1)(new Uint8Array(rawSignature));
        const attestationData = JSON.stringify({
            publicKey: publicKeyPem,
            signature: (0, $8994280c22990d52$exports.toHex)(signature.buffer)
        });
        return {
            credentialKind: 'Key',
            credentialInfo: {
                credId: credId,
                clientData: (0, $8994280c22990d52$exports.toBase64Url)(clientData),
                attestationData: (0, $8994280c22990d52$exports.toBase64Url)(attestationData)
            }
        };
    }
    async sign(challenge) {
        const credId = this.options.credId;
        if (credId === undefined || credId === '') throw new $fbb1598b194338be$exports.DfnsError(-1, 'credId is needed to sign');
        const allowedCredId = challenge.allowCredentials.key.map((cred)=>cred.id);
        if (!allowedCredId.includes(credId)) throw new $fbb1598b194338be$exports.DfnsError(-1, `${credId} does not match allowed credentials: ${allowedCredId}`);
        const clientData = JSON.stringify({
            type: 'key.get',
            challenge: challenge.challenge
        });
        let rawSignature;
        const algorithm = this.options.keyPair.privateKey.algorithm.name;
        if (algorithm == 'ECDSA') rawSignature = await crypto.subtle.sign({
            name: 'ECDSA',
            hash: {
                name: 'SHA-256'
            }
        }, this.options.keyPair.privateKey, new TextEncoder().encode(clientData));
        else throw new $fbb1598b194338be$exports.DfnsError(-1, `${algorithm} is not supported`);
        const signature = (0, $8994280c22990d52$exports.rawSignatureToAns1)(new Uint8Array(rawSignature));
        return {
            kind: 'Key',
            credentialAssertion: {
                credId: this.options.credId ?? '',
                clientData: (0, $8994280c22990d52$exports.toBase64Url)(clientData),
                signature: (0, $8994280c22990d52$exports.toBase64Url)($B0S8N.Buffer.from(signature))
            }
        };
    }
}
$931a2127c702ad79$exports.BrowserKeySigner = $931a2127c702ad79$var$BrowserKeySigner;


Object.defineProperty($b30e2eb3b270edb4$exports, "BrowserKeySigner", {
    enumerable: true,
    get: function() {
        return $931a2127c702ad79$exports.BrowserKeySigner;
    }
});
var $35b5d84273cea126$exports = {};
"use strict";
Object.defineProperty($35b5d84273cea126$exports, "__esModule", {
    value: true
});
$35b5d84273cea126$exports.WebAuthnSigner = $35b5d84273cea126$exports.DEFAULT_WAIT_TIMEOUT = void 0;



var $B0S8N = parcelRequire("B0S8N");
$35b5d84273cea126$exports.DEFAULT_WAIT_TIMEOUT = 60000;
class $35b5d84273cea126$var$WebAuthnSigner {
    constructor(conf){
        this.conf = conf;
        if (!this.conf?.relyingParty?.id || !this.conf?.relyingParty?.name) throw new $fbb1598b194338be$exports.DfnsError(-1, `Relying party ID and name must be specified in the WebauthnSigner initializer`);
    }
    async sign(challenge) {
        const response = await navigator.credentials.get({
            publicKey: {
                challenge: $B0S8N.Buffer.from(challenge.challenge),
                allowCredentials: challenge.allowCredentials.webauthn.map(({ id: id, type: type })=>({
                        id: (0, $8994280c22990d52$exports.fromBase64Url)(id).buffer,
                        type: type
                    })),
                rpId: this.conf.relyingParty.id,
                userVerification: challenge.userVerification,
                timeout: this.conf.timeout ?? $35b5d84273cea126$exports.DEFAULT_WAIT_TIMEOUT
            }
        });
        if (response === null) throw new $fbb1598b194338be$exports.DfnsError(-1, 'Failed to sign with WebAuthn credential');
        const credential = response;
        const assertion = credential.response;
        return {
            kind: 'Fido2',
            credentialAssertion: {
                credId: credential.id,
                clientData: (0, $8994280c22990d52$exports.toBase64Url)($B0S8N.Buffer.from(assertion.clientDataJSON)),
                authenticatorData: (0, $8994280c22990d52$exports.toBase64Url)($B0S8N.Buffer.from(assertion.authenticatorData)),
                signature: (0, $8994280c22990d52$exports.toBase64Url)($B0S8N.Buffer.from(assertion.signature)),
                userHandle: assertion.userHandle ? (0, $8994280c22990d52$exports.toBase64Url)($B0S8N.Buffer.from(assertion.userHandle)) : undefined
            }
        };
    }
    async create(challenge) {
        const options = {
            publicKey: {
                challenge: $B0S8N.Buffer.from(challenge.challenge),
                pubKeyCredParams: challenge.pubKeyCredParams,
                rp: this.conf.relyingParty,
                user: {
                    displayName: challenge.user.displayName,
                    id: $B0S8N.Buffer.from(challenge.user.id),
                    name: challenge.user.name
                },
                attestation: challenge.attestation,
                excludeCredentials: challenge.excludeCredentials.map(({ id: id, type: type })=>({
                        id: (0, $8994280c22990d52$exports.fromBase64Url)(id).buffer,
                        type: type
                    })),
                authenticatorSelection: challenge.authenticatorSelection,
                timeout: this.conf.timeout ?? $35b5d84273cea126$exports.DEFAULT_WAIT_TIMEOUT
            }
        };
        const response = await navigator.credentials.create(options);
        if (response === null) throw new $fbb1598b194338be$exports.DfnsError(-1, `Failed to create and sign with WebAuthn credential`);
        const credential = response;
        const attestation = credential.response;
        return {
            credentialKind: 'Fido2',
            credentialInfo: {
                credId: credential.id,
                attestationData: (0, $8994280c22990d52$exports.toBase64Url)($B0S8N.Buffer.from(attestation.attestationObject)),
                clientData: (0, $8994280c22990d52$exports.toBase64Url)($B0S8N.Buffer.from(attestation.clientDataJSON))
            }
        };
    }
}
$35b5d84273cea126$exports.WebAuthnSigner = $35b5d84273cea126$var$WebAuthnSigner;


Object.defineProperty($b30e2eb3b270edb4$exports, "WebAuthnSigner", {
    enumerable: true,
    get: function() {
        return $35b5d84273cea126$exports.WebAuthnSigner;
    }
});


function $e4096da1729505e0$export$2e2bcd8739ae039(msg, variant) {
    const stack = document.getElementById("toasts") || this.element.querySelector("#toasts");
    if (!stack) return console.warn(msg);
    const el = document.createElement("div");
    el.className = "text-sm rounded-md px-3 py-2 shadow";
    el.style.backgroundColor = variant === "success" ? "#16a34a" : variant === "info" ? "#3b82f6" : "#dc2626";
    el.style.color = "white";
    el.textContent = msg;
    stack.appendChild(el);
    setTimeout(()=>el.remove(), 4000);
}


// Error code -> translation key for the wallet app (COI-779, ADR-0032).
//
// Every code here has copy in internal/waas/locales/{en,es}.toml under
// [errors]; the Go test in pkg/errors/errori18n holds the two languages to the
// same key set. A code that is absent renders the canonical message the server
// sent — that is the documented fallback, not a gap.
// Client-side resolution of a coded API error into display copy (COI-779,
// ADR-0032).
//
// The server answers every migrated route with
//   {"error": {"code", "message", "details", "request_id"}}
// and one canonical English message — i18n is client-side only. Each app
// declares which codes it renders itself, as a code -> translation key map,
// and the page carries a dictionary of translation key -> localised message
// for the request's language (rendered by pkg/errors/errori18n into a
// <script type="application/json" id="error-translations"> element).
//
// The fallback chain is deliberate and shallow:
//   1. the app maps the code AND the page localises that key -> localised copy
//   2. otherwise the server's message -> always correct, just not localised
//   3. otherwise the caller's fallback
//
// Step 2 is what makes a newly added server code safe: it renders the server's
// wording until the frontend is taught about it, instead of rendering nothing.
const $21deb36bd749443d$export$54cb9b7052b28d2a = "error-translations";
const $21deb36bd749443d$export$711117ad6ad27992 = "errors.";
function $21deb36bd749443d$export$ece3124d05bff402(code) {
    if (!code || typeof code !== "string") return "";
    return $21deb36bd749443d$export$711117ad6ad27992 + code.toLowerCase();
}
let $21deb36bd749443d$var$cachedTranslations = null;
function $21deb36bd749443d$export$db2e52950db3187d(doc) {
    const target = doc || (typeof document === "undefined" ? null : document);
    if (!target) return {};
    if (!doc && $21deb36bd749443d$var$cachedTranslations) return $21deb36bd749443d$var$cachedTranslations;
    let parsed = {};
    const element = target.getElementById($21deb36bd749443d$export$54cb9b7052b28d2a);
    if (element && element.textContent) try {
        const candidate = JSON.parse(element.textContent);
        if (candidate && typeof candidate === "object") parsed = candidate;
    } catch  {
        // A malformed dictionary must not break error rendering — that would
        // swallow the error the customer is being told about.
        parsed = {};
    }
    if (!doc) $21deb36bd749443d$var$cachedTranslations = parsed;
    return parsed;
}
function $21deb36bd749443d$export$7f667c364d89276d() {
    $21deb36bd749443d$var$cachedTranslations = null;
}
function $21deb36bd749443d$export$aaf161f05ffb8bad(source) {
    if (!source || typeof source !== "object") return null;
    const body = source.error;
    if (body && typeof body === "object") return {
        code: body.code || "",
        message: body.message || "",
        details: body.details || null,
        requestId: body.request_id || ""
    };
    // An Error carrying the envelope fields, or a legacy body: {"message": …} /
    // {"error": "…"}.
    return {
        code: source.code || "",
        message: source.message || (typeof body === "string" ? body : ""),
        details: source.details || null,
        requestId: source.requestId || source.request_id || ""
    };
}
function $21deb36bd749443d$export$cfbc26ba8078f2d1(source, { keys: keys = {}, fallback: fallback = "", translations: translations } = {}) {
    const envelope = $21deb36bd749443d$export$aaf161f05ffb8bad(source);
    if (!envelope) return fallback;
    const key = keys[envelope.code];
    if (key) {
        const dictionary = translations || $21deb36bd749443d$export$db2e52950db3187d();
        const localised = dictionary[key];
        if (localised) return localised;
    }
    return envelope.message || fallback;
}
function $21deb36bd749443d$export$e50f9ae597e1ea02(keys) {
    return function translateError(source, fallback = "") {
        return $21deb36bd749443d$export$cfbc26ba8078f2d1(source, {
            keys: keys,
            fallback: fallback
        });
    };
}


const $7fd6c3b3bdbaa3c1$export$14847bd804e4fed5 = {
    AUTH_ACCOUNT_UNAVAILABLE: "errors.auth_account_unavailable",
    AUTH_EMAIL_NOT_RECOGNIZED: "errors.auth_email_not_recognized",
    AUTH_FORBIDDEN: "errors.auth_forbidden",
    AUTH_INVALID_TOKEN: "errors.auth_invalid_token",
    AUTH_OTP_EXPIRED: "errors.auth_otp_expired",
    AUTH_OTP_INVALID: "errors.auth_otp_invalid",
    AUTH_OTP_LOCKED: "errors.auth_otp_locked",
    AUTH_OTP_SEND_FAILED: "errors.auth_otp_send_failed",
    AUTH_PASSKEY_CANCELLED: "errors.auth_passkey_cancelled",
    AUTH_SESSION_EXPIRED: "errors.auth_session_expired",
    AUTH_UNAUTHENTICATED: "errors.auth_unauthenticated",
    INTERNAL: "errors.internal",
    PAYMENT_ALREADY_COMPLETED: "errors.payment_already_completed",
    PAYMENT_BALANCE_UNAVAILABLE: "errors.payment_balance_unavailable",
    PAYMENT_DECLINED_IN_WALLET: "errors.payment_declined_in_wallet",
    PAYMENT_DEPOSIT_ADDRESS_EXPIRED: "errors.payment_deposit_address_expired",
    PAYMENT_DEPOSIT_SETUP_FAILED: "errors.payment_deposit_setup_failed",
    PAYMENT_DEPOSIT_SHORT: "errors.payment_deposit_short",
    PAYMENT_FAILED: "errors.payment_failed",
    PAYMENT_IDEMPOTENCY_CONFLICT: "errors.payment_idempotency_conflict",
    PAYMENT_INSUFFICIENT_BALANCE: "errors.payment_insufficient_balance",
    PAYMENT_INVALID_AMOUNT: "errors.payment_invalid_amount",
    PAYMENT_METHOD_UNAVAILABLE: "errors.payment_method_unavailable",
    PAYMENT_NOT_FOUND: "errors.payment_not_found",
    PAYMENT_NOT_PERMITTED: "errors.payment_not_permitted",
    PAYMENT_PENDING: "errors.payment_pending",
    PAYMENT_PRICING_UNAVAILABLE: "errors.payment_pricing_unavailable",
    PAYMENT_REVERTED_ON_CHAIN: "errors.payment_reverted_on_chain",
    PAYMENT_STATUS_UNCONFIRMED: "errors.payment_status_unconfirmed",
    PAYMENT_UNSUPPORTED_NETWORK: "errors.payment_unsupported_network",
    REQUEST_RATE_LIMITED: "errors.request_rate_limited",
    RESOURCE_CONFLICT: "errors.resource_conflict",
    RESOURCE_NOT_FOUND: "errors.resource_not_found",
    RPC_INVALID_RESPONSE: "errors.rpc_invalid_response",
    RPC_RATE_LIMITED: "errors.rpc_rate_limited",
    RPC_TIMEOUT: "errors.rpc_timeout",
    RPC_UNAVAILABLE: "errors.rpc_unavailable",
    SIGNER_CHALLENGE_EXPIRED: "errors.signer_challenge_expired",
    SIGNER_NONCE_CONFLICT: "errors.signer_nonce_conflict",
    SIGNER_OUT_OF_GAS: "errors.signer_out_of_gas",
    SIGNER_REJECTED: "errors.signer_rejected",
    SIGNER_TIMEOUT: "errors.signer_timeout",
    SIGNER_UNAVAILABLE: "errors.signer_unavailable",
    SIGNER_UNDERPRICED: "errors.signer_underpriced",
    SIGNER_WALLET_SETUP_FAILED: "errors.signer_wallet_setup_failed",
    UPSTREAM_INVALID_RESPONSE: "errors.upstream_invalid_response",
    UPSTREAM_TIMEOUT: "errors.upstream_timeout",
    UPSTREAM_UNAVAILABLE: "errors.upstream_unavailable",
    VALIDATION_INVALID_EMAIL: "errors.validation_invalid_email",
    VALIDATION_INVALID_FIELD: "errors.validation_invalid_field",
    VALIDATION_INVALID_REQUEST: "errors.validation_invalid_request",
    VALIDATION_REQUIRED_FIELD: "errors.validation_required_field"
};
const $7fd6c3b3bdbaa3c1$export$dbb77d813a78f040 = (0, $21deb36bd749443d$export$e50f9ae597e1ea02)($7fd6c3b3bdbaa3c1$export$14847bd804e4fed5);


function $b8614c1cf7554158$export$85575c1a77628ede(error) {
    if (!error) return "";
    // A catalog code already has approved, localisable copy — prefer it over
    // the WebAuthn heuristics below (COI-779, ADR-0032). The map lookup is what
    // makes this safe: error.code is also where EIP-1193 puts its numeric
    // rejection codes, and those must still fall through to the heuristics.
    if ((0, $7fd6c3b3bdbaa3c1$export$14847bd804e4fed5)[error.code]) {
        const coded = (0, $7fd6c3b3bdbaa3c1$export$dbb77d813a78f040)(error, "");
        if (coded) return coded;
    }
    const errorMessage = error.message || error.toString();
    const errorName = error.name || '';
    // Handle specific WebAuthn errors
    if (errorName === 'NotAllowedError' || errorMessage.includes('NotAllowedError')) return "Authentication was cancelled or failed.";
    if (errorName === 'AbortError' || errorMessage.includes('AbortError')) return "Authentication was cancelled.";
    if (errorName === 'TimeoutError' || errorMessage.includes('TimeoutError')) return "Authentication timed out.";
    if (errorName === 'NotSupportedError' || errorMessage.includes('NotSupportedError')) return "Authentication is not supported on this device.";
    if (errorName === 'SecurityError' || errorMessage.includes('SecurityError')) {
        if (errorMessage.includes('relying party ID') || errorMessage.includes('registrable domain')) return "Something wen't wrong. Please contact support.";
        return "Something wen't wrong. Please contact support.";
    }
    if (errorName === 'InvalidStateError' || errorMessage.includes('InvalidStateError')) return "Something wen't wrong. Please contact support.";
    // If it's a user-friendly message already, return it as is
    return errorMessage;
}




async function $76e753e031c74aeb$export$ea607f18896190ac(response, fallbackErrorMessage) {
    const contentType = response.headers.get("Content-Type") || "";
    // PRIORITY 1: Turbo-stream (renderToast from backend)
    if (contentType.includes("turbo-stream")) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
        // If response is not ok, backend already displayed the toast
        // Throw special marker error so caller knows not to show another toast
        if (!response.ok) throw new Error("backend-error");
        return {
            success: true,
            type: "toast"
        };
    }
    // PRIORITY 2: Redirect
    if (response.redirected || response.status === 302 || response.status === 303) {
        window.location.href = response.url;
        return {
            success: true,
            type: "redirect"
        };
    }
    // PRIORITY 3: JSON response
    if (contentType.includes("application/json")) {
        if (!response.ok) {
            // Migrated routes answer the coded envelope (COI-779); translateError
            // renders its localised copy, falls back to the server's message for a
            // code this app has no key for, and to fallbackErrorMessage for a legacy
            // body that carries neither.
            const errorData = await response.json().catch(()=>null);
            const error = new Error((0, $7fd6c3b3bdbaa3c1$export$dbb77d813a78f040)(errorData, fallbackErrorMessage));
            const envelope = (0, $21deb36bd749443d$export$aaf161f05ffb8bad)(errorData);
            if (envelope) {
                error.code = envelope.code;
                error.requestId = envelope.requestId;
            }
            throw error;
        }
        const data = await response.json();
        return data;
    }
    // PRIORITY 4: HTML response
    if (contentType.includes("text/html")) {
        const html = await response.text();
        // Update content frame if present (for dynamic page updates)
        const contentFrame = document.getElementById("content");
        if (contentFrame) contentFrame.innerHTML = html;
        return {
            success: true,
            type: "html",
            html: html
        };
    }
    // FALLBACK: Unexpected response or server error
    if (!response.ok) throw new Error(fallbackErrorMessage);
    return {
        success: true
    };
}



class $482fa7740b66b7fb$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        domain: String,
        company: {
            type: String,
            default: "CoinSub Wallet"
        },
        csrfToken: String,
        idempotencyKey: String,
        payload: Object
    };
    static targets = [
        "confirmButton",
        "spinner"
    ];
    connect() {
        this.isProcessing = false;
    }
    async approve(event) {
        event.preventDefault();
        if (this.isProcessing) return;
        this.isProcessing = true;
        this.showSpinner();
        try {
            const { challenge: challenge } = await this.requestChallenge();
            const signedChallenge = await this.signChallenge(challenge);
            await this.submitApproval(signedChallenge);
        // On success the backend rendered the "ready" Turbo Stream; nothing else to do.
        } catch (error) {
            if (error.message !== "backend-error") {
                if (error.name === "TypeError" || error.message?.includes("fetch")) (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Unable to connect to server.", "error");
                else (0, $e4096da1729505e0$export$2e2bcd8739ae039)((0, $b8614c1cf7554158$export$85575c1a77628ede)(error), "error");
            }
            this.isProcessing = false;
            this.hideSpinner();
        }
    }
    async requestChallenge() {
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)("/withdraw/cash/passkey/request", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "X-CSRF-Token": this.csrfTokenValue
            },
            credentials: "same-origin"
        });
        return (0, $76e753e031c74aeb$export$ea607f18896190ac)(response, "Failed to start passkey approval.");
    }
    async signChallenge(challengeData) {
        const relyingPartyId = this.domainValue || window.location.hostname;
        const webauthn = new (0, $b30e2eb3b270edb4$exports.WebAuthnSigner)({
            relyingParty: {
                id: relyingPartyId,
                name: this.companyValue
            }
        });
        try {
            const assertion = await webauthn.sign(challengeData);
            const credentialAssertion = assertion.credentialAssertion || {};
            return {
                challengeIdentifier: challengeData.challengeIdentifier,
                signature: {
                    kind: assertion.kind,
                    credentialAssertion: {
                        credId: credentialAssertion.credId || "",
                        clientData: credentialAssertion.clientData || "",
                        signature: credentialAssertion.signature || "",
                        authenticatorData: credentialAssertion.authenticatorData || "",
                        userHandle: credentialAssertion.userHandle || ""
                    }
                }
            };
        } catch (error) {
            if (error.name === "InvalidStateError" || error.message?.includes("pending")) {
                (0, $e4096da1729505e0$export$2e2bcd8739ae039)("A passkey request is already in progress. Please refresh the page and try again.", "error");
                throw new Error("Passkey request already pending");
            }
            throw error;
        }
    }
    async submitApproval({ challengeIdentifier: challengeIdentifier, signature: signature }) {
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)("/withdraw/cash/passkey/submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.csrfTokenValue
            },
            body: JSON.stringify({
                challengeIdentifier: challengeIdentifier,
                signature: signature,
                payload: this.payloadValue,
                idempotencyKey: this.idempotencyKeyValue
            }),
            credentials: "same-origin"
        });
        await (0, $76e753e031c74aeb$export$ea607f18896190ac)(response, "Failed to approve cash order.");
    }
    showSpinner() {
        if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden");
        if (this.hasConfirmButtonTarget) this.confirmButtonTarget.disabled = true;
    }
    hideSpinner() {
        if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden");
        if (this.hasConfirmButtonTarget) this.confirmButtonTarget.disabled = false;
    }
}





class $3d9d523c0a991033$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "codeMasked",
        "codeReveal",
        "codeText",
        "copy"
    ];
    static values = {
        revealUrl: String
    };
    async reveal(event) {
        if (event) event.preventDefault();
        if (this._revealed || !this.hasRevealUrlValue) return;
        try {
            const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(this.revealUrlValue, {
                method: "GET",
                headers: {
                    Accept: "application/json"
                },
                credentials: "same-origin"
            });
            const data = await response.json();
            const code = data && data.code || "";
            if (!code) throw new Error("empty code");
            this._revealed = true;
            if (this.hasCodeTextTarget) this.codeTextTarget.textContent = code;
            if (this.hasCopyTarget) this.copyTarget.setAttribute("data-copy-text-value", code);
            if (this.hasCodeMaskedTarget) this.codeMaskedTarget.classList.add("hidden");
            if (this.hasCodeRevealTarget) this.codeRevealTarget.classList.remove("hidden");
        } catch (error) {
            (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Couldn't reveal the code. Please try again.", "error");
        }
    }
}



const $a1f594e67c215345$export$6acf1bf64841a8c2 = "checkout_onramp_method_selected";
const $a1f594e67c215345$export$29683e7ac68ad070 = "checkout_onramp_payment_in_progress";
class $a1f594e67c215345$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        onrampProvider: String,
        checkoutOrigin: String
    };
    connect() {
        this.inIframe = this.#isEmbedded();
        if (this.inIframe) {
            document.documentElement.classList.add("embedded");
            document.body.classList.add("embedded");
        }
    }
    notifyParentOnExternalClick(event) {
        if (!this.inIframe || !this.checkoutOriginValue) return;
        const link = event.target.closest('a[target="_blank"]');
        if (!link) return;
        const href = link.getAttribute("href") || "";
        if (!href || href.startsWith("#")) return;
        globalThis.parent.postMessage({
            type: $a1f594e67c215345$export$6acf1bf64841a8c2,
            href: href,
            provider: this.hasOnrampProviderValue ? this.onrampProviderValue : ""
        }, this.checkoutOriginValue);
    }
    #isEmbedded() {
        try {
            return globalThis.self !== globalThis.top;
        } catch (_) {
            return true;
        }
    }
}


// controllers/passkeyCreateRemoveController.js





function $2c821d6e252819b0$export$8d643fb172cc684e() {
    const origin = typeof window !== "undefined" && window.location ? window.location.origin : "";
    try {
        if (typeof navigator === "undefined") return {
            origin: origin,
            isMobile: false,
            platform: "Unknown",
            browser: "Unknown"
        };
        let browser = "Unknown";
        let platform = "Unknown";
        let isMobile = false;
        if (navigator.userAgentData) {
            const uaData = navigator.userAgentData;
            platform = uaData.platform || "Unknown";
            isMobile = uaData.mobile || false;
            const brandEntries = Array.isArray(uaData.brands) ? uaData.brands.filter((b)=>b.brand !== "Not)A;Brand") : [];
            const lastBrand = brandEntries[brandEntries.length - 1];
            browser = lastBrand ? `${lastBrand.brand} ${lastBrand.version}` : "Unknown";
        } else if (navigator.userAgent) {
            const ua = navigator.userAgent;
            const browserMatchers = [
                {
                    regex: /Chrome\/(\d+)/,
                    name: "Chrome"
                },
                {
                    regex: /Safari\/(\d+)/,
                    name: "Safari"
                },
                {
                    regex: /Firefox\/(\d+)/,
                    name: "Firefox"
                },
                {
                    regex: /Edg\/(\d+)/,
                    name: "Edge"
                }
            ];
            for (const { regex: regex, name: name } of browserMatchers){
                const match = ua.match(regex);
                if (match) {
                    browser = `${name} ${match[1]}`;
                    break;
                }
            }
            if (/Android/i.test(ua)) {
                platform = "Android";
                isMobile = true;
            } else if (/iPhone|iPad|iPod/i.test(ua)) {
                platform = "iOS";
                isMobile = true;
            } else if (/Mac OS X/i.test(ua)) platform = "macOS";
            else if (/Windows/i.test(ua)) platform = "Windows";
        }
        return {
            origin: origin,
            isMobile: isMobile,
            platform: platform,
            browser: browser
        };
    } catch (error) {
        return {
            origin: origin,
            isMobile: false,
            platform: "Unknown",
            browser: "Unknown"
        };
    }
}




class $48d68d3a16ca0114$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "form",
        "spinner",
        "error",
        "result",
        "button",
        "buttonText",
        "setupButton",
        "skipButton",
        "setupSpinner",
        "setupIcon",
        "setupButtonText",
        "pinButton"
    ];
    static values = {
        initUrl: {
            type: String,
            default: "/passkey/init"
        },
        domain: String,
        company: String,
        payload: Object,
        idempotencyKey: String,
        csrfToken: String
    };
    connect() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("Passkey create remove controller connected");
    }
    // create passkey from security page
    async createPasskeyFromSecurity(event) {
        event.preventDefault();
        // Prevent double-click
        if (this.buttonTarget.disabled) return;
        this.showSpinner();
        this.disableCreatePasskeyButton();
        this.disablePinButton();
        try {
            await this.requestChallengeFromSecurity();
        } catch (error) {
            if (error.message !== "backend-error") {
                if (error.name === "TypeError" || error.message.includes("fetch")) (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Unable to connect to server.", "error");
                else (0, $e4096da1729505e0$export$2e2bcd8739ae039)((0, $b8614c1cf7554158$export$85575c1a77628ede)(error), "error");
            }
            this.hideSpinner();
            this.enableCreatePasskeyButton();
            this.enablePinButton();
        }
    }
    // create passkey from nag passkey modal
    async createPasskeyFromSend(event) {
        event.preventDefault();
        // Prevent double-click
        if (this.hasSetupButtonTarget && this.setupButtonTarget.disabled) return;
        this.disableSkipButton();
        this.disableSetupButton();
        try {
            await this.requestChallengeFromSend();
        } catch (error) {
            if (error.message !== "backend-error") {
                if (error.name === "TypeError" || error.message.includes("fetch")) (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Unable to connect to server.", "error");
                else (0, $e4096da1729505e0$export$2e2bcd8739ae039)((0, $b8614c1cf7554158$export$85575c1a77628ede)(error), "error");
            }
            this.enableSkipButton();
            this.enableSetupButton();
        }
    }
    // create passkey from nag passkey modal for withdraw-to-crypto
    async createPasskeyFromWithdrawToCrypto(event) {
        event.preventDefault();
        // Prevent double-click
        if (this.hasSetupButtonTarget && this.setupButtonTarget.disabled) return;
        this.disableSkipButton();
        this.disableSetupButton();
        try {
            await this.requestChallengeFromWithdrawToCrypto();
        } catch (error) {
            if (error.message !== "backend-error") {
                if (error.name === "TypeError" || error.message.includes("fetch")) (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Unable to connect to server.", "error");
                else (0, $e4096da1729505e0$export$2e2bcd8739ae039)((0, $b8614c1cf7554158$export$85575c1a77628ede)(error), "error");
            }
            this.enableSkipButton();
            this.enableSetupButton();
        }
    }
    // create passkey from nag passkey modal for withdraw-to-crypto
    async createPasskeyFromWithdraw(event) {
        event.preventDefault();
        // Prevent double-click
        if (this.hasSetupButtonTarget && this.setupButtonTarget.disabled) return;
        this.disableSkipButton();
        this.disableSetupButton();
        try {
            await this.requestChallengeFromWithdraw();
        } catch (error) {
            if (error.message !== "backend-error") {
                if (error.name === "TypeError" || error.message.includes("fetch")) (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Unable to connect to server.", "error");
                else (0, $e4096da1729505e0$export$2e2bcd8739ae039)((0, $b8614c1cf7554158$export$85575c1a77628ede)(error), "error");
            }
            this.enableSkipButton();
            this.enableSetupButton();
        }
    }
    async requestChallengeFromSecurity() {
        // Step 1: Get challenge from backend
        const challenge = await this.getChallenge();
        // Step 2: Create passkey using WebAuthn
        const attestation = await this.createWebAuthnCredential(challenge);
        // Step 3: Save passkey to backend (handles toasts internally)
        const response = await this.savePasskey(attestation);
        return response;
    }
    async requestChallengeFromSend() {
        // Step 1: Get challenge from backend
        const challenge = await this.getChallenge();
        // Step 2: Create passkey using WebAuthn
        const attestation = await this.createWebAuthnCredential(challenge);
        // Step 3: Save passkey to backend
        await this.savePasskey(attestation);
    }
    async requestChallengeFromWithdrawToCrypto() {
        // Step 1: Get challenge from backend
        const challenge = await this.getChallenge();
        // Step 2: Create passkey using WebAuthn
        const attestation = await this.createWebAuthnCredential(challenge);
        // Step 3: Save passkey to backend
        await this.savePasskey(attestation);
    }
    async requestChallengeFromWithdraw() {
        // Step 1: Get challenge from backend
        const challenge = await this.getChallenge();
        // Step 2: Create passkey using WebAuthn
        const attestation = await this.createWebAuthnCredential(challenge);
        // Step 3: Save passkey to backend
        await this.savePasskey(attestation);
    }
    async getChallenge() {
        // Add source as query parameter if payload contains source
        let url = this.initUrlValue;
        if (this.hasPayloadValue && this.payloadValue && this.payloadValue.source) {
            const separator = url.includes('?') ? '&' : '?';
            url = `${url}${separator}source=${encodeURIComponent(this.payloadValue.source)}`;
        }
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        return await (0, $76e753e031c74aeb$export$ea607f18896190ac)(response, "Failed to get challenge");
    }
    async createWebAuthnCredential(challengeData) {
        // For WebAuthn, relying party ID must match the current domain
        const currentDomain = window.location.hostname;
        const relyingPartyId = this.domainValue || currentDomain;
        const relyingPartyName = this.companyValue || "CoinSub Wallet";
        let webauthn = new (0, $b30e2eb3b270edb4$exports.WebAuthnSigner)({
            relyingParty: {
                id: relyingPartyId,
                name: relyingPartyName
            }
        });
        const challenge = challengeData.challenge;
        try {
            const attestation = await webauthn.create(challenge);
            this.credentialInfoValue = {
                credentialName: "rocket passkey",
                credentialKind: "Fido2",
                credentialInfo: attestation.credentialInfo,
                challengeIdentifier: challenge.challengeIdentifier
            };
            if (this.credentialInfoValue.credentialInfo, this.credentialInfoValue.challengeIdentifier, this.credentialInfoValue.credentialName, this.credentialInfoValue.credentialKind !== null) return this.credentialInfoValue;
        } catch (error) {
            // Handle "A request is already pending" error
            if (error.name === "InvalidStateError" || error.message?.includes("pending")) {
                (0, $e4096da1729505e0$export$2e2bcd8739ae039)("A passkey request is already in progress. Please refresh the page and try again.", "error");
                throw new Error("Passkey request already pending");
            }
            throw error;
        }
    }
    async savePasskey(values) {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("IDempotency key: ", this.idempotencyKeyValue);
        const requestBody = {
            ...values,
            metadata: (0, $2c821d6e252819b0$export$8d643fb172cc684e)(),
            idempotencyKey: this.idempotencyKeyValue
        };
        // Add source and payload separately if they exist
        if (this.hasPayloadValue && this.payloadValue) {
            requestBody.source = this.payloadValue.source;
            requestBody.payload = this.payloadValue;
        } else // For security flow, set source to "security"
        requestBody.source = "security";
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)('/passkey/complete', {
            method: "POST",
            body: JSON.stringify(requestBody),
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.csrfTokenValue
            }
        });
        return await (0, $76e753e031c74aeb$export$ea607f18896190ac)(response, "Failed to save passkey");
    }
    showSpinner() {
        if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden");
    }
    hideSpinner() {
        if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden");
    }
    disableCreatePasskeyButton() {
        this.buttonTarget.disabled = true;
    }
    enableCreatePasskeyButton() {
        this.buttonTarget.disabled = false;
    }
    disableSkipButton() {
        this.skipButtonTarget.disabled = true;
    }
    enableSkipButton() {
        this.skipButtonTarget.disabled = false;
    }
    disableSetupButton() {
        if (this.hasSetupButtonTarget) this.setupButtonTarget.disabled = true;
        // Show spinner, hide icon
        if (this.hasSetupSpinnerTarget) this.setupSpinnerTarget.classList.remove('hidden');
        if (this.hasSetupIconTarget) this.setupIconTarget.classList.add('hidden');
        // Update button text
        if (this.hasSetupButtonTextTarget) this.setupButtonTextTarget.textContent = "Setting up...";
    }
    enableSetupButton() {
        if (this.hasSetupButtonTarget) this.setupButtonTarget.disabled = false;
        // Hide spinner, show icon
        if (this.hasSetupSpinnerTarget) this.setupSpinnerTarget.classList.add('hidden');
        if (this.hasSetupIconTarget) this.setupIconTarget.classList.remove('hidden');
        // Restore button text
        if (this.hasSetupButtonTextTarget) this.setupButtonTextTarget.textContent = "Setup Passkey";
    }
    disablePinButton() {
        if (this.hasPinButtonTarget) {
            this.pinButtonTarget.classList.add('pointer-events-none', 'opacity-50', 'cursor-not-allowed');
            this.pinButtonTarget.setAttribute('aria-disabled', 'true');
        }
    }
    enablePinButton() {
        if (this.hasPinButtonTarget) {
            this.pinButtonTarget.classList.remove('pointer-events-none', 'opacity-50', 'cursor-not-allowed');
            this.pinButtonTarget.removeAttribute('aria-disabled');
        }
    }
}



class $22532de6459e1986$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "amountInput",
        "walletInput",
        "previewButton",
        "loadingSpinner",
        "previewButtonText",
        "form",
        "maxButton",
        "backButton",
        "addressBookButton",
        "pasteButton",
        "amountHidden",
        "walletAddressHidden",
        "houdiniTokenIdHidden",
        "tokenSymbolHidden"
    ];
    static values = {
        tokenSymbol: String,
        balance: Number,
        houdiniTokenId: String,
        payload: Object,
        minValue: Number,
        selectedWallet: String
    };
    connect() {
        this.prefillFromPayload();
        this.clearPayloadFromURL();
        this.validateForm();
        if (this.hasPreviewButtonTextTarget) this.originalButtonText = this.previewButtonTextTarget.textContent.trim();
        if (this.hasAmountInputTarget) {
            this.amountInputTarget.addEventListener("input", this.validateForm.bind(this));
            this.amountInputTarget.addEventListener("change", this.validateForm.bind(this));
        }
        if (this.hasWalletInputTarget) {
            this.walletInputTarget.addEventListener("input", this.validateForm.bind(this));
            this.walletInputTarget.addEventListener("change", this.validateForm.bind(this));
        }
        if (this.hasFormTarget) {
            this.handleTurboStream = this.handleTurboStream.bind(this);
            this.formTarget.addEventListener("turbo:submit-start", this.onSubmitStart.bind(this));
            this.formTarget.addEventListener("turbo:submit-end", this.onSubmitEnd.bind(this));
        }
    }
    clearPayloadFromURL() {
        const url = new URL(globalThis.location.href);
        if (url.searchParams.has("p")) {
            url.searchParams.delete("p");
            globalThis.history.replaceState({}, "", url.toString());
        }
    }
    prefillFromPayload() {
        if (!this.hasPayloadValue || !this.payloadValue) return;
        const payload = this.payloadValue;
        const minValue = this.hasMinValueValue ? this.minValueValue : 0;
        const balance = this.hasBalanceValue ? this.balanceValue : 0;
        if (this.hasAmountInputTarget && payload.amount) {
            const amount = Number.parseFloat(payload.amount);
            if (!Number.isNaN(amount)) {
                if (amount >= minValue && amount <= balance) this.amountInputTarget.value = payload.amount;
                else if (amount > balance) this.amountInputTarget.value = balance.toFixed(2);
            }
        }
        if (this.hasWalletInputTarget && payload.walletAddress) this.walletInputTarget.value = payload.walletAddress;
    }
    selectedWalletValueChanged() {
        if (this.selectedWalletValue && this.hasWalletInputTarget) {
            this.walletInputTarget.value = this.selectedWalletValue;
            this.validateForm();
            this.selectedWalletValue = "";
        }
    }
    disconnect() {
        if (this.hasFormTarget) {
            this.formTarget.removeEventListener("turbo:submit-start", this.onSubmitStart);
            this.formTarget.removeEventListener("turbo:submit-end", this.onSubmitEnd);
        }
    }
    onSubmitStart(event) {
        this.isLoading = true;
    }
    onSubmitEnd(event) {
        if (event.detail.success === false) this.hideLoading();
    }
    handleTurboStream(event) {
        if (this.isLoading && document.contains(this.element)) {
            this.hideLoading();
            this.isLoading = false;
        }
    }
    validateForm() {
        let isValid = true;
        if (this.hasAmountInputTarget) {
            const amountValue = this.amountInputTarget.value.trim();
            const cleaned = String(amountValue).replace(/[^0-9.]/g, "");
            const amount = Number.parseFloat(cleaned);
            if (!amountValue || amountValue === "" || Number.isNaN(amount) || amount <= 0) isValid = false;
            else if (this.hasBalanceValue && amount > this.balanceValue) isValid = false;
        } else isValid = false;
        if (this.hasWalletInputTarget) {
            const walletAddress = this.walletInputTarget.value.trim();
            if (!walletAddress || walletAddress === "") isValid = false;
        } else isValid = false;
        if (this.hasPreviewButtonTarget) {
            if (isValid) {
                this.previewButtonTarget.classList.remove("opacity-50", "cursor-not-allowed", "pointer-events-none");
                this.previewButtonTarget.classList.add("hover:bg-black/80");
            } else {
                this.previewButtonTarget.classList.add("opacity-50", "cursor-not-allowed", "pointer-events-none");
                this.previewButtonTarget.classList.remove("hover:bg-black/80");
            }
        }
    }
    handlePreviewClick(event) {
        event.preventDefault();
        if (this.isLoading) return false;
        this.clearPayloadFromURL();
        if (!this.isFormValid()) return false;
        let amountValue = "";
        let walletAddressValue = "";
        if (this.hasAmountInputTarget) {
            amountValue = this.amountInputTarget.value.trim();
            amountValue = String(amountValue).replace(/[^0-9.]/g, "");
        }
        if (this.hasWalletInputTarget) walletAddressValue = this.walletInputTarget.value.trim();
        // Update hidden inputs directly via targets
        if (this.hasAmountHiddenTarget) this.amountHiddenTarget.value = amountValue;
        if (this.hasWalletAddressHiddenTarget) this.walletAddressHiddenTarget.value = walletAddressValue;
        if (this.hasHoudiniTokenIdHiddenTarget) this.houdiniTokenIdHiddenTarget.value = this.houdiniTokenIdValue;
        if (this.hasTokenSymbolHiddenTarget) this.tokenSymbolHiddenTarget.value = this.tokenSymbolValue;
        if (this.hasFormTarget && !this.formTarget.checkValidity()) {
            this.formTarget.reportValidity();
            return false;
        }
        this.showLoading();
        if (this.hasFormTarget) this.formTarget.requestSubmit();
    }
    showLoading() {
        this.isLoading = true;
        if (this.hasAmountInputTarget) this.amountInputTarget.disabled = true;
        if (this.hasWalletInputTarget) this.walletInputTarget.disabled = true;
        if (this.hasLoadingSpinnerTarget) this.loadingSpinnerTarget.classList.remove("hidden");
        if (this.hasPreviewButtonTextTarget) this.previewButtonTextTarget.textContent = "Calculating...";
        if (this.hasPreviewButtonTarget) {
            this.previewButtonTarget.disabled = true;
            this.previewButtonTarget.classList.remove("hover:bg-black/80");
            this.previewButtonTarget.classList.add("opacity-50", "cursor-not-allowed", "pointer-events-none");
        }
        // Disable all interactive elements
        this.setDisabled(true);
    }
    hideLoading() {
        this.isLoading = false;
        if (this.hasPreviewButtonTarget) this.previewButtonTarget.disabled = false;
        if (this.hasAmountInputTarget) this.amountInputTarget.disabled = false;
        if (this.hasWalletInputTarget) this.walletInputTarget.disabled = false;
        if (this.hasLoadingSpinnerTarget) this.loadingSpinnerTarget.classList.add("hidden");
        if (this.hasPreviewButtonTextTarget && this.originalButtonText) this.previewButtonTextTarget.textContent = this.originalButtonText;
        // Re-enable all interactive elements
        this.setDisabled(false);
        this.validateForm();
    }
    isFormValid() {
        let isValid = true;
        if (this.hasAmountInputTarget) {
            const amountValue = this.amountInputTarget.value.trim();
            const cleaned = String(amountValue).replace(/[^0-9.]/g, "");
            const amount = Number.parseFloat(cleaned);
            if (!amountValue || amountValue === "" || Number.isNaN(amount) || amount <= 0) isValid = false;
            else if (this.hasBalanceValue && amount > this.balanceValue) isValid = false;
        } else isValid = false;
        if (this.hasWalletInputTarget) {
            const walletAddress = this.walletInputTarget.value.trim();
            if (!walletAddress || walletAddress === "") isValid = false;
        } else isValid = false;
        return isValid;
    }
    setDisabled(disabled) {
        this.setButtonDisabled(this.hasBackButtonTarget, this.backButtonTarget, disabled, true);
        this.setButtonDisabled(this.hasMaxButtonTarget, this.maxButtonTarget, disabled, false);
        this.setButtonDisabled(this.hasAddressBookButtonTarget, this.addressBookButtonTarget, disabled, true);
        this.setButtonDisabled(this.hasPasteButtonTarget, this.pasteButtonTarget, disabled, false);
    }
    setButtonDisabled(hasTarget, target, disabled, usePointerEvents) {
        if (!hasTarget) return;
        if (usePointerEvents) {
            if (disabled) target.classList.add("pointer-events-none", "opacity-50");
            else target.classList.remove("pointer-events-none", "opacity-50");
        } else {
            target.disabled = disabled;
            if (disabled) target.classList.add("opacity-50");
            else target.classList.remove("opacity-50");
        }
    }
}



class $4ff4204b59a5ca3a$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "dateInput",
        "hiddenInput",
        "overlay",
        "monthSelect",
        "yearSelect",
        "grid",
        "calendarIcon",
        "fieldWrapper",
        "fieldLabel",
        "errorText"
    ];
    connect() {
        this.selectedDate = null;
        this.viewMonth = new Date().getMonth();
        this.viewYear = new Date().getFullYear();
        this.touched = false;
        this.boundClose = this.closeOnOutsideClick.bind(this);
    }
    disconnect() {
        document.removeEventListener("click", this.boundClose);
    }
    handleInput(event) {
        const value = this.dateInputTarget.value;
        const digits = value.replace(/\D/g, "");
        let formatted = this.formatDigits(digits);
        const isDeleting = event.inputType && event.inputType.startsWith("delete");
        if (!isDeleting && (digits.length === 2 || digits.length === 4) && value.length > formatted.length) formatted += " / ";
        this.dateInputTarget.value = formatted;
        this.syncFromInput(digits);
        this.validate(digits);
    }
    formatDigits(digits) {
        if (digits.length <= 2) return digits;
        if (digits.length <= 4) return `${digits.slice(0, 2)} / ${digits.slice(2)}`;
        return `${digits.slice(0, 2)} / ${digits.slice(2, 4)} / ${digits.slice(4, 8)}`;
    }
    handleBlur() {
        this.touched = true;
        let digits = this.dateInputTarget.value.replace(/\D/g, "");
        if (digits.length === 6) {
            const yy = parseInt(digits.slice(4, 6), 10);
            const currentYear = new Date().getFullYear();
            const currentCentury = Math.floor(currentYear / 100) * 100;
            const century = yy <= currentYear % 100 ? currentCentury : currentCentury - 100;
            digits = digits.slice(0, 4) + String(century + yy);
            this.dateInputTarget.value = this.formatDigits(digits);
            this.syncFromInput(digits);
        }
        this.validate(digits);
    }
    syncFromInput(digits) {
        if (digits.length < 8) {
            this.hiddenInputTarget.value = "";
            this.hiddenInputTarget.dispatchEvent(new Event("change", {
                bubbles: true
            }));
            return;
        }
        const month = parseInt(digits.slice(0, 2), 10);
        const day = parseInt(digits.slice(2, 4), 10);
        const year = parseInt(digits.slice(4, 8), 10);
        if (this.isValidDate(month, day, year)) {
            this.selectedDate = new Date(year, month - 1, day);
            this.viewMonth = month - 1;
            this.viewYear = year;
            const m = String(month).padStart(2, "0");
            const d = String(day).padStart(2, "0");
            this.hiddenInputTarget.value = `${year}-${m}-${d}`;
        } else {
            this.hiddenInputTarget.value = "";
            this.selectedDate = null;
        }
        this.hiddenInputTarget.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    validate(digits) {
        if (digits.length === 0) {
            if (this.touched) this.showError("Date of birth is required");
            else this.clearError();
            return;
        }
        if (digits.length >= 2) {
            const month = parseInt(digits.slice(0, 2), 10);
            if (month < 1 || month > 12) {
                this.showError("Invalid month");
                return;
            }
        }
        if (digits.length >= 4) {
            const month = parseInt(digits.slice(0, 2), 10);
            const day = parseInt(digits.slice(2, 4), 10);
            if (day < 1 || day > 31) {
                this.showError("Invalid day");
                return;
            }
            const daysInMonth = new Date(2000, month, 0).getDate();
            if (day > daysInMonth) {
                this.showError("Invalid day for this month");
                return;
            }
        }
        if (digits.length >= 8) {
            const error = this.getDateError(digits);
            if (error) {
                this.showError(error);
                return;
            }
        }
        if (this.touched && digits.length < 8) {
            this.showError("Please enter a complete date (MM / DD / YYYY)");
            return;
        }
        this.clearError();
    }
    getDateError(digits) {
        const month = parseInt(digits.slice(0, 2), 10);
        const day = parseInt(digits.slice(2, 4), 10);
        const year = parseInt(digits.slice(4, 8), 10);
        const currentYear = new Date().getFullYear();
        if (month < 1 || month > 12) return "Invalid month";
        if (year < currentYear - 120 || year > currentYear) return "Invalid year";
        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) return "Invalid day for this month";
        const dob = new Date(year, month - 1, day);
        if (dob > new Date()) return "Date cannot be in the future";
        const now = new Date();
        const age = now.getFullYear() - dob.getFullYear();
        const monthDiff = now.getMonth() - dob.getMonth();
        const dayDiff = now.getDate() - dob.getDate();
        const fullAge = monthDiff < 0 || monthDiff === 0 && dayDiff < 0 ? age - 1 : age;
        if (fullAge < 18) return "Must be at least 18 years old";
        return null;
    }
    isValidDate(month, day, year) {
        return this.getDateError(String(month).padStart(2, "0") + String(day).padStart(2, "0") + String(year)) === null;
    }
    showError(message) {
        this.fieldWrapperTarget.style.borderColor = "rgb(239, 68, 68)";
        this.fieldLabelTarget.style.color = "rgb(239, 68, 68)";
        this.errorTextTarget.textContent = message;
        this.errorTextTarget.classList.remove("hidden");
    }
    clearError() {
        this.fieldWrapperTarget.style.borderColor = "";
        this.fieldLabelTarget.style.color = "";
        this.errorTextTarget.textContent = "";
        this.errorTextTarget.classList.add("hidden");
    }
    open(event) {
        event.stopPropagation();
        this.overlayTarget.classList.remove("hidden");
        this.buildMonthOptions();
        this.buildYearOptions();
        this.renderGrid();
        document.addEventListener("click", this.boundClose);
    }
    close() {
        this.overlayTarget.classList.add("hidden");
        document.removeEventListener("click", this.boundClose);
    }
    cancel(event) {
        event.stopPropagation();
        this.close();
    }
    confirm(event) {
        event.stopPropagation();
        if (!this.selectedDate) return;
        const y = this.selectedDate.getFullYear();
        const m = String(this.selectedDate.getMonth() + 1).padStart(2, "0");
        const d = String(this.selectedDate.getDate()).padStart(2, "0");
        this.hiddenInputTarget.value = `${y}-${m}-${d}`;
        this.dateInputTarget.value = `${m} / ${d} / ${y}`;
        this.clearError();
        this.hiddenInputTarget.dispatchEvent(new Event("change", {
            bubbles: true
        }));
        this.close();
    }
    changeMonth(event) {
        event.stopPropagation();
        this.viewMonth = parseInt(event.target.value, 10);
        this.renderGrid();
    }
    changeYear(event) {
        event.stopPropagation();
        this.viewYear = parseInt(event.target.value, 10);
        this.renderGrid();
    }
    selectDay(event) {
        event.stopPropagation();
        const day = parseInt(event.currentTarget.dataset.day, 10);
        this.selectedDate = new Date(this.viewYear, this.viewMonth, day);
        this.renderGrid();
    }
    closeOnOutsideClick(event) {
        if (!this.overlayTarget.contains(event.target) && !this.element.contains(event.target)) this.close();
    }
    buildMonthOptions() {
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        this.monthSelectTarget.innerHTML = months.map((name, i)=>`<option value="${i}" ${i === this.viewMonth ? "selected" : ""}>${name}</option>`).join("");
    }
    buildYearOptions() {
        const currentYear = new Date().getFullYear();
        const options = [];
        for(let y = currentYear; y >= currentYear - 120; y--)options.push(`<option value="${y}" ${y === this.viewYear ? "selected" : ""}>${y}</option>`);
        this.yearSelectTarget.innerHTML = options.join("");
    }
    renderGrid() {
        const firstDay = new Date(this.viewYear, this.viewMonth, 1).getDay();
        const daysInMonth = new Date(this.viewYear, this.viewMonth + 1, 0).getDate();
        const daysInPrevMonth = new Date(this.viewYear, this.viewMonth, 0).getDate();
        let cells = "";
        for(let i = firstDay - 1; i >= 0; i--)cells += `<div class="py-2 text-center text-sm opacity-30">${daysInPrevMonth - i}</div>`;
        for(let d = 1; d <= daysInMonth; d++){
            const isSelected = this.selectedDate && this.selectedDate.getFullYear() === this.viewYear && this.selectedDate.getMonth() === this.viewMonth && this.selectedDate.getDate() === d;
            const selectedClass = isSelected ? "wdark:bg-wdark-button-background wlight:bg-wlight-button-background dark:bg-dark-button-background wdark:text-wdark-button-text-and-icon wlight:text-wlight-button-text-and-icon dark:text-dark-button-text-and-icon rounded-full" : "";
            cells += `<button type="button" data-day="${d}" data-action="click->date-picker#selectDay"
        class="py-2 text-center text-sm cursor-pointer hover:opacity-75 ${selectedClass}">${d}</button>`;
        }
        const totalCells = firstDay + daysInMonth;
        const remaining = totalCells % 7 === 0 ? 0 : 7 - totalCells % 7;
        for(let i = 1; i <= remaining; i++)cells += `<div class="py-2 text-center text-sm opacity-30">${i}</div>`;
        this.gridTarget.innerHTML = cells;
    }
}




class $e5201a4290c704cf$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "findBestRouteButton",
        "findBestRouteButtonText",
        "goBackButton",
        "goBackButtonText",
        "loadingSpinner",
        "errorMessage"
    ];
    static values = {
        redirectlink: String,
        orderid: String,
        csrftoken: String
    };
    connect() {}
    async handleRedirectToHoudini(e) {
        const redirectLink = this.redirectlinkValue;
        const orderId = this.orderidValue;
        const csrfToken = this.csrftokenValue;
        try {
            window.open(redirectLink, "_blank");
            const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)("/deposit/crypto/order-status", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken
                },
                body: JSON.stringify({
                    orderId: orderId
                })
            });
        } catch (error) {
            console.error("Error happened during find best route", error);
            this.errorMessageTarget.textContent = "Error happened during find best route";
        }
    }
    showLoadingSpinner() {
        this.findBestRouteButtonTarget.disabled = true;
        this.loadingSpinnerTarget.classList.remove("hidden");
        this.findBestRouteButtonTextTarget.textContent = "Awaiting deposit...";
    }
}



class $0fa499a54af8a3e3$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        swapId: String
    };
    close() {
        const onPendingForThisSwap = this.swapIdValue && window.location.pathname === `/deposit/crypto/order/${this.swapIdValue}`;
        this.hide();
        if (onPendingForThisSwap) Turbo.visit("/home");
    }
    hide() {
        this.element.setAttribute("inert", "");
        this.element.setAttribute("aria-hidden", "true");
        this.element.classList.add("hidden");
    }
}





class $5e3ea06fc0bbcc77$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "topToken",
        "selectedTokenIcon",
        "searchTokenInput",
        "amountInput",
        "depositButton",
        "loadingSpinner",
        "depositButtonText",
        "processingMessage",
        "changeDepositOptionsButton"
    ];
    static values = {
        selectedTokenId: String,
        selectedNetwork: String,
        amountNeeded: String,
        csrfToken: String,
        idemKey: String,
        withdrawFromCrypto: Boolean
    };
    connect() {
        this.setupEventListeners();
        this.debouncedTokenSearch = (0, $6adb56df0e842c64$export$61fc7d43ac8f84b0)(this.searchTokens.bind(this), 300);
        this.initializeTokenSelection();
    }
    setupEventListeners() {
        this.searchTokenInputTarget.addEventListener("focus", (e)=>{
            e.currentTarget.select();
        });
        if (this.hasAmountInputTarget) this.amountInputTarget.addEventListener("focus", (e)=>{
            e.currentTarget.select();
        });
        this.searchTokenInputTarget.addEventListener("input", this.handleTokenInputChange.bind(this));
    }
    initializeTokenSelection() {
        if (this.hasSelectedTokenIdValue && this.selectedTokenIdValue) {
            const tokenElement = this.topTokenTargets.find((token)=>token.dataset.tokenId === this.selectedTokenIdValue);
            if (tokenElement) this.selectTop3Token(tokenElement);
            else this.handleTokenNotInTop3();
        } else if (this.topTokenTargets.length > 0) this.selectTop3Token(this.topTokenTargets[0]);
    }
    handleTokenNotInTop3() {
        const payloadData = this.element.dataset.payload;
        if (payloadData) try {
            this.setTokenFromPayload(payloadData);
        } catch (e) {
            console.error("Failed to parse payload:", e);
            this.fallbackToFirstToken();
        }
        else this.fallbackToFirstToken();
    }
    setTokenFromPayload(payloadData) {
        const payload = JSON.parse(payloadData);
        const tokenName = payload.tokenName || payload.tokenSymbol || this.selectedTokenIdValue;
        const tokenIcon = payload.tokenIcon || "https://api.houdiniswap.com/assets/default.png";
        if (this.hasSelectedTokenIconTarget) this.selectedTokenIconTarget.src = tokenIcon;
        if (this.hasSearchTokenInputTarget) this.searchTokenInputTarget.value = tokenName;
        const hiddenInput = document.getElementById('selected-token-id');
        if (hiddenInput) hiddenInput.value = this.selectedTokenIdValue;
    }
    fallbackToFirstToken() {
        if (this.topTokenTargets.length > 0) this.selectTop3Token(this.topTokenTargets[0]);
    }
    handleSelectTop3Tokens(event) {
        const clickedToken = event.currentTarget;
        this.selectTop3Token(clickedToken);
    }
    async selectTop3Token(tokenElement) {
        // Remove selection from all tokens
        console.log("selectTop3Token", tokenElement);
        this.topTokenTargets.forEach((token)=>{
            token.classList.remove('selected-token');
        });
        // Add selection to clicked token
        tokenElement.classList.add('selected-token');
        // Hide the entire search token list
        const tokenList = document.getElementById('wallet-houdini-tokens-list');
        if (tokenList) tokenList.style.display = 'none';
        // Update search icon and input value to show selected token's icon and name
        const tokenIcon = tokenElement.dataset.tokenIcon;
        const tokenName = tokenElement.dataset.tokenName;
        const tokenId = tokenElement.dataset.tokenId;
        const network = tokenElement.dataset.network;
        // Store selected token data
        this.selectedTokenIdValue = tokenId;
        this.selectedNetworkValue = network;
        if (tokenIcon && this.hasSelectedTokenIconTarget) {
            this.selectedTokenIconTarget.src = tokenIcon;
            this.searchTokenInputTarget.value = tokenName;
        }
    }
    handleTokenInputChange(event) {
        const searchValue = event.target.value.trim();
        // Only search if there's actually something to search for
        if (this.topTokenTargets.length >= 1) {
            // Only show default icon when input is empty or cleared
            // Keep selected token icon if user is just editing the search text
            if (searchValue === "" && this.hasSelectedTokenIconTarget) this.selectedTokenIconTarget.src = "https://api.houdiniswap.com/assets/default.png";
            this.debouncedTokenSearch(searchValue);
        }
    }
    async searchTokens(searchValue) {
        try {
            const amountNeeded = this.searchTokenInputTarget.dataset.amountNeeded || "20";
            const csrfToken = this.csrfTokenValue;
            const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)("/deposit/crypto/search-tokens", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken
                },
                body: JSON.stringify({
                    search: searchValue,
                    amountNeeded: amountNeeded
                })
            });
            const responseData = await response.json();
            if (responseData.type === "html") Turbo.renderStreamMessage(responseData.data);
            else {
                console.error("error", responseData.error);
                this.showError(responseData.error);
            }
        } catch (error) {
            console.error("Error searching tokens:", error);
            this.showError("Error searching tokens");
        }
    }
    showError(errorMessage) {
        const errorDiv = document.getElementById("error-message");
        if (errorDiv) {
            errorDiv.textContent = errorMessage;
            errorDiv.classList.remove("hidden");
        }
        setTimeout(()=>{
            this.hideError();
        }, 5000);
    }
    handleSelectSearchToken(event) {
        const clickedToken = event.currentTarget;
        const tokenIcon = clickedToken.dataset.tokenIcon;
        const tokenName = clickedToken.dataset.tokenName;
        const tokenId = clickedToken.dataset.tokenId;
        const network = clickedToken.dataset.network;
        // Store selected token data
        this.selectedTokenIdValue = tokenId;
        this.selectedNetworkValue = network;
        // Update search input to show selected token's name
        if (tokenName && this.hasSearchTokenInputTarget) this.searchTokenInputTarget.value = tokenName + " (" + network + ")";
        // Update search icon to show selected token's icon
        if (tokenIcon && this.hasSelectedTokenIconTarget) this.selectedTokenIconTarget.src = tokenIcon;
        const hiddenInput = document.getElementById('selected-token-id');
        if (hiddenInput) hiddenInput.value = tokenId;
        // Clear top 3 token styles
        this.clearTop3TokenStyles();
        this.selectListToken(clickedToken.dataset.tokenId);
    }
    async selectListToken(tokenId) {
        try {
            const csrfToken = this.csrfTokenValue;
            const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)("/deposit/crypto/select-token", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken
                },
                body: JSON.stringify({
                    tokenId: tokenId
                })
            });
            const responseData = await response.json();
            if (responseData.type === "html") Turbo.renderStreamMessage(responseData.data);
            else console.error("error", responseData.error);
        } catch (error) {
            console.error("error", error);
        }
    }
    clearTop3TokenStyles() {
        this.topTokenTargets.forEach((token)=>{
            token.classList.remove('selected-token');
        });
    }
    handleAmountInput(e) {
        const input = e.currentTarget;
        let value = input.value;
        // Only allow numbers and one decimal point
        value = value.replace(/[^0-9.]/g, '');
        // Ensure only one decimal point
        const parts = value.split('.');
        if (parts.length > 2) value = parts[0] + '.' + parts.slice(1).join('');
        // Update the input value
        input.value = value;
    }
    showAmountError(errorMessage, minimumAmount = null) {
        const errorDiv = document.getElementById("amount-error-message");
        const errorText = document.getElementById("error-text");
        const amountDisplay = this.hasAmountInputTarget ? this.amountInputTarget : null;
        if (errorDiv && errorText) {
            // Set the error message text
            errorText.textContent = errorMessage;
            errorDiv.classList.remove("hidden");
            // Update amount to show the corrected/adjusted amount if provided
            if (minimumAmount && amountDisplay) {
                // Update amount to show the corrected/adjusted amount (no $ prefix)
                amountDisplay.value = minimumAmount.toFixed(2);
                // Store the minimum amount for retry
                this.minimumAmountValue = minimumAmount;
                amountDisplay.dispatchEvent(new Event("input"));
                // Update the deposit button data attribute with the new amount
                if (this.hasDepositButtonTarget) this.depositButtonTarget.dataset.amountNeeded = minimumAmount;
                // Update hidden input if it exists
                const hiddenAmountInput = document.getElementById('amount-needed');
                if (hiddenAmountInput) hiddenAmountInput.value = minimumAmount.toFixed(2);
            }
            // Auto-hide error message after 5 seconds
            setTimeout(()=>{
                this.hideAmountError();
            }, 5000);
        } else console.error("Error: Could not find errorDiv or errorText elements");
    }
    hideAmountError() {
        const errorDiv = document.getElementById("amount-error-message");
        if (errorDiv) errorDiv.classList.add("hidden");
    }
    lockInputs() {
        this.searchTokenInputTarget.disabled = true;
        if (this.hasAmountInputTarget) this.amountInputTarget.disabled = true;
        this.topTokenTargets.forEach((btn)=>btn.disabled = true);
    }
    hideChangeDepositOptionsButton() {
        this.changeDepositOptionsButtonTarget.classList.add("hidden");
    }
    showChangeDepositOptionsButton() {
        this.changeDepositOptionsButtonTarget.classList.remove("hidden");
    }
    showLoadingSpinner() {
        this.depositButtonTarget.disabled = true;
        this.searchTokenInputTarget.disabled = true;
        this.loadingSpinnerTarget.classList.remove("hidden");
        this.depositButtonTextTarget.textContent = "Processing...";
        // Show the processing message
        if (!this.withdrawFromCryptoValue) this.processingMessageTarget.classList.remove("hidden");
    }
    hideLoadingSpinner() {
        this.depositButtonTarget.disabled = false;
        this.searchTokenInputTarget.disabled = false;
        if (this.hasAmountInputTarget) this.amountInputTarget.disabled = false;
        this.topTokenTargets.forEach((btn)=>btn.disabled = false);
        this.loadingSpinnerTarget.classList.add("hidden");
        this.depositButtonTextTarget.textContent = "Deposit";
        // Hide the processing message
        if (!this.withdrawFromCryptoValue) this.processingMessageTarget.classList.add("hidden");
    }
    async handleWalletFindBestRoute(event) {
        const amountNeeded = (this.hasAmountInputTarget ? this.amountInputTarget.value : null) || this.amountNeededValue;
        const selectedTokenId = this.selectedTokenIdValue;
        const csrfToken = this.csrfTokenValue;
        if (!this.withdrawFromCryptoValue && (!amountNeeded || amountNeeded.trim() === "")) {
            console.error("Amount is empty!");
            return;
        }
        this.hideAmountError();
        this.showLoadingSpinner();
        this.lockInputs();
        this.hideChangeDepositOptionsButton();
        try {
            // Determine endpoint based on withdrawFromCrypto value
            const endpoint = this.withdrawFromCryptoValue ? "/withdraw/crypto/select-asset" : "/deposit/crypto/find-best-route";
            const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken
                },
                body: JSON.stringify({
                    amount: amountNeeded,
                    houdiniTokenId: selectedTokenId,
                    idemKey: this.idemKeyValue
                })
            });
            const contentType = response.headers.get("content-type") || "";
            if (contentType.includes("text/vnd.turbo-stream.html")) {
                const html = await response.text();
                Turbo.renderStreamMessage(html);
                this.showChangeDepositOptionsButton();
            } else if (contentType.includes("application/json")) {
                const responseData = await response.json();
                if (responseData.type === "error") {
                    this.showAmountError(responseData.error, responseData.minimumAmount);
                    this.showChangeDepositOptionsButton();
                } else if (responseData.type === "redirect" && responseData.url) {
                    Turbo.visit(responseData.url);
                    return;
                }
            }
        } catch (error) {
            console.error("Error happened during find best route", error);
        } finally{
            this.hideLoadingSpinner();
        }
    }
}



class $d5bf9e17054544c9$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    connect() {
        if (this.isEmbedded()) {
            document.documentElement.classList.add("embedded");
            document.body.classList.add("embedded");
        }
    }
    isEmbedded() {
        try {
            return window.self !== window.top;
        } catch (_) {
            return true // cross-origin → embedded
            ;
        }
    }
}



class $a668f6ba336379e5$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "toggle",
        "parts",
        "arrow"
    ];
    toggle() {
        const open = this.partsTarget.style.display === "none";
        this.partsTarget.style.display = open ? "" : "none";
        this.arrowTarget.style.transform = open ? "rotate(180deg)" : "rotate(0deg)";
        this.toggleTarget.setAttribute("aria-expanded", String(open));
    }
}



class $9faadb2e87f40758$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "form",
        "submit",
        "spinner",
        "text"
    ];
    static values = {
        text: String
    };
    connect() {
        // Store original text for each text target
        if (this.hasTextTarget) this.originalText = this.textTargets.map((target)=>target.textContent.trim());
        // Bind event handlers
        this.onStart = this.onStart.bind(this);
        this.onFetchResponse = this.onFetchResponse.bind(this);
        this.onSubmitEnd = this.onSubmitEnd.bind(this);
        // Listen for Turbo form events
        this.formTarget.addEventListener("turbo:submit-start", this.onStart);
        this.formTarget.addEventListener("turbo:before-fetch-response", this.onFetchResponse);
        this.formTarget.addEventListener("turbo:submit-end", this.onSubmitEnd);
    }
    disconnect() {
        // Clean up event listeners
        this.formTarget.removeEventListener("turbo:submit-start", this.onStart);
        this.formTarget.removeEventListener("turbo:before-fetch-response", this.onFetchResponse);
        this.formTarget.removeEventListener("turbo:submit-end", this.onSubmitEnd);
    }
    onStart() {
        this.lock();
    }
    onFetchResponse(e) {
        // Unlock if response is not OK (>=400)
        const ok = e.detail.fetchResponse.response.ok;
        if (!ok) this.unlock();
    // If OK, the frame/page will replace; no need to unlock
    }
    onSubmitEnd(e) {
        // Unlock on any submission failure
        if (e.detail.success === false) this.unlock();
    }
    lock() {
        this.submitTargets.forEach((btn)=>{
            btn.setAttribute("disabled", "disabled");
            btn.setAttribute("aria-busy", "true");
            btn.classList.add("cursor-not-allowed", "opacity-50", "hover:bg-black");
            btn.style.filter = "brightness(95%)";
        });
        // Show spinner
        if (this.hasSpinnerTarget) this.spinnerTargets.forEach((spinner)=>{
            spinner.classList.remove("hidden");
        });
        // Update button text
        if (this.hasTextTarget && this.hasTextValue) this.textTargets.forEach((target)=>{
            target.textContent = this.textValue || "Please wait";
        });
    }
    unlock() {
        this.submitTargets.forEach((btn)=>{
            btn.removeAttribute("disabled");
            btn.removeAttribute("aria-busy");
            btn.classList.remove("cursor-not-allowed");
            btn.style.filter = "";
        });
        // Hide spinner
        if (this.hasSpinnerTarget) this.spinnerTargets.forEach((spinner)=>{
            spinner.classList.add("hidden");
        });
        // Restore original button text
        if (this.hasTextTarget && this.originalText) this.textTargets.forEach((target, index)=>{
            target.textContent = this.originalText[index] || "";
        });
    }
}



class $4ebef11e1590c665$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "submit",
        "requiredInput",
        "error"
    ];
    connect() {
        this.boundValidateForm = this.validateForm.bind(this);
        this.boundHandleBlur = this.handleBlur.bind(this);
        this.boundHandleInput = this.handleInput.bind(this);
        this.requiredInputTargets.forEach((input)=>{
            input.addEventListener("input", this.boundHandleInput);
            input.addEventListener("change", this.boundHandleInput);
            input.addEventListener("blur", this.boundHandleBlur);
        });
        this.validateForm();
    }
    disconnect() {
        this.requiredInputTargets.forEach((input)=>{
            input.removeEventListener("input", this.boundHandleInput);
            input.removeEventListener("change", this.boundHandleInput);
            input.removeEventListener("blur", this.boundHandleBlur);
        });
    }
    handleInput(event) {
        const input = event.target;
        this.validateForm();
    }
    handleBlur(event) {
        const input = event.target;
        const trimmed = input.value.trim();
        if (trimmed !== input.value) input.value = trimmed;
        input.dataset.touched = "true";
        this.validateForm();
    }
    validateForm() {
        let isFormValid = true;
        this.requiredInputTargets.forEach((input)=>{
            const fieldValid = this.validateInputField(input);
            if (!fieldValid) isFormValid = false;
        });
        this.updateSubmitButton(isFormValid);
    }
    validateInputField(input) {
        const value = input.value.replaceAll(/\s+/g, '');
        const validationType = input.dataset.validationType;
        const regexPattern = input.dataset.validationRegex;
        const errorMessage = input.dataset.validationMessage;
        const isTouched = input.dataset.touched === "true";
        if (!value) {
            this.updateErrorDisplay(input, errorMessage, isTouched, false);
            return false;
        }
        if (validationType === "positive-number" && !this.isValidPositiveNumber(value)) {
            this.updateErrorDisplay(input, errorMessage, isTouched, false);
            return false;
        }
        if (regexPattern && !this.isValidRegex(value, regexPattern)) {
            this.updateErrorDisplay(input, errorMessage, isTouched, false);
            return false;
        }
        this.updateErrorDisplay(input, errorMessage, isTouched, true);
        return true;
    }
    isValidPositiveNumber(value) {
        const numericValue = Number.parseFloat(value);
        return !Number.isNaN(numericValue) && numericValue > 0;
    }
    isValidRegex(value, regexPattern) {
        try {
            const re = new RegExp(regexPattern);
            return re.test(value);
        } catch (e) {
            console.warn("Invalid regex pattern:", regexPattern, e);
            return false;
        }
    }
    updateErrorDisplay(input, errorMessage, isTouched, fieldValid) {
        if (!this.hasErrorTarget) return;
        const errorEl = this.errorTargets.find((el)=>el.dataset.errorFor === input.name);
        if (errorEl) {
            if (isTouched && !fieldValid) {
                errorEl.textContent = errorMessage || "Invalid value";
                errorEl.classList.remove("hidden");
            } else {
                errorEl.textContent = "";
                errorEl.classList.add("hidden");
            }
        }
    }
    updateSubmitButton(isFormValid) {
        if (!this.hasSubmitTarget) return;
        this.submitTarget.disabled = !isFormValid;
        if (isFormValid) {
            this.submitTarget.classList.remove("opacity-50", "cursor-not-allowed", "bg-gray-600");
            this.submitTarget.classList.add("hover:bg-gray-900", "bg-black");
        } else {
            this.submitTarget.classList.add("opacity-50", "cursor-not-allowed", "bg-gray-600");
            this.submitTarget.classList.remove("hover:bg-gray-900", "bg-black");
        }
    }
}



const $ac53d7f40e30149d$var$MAX_FILE_SIZE = 5242880; // 5MB
const $ac53d7f40e30149d$var$MIN_IMAGE_DIMENSION = 200; // 200px
const $ac53d7f40e30149d$var$ALLOWED_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png"
];
class $ac53d7f40e30149d$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "fileInput",
        "cameraInput",
        "uploadArea",
        "cameraButton",
        "cameraView",
        "video",
        "previewArea",
        "previewIcon",
        "previewImage",
        "fileName",
        "fileSize",
        "submitButton",
        "errorMessage",
        "bottomActions",
        "dataUriInput"
    ];
    disconnect() {
        this.stopCameraStream();
    }
    selectFile() {
        this.fileInputTarget.click();
    }
    capturePhoto() {
        this.clearError();
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            this.cameraInputTarget.click();
            return;
        }
        navigator.mediaDevices.getUserMedia({
            video: {
                facingMode: "environment"
            }
        }).then((stream)=>{
            this.stream = stream;
            this.videoTarget.srcObject = stream;
            this.uploadAreaTarget.classList.add("hidden");
            this.cameraButtonTarget.classList.add("hidden");
            this.bottomActionsTarget.classList.add("hidden");
            this.cameraViewTarget.classList.remove("hidden");
        }).catch(()=>{
            this.cameraInputTarget.click();
        });
    }
    takePicture() {
        const video = this.videoTarget;
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0);
        this.stopCameraStream();
        this.cameraViewTarget.classList.add("hidden");
        canvas.toBlob((blob)=>{
            if (!blob) {
                this.showError("Could not capture photo. Please try again.");
                return;
            }
            const file = new File([
                blob
            ], "photo.jpg", {
                type: "image/jpeg"
            });
            this.processFile(file);
        }, "image/jpeg", 0.92);
    }
    cancelCamera() {
        this.stopCameraStream();
        this.cameraViewTarget.classList.add("hidden");
        this.uploadAreaTarget.classList.remove("hidden");
        this.cameraButtonTarget.classList.remove("hidden");
        this.bottomActionsTarget.classList.remove("hidden");
    }
    stopCameraStream() {
        if (this.stream) {
            this.stream.getTracks().forEach((track)=>track.stop());
            this.stream = null;
        }
    }
    handleFileSelected(event) {
        const file = event.target.files[0];
        if (!file) return;
        this.processFile(file);
    }
    handleCameraCapture(event) {
        const file = event.target.files[0];
        if (!file) return;
        this.processFile(file);
    }
    processFile(file) {
        this.clearError();
        if (!$ac53d7f40e30149d$var$ALLOWED_TYPES.includes(file.type)) {
            this.showError("Please select a PDF, JPEG, or PNG file.");
            return;
        }
        if (file.size > $ac53d7f40e30149d$var$MAX_FILE_SIZE) {
            this.showError("File must be smaller than 5MB.");
            return;
        }
        const reader = new FileReader();
        reader.onload = (e)=>{
            const dataUri = e.target.result;
            if (file.type.startsWith("image/")) this.validateImageAndShow(file, dataUri);
            else {
                this.dataUriInputTarget.value = dataUri;
                this.showFilePreview(file, null);
            }
        };
        reader.onerror = ()=>{
            this.showError("Could not read file. Please try again.");
        };
        reader.readAsDataURL(file);
    }
    validateImageAndShow(file, dataUri) {
        const img = new Image();
        img.onload = ()=>{
            if (img.width < $ac53d7f40e30149d$var$MIN_IMAGE_DIMENSION || img.height < $ac53d7f40e30149d$var$MIN_IMAGE_DIMENSION) {
                this.showError(`Image must be at least ${$ac53d7f40e30149d$var$MIN_IMAGE_DIMENSION}x${$ac53d7f40e30149d$var$MIN_IMAGE_DIMENSION} pixels.`);
                return;
            }
            this.dataUriInputTarget.value = dataUri;
            this.showFilePreview(file, dataUri);
        };
        img.onerror = ()=>{
            this.showError("Could not read image. Please try another file.");
        };
        img.src = dataUri;
    }
    showFilePreview(file, dataUrl) {
        this.fileNameTarget.textContent = file.name;
        this.fileSizeTarget.textContent = this.formatFileSize(file.size);
        if (dataUrl && file.type.startsWith("image/")) {
            this.previewImageTarget.src = dataUrl;
            this.previewImageTarget.classList.remove("hidden");
        } else this.previewImageTarget.classList.add("hidden");
        this.uploadAreaTarget.classList.add("hidden");
        this.cameraButtonTarget.classList.add("hidden");
        this.bottomActionsTarget.classList.remove("hidden");
        this.previewAreaTarget.classList.remove("hidden");
        this.submitButtonTarget.removeAttribute("disabled");
    }
    removeFile() {
        this.fileInputTarget.value = "";
        this.cameraInputTarget.value = "";
        this.previewImageTarget.src = "";
        this.dataUriInputTarget.value = "";
        this.previewAreaTarget.classList.add("hidden");
        this.uploadAreaTarget.classList.remove("hidden");
        this.cameraButtonTarget.classList.remove("hidden");
        this.submitButtonTarget.setAttribute("disabled", "disabled");
        this.clearError();
    }
    showError(message) {
        this.errorMessageTarget.textContent = message;
        this.errorMessageTarget.classList.remove("hidden");
        this.fileInputTarget.value = "";
        this.cameraInputTarget.value = "";
        this.dataUriInputTarget.value = "";
        this.uploadAreaTarget.classList.remove("hidden");
        this.cameraButtonTarget.classList.remove("hidden");
        this.bottomActionsTarget.classList.remove("hidden");
    }
    clearError() {
        this.errorMessageTarget.textContent = "";
        this.errorMessageTarget.classList.add("hidden");
    }
    formatFileSize(bytes) {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / 1048576).toFixed(1)} MB`;
    }
}



class $81d0eea0444ea03d$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "button",
        "form",
        "email"
    ];
    static values = {
        posturl: String,
        verifyurl: String
    };
    initialize() {
        this.handleButtonClick = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const email = this.emailTarget?.value?.trim();
            if (!email || !this.isValidEmail(email)) {
                this.emailTarget.setCustomValidity("Please enter a valid email address");
                this.formTarget.reportValidity();
                return;
            }
            this.emailTarget.setCustomValidity("");
            if (this.hasPosturlValue) this.formTarget.action = this.posturlValue;
            // 3) Submit (fires 'submit' event, honors constraints, works with Turbo)
            this.formTarget.requestSubmit();
        };
        // Auto-clean zero-width spaces on any input change
        this.handleInput = (e)=>{
            const cleaned = e.target.value.replaceAll('\u200b', '');
            if (cleaned !== e.target.value) e.target.value = cleaned;
        };
    }
    // Simple email validation - checks for basic pattern
    isValidEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }
    connect() {
        if (this.hasFormTarget && this.hasPosturlValue) this.formTarget.action = this.posturlValue;
        if (this.hasButtonTarget) this.buttonTarget.addEventListener("click", this.handleButtonClick);
        if (this.hasEmailTarget) this.emailTarget.addEventListener("input", this.handleInput);
    }
    disconnect() {
        if (this.hasButtonTarget) this.buttonTarget.removeEventListener("click", this.handleButtonClick);
        if (this.hasEmailTarget) this.emailTarget.removeEventListener("input", this.handleInput);
    }
}



class $55396f0c8de899b2$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "textinput"
    ];
    static values = {
        max: Number,
        min: Number
    };
    connect() {
        // Add input event listener to validate against max value
        if (this.hasTextinputTarget) this.textinputTarget.addEventListener('input', this.validateAmount.bind(this));
    }
    insertMaxAmount() {
        if (this.hasTextinputTarget && this.hasMaxValue) {
            // Use max amount, but ensure it's at least the minimum value
            const amountToInsert = Math.max(this.maxValue, this.minValue);
            this.textinputTarget.value = amountToInsert.toFixed(2);
            this.textinputTarget.focus();
            // Trigger input event so other controllers (like money controller) can respond
            this.textinputTarget.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        }
    }
    validateAmount(event) {
        if (!this.hasMaxValue) return;
        const inputValue = Number.parseFloat(event.target.value);
        // Only validate max if the input is a valid number and exceeds max
        if (!Number.isNaN(inputValue) && inputValue > this.maxValue) {
            event.target.value = this.maxValue.toFixed(2);
            // Trigger input event so other controllers can respond to the capped value
            event.target.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        }
        if (!Number.isNaN(inputValue) && inputValue < this.minValue) {
            const inputString = event.target.value;
            const isCompleteDecimal = /^\d+\.\d{2}$/.test(inputString); // e.g., "1.50", "12.34"
            const isLargeWholeNumber = /^\d{2,}$/.test(inputString); // e.g., "10", "100", "1000"
            if (isCompleteDecimal || isLargeWholeNumber) {
                event.target.value = this.minValue.toFixed(2);
                // Trigger input event so other controllers can respond to the capped value
                event.target.dispatchEvent(new Event('input', {
                    bubbles: true
                }));
            }
        }
    }
}



const $fe2fe4bc73a31ff9$export$8dc9e36fea1ab1e4 = {
    TOPPER: `<svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M26.4987 17.1153C27.5671 18.9659 26.933 21.3323 25.0824 22.4007L20.4427 25.0794C18.5921 26.1479 16.2258 25.5138 15.1574 23.6632C14.0889 21.8126 14.723 19.4463 16.5736 18.3779L21.2133 15.6991C23.0639 14.6307 25.4302 15.2647 26.4987 17.1153ZM21.429 8.33364C22.4974 10.1842 21.8633 12.5506 20.0127 13.619L9.18526 19.8703C7.33465 20.9387 4.96831 20.3047 3.89987 18.4541C2.83144 16.6035 3.46549 14.2371 5.31608 13.1687L16.1436 6.91745C17.9942 5.84902 20.3605 6.48307 21.429 8.33364Z" fill="#84FB7F"/></svg>`,
    MERCURYO: `<svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="8" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.4605 8.54405C12.6288 7.86949 14.1808 8.22971 15.6994 9.2323C16.6081 9.8323 17.526 10.676 18.3817 11.7103C18.7788 10.8713 18.9909 9.94735 18.991 9.00137H19.5189C19.5189 10.6808 20.1858 12.2912 21.3733 13.4788C22.5609 14.6664 24.1719 15.3339 25.8514 15.3339V15.8618C24.2532 15.8618 22.7178 16.4665 21.5495 17.5483C21.8413 18.5024 22.0157 19.4197 22.0661 20.2595C22.1567 21.7701 21.8499 23.0776 21.0724 23.8633L21.0777 23.8686C20.8925 24.0538 20.6822 24.2037 20.4525 24.3229C20.3969 24.3521 20.3404 24.3787 20.2831 24.4034C20.2595 24.4137 20.2357 24.4234 20.2117 24.4331C20.1798 24.4457 20.1476 24.4575 20.1153 24.4688C19.2025 24.7988 18.0382 24.712 16.8047 24.3009C15.0647 23.721 13.1184 22.4833 11.3685 20.7335C9.61882 18.9838 8.38194 17.0367 7.80271 15.2967C7.22818 13.5705 7.28247 11.9783 8.23647 11.0259C8.73525 10.528 9.40875 10.2773 10.1842 10.232C10.4281 9.48864 10.8462 8.89873 11.4605 8.54405ZM10.5079 10.6521C10.3725 11.1925 10.3218 11.8254 10.3643 12.533C10.4694 14.2844 11.1356 16.4209 12.347 18.5191C13.5584 20.6174 15.0754 22.2623 16.5395 23.229C18.0063 24.1974 19.3583 24.4491 20.3097 23.9127C20.3253 23.9041 20.34 23.8943 20.3553 23.8854C21.2888 23.3263 21.7433 22.0329 21.6384 20.2846C21.5939 19.5449 21.4487 18.7368 21.2054 17.8917C20.1232 19.06 19.5189 20.5959 19.5189 22.1944H18.991C18.991 20.5149 18.3234 18.9038 17.1359 17.7162C15.9483 16.5288 14.3378 15.8619 12.6584 15.8618V15.3339C14.2134 15.3338 15.7081 14.7606 16.8639 13.7333C15.3688 12.4094 13.7898 11.4725 12.3736 11.0008C11.6963 10.7753 11.0679 10.6598 10.5079 10.6521ZM10.0627 10.6696C9.4362 10.7322 8.91647 10.9513 8.53882 11.3282C7.7612 12.1043 7.65044 13.4839 8.20913 15.1622C8.76331 16.8267 9.95885 18.7183 11.6717 20.4312C13.2692 22.0287 15.0219 23.1755 16.6011 23.7729C16.5021 23.7132 16.4028 23.6513 16.304 23.5861C14.7736 22.5756 13.2137 20.8766 11.9763 18.7334C10.7388 16.59 10.0472 14.3896 9.93735 12.5588C9.89652 11.8783 9.93578 11.2388 10.0627 10.6696ZM15.4639 9.58934C13.9878 8.61474 12.6271 8.3649 11.6747 8.91477C11.2093 9.18348 10.8611 9.63206 10.6385 10.2267C11.2248 10.25 11.8572 10.3774 12.5088 10.5944C13.9975 11.0902 15.6367 12.0682 17.1754 13.4363C17.5649 13.0395 17.8964 12.5971 18.166 12.1213C17.3019 11.0519 16.373 10.1896 15.4639 9.58934Z" fill="white"/></svg>`,
    STRIPE: `<svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="8" fill="#635BFF"/><path d="M14.688 13.024c0-.832.688-1.152 1.824-1.152 1.632 0 3.696.496 5.328 1.376V8.56C20.208 7.84 18.384 7.2 16 7.2c-4.16 0-6.944 2.176-6.944 5.808 0 5.664 7.808 4.752 7.808 7.2 0 .976-.848 1.296-2.032 1.296-1.76 0-4-.72-5.776-1.696v4.736c1.968.848 3.952 1.2 5.776 1.2 4.288 0 7.232-2.112 7.232-5.792-.016-6.112-7.376-5.024-7.376-6.928z" fill="white"/></svg>`,
    TRANSAK: `<svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="8" fill="#0A1F44"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.4605 8.54405C12.6288 7.86949 14.1808 8.22971 15.6994 9.2323C16.6081 9.8323 17.526 10.676 18.3817 11.7103C18.7788 10.8713 18.9909 9.94735 18.991 9.00137H19.5189C19.5189 10.6808 20.1858 12.2912 21.3733 13.4788C22.5609 14.6664 24.1719 15.3339 25.8514 15.3339V15.8618C24.2532 15.8618 22.7178 16.4665 21.5495 17.5483C21.8413 18.5024 22.0157 19.4197 22.0661 20.2595C22.1567 21.7701 21.8499 23.0776 21.0724 23.8633L21.0777 23.8686C20.8925 24.0538 20.6822 24.2037 20.4525 24.3229C20.3969 24.3521 20.3404 24.3787 20.2831 24.4034C20.2595 24.4137 20.2357 24.4234 20.2117 24.4331C20.1798 24.4457 20.1476 24.4575 20.1153 24.4688C19.2025 24.7988 18.0382 24.712 16.8047 24.3009C15.0647 23.721 13.1184 22.4833 11.3685 20.7335C9.61882 18.9838 8.38194 17.0367 7.80271 15.2967C7.22818 13.5705 7.28247 11.9783 8.23647 11.0259C8.73525 10.528 9.40875 10.2773 10.1842 10.232C10.4281 9.48864 10.8462 8.89873 11.4605 8.54405ZM10.5079 10.6521C10.3725 11.1925 10.3218 11.8254 10.3643 12.533C10.4694 14.2844 11.1356 16.4209 12.347 18.5191C13.5584 20.6174 15.0754 22.2623 16.5395 23.229C18.0063 24.1974 19.3583 24.4491 20.3097 23.9127C20.3253 23.9041 20.34 23.8943 20.3553 23.8854C21.2888 23.3263 21.7433 22.0329 21.6384 20.2846C21.5939 19.5449 21.4487 18.7368 21.2054 17.8917C20.1232 19.06 19.5189 20.5959 19.5189 22.1944H18.991C18.991 20.5149 18.3234 18.9038 17.1359 17.7162C15.9483 16.5288 14.3378 15.8619 12.6584 15.8618V15.3339C14.2134 15.3338 15.7081 14.7606 16.8639 13.7333C15.3688 12.4094 13.7898 11.4725 12.3736 11.0008C11.6963 10.7753 11.0679 10.6598 10.5079 10.6521ZM10.0627 10.6696C9.4362 10.7322 8.91647 10.9513 8.53882 11.3282C7.7612 12.1043 7.65044 13.4839 8.20913 15.1622C8.76331 16.8267 9.95885 18.7183 11.6717 20.4312C13.2692 22.0287 15.0219 23.1755 16.6011 23.7729C16.5021 23.7132 16.4028 23.6513 16.304 23.5861C14.7736 22.5756 13.2137 20.8766 11.9763 18.7334C10.7388 16.59 10.0472 14.3896 9.93735 12.5588C9.89652 11.8783 9.93578 11.2388 10.0627 10.6696ZM15.4639 9.58934C13.9878 8.61474 12.6271 8.3649 11.6747 8.91477C11.2093 9.18348 10.8611 9.63206 10.6385 10.2267C11.2248 10.25 11.8572 10.3774 12.5088 10.5944C13.9975 11.0902 15.6367 12.0682 17.1754 13.4363C17.5649 13.0395 17.8964 12.5971 18.166 12.1213C17.3019 11.0519 16.373 10.1896 15.4639 9.58934Z" fill="white"/></svg>`,
    // The source asset clipped to a 24×24 rect that every path already sits inside, so the clipPath
    // is dropped: it changed nothing visually and its fixed id would repeat once per quote card.
    SWAPPED: `<svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.05572 4H20.3513C20.463 4.04792 20.7682 4.0534 20.908 4.08022C21.7376 4.23934 22.5965 4.59156 23.2584 5.12242C23.8774 5.61884 24.4377 6.234 25.0007 6.79505L25.9569 7.75102C26.2298 8.02409 26.5095 8.28976 26.743 8.5899C27.463 9.51561 27.8762 10.6555 27.8853 11.83C27.8865 11.9773 27.887 12.1278 27.8871 12.2767L27.8867 13.3482L27.8865 16.822L27.8864 20.9168L27.8867 22.2099C27.8868 23.0398 27.8742 23.7076 27.5842 24.5057C27.0921 25.8898 26.067 27.0196 24.7374 27.644C24.5175 27.7475 24.2906 27.8356 24.0584 27.9075C24.0107 27.9227 23.7824 27.9856 23.7648 28H10.5788C10.4256 27.9384 10.2201 27.8819 10.0583 27.8242C9.77657 27.7216 9.50436 27.5946 9.24478 27.4446C8.51654 27.0287 8.18271 26.6576 7.60112 26.0757L6.61374 25.0882L5.8606 24.3365C5.78502 24.261 5.70969 24.1841 5.63361 24.1097C4.79921 23.2937 4.23333 22.1976 4.05874 21.0435C4.03954 20.9165 4.0363 20.7604 4 20.64V9.06689C4.02097 8.99561 4.02217 8.95421 4.02876 8.88101C4.08563 8.2496 4.29518 7.57236 4.57985 7.00883C5.26118 5.66284 6.46593 4.65618 7.91159 4.22494C8.1288 4.16152 8.32498 4.11375 8.54765 4.07551C8.68193 4.05245 8.94143 4.04334 9.05572 4ZM22.5612 26.2227C23.5019 26.174 24.3854 25.7562 25.02 25.0601C25.459 24.5768 25.7565 23.9818 25.8795 23.3405C25.9817 22.7883 25.9466 22.0101 25.9462 21.4304L25.9461 18.6756V14.1476L25.9462 12.6701C25.9462 12.3827 25.9535 12.0633 25.9389 11.7784C25.8932 10.8335 25.4715 9.94606 24.7677 9.31386C24.2582 8.85628 23.6198 8.55377 22.9451 8.44655C22.6584 8.401 22.3716 8.40368 22.0829 8.40354L21.2342 8.4036L18.2288 8.40413L13.9351 8.40426L12.5683 8.40353C12.3453 8.40333 12.0258 8.38686 11.8081 8.40914C10.8214 8.45735 9.97432 8.86844 9.31136 9.59966C8.87518 10.0832 8.58191 10.6784 8.46423 11.3189C8.37839 11.8038 8.40503 12.5774 8.40506 13.0934L8.40525 15.7903L8.40498 20.3712L8.40513 21.8477C8.40519 22.1956 8.40006 22.5411 8.41719 22.8875C8.49546 24.4706 9.71735 25.8621 11.272 26.1593C11.8223 26.2644 12.5037 26.2277 13.0727 26.2274L15.5344 26.2272L20.1478 26.2275H21.6638C21.9562 26.2275 22.2708 26.2331 22.5612 26.2227Z" fill="white"/><path d="M16.1523 12.7626C16.1935 12.7564 16.2759 12.7566 16.3187 12.761C16.5361 12.7845 16.7349 12.8939 16.8709 13.0649C17.1424 13.4034 17.0356 13.9793 17.054 14.3914C17.0618 14.567 17.0656 14.8924 17.048 15.0643C17.6651 15.0515 18.302 15.0702 18.923 15.0627C19.2729 15.075 19.6537 15.0369 19.9984 15.0816C20.3171 15.1228 20.6551 15.4995 20.6387 15.8213C20.5911 16.7625 19.8829 16.6704 19.1864 16.6704L17.878 16.6695L15.336 16.6693L14.5882 16.6705C14.4102 16.6707 14.2414 16.6762 14.062 16.6568C13.4565 16.5914 13.1555 15.8806 13.5129 15.3953C13.6316 15.234 13.7709 15.0905 13.906 14.9406L14.6086 14.1626L15.2988 13.3962C15.5713 13.0934 15.7289 12.8333 16.1523 12.7626Z" fill="white"/><path d="M14.1667 18.1162C14.5815 18.101 15.0616 18.1124 15.4833 18.1125L17.8821 18.1123L19.2333 18.1122C19.6072 18.1122 20.1203 18.0471 20.4054 18.3229C20.8181 18.7217 20.7009 19.2739 20.3078 19.6322C20.2431 19.6911 20.1707 19.7949 20.1058 19.8634C19.7262 20.2634 19.369 20.689 18.993 21.092C18.9074 21.1604 18.8534 21.2515 18.7804 21.3317C18.6456 21.4779 18.5136 21.6306 18.3742 21.7719C17.9085 22.2439 17.1209 22.0034 16.9958 21.3514C16.9505 21.1156 16.9684 20.879 16.9684 20.6412C16.9664 20.3331 16.968 20.0252 16.9736 19.7173C16.3524 19.7247 15.7208 19.7162 15.0986 19.7194C14.8968 19.7204 14.2604 19.7331 14.0894 19.7048C13.9471 19.6816 13.8127 19.6237 13.6982 19.5359C13.5349 19.4099 13.4371 19.227 13.4159 19.0238C13.3633 18.5199 13.6769 18.1654 14.1667 18.1162Z" fill="white"/></svg>`
};
const $fe2fe4bc73a31ff9$export$e7b967560105a26c = Object.fromEntries(Object.entries($fe2fe4bc73a31ff9$export$8dc9e36fea1ab1e4).map(([k, v])=>[
        k,
        v.replace(/width="20" height="20"/, 'width="16" height="16"')
    ]));
function $fe2fe4bc73a31ff9$export$df1b618a159acd91(name) {
    if (!name) return "\u2014";
    const known = {
        MOONPAY: "MoonPay",
        TOPPER: "Topper",
        TRANSAK: "Transak",
        BANXA: "Banxa",
        SARDINE: "Sardine",
        WERT: "Wert",
        STRIPE: "Stripe",
        MERCURYO: "Mercuryo"
    };
    return known[name] || name.charAt(0) + name.slice(1).toLowerCase();
}
function $fe2fe4bc73a31ff9$export$93c22668779c2a44(url) {
    if (!url) return;
    let embedded;
    try {
        embedded = window.top !== window.self;
    } catch  {
        embedded = true;
    }
    if (embedded) try {
        window.top.location.href = url;
        return;
    } catch  {}
    window.location.href = url;
}
function $fe2fe4bc73a31ff9$export$3fa72122dee1877c(quote) {
    const dest = parseFloat(quote.destinationAmount) || 0;
    const src = parseFloat(quote.sourceAmount) || 0;
    return src > 0 ? dest / src : dest;
}
const $fe2fe4bc73a31ff9$export$ad39b96a630179ee = {
    CREDIT_DEBIT_CARD: "Card",
    BANK_TRANSFER: "Bank Transfer",
    APPLE_PAY: "Apple Pay",
    GOOGLE_PAY: "Google Pay"
};
const $fe2fe4bc73a31ff9$export$5b9fb8b4d0641f37 = {
    TOPPER: "by Uphold",
    MERCURYO: "by Mercuryo",
    STRIPE: "by Link",
    TRANSAK: "by Transak",
    MOONPAY: "by MoonPay",
    BANXA: "by Banxa",
    SARDINE: "by Sardine"
};


class $a4855fc25d0b7643$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "providerList",
        "continueBtnText",
        "selectedProviderInput",
        "selectedMethodInput"
    ];
    // Translated copy written into the DOM by this controller. {provider} is
    // substituted with the chosen provider's display name.
    static values = {
        continueWith: String
    };
    connect() {
        const raw = sessionStorage.getItem("meld_quotes");
        if (!raw) {
            window.location.href = "/meld";
            return;
        }
        this._quotes = this._sortQuotes(JSON.parse(raw));
        this._selectedIdx = 0;
        const savedProvider = sessionStorage.getItem("meld_selected_provider");
        const savedMethod = sessionStorage.getItem("meld_selected_method");
        if (savedProvider) {
            const idx = this._quotes.findIndex((q)=>q.serviceProvider === savedProvider && (!savedMethod || q.paymentMethodType === savedMethod));
            if (idx >= 0) this._selectedIdx = idx;
        }
        this._render();
    }
    select(event) {
        const idx = parseInt(event.currentTarget.dataset.idx, 10);
        if (isNaN(idx)) return;
        this._selectedIdx = idx;
        const q = this._quotes[idx];
        this.selectedProviderInputTarget.value = q.serviceProvider;
        this.selectedMethodInputTarget.value = q.paymentMethodType || "";
        this._highlightSelected();
        this._updateContinueBtn();
    }
    // ── Private ───────────────────────────────────────────────
    _sortQuotes(quotes) {
        return [
            ...quotes
        ].sort((a, b)=>{
            // Same ranking the picker uses. Matters here because the list can come from the
            // express (reverse) quote, where each provider has its own sourceAmount.
            const vDiff = (0, $fe2fe4bc73a31ff9$export$3fa72122dee1877c)(b) - (0, $fe2fe4bc73a31ff9$export$3fa72122dee1877c)(a);
            if (vDiff !== 0) return vDiff;
            const aLow = a.lowKyc ? 1 : 0;
            const bLow = b.lowKyc ? 1 : 0;
            if (bLow !== aLow) return bLow - aLow;
            const rateDiff = (parseFloat(b.exchangeRate) || 0) - (parseFloat(a.exchangeRate) || 0);
            if (rateDiff !== 0) return rateDiff;
            return (b.customerScore || 0) - (a.customerScore || 0);
        });
    }
    _render() {
        this.providerListTarget.innerHTML = this._quotes.map((q, i)=>this._cardHTML(q, i)).join("");
        const selected = this._quotes[this._selectedIdx] || this._quotes[0];
        if (selected) {
            this.selectedProviderInputTarget.value = selected.serviceProvider;
            this.selectedMethodInputTarget.value = selected.paymentMethodType || "";
        }
        this._updateContinueBtn();
    }
    _cardHTML(q, i) {
        const selected = i === this._selectedIdx;
        const icon = (0, $fe2fe4bc73a31ff9$export$8dc9e36fea1ab1e4)[q.serviceProvider] || "";
        const name = (0, $fe2fe4bc73a31ff9$export$df1b618a159acd91)(q.serviceProvider);
        const method = (0, $fe2fe4bc73a31ff9$export$ad39b96a630179ee)[q.paymentMethodType] || q.paymentMethodType || "";
        const destAmt = parseFloat(q.destinationAmount || 0);
        // Shown as dollars, matching the picker's "You receive": the destination is a dollar
        // stablecoin, and "$114.50" is read at a glance where "114.50 USDC" is decoded.
        const amtStr = destAmt > 0 ? "$" + new Intl.NumberFormat(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(destAmt) : "\u2014";
        const borderCls = selected ? "dark:border-dark-primary-color wdark:border-wdark-primary-color" : "dark:border-dark-input-border wdark:border-wdark-input-border";
        const badge = i === 0 ? `<span class="text-[10px] font-bold px-1.5 py-0.5 rounded uppercase
                 dark:bg-dark-input-background wdark:bg-wdark-input-background
                 dark:text-dark-primary-color wdark:text-wdark-primary-color">
                 Recommended
               </span>` : "";
        return `
        <div data-action="click->meld-compare#select"
             data-idx="${i}"
             class="flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition-colors
               dark:bg-dark-secondary-color wdark:bg-wdark-secondary-color ${borderCls}">
          <div class="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded overflow-hidden">
            ${icon}
          </div>
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 flex-wrap">
              <span class="font-semibold text-sm dark:text-dark-text-and-title wdark:text-wdark-text-and-title">${name}</span>
              ${badge}
            </div>
            <p class="text-xs mt-0.5 dark:text-dark-passive-color-text-1 wdark:text-wdark-passive-color-text-1">${method}</p>
          </div>
          <div class="flex-shrink-0 text-right">
            <p class="font-semibold text-sm dark:text-dark-text-and-title wdark:text-wdark-text-and-title">${amtStr}</p>
            <p class="text-xs dark:text-dark-passive-color-text-1 wdark:text-wdark-passive-color-text-1">you receive</p>
          </div>
        </div>`;
    }
    _highlightSelected() {
        this.providerListTarget.querySelectorAll("[data-idx]").forEach((el, i)=>{
            el.classList.remove("dark:border-dark-primary-color", "wdark:border-wdark-primary-color", "dark:border-dark-input-border", "wdark:border-wdark-input-border");
            if (i === this._selectedIdx) el.classList.add("dark:border-dark-primary-color", "wdark:border-wdark-primary-color");
            else el.classList.add("dark:border-dark-input-border", "wdark:border-wdark-input-border");
        });
    }
    _updateContinueBtn() {
        if (!this._quotes.length) return;
        const q = this._quotes[this._selectedIdx] || this._quotes[0];
        const pattern = this.continueWithValue || "Continue With {provider}";
        this.continueBtnTextTarget.textContent = pattern.replace("{provider}", (0, $fe2fe4bc73a31ff9$export$df1b618a159acd91)(q.serviceProvider));
    }
}




class $0ba1a370a0e980c0$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "providerIcon",
        "feeBreakdown",
        "feeArrow",
        "providerOverlay",
        "providerFrame"
    ];
    static values = {
        provider: String,
        lowKyc: Boolean
    };
    connect() {
        this._widgetUrl = sessionStorage.getItem("meld_widget_url");
        if (!this._widgetUrl) {
            Turbo.visit("/meld", {
                action: "replace"
            });
            return;
        }
        this._onCloseOverlay = ()=>{
            this.providerOverlayTarget.removeAttribute("open");
            this.providerFrameTarget.src = "";
        };
        window.addEventListener("meld:close-overlay", this._onCloseOverlay);
        this._renderProviderIcon();
    }
    disconnect() {
        if (this._onCloseOverlay) window.removeEventListener("meld:close-overlay", this._onCloseOverlay);
    }
    toggleFees() {
        const expanded = this.feeBreakdownTarget.style.display !== "none";
        this.feeBreakdownTarget.style.display = expanded ? "none" : "";
        this.feeArrowTarget.style.transform = expanded ? "rotate(0deg)" : "rotate(180deg)";
    }
    confirmAndPay() {
        if (!this._widgetUrl) return;
        // Keep the user inside the wallet: desktop opens a popup on top of the app, mobile /
        // PWA does a full-page load in the same window. Never an iframe (provider CSP
        // frame-ancestors blocks it and breaks Apple Pay / camera KYC). Completion comes
        // back via the Meld webhook (deposit_confirmed).
        (0, $fe2fe4bc73a31ff9$export$93c22668779c2a44)(this._widgetUrl);
    }
    _renderProviderIcon() {
        if (!this.hasProviderIconTarget) return;
        const icon = (0, $fe2fe4bc73a31ff9$export$8dc9e36fea1ab1e4)[this.providerValue];
        if (icon) this.providerIconTarget.innerHTML = icon;
        else {
            const badge = document.createElement("span");
            badge.className = "inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold dark:bg-dark-primary-color wdark:bg-wdark-primary-color dark:text-dark-button-text-and-icon wdark:text-wdark-button-text-and-icon";
            badge.textContent = (this.providerValue || "?")[0].toUpperCase();
            this.providerIconTarget.replaceChildren(badge);
        }
    }
}





// meldOpensProviderDirectly reports whether the express flow should open the provider straight
// after creating the session instead of showing Confirm & Pay (CS-3534). The server decides
// skipConfirm (buy-checkout handoff, one allowed provider, all-in total shown); the page still keeps
// Confirm unless express is running on that all-in pay-in, so the provider opens on exactly the
// total the checkout showed.
function $f0015b71e2f21062$export$3a0d0d145c682000({ skipConfirm: skipConfirm, express: express, payIn: payIn }) {
    return Boolean(skipConfirm && express && payIn > 0);
}


// Country codes Meld serves that have no Unicode flag: AN was withdrawn from ISO 3166, XK is
// user-assigned. See _countryFlag.
const $b4a20be47a536640$var$MELD_COUNTRIES_WITHOUT_FLAG = new Set([
    "AN",
    "XK"
]);
// Quick-amount chips. The ladder is the one shown for dollars and euros; the shape is its rungs
// as multiples of the first, so any other currency can be given the same ladder in its own money.
const $b4a20be47a536640$var$MELD_PRESET_LADDER = [
    50,
    100,
    300,
    500
];
const $b4a20be47a536640$var$MELD_PRESET_SHAPE = $b4a20be47a536640$var$MELD_PRESET_LADDER.map((v)=>v / $b4a20be47a536640$var$MELD_PRESET_LADDER[0]) // 1 · 2 · 6 · 10
;
const $b4a20be47a536640$var$MELD_MAJOR_CURRENCIES = new Set([
    "USD",
    "EUR"
]);
class $b4a20be47a536640$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        // Country header selector
        "countryFlag",
        "countrySearch",
        "countryDropdown",
        "countryDropdownPanel",
        "countrySearchWrapper",
        "countryCode",
        // You pay
        "amountInput",
        "currencySymbol",
        "fiatCurrencyLabel",
        "presetChip",
        "presetRow",
        "limitsLabel",
        "rateLabel",
        // Currency selector (the chip next to the amount)
        "currencyWrapper",
        "currencyDropdown",
        "currencyDropdownPanel",
        "currencyCaret",
        // You receive
        "youReceiveAmount",
        "emptyNotice",
        "purchaseCheck",
        // Provider row (inside you-receive, below separator)
        "providerRow",
        "providerName",
        "providerBestBadge",
        "providerLogoWrapper",
        "seeMoreForm",
        "compareMethodInput",
        "compareAmountInput",
        "compareCurrencyInput",
        "compareProviderInput",
        "compareCountryInput",
        // Provider picker (bottom sheet)
        "providerDropdown",
        "providerList",
        // Countdown
        "stalenessBar",
        "countdownLabel",
        // Footer
        "continueBtn",
        "confirmForm",
        // Provider iframe overlay
        "providerOverlay",
        "providerFrame",
        "providerOverlayTitle",
        // Buy-checkout express: full-card cover while we auto-quote → Confirm & Pay
        "expressLoading"
    ];
    static values = {
        csrf: String,
        checkoutOrigin: String,
        embedToken: String,
        wallet: String,
        destCc: String,
        customerId: String,
        countryCode: String,
        currency: String,
        limits: String,
        paymentMethod: String,
        selectedProvider: String,
        expressAmount: Number,
        expressPayAmount: Number,
        minAmount: Number,
        initialAmount: Number,
        // Translated copy the controller writes into the DOM. Passing it in as a
        // value keeps the strings in the TOML bundles instead of this file.
        countdownLabel: String,
        openingLabel: String,
        purchaseTotal: Number,
        skipConfirm: Boolean
    };
    connect() {
        // Capture the server-rendered button label so a reset restores the
        // translated text rather than an English literal.
        this._continueLabel = this.hasContinueBtnTarget ? this.continueBtnTarget.textContent.trim() : "";
        this._allQuotes = [];
        this._quotes = [];
        this._paymentMethods = [];
        this._selectedMethod = this.paymentMethodValue || "CREDIT_DEBIT_CARD" // card by default — widest coverage (COI-365)
        ;
        this._countries = [];
        this._fiatCode = "USD";
        // Resolved per country from Meld's defaults; also the currency we quote in.
        this._currencyByCountry = new Map();
        // The quotable pay-in currencies of the selected country, in the order the server ranked
        // them (the country's own first). Drives the chip's dropdown.
        this._currencies = [];
        // Set once the shopper picks a currency themselves. An explicit pick outranks the country's
        // default and survives everything except a country change — including the automatic switch
        // to dollars, which exists for currencies nobody can price, not to overrule a choice.
        this._currencyPinned = false;
        // Fiat per destination-token unit, learned from the last quote. Sizes the preset chips
        // for non-USD currencies; 0 until the first quote of a currency lands.
        this._fxRate = 0;
        // Per-currency floors Meld reported on a rejected quote — the only source for currencies
        // its limits feed omits. Survives country switches within the page.
        this._minByCurrency = new Map();
        // The quick-amount chips are drawn once per currency; this guards against a second draw.
        this._presetsRendered = false;
        this._renderedPresets = [];
        // The server's starting amount applies to the country the page opened on, once.
        this._seedUsed = false;
        this._selectedIdx = 0;
        // serviceProvider the user picked explicitly — provider row, picker sheet, or Compare.
        // Stays null while the selection is ours (best rate), so a re-quote is free to move it.
        this._selectedProvider = null;
        // The currency the amount field was last written for. A country change that keeps the
        // currency leaves the shopper's figure alone; only a change of currency reseeds it.
        this._lastSeededCurrency = "";
        this._sessionStarted = false;
        this._platformFee = 0;
        this._lastQuotedAmount = 0;
        this._countdownTimer = null;
        this._fetchDebounce = null;
        this._minAmount = 0;
        this._maxAmount = Infinity;
        // Buy-checkout only: a hard floor equal to the product price (checkout total). Shoppers
        // can raise the amount but never onramp less than what they're paying for. 0 = standalone
        // wallet, no floor.
        this._productMin = 0;
        this._onProviderClick = (e)=>{
            const item = e.target.closest("[data-quote-idx]");
            if (!item) return;
            const idx = parseInt(item.dataset.quoteIdx);
            if (isNaN(idx)) return;
            this._selectedIdx = idx;
            this._selectedProvider = (this._quotes[idx] || {}).serviceProvider || null;
            this._updateQuoteDisplay();
        };
        this.element.addEventListener("click", this._onProviderClick);
        this._onCloseOverlay = ()=>{
            this.providerOverlayTarget.removeAttribute("open");
            this.providerFrameTarget.src = "";
        };
        window.addEventListener("meld:close-overlay", this._onCloseOverlay);
        // Buy-checkout express mode (COI-365): the checkout total is supplied up front, so skip
        // the amount + provider steps — auto-quote, auto-pick (low-KYC first), and land straight
        // on Confirm & Pay. Only the buy embed sets expressAmount>0; the standalone wallet keeps
        // expressAmount=0 and behaves exactly as before. Show the cover immediately so the picker
        // never flashes before we advance.
        this._express = this.hasExpressAmountValue && this.expressAmountValue > 0 || this._expressPayIn() > 0;
        if (this._express) this._showExpressLoading(true);
        this._init();
        const input = this.amountInputTarget;
        if (input.value) {
            const len = input.value.length;
            input.setSelectionRange(len, len);
        }
    }
    disconnect() {
        if (this._countdownTimer) clearInterval(this._countdownTimer);
        if (this._fetchDebounce) clearTimeout(this._fetchDebounce);
        if (this._onProviderClick) this.element.removeEventListener("click", this._onProviderClick);
        if (this._onCloseOverlay) window.removeEventListener("meld:close-overlay", this._onCloseOverlay);
        if (this._onDocumentClick) document.removeEventListener("click", this._onDocumentClick);
        this._closeCurrencyDropdown();
    }
    // ── API ──────────────────────────────────────────────────
    async _apiFetch(method, path, body) {
        const opts = {
            method: method,
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.csrfValue
            }
        };
        // When embedded cross-site, Chrome withholds the session cookie from this XHR, so carry
        // the short-lived session token in X-Session instead (server accepts either). Empty in
        // standalone, where the cookie works and stays HttpOnly.
        if (this.embedTokenValue) opts.headers["X-Session"] = this.embedTokenValue;
        if (body) opts.body = JSON.stringify(body);
        const r = await fetch(path, opts);
        const data = await r.json();
        if (!r.ok) {
            // Carry the parsed body: Meld's rejections name the real limit (INVALID_AMOUNT_TOO_LOW
            // says what the minimum is), which is the only place some currencies report it, and
            // our own structured errors (amount_below_purchase) carry their figures the same way.
            const err = new Error(data.error || data.message || "HTTP " + r.status);
            err.status = r.status;
            err.payload = data;
            throw err;
        }
        return data;
    }
    // ── Init ─────────────────────────────────────────────────
    async _init() {
        try {
            const data = await this._apiFetch("GET", "/meld/api/countries");
            this._countries = Array.isArray(data) ? data : data.countries || [];
            if (!this._countries.length) {
                this._showEmpty();
                return;
            }
            this._buildCountryDropdown();
            const preselected = this.countryCodeValue;
            const initial = preselected ? this._countries.find((c)=>c.countryCode === preselected) || this._countries[0] : this._countries[0];
            // The currency the page was rendered with is the shopper's own pick coming back from
            // Compare or Confirm — the server only sets it after confirming a partner still serves
            // it. Anything else opens on the country's default.
            if (initial) await this._selectCountry(initial, this.currencyValue);
        } catch (e) {
            // In express mode, drop the loading cover and fall back to the picker instead of
            // leaving the shopper on a spinner.
            if (this._express) {
                this._exitExpress();
                return;
            }
            this._showEmpty();
            console.error("meld init failed", e);
        }
    }
    // ── Country ───────────────────────────────────────────────
    _buildCountryDropdown() {
        this.countrySearchTarget.addEventListener("input", ()=>{
            const q = this.countrySearchTarget.value.toLowerCase();
            this._renderCountryItems(this._countries.filter((c)=>(c.name || c.countryName || "").toLowerCase().includes(q) || c.countryCode.toLowerCase().startsWith(q)));
        });
        this._onDocumentClick = (e)=>{
            if (!this.countrySearchWrapperTarget.contains(e.target)) this.countryDropdownPanelTarget.style.display = "none";
            // The panel is fixed, so it is no longer inside the wrapper as far as the DOM is
            // concerned — a click on one of its rows must not count as a click outside.
            const inCurrency = this.hasCurrencyWrapperTarget && this.currencyWrapperTarget.contains(e.target) || this.hasCurrencyDropdownPanelTarget && this.currencyDropdownPanelTarget.contains(e.target);
            if (!inCurrency) this._closeCurrencyDropdown();
        };
        document.addEventListener("click", this._onDocumentClick);
    }
    toggleCountryDropdown() {
        const panel = this.countryDropdownPanelTarget;
        const isOpen = panel.style.display !== "none";
        if (isOpen) panel.style.display = "none";
        else {
            panel.style.display = "";
            this._renderCountryItems(this._countries);
            this.countrySearchTarget.value = "";
            setTimeout(()=>this.countrySearchTarget.focus(), 0);
        }
    }
    _renderCountryItems(list) {
        const dropdown = this.countryDropdownTarget;
        dropdown.replaceChildren();
        list.slice(0, 60).forEach((c)=>{
            const div = document.createElement("div");
            div.className = "meld-country-item";
            div.textContent = this._countryFlag(c.countryCode) + "  " + (c.name || c.countryName) + " (" + c.countryCode + ")";
            div.addEventListener("mousedown", (e)=>{
                e.preventDefault();
                this.countryDropdownPanelTarget.style.display = "none";
                // Which provider pays out most is a fact about the route, and the route just
                // changed: a new country brings its own providers, fees and ranking. Keeping the
                // old pick would go on recommending a provider that was best somewhere else, and
                // could pin one this country is not even served by. Editing the amount clears the
                // pick for the same reason; this is the other half of it.
                this._selectedProvider = null;
                this.selectedProviderValue = "";
                this._selectCountry(c);
            });
            dropdown.appendChild(div);
        });
    }
    async _selectCountry(c, preferredCurrency = "") {
        this.countryCodeTarget.value = c.countryCode;
        this.countryFlagTarget.textContent = this._countryFlag(c.countryCode);
        // A currency pick belongs to the country it was made in: the new country may not even be
        // quotable in it, so the choice goes with the old one.
        this._currencyPinned = false;
        await this._loadFiatForCountry(c.countryCode, preferredCurrency);
    }
    // Flag emoji are built from the country code's regional indicators, which only render for
    // codes Unicode actually assigns a flag to. Meld's list carries two that it doesn't: AN, the
    // Netherlands Antilles, withdrawn from ISO 3166 in 2010, and XK for Kosovo, which is
    // user-assigned rather than official. Both would come out as two blank boxes, so they get the
    // globe instead.
    _countryFlag(cc) {
        const code = (cc || "").toUpperCase();
        if (code.length !== 2 || $b4a20be47a536640$var$MELD_COUNTRIES_WITHOUT_FLAG.has(code)) return "\uD83C\uDF0D";
        return String.fromCodePoint(...[
            ...code
        ].map((ch)=>ch.charCodeAt(0) + 127397));
    }
    // ── Fiat ─────────────────────────────────────────────────
    async _loadFiatForCountry(cc, preferredCurrency = "") {
        // Quote in the country's own currency, so what the shopper types is what the provider
        // charges: 50 RSD prices as 50 dinars, not as 50 dollars. COI-310 had pinned this to USD
        // for provider coverage; that concern is now handled by the USD retry in fetchQuotes,
        // which only kicks in for currencies Meld genuinely cannot price.
        const entry = await this._defaultCurrencyForCountry(cc);
        this._currencies = entry.currencies;
        // A currency handed to us counts as a pick only when it differs from what this country
        // would have opened on anyway. Confirm's back arrow carries the currency it priced in
        // whether or not the shopper chose it, and treating the default as a choice would switch
        // off the dollar fallback for someone who never asked for anything.
        const wanted = (preferredCurrency || "").toUpperCase();
        if (wanted && this._currencies.includes(wanted)) {
            this._fiatCode = wanted;
            this._currencyPinned = wanted !== entry.code;
        } else this._fiatCode = entry.code;
        this._renderCurrencyChip();
        // The old country's rate and chips say nothing about the new one's.
        this._fxRate = 0;
        this._presetsRendered = false;
        this._renderedPresets = [];
        this._applyCurrencyLabels(this._fiatCode);
        this._applyLimitsForCurrency();
        if (this._express) await this._expressQuoteAndAdvance();
        else await this.fetchQuotes();
    }
    // Currency chip + symbol next to the amount, for whatever currency we are quoting in.
    _applyCurrencyLabels(code) {
        const symbol = this._getCurrencySymbol(code);
        this.fiatCurrencyLabelTarget.textContent = code;
        this.currencySymbolTarget.textContent = symbol;
        // Glyphs sit tight against the figure ("$100"), letters can't — "KM100" and "RSD5.000"
        // read as one word. Bosnia's mark and every currency whose symbol is just its code get a
        // space; the dollar and the euro are unchanged.
        this.currencySymbolTarget.style.marginRight = /[A-Za-z]$/.test(symbol) ? "0.22em" : "";
    }
    // The country's pay-in currencies and the bounds of the route serving each, in one call — the
    // server resolves them from the same partner lookup, so switching currency afterwards costs no
    // round trip. Every currency listed is one a partner actually quotes; the list is ranked with
    // the country's own money first. Cached per country for the life of the controller, and for a
    // week on the server. Falls back to USD so a failed lookup never blanks the field.
    async _defaultCurrencyForCountry(cc) {
        const key = (cc || "").toUpperCase();
        if (!key) return {
            code: "USD",
            limits: "[]",
            currencies: [
                "USD"
            ]
        };
        if (this._currencyByCountry.has(key)) {
            const cached = this._currencyByCountry.get(key);
            this.limitsValue = cached.limits;
            return cached;
        }
        let code = "USD";
        let limits = "[]";
        let currencies = [];
        try {
            const data = await this._apiFetch("GET", `/meld/api/defaults?countries=${encodeURIComponent(key)}`);
            const list = Array.isArray(data) ? data : data.items || [];
            const entry = list.find((e)=>(e.countryCode || "").toUpperCase() === key) || list[0];
            if (entry && entry.defaultCurrencyCode) code = entry.defaultCurrencyCode.toUpperCase();
            if (entry && Array.isArray(entry.limits)) limits = JSON.stringify(entry.limits);
            if (entry && Array.isArray(entry.supportedCurrencies)) currencies = entry.supportedCurrencies.map((x)=>String(x).toUpperCase());
        } catch (e) {
            console.error("meld: failed to resolve currency for", key, e);
        }
        // The currency we quote in always has to be offered, even when the lookup failed and left
        // the list empty — otherwise the chip would show a currency its own dropdown denies.
        if (!currencies.includes(code)) currencies = [
            code,
            ...currencies
        ];
        const resolved = {
            code: code,
            limits: limits,
            currencies: currencies
        };
        this._currencyByCountry.set(key, resolved);
        this.limitsValue = limits;
        return resolved;
    }
    // ── Currency ─────────────────────────────────────────────
    // The chip only opens a dropdown when there is something to choose between; with a single
    // quotable currency it stays the plain label it has always been.
    _renderCurrencyChip() {
        if (!this.hasCurrencyCaretTarget) return;
        const selectable = this._currencies.length > 1;
        this.currencyCaretTarget.style.display = selectable ? "" : "none";
        if (!selectable) this._closeCurrencyDropdown();
    }
    toggleCurrencyDropdown(event) {
        if (this._currencies.length < 2) return;
        const panel = this.currencyDropdownPanelTarget;
        if (panel.style.display !== "none") {
            this._closeCurrencyDropdown();
            return;
        }
        this._renderCurrencyItems();
        panel.style.display = "";
        this._currencyAnchor = event ? event.currentTarget : null;
        this._positionCurrencyPanel();
        // The panel is fixed to the viewport so the card can't clip it, which also means it no
        // longer moves with the chip on its own. Anything that shifts the chip has to move it too.
        this._onCurrencyReflow = ()=>this._positionCurrencyPanel();
        window.addEventListener("scroll", this._onCurrencyReflow, true);
        window.addEventListener("resize", this._onCurrencyReflow);
    }
    _closeCurrencyDropdown() {
        if (this.hasCurrencyDropdownPanelTarget) this.currencyDropdownPanelTarget.style.display = "none";
        if (this._onCurrencyReflow) {
            window.removeEventListener("scroll", this._onCurrencyReflow, true);
            window.removeEventListener("resize", this._onCurrencyReflow);
            this._onCurrencyReflow = null;
        }
    }
    // Hangs the panel under the chip, right edges aligned, and never closer than a margin to either
    // side of the screen — the list is wider than the chip, so on a narrow viewport aligning alone
    // would push it off the edge.
    _positionCurrencyPanel() {
        const anchor = this._currencyAnchor;
        if (!anchor) return;
        const margin = 8;
        const rect = anchor.getBoundingClientRect();
        const panel = this.currencyDropdownPanelTarget;
        panel.style.minWidth = `${Math.round(rect.width)}px`;
        const left = Math.min(Math.max(margin, rect.right - panel.offsetWidth), Math.max(margin, window.innerWidth - panel.offsetWidth - margin));
        panel.style.top = `${Math.round(rect.bottom + margin)}px`;
        panel.style.left = `${Math.round(left)}px`;
    }
    _renderCurrencyItems() {
        const dropdown = this.currencyDropdownTarget;
        dropdown.replaceChildren();
        this._currencies.forEach((code)=>{
            const div = document.createElement("div");
            div.className = "meld-country-item";
            div.textContent = code === this._fiatCode ? `${code}  \u{2713}` : code;
            div.addEventListener("mousedown", (e)=>{
                e.preventDefault();
                this._closeCurrencyDropdown();
                this._selectCurrency(code);
            });
            dropdown.appendChild(div);
        });
    }
    // Switching currency re-prices everything: the rate, the chips and the limits all belonged to
    // the old money. The amount is left to _applyLimitsForCurrency, which seeds a sensible figure
    // for the new one rather than carrying over a number that means something else.
    async _selectCurrency(code) {
        const next = (code || "").toUpperCase();
        if (!next || next === this._fiatCode) return;
        this._fiatCode = next;
        this._currencyPinned = true;
        this._fxRate = 0;
        this._presetsRendered = false;
        this._renderedPresets = [];
        this._hideEmptyNotice();
        this._applyCurrencyLabels(next);
        this._applyLimitsForCurrency();
        await this.fetchQuotes();
    }
    _applyLimitsForCurrency() {
        try {
            const limits = JSON.parse(this.limitsValue || "[]");
            const entry = limits.find((l)=>l.currencyCode === this._fiatCode);
            if (entry) {
                // Whole units in both directions: a floor of 4.60 becomes 5 and a ceiling of
                // 20,000.99 becomes 20,000, so neither the Min/Max line nor the amount the field
                // snaps to ever carries a stray remainder. Rounding the floor up and the ceiling
                // down keeps both inside the range the partner actually accepts.
                this._minAmount = entry.minimumAmount ? Math.ceil(entry.minimumAmount) : 0;
                this._maxAmount = entry.maximumAmount ? Math.floor(entry.maximumAmount) : Infinity;
            } else {
                this._minAmount = 0;
                this._maxAmount = Infinity;
            }
        // The bounds are shown under the amount (Min · Max) and enforced by clamping the
        // field to them — never by an error message. The quote stays the final gate.
        } catch  {}
        // Minimum Meld itself reported for this currency on an earlier rejection. Meld's limits
        // feed doesn't carry every currency, so for those this is the only real floor we have —
        // and it outranks the feed when both exist, because it comes from the quote engine.
        const learnedMin = this._minByCurrency.get(this._fiatCode) || 0;
        if (learnedMin > 0) this._minAmount = Math.max(this._minAmount || 0, Math.ceil(learnedMin));
        // Buy-checkout floor: the product price is a hard minimum. Raise the effective minimum so
        // presets below it are dropped and the default can't start below what the shopper owes.
        this._productMin = this.hasMinAmountValue && this.minAmountValue > 0 ? this.minAmountValue : 0;
        if (this._productMin > 0) this._minAmount = Math.max(this._minAmount || 0, this._productMin);
        // Chips are drawn once per currency and not re-labelled for cosmetic reasons: a redraw is
        // the flicker where "8 AED" turns into "100" under the user's eyes. Bounds are not
        // cosmetic though — when a minimum arrives late (Meld reports it only on a rejected
        // quote) chips that now sit outside the range are redrawn, because a chip below the
        // floor is a button that can only fail.
        if (!this._presetsRendered && this._presetsAreFinal() || this._renderedPresetsOutOfBounds()) this._renderPresetChips(this._generatePresets());
        this._renderLimitsLabel();
        // The field opens on an amount a person would plausibly deposit — the first quick-amount,
        // 50 where the minimum is 9 — rather than on a bound. A minimum is a constraint, not a
        // suggestion, and a maximum even less so.
        //
        // An amount handed over by the server outranks it, but only the first time: that is the
        // buy-checkout total or the figure carried back from Compare, and it is meant for the
        // country the page opened on. Every later country brings its own currency, where the old
        // number means nothing.
        // The handed-over amount is only honoured when it is usable as-is. Clamping it instead
        // would land the field exactly on a bound — a $20 default against a 106 AED floor becomes
        // "AED 106", which is the one thing the field must never open on.
        const seed = !this._seedUsed && this.hasInitialAmountValue ? this.initialAmountValue : 0;
        this._seedUsed = true;
        const withinBounds = seed > 0 && seed >= (this._minAmount || 0) && seed <= (this._maxAmount || Infinity);
        // A figure is only replaced when the currency it was written in changes. Reseeding on
        // every country was wrong: pick a different country that quotes in the same currency —
        // and USD is now the default in all of them — and the amount the shopper had entered was
        // thrown away for a round default. In the buy checkout that meant a $19.70 purchase
        // reopening as 50.
        //
        // The current value is still put through the new bounds, because the new country's
        // provider limits may not admit it.
        const sameCurrency = this._lastSeededCurrency === this._fiatCode;
        const onScreen = this._parseAmount(this.amountInputTarget.value);
        this._lastSeededCurrency = this._fiatCode;
        if (sameCurrency && onScreen > 0) {
            this.amountInputTarget.value = this._formatAmount(this._clampToLimits(onScreen));
            this.presetChipTargets.forEach((chip)=>chip.classList.remove("meld-preset-chip-active"));
            return;
        }
        const start = withinBounds ? seed : this._defaultAmount();
        // Not rounded: an amount with cents (23.44) must survive a reload as typed. _formatAmount
        // already caps at the currency's own precision.
        this.amountInputTarget.value = this._formatAmount(this._clampToLimits(start));
        this.presetChipTargets.forEach((chip)=>chip.classList.remove("meld-preset-chip-active"));
    }
    // Quick-amounts in the currency being quoted. USD keeps the familiar 20/50/100/200 ladder;
    // every other currency scales that ladder by the rate the last quote implied and rounds to a
    // figure a person would actually pick — so Serbia gets 2.000/5.000/10.000/20.000 RSD instead
    // of four amounts that all sit below the provider minimum. Tiers outside the limits drop out.
    // Every chip is an amount the currency will actually quote: never under its minimum, never
    // over its maximum. A chip outside those bounds is a button that can only fail.
    //
    // Dollars and euros are the exception, by design: their ladder is fixed at 50 · 100 · 300 ·
    // 500 and is never rebuilt, so the two currencies people move between most read the same
    // every time.
    _generatePresets() {
        const min = this._minAmount || 0;
        const max = this._maxAmount || Infinity;
        // Contradictory bounds (a ceiling below the floor) leave no amount that satisfies both,
        // so there is no honest chip to offer — the row stays empty rather than showing a button
        // that can only fail.
        if (max < min) return [];
        const inRange = (list)=>list.filter((v)=>v >= min && v <= max).filter((v, i, all)=>all.indexOf(v) === i) // rounding can collapse two tiers into one
        ;
        let kept = inRange(this._presetTiers());
        // The ladder is built for the currency at large, so on a route with tight bounds most of
        // it can fall outside them. Rebuild it from a round figure above the minimum.
        if (kept.length < 2 && min > 0) kept = inRange($b4a20be47a536640$var$MELD_PRESET_SHAPE.map((m)=>this._baseAboveMin() * m));
        if (kept.length) return kept;
        // Nothing fits: offer a single amount from inside the bounds. Deliberately not the
        // minimum — a chip sitting exactly on the floor reads as the only allowed amount rather
        // than as a suggestion.
        const ceiling = max === Infinity ? min * 4 : max;
        const inside = Math.min(Math.max(this._niceRound((min + ceiling) / 2), min), max);
        return inside > 0 ? [
            inside
        ] : [];
    }
    // Dollars and euros get the fixed ladder: 50 · 100 · 300 · 500. Any other currency gets that
    // same worth of itself — 5.000 · 10.000 · 30.000 · 50.000 dinars — in figures a person would
    // pick.
    //
    // One base is rounded and then multiplied, rather than rounding each rung on its own: round
    // each and the ladder buckles, because neighbouring amounts snap to the same figure. Large
    // numbers therefore appear only where the rate truly puts them — dinars run in thousands,
    // dong in millions, and neither is padding.
    _presetTiers() {
        // The default ladder stands as long as the route's floor is below its first rung: a $9
        // minimum against a $50 chip changes nothing, and redrawing it would only move buttons
        // under the shopper. Once the floor is above that rung the whole ladder is unusable —
        // every chip a button that can only fail — so it is rebuilt from the minimum instead.
        // This applies to USD and EUR too. It did not have to while USD meant the US; now that
        // USD is the default in every country, its floor varies by route like any other.
        if ($b4a20be47a536640$var$MELD_MAJOR_CURRENCIES.has(this._fiatCode) && (this._minAmount || 0) <= $b4a20be47a536640$var$MELD_PRESET_LADDER[0]) return $b4a20be47a536640$var$MELD_PRESET_LADDER;
        // With a rate the ladder is that ladder's worth in this currency; without one (no quote
        // yet) it is built up from the minimum instead.
        const base = this._fxRate > 0 ? this._niceRound($b4a20be47a536640$var$MELD_PRESET_LADDER[0] * this._fxRate) : this._minAmount > 0 ? this._baseAboveMin() : 0;
        return base > 0 ? $b4a20be47a536640$var$MELD_PRESET_SHAPE.map((m)=>base * m) : $b4a20be47a536640$var$MELD_PRESET_LADDER;
    }
    // What the amount field opens on. The first quick-amount that the bounds allow — never a
    // bound itself, in any currency. Dollars and euros keep a fixed ladder, so their chips can
    // sit under a route's floor; the field still opens above it, on a round figure of its own.
    _defaultAmount() {
        const min = this._minAmount || 0;
        const max = this._maxAmount || Infinity;
        const presets = this._renderedPresets.length ? this._renderedPresets : this._generatePresets();
        const usable = presets.find((v)=>v >= min && v <= max);
        if (usable) return usable;
        const aboveMin = min > 0 ? this._baseAboveMin() : 0;
        if (aboveMin > 0 && aboveMin <= max) return aboveMin;
        // Bounds this tight leave the minimum as the only quotable amount.
        return min;
    }
    // A round figure comfortably above the minimum. The first chip is never the minimum itself:
    // an amount sitting exactly on the floor reads as a constraint rather than as a suggestion.
    _baseAboveMin() {
        let base = this._niceRound(this._minAmount * 2);
        while(base <= this._minAmount)base *= 2;
        return base;
    }
    // Snaps to the *nearest* 1 / 2 / 2.5 / 5 / 10 × power of ten, so a converted amount reads like
    // a chosen one (4 812 → 5 000). Nearest rather than up, or the ladder buckles: 50 USD of
    // dinars is 5 850, and rounding that up lands on 10 000 — the same figure 100 USD deserves.
    _niceRound(v) {
        if (!(v > 0)) return 0;
        const mag = Math.pow(10, Math.floor(Math.log10(v)));
        return [
            1,
            2,
            2.5,
            5,
            10
        ].map((s)=>s * mag).reduce((best, candidate)=>Math.abs(candidate - v) < Math.abs(best - v) ? candidate : best);
    }
    // Rate implied by a quote: fiat per unit of the destination stablecoin, i.e. within rounding
    // of fiat per USD. Only ever used to size the preset chips — nothing is priced with it.
    _updateFxRate(q) {
        if (!q) return;
        const src = parseFloat(q.sourceAmount) || 0;
        const dest = parseFloat(q.destinationAmount) || 0;
        if (src <= 0 || dest <= 0) return;
        this._fxRate = src / dest;
        // Only draws the chips that were still waiting on a rate. Chips already on screen are
        // left exactly as they are — this is the redraw the user sees as a flicker.
        if (!this._presetsRendered) this._renderPresetChips(this._generatePresets());
    }
    // Enough to build a ladder that won't have to change: dollars use the fixed one, another
    // currency needs either its own minimum or a rate from a quote.
    _presetsAreFinal() {
        return this._fiatCode === "USD" || this._fxRate > 0 || this._minAmount > 0;
    }
    // True when chips already on screen no longer satisfy the current bounds — the case where a
    // minimum or maximum landed after they were drawn. Dollars and euros keep their fixed ladder,
    // so nothing ever redraws them.
    _renderedPresetsOutOfBounds() {
        if (!this._presetsRendered || !this._renderedPresets.length) return false;
        const min = this._minAmount || 0;
        const max = this._maxAmount || Infinity;
        return this._renderedPresets.some((v)=>v < min || v > max);
    }
    _renderPresetChips(presets) {
        this._presetsRendered = true;
        this._renderedPresets = presets;
        // An empty ladder means no amount satisfies the route's bounds; showing an empty row
        // would just be a gap in the layout.
        if (this.hasPresetRowTarget) this.presetRowTarget.style.visibility = presets.length ? "visible" : "hidden";
        this.presetChipTargets.forEach((chip, i)=>{
            const v = presets[i];
            if (v == null) {
                chip.style.display = "none";
                chip.dataset.amount = "";
                chip.classList.remove("meld-preset-chip-active");
                return;
            }
            chip.style.display = "";
            // The chip carries the exact amount; only its label is shortened.
            chip.dataset.amount = String(v);
            // Plain number, no currency prefix — the currency is already on the amount field and
            // the Min/Max line — and shortened, so a dong chip is "5M" rather than "5,000,000".
            chip.textContent = this._compactAmount(v);
        });
    }
    // Chip labels only: thousands as K, millions as M, one decimal at most. The amount field and
    // every figure that gets quoted keep the full number — this is shorthand for a button, not a
    // rounding of the value.
    _compactAmount(v) {
        if (v >= 1e6) return this._trimTrailingZero(v / 1e6) + "M";
        if (v >= 1e3) return this._trimTrailingZero(v / 1e3) + "K";
        return new Intl.NumberFormat(undefined, {
            maximumFractionDigits: 0
        }).format(v);
    }
    _trimTrailingZero(n) {
        return String(Math.round(n * 10) / 10).replace(/\.0$/, "");
    }
    // _groupInt groups thousands with a comma, always, whatever locale the browser is in.
    //
    // Intl.NumberFormat(undefined, …) cannot be used for anything this field will read back:
    // in tr-TR and sr-RS it groups with a dot, and _parseAmount treats a dot as the decimal
    // mark. A shopper in Turkey typing 20111 got "20.111" back, the next keystroke re-read that
    // dot as decimals, and the value collapsed to 20.11 — the field looked frozen until they
    // deleted it. This field is comma-grouped and dot-decimal in every locale, and the parser
    // agrees with it by construction.
    _groupInt(digits) {
        return String(digits).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    _parseAmount(str) {
        // Strip all formatting characters except the decimal separator
        return Number.parseFloat(String(str).replace(/[^0-9.]/g, "")) || 0;
    }
    _formatAmount(n) {
        if (!n) return "";
        // An amount with a fraction shows every digit the currency has — 32.40 must not collapse
        // to "32.4" when the controller rewrites the field. Whole amounts stay clean ("50", not
        // "50.00"), and a currency without subunits (RSD, JPY) never grows a decimal part.
        const dec = this._currencyDecimals(this._fiatCode);
        const factor = Math.pow(10, dec);
        const rounded = Math.round(n * factor) / factor;
        const hasCents = dec > 0 && Math.round(n * factor) % factor !== 0;
        const whole = Math.trunc(rounded);
        const grouped = this._groupInt(whole);
        if (!hasCents) return grouped;
        const cents = Math.round(Math.abs(rounded - whole) * factor);
        return `${grouped}.${String(cents).padStart(dec, "0")}`;
    }
    onAmountBlur() {
        if (this._fetchDebounce) clearTimeout(this._fetchDebounce);
        // Out-of-range amounts are corrected, not reported: the field snaps to the bound it broke
        // and quotes for that. The Min/Max line above already says what the bounds are, so an
        // error message underneath would only repeat it back after the fact.
        const input = this.amountInputTarget;
        const typed = this._parseAmount(input.value);
        if (!typed) return;
        const raw = this._clampToLimits(typed);
        input.value = this._formatAmount(raw);
        // Re-fetch only when the amount actually changed from the last quoted one — blur fires
        // before the click event, so fetching unconditionally would disable the Continue button
        // right as the user clicks it.
        if (raw !== this._lastQuotedAmount) this.fetchQuotes();
    }
    // narrowSymbol keeps it to "$" rather than "US$" outside en-US; older runtimes reject the
    // option, so fall back to the wide symbol and finally to the code itself (e.g. "RSD").
    _getCurrencySymbol(code) {
        for (const currencyDisplay of [
            "narrowSymbol",
            "symbol"
        ])try {
            const sym = new Intl.NumberFormat(undefined, {
                style: "currency",
                currency: code,
                currencyDisplay: currencyDisplay
            }).formatToParts(0).find((p)=>p.type === "currency")?.value;
            if (sym) return sym;
        } catch  {}
        return code;
    }
    // Fraction digits the currency actually uses (0 for RSD/JPY, 2 for USD/EUR), from Intl so
    // there is no table to maintain. Used for both formatting and what the input accepts.
    _currencyDecimals(code) {
        try {
            return new Intl.NumberFormat(undefined, {
                style: "currency",
                currency: code
            }).resolvedOptions().maximumFractionDigits ?? 2;
        } catch  {
            return 2;
        }
    }
    // "Min €5 · Max €20,000" — the bounds the currency actually allows, under the amount field.
    // Each half appears only once its number is known: with no ceiling reported the line is just
    // the minimum, which is the honest reading of "no maximum on record".
    _renderLimitsLabel() {
        if (!this.hasLimitsLabelTarget) return;
        const parts = [];
        if (this._minAmount > 0) parts.push(`Min ${this._money(this._minAmount)}`);
        if (this._maxAmount > 0 && this._maxAmount !== Infinity) parts.push(`Max ${this._money(this._maxAmount)}`);
        this.limitsLabelTarget.textContent = parts.join(" \xb7 ");
    }
    // "1 EUR = 1.15 USDC" — the conversion rate, with the fees taken out of the pay-in first.
    //
    // Dividing the amount received by the amount paid gives the net result, not a rate: a dollar
    // buying 0.9721 USDC says the dollar lost 3%, when what happened is that fees did. Fees are
    // disclosed on their own line at Confirm; this line is about the conversion.
    _renderRateLabel(q) {
        if (!this.hasRateLabelTarget) return;
        const src = this._sourceAmountWithoutFees(q);
        const dest = parseFloat(q && q.destinationAmount) || 0;
        const destCode = String(q && q.destinationCurrencyCode || this.destCcValue || "").split("_")[0];
        if (src <= 0 || dest <= 0 || !destCode) {
            this.rateLabelTarget.textContent = "";
            return;
        }
        // One unit of a weak currency buys a sliver of a dollar — "1 RSD = 0.0085 USDC" is a
        // number nobody can hold on to. Flip the direction there, so dinars and lira read the way
        // people actually quote them: how much of the currency one dollar costs.
        const rate = dest / src;
        if (rate < 0.1) {
            this.rateLabelTarget.textContent = `1 ${destCode} = ${this._formatRate(src / dest)} ${this._fiatCode}`;
            return;
        }
        this.rateLabelTarget.textContent = `1 ${this._fiatCode} = ${this._formatRate(rate)} ${destCode}`;
    }
    // What the pay-in is worth once fees are set aside. Meld reports it directly on most quotes;
    // where it doesn't, the fee total is subtracted. Falls back to the gross amount so the line
    // still shows something rather than disappearing.
    _sourceAmountWithoutFees(q) {
        if (!q) return 0;
        const net = parseFloat(q.sourceAmountWithoutFees) || parseFloat(q.fiatAmountWithoutFees) || 0;
        if (net > 0) return net;
        const gross = parseFloat(q.sourceAmount) || 0;
        const fees = parseFloat(q.totalFee) || 0;
        return fees > 0 && fees < gross ? gross - fees : gross;
    }
    // Precision follows magnitude: 117 needs no decimals, 1.15 needs two, 0.0085 needs four.
    _formatRate(v) {
        const digits = v >= 100 ? 0 : v >= 1 ? 2 : 4;
        return new Intl.NumberFormat(undefined, {
            maximumFractionDigits: digits
        }).format(v);
    }
    // _money formats an amount with its currency symbol. Alphabetic codes (RSD, TRY as
    // "RSD") read better with a space — "RSD 516"; glyph symbols ($, ₺, €) don't — "$20".
    _money(n) {
        const sym = this._getCurrencySymbol(this._fiatCode);
        const num = new Intl.NumberFormat(undefined, {
            maximumFractionDigits: 0
        }).format(n);
        return /[A-Za-z]$/.test(sym) ? `${sym} ${num}` : `${sym}${num}`;
    }
    // ── Amount input ─────────────────────────────────────────
    onAmountInput() {
        const input = this.amountInputTarget;
        const cursor = input.selectionStart;
        // Strip anything that's not a digit, dot, or comma; no leading separator
        const original = input.value;
        let clean = original.replace(/[^0-9.,]/g, "").replace(/^[.,]+/, "");
        if (original !== clean) {
            const removed = original.length - clean.length;
            input.value = clean;
            const pos = Math.max(0, cursor - removed);
            input.setSelectionRange(pos, pos);
        }
        const raw = this._parseAmount(clean);
        // Group the integer part, but leave the fraction exactly as typed. Formatting the whole
        // value through _formatAmount here padded it back to two decimals, which silently undid
        // every backspace in the cents: deleting the last digit of "50.30" produced "50.3" and
        // this immediately restored the "0", so the field looked frozen. Padding belongs on the
        // way in from the server, not under the user's cursor.
        if (clean) {
            // Commas are grouping in this field; "." is the decimal mark, same as _parseAmount reads it.
            const bare = clean.replace(/,/g, "");
            const dot = bare.indexOf(".");
            const whole = dot === -1 ? bare : bare.slice(0, dot);
            // Fraction digits follow the currency: two for USD/EUR, none for RSD/JPY — where a
            // typed "." is dropped rather than left dangling on a currency that has no subunit.
            const dec = this._currencyDecimals(this._fiatCode);
            const cents = dot === -1 || dec === 0 ? null : bare.slice(dot + 1).replace(/\D/g, "").slice(0, dec);
            const grouped = whole ? this._groupInt(Number.parseInt(whole, 10) || 0) : "";
            const formatted = cents === null ? grouped : `${grouped}.${cents}`;
            if (input.value !== formatted) {
                const lengthDiff = formatted.length - input.value.length;
                input.value = formatted;
                const newCursor = Math.max(0, cursor + lengthDiff);
                input.setSelectionRange(newCursor, newCursor);
            }
        }
        if (this._fetchDebounce) clearTimeout(this._fetchDebounce);
        if (raw > 0) this._fetchDebounce = setTimeout(()=>this._validateAndFetch(), 700);
    }
    _validateAndFetch() {
        const raw = this._parseAmount(this.amountInputTarget.value);
        if (!raw) return;
        // Deliberately does not rewrite the field: onAmountInput already keeps it grouped, and
        // re-formatting here would pad the cents back 700ms after the user deleted them — the
        // same fight, just delayed. fetchQuotes clamps to the limits and corrects the field only
        // when the typed amount is actually out of range.
        this.fetchQuotes();
    }
    onPresetClick(e) {
        const raw = Number.parseFloat(e.currentTarget.dataset.amount) || 0;
        this.amountInputTarget.value = this._formatAmount(raw);
        this.presetChipTargets.forEach((chip)=>{
            chip.classList.toggle("meld-preset-chip-active", chip === e.currentTarget);
        });
        if (this._fetchDebounce) clearTimeout(this._fetchDebounce);
        this.fetchQuotes();
    }
    // ── Quotes ────────────────────────────────────────────────
    async fetchQuotes(isRetry = false) {
        const cc = this.countryCodeTarget.value;
        if (!cc) return;
        // Never send an amount the currency's limits already reject: clamp first and show the
        // corrected figure, so a country switch lands on a quotable amount instead of an error.
        const typed = this._parseAmount(this.amountInputTarget.value);
        const amt = this._clampToLimits(typed);
        if (amt <= 0) return;
        if (amt !== typed) this.amountInputTarget.value = this._formatAmount(amt);
        // A new amount re-ranks the providers, so whoever was selected for the old amount — our
        // auto-pick, a tap in the picker, or a return from Compare — no longer means "best value".
        // Drop the pick so _applyMethodFilter takes the top quote for this amount. The ~30s
        // countdown refresh re-quotes the same amount and therefore keeps the pick.
        if (this._lastQuotedAmount && amt !== this._lastQuotedAmount) this._selectedProvider = null;
        this._lastQuotedAmount = amt;
        if (this._countdownTimer) {
            clearInterval(this._countdownTimer);
            this._countdownTimer = null;
        }
        this._setLoading();
        try {
            let data = await this._requestQuotes(this._fiatCode, amt, cc);
            let quotes = data.quotes || [];
            // Meld prices most local currencies, but not all of them. An OK response with an
            // empty list means the currency/country pair has no providers at all — an amount that
            // is merely out of range comes back as an error status instead — so retry once in USD
            // rather than leaving the shopper with an empty picker. The country keeps USD from
            // then on, so this costs one extra call, once.
            //
            // Never when the shopper chose the currency: this fallback is for a default we picked
            // for them, and silently paying in dollars instead of what they asked for is a
            // different transaction, not a recovery. They get told, and the choice stands.
            if (!quotes.length && this._fiatCode !== "USD" && !this._currencyPinned) {
                const usdData = await this._quoteInUsdInstead(amt, cc);
                if (usdData) {
                    data = usdData;
                    quotes = usdData.quotes;
                }
            }
            // No providers can fill this amount (too low / too high for every provider in
            // this country) — this is now the real min/max signal, since we no longer
            // pre-block on Meld's unreliable per-currency limits.
            if (!quotes.length) {
                this._showEmpty();
                return;
            }
            this._hideEmptyNotice();
            this._platformFee = data.platformFee || 0;
            this._allQuotes = this._sortQuotes(quotes);
            this._updateFxRate(this._allQuotes[0]);
            // Derive unique payment methods preserving sort order
            const seen = new Set();
            this._paymentMethods = this._allQuotes.map((q)=>q.paymentMethodType).filter((m)=>m && !seen.has(m) && seen.add(m));
            // Keep the method the user chose whenever it is still on offer. When it isn't, the
            // row has to follow the quotes actually being shown — labelling card quotes as Bank
            // Transfer would be worse than relabelling. The server says when it dropped the
            // filter, so the switch is traceable instead of looking like the picker forgot.
            if (!this._selectedMethod || !this._paymentMethods.includes(this._selectedMethod)) {
                if (this._selectedMethod) console.info("meld: no quotes for", this._selectedMethod, data.paymentMethodFallback ? "(server dropped the method filter)" : "", "\u2192 showing", this._paymentMethods[0]);
                this._selectedMethod = this._paymentMethods[0] || null;
            }
            this._applyMethodFilter();
        } catch (e) {
            // Meld rejected the amount and named the real floor for this currency. Learn it, move
            // the field up to it and quote once more, so the shopper lands on a valid amount
            // instead of an empty "You receive". One retry only — a second failure is reported.
            // A rejection that names a provider ("[SWAPPED] Invalid fiat currency provided") is
            // about the currency, not the amount: this route's partners cannot price it at all.
            // Move to dollars rather than reporting an error the shopper can do nothing about.
            if (!isRetry && this._fiatCode !== "USD" && !this._currencyPinned && this._isCurrencyRejection(e)) {
                const usdData = await this._quoteInUsdInstead(amt, cc);
                if (usdData) {
                    await this.fetchQuotes(true);
                    return;
                }
            }
            // Only a floor above what we just asked for says anything about this request. A lower
            // one is a number picked out of some other sentence in the message, and acting on it
            // would move the field down for no reason — and re-send a quote that just failed.
            const learned = this._learnMinimum(e);
            if (learned > amt && !isRetry) {
                // The floor Meld named is now folded into the currency's minimum, so the field
                // moves to the usual default for it — a round figure above that floor, never the
                // floor itself. Setting the bare minimum here is what dropped a settled 200 back
                // down to 106 after the first quote.
                this._applyLimitsForCurrency();
                this.amountInputTarget.value = this._formatAmount(this._defaultAmount());
                await this.fetchQuotes(true);
                return;
            }
            console.error("meld: quote failed", e);
            this._showEmpty();
        }
    }
    // _learnMinimum reads the floor out of a rejected quote and remembers it for the currency.
    // Returns the minimum, or 0 when the failure was something else. Meld reports it in the
    // currency we asked in, so the number is directly usable as the field's new value.
    _learnMinimum(err) {
        const payload = err && err.payload || {};
        const code = String(payload.code || "");
        const message = String(payload.message || payload.error || "");
        if (code !== "INVALID_AMOUNT_TOO_LOW" && !/too\s*low|minimum/i.test(message)) return 0;
        const byCurrency = new RegExp(`([0-9]+(?:[.,][0-9]+)?)\\s*${this._fiatCode}`, "i").exec(message);
        const anyNumber = byCurrency || /([0-9]+(?:[.,][0-9]+)?)/.exec(message);
        if (!anyNumber) return 0;
        const min = Number.parseFloat(String(anyNumber[1]).replace(",", ".")) || 0;
        if (min <= 0) return 0;
        this._minByCurrency.set(this._fiatCode, min);
        return min;
    }
    // Keeps an amount inside the currency's limits. The product floor is already folded into
    // _minAmount by _applyLimitsForCurrency.
    _clampToLimits(amt) {
        if (!(amt > 0)) return 0;
        const min = this._minAmount || 0;
        const max = this._maxAmount || Infinity;
        return Math.min(Math.max(amt, min), max);
    }
    // Re-quotes the same amount in dollars and, if that works, switches the picker over: labels,
    // limits and chips all follow the new currency. Returns the quote payload, or null when
    // dollars are no better — the caller then reports the original failure.
    async _quoteInUsdInstead(amt, cc) {
        let usdData;
        try {
            usdData = await this._requestQuotes("USD", amt, cc);
        } catch (e) {
            console.error("meld: USD fallback failed", e);
            return null;
        }
        if (!(usdData.quotes || []).length) return null;
        // Remembered without limits: the ones on record belong to the currency that just failed,
        // and the dollar route's own bounds are unknown here. The country's currency list survives
        // the switch — the one that failed is still on offer, since it failed for this amount and
        // not necessarily for every one.
        const key = String(cc).toUpperCase();
        const previous = this._currencyByCountry.get(key);
        const currencies = previous && previous.currencies || [];
        // Dollars just quoted successfully, so they belong in the list whatever the coverage feed
        // said — the chip must never show a currency its own dropdown denies.
        this._currencies = currencies.includes("USD") ? currencies : [
            "USD",
            ...currencies
        ];
        this._currencyByCountry.set(key, {
            code: "USD",
            limits: "[]",
            currencies: this._currencies
        });
        this._fiatCode = "USD";
        this._fxRate = 0;
        this.limitsValue = "[]";
        this._presetsRendered = false;
        this._renderedPresets = [];
        this._applyCurrencyLabels("USD");
        this._renderCurrencyChip();
        this._applyLimitsForCurrency();
        // _applyLimitsForCurrency re-seeds the field; the shopper's own amount wins.
        this.amountInputTarget.value = this._formatAmount(amt);
        return usdData;
    }
    // True when Meld refused the pair itself rather than the amount — a named provider that
    // cannot price the fiat, or no valid combination at all.
    _isCurrencyRejection(err) {
        const payload = err && err.payload || {};
        const code = String(payload.code || payload.error || "");
        const message = String(payload.message || err && err.message || "");
        if (code === "INCOMPATIBLE_REQUEST" || code === "NO_VALID_QUOTES") return true;
        return /invalid fiat currency|no valid quote/i.test(message);
    }
    _requestQuotes(currency, amt, cc) {
        return this._apiFetch("POST", "/meld/api/quote", {
            sourceCurrencyCode: currency,
            destinationCurrencyCode: this.destCcValue,
            countryCode: cc,
            sourceAmount: String(amt),
            paymentMethodType: this._selectedMethod,
            platformFeeFixed: 0,
            platformFeePercent: 0
        });
    }
    _applyMethodFilter() {
        // The method the user came back from Compare with is restored before the filter runs, not
        // after. Filtering first and restoring second left the two out of step: the row said Bank
        // Transfer while the list underneath had already been built for Credit / Debit Card.
        const savedProvider = this.selectedProviderValue;
        // From the value the server rendered, not from window.location. Compare's Continue
        // submits into the "content" Turbo frame, so the address bar still holds the URL the
        // shopper arrived on — reading the method there returned the previous one, or nothing.
        // The filter then stayed on the default card rail, the provider they had just chosen was
        // filtered out of the list, and the picker fell back to the top quote: choosing a
        // provider on Compare appeared to do nothing.
        const savedMethod = (this.paymentMethodValue || "").trim();
        if (savedProvider && savedMethod && this._allQuotes.some((q)=>q.paymentMethodType === savedMethod)) this._selectedMethod = savedMethod;
        this._quotes = this._selectedMethod ? this._allQuotes.filter((q)=>q.paymentMethodType === this._selectedMethod) : this._allQuotes;
        if (!this._quotes.length) {
            this._showEmpty();
            return;
        }
        if (savedProvider) {
            const idx = this._quotes.findIndex((q)=>q.serviceProvider === savedProvider && (!savedMethod || q.paymentMethodType === savedMethod));
            this._selectedIdx = idx >= 0 ? idx : 0;
            // Choosing on Compare is an explicit pick, so it survives later re-quotes.
            this._selectedProvider = idx >= 0 ? savedProvider : null;
            this.selectedProviderValue = "";
        } else if (this._selectedProvider) {
            // Keep the provider the user picked across re-quotes (amount edits, the ~30s
            // countdown refresh, method changes) instead of snapping back to the best one.
            // If their pick is no longer offered we move them to the best quote and drop the
            // pick, rather than silently restoring it if that provider reappears later.
            const idx = this._quotes.findIndex((q)=>q.serviceProvider === this._selectedProvider);
            this._selectedIdx = idx >= 0 ? idx : 0;
            if (idx < 0) this._selectedProvider = null;
        } else // Nobody picked anything: always follow the best quote for the current amount.
        // _quotes is sorted best-first, so this re-ranks on every amount edit and refresh.
        this._selectedIdx = 0;
        // Compare gets the list the picker is actually working from — filtered by the payment
        // method — not every quote there is. The two used to disagree: the picker showed the best
        // card quote while Compare ranked every rail, so its top row was a provider on a method
        // the shopper had not chosen, and the row that was highlighted sat further down. The buy
        // flow already stored the filtered list, because express quotes one method; this makes the
        // wallet do the same.
        sessionStorage.setItem("meld_quotes", JSON.stringify(this._quotes));
        this._updateQuoteDisplay();
        this._startCountdown();
        this.continueBtnTarget.disabled = !this._quoteCoversPurchase(this._quotes[this._selectedIdx]);
    }
    // _quoteCoversPurchase is the buy-checkout rule (COI-833): a quote is usable only if it
    // delivers at least the purchase total. Always true outside the checkout embed.
    _quoteCoversPurchase(q) {
        const total = this.hasPurchaseTotalValue ? this.purchaseTotalValue : 0;
        if (!(total > 0) || !q) return true;
        return Number.parseFloat(q.destinationAmount || 0) + 1e-6 >= total;
    }
    // _renderPurchaseCheck shows a "you'd receive X / purchase needs Y" line under the receive
    // amount whenever a quote the shopper can act on falls short of the checkout total.
    _renderPurchaseCheck(q) {
        if (!this.hasPurchaseCheckTarget) return;
        const total = this.hasPurchaseTotalValue ? this.purchaseTotalValue : 0;
        const el = this.purchaseCheckTarget;
        if (!(total > 0) || !q) {
            el.style.display = "none";
            return;
        }
        // Only the shortfall needs words; a quote that covers the purchase says nothing extra.
        if (this._quoteCoversPurchase(q)) {
            el.style.display = "none";
            return;
        }
        const dest = Number.parseFloat(q.destinationAmount || 0);
        el.textContent = `You'd receive ${this._money(dest)} \u{2014} your purchase needs ${this._money(total)}. Increase the amount or pick another provider.`;
        el.classList.add("meld-purchase-check-short");
        el.style.display = "";
    }
    _setLoading() {
        this.youReceiveAmountTarget.textContent = "\u2014";
        if (this.hasPurchaseCheckTarget) this.purchaseCheckTarget.style.display = "none";
        this.providerRowTarget.style.display = "none";
        this.stalenessBarTarget.style.display = "none";
        this.continueBtnTarget.disabled = true;
        // The rate belongs to a quote; with no quote on screen it would be a leftover from the
        // previous amount. Limits stay — they belong to the currency, not to the quote.
        if (this.hasRateLabelTarget) this.rateLabelTarget.textContent = "";
    }
    // An empty picker with a currency the shopper chose themselves needs a reason, because the one
    // thing they can do about it — pick another currency — is the thing they just did. Left to the
    // default currency the Min/Max line is explanation enough, so nothing is said.
    _showEmpty() {
        this._setLoading();
        if (!this.hasEmptyNoticeTarget) return;
        if (!this._currencyPinned) {
            this._hideEmptyNotice();
            return;
        }
        this.emptyNoticeTarget.textContent = `No provider is quoting ${this._fiatCode} for this amount. Try a different amount, or switch back to ${this._currencies[0] || "another currency"}.`;
        this.emptyNoticeTarget.style.display = "";
    }
    _hideEmptyNotice() {
        if (!this.hasEmptyNoticeTarget) return;
        this.emptyNoticeTarget.style.display = "none";
    }
    // ── Quote display ─────────────────────────────────────────
    _updateQuoteDisplay() {
        const q = this._quotes[this._selectedIdx];
        if (!q) return;
        sessionStorage.setItem("meld_selected_provider", q.serviceProvider || "");
        sessionStorage.setItem("meld_selected_method", q.paymentMethodType || "");
        const destAmt = Number.parseFloat(q.destinationAmount || 0);
        this.youReceiveAmountTarget.textContent = destAmt > 0 ? new Intl.NumberFormat(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(destAmt) : "\u2014";
        this._renderPurchaseCheck(q);
        this._renderRateLabel(q);
        this.providerNameTarget.textContent = this._formatProvider(q.serviceProvider);
        this.providerBestBadgeTarget.style.display = this._selectedIdx === 0 ? "" : "none";
        this.seeMoreFormTarget.style.display = "";
        this.compareMethodInputTarget.value = this._selectedMethod || "";
        // Hand the current amount, provider and country to Compare so the return trip restores all
        // three. The country especially: picking a provider there navigates back to the picker,
        // and a stale country would silently move the shopper to another market.
        this.compareAmountInputTarget.value = String(this._lastQuotedAmount || "");
        this.compareProviderInputTarget.value = q.serviceProvider || "";
        if (this.hasCompareCountryInputTarget) this.compareCountryInputTarget.value = this.countryCodeTarget.value || "";
        // Only a currency the shopper chose travels: sending the default back would pin it on the
        // return trip and freeze a choice they never made.
        if (this.hasCompareCurrencyInputTarget) this.compareCurrencyInputTarget.value = this._currencyPinned ? this._fiatCode : "";
        this.providerRowTarget.style.display = "";
        this._renderProviderLogo(q.serviceProvider);
    }
    _renderProviderLogo(name) {
        const wrapper = this.providerLogoWrapperTarget;
        wrapper.replaceChildren();
        const svg = (0, $fe2fe4bc73a31ff9$export$e7b967560105a26c)[name];
        if (svg) wrapper.innerHTML = svg;
        else {
            const badge = document.createElement("span");
            badge.className = "inline-flex items-center justify-center self-center w-4 h-4 rounded-full text-[9px] font-bold flex-shrink-0 dark:bg-dark-primary-color wdark:bg-wdark-primary-color dark:text-dark-button-text-and-icon wdark:text-wdark-button-text-and-icon";
            badge.textContent = (name || "?")[0].toUpperCase();
            wrapper.appendChild(badge);
        }
    }
    _formatProvider(name) {
        if (!name) return "\u2014";
        const known = {
            MOONPAY: "MoonPay",
            TOPPER: "Topper",
            TRANSAK: "Transak",
            BANXA: "Banxa",
            SARDINE: "Sardine",
            WERT: "Wert",
            STRIPE: "Stripe"
        };
        return known[name] || name.charAt(0) + name.slice(1).toLowerCase();
    }
    // ── Provider picker (bottom sheet) ────────────────────────
    toggleProviderDropdown() {
        const dd = this.providerDropdownTarget;
        const isOpen = dd.style.display !== "none";
        if (isOpen) dd.style.display = "none";
        else {
            this._renderProviderList();
            dd.style.display = "";
        }
    }
    _renderProviderList() {
        const list = this.providerListTarget;
        list.replaceChildren();
        this._quotes.forEach((q, i)=>{
            const item = document.createElement("div");
            item.className = "meld-provider-item" + (i === this._selectedIdx ? " meld-provider-item-active" : "");
            const nameEl = document.createElement("span");
            nameEl.className = "font-semibold text-sm";
            nameEl.textContent = this._formatProvider(q.serviceProvider);
            const priceEl = document.createElement("span");
            priceEl.className = "text-xs opacity-60";
            priceEl.textContent = Number.parseFloat(q.destinationAmount || 0).toFixed(6).replace(/\.?0+$/, "") + " " + (q.destinationCurrencyCode || "").split("_")[0];
            item.appendChild(nameEl);
            item.appendChild(priceEl);
            item.addEventListener("click", ()=>{
                this._selectedIdx = i;
                this._selectedProvider = q.serviceProvider || null;
                this._updateQuoteDisplay();
                this.providerDropdownTarget.style.display = "none";
            });
            list.appendChild(item);
        });
    }
    // ── Payment method ────────────────────────────────────────
    async openPaymentPicker() {
        try {
            const cc = this.countryCodeTarget.value;
            let qs = cc ? `&countryCode=${encodeURIComponent(cc)}` : "";
            // Carry the amount so switching method keeps it. Each option in the sheet navigates to
            // /meld afresh, so anything not in that URL is lost.
            if (this._lastQuotedAmount > 0) qs += `&amount=${encodeURIComponent(this._lastQuotedAmount)}`;
            const headers = {
                "Turbo-Frame": "content",
                "Accept": "text/vnd.turbo-stream.html, text/html",
                "X-CSRF-Token": this.csrfValue
            };
            if (this.embedTokenValue) headers["X-Session"] = this.embedTokenValue;
            const resp = await fetch(`/deposit/options?meldPaymentPicker=1${qs}`, {
                headers: headers
            });
            if (!resp.ok) return;
            const html = await resp.text();
            await Turbo.renderStreamMessage(html);
        } catch (e) {
            console.error("meld openPaymentPicker error", e);
        }
    }
    // ── Countdown ─────────────────────────────────────────────
    _startCountdown() {
        this._countdownSecs = 60;
        this.stalenessBarTarget.style.display = "";
        this._updateCountdown();
        if (this._countdownTimer) clearInterval(this._countdownTimer);
        this._countdownTimer = setInterval(()=>{
            this._countdownSecs--;
            if (this._countdownSecs <= 0) {
                clearInterval(this._countdownTimer);
                this._countdownTimer = null;
                this.fetchQuotes();
            } else this._updateCountdown();
        }, 1000);
    }
    _updateCountdown() {
        // Pattern comes from the template so it can be translated; {s} is the
        // seconds placeholder. Falls back to English only if the value is absent.
        const pattern = this.countdownLabelValue || "Quote updates in {s}s";
        this.countdownLabelTarget.textContent = pattern.replace("{s}", this._countdownSecs);
    }
    // ── Continue (session creation) ───────────────────────────
    async onContinue() {
        const q = this._quotes[this._selectedIdx];
        if (!q) return;
        this.continueBtnTarget.disabled = true;
        this.continueBtnTarget.textContent = this.openingLabelValue || "Opening\u2026";
        let navigated = false;
        try {
            const resp = await this._apiFetch("POST", "/meld/api/session", {
                countryCode: q.countryCode,
                sourceCurrencyCode: q.sourceCurrencyCode,
                sourceAmount: String(q.sourceAmount),
                destinationCurrencyCode: q.destinationCurrencyCode,
                serviceProvider: q.serviceProvider,
                paymentMethodType: q.paymentMethodType,
                // Informational quote snapshot: the buy-checkout session keeps it so settlement
                // can record quoted-vs-realized figures for this onramp.
                destinationAmount: String(q.destinationAmount ?? ""),
                totalFee: String(q.totalFee ?? "")
            });
            // Prefer serviceProviderWidgetUrl (the provider's own URL) per Meld's guidance:
            // it's opened in a new tab, sidestepping the CSP frame-ancestors blocks that
            // break iframing (Mercuryo) and the Apple Pay / camera-KYC issues iframes cause.
            // Fall back to widgetUrl if a provider doesn't return the direct URL.
            const providerUrl = resp.serviceProviderWidgetUrl || resp.widgetUrl;
            // A session with no URL is a provider that cannot take this combination. Nothing to
            // open, so say so here instead of leaving the button to spring back with no reason.
            if (!providerUrl) {
                await this._showUnavailableSheet();
                return;
            }
            sessionStorage.setItem("meld_widget_url", providerUrl);
            if ((0, $f0015b71e2f21062$export$3a0d0d145c682000)({
                skipConfirm: this.skipConfirmValue,
                express: this._express,
                payIn: this._expressPayIn()
            })) {
                navigated = true;
                this._sessionStarted = true;
                (0, $fe2fe4bc73a31ff9$export$93c22668779c2a44)(providerUrl);
                return;
            }
            const fmt2 = (n)=>(parseFloat(n) || 0).toFixed(2);
            const form = this.confirmFormTarget;
            const set = (n, v)=>{
                const el = form.elements.namedItem(n);
                if (el) el.value = v;
            };
            set("amount", fmt2(q.sourceAmount || this._parseAmount(this.amountInputTarget.value)));
            set("destAmount", fmt2(q.destinationAmount));
            set("currency", q.sourceCurrencyCode || this._fiatCode);
            set("destCurrency", (q.destinationCurrencyCode || "").split("_")[0]);
            set("provider", q.serviceProvider || "");
            set("paymentMethod", q.paymentMethodType || "");
            set("exchangeRate", String(parseFloat(q.exchangeRate) || 0));
            set("networkFee", fmt2(q.networkFee ?? q.networkFeeUsd ?? 0));
            set("transactionFee", fmt2(q.transactionFee ?? 0));
            set("partnerFee", fmt2(q.partnerFee ?? 0));
            set("totalFee", fmt2(q.totalFee ?? 0));
            set("platformFee", fmt2(this._platformFee || 0));
            set("lowKyc", q.lowKyc ? "1" : "0");
            set("countryCode", this.countryCodeTarget.value || "");
            navigated = true;
            this._sessionStarted = true;
            form.requestSubmit();
        } catch (e) {
            if (e?.payload?.error === "payment_in_progress") {
                // A payment is already pending for this checkout (COI-1305). Keep Continue
                // disabled and let the checkout swap to its payment-in-progress state.
                navigated = true;
                if (globalThis.parent !== globalThis.self && this.checkoutOriginValue) globalThis.parent.postMessage({
                    type: (0, $a1f594e67c215345$export$29683e7ac68ad070)
                }, this.checkoutOriginValue);
            } else if (e?.payload?.error === "amount_below_purchase") {
                // Server re-quoted this provider at the submitted amount and it no longer covers
                // the purchase (COI-833). Raise the amount to what would and re-quote so the
                // shopper sees the corrected deal instead of a dead Continue.
                const d = e.payload;
                const required = Number.parseFloat(d.requiredSourceAmount) || 0;
                this._showAmountError(`${this._formatProvider(q.serviceProvider)} would deliver ${this._money(Number.parseFloat(d.destinationAmount) || 0)} ` + `at this amount \u{2014} your purchase needs ${this._money(Number.parseFloat(d.purchaseTotal) || 0)}.` + (required > 0 ? ` Amount raised to ${this._money(required)}.` : ""));
                if (required > 0) {
                    this.amountInputTarget.value = this._formatAmount(required);
                    this._selectedProvider = q.serviceProvider;
                    this.fetchQuotes();
                }
            } else {
                console.error("meld session error", e);
                // Meld refusing to open a session for this provider is the last thing we can learn
                // before the shopper leaves the app — after this point the provider's own page is the
                // one saying no, with no way back into the picker. Express mode is the exception: it
                // has its own fallback to the manual picker, which is more useful than a dead end.
                if (!this._express) await this._showUnavailableSheet();
            }
        }
        if (!navigated) {
            this.continueBtnTarget.disabled = false;
            // Restore what the server rendered; hardcoding "Continue" here would
            // overwrite the translated label with English.
            this.continueBtnTarget.textContent = this._continueLabel;
        }
    }
    // Renders the "onramp currently unavailable" sheet. Same fetch-and-render path the channel
    // service uses for the other deposit sheets, plus the embed token, since in the buy iframe the
    // session cookie is withheld and the route would answer 401.
    async _showUnavailableSheet() {
        try {
            const headers = {
                "X-Requested-With": "XMLHttpRequest",
                "Accept": "text/vnd.turbo-stream.html"
            };
            if (this.embedTokenValue) headers["X-Session"] = this.embedTokenValue;
            const resp = await fetch("/meld/deposit-unavailable", {
                headers: headers,
                credentials: "same-origin"
            });
            if (!resp.ok) return;
            Turbo.renderStreamMessage(await resp.text());
        } catch (e) {
            console.error("meld: failed to open unavailable sheet", e);
        }
    }
    // ── Helpers ───────────────────────────────────────────────
    _sortQuotes(quotes) {
        return [
            ...quotes
        ].sort((a, b)=>{
            const vDiff = (0, $fe2fe4bc73a31ff9$export$3fa72122dee1877c)(b) - (0, $fe2fe4bc73a31ff9$export$3fa72122dee1877c)(a);
            if (vDiff !== 0) return vDiff;
            const aLow = a.lowKyc ? 1 : 0;
            const bLow = b.lowKyc ? 1 : 0;
            if (bLow !== aLow) return bLow - aLow;
            const rateDiff = (parseFloat(b.exchangeRate) || 0) - (parseFloat(a.exchangeRate) || 0);
            if (rateDiff !== 0) return rateDiff;
            return (b.customerScore || 0) - (a.customerScore || 0);
        });
    }
    // ── Buy-checkout express ──────────────────────────────────
    // _expressQuoteAndAdvance runs a single reverse quote (destinationAmount = checkout total),
    // picks the best provider (best receive first, same order as the picker), and submits straight
    // to Confirm & Pay. Any failure
    // — network error, no providers — reveals the normal amount→provider picker so the shopper
    // can still proceed manually (the "show the payment-options step" fallback).
    async _expressQuoteAndAdvance() {
        const cc = this.countryCodeTarget.value;
        if (!cc) {
            this._exitExpress();
            return;
        }
        // Onramp-only checkout: the shopper has already been shown the all-in total, so quote every
        // provider at exactly that pay-in instead of sizing each one to the receive target.
        const payIn = this._expressPayIn();
        const amount = payIn > 0 ? {
            sourceAmount: payIn.toFixed(2)
        } : {
            destinationAmount: String(this.expressAmountValue)
        };
        try {
            const data = await this._apiFetch("POST", "/meld/api/quote", {
                sourceCurrencyCode: this._fiatCode,
                destinationCurrencyCode: this.destCcValue,
                countryCode: cc,
                ...amount,
                // Honour the chosen method. Without it the express quote is unfiltered, the top
                // quote can be any rail, and Confirm — plus its back link — reports whatever won,
                // which is how a picked Apple Pay came back as Credit / Debit Card.
                paymentMethodType: this._selectedMethod,
                platformFeeFixed: 0,
                platformFeePercent: 0
            });
            const quotes = data.quotes || [];
            if (!quotes.length) {
                this._exitExpress();
                return;
            }
            this._platformFee = data.platformFee || 0;
            // Same ranking as the picker and Compare — best receive first, low-KYC only as a
            // tiebreaker. Express used to rank low-KYC first, so the provider it auto-advanced to
            // could sit third in "see more quotes", which reads as the wrong provider being chosen.
            this._allQuotes = this._sortQuotes(quotes);
            this._quotes = this._allQuotes;
            // Express auto-picks the top quote; that is our choice, not the shopper's, so it stays
            // unpinned — if express falls back to the picker, re-quotes still follow the best rate.
            this._selectedIdx = 0;
            sessionStorage.setItem("meld_quotes", JSON.stringify(this._allQuotes));
            // Reuse the normal session-create + confirm submit. It navigates the #content frame
            // to Confirm & Pay on success; if it didn't (session error), fall back to the picker.
            await this.onContinue();
            if (!this._sessionStarted) this._exitExpress();
        } catch (e) {
            console.error("meld express quote failed", e);
            this._exitExpress();
        }
    }
    // _expressPayIn is the all-in pay-in to quote at, or 0 for receive-target sizing. The all-in
    // total is a USD figure, so a shopper paying in another currency keeps receive-target sizing.
    _expressPayIn() {
        if (!this.hasExpressPayAmountValue || !(this.expressPayAmountValue > 0)) return 0;
        return this._fiatCode === "USD" ? this.expressPayAmountValue : 0;
    }
    // _exitExpress leaves express mode and shows the standard picker as the fallback step,
    // pre-sized to the checkout amount so the manual flow starts from the right number.
    _exitExpress() {
        this._express = false;
        this._showExpressLoading(false);
        if (this.expressAmountValue > 0) {
            // expressAmount is the checkout total in the destination token (≈ USD), so in a local
            // currency the field has to start from the equivalent pay-in, not the token figure.
            // Without a rate yet we show it as-is, exactly as before.
            const start = this._fiatCode !== "USD" && this._fxRate > 0 ? this.expressAmountValue * this._fxRate : this.expressAmountValue;
            // The picker's "you pay" input must open on at least the sized pay-in (_productMin,
            // a USD figure — convert it the same way) — quoting the bare total sizes a deposit
            // that lands short after fees (COI-833).
            const floor = this._fiatCode !== "USD" && this._fxRate > 0 ? (this._productMin || 0) * this._fxRate : this._productMin || 0;
            const fallback = Math.max(start, floor);
            this.amountInputTarget.value = this._formatAmount(fallback);
        }
        this.fetchQuotes();
    }
    _showExpressLoading(on) {
        if (!this.hasExpressLoadingTarget) return;
        this.expressLoadingTarget.style.display = on ? "" : "none";
    }
    // ── Provider overlay ──────────────────────────────────────
    openProviderOverlay(widgetUrl, directUrl, providerName) {
        // Stay in-app: desktop popup / mobile full-page load, never an iframe.
        (0, $fe2fe4bc73a31ff9$export$93c22668779c2a44)(directUrl || widgetUrl);
    }
}





class $998045ec83f77af7$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "form",
        "link"
    ];
    connect() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ModalButtonController: Connected");
    }
    openModal(event) {
        event.preventDefault();
        let url = null;
        if (this.hasFormTarget) url = this.formTarget.action;
        else if (this.hasLinkTarget) url = this.linkTarget.href;
        if (!url) {
            (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ModalButtonController: No form or link target found");
            return;
        }
        (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(url, {
            method: "GET",
            headers: {
                headers: {
                    Accept: "text/vnd.turbo-stream.html"
                }
            }
        }).then((response)=>response.text()).then((html)=>{
            Turbo.renderStreamMessage(html);
        });
    }
}




class $ee018b8705124014$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "backdrop",
        "content",
        "container",
        "scrollIndicator"
    ];
    static values = {
        closeModalDeltaY: {
            type: Number,
            default: 100
        },
        redirectUrl: {
            type: String,
            default: ""
        }
    };
    connect() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("ModalController: Connected");
        if ((0, $6adb56df0e842c64$export$44f917bf91becd01)()) {
            this.setupScrollToClose();
            if (this.hasScrollIndicatorTarget) this.scrollIndicatorTarget.classList.remove("hidden");
        }
    }
    disconnect() {
        this.removeScrollToClose();
    }
    setupScrollToClose() {
        if (!this.hasContainerTarget && !this.hasContentTarget) return;
        // Only add scroll-to-close for mobile devices
        this.touchStartY = 0;
        this.touchStartTime = 0;
        this.isScrolling = false;
        // Add touch event listeners to backdrop, container, and content
        const elements = [
            this.containerTarget,
            this.contentTarget
        ];
        elements.forEach((element)=>{
            if (element) {
                element.addEventListener('touchstart', this.handleTouchStart.bind(this), {
                    passive: true
                });
                element.addEventListener('touchmove', this.handleTouchMove.bind(this), {
                    passive: true
                });
                element.addEventListener('touchend', this.handleTouchEnd.bind(this), {
                    passive: true
                });
            }
        });
    }
    removeScrollToClose() {
        if (!this.hasContainerTarget && !this.hasContentTarget) return;
        const elements = [
            this.containerTarget,
            this.contentTarget
        ];
        elements.forEach((element)=>{
            if (element) {
                element.removeEventListener('touchstart', this.handleTouchStart.bind(this));
                element.removeEventListener('touchmove', this.handleTouchMove.bind(this));
                element.removeEventListener('touchend', this.handleTouchEnd.bind(this));
            }
        });
    }
    handleTouchStart(event) {
        this.touchStartY = event.touches[0].clientY;
        this.touchStartTime = Date.now();
        this.isScrolling = false;
        this.touchTarget = event.target;
    }
    handleTouchMove(event) {
        if (!this.touchStartY) return;
        const currentY = event.touches[0].clientY;
        const deltaY = currentY - this.touchStartY;
        // If scrolling down more than 50px, mark as scrolling
        if (deltaY > 50) this.isScrolling = true;
        if (deltaY > this.closeModalDeltaYValue) this.contentTarget.style.top = "20px";
    }
    handleTouchEnd(event) {
        if (!this.touchStartY) return;
        const touchEndTime = Date.now();
        const touchDuration = touchEndTime - this.touchStartTime;
        const currentY = event.changedTouches[0].clientY;
        const deltaY = currentY - this.touchStartY;
        // Close modal if:
        // 1. Scrolled down more than 100px
        // 2. Touch duration is greater than 250ms, preventing accidental close
        if (this.isScrolling && deltaY > this.closeModalDeltaYValue && touchDuration > 250) this.closeModal();
        // Reset values
        this.touchStartY = 0;
        this.touchStartTime = 0;
        this.isScrolling = false;
        this.touchTarget = null;
        this.contentTarget.style.top = "0px";
    }
    closeModal() {
        if (this.redirectUrlValue) {
            Turbo.visit(this.redirectUrlValue);
            return;
        }
        // Close modal will make the modal container hidden and inert
        if (this.hasContainerTarget) {
            this.containerTarget.setAttribute("inert", "");
            this.containerTarget.setAttribute("aria-hidden", "true");
            this.containerTarget.classList.add("hidden");
        }
    }
}




class $4fa0f36302d0d20e$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "amountInput"
    ];
    static values = {
        maxCh: Number,
        padCh: Number,
        defaultValue: String,
        autoFocus: {
            type: Boolean,
            default: true
        }
    };
    connect() {
        this.inIframe = window.self !== window.top;
        // Use placeholder "0" when empty (no default value set)
        if (!this.element.placeholder) this.element.placeholder = "0";
        // if (!this.element.value) this.element.value = this.setAmountValue;
        // viewport cap + initial size
        this.element.style.maxWidth = "90vw";
        this._autosize();
        // focus fallback (works in modals/frames) - only if autoFocus is enabled
        if (this.autoFocusValue) requestAnimationFrame(()=>{
            try {
                this.element.focus({
                    preventScroll: true
                });
            } catch  {}
        });
        this.amountInputTarget.addEventListener("input", this.handleInput.bind(this));
        this.element.addEventListener("input", ()=>this._autosize());
        this.element.addEventListener("blur", ()=>this._onBlur());
        window.addEventListener("resize", this._onResize);
    }
    disconnect() {
        window.removeEventListener("resize", this._onResize);
    }
    _onResize = ()=>this._autosize();
    _autosize() {
        // Use placeholder when empty so width doesn't collapse
        const raw = this.element.value ?? "";
        const base = raw === "" ? this.element.placeholder || "" : raw;
        const pad = this.hasPadChValue ? this.padChValue : 1;
        const maxCh = this.hasMaxChValue ? this.maxChValue : 10;
        // Treat periods as ~half a character for visual centering
        const dotCount = (base.match(/\./g) || []).length;
        const effectiveLen = base.length - dotCount * 0.5;
        const ch = Math.min(maxCh, Math.max(1, effectiveLen + pad));
        this.element.style.width = `${ch}ch`;
    }
    _onBlur() {
        if (this.element.hasAttribute("readonly")) return;
        let raw = (this.element.value || "").trim();
        // Try backend-provided min, fallback 0
        let min = Number(this.minValue ?? 0);
        // Try HTML min attribute
        const minAttr = Number.parseFloat(this.element.getAttribute("min"));
        if (!Number.isNaN(minAttr)) min = minAttr;
        let val = Number.parseFloat(raw);
        if (Number.isNaN(val)) {
            this._autosize();
            return;
        }
        // min value needs to be converted to float
        min = min.toFixed(2);
        if (val < min) {
            (0, $e4096da1729505e0$export$2e2bcd8739ae039)(`Amount cannot be less than ${min}`, "error");
            this.element.value = min;
            this._autosize();
            if (this.inIframe) window.parent.postMessage({
                type: "transaction_error",
                message: `Amount cannot be less than ${min}`
            }, "*");
            return;
        }
        const maxAttr = this.element.getAttribute("max");
        const max = Number.parseFloat(maxAttr);
        if (!Number.isNaN(max) && val > max) {
            val = max;
            (0, $e4096da1729505e0$export$2e2bcd8739ae039)(`Amount cannot be greater than ${max}`, "error");
            if (this.inIframe) window.parent.postMessage({
                type: "transaction_error",
                message: `Amount cannot be greater than ${max}`
            }, "*");
        }
        this.element.value = val.toFixed(2);
        this._autosize();
    }
    handleInput(e) {
        const input = e.currentTarget;
        let value = input.value;
        // Only allow numbers and one decimal point
        value = value.replace(/[^0-9.]/g, '');
        // Ensure only one decimal point
        const parts = value.split('.');
        if (parts.length > 2) value = parts[0] + '.' + parts.slice(1).join('');
        // Update the input value
        input.value = value;
    }
}


// controllers/otp_controller.js


class $af332ae9e5563cc0$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "form",
        "otpInput",
        "continueButton",
        "timer",
        "resendButton"
    ];
    static values = {
        verifyurl: String,
        resendurl: String,
        email: String,
        duration: {
            type: Number,
            default: 300
        },
        autoSubmit: {
            type: Boolean,
            default: true
        }
    };
    connect() {
        if (this.hasFormTarget) this.formTarget.addEventListener("turbo:submit-end", this.onSubmitEnd);
        this._autoSubmitting = false;
        this.otpInputTargets.forEach((el, idx)=>{
            el.addEventListener("input", this.onOtpInput);
            el.addEventListener("keydown", this.onOtpBackspace);
            if (idx === 0) el.addEventListener("paste", this.onPasteCode);
            el.addEventListener("keydown", (e)=>{
                if (e.key === "Enter") this.verifyAndSubmit(e);
            });
        });
        this.updateContinueDisabled();
        this.startTimer();
    }
    disconnect() {
        if (this.hasFormTarget) this.formTarget.removeEventListener("turbo:submit-end", this.onSubmitEnd);
        this.otpInputTargets.forEach((el, idx)=>{
            el.removeEventListener("input", this.onOtpInput);
            el.removeEventListener("keydown", this.onOtpBackspace);
            if (idx === 0) el.removeEventListener("paste", this.onPasteCode);
        });
        clearInterval(this._timerId);
    }
    // Manual submit (also used by auto-submit)
    verifyAndSubmit = (e)=>{
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this._autoSubmitting) return;
        if (this._timeLeft <= 0) return;
        const code = this.otpInputTargets.map((i)=>i.value.trim()).join("");
        if (!/^\d{6}$/.test(code)) {
            this.bumpInvalid();
            return;
        }
        this._autoSubmitting = true; // guard
        this.setHidden("code", code);
        if (this.hasEmailValue) this.setHidden("email", this.emailValue);
        if (this._timeLeft) this.setHidden("expiresTime", this._timeLeft);
        let metadata = (0, $2c821d6e252819b0$export$8d643fb172cc684e)();
        metadata.appType = "rocket";
        this.setHidden("metadata", JSON.stringify(metadata));
        if (this.hasVerifyurlValue) this.formTarget.action = this.verifyurlValue;
        this.formTarget.method = "post";
        this.formTarget.requestSubmit(); // Turbo events fire; lock/spinner controller will engage
    };
    // Auto-submit when all boxes filled
    maybeAutoSubmit() {
        if (!this.autoSubmitValue) return;
        const allFilled = this.otpInputTargets.every((i)=>i.value.length === 1);
        if (allFilled) this.verifyAndSubmit(); // no event object needed
    }
    // Only purpose now: release guard so user can retry
    onSubmitEnd = (event)=>{
        this._autoSubmitting = false;
        const { detail: detail } = event;
        const { fetchResponse: fetchResponse } = detail;
        if (fetchResponse) {
            if (fetchResponse.failed) this.clearOtpInputs();
        }
    };
    // Resend flow
    resend = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (this.hasEmailValue) this.setHidden("email", this.emailValue);
        this.setHidden("resend", true);
        if (this.hasResendurlValue) this.formTarget.action = this.resendurlValue;
        this.formTarget.method = "post";
        this.formTarget.requestSubmit();
        this.clearOtpInputs();
        this.updateContinueDisabled();
        this.startTimer();
    };
    // Timer (MM:SS)
    startTimer() {
        clearInterval(this._timerId);
        this._timeLeft = this.durationValue;
        const tick = ()=>{
            if (!this.hasTimerTarget) return;
            const m = Math.floor(this._timeLeft / 60);
            const s = String(this._timeLeft % 60).padStart(2, "0");
            this.timerTarget.textContent = this._timeLeft > 0 ? `Expires in ${m}:${s}` : "Expired";
            if (this._timeLeft <= 0) {
                clearInterval(this._timerId);
                if (this.hasContinueButtonTarget) this.continueButtonTarget.disabled = true;
                if (this.hasResendButtonTarget) this.resendButtonTarget.disabled = false;
                return;
            }
            this._timeLeft -= 1;
        };
        if (this.hasResendButtonTarget) this.resendButtonTarget.disabled = true;
        tick();
        this._timerId = setInterval(tick, 1000);
    }
    // OTP UX helpers
    onOtpInput = (e)=>{
        const val = e.target.value;
        const numberRegex = /^\d$/;
        const digits = val.replace(/\D/g, "");
        if (digits.length > 1) {
            this.otpInputTargets.forEach((otpTarget, index)=>{
                otpTarget.value = digits[index] || "";
            });
            if (digits.length === 6) this.verifyAndSubmit();
            return;
        }
        if (!/^\d$/.test(val)) {
            e.target.value = "";
            return;
        }
        if (e.target.nextElementSibling) e.target.nextElementSibling.focus();
        const allDigitsEntered = this.otpInputTargets.every((code)=>code.value.length === 1);
        if (allDigitsEntered) this.verifyAndSubmit();
        this.updateContinueDisabled();
    };
    onOtpBackspace = (e)=>{
        if (e.key === "Backspace" && e.target.value === "") {
            const prev = e.target.previousElementSibling;
            if (prev && this.otpInputTargets.includes(prev)) {
                e.preventDefault();
                prev.value = "";
                prev.focus();
            }
            this.updateContinueDisabled();
        }
    };
    onPasteCode = (e)=>{
        const text = (e.clipboardData || window.clipboardData).getData("text");
        const code = (text || "").replace(/\D/g, "").slice(0, 6);
        if (!code) return;
        e.preventDefault();
        this.otpInputTargets.forEach((box, i)=>box.value = code[i] || "");
        const lastFilled = this.otpInputTargets[Math.min(code.length - 1, this.otpInputTargets.length - 1)];
        if (lastFilled) lastFilled.focus();
        this.updateContinueDisabled();
        this.maybeAutoSubmit();
    };
    updateContinueDisabled() {
        const allFilled = this.otpInputTargets.every((i)=>i.value.length === 1);
        if (this.hasContinueButtonTarget) this.continueButtonTarget.disabled = !allFilled;
    }
    clearOtpInputs() {
        this.otpInputTargets.forEach((i)=>i.value = "");
        if (this.otpInputTargets[0]) this.otpInputTargets[0].focus();
    }
    bumpInvalid() {
        this.otpInputTargets.forEach((i)=>i.classList.add("ring-2", "ring-red-500"));
        setTimeout(()=>this.otpInputTargets.forEach((i)=>i.classList.remove("ring-2", "ring-red-500")), 350);
    }
    setHidden(name, value) {
        let el = this.formTarget.querySelector(`input[type="hidden"][name="${name}"]`);
        if (!el) {
            el = document.createElement("input");
            el.type = "hidden";
            el.name = name;
            this.formTarget.appendChild(el);
        }
        el.value = value;
    }
}



class $4b4aa57cfe6265c7$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "walletInput"
    ];
    async pasteWalletAddress(event) {
        event.preventDefault();
        try {
            // Read from clipboard
            const text = await navigator.clipboard.readText();
            const trimmedAddress = text.trim();
            // Set the value in the input (clear first, then set new value)
            // Validation will be done by backend on form submit
            if (this.hasWalletInputTarget) {
                this.walletInputTarget.value = "";
                this.walletInputTarget.value = trimmedAddress;
                // Trigger input event to notify any listeners (including validation controller)
                this.walletInputTarget.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
                this.walletInputTarget.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            }
        } catch (error) {
            console.error("Failed to read from clipboard:", error);
        }
    }
}



const $5e949b3e6acc7bd2$var$TURBO_STREAM = "text/vnd.turbo-stream.html";
function $5e949b3e6acc7bd2$export$a95ed983b82faebd(contentType) {
    return (contentType || "").startsWith($5e949b3e6acc7bd2$var$TURBO_STREAM);
}
function $5e949b3e6acc7bd2$export$248a69dbe1a2a548({ succeeded: succeeded, contentType: contentType }) {
    return !succeeded || $5e949b3e6acc7bd2$export$a95ed983b82faebd(contentType);
}


class $17565875cf361a46$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "keepOpen",
        "stillWorking",
        "returnForm",
        "fallbackError"
    ];
    static outlets = [
        "pin"
    ];
    static values = {
        slowAfter: {
            type: Number,
            default: 8000
        }
    };
    // idle -> sending -> failed
    state = "idle";
    disconnect() {
        clearTimeout(this.slowTimer);
    }
    pinOutletConnected(pin) {
        this.pinForm = pin.formTarget;
        this.pinForm.addEventListener("submit", this.onSubmit);
        this.pinForm.addEventListener("turbo:before-fetch-response", this.onWithdrawalResponse);
        this.pinForm.addEventListener("turbo:submit-end", this.onWithdrawalEnd);
    }
    pinOutletDisconnected() {
        this.pinForm?.removeEventListener("submit", this.onSubmit);
        this.pinForm?.removeEventListener("turbo:before-fetch-response", this.onWithdrawalResponse);
        this.pinForm?.removeEventListener("turbo:submit-end", this.onWithdrawalEnd);
    }
    // Keys pressed on the hidden keypad can submit again; only the first goes through.
    onSubmit = (event)=>{
        if (this.state !== "idle") {
            event.preventDefault();
            return;
        }
        this.state = "sending";
        this.showScreen();
    };
    showScreen() {
        this.pinOutlet.element.classList.add("hidden");
        this.element.classList.replace("hidden", "flex");
        this.slowTimer = setTimeout(()=>{
            this.keepOpenTarget.classList.add("hidden");
            this.stillWorkingTarget.classList.remove("hidden");
        }, this.slowAfterValue);
    }
    hideScreen() {
        clearTimeout(this.slowTimer);
        this.element.classList.replace("flex", "hidden");
        this.keepOpenTarget.classList.remove("hidden");
        this.stillWorkingTarget.classList.add("hidden");
        this.pinOutlet.element.classList.remove("hidden");
    }
    // The result screen renders as usual. A failure is taken here, before
    // Turbo's stream observer on the document would draw it over this screen.
    onWithdrawalResponse = async (event)=>{
        if (this.state !== "sending") return;
        const { fetchResponse: fetchResponse } = event.detail;
        if (!(0, $5e949b3e6acc7bd2$export$248a69dbe1a2a548)(fetchResponse)) return;
        event.preventDefault();
        event.stopPropagation();
        this.state = "failed";
        const streamHtml = (0, $5e949b3e6acc7bd2$export$a95ed983b82faebd)(fetchResponse.contentType) ? await fetchResponse.responseHTML : null;
        this.returnToConfirm(streamHtml || this.fallbackErrorTarget.innerHTML);
    };
    // A dropped connection has no response to inspect.
    onWithdrawalEnd = (event)=>{
        if (this.state === "sending" && event.detail.error) {
            this.state = "failed";
            this.returnToConfirm(this.fallbackErrorTarget.innerHTML);
        }
    };
    returnToConfirm(streamHtml) {
        this.pendingError = streamHtml;
        this.confirmWillRender = false;
        this.returnFormTarget.requestSubmit();
    }
    // Confirm Withdrawal replaces this screen, so the message is drawn once it has.
    onConfirmResponse(event) {
        const { fetchResponse: fetchResponse } = event.detail;
        this.confirmWillRender = fetchResponse.succeeded && !(0, $5e949b3e6acc7bd2$export$a95ed983b82faebd)(fetchResponse.contentType);
        if (!this.confirmWillRender) return;
        const streamHtml = this.pendingError;
        this.element.closest("turbo-frame")?.addEventListener("turbo:frame-render", ()=>Turbo.renderStreamMessage(streamHtml), {
            once: true
        });
    }
    // Confirm Withdrawal could not be shown. Back to the keypad with the message.
    // Its payload keeps the old key; once that withdrawal has run, finalize
    // refuses it and the next failure returns here for a new one.
    onConfirmEnd() {
        if (this.confirmWillRender) return;
        this.hideScreen();
        this.state = "idle";
        Turbo.renderStreamMessage(this.pendingError);
        this.pinOutlet.clearPin();
    }
}


// controllers/regionSelectController.js
//
// Populates the light-KYC state/region select from whichever country is picked
// in the country field above it (COI-840). The full country -> regions map is
// rendered onto the element as JSON rather than fetched, so switching country
// costs no round trip.
//
// The select is the customer-facing convenience only. SubmitLightKYC re-checks
// the country/region pair server-side, because both arrive as form fields a
// client can set to anything.

class $b8127b53e41c4c37$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "select"
    ];
    static values = {
        regions: Object,
        countryField: String,
        placeholder: String,
        emptyPlaceholder: String
    };
    connect() {
        this.countryInput = this.findCountryInput();
        if (this.countryInput) {
            this.boundCountryChanged = this.countryChanged.bind(this);
            this.countryInput.addEventListener("change", this.boundCountryChanged);
        }
        this.render();
    }
    disconnect() {
        if (this.countryInput && this.boundCountryChanged) this.countryInput.removeEventListener("change", this.boundCountryChanged);
    }
    countryChanged() {
        this.render();
    }
    // The country picker lives in a sibling element, so scope the lookup to the
    // enclosing form rather than the controller element.
    findCountryInput() {
        const root = this.element.closest("form") || document;
        return root.querySelector(`[name="${this.countryFieldValue}"]`);
    }
    render() {
        if (!this.hasSelectTarget) return;
        const country = this.countryInput ? this.countryInput.value : "";
        const regions = this.regionsValue[country] || [];
        const previous = this.selectTarget.value;
        // Rebuilding wipes the previous selection on purpose: a state only means
        // something under the country it belongs to, and carrying "California" over
        // to a new country would submit a pair the server refuses.
        this.selectTarget.replaceChildren();
        const placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = regions.length ? this.placeholderValue : this.emptyPlaceholderValue;
        this.selectTarget.appendChild(placeholder);
        for (const region of regions){
            const option = document.createElement("option");
            option.value = region;
            option.textContent = region;
            this.selectTarget.appendChild(option);
        }
        this.selectTarget.value = regions.includes(previous) ? previous : "";
        this.selectTarget.disabled = regions.length === 0;
        // form-validation gates the submit button on this field, and it only
        // listens — nothing dispatches on a programmatic value change.
        this.selectTarget.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
}



class $e3566fe8e070b4b4$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "form",
        "spinner"
    ];
    removeAccount(event) {
        event.preventDefault();
        console.log("RemoveBankAccountController: removeAccount");
        const form = this.formTarget;
        const accountId = form.dataset.accountId;
        this.removeButtonDisabled();
        this.cancelButtonDisabled();
        this.showSpinner();
        form.action = `/withdraw/remove-bank-account/${accountId}/`;
        form.method = "POST";
        form.requestSubmit();
    }
    onSubmitEnd(event) {
        console.log("RemoveBankAccountController: event", event);
        const response = event.detail.fetchResponse;
        if (response.succeeded) setTimeout(()=>{
            Turbo.visit("/withdraw/linked-bank-accounts", {
                action: "replace"
            });
            this.hideSpinner();
        }, 1200);
    }
    removeButtonDisabled() {
        const button = document.getElementById("remove-button");
        const text = document.getElementById("remove-button-text");
        if (button) {
            button.disabled = true;
            button.classList.add("cursor-not-allowed", "opacity-50");
        }
        if (text) text.textContent = "Removing...";
    }
    cancelButtonDisabled() {
        const button = document.getElementById("cancel-button");
        if (button) {
            button.style.pointerEvents = "none";
            button.classList.add("cursor-not-allowed", "opacity-50");
        }
    }
    showSpinner() {
        if (this.spinnerTarget) this.spinnerTarget.classList.remove("hidden");
    }
    hideSpinner() {
        if (this.spinnerTarget) this.spinnerTarget.classList.add("hidden");
    }
}








class $33e05a87bc3153cf$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        domain: String,
        company: {
            type: String,
            default: "CoinSub Wallet"
        },
        idempotencyKey: String,
        csrfToken: String
    };
    connect() {
        this.isProcessing = false;
    }
    async removePasskey(event) {
        event.preventDefault();
        if (this.isProcessing) return;
        this.isProcessing = true;
        this.removeButtonDisabled();
        this.cancelButtonDisabled();
        this.showSpinner();
        try {
            const { challenge: challenge } = await this.requestDeletionChallenge();
            const signedChallenge = await this.signChallenge(challenge);
            await this.submitSignedChallenge({
                ...signedChallenge
            });
            this.handleSuccess();
        } catch (error) {
            if (error.message !== "backend-error") {
                if (error.name === "TypeError" || error.message?.includes("fetch")) (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Unable to connect to server.", "error");
                else (0, $e4096da1729505e0$export$2e2bcd8739ae039)((0, $b8614c1cf7554158$export$85575c1a77628ede)(error), "error");
            }
            this.resetUIState();
        }
    }
    async requestDeletionChallenge() {
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)('/passkey/challenge/delete/request', {
            method: "GET",
            headers: {
                Accept: "application/json"
            },
            credentials: "same-origin"
        });
        return (0, $76e753e031c74aeb$export$ea607f18896190ac)(response, "Failed to initiate passkey removal.");
    }
    async signChallenge(challengeData) {
        const currentDomain = window.location.hostname;
        const relyingPartyId = this.domainValue || currentDomain;
        const relyingPartyName = this.companyValue || "CoinSub Wallet";
        const webauthn = new (0, $b30e2eb3b270edb4$exports.WebAuthnSigner)({
            relyingParty: {
                id: relyingPartyId,
                name: relyingPartyName
            }
        });
        try {
            const assertion = await webauthn.sign(challengeData);
            const credentialAssertion = assertion.credentialAssertion || {};
            return {
                challengeIdentifier: challengeData.challengeIdentifier,
                signature: {
                    kind: assertion.kind,
                    credentialAssertion: {
                        credId: credentialAssertion.credId || "",
                        clientData: credentialAssertion.clientData || "",
                        signature: credentialAssertion.signature || "",
                        authenticatorData: credentialAssertion.authenticatorData || "",
                        userHandle: credentialAssertion.userHandle || ""
                    }
                }
            };
        } catch (error) {
            if (error.name === "InvalidStateError" || error.message?.includes("pending")) {
                (0, $e4096da1729505e0$export$2e2bcd8739ae039)("A passkey request is already in progress. Please refresh the page and try again.", "error");
                throw new Error("Passkey request already pending");
            }
            throw error;
        }
    }
    async submitSignedChallenge({ challengeIdentifier: challengeIdentifier, signature: signature }) {
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)("/passkey/challenge/delete/submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.csrfTokenValue
            },
            body: JSON.stringify({
                challengeIdentifier: challengeIdentifier,
                signature: signature,
                idempotencyKey: this.idempotencyKeyValue
            }),
            credentials: "same-origin"
        });
        await (0, $76e753e031c74aeb$export$ea607f18896190ac)(response, "Failed to remove passkey.");
    }
    handleSuccess() {
        this.isProcessing = false;
        setTimeout(()=>{
            this.hideSpinner();
            Turbo.visit("/home", {
                action: "replace"
            });
        }, 1200);
    }
    resetUIState() {
        this.hideSpinner();
        this.enableRemoveButton();
        this.enableCancelButton();
        this.isProcessing = false;
    }
    removeButtonDisabled() {
        const button = document.getElementById("remove-button");
        const text = document.getElementById("remove-button-text");
        if (button) {
            button.disabled = true;
            button.classList.add("cursor-not-allowed", "opacity-50");
        }
        if (text) text.textContent = "Removing...";
    }
    enableRemoveButton() {
        const button = document.getElementById("remove-button");
        const text = document.getElementById("remove-button-text");
        if (button) {
            button.disabled = false;
            button.classList.remove("cursor-not-allowed", "opacity-50");
        }
        if (text) text.textContent = "Remove Passkey";
    }
    cancelButtonDisabled() {
        const button = document.getElementById("cancel-button");
        if (button) {
            button.style.pointerEvents = "none";
            button.classList.add("cursor-not-allowed", "opacity-50");
        }
    }
    enableCancelButton() {
        const button = document.getElementById("cancel-button");
        if (button) {
            button.style.pointerEvents = "";
            button.classList.remove("cursor-not-allowed", "opacity-50");
        }
    }
    showSpinner() {
        const spinner = document.getElementById("loading-spinner");
        if (spinner) spinner.classList.remove("hidden");
    }
    hideSpinner() {
        const spinner = document.getElementById("loading-spinner");
        if (spinner) spinner.classList.add("hidden");
    }
}




function $93a66ce7b55edebc$export$8b34f988e3eb68ec(hasLimitValue, limitValue) {
    return hasLimitValue && limitValue > 0 ? limitValue : 5;
}
function $93a66ce7b55edebc$export$3e6210e91a748b85(scrollHeight, scrollTop, clientHeight, threshold = 12) {
    return scrollHeight - scrollTop - clientHeight <= threshold;
}
function $93a66ce7b55edebc$export$58e40889c399f80c({ panel: panel, cursor: cursor, limit: limit, cursorId: cursorId }) {
    const query = new URLSearchParams({
        panel: panel,
        cursor: cursor,
        limit: String(limit)
    });
    if (cursorId) query.set("cursor_id", cursorId);
    return query;
}


class $a69a63ffbd70136d$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "tab",
        "panel",
        "scrollContainer"
    ];
    static values = {
        limit: Number
    };
    connect() {
        this.loadingPanels = {};
        this.hasScrolled = false;
        this.handleScroll = this.#onScroll.bind(this);
        this.currentPanel = this.tabTargets[0]?.dataset.rewardsTabsPanelParam || "active";
        if (this.hasScrollContainerTarget) this.scrollContainerTarget.addEventListener("scroll", this.handleScroll, {
            passive: true
        });
        this.#activateTab(0);
        this.observeLastRow();
    }
    disconnect() {
        if (this.hasScrollContainerTarget) this.scrollContainerTarget.removeEventListener("scroll", this.handleScroll);
        this.cleanupObserver();
    }
    show({ params: { panel: panel } }) {
        const idx = this.tabTargets.findIndex((t)=>t.dataset.rewardsTabsPanelParam === panel);
        if (idx < 0 || panel === this.currentPanel) return;
        this.currentPanel = panel;
        if (this.hasScrollContainerTarget) this.scrollContainerTarget.scrollTop = 0;
        this.#activateTab(idx);
        this.observeLastRow();
    }
    observeLastRow() {
        this.cleanupObserver();
        const activePanel = this.activePanelElement;
        if (!activePanel) return;
        const rows = activePanel.querySelectorAll('[data-rewards-tabs-target="row"]');
        const lastRow = rows[rows.length - 1];
        if (!lastRow) return;
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && this.hasScrolled) this.loadMore();
            });
        }, {
            root: this.hasScrollContainerTarget ? this.scrollContainerTarget : null,
            threshold: 0
        });
        this.observer.observe(lastRow);
    }
    cleanupObserver() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
    async loadMore() {
        const panel = this.currentPanel;
        if (this.loadingPanels[panel]) return;
        const activePanel = this.activePanelElement;
        if (!activePanel) return;
        const rows = activePanel.querySelectorAll('[data-rewards-tabs-target="row"]');
        const lastRow = rows[rows.length - 1];
        const cursor = lastRow?.dataset.cursor;
        const cursorId = lastRow?.dataset.cursorId;
        if (!cursor) {
            this.cleanupObserver();
            return;
        }
        const query = (0, $93a66ce7b55edebc$export$58e40889c399f80c)({
            panel: panel,
            cursor: cursor,
            limit: this.limit,
            cursorId: cursorId
        });
        this.loadingPanels[panel] = true;
        try {
            const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(`/rewards/list/load?${query.toString()}`, {
                headers: {
                    Accept: "text/vnd.turbo-stream.html"
                }
            });
            if (response.status === 204) {
                this.cleanupObserver();
                return;
            }
            if (!response.ok) return;
            const stream = await response.text();
            // Tear down the observer BEFORE rendering so the old observer cannot
            // fire again on the updated DOM and issue a duplicate request.
            this.cleanupObserver();
            Turbo.renderStreamMessage(stream);
            requestAnimationFrame(()=>this.observeLastRow());
        } finally{
            this.loadingPanels[panel] = false;
        }
    }
    get limit() {
        return (0, $93a66ce7b55edebc$export$8b34f988e3eb68ec)(this.hasLimitValue, this.limitValue);
    }
    get activePanelElement() {
        return this.panelTargets.find((panel)=>panel.dataset.panel === this.currentPanel);
    }
    #onScroll() {
        this.hasScrolled = true;
        if (this.isNearBottom()) this.loadMore();
    }
    isNearBottom() {
        if (!this.hasScrollContainerTarget) return false;
        const el = this.scrollContainerTarget;
        return (0, $93a66ce7b55edebc$export$3e6210e91a748b85)(el.scrollHeight, el.scrollTop, el.clientHeight);
    }
    #activateTab(activeIdx) {
        this.tabTargets.forEach((tab, i)=>{
            const isActive = i === activeIdx;
            tab.classList.toggle("wdark:bg-wdark-primary-color", isActive);
            tab.classList.toggle("wlight:bg-wlight-primary-color", isActive);
            tab.classList.toggle("dark:bg-dark-primary-color", isActive);
            tab.classList.toggle("wdark:text-wdark-background-color", isActive);
            tab.classList.toggle("wlight:text-wlight-background-color", isActive);
            tab.classList.toggle("dark:text-dark-background-color", isActive);
            tab.classList.toggle("wdark:text-wdark-primary-color", !isActive);
            tab.classList.toggle("wlight:text-wlight-primary-color", !isActive);
            tab.classList.toggle("dark:text-dark-primary-color", !isActive);
            tab.classList.toggle("wdark:bg-wdark-secondary-color", !isActive);
            tab.classList.toggle("wlight:bg-wlight-secondary-color", !isActive);
            tab.classList.toggle("dark:bg-dark-secondary-color", !isActive);
        });
        this.panelTargets.forEach((panel, i)=>{
            const isActive = i === activeIdx;
            panel.classList.toggle("hidden", !isActive);
            panel.classList.toggle("flex", isActive);
        });
    }
}


// controllers/scan_controller.js



class $3e64758101641bb9$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "reader",
        "result",
        "overlay"
    ];
    static values = {
        startDelay: {
            type: Number,
            default: 100
        },
        autoStart: {
            type: Boolean,
            default: true
        },
        qrbox: {
            type: Number,
            default: 250
        }
    };
    connect() {
        this._starting = false;
        this._stopping = false;
        this._beforeRender = ()=>this.gracefulStop();
        document.addEventListener("turbo:before-render", this._beforeRender);
        if (this.autoStartValue) this._timer = setTimeout(()=>this.start(), this.startDelayValue);
    }
    disconnect() {
        clearTimeout(this._timer);
        document.removeEventListener("turbo:before-render", this._beforeRender);
        // fire-and-forget; don't await inside disconnect
        this.gracefulStop();
    }
    async start() {
        if (!this.hasReaderTarget) return;
        // Hide the "Scan QR" overlay (if any) once the camera is being brought up.
        if (this.hasOverlayTarget) this.overlayTarget.classList.add("hidden");
        if (this._stopping) await this._waitUntil(()=>!this._stopping);
        if (this.html5) await this.gracefulStop();
        this._starting = true;
        try {
            const { Html5Qrcode: Html5Qrcode, Html5QrcodeSupportedFormats: Html5QrcodeSupportedFormats } = await (parcelRequire("6QUUT"));
            const devices = await Html5Qrcode.getCameras();
            if (!devices?.length) {
                (0, $e4096da1729505e0$export$2e2bcd8739ae039)("No cameras found", "error");
                return;
            }
            const backCameras = devices.filter((d)=>/back|rear|environment/i.test(d.label || ""));
            const preferredCamera = backCameras.find((d)=>!/wide/i.test(d.label || "")) || backCameras[0] || devices[0];
            const cameraId = preferredCamera.id;
            this.html5 = new Html5Qrcode(this.readerTarget.id, {
                verbose: false
            });
            await this.html5.start(cameraId, {
                fps: 10,
                ...this.qrboxValue > 0 ? {
                    qrbox: this.qrboxValue
                } : {},
                formatsToSupport: [
                    Html5QrcodeSupportedFormats.QR_CODE
                ]
            }, (decodedText)=>this.onDecode(decodedText));
            const video = document.querySelector(`#${this.readerTarget.id} video`);
            if (video && video.srcObject) {
                const track = video.srcObject.getVideoTracks()[0];
                const capabilities = track.getCapabilities?.();
                if (capabilities?.focusMode?.includes("continuous")) await track.applyConstraints({
                    advanced: [
                        {
                            focusMode: "continuous"
                        }
                    ]
                });
            }
        } catch (err) {
            console.error("QR start error:", err);
            (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Camera access failed", "error");
            this.html5 = null;
        } finally{
            this._starting = false;
        }
    }
    async gracefulStop() {
        if (!this.html5 || this._stopping) return;
        if (this._starting) await this._waitUntil(()=>!this._starting);
        this._stopping = true;
        try {
            await this.html5.stop();
            this.html5.clear();
        } catch (err) {
            const msg = String(err || "");
            if (!msg.includes("under transition")) console.warn("QR stop error:", err);
        } finally{
            this.html5 = null;
            this._stopping = false;
        }
    }
    onDecode(text) {
        this.gracefulStop();
        try {
            const marker = "/send/to/";
            const index = text.indexOf(marker);
            if (index !== -1) {
                const lastPart = text.substring(index + marker.length);
                if (lastPart) {
                    Turbo.visit(`/send/to/${encodeURIComponent(lastPart)}`, {
                        action: "advance"
                    });
                    return;
                }
            }
            (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Invalid QR code. Please try again.", "error");
            this.setContent(text);
            setTimeout(()=>{
                this.start();
            }, 800);
        } catch (err) {
            console.error("QR decode error:", err);
            (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Error. Please try again.", "error");
            setTimeout(()=>{
                this.start();
            }, 800);
        }
    }
    setContent(text) {
        this.resultTarget.classList.remove("hidden");
        if (this.hasResultTarget) this.resultTarget.textContent = `Scanned: ${text}`;
    }
    _waitUntil(pred, timeout = 1000) {
        return new Promise((resolve)=>{
            const start = performance.now();
            const tick = ()=>pred() || performance.now() - start > timeout ? resolve() : requestAnimationFrame(tick);
            tick();
        });
    }
}


// controllers/searchableSelectController.js

class $4489ad58521d3dc3$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "trigger",
        "dropdown",
        "selectedText",
        "hiddenInput",
        "chevron",
        "searchInput",
        "option",
        "optionsContainer"
    ];
    static values = {
        name: String
    };
    connect() {
        this.boundHandleClickOutside = this.handleClickOutside.bind(this);
        document.addEventListener("click", this.boundHandleClickOutside);
    }
    disconnect() {
        document.removeEventListener("click", this.boundHandleClickOutside);
    }
    toggle(event) {
        event.stopPropagation();
        // Close all other dropdowns first
        this.closeOtherDropdowns();
        // Toggle this dropdown
        const isHidden = this.dropdownTarget.classList.toggle("hidden");
        this.chevronTarget.classList.toggle("rotate-180");
        // If opening, focus search input and reset search
        if (!isHidden) {
            this.searchInputTarget.value = "";
            this.search();
            setTimeout(()=>this.searchInputTarget.focus(), 100);
        }
    }
    search() {
        const searchTerm = this.searchInputTarget.value.toLowerCase();
        let visibleCount = 0;
        this.optionTargets.forEach((option)=>{
            const text = option.textContent.toLowerCase();
            if (text.includes(searchTerm)) {
                option.classList.remove("hidden");
                visibleCount++;
            } else option.classList.add("hidden");
        });
        // Show "No results" message if no options match
        this.updateNoResultsMessage(visibleCount);
    }
    updateNoResultsMessage(visibleCount) {
        let noResultsEl = this.optionsContainerTarget.querySelector('[data-no-results]');
        if (visibleCount === 0) {
            if (!noResultsEl) {
                noResultsEl = document.createElement('div');
                noResultsEl.setAttribute('data-no-results', '');
                noResultsEl.className = 'px-4 py-8 text-center text-gray-500';
                noResultsEl.textContent = 'No items found';
                this.optionsContainerTarget.appendChild(noResultsEl);
            }
        } else if (noResultsEl) noResultsEl.remove();
    }
    select(event) {
        const displayText = event.params.display;
        const value = event.params.value;
        this.selectedTextTarget.textContent = displayText;
        this.selectedTextTarget.classList.remove("dark:text-dark-input-icon-and-text-secondary", "wdark:text-wdark-input-icon-and-text-secondary");
        this.selectedTextTarget.classList.add("dark:text-dark-input-icon-and-text", "wdark:text-wdark-input-icon-and-text");
        this.hiddenInputTarget.value = value;
        this.hiddenInputTarget.name = this.nameValue;
        this.close();
        this.hiddenInputTarget.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    close() {
        this.dropdownTarget.classList.add("hidden");
        this.chevronTarget.classList.remove("rotate-180");
        this.searchInputTarget.value = "";
        this.search() // Reset all options to visible
        ;
    }
    closeOtherDropdowns() {
        // Find all other searchable-select controllers and close their dropdowns
        document.querySelectorAll('[data-controller*="searchable-select"]').forEach((element)=>{
            if (element !== this.element) {
                const controller = this.application.getControllerForElementAndIdentifier(element, "searchable-select");
                if (controller && controller.close) controller.close();
            }
        });
        // Also close regular select dropdowns (substring match can hit non-select controllers; getController may be null)
        document.querySelectorAll('[data-controller*="select"]').forEach((element)=>{
            if (element !== this.element) {
                const controller = this.application.getControllerForElementAndIdentifier(element, "select");
                if (controller && controller.close) controller.close();
            }
        });
    }
    handleClickOutside(event) {
        if (!this.element.contains(event.target)) this.close();
    }
}


// controllers/select_controller.js

class $38216c34aa0c2e48$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "trigger",
        "dropdown",
        "selectedText",
        "selectedSubtext",
        "hiddenInput",
        "chevron"
    ];
    static values = {
        name: String,
        placeholder: String
    };
    connect() {
        this.boundHandleClickOutside = this.handleClickOutside.bind(this);
        document.addEventListener("click", this.boundHandleClickOutside);
        // Ensure placeholder/selected styling is correct on first render (e.g. preview mode)
        this.syncSelectedTextStyle();
    }
    disconnect() {
        document.removeEventListener("click", this.boundHandleClickOutside);
    }
    toggle(event) {
        event.stopPropagation();
        if (!this.hasDropdownTarget) return;
        // Close all other select dropdowns first
        this.closeOtherDropdowns();
        // Toggle this dropdown
        this.dropdownTarget.classList.toggle("hidden");
        if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-180");
    }
    select(event) {
        const displayText = event.params.display;
        const subtext = event.params.subtext;
        const value = event.params.value;
        this.selectedTextTarget.textContent = displayText;
        if (this.hasSelectedSubtextTarget) this.selectedSubtextTarget.textContent = subtext;
        this.hiddenInputTarget.value = value;
        this.hiddenInputTarget.name = this.nameValue;
        this.syncSelectedTextStyle(displayText, value);
        this.close();
        this.hiddenInputTarget.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    close() {
        if (!this.hasDropdownTarget) return;
        this.dropdownTarget.classList.add("hidden");
        if (this.hasChevronTarget) this.chevronTarget.classList.remove("rotate-180");
    }
    closeOtherDropdowns() {
        // Find all other select controllers and close their dropdowns
        document.querySelectorAll('[data-controller*="select"]').forEach((element)=>{
            if (element !== this.element) {
                const controller = this.application.getControllerForElementAndIdentifier(element, "select");
                if (controller && controller.close) controller.close();
            }
        });
    }
    handleClickOutside(event) {
        if (!this.element.contains(event.target)) this.close();
    }
    syncSelectedTextStyle(displayTextParam, valueParam) {
        if (!this.hasSelectedTextTarget) return;
        const displayText = displayTextParam ?? this.selectedTextTarget.textContent?.trim() ?? "";
        const value = valueParam ?? (this.hasHiddenInputTarget ? this.hiddenInputTarget.value : "");
        const placeholderMatches = this.hasPlaceholderValue && displayText === this.placeholderValue;
        const isPlaceholder = placeholderMatches || displayText === "" && value === "";
        const usesInputIconTokens = this.selectedTextTarget.classList.contains("dark:text-dark-input-icon-and-text") || this.selectedTextTarget.classList.contains("wdark:text-wdark-input-icon-and-text") || this.selectedTextTarget.classList.contains("dark:text-dark-input-icon-and-text-secondary") || this.selectedTextTarget.classList.contains("wdark:text-wdark-input-icon-and-text-secondary") || this.hasPlaceholderValue;
        if (!usesInputIconTokens) return;
        if (isPlaceholder) {
            this.selectedTextTarget.classList.remove("dark:text-dark-input-icon-and-text", "wdark:text-wdark-input-icon-and-text");
            this.selectedTextTarget.classList.add("dark:text-dark-input-icon-and-text-secondary", "wdark:text-wdark-input-icon-and-text-secondary");
        } else {
            this.selectedTextTarget.classList.remove("dark:text-dark-input-icon-and-text-secondary", "wdark:text-wdark-input-icon-and-text-secondary");
            this.selectedTextTarget.classList.add("dark:text-dark-input-icon-and-text", "wdark:text-wdark-input-icon-and-text");
        }
    }
}


// a generic controller that triggers a POST request when a select input changes
// html usage: data-controller="select-trigger" data-select-trigger-endpoint-value="/endpoint"


class $fb154414b4c46189$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "input"
    ] //html Usage: data-select-trigger-input-target="input"
    ;
    static values = {
        endpoint: String,
        payloadKey: String,
        includeFormFields: Boolean,
        csrfToken: String
    };
    connect() {
        // Listen for change events on the input target
        this.inputTarget.addEventListener("change", this.handleInputChange.bind(this));
    }
    disconnect() {
        this.inputTarget.removeEventListener("change", this.handleInputChange.bind(this));
    }
    handleInputChange(event) {
        const value = event.target.value || "";
        // Submit POST request with the input value
        this.submitRequest(value);
    }
    async submitRequest(value) {
        try {
            if (!this.endpointValue) {
                console.error("selectTriggerController: endpoint value is required");
                return;
            }
            // Build FormData for turbo-stream compatible requests
            let formData = new FormData();
            // If includeFormFields is true, gather all form fields
            if (this.includeFormFieldsValue) {
                const form = this.inputTarget.closest('form');
                if (form) {
                    const existingFormData = new FormData(form);
                    for (const [key, val] of existingFormData.entries())formData.append(key, val);
                }
            } else {
                // Default behavior: only send the input value
                const payloadKey = this.payloadKeyValue || this.inputTarget.name || "value";
                formData.append(payloadKey, value);
                // Get CSRF token from the main form if available
                const csrfInput = this.csrfTokenValue;
                if (csrfInput) formData.append('csrf_token', csrfInput);
            }
            // Send as FormData for compatibility with Go's PostForm
            // Use rrFetch to maintain session handling and embed detection
            const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(this.endpointValue, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'text/vnd.turbo-stream.html'
                }
            });
            if (!response.ok) console.error(`selectTriggerController: HTTP error! status: ${response.status}`);
            const html = await response.text();
            // Render turbo stream response
            if (html && globalThis.Turbo) await globalThis.Turbo.renderStreamMessage(html);
        } catch (error) {
            console.error("Error in selectTriggerController:", error);
        }
    }
}


// controllers/send_controller.js


class $09c8d1a5c6bda116$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "form",
        "amount",
        "email"
    ];
    static values = {
        posturl: String,
        max: Number,
        amountLocked: Boolean
    };
    connect() {
        // If you want to set the action from data value, do it once here.
        if (this.hasPosturlValue && this.formTarget.action !== this.posturlValue) this.formTarget.action = this.posturlValue;
        this.loadSavedData();
    }
    loadSavedData() {
        const savedAmount = sessionStorage.getItem("sendAmount");
        const savedEmail = sessionStorage.getItem("sendEmail");
        if (savedAmount && this.hasAmountTarget) {
            this.amountTarget.value = savedAmount;
            this.amountTarget.dataset.autofilled = "1";
            this.amountTarget.dataset.initialValue = savedAmount;
        }
        if (savedEmail && this.hasEmailTarget) {
            this.emailTarget.value = savedEmail;
            this.emailTarget.dataset.autofilled = "1";
            this.emailTarget.dataset.initialValue = savedEmail;
        }
    }
    setSavedData() {
        sessionStorage.setItem("sendAmount", this.amountTarget?.value ?? "");
        sessionStorage.setItem("sendEmail", this.emailTarget?.value ?? "");
    }
    clearSavedData() {
        sessionStorage.removeItem("sendAmount");
        sessionStorage.removeItem("sendEmail");
    }
    // data-action="submit->send#submit" on the <form>
    submit = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        // 1) native form constraints first
        if (!this.formTarget.checkValidity()) {
            this.formTarget.reportValidity();
            return;
        }
        // If over max, cap and REQUIRE second submit
        if (this.hasAmountTarget && this.hasMaxValue) {
            const num = this.parseAmount(this.amountTarget.value ?? "");
            if (Number.isFinite(num) && num > this.maxValue) {
                e.preventDefault(); // stop this submit
                if (this.amountLockedValue) (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Insufficient funds", "error");
                else {
                    this.amountTarget.value = this.formatAmount(this.maxValue);
                    this.amountTarget.focus();
                    this.amountTarget.select?.();
                }
                return; // user must press submit again
            }
        }
        // set ammount and email to the session storage
        this.setSavedData();
        this.formTarget.requestSubmit();
    };
    // Handle Turbo submit completion
    onSubmitEnd = (event)=>{};
    // --- helpers ---
    parseAmount(v) {
        const cleaned = String(v).replace(/[^0-9.]/g, "");
        const [head, ...rest] = cleaned.split(".");
        const normalized = head + (rest.length ? "." + rest.join("") : "");
        const n = Number.parseFloat(normalized);
        return Number.isFinite(n) ? n : NaN;
    }
    formatAmount(n) {
        return (Math.round(n * 100) / 100).toFixed(2);
    }
}









class $9fd18f8ea2bd2adf$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "form",
        "confirmButton",
        "editButton",
        "spinner",
        "buttonText",
        "note"
    ];
    static values = {
        challengeRequestUrl: {
            type: String,
            default: "/passkey/challenge/request"
        },
        canUseTransactionNotes: {
            type: Boolean,
            default: true
        },
        domain: String,
        company: String,
        idempotencyKey: String,
        csrfToken: String,
        payload: Object,
        provider: String,
        note: String,
        sendAttemptId: String
    };
    connect() {
        this.tryAttachProcessTransfer();
    }
    tryAttachProcessTransfer() {
        const controller = this.application.getControllerForElementAndIdentifier(this.element.closest('[data-controller~="process-transfer"]'), "process-transfer");
        if (controller) this.processTransferController = controller;
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)(this.processTransferController);
    }
    async requestValidationChallenge(event) {
        event.preventDefault();
        this.showLoading();
        try {
            // Step 1: Get challenge from backend (this will fail if no passkey exists)
            const challengeData = await this.getValidationChallenge();
            // Step 2: Sign challenge using WebAuthn (this is signing, not credential creation)
            const signedChallengeData = await this.createWebAuthnCredentialFromValidation(challengeData);
            // Step 3: Submit the signed challenge and execute transfer
            await this.executeTransaction(signedChallengeData);
        } catch (error) {
            (0, $c0e0e410f6c5ef5d$export$280f90b954565303)("Error in passkey validation:", error);
            if (error.message !== "backend-error") {
                if (error.name === "TypeError" || error.message.includes("fetch")) (0, $e4096da1729505e0$export$2e2bcd8739ae039)("Unable to connect to server. Please check your connection.", "error");
                else (0, $e4096da1729505e0$export$2e2bcd8739ae039)((0, $b8614c1cf7554158$export$85575c1a77628ede)(error), "error");
            }
            this.hideLoading();
        }
    }
    shouldIncludeNote() {
        if (!this.canUseTransactionNotesValue) return false;
        const source = this.payloadValue?.source;
        return source === "send" || source === "withdraw";
    }
    getCurrentNoteValue(fallback = "") {
        if (!this.canUseTransactionNotesValue) return "";
        let noteValue = fallback;
        if (this.hasNoteTarget) noteValue = this.noteTarget.value || noteValue;
        else if (this.processTransferController?.hasNoteTarget) noteValue = this.processTransferController.noteTarget.value || noteValue;
        return (noteValue || "").trim();
    }
    async getValidationChallenge() {
        if (!this.hasPayloadValue || !this.payloadValue) throw new Error("Payload is required but not provided");
        const formData = new FormData();
        formData.append("payload", JSON.stringify(this.payloadValue));
        formData.append("idempotency_key", this.idempotencyKeyValue);
        formData.append("provider", this.providerValue);
        if (this.shouldIncludeNote()) {
            const noteValue = this.getCurrentNoteValue();
            if (noteValue) formData.append("note", noteValue);
        }
        formData.append("send_attempt_id", this.sendAttemptIdValue);
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)("/passkey/challenge/request", {
            method: "POST",
            headers: {
                "X-CSRF-Token": this.csrfTokenValue
            },
            body: formData
        });
        return await (0, $76e753e031c74aeb$export$ea607f18896190ac)(response, "Failed to get challenge");
    }
    async createWebAuthnCredentialFromValidation(challengeData) {
        // For WebAuthn, relying party ID must match the current domain
        const currentDomain = globalThis.location.hostname;
        const relyingPartyId = this.domainValue || currentDomain;
        const relyingPartyName = this.companyValue || "CoinSub Wallet";
        let webauthn = new (0, $b30e2eb3b270edb4$exports.WebAuthnSigner)({
            relyingParty: {
                id: relyingPartyId,
                name: relyingPartyName
            }
        });
        const challengeIdentifier = challengeData.challengeIdentifier;
        const agreementId = challengeData.agreementId;
        const keyId = challengeData.keyId;
        const note = challengeData.note;
        // Get payload from challenge response
        const payload = challengeData.payload || {};
        const includeNote = this.shouldIncludeNote();
        const noteValue = includeNote ? this.getCurrentNoteValue(this.noteValue || note || "") : "";
        // Keep note in payload for send flow compatibility when notes are enabled.
        if (payload.source === "send") {
            if (includeNote && noteValue) payload.note = noteValue;
            else delete payload.note;
        }
        if (!challengeIdentifier) throw new Error("Challenge identifier is missing from challenge data");
        const assertion = await webauthn.sign(challengeData);
        const credentialAssertion = assertion.credentialAssertion;
        // Get all values from payload
        if (!payload) throw new Error("Payload is required but not provided");
        const signedChallengeData = {
            challengeIdentifier: challengeIdentifier,
            agreementId: agreementId,
            keyId: keyId,
            signature: {
                kind: "Fido2",
                credentialAssertion: {
                    credId: credentialAssertion.credId || "",
                    clientData: credentialAssertion.clientData || "",
                    signature: credentialAssertion.signature || "",
                    authenticatorData: credentialAssertion.authenticatorData || "",
                    userHandle: credentialAssertion.userHandle || ""
                }
            },
            networkName: "Polygon",
            idempotencyKey: this.idempotencyKeyValue,
            payload: payload,
            send_attempt_id: this.sendAttemptIdValue
        };
        if (includeNote && noteValue) signedChallengeData.note = noteValue;
        return signedChallengeData;
    }
    async executeTransaction(signedChallengeData) {
        signedChallengeData.idempotencyKey = this.idempotencyKeyValue;
        const response = await (0, $7698590c42a3bf25$export$18b31d9eba2a1098)('/passkey/challenge/submit', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.csrfTokenValue
            },
            body: JSON.stringify(signedChallengeData)
        });
        return await (0, $76e753e031c74aeb$export$ea607f18896190ac)(response, "Transaction failed");
    }
    showLoading() {
        // Disable confirm button
        this.confirmButtonTarget.disabled = true;
        // Disable edit link (anchor tag)
        if (this.hasEditButtonTarget) {
            this.editButtonTarget.classList.add('pointer-events-none', 'opacity-50');
            this.editButtonTarget.setAttribute('aria-disabled', 'true');
        }
        // Show spinner
        this.spinnerTarget.classList.remove('hidden');
        // Update text
        this.buttonTextTarget.textContent = "Processing...";
    }
    hideLoading() {
        // Enable confirm button
        this.confirmButtonTarget.disabled = false;
        // Enable edit link
        if (this.hasEditButtonTarget) {
            this.editButtonTarget.classList.remove('pointer-events-none', 'opacity-50');
            this.editButtonTarget.removeAttribute('aria-disabled');
        }
        // Hide spinner
        this.spinnerTarget.classList.add('hidden');
        // Restore text
        this.buttonTextTarget.textContent = "Confirm";
    }
}



var $56deb226d5cec537$var$i = function() {
    return $56deb226d5cec537$var$i = Object.assign || function(i) {
        for(var t, e = 1, o = arguments.length; e < o; e++)for(var n in t = arguments[e])Object.prototype.hasOwnProperty.call(t, n) && (i[n] = t[n]);
        return i;
    }, $56deb226d5cec537$var$i.apply(this, arguments);
};
function $56deb226d5cec537$var$t(i) {
    return i.endsWith("-v2") ? 2 : 1;
}
var $56deb226d5cec537$var$e = function() {
    function e(i, t, e, o) {
        var n = this;
        this.iframe = null, this.iframeId = null, this.sessionId = "", this.$container = null, this.initialized = !1, this.scrollPosition = -1, this.scrollElement = null, this.onMessage = function(i) {
            n.onSdkMessage(i);
        }, this.baseUrl = i || this.getCurrentBaseUrl("https://in.sumsub.com", t.accessToken), this.config = t, this.config.packageVersion = this.getVersion(), this.config.origin = location.origin, this.callbacks = e, this.options = o;
    }
    return e.prototype.getVersion = function() {
        return "2.6.2";
    }, e.prototype.getCurrentBaseUrl = function(i, t) {
        var e = [
            "_act-sbx-jwt-",
            "_act-jwt-"
        ].find(function(i) {
            return t.startsWith(i);
        });
        if (e) for(var o = 0, n = t.replace(e, "").replace("-v2", "").split(".").map(function(i) {
            try {
                return atob(i);
            } catch (t) {
                return i;
            }
        }).map(function(i) {
            try {
                return JSON.parse(i);
            } catch (t) {
                return i;
            }
        }); o < n.length; o++){
            var s = n[o];
            if (null == s ? void 0 : s.url) return s.url;
        }
        return i;
    }, e.prototype.getIframeId = function() {
        if (2 === this.config.version) try {
            return btoa(this.config.accessToken);
        } catch (i) {
            return this.config.accessToken;
        }
        return String(Math.floor(1e8 * Math.random()));
    }, e.prototype.launch = function(i) {
        this.options.addViewportTag && this.addViewportTag(), this.iframe = this.createIframe(i), this.sessionId = "", this.iframeId = "id_" + this.getIframeId(), this.iframe && this.config ? (this.registerEventListener(), this.iframe.src = this.getIframeSrc()) : console.error("Idensic was not initialized since either provided element was not found in the DOM or invalid config");
    }, e.prototype.addViewportTag = function() {
        var i = document.getElementsByName("viewport");
        if (!i || 0 === i.length) {
            var t = document.createElement("meta");
            t.setAttribute("name", "viewport"), t.setAttribute("content", "width=device-width,user-scalable=yes"), document.head.appendChild(t);
        }
    }, e.prototype.createIframe = function(i) {
        var t = "string" == typeof i ? document.querySelector(i) : i;
        if (!t) return console.error("Provide a valid selector for the iframe container"), null;
        this.$container = t;
        var e = document.createElement("iframe");
        for(e.width = "100%", e.scrolling = "no", e.allow = "camera; microphone; geolocation; clipboard-write", e.setAttribute("frameborder", "0"); t.firstChild;)t.removeChild(t.firstChild);
        return t.appendChild(e), e;
    }, e.prototype.getIframeSrc = function() {
        var i = "?_=" + this.iframeId, t = 2 === this.config.version ? "/websdk" : "/idensic", e = this.baseUrl + t + "/websdk.html";
        return 2 === this.config.version && this.config.theme && (i += "&theme=" + this.config.theme), 2 === this.config.version && this.config.customizationName && (i += "&customizationName=" + encodeURIComponent(this.config.customizationName)), 2 === this.config.version && this.config.translationName && (i += "&translationName=" + encodeURIComponent(this.config.translationName)), e + i;
    }, e.prototype.registerEventListener = function() {
        window.addEventListener("message", this.onMessage);
    }, e.prototype.onSdkMessage = function(t) {
        var e;
        if (this.baseUrl === t.origin) {
            var o = t.data;
            if (o.method && ~o.method.indexOf("idCheck") && (!this.sessionId || this.sessionId === o.sessionId) && (null === (e = this.iframe) || void 0 === e ? void 0 : e.contentWindow)) {
                if ("idCheck.onReady" == o.method && o.frameId === this.iframeId) {
                    this.sessionId = o.sessionId;
                    var n = {
                        options: {
                            adaptIframeHeight: this.options.adaptIframeHeight,
                            enableScrollIntoView: this.options.enableScrollIntoView
                        }
                    };
                    this.iframe.contentWindow.postMessage($56deb226d5cec537$var$i($56deb226d5cec537$var$i({
                        method: "idCheck.init"
                    }, this.config), n), "*");
                }
                if ("idCheck.onInitialized" == o.method && (this.initialized = !0), "idCheck.onResize" == o.method && this.options.adaptIframeHeight && (this.iframe.style.height = o.height + "px"), "idCheck.onSetBorderRadius" != o.method) {
                    if ("idCheck.scrollTo" == o.method && this.options.adaptIframeHeight) this.scrollTo(o.top);
                    else if ("idCheck.getScrollPosition" != o.method) {
                        if ("idCheck.restoreScrollPosition" != o.method) {
                            var s = o.method;
                            delete o.method, delete o.frameId, delete o.sessionId, "idCheck.onError" === s && "invalid-token" === o.code ? this.callExpirationHandler() : "idCheck.onError" === s && "function" == typeof this.callbacks.onError ? this.callbacks.onError(o) : "function" == typeof this.callbacks.onMessage && this.callbacks.onMessage(s, o);
                        } else this.restoreScrollPosition();
                    } else this.getScrollPosition();
                } else this.iframe && o.radius && "string" == typeof o.radius && (this.iframe.style.borderRadius = o.radius, this.iframe.style.overflow = "hidden");
            }
        }
    }, e.prototype.callExpirationHandler = function() {
        var i = this, t = this.callbacks.expirationHandler;
        t.legacy ? t.handler(function(t) {
            return i.updateAccessTokenOrReinitialize(t);
        }) : t.handler().then(function(t) {
            return i.updateAccessTokenOrReinitialize(t);
        }, function(t) {
            null != t || (t = "Failed to update access token"), t.message && (t = t.message), "string" != typeof t && (t = String(t)), i.updateAccessToken(null, t);
        });
    }, e.prototype.updateAccessTokenOrReinitialize = function(i) {
        var e = i ? $56deb226d5cec537$var$t(i) : this.config.version;
        if (i && this.iframe && !this.initialized && this.config.version != e) return this.sessionId = "", this.config.accessToken = i, this.config.version = e, this.baseUrl = this.getCurrentBaseUrl(this.baseUrl, i), this.iframeId = "id_" + this.getIframeId(), void (this.iframe.src = this.getIframeSrc());
        this.updateAccessToken(i);
    }, e.prototype.getScrolledElement = function() {
        for(var i, t = null === (i = this.iframe) || void 0 === i ? void 0 : i.parentElement; 0 === (null == t ? void 0 : t.scrollTop) && "BODY" !== (null == t ? void 0 : t.tagName);)t = null == t ? void 0 : t.parentElement;
        return t;
    }, e.prototype.getScrollPosition = function() {
        var i, t, e = this.getScrolledElement();
        this.scrollPosition = (null == e ? void 0 : e.scrollTop) || -1, this.scrollElement = this.scrollPosition > 0 && e ? e : null, null === (t = null === (i = this.iframe) || void 0 === i ? void 0 : i.contentWindow) || void 0 === t || t.postMessage({
            method: "idCheck.scrollPositionStored"
        }, "*");
    }, e.prototype.restoreScrollPosition = function() {
        this.scrollElement && this.scrollPosition >= 0 && (this.scrollElement.scrollTop = this.scrollPosition), this.scrollPosition = -1, this.scrollElement = null;
    }, e.prototype.scrollTo = function(i) {
        var t;
        if (this.options.enableScrollIntoView) {
            var e = this.getScrolledElement();
            if (0 === (null == e ? void 0 : e.scrollTop) && "BODY" === (null == e ? void 0 : e.tagName)) {
                var o = (null === (t = this.iframe) || void 0 === t ? void 0 : t.getBoundingClientRect().top) || 0;
                window.scrollTo({
                    top: o + i,
                    behavior: "smooth"
                });
            } else null == e || e.scrollTo({
                top: i,
                behavior: "smooth"
            });
        }
    }, e.prototype.updateAccessToken = function(i, t) {
        var e, o;
        null === (o = null === (e = this.iframe) || void 0 === e ? void 0 : e.contentWindow) || void 0 === o || o.postMessage({
            method: "idCheck.updateAccessToken",
            accessToken: i,
            error: t
        }, "*");
    }, e.prototype.destroy = function() {
        for(window.removeEventListener("message", this.onMessage); this.$container && this.$container.firstChild;)this.$container.removeChild(this.$container.firstChild);
        this.$container = null;
    }, e.prototype.navigateBack = function() {
        var i, t;
        null === (t = null === (i = this.iframe) || void 0 === i ? void 0 : i.contentWindow) || void 0 === t || t.postMessage({
            method: "idCheck.callNavigationBack"
        }, "*");
    }, e.prototype.singleStepNext = function(i) {
        var t, e;
        null === (e = null === (t = this.iframe) || void 0 === t ? void 0 : t.contentWindow) || void 0 === e || e.postMessage({
            method: "idCheck.callSingleStepNext",
            step: i
        }, "*");
    }, e.prototype.setLanguage = function(i) {
        var t, e;
        null === (e = null === (t = this.iframe) || void 0 === t ? void 0 : t.contentWindow) || void 0 === e || e.postMessage({
            method: "idCheck.callSetLanguage",
            language: i
        }, "*");
    }, e.prototype.setTheme = function(i) {
        var t, e;
        null === (e = null === (t = this.iframe) || void 0 === t ? void 0 : t.contentWindow) || void 0 === e || e.postMessage({
            method: "idCheck.callSetTheme",
            theme: i
        }, "*");
    }, e;
}(), $56deb226d5cec537$var$o = function() {
    function i(i, t) {
        if (this.config = null, this.eventHandlers = {}, this.anyEventHandler = null, this.options = {
            adaptIframeHeight: !0,
            addViewportTag: !0,
            enableScrollIntoView: !0
        }, "string" != typeof i) throw new Error("Access token must be a string");
        if ("function" != typeof t) throw new Error("updateAccessToken callback is required");
        this.accessToken = i, this.updateAccessToken = t;
    }
    return i.prototype.onTestEnv = function() {
        return this;
    }, i.prototype.withBaseUrl = function(i) {
        return this.baseUrl = i, this;
    }, i.prototype.withConf = function(i) {
        return this.config = i, this;
    }, i.prototype.withOptions = function(i) {
        var t;
        return i.hasOwnProperty("adaptIframeHeight") && (this.options.adaptIframeHeight = i.adaptIframeHeight), i.hasOwnProperty("addViewportTag") && (this.options.addViewportTag = i.addViewportTag), this.options.enableScrollIntoView = null === (t = i.enableScrollIntoView) || void 0 === t || t, this;
    }, i.prototype.on = function(i, t) {
        return this.eventHandlers[i] = t, this;
    }, i.prototype.onMessage = function(i) {
        return this.anyEventHandler = i, this;
    }, i.prototype.onNavigationUiControlsStateChanged = function(i) {
        return this.eventHandlers["idCheck.onNavigationUiControlsStateChanged"] = i, this;
    }, i.prototype.build = function() {
        var i, o, n, s, r, a, l, c, d, h, u, f, p, g, v, m = this, w = $56deb226d5cec537$var$t(this.accessToken);
        return new $56deb226d5cec537$var$e(this.baseUrl, {
            version: w,
            theme: null === (i = this.config) || void 0 === i ? void 0 : i.theme,
            customizationName: null === (o = this.config) || void 0 === o ? void 0 : o.customizationName,
            translationName: null === (n = this.config) || void 0 === n ? void 0 : n.translationName,
            accessToken: this.accessToken,
            lang: null === (s = this.config) || void 0 === s ? void 0 : s.lang,
            email: null === (r = this.config) || void 0 === r ? void 0 : r.email,
            phone: null === (a = this.config) || void 0 === a ? void 0 : a.phone,
            country: null === (l = this.config) || void 0 === l ? void 0 : l.country,
            uiConf: null === (c = this.config) || void 0 === c ? void 0 : c.uiConf,
            i18n: null === (d = this.config) || void 0 === d ? void 0 : d.i18n,
            documentsByCountries: null === (h = this.config) || void 0 === h ? void 0 : h.documentsByCountries,
            documentDefinitions: null === (u = this.config) || void 0 === u ? void 0 : u.documentDefinitions,
            autoSelectDocumentDefinitions: null === (f = this.config) || void 0 === f ? void 0 : f.autoSelectDocumentDefinitions,
            controlledNavigationBack: null === (p = this.config) || void 0 === p ? void 0 : p.controlledNavigationBack,
            singleStep: null === (g = this.config) || void 0 === g ? void 0 : g.singleStep,
            preferredCameras: null === (v = this.config) || void 0 === v ? void 0 : v.preferredCameras
        }, {
            expirationHandler: {
                legacy: !1,
                handler: this.updateAccessToken
            },
            onMessage: function(i, t) {
                var e, o = m.eventHandlers[i];
                o ? o(t) : null === (e = m.anyEventHandler) || void 0 === e || e.call(m, i, t);
            }
        }, this.options);
    }, i;
}(), $56deb226d5cec537$var$n = function() {
    function i(i, t) {
        this.debugEnabled = !1, this.options = {
            adaptIframeHeight: !0,
            addViewportTag: !0,
            enableScrollIntoView: !0
        }, this.config = null, this.accessToken = null, this.expirationHandler = null, this.baseUrl = i, this.flowName = t;
    }
    return i.prototype.withAccessToken = function(i, t) {
        if (this.accessToken = i, !t || "function" != typeof t) throw new Error('Invalid parameter, "expirationHandler" must be a function');
        return this.expirationHandler = t, this;
    }, i.prototype.debug = function(i) {
        return this.debugEnabled = i, this;
    }, i.prototype.withOptions = function(i) {
        var t;
        return i.hasOwnProperty("adaptIframeHeight") && (this.options.adaptIframeHeight = i.adaptIframeHeight), i.hasOwnProperty("addViewportTag") && (this.options.addViewportTag = i.addViewportTag), this.options.enableScrollIntoView = null === (t = i.enableScrollIntoView) || void 0 === t || t, this;
    }, i.prototype.withConf = function(i) {
        return this.config = i, this;
    }, i.prototype.build = function() {
        var i, o, n, s, r, a, l, c, d, h, u, f, p, g, v;
        if (!this.accessToken || !this.expirationHandler) throw new Error("Configure access token end the expiration handler before");
        var m = $56deb226d5cec537$var$t(this.accessToken);
        return new $56deb226d5cec537$var$e(this.baseUrl, {
            version: m,
            theme: null === (i = this.config) || void 0 === i ? void 0 : i.theme,
            customizationName: null === (o = this.config) || void 0 === o ? void 0 : o.customizationName,
            translationName: null === (n = this.config) || void 0 === n ? void 0 : n.translationName,
            accessToken: this.accessToken,
            flowName: this.flowName,
            lang: null === (s = this.config) || void 0 === s ? void 0 : s.lang,
            email: null === (r = this.config) || void 0 === r ? void 0 : r.email,
            phone: null === (a = this.config) || void 0 === a ? void 0 : a.phone,
            country: null === (l = this.config) || void 0 === l ? void 0 : l.country,
            uiConf: null === (c = this.config) || void 0 === c ? void 0 : c.uiConf,
            i18n: null === (d = this.config) || void 0 === d ? void 0 : d.i18n,
            documentsByCountries: null === (h = this.config) || void 0 === h ? void 0 : h.documentsByCountries,
            documentDefinitions: null === (u = this.config) || void 0 === u ? void 0 : u.documentDefinitions,
            autoSelectDocumentDefinitions: null === (f = this.config) || void 0 === f ? void 0 : f.autoSelectDocumentDefinitions,
            singleStep: null === (p = this.config) || void 0 === p ? void 0 : p.singleStep
        }, {
            expirationHandler: {
                legacy: !0,
                handler: this.expirationHandler
            },
            onMessage: null === (g = this.config) || void 0 === g ? void 0 : g.onMessage,
            onError: null === (v = this.config) || void 0 === v ? void 0 : v.onError
        }, {
            adaptIframeHeight: this.options.adaptIframeHeight,
            addViewportTag: this.options.addViewportTag,
            enableScrollIntoView: this.options.enableScrollIntoView,
            debug: this.debugEnabled
        });
    }, i;
}(), $56deb226d5cec537$export$2e2bcd8739ae039 = {
    Builder: function(i, t) {
        return new $56deb226d5cec537$var$n(i, t);
    },
    init: function(i, t) {
        return new $56deb226d5cec537$var$o(i, t);
    }
};



// Map Sumsub SDK error descriptions to bottomsheet URLs.
// Add new entries here to handle additional error states without touching launch().
const $412b74e4a616ebf1$var$SUMSUB_ERROR_BOTTOMSHEETS = {
    "Applicant is deactivated": "/account-verification/kyc-error/deactivated"
};
class $412b74e4a616ebf1$var$BottomsheetError extends Error {
    constructor(url){
        super("bottomsheet");
        this.bottomsheetUrl = url;
    }
}
class $412b74e4a616ebf1$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        csrfToken: String,
        tokenUrl: String,
        customizationName: String
    };
    static targets = [
        "status",
        "startButton",
        "sdkContainer",
        "retryButton",
        "errorState"
    ];
    connect() {
        this._onResize = this.syncContainerHeight.bind(this);
        window.addEventListener("resize", this._onResize, {
            passive: true
        });
        requestAnimationFrame(()=>{
            this.syncContainerHeight();
            this.start();
        });
    }
    disconnect() {
        if (this._onResize) window.removeEventListener("resize", this._onResize);
    }
    start() {
        if (this.hasStartButtonTarget) this.startButtonTarget.classList.add("hidden");
        if (this.hasSdkContainerTarget) {
            this.sdkContainerTarget.classList.remove("hidden");
            this.syncContainerHeight();
        }
        this.launch();
    }
    syncContainerHeight() {
        if (!this.hasSdkContainerTarget) return;
        const rootRect = this.element.getBoundingClientRect();
        const containerRect = this.sdkContainerTarget.getBoundingClientRect();
        const availableHeight = Math.floor(rootRect.bottom - containerRect.top);
        if (availableHeight > 240) this.sdkContainerTarget.style.height = `${availableHeight}px`;
    }
    showStatus(message) {
        this.showError(message);
    }
    showError(message) {
        if (this.hasStatusTarget) this.statusTarget.textContent = message;
        if (this.hasErrorStateTarget) this.errorStateTarget.classList.remove("hidden");
        if (this.hasSdkContainerTarget) this.sdkContainerTarget.classList.add("hidden");
    }
    hideError() {
        if (this.hasErrorStateTarget) this.errorStateTarget.classList.add("hidden");
        if (this.hasStatusTarget) this.statusTarget.textContent = "";
        if (this.hasSdkContainerTarget) this.sdkContainerTarget.classList.remove("hidden");
    }
    _fetchBottomsheet(url) {
        (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(url, {
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                Accept: "text/vnd.turbo-stream.html"
            },
            credentials: "same-origin"
        }).then((r)=>{
            if (!r.ok) throw new Error(r.status);
            return r.text();
        }).then((html)=>Turbo.renderStreamMessage(html)).catch((e)=>{
            console.error("Failed to fetch KYC error bottomsheet:", e);
        });
    }
    _handleSdkError(err) {
        const description = err?.description || (typeof err === "string" ? err : null);
        const url = description && $412b74e4a616ebf1$var$SUMSUB_ERROR_BOTTOMSHEETS[description];
        if (url) {
            this._fetchBottomsheet(url);
            return;
        }
        const msg = description || err?.code || "Verification error";
        this.showStatus(msg);
    }
    async fetchToken() {
        const res = await fetch(this.tokenUrlValue, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.csrfTokenValue,
                Accept: "application/json"
            },
            body: "{}"
        });
        const data = await res.json().catch(()=>({}));
        if (!res.ok) {
            if (data.bottomsheet_url) throw new $412b74e4a616ebf1$var$BottomsheetError(data.bottomsheet_url);
            throw new Error(data.error || res.statusText || "Token request failed");
        }
        if (!data.token) throw new Error("No token in response");
        return data.token;
    }
    async launch() {
        this.hideError();
        try {
            const accessToken = await this.fetchToken();
            const instance = (0, $56deb226d5cec537$export$2e2bcd8739ae039).init(accessToken, ()=>this.fetchToken()).withConf({
                lang: "en",
                theme: "dark",
                customCssStr: `
            :root { --border-radius: 12px; }
            html, body { height: 100% !important; min-height: 100% !important; }
            body { border-radius: 12px; overflow: hidden; }
          `,
                customizationName: this.customizationNameValue
            }).withOptions({
                addViewportTag: false,
                adaptIframeHeight: false
            }).on("idCheck.onStepCompleted", ()=>{}).on("idCheck.onError", (err)=>{
                console.warn("Sumsub WebSDK error", err);
                this._handleSdkError(err);
            }).build();
            instance.launch("#sumsub-websdk-container");
        } catch (e) {
            if (e instanceof $412b74e4a616ebf1$var$BottomsheetError) this._fetchBottomsheet(e.bottomsheetUrl);
            else {
                console.error(e);
                this.showError(e.message);
            }
        }
    }
}



class $f00701fdd67d1d43$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "scroll",
        "acceptButton",
        "termsBottom",
        "scrollToBottomButton",
        "customScrollbar",
        "customThumb"
    ];
    static values = {
        threshold: {
            type: Number,
            default: 12
        }
    };
    connect() {
        if (!this.hasScrollTarget || !this.hasAcceptButtonTarget) return;
        this.unlocked = false;
        this.onScroll = this.onScroll.bind(this);
        this.scrollTarget.addEventListener("scroll", this.onScroll, {
            passive: true
        });
        this.onResize = this.onResize.bind(this);
        window.addEventListener("resize", this.onResize, {
            passive: true
        });
        if (this.hasTermsBottomTarget) {
            this.io = new IntersectionObserver((entries)=>{
                const visible = entries[0]?.isIntersecting;
                if (visible) {
                    console.log("[terms] termsBottom is visible");
                    this.unlock();
                }
            }, {
                root: this.scrollTarget,
                threshold: 0.01
            });
            this.io.observe(this.termsBottomTarget);
        }
        this.setupCustomScrollbar();
        this.syncState();
        this.isScrollbarSyncActive = true;
        this.scrollbarTick();
    }
    disconnect() {
        if (this.hasScrollTarget) this.scrollTarget.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("resize", this.onResize);
        if (this.io) {
            this.io.disconnect();
            this.io = null;
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        this.isScrollbarSyncActive = false;
        if (this.scrollbarRafId) {
            cancelAnimationFrame(this.scrollbarRafId);
            this.scrollbarRafId = null;
        }
    }
    onScroll() {
        this.syncState();
        this.updateCustomScrollbar();
    }
    onResize() {
        this.updateCustomScrollbar();
    }
    setupCustomScrollbar() {
        if (!this.hasCustomScrollbarTarget || !this.hasCustomThumbTarget || !this.hasScrollTarget) return;
        this.resizeObserver = new ResizeObserver(()=>{
            this.updateCustomScrollbar();
        });
        this.resizeObserver.observe(this.scrollTarget);
        const scrollContent = this.scrollTarget.firstElementChild;
        if (scrollContent) this.resizeObserver.observe(scrollContent);
    }
    updateCustomScrollbar() {
        if (!this.hasCustomScrollbarTarget || !this.hasCustomThumbTarget || !this.hasScrollTarget) return;
        const scrollEl = this.scrollTarget;
        const trackEl = this.customScrollbarTarget;
        const thumbEl = this.customThumbTarget;
        const verticalOffsetTop = 80;
        const verticalOffsetBottom = 108;
        const trackTop = scrollEl.offsetTop + verticalOffsetTop;
        const trackHeightFromViewport = Math.max(0, scrollEl.clientHeight - verticalOffsetTop - verticalOffsetBottom);
        const scrollHeight = scrollEl.scrollHeight;
        const clientHeight = scrollEl.clientHeight;
        const canScroll = scrollHeight > clientHeight + 1;
        if (trackHeightFromViewport <= 0) return;
        trackEl.style.top = `${trackTop}px`;
        trackEl.style.height = `${trackHeightFromViewport}px`;
        trackEl.style.display = "block";
        trackEl.style.opacity = canScroll ? "1" : "0.55";
        const trackHeight = trackEl.clientHeight;
        const minThumbHeight = 30;
        const thumbHeight = canScroll ? Math.max(minThumbHeight, clientHeight / scrollHeight * trackHeight) : Math.max(minThumbHeight, trackHeight);
        const maxThumbTop = Math.max(0, trackHeight - thumbHeight);
        const maxScrollTop = Math.max(1, scrollHeight - clientHeight);
        const thumbTop = canScroll ? scrollEl.scrollTop / maxScrollTop * maxThumbTop : 0;
        thumbEl.style.height = `${thumbHeight}px`;
        thumbEl.style.transform = `translateY(${thumbTop}px)`;
    }
    scrollbarTick() {
        if (!this.isScrollbarSyncActive) return;
        this.updateCustomScrollbar();
        this.scrollbarRafId = requestAnimationFrame(()=>this.scrollbarTick());
    }
    async scrollToTermsBottom(event) {
        event.preventDefault();
        if (!this.hasTermsBottomTarget || !this.hasScrollTarget) return;
        const extraOffset = 120;
        const scrollEl = this.scrollTarget;
        const scrollRect = scrollEl.getBoundingClientRect();
        const targetRect = this.termsBottomTarget.getBoundingClientRect();
        const targetTopInScroll = targetRect.top - scrollRect.top + scrollEl.scrollTop;
        const targetBottomInScroll = targetTopInScroll + this.termsBottomTarget.offsetHeight;
        const endAlignedTop = targetBottomInScroll - scrollEl.clientHeight;
        const desiredTop = Math.min(scrollEl.scrollHeight - scrollEl.clientHeight, Math.max(0, endAlignedTop + extraOffset));
        scrollEl.scrollTo({
            top: desiredTop,
            behavior: "smooth"
        });
        await this.waitForScrollFinish(scrollEl, desiredTop);
        if (this.hasScrollToBottomButtonTarget) this.scrollToBottomButtonTarget.classList.add("hidden");
    }
    waitForScrollFinish(scrollEl, desiredTop) {
        return new Promise((resolve)=>{
            const maxWaitMs = 1200;
            const start = performance.now();
            const done = ()=>resolve();
            const tick = ()=>{
                const reached = Math.abs(scrollEl.scrollTop - desiredTop) <= 2;
                const timedOut = performance.now() - start > maxWaitMs;
                if (reached || timedOut) {
                    done();
                    return;
                }
                requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
        });
    }
    unlock() {
        if (this.unlocked) return;
        this.unlocked = true;
        const btn = this.acceptButtonTarget;
        btn.disabled = false;
        btn.classList.remove("pointer-events-none", "backdrop-blur-lg", "bg-white/10", "wlight:bg-[#1c197b]/10", "wdark:text-wdark-text-and-title", "wlight:text-wlight-text-and-title", "dark:text-dark-text-and-title");
        btn.classList.add("cursor-pointer", "wdark:bg-wdark-button-background", "wlight:bg-wlight-button-background", "dark:bg-dark-button-background", "wdark:text-wdark-primary-icon-and-text", "wlight:text-wlight-primary-icon-and-text", "dark:text-dark-primary-icon-and-text");
        if (this.io) {
            this.io.disconnect();
            this.io = null;
        }
    }
    syncState() {
        if (this.unlocked) return;
        const el = this.scrollTarget;
        const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
        const atBottom = distanceFromBottom <= this.thresholdValue;
        if (atBottom) this.unlock();
    }
}



// Toggles the wallet UI between the network's dark theme (wdark/dark/cdark) and
// the shared light theme (wlight). The choice is persisted in localStorage and
// re-applied before first paint by the inline script in base.html (no FOUC).
//
// Markup:
//   <button data-controller="theme-toggle" data-action="theme-toggle#toggle">
//     <span data-theme-toggle-target="dark">…moon…</span>
//     <span data-theme-toggle-target="light">…sun…</span>
//   </button>
const $ad0bfd9e8d70f11c$var$STORAGE_KEY = "waas-theme";
const $ad0bfd9e8d70f11c$var$DARK_THEMES = [
    "wdark",
    "dark",
    "cdark"
];
class $ad0bfd9e8d70f11c$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "dark",
        "light"
    ];
    connect() {
        this.syncIcons();
    }
    toggle() {
        const root = document.documentElement;
        if (this.isLight()) {
            this.applyDark(root);
            this.store("dark");
        } else {
            this.applyLight(root);
            this.store("light");
        }
        this.syncIcons();
        // Let theme-dependent controllers (e.g. background video) react.
        document.dispatchEvent(new CustomEvent("theme:changed", {
            detail: {
                light: this.isLight()
            }
        }));
    }
    isLight() {
        return document.documentElement.classList.contains("wlight");
    }
    networkDarkTheme() {
        const root = document.documentElement;
        return root.getAttribute("data-dark-theme") || $ad0bfd9e8d70f11c$var$DARK_THEMES.find((t)=>root.classList.contains(t)) || "wdark";
    }
    applyLight(root) {
        $ad0bfd9e8d70f11c$var$DARK_THEMES.forEach((t)=>root.classList.remove(t));
        root.classList.add("wlight");
    }
    applyDark(root) {
        root.classList.remove("wlight");
        root.classList.add(this.networkDarkTheme());
    }
    store(value) {
        try {
            localStorage.setItem($ad0bfd9e8d70f11c$var$STORAGE_KEY, value);
        } catch (e) {
        /* storage unavailable — theme still applies for this session */ }
    }
    // Show the icon representing the theme you'd switch TO.
    syncIcons() {
        const light = this.isLight();
        if (this.hasDarkTarget) this.darkTarget.classList.toggle("hidden", !light);
        if (this.hasLightTarget) this.lightTarget.classList.toggle("hidden", light);
    }
}


// controllers/toast_controller.js

class $19f69a9debbb50a9$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        timeout: {
            type: Number,
            default: 5000
        },
        redirectUrl: String,
        redirectDelay: {
            type: Number,
            default: 1200
        },
        redirectAction: {
            type: String,
            default: "replace"
        } // Turbo action: "advance" | "replace"
    };
    connect() {
        // Auto-dismiss timer
        if (this.timeoutValue > 0) this.hideTimer = setTimeout(()=>this.close(), this.timeoutValue);
        // Optional redirect timer
        if (this.hasRedirectUrlValue) this.redirectTimer = setTimeout(()=>this.performRedirect(), this.redirectDelayValue);
    }
    disconnect() {
        clearTimeout(this.hideTimer);
        clearTimeout(this.redirectTimer);
    }
    close() {
        this.element.remove();
    }
    performRedirect() {
        // Hide immediately for a snappier feel
        this.close();
        const url = this.redirectUrlValue;
        if (!url) return;
        if (window.Turbo?.visit) Turbo.visit(url, {
            action: this.redirectActionValue
        });
        else if (this.redirectActionValue === "replace") window.location.replace(url);
        else window.location.assign(url);
    }
}




class $02dff06d0b373d99$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "content"
    ];
    toggle() {
        (0, $c0e0e410f6c5ef5d$export$140d7860bc6d1e6e)("UnhideController: toggle");
        this.contentTarget.classList.toggle("hidden");
    }
}



// Gap between the trigger and the bubble, and the height of the arrow that sits in it.
const $4cdae2730ff5bd03$var$ARROW_HEIGHT = 6;
const $4cdae2730ff5bd03$var$GAP = 6;
// Keep the bubble this far from the screen edge before shifting it back in.
const $4cdae2730ff5bd03$var$VIEWPORT_MARGIN = 8;
// A [data-tooltip-boundary] ancestor, when present, is the box the bubble may not leave.
const $4cdae2730ff5bd03$var$BOUNDARY_SELECTOR = "[data-tooltip-boundary]";
// Keep the arrow this far from the bubble's rounded corners.
const $4cdae2730ff5bd03$var$ARROW_INSET = 10;
// Only one tooltip is open at a time; opening one broadcasts this so the rest close.
const $4cdae2730ff5bd03$var$OPEN_EVENT = "cs-tooltip:open";
let $4cdae2730ff5bd03$var$idCounter = 0;
class $4cdae2730ff5bd03$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "trigger",
        "bubble",
        "arrow"
    ];
    static values = {
        position: {
            type: String,
            default: "top"
        }
    };
    connect() {
        this.isOpen = false;
        // role="tooltip" only helps if the trigger points at it.
        if (!this.bubbleTarget.id) this.bubbleTarget.id = `cs-tooltip-${++$4cdae2730ff5bd03$var$idCounter}`;
        this.triggerTarget.setAttribute("aria-describedby", this.bubbleTarget.id);
        this._onOutsidePointer = (event)=>{
            if (!this.element.contains(event.target)) this.hide();
        };
        this._onKeydown = (event)=>{
            if (event.key === "Escape") this.hide();
        };
        this._onOtherOpened = (event)=>{
            if (event.detail?.source !== this.element) this.hide();
        };
        this._onReflow = ()=>{
            if (!this.isOpen) return;
            // The bubble is anchored to the trigger, so it travels with it — only the
            // flip and the horizontal clamp need recomputing.
            if (this._reflowFrame) return;
            this._reflowFrame = requestAnimationFrame(()=>{
                this._reflowFrame = null;
                if (this.isOpen) this._place();
            });
        };
        document.addEventListener($4cdae2730ff5bd03$var$OPEN_EVENT, this._onOtherOpened);
    }
    disconnect() {
        this._teardownDismissListeners();
        document.removeEventListener($4cdae2730ff5bd03$var$OPEN_EVENT, this._onOtherOpened);
        if (this._reflowFrame) {
            cancelAnimationFrame(this._reflowFrame);
            this._reflowFrame = null;
        }
    }
    toggle(event) {
        event.preventDefault();
        event.stopPropagation();
        this.isOpen ? this.hide() : this.show();
    }
    // Touch browsers synthesise mouseenter on tap, which would open the bubble a
    // beat before the click closes it again. Hover is for real pointers only.
    showOnHover() {
        if (window.matchMedia("(hover: hover)").matches) this.show();
    }
    hideOnHover() {
        if (window.matchMedia("(hover: hover)").matches) this.hide();
    }
    // A mouse click focuses the trigger too, so react to keyboard focus only —
    // otherwise focus opens the bubble and the click that caused it closes it.
    showOnFocus() {
        if (this.triggerTarget.matches(":focus-visible")) this.show();
    }
    hideOnFocus() {
        if (!this.triggerTarget.matches(":hover")) this.hide();
    }
    show() {
        if (this.isOpen) return;
        this.isOpen = true;
        document.dispatchEvent(new CustomEvent($4cdae2730ff5bd03$var$OPEN_EVENT, {
            detail: {
                source: this.element
            }
        }));
        this.bubbleTarget.dataset.open = "true";
        this.triggerTarget.setAttribute("aria-expanded", "true");
        this._place();
        document.addEventListener("pointerdown", this._onOutsidePointer, true);
        document.addEventListener("keydown", this._onKeydown);
        window.addEventListener("resize", this._onReflow);
        window.addEventListener("scroll", this._onReflow, true);
    }
    hide() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.bubbleTarget.dataset.open = "false";
        this.triggerTarget.setAttribute("aria-expanded", "false");
        this._teardownDismissListeners();
    }
    _teardownDismissListeners() {
        document.removeEventListener("pointerdown", this._onOutsidePointer, true);
        document.removeEventListener("keydown", this._onKeydown);
        window.removeEventListener("resize", this._onReflow);
        window.removeEventListener("scroll", this._onReflow, true);
    }
    // Picks the side that actually fits, then slides the bubble back on screen and
    // walks the arrow the other way so it stays over the trigger.
    _place() {
        const bubble = this.bubbleTarget;
        bubble.style.setProperty("--cs-tooltip-shift", "0px");
        bubble.dataset.side = this._fittingSide();
        const rect = bubble.getBoundingClientRect();
        const bounds = this._bounds();
        let shift = 0;
        if (rect.width >= bounds.right - bounds.left || rect.left < bounds.left) // Too wide to fit, or hanging off the left: pin the left edge. The left is the side
        // that must never be clipped, so it wins when both edges can't be satisfied.
        shift = bounds.left - rect.left;
        else if (rect.right > bounds.right) shift = bounds.right - rect.right;
        // The arrow can only travel as far as the bubble's straight edge allows.
        const arrowLimit = Math.max(0, rect.width / 2 - $4cdae2730ff5bd03$var$ARROW_INSET);
        const arrowShift = Math.max(-arrowLimit, Math.min(arrowLimit, -shift));
        bubble.style.setProperty("--cs-tooltip-shift", `${shift}px`);
        this.arrowTarget.style.setProperty("--cs-tooltip-arrow-shift", `${arrowShift}px`);
    }
    // The horizontal box the bubble has to stay inside. Defaults to the viewport; a
    // [data-tooltip-boundary] ancestor narrows it to that element — the fee card, say, so the
    // bubble never hangs past the card's edge. The viewport still caps it either way.
    _bounds() {
        const viewportLeft = $4cdae2730ff5bd03$var$VIEWPORT_MARGIN;
        const viewportRight = window.innerWidth - $4cdae2730ff5bd03$var$VIEWPORT_MARGIN;
        const boundary = this.element.closest($4cdae2730ff5bd03$var$BOUNDARY_SELECTOR);
        if (!boundary) return {
            left: viewportLeft,
            right: viewportRight
        };
        const box = boundary.getBoundingClientRect();
        return {
            left: Math.max(box.left, viewportLeft),
            right: Math.min(box.right, viewportRight)
        };
    }
    _fittingSide() {
        const preferred = this.positionValue === "bottom" ? "bottom" : "top";
        const trigger = this.triggerTarget.getBoundingClientRect();
        const needed = this.bubbleTarget.getBoundingClientRect().height + $4cdae2730ff5bd03$var$ARROW_HEIGHT + $4cdae2730ff5bd03$var$GAP;
        const roomAbove = trigger.top;
        const roomBelow = window.innerHeight - trigger.bottom;
        if (preferred === "top" && roomAbove < needed && roomBelow >= needed) return "bottom";
        if (preferred === "bottom" && roomBelow < needed && roomAbove >= needed) return "top";
        return preferred;
    }
}



class $926ec5fd96f10e22$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "form",
        "loadingSpinner",
        "confirmButton",
        "buttonText"
    ];
    handleConfirmClick(event) {
        event.preventDefault();
        if (this.isLoading) return false;
        if (this.hasFormTarget && !this.formTarget.checkValidity()) {
            this.formTarget.reportValidity();
            return false;
        }
        this.showLoading();
        if (this.hasFormTarget) this.formTarget.requestSubmit();
    }
    showLoading() {
        this.isLoading = true;
        if (this.hasConfirmButtonTarget) {
            this.confirmButtonTarget.disabled = true;
            this.confirmButtonTarget.classList.add("pointer-events-none", "opacity-50");
        }
        if (this.hasLoadingSpinnerTarget) this.loadingSpinnerTarget.classList.remove("hidden");
        if (this.hasButtonTextTarget) this.buttonTextTarget.textContent = "Processing...";
    }
    hideLoading() {
        this.isLoading = false;
        // Enable button
        if (this.hasConfirmButtonTarget) {
            this.confirmButtonTarget.disabled = false;
            this.confirmButtonTarget.classList.remove("pointer-events-none", "opacity-50");
        }
        // Hide spinner
        if (this.hasLoadingSpinnerTarget) this.loadingSpinnerTarget.classList.add("hidden");
        // Reset button text
        if (this.hasButtonTextTarget) this.buttonTextTarget.textContent = "Confirm";
    }
    onSubmitStart(event) {
        if (!this.isLoading) this.showLoading();
    }
    onSubmitEnd(event) {
        if (event.detail && event.detail.success === false) this.hideLoading();
    }
}



class $3ba8da1c856eaebf$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "toggle",
        "walletNameInput",
        "form",
        "shouldSaveInput",
        "walletNameHiddenInput",
        "doneButton",
        "loadingSpinner",
        "buttonText",
        "charCount",
        "currentCount"
    ];
    static values = {
        maxLength: {
            type: Number,
            default: 50
        },
        shouldSave: {
            type: Boolean,
            default: false
        }
    };
    connect() {
        if (this.hasToggleTarget) {
            this.toggleTarget.checked = false;
            this.toggleTarget.addEventListener("change", this.validateForm.bind(this));
        }
        if (this.hasFormTarget) this.formTarget.addEventListener("submit", this.showLoading.bind(this));
        this.updateCharCount();
        this.validateForm();
    }
    handleInputChange() {
        this.limitInputLength();
        this.updateCharCount();
        this.syncToggle();
        this.validateForm();
    }
    limitInputLength() {
        if (!this.hasWalletNameInputTarget) return;
        const value = this.walletNameInputTarget.value;
        const maxLength = this.maxLengthValue;
        if (value.length > maxLength) this.walletNameInputTarget.value = value.substring(0, maxLength);
    }
    updateCharCount() {
        if (this.hasWalletNameInputTarget && this.hasCurrentCountTarget) this.currentCountTarget.textContent = this.walletNameInputTarget.value.length;
    }
    syncToggle() {
        if (this.hasToggleTarget && this.hasWalletNameInputTarget) this.toggleTarget.checked = this.walletNameInputTarget.value.trim().length > 0;
    }
    validateForm() {
        if (!this.hasDoneButtonTarget) return;
        // Button is always enabled if wallet is already saved or no toggle exists
        const alwaysEnabled = this.shouldSaveValue || !this.hasToggleTarget;
        let isValid = alwaysEnabled;
        if (!alwaysEnabled && this.hasToggleTarget) {
            const isToggleChecked = this.toggleTarget.checked;
            const hasInputValue = this.hasWalletNameInputTarget && this.walletNameInputTarget.value.trim().length > 0;
            // Valid if toggle is off OR (toggle is on AND input has value)
            isValid = !isToggleChecked || hasInputValue;
            // Show/hide input based on toggle
            if (this.hasWalletNameInputTarget) {
                const shouldShow = isToggleChecked;
                this.walletNameInputTarget.classList.toggle("hidden", !shouldShow);
                if (this.hasCharCountTarget) this.charCountTarget.classList.toggle("hidden", !shouldShow);
            }
        }
        this.doneButtonTarget.disabled = !isValid;
        this.doneButtonTarget.classList.toggle("opacity-50", !isValid);
        this.doneButtonTarget.classList.toggle("cursor-not-allowed", !isValid);
        this.doneButtonTarget.classList.toggle("pointer-events-none", !isValid);
        this.doneButtonTarget.classList.toggle("hover:bg-gray-900", isValid);
    }
    handleDoneClick(event) {
        const wantsToSave = this.hasToggleTarget && this.toggleTarget.checked;
        if (!wantsToSave) {
            event.preventDefault();
            window.location.href = "/home";
            return;
        }
        // Saving - validate and set wallet name
        const walletName = this.hasWalletNameInputTarget ? this.walletNameInputTarget.value.trim() : "";
        if (!walletName || walletName.length > this.maxLengthValue) {
            event.preventDefault();
            return;
        }
        if (this.hasShouldSaveInputTarget) this.shouldSaveInputTarget.value = "true";
        if (this.hasWalletNameHiddenInputTarget) this.walletNameHiddenInputTarget.value = walletName;
    }
    showLoading() {
        const isSaving = this.hasToggleTarget && this.toggleTarget.checked;
        if (this.hasDoneButtonTarget) {
            this.doneButtonTarget.disabled = true;
            this.doneButtonTarget.classList.add("opacity-50", "cursor-not-allowed", "pointer-events-none");
            this.doneButtonTarget.classList.remove("hover:bg-gray-900");
        }
        if (this.hasLoadingSpinnerTarget) this.loadingSpinnerTarget.classList.remove("hidden");
        if (this.hasButtonTextTarget) this.buttonTextTarget.textContent = isSaving ? "Saving..." : "Processing...";
        if (this.hasToggleTarget) this.toggleTarget.disabled = true;
        if (this.hasWalletNameInputTarget) this.walletNameInputTarget.disabled = true;
    }
    showCharCount() {
        if (this.hasCharCountTarget) this.charCountTarget.classList.remove("hidden");
        this.updateCharCount();
    }
    hideCharCount() {
        if (this.hasCharCountTarget && this.hasWalletNameInputTarget) {
            if (this.walletNameInputTarget.value.trim().length === 0) this.charCountTarget.classList.add("hidden");
        }
    }
}



class $890c481d0dd5b4c3$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "link"
    ];
    connect() {
        this.update();
        document.addEventListener("turbo:load", this.update);
        document.addEventListener("turbo:frame-load", this.update);
    }
    disconnect() {
        document.removeEventListener("turbo:load", this.update);
        document.removeEventListener("turbo:frame-load", this.update);
    }
    update = ()=>{
        const current = window.location.pathname;
        // WALLETTODO: check if this is good solution for active link detection
        this.linkTargets.forEach((link)=>{
            const href = link.getAttribute("href");
            // Parse href to get only the pathname (remove query string and hash)
            const hrefPath = href ? href.split('?')[0].split('#')[0] : '';
            if (current === hrefPath || current.startsWith(hrefPath + "/")) link.setAttribute("aria-current", "page");
            else link.removeAttribute("aria-current");
        });
    };
}





class $bec33484964d7d36$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "input",
        "button"
    ];
    static values = {
        attemptId: String,
        csrfToken: String
    };
    endpoint = "/analytics/event";
    connect() {
        this.viewport = (0, $6adb56df0e842c64$export$f1768d02d4612c4)();
    }
    handleEvent(e) {
        const el = e.currentTarget;
        const events = this.extractEvents(el) // [{ idx:1, name:"..." }, { idx:2, name:"..." }, ...]
        ;
        if (events.length === 0) return;
        if (el.dataset.sent === "1") return;
        el.dataset.sent = "1";
        const base = {
            page: window.location.pathname,
            ts: Date.now()
        };
        for(let i = 0; i < events.length; i++){
            const { idx: idx, name: name } = events[i];
            this.send({
                event: name,
                page: base.page,
                ts: base.ts + i
            }, el, idx);
        }
    }
    // Finds: data-event, data-event2, data-event3, ...
    extractEvents(el) {
        const out = [];
        if (!el?.attributes) return out;
        for (const attr of el.attributes){
            const name = attr.name // "data-event", "data-event-2"
            ;
            if (!name.startsWith("data-event")) continue;
            // match: data-event OR data-event-<n>
            const m = name.match(/^data-event(?:-(\d+))?$/);
            if (!m) continue;
            const idx = m[1] ? parseInt(m[1], 10) : 1;
            if (!Number.isFinite(idx) || idx < 1) continue;
            const val = (attr.value || "").trim();
            if (!val) continue;
            out.push({
                idx: idx,
                name: val
            });
        }
        out.sort((a, b)=>a.idx - b.idx);
        return out;
    }
    send(payload, el, idx = 1) {
        try {
            const formData = new FormData();
            formData.append("csrf_token", this.csrfTokenValue || "");
            formData.append("event", payload.event);
            formData.append("viewport", this.viewport);
            formData.append("page", payload.page);
            formData.append("ts", String(payload.ts));
            // meta for this specific event index:
            // data-analytics-1-meta-*, data-analytics-2-meta-*, ...
            this.appendIndexedMeta(formData, el, idx);
            // customIDs for this specific event index:
            this.appendCustomIDs(formData, idx);
            if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement) {
                const raw = (el.value ?? "").toString().trim();
                if (raw) formData.append("meta.input_value", raw);
            }
            if (navigator.sendBeacon) {
                const ok = navigator.sendBeacon(this.endpoint, formData);
                if (ok) return;
            }
            (0, $7698590c42a3bf25$export$18b31d9eba2a1098)(this.endpoint, {
                method: "POST",
                body: formData,
                keepalive: true
            }).catch(()=>{});
        } catch (_) {
        // ignore
        }
    }
    appendIndexedMeta(formData, el, idx) {
        if (!el?.attributes) return;
        const prefix = idx === 1 ? "data-analytics-meta-" : `data-analytics-${idx}-meta-`;
        for (const attr of el.attributes){
            const name = attr.name;
            if (!name.startsWith(prefix)) continue;
            const key = name.slice(prefix.length);
            const val = attr.value;
            if (!key || val == null || val === "") continue;
            formData.append(`meta.${key}`, String(val));
        }
    }
    appendCustomIDs(formData, idx = 1) {
        const wrapper = this.element;
        if (!wrapper?.attributes) return;
        const prefix = idx === 1 ? "data-analytics-customid-" : `data-analytics-${idx}-customid-`;
        for (const attr of wrapper.attributes){
            const name = attr.name;
            if (!name.startsWith(prefix)) continue;
            const key = name.slice(prefix.length);
            const val = attr.value;
            if (!key || val == null || val === "") continue;
            formData.append(`cid.${key}`, String(val));
        }
    }
}



class $d24155e38ad10359$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static HIDDEN_PATHS = [
        "/",
        "/home",
        "/otp"
    ];
    connect() {
        this.applyThemeSource();
        this.update();
        document.addEventListener("turbo:load", this.update);
        document.addEventListener("turbo:frame-load", this.update);
        document.addEventListener("theme:changed", this.applyThemeSource);
    }
    disconnect() {
        document.removeEventListener("turbo:load", this.update);
        document.removeEventListener("turbo:frame-load", this.update);
        document.removeEventListener("theme:changed", this.applyThemeSource);
        document.documentElement.classList.remove("tn-bg-active");
    }
    // Swap the image between the dark/light theme assets. Falls back to the dark
    // image when the active theme has no dedicated asset.
    applyThemeSource = ()=>{
        const dark = this.element.dataset.imageDark || "";
        const light = this.element.dataset.imageLight || "";
        const isLight = document.documentElement.classList.contains("wlight");
        const url = (isLight ? light : dark) || dark;
        if (url && this.element.getAttribute("src") !== url) this.element.setAttribute("src", url);
    };
    update = ()=>{
        const path = window.location.pathname;
        const videoSkipped = document.documentElement.classList.contains("tn-video-skipped");
        const hidden = !videoSkipped && this.constructor.HIDDEN_PATHS.some((p)=>path === p || p !== "/" && path.startsWith(p + "/"));
        // Hide/show the image itself and flag the root so the app content surface
        // becomes transparent (CSS in base.html) to let the image show through.
        this.element.classList.toggle("hidden", hidden);
        document.documentElement.classList.toggle("tn-bg-active", !hidden);
    };
}



class $ba126a5df74935f5$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static allowedRoutes = [
        "/",
        "/home",
        "/otp"
    ];
    connect() {
        const reason = this.reasonToSkip();
        if (reason) {
            this.skipVideo(reason);
            return;
        }
        this.evaluateRoute();
        this.applyPosterTheme();
        document.addEventListener("turbo:load", this.evaluateRoute);
        document.addEventListener("turbo:frame-load", this.evaluateRoute);
        document.addEventListener("theme:changed", this.evaluateRoute);
        // Chrome pauses & discards the decoded frame of a backgrounded <video>, so
        // it comes back black. While the tab is hidden we drop the video's opacity
        // to reveal the poster image behind it, then fade the video back in once it
        // is actually playing again — so the user never sees a black flash.
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        window.addEventListener("pageshow", this.onVisibilityChange);
    }
    disconnect() {
        document.removeEventListener("turbo:load", this.evaluateRoute);
        document.removeEventListener("turbo:frame-load", this.evaluateRoute);
        document.removeEventListener("theme:changed", this.evaluateRoute);
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
        window.removeEventListener("pageshow", this.onVisibilityChange);
    }
    // Keep the poster image (shown during the resume gap) matched to the theme.
    applyPosterTheme() {
        const poster = document.getElementById("app-bg-video-poster");
        if (!poster) return;
        const isLight = document.documentElement.classList.contains("wlight");
        const url = (isLight ? poster.dataset.imageLight : poster.dataset.imageDark) || poster.dataset.imageDark || "";
        if (url && poster.getAttribute("src") !== url) poster.setAttribute("src", url);
    }
    onVisibilityChange = ()=>{
        const v = this.element;
        if (v.style.display === "none") return; // video not in use on this route/theme
        if (document.visibilityState === "hidden") {
            // Reveal the poster and remember we were backgrounded, so on return we
            // do a clean reset instead of showing Chrome's half-decoded (black) frame.
            this.wasHidden = true;
            v.style.opacity = "0";
            return;
        }
        if (!this.wasHidden) return; // e.g. initial pageshow — nothing to recover
        this.wasHidden = false;
        if (!this.constructor.allowedRoutes.includes(window.location.pathname)) return;
        if (!this.themeUrl()) return;
        // Keep the video hidden (poster showing) and fully reload it so the stale,
        // partially-black surface is discarded. Only fade the video back in once it
        // is genuinely playing fresh frames — never on a blind timer.
        this.applyPosterTheme();
        v.style.opacity = "0";
        try {
            v.load();
        } catch (e) {}
        const p = v.play?.();
        if (p && typeof p.catch === "function") p.catch(()=>{});
        v.addEventListener("playing", ()=>{
            v.style.opacity = "1";
        }, {
            once: true
        });
    };
    evaluateRoute = ()=>{
        if (this.constructor.allowedRoutes.includes(window.location.pathname)) this.showVideo();
        else this.hideVideo();
    };
    // URL for the currently active theme. Falls back to the dark video for any
    // dark theme; returns "" when the active theme has no video (→ stays hidden).
    themeUrl() {
        const isLight = document.documentElement.classList.contains("wlight");
        return (isLight ? this.element.dataset.videoLight : this.element.dataset.videoDark) || "";
    }
    showVideo() {
        const url = this.themeUrl();
        if (!url) {
            // No video for this theme (e.g. light theme without a light video) — keep
            // the background transparent so the black base shows through.
            this.hideVideo();
            return;
        }
        this.applyPosterTheme();
        const source = this.element.querySelector("source");
        if (source && source.getAttribute("src") !== url) {
            source.setAttribute("src", url);
            this.element.load();
        }
        this.element.style.display = "";
        this.element.style.opacity = "1";
        const p = this.element.play?.();
        if (p && typeof p.catch === "function") p.catch(()=>{});
    }
    hideVideo() {
        this.element.pause?.();
        this.element.style.display = "none";
    }
    reasonToSkip() {
        const c = navigator.connection;
        const params = new URLSearchParams(window.location.search);
        if (params.has("nobgvideo")) return "url-param";
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return "reduced-motion";
        if (c?.saveData) return "save-data";
        if (c && [
            "slow-2g",
            "2g"
        ].includes(c.effectiveType)) return "slow-network";
        // deviceMemory is a floating-point GB estimate capped at 8 by the browser;
        // undefined on iOS Safari / Firefox. Treat undefined as "not low".
        if (typeof navigator.deviceMemory === "number" && navigator.deviceMemory < 2) return "low-memory";
        // hardwareConcurrency is logical CPU count, undefined on some browsers.
        if (typeof navigator.hardwareConcurrency === "number" && navigator.hardwareConcurrency < 4) return "low-cpu";
        return null;
    }
    skipVideo(reason) {
        if (window.console?.info) console.info(`[bg-video] skipped: ${reason}`);
        // Prefer the static background image as the fallback
        const img = document.getElementById("app-bg-image");
        if (img) {
            document.documentElement.classList.add("tn-video-skipped");
            img.classList.remove("hidden");
            document.documentElement.classList.add("tn-bg-active");
        } else {
            // No static image available — restore a solid background on the wrapper.
            const wrapper = this.element.parentElement;
            if (wrapper) wrapper.classList.add("dark:bg-dark-app-bg", "wdark:bg-wdark-app-bg");
        }
        this.element.pause?.();
        this.element.removeAttribute("autoplay");
        this.element.remove();
    }
}


// controllers/expiration_controller.js

class $bd9cad85a6ad6d01$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "counter",
        "label"
    ];
    static values = {
        expiresAt: Number,
        warnSeconds: {
            type: Number,
            default: 300
        }
    };
    connect() {
        this.update = this.update.bind(this);
        this.warned = false;
        this.update();
        this.timer = setInterval(this.update, 1000);
    }
    disconnect() {
        if (this.timer) clearInterval(this.timer);
    }
    update() {
        const endMs = this.expiresAtValue;
        if (!endMs) {
            this.counterTarget.textContent = "--:--";
            return;
        }
        const diffMs = endMs - Date.now();
        if (diffMs <= 0) {
            this.counterTarget.textContent = "00:00";
            this.dispatch("expired");
            clearInterval(this.timer);
            this.timer = null;
            return;
        }
        const totalSeconds = Math.floor(diffMs / 1000);
        if (totalSeconds < this.warnSecondsValue && !this.warned) {
            this.warned = true;
            this.counterTarget.classList.add("text-amber-400");
            // optional label swap
            if (this.hasLabelTarget) this.labelTarget.textContent = "Rate expires soon";
            this.dispatch("warning");
        }
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        this.counterTarget.textContent = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
    handleExpired() {
        if (document.querySelector('[data-controller~="deposit-success"]')) return;
        // Redirect to expired page when countdown reaches 00:00
        Turbo.visit("/deposit/crypto/expired", {
            action: "replace"
        });
    }
}



class $0ceb68875daaca9b$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    connect() {
        requestAnimationFrame(()=>{
            this.element.classList.remove("opacity-0", "translate-y-1");
        });
    }
}



class $88ff8688ffe8c653$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        param: {
            type: String,
            default: "platform"
        }
    };
    static targets = [
        "link"
    ];
    connect() {
        const platform = this.detectPlatform();
        const href = this.hasLinkTarget ? this.linkTarget.getAttribute("href") : "(no link target)";
        const u = new URL(href, window.location.origin);
        u.searchParams.set(this.paramValue, platform);
        this.linkTarget.setAttribute("href", u.pathname + u.search + u.hash);
    }
    detectPlatform() {
        const ua = navigator.userAgent.toLowerCase();
        if (/android/.test(ua)) return "android";
        if (/iphone|ipad|ipod/.test(ua)) return "ios";
        return "web";
    }
}



class $5169b9f8bbbce1c9$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "input"
    ];
    connect() {
        try {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.inputTarget.value = tz;
        } catch (e) {
            console.error("Failed to detect timezone:", e);
            this.inputTarget.value = "UTC";
        }
    }
}



/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ function $f90d128762560541$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $f90d128762560541$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $f90d128762560541$export$bcc6e673dfa14d36(v) {
    return $f90d128762560541$export$837ba5c449269406($f90d128762560541$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $f90d128762560541$export$869b26d4e1bbdb63(v) {
    return $f90d128762560541$export$837ba5c449269406($f90d128762560541$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $f90d128762560541$export$ed9bd8dcaeba14f6(v) {
    return $f90d128762560541$export$837ba5c449269406($f90d128762560541$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $f90d128762560541$export$dbf961a8d278dbef(v) {
    return $f90d128762560541$export$837ba5c449269406($f90d128762560541$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $f90d128762560541$export$aa35ef1f24408ab9(v) {
    return $f90d128762560541$export$837ba5c449269406($f90d128762560541$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $f90d128762560541$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $f90d128762560541$var$hex = [
    ...'0123456789ABCDEF'
];
const $f90d128762560541$var$h1 = (b)=>$f90d128762560541$var$hex[b & 0xF];
const $f90d128762560541$var$h2 = (b)=>$f90d128762560541$var$hex[(b & 0xF0) >> 4] + $f90d128762560541$var$hex[b & 0xF];
const $f90d128762560541$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $f90d128762560541$var$isShort = (v)=>$f90d128762560541$var$eq(v.r) && $f90d128762560541$var$eq(v.g) && $f90d128762560541$var$eq(v.b) && $f90d128762560541$var$eq(v.a);
function $f90d128762560541$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $f90d128762560541$var$map$1[str[1]] * 17,
            g: 255 & $f90d128762560541$var$map$1[str[2]] * 17,
            b: 255 & $f90d128762560541$var$map$1[str[3]] * 17,
            a: len === 5 ? $f90d128762560541$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $f90d128762560541$var$map$1[str[1]] << 4 | $f90d128762560541$var$map$1[str[2]],
            g: $f90d128762560541$var$map$1[str[3]] << 4 | $f90d128762560541$var$map$1[str[4]],
            b: $f90d128762560541$var$map$1[str[5]] << 4 | $f90d128762560541$var$map$1[str[6]],
            a: len === 9 ? $f90d128762560541$var$map$1[str[7]] << 4 | $f90d128762560541$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $f90d128762560541$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $f90d128762560541$export$1b06654353ef9f67(v) {
    var f = $f90d128762560541$var$isShort(v) ? $f90d128762560541$var$h1 : $f90d128762560541$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $f90d128762560541$var$alpha(v.a, f) : undefined;
}
const $f90d128762560541$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $f90d128762560541$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $f90d128762560541$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $f90d128762560541$var$hwb2rgbn(h, w, b) {
    const rgb = $f90d128762560541$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $f90d128762560541$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $f90d128762560541$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $f90d128762560541$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $f90d128762560541$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($f90d128762560541$export$ed9bd8dcaeba14f6);
}
function $f90d128762560541$export$4c15bd42559b811d(h, s, l) {
    return $f90d128762560541$var$calln($f90d128762560541$var$hsl2rgbn, h, s, l);
}
function $f90d128762560541$export$e2710022c70fc9ee(h, w, b) {
    return $f90d128762560541$var$calln($f90d128762560541$var$hwb2rgbn, h, w, b);
}
function $f90d128762560541$export$b785a357c84e4a04(h, s, v) {
    return $f90d128762560541$var$calln($f90d128762560541$var$hsv2rgbn, h, s, v);
}
function $f90d128762560541$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $f90d128762560541$export$5e91288c399be4f9(str) {
    const m = $f90d128762560541$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $f90d128762560541$export$bcc6e673dfa14d36(+m[5]) : $f90d128762560541$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $f90d128762560541$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $f90d128762560541$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $f90d128762560541$export$b785a357c84e4a04(h, p1, p2);
    else v = $f90d128762560541$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $f90d128762560541$export$bb628a54ab399bc9(v, deg) {
    var h = $f90d128762560541$export$b5ba70b240f8f7f(v);
    h[0] = $f90d128762560541$var$hue(h[0] + deg);
    h = $f90d128762560541$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $f90d128762560541$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $f90d128762560541$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $f90d128762560541$export$aa35ef1f24408ab9(a[1]);
    const l = $f90d128762560541$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$f90d128762560541$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $f90d128762560541$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $f90d128762560541$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $f90d128762560541$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($f90d128762560541$var$names$1);
    const tkeys = Object.keys($f90d128762560541$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $f90d128762560541$var$map[k]);
        }
        k = parseInt($f90d128762560541$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $f90d128762560541$var$names;
function $f90d128762560541$export$b2f06b640faad956(str) {
    if (!$f90d128762560541$var$names) {
        $f90d128762560541$var$names = $f90d128762560541$var$unpack();
        $f90d128762560541$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $f90d128762560541$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $f90d128762560541$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $f90d128762560541$export$91aedb20f296e541(str) {
    const m = $f90d128762560541$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $f90d128762560541$export$bcc6e673dfa14d36(v) : $f90d128762560541$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $f90d128762560541$export$bcc6e673dfa14d36(r) : $f90d128762560541$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $f90d128762560541$export$bcc6e673dfa14d36(g) : $f90d128762560541$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $f90d128762560541$export$bcc6e673dfa14d36(b) : $f90d128762560541$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $f90d128762560541$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$f90d128762560541$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $f90d128762560541$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $f90d128762560541$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $f90d128762560541$var$interpolate(rgb1, rgb2, t) {
    const r = $f90d128762560541$var$from($f90d128762560541$export$dbf961a8d278dbef(rgb1.r));
    const g = $f90d128762560541$var$from($f90d128762560541$export$dbf961a8d278dbef(rgb1.g));
    const b = $f90d128762560541$var$from($f90d128762560541$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $f90d128762560541$export$ed9bd8dcaeba14f6($f90d128762560541$var$to(r + t * ($f90d128762560541$var$from($f90d128762560541$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $f90d128762560541$export$ed9bd8dcaeba14f6($f90d128762560541$var$to(g + t * ($f90d128762560541$var$from($f90d128762560541$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $f90d128762560541$export$ed9bd8dcaeba14f6($f90d128762560541$var$to(b + t * ($f90d128762560541$var$from($f90d128762560541$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $f90d128762560541$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $f90d128762560541$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $f90d128762560541$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $f90d128762560541$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $f90d128762560541$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $f90d128762560541$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $f90d128762560541$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $f90d128762560541$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $f90d128762560541$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $f90d128762560541$export$91aedb20f296e541(str);
    return $f90d128762560541$export$5e91288c399be4f9(str);
}
class $f90d128762560541$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $f90d128762560541$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $f90d128762560541$var$fromObject(input);
        else if (type === 'string') v = $f90d128762560541$export$625a38b961e8b5e9(input) || $f90d128762560541$export$b2f06b640faad956(input) || $f90d128762560541$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $f90d128762560541$var$clone(this._rgb);
        if (v) v.a = $f90d128762560541$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $f90d128762560541$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $f90d128762560541$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $f90d128762560541$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $f90d128762560541$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $f90d128762560541$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $f90d128762560541$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $f90d128762560541$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $f90d128762560541$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $f90d128762560541$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $f90d128762560541$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $f90d128762560541$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $f90d128762560541$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $f90d128762560541$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $f90d128762560541$export$2e2bcd8739ae039(input) {
    return new $f90d128762560541$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $db48ff1d57c620ad$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $db48ff1d57c620ad$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $db48ff1d57c620ad$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $db48ff1d57c620ad$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $db48ff1d57c620ad$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $db48ff1d57c620ad$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $db48ff1d57c620ad$export$c4ce752e73470fba(value, defaultValue) {
    return $db48ff1d57c620ad$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $db48ff1d57c620ad$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $db48ff1d57c620ad$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $db48ff1d57c620ad$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $db48ff1d57c620ad$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $db48ff1d57c620ad$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($db48ff1d57c620ad$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($db48ff1d57c620ad$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $db48ff1d57c620ad$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $db48ff1d57c620ad$export$667d3bf0c5f83305(source) {
    if ($db48ff1d57c620ad$export$8b22cf2602fb60ce(source)) return source.map($db48ff1d57c620ad$export$667d3bf0c5f83305);
    if ($db48ff1d57c620ad$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $db48ff1d57c620ad$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $db48ff1d57c620ad$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $db48ff1d57c620ad$export$317a3d46287192d8(key, target, source, options) {
    if (!$db48ff1d57c620ad$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($db48ff1d57c620ad$export$23f2a1d2818174ef(tval) && $db48ff1d57c620ad$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $db48ff1d57c620ad$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $db48ff1d57c620ad$export$667d3bf0c5f83305(sval);
}
function $db48ff1d57c620ad$export$efca4cbe5dd06740(target, source, options) {
    const sources = $db48ff1d57c620ad$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$db48ff1d57c620ad$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $db48ff1d57c620ad$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$db48ff1d57c620ad$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $db48ff1d57c620ad$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $db48ff1d57c620ad$export$efca4cbe5dd06740(target, source, {
        merger: $db48ff1d57c620ad$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $db48ff1d57c620ad$export$1ee57be6f6687d2c(key, target, source) {
    if (!$db48ff1d57c620ad$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($db48ff1d57c620ad$export$23f2a1d2818174ef(tval) && $db48ff1d57c620ad$export$23f2a1d2818174ef(sval)) $db48ff1d57c620ad$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $db48ff1d57c620ad$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $db48ff1d57c620ad$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $db48ff1d57c620ad$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $db48ff1d57c620ad$var$_getKeyResolver(key) {
    const keys = $db48ff1d57c620ad$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $db48ff1d57c620ad$export$2d1720544b23b823(obj, key) {
    const resolver = $db48ff1d57c620ad$var$keyResolvers[key] || ($db48ff1d57c620ad$var$keyResolvers[key] = $db48ff1d57c620ad$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $db48ff1d57c620ad$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $db48ff1d57c620ad$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $db48ff1d57c620ad$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $db48ff1d57c620ad$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $db48ff1d57c620ad$export$56c0d5a1e737357d = Math.PI;
const $db48ff1d57c620ad$export$971d5caa766a69d7 = 2 * $db48ff1d57c620ad$export$56c0d5a1e737357d;
const $db48ff1d57c620ad$export$2ec5befb9e6c97d4 = $db48ff1d57c620ad$export$971d5caa766a69d7 + $db48ff1d57c620ad$export$56c0d5a1e737357d;
const $db48ff1d57c620ad$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $db48ff1d57c620ad$export$39c1cc7c062529d4 = $db48ff1d57c620ad$export$56c0d5a1e737357d / 180;
const $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd = $db48ff1d57c620ad$export$56c0d5a1e737357d / 2;
const $db48ff1d57c620ad$export$7a0bdf7d4a91ea88 = $db48ff1d57c620ad$export$56c0d5a1e737357d / 4;
const $db48ff1d57c620ad$export$c18d01048907ea92 = $db48ff1d57c620ad$export$56c0d5a1e737357d * 2 / 3;
const $db48ff1d57c620ad$export$faec65b429be379 = Math.log10;
const $db48ff1d57c620ad$export$2408f22a0fab9ae5 = Math.sign;
function $db48ff1d57c620ad$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $db48ff1d57c620ad$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $db48ff1d57c620ad$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($db48ff1d57c620ad$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $db48ff1d57c620ad$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $db48ff1d57c620ad$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $db48ff1d57c620ad$export$d141bba7fdc215a3(n) {
    return !$db48ff1d57c620ad$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $db48ff1d57c620ad$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $db48ff1d57c620ad$export$625550452a3fa3ec(degrees) {
    return degrees * ($db48ff1d57c620ad$export$56c0d5a1e737357d / 180);
}
function $db48ff1d57c620ad$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $db48ff1d57c620ad$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $db48ff1d57c620ad$export$91477dc880baac21(x) {
    if (!$db48ff1d57c620ad$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $db48ff1d57c620ad$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $db48ff1d57c620ad$export$56c0d5a1e737357d) angle += $db48ff1d57c620ad$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $db48ff1d57c620ad$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $db48ff1d57c620ad$export$f074adc9fbd50943(a, b) {
    return (a - b + $db48ff1d57c620ad$export$2ec5befb9e6c97d4) % $db48ff1d57c620ad$export$971d5caa766a69d7 - $db48ff1d57c620ad$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $db48ff1d57c620ad$export$ab83b03e4111b1d0(a) {
    return (a % $db48ff1d57c620ad$export$971d5caa766a69d7 + $db48ff1d57c620ad$export$971d5caa766a69d7) % $db48ff1d57c620ad$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $db48ff1d57c620ad$export$ab83b03e4111b1d0(angle);
    const s = $db48ff1d57c620ad$export$ab83b03e4111b1d0(start);
    const e = $db48ff1d57c620ad$export$ab83b03e4111b1d0(end);
    const angleToStart = $db48ff1d57c620ad$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $db48ff1d57c620ad$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $db48ff1d57c620ad$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $db48ff1d57c620ad$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $db48ff1d57c620ad$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $db48ff1d57c620ad$export$71cec2538cb2c617(value) {
    return $db48ff1d57c620ad$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $db48ff1d57c620ad$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $db48ff1d57c620ad$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $db48ff1d57c620ad$export$ef35774e6d314e91 = (table, key, value, last)=>$db48ff1d57c620ad$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $db48ff1d57c620ad$export$ebd11618f299a286 = (table, key, value)=>$db48ff1d57c620ad$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $db48ff1d57c620ad$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $db48ff1d57c620ad$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $db48ff1d57c620ad$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $db48ff1d57c620ad$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $db48ff1d57c620ad$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $db48ff1d57c620ad$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $db48ff1d57c620ad$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $db48ff1d57c620ad$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $db48ff1d57c620ad$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $db48ff1d57c620ad$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $db48ff1d57c620ad$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $db48ff1d57c620ad$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $db48ff1d57c620ad$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $db48ff1d57c620ad$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $db48ff1d57c620ad$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $db48ff1d57c620ad$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $db48ff1d57c620ad$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($db48ff1d57c620ad$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $db48ff1d57c620ad$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$db48ff1d57c620ad$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $db48ff1d57c620ad$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($db48ff1d57c620ad$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $db48ff1d57c620ad$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$db48ff1d57c620ad$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $db48ff1d57c620ad$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $db48ff1d57c620ad$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $db48ff1d57c620ad$var$atEdge = (t)=>t === 0 || t === 1;
const $db48ff1d57c620ad$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $db48ff1d57c620ad$export$971d5caa766a69d7 / p));
const $db48ff1d57c620ad$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $db48ff1d57c620ad$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $db48ff1d57c620ad$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($db48ff1d57c620ad$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$db48ff1d57c620ad$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$db48ff1d57c620ad$var$atEdge(t) ? t : $db48ff1d57c620ad$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$db48ff1d57c620ad$var$atEdge(t) ? t : $db48ff1d57c620ad$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $db48ff1d57c620ad$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $db48ff1d57c620ad$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $db48ff1d57c620ad$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $db48ff1d57c620ad$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $db48ff1d57c620ad$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $db48ff1d57c620ad$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $db48ff1d57c620ad$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $db48ff1d57c620ad$export$db3b6bfb95261072(value) {
    return $db48ff1d57c620ad$export$738ab4df8bf92ae9(value) ? value : new (0, $f90d128762560541$export$892596cec99bc70e)(value);
}
function $db48ff1d57c620ad$export$d377dcb2b61d6c4e(value) {
    return $db48ff1d57c620ad$export$738ab4df8bf92ae9(value) ? value : new (0, $f90d128762560541$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $db48ff1d57c620ad$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $db48ff1d57c620ad$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $db48ff1d57c620ad$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $db48ff1d57c620ad$var$colors
        },
        numbers: {
            type: 'number',
            properties: $db48ff1d57c620ad$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $db48ff1d57c620ad$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $db48ff1d57c620ad$var$intlCache = new Map();
function $db48ff1d57c620ad$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $db48ff1d57c620ad$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $db48ff1d57c620ad$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $db48ff1d57c620ad$export$ae1af26003f05816(num, locale, options) {
    return $db48ff1d57c620ad$var$getNumberFormat(locale, options).format(num);
}
const $db48ff1d57c620ad$var$formatters = {
    values (value) {
        return $db48ff1d57c620ad$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $db48ff1d57c620ad$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $db48ff1d57c620ad$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $db48ff1d57c620ad$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($db48ff1d57c620ad$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $db48ff1d57c620ad$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $db48ff1d57c620ad$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $db48ff1d57c620ad$export$9f4f30ee63539e24 = {
    formatters: $db48ff1d57c620ad$var$formatters
};
function $db48ff1d57c620ad$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $db48ff1d57c620ad$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $db48ff1d57c620ad$export$6559d589eb85fbb6 = Object.create(null);
const $db48ff1d57c620ad$export$2e2af4578d910ddf = Object.create(null);
function $db48ff1d57c620ad$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $db48ff1d57c620ad$var$set(root, scope, values) {
    if (typeof scope === 'string') return $db48ff1d57c620ad$export$efca4cbe5dd06740($db48ff1d57c620ad$var$getScope$1(root, scope), values);
    return $db48ff1d57c620ad$export$efca4cbe5dd06740($db48ff1d57c620ad$var$getScope$1(root, ''), scope);
}
class $db48ff1d57c620ad$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$db48ff1d57c620ad$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$db48ff1d57c620ad$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$db48ff1d57c620ad$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $db48ff1d57c620ad$var$set(this, scope, values);
    }
    get(scope) {
        return $db48ff1d57c620ad$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $db48ff1d57c620ad$var$set($db48ff1d57c620ad$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $db48ff1d57c620ad$var$set($db48ff1d57c620ad$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $db48ff1d57c620ad$var$getScope$1(this, scope);
        const targetScopeObject = $db48ff1d57c620ad$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($db48ff1d57c620ad$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $db48ff1d57c620ad$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $db48ff1d57c620ad$export$4368d992c4eafac0 = /* #__PURE__ */ new $db48ff1d57c620ad$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $db48ff1d57c620ad$var$applyAnimationsDefaults,
    $db48ff1d57c620ad$var$applyLayoutsDefaults,
    $db48ff1d57c620ad$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $db48ff1d57c620ad$export$e171bab687b50e0(font) {
    if (!font || $db48ff1d57c620ad$export$342063e11d6c3cad(font.size) || $db48ff1d57c620ad$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $db48ff1d57c620ad$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$db48ff1d57c620ad$export$8b22cf2602fb60ce(thing)) longest = $db48ff1d57c620ad$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($db48ff1d57c620ad$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$db48ff1d57c620ad$export$8b22cf2602fb60ce(nestedThing)) longest = $db48ff1d57c620ad$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $db48ff1d57c620ad$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $db48ff1d57c620ad$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $db48ff1d57c620ad$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $db48ff1d57c620ad$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $db48ff1d57c620ad$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $db48ff1d57c620ad$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $db48ff1d57c620ad$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $db48ff1d57c620ad$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $db48ff1d57c620ad$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $db48ff1d57c620ad$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $db48ff1d57c620ad$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $db48ff1d57c620ad$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $db48ff1d57c620ad$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $db48ff1d57c620ad$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $db48ff1d57c620ad$export$56c0d5a1e737357d, rad - $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd, rad + $db48ff1d57c620ad$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $db48ff1d57c620ad$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $db48ff1d57c620ad$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $db48ff1d57c620ad$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $db48ff1d57c620ad$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $db48ff1d57c620ad$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $db48ff1d57c620ad$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $db48ff1d57c620ad$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$db48ff1d57c620ad$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $db48ff1d57c620ad$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $db48ff1d57c620ad$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $db48ff1d57c620ad$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $db48ff1d57c620ad$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $db48ff1d57c620ad$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $db48ff1d57c620ad$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$db48ff1d57c620ad$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $db48ff1d57c620ad$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $db48ff1d57c620ad$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $db48ff1d57c620ad$export$56c0d5a1e737357d, $db48ff1d57c620ad$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $db48ff1d57c620ad$export$56c0d5a1e737357d, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$db48ff1d57c620ad$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $db48ff1d57c620ad$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $db48ff1d57c620ad$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $db48ff1d57c620ad$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($db48ff1d57c620ad$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $db48ff1d57c620ad$var$numberOrZero = (v)=>+v || 0;
function $db48ff1d57c620ad$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $db48ff1d57c620ad$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $db48ff1d57c620ad$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$db48ff1d57c620ad$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $db48ff1d57c620ad$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $db48ff1d57c620ad$export$9fa96a7d116ea3ce(value) {
    return $db48ff1d57c620ad$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $db48ff1d57c620ad$export$28f7fcd39efa255(value) {
    return $db48ff1d57c620ad$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $db48ff1d57c620ad$export$a9c23c6ac3fc3eca(value) {
    const obj = $db48ff1d57c620ad$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $db48ff1d57c620ad$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $db48ff1d57c620ad$export$4368d992c4eafac0.font;
    let size = $db48ff1d57c620ad$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $db48ff1d57c620ad$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($db48ff1d57c620ad$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $db48ff1d57c620ad$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $db48ff1d57c620ad$export$d29e374196577086($db48ff1d57c620ad$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $db48ff1d57c620ad$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $db48ff1d57c620ad$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $db48ff1d57c620ad$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $db48ff1d57c620ad$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $db48ff1d57c620ad$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $db48ff1d57c620ad$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $db48ff1d57c620ad$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $db48ff1d57c620ad$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $db48ff1d57c620ad$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$db48ff1d57c620ad$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $db48ff1d57c620ad$var$_cached(target, prop, ()=>$db48ff1d57c620ad$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $db48ff1d57c620ad$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $db48ff1d57c620ad$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $db48ff1d57c620ad$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $db48ff1d57c620ad$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$db48ff1d57c620ad$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$db48ff1d57c620ad$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $db48ff1d57c620ad$var$_cached(target, prop, ()=>$db48ff1d57c620ad$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $db48ff1d57c620ad$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $db48ff1d57c620ad$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $db48ff1d57c620ad$var$readKey = (prefix, name)=>prefix ? prefix + $db48ff1d57c620ad$export$a8550f7dbe79f93a(name) : name;
const $db48ff1d57c620ad$var$needsSubResolver = (prop, value)=>$db48ff1d57c620ad$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $db48ff1d57c620ad$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $db48ff1d57c620ad$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($db48ff1d57c620ad$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $db48ff1d57c620ad$var$_resolveScriptable(prop, value, target, receiver);
    if ($db48ff1d57c620ad$export$8b22cf2602fb60ce(value) && value.length) value = $db48ff1d57c620ad$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($db48ff1d57c620ad$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $db48ff1d57c620ad$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $db48ff1d57c620ad$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($db48ff1d57c620ad$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $db48ff1d57c620ad$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $db48ff1d57c620ad$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($db48ff1d57c620ad$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $db48ff1d57c620ad$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($db48ff1d57c620ad$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $db48ff1d57c620ad$var$resolveFallback(fallback, prop, value) {
    return $db48ff1d57c620ad$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $db48ff1d57c620ad$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $db48ff1d57c620ad$export$2d1720544b23b823(parent, key) : undefined;
function $db48ff1d57c620ad$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $db48ff1d57c620ad$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $db48ff1d57c620ad$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $db48ff1d57c620ad$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $db48ff1d57c620ad$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $db48ff1d57c620ad$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $db48ff1d57c620ad$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $db48ff1d57c620ad$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$db48ff1d57c620ad$var$subGetTarget(resolver, prop, value));
}
function $db48ff1d57c620ad$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $db48ff1d57c620ad$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $db48ff1d57c620ad$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($db48ff1d57c620ad$export$8b22cf2602fb60ce(target) && $db48ff1d57c620ad$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $db48ff1d57c620ad$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $db48ff1d57c620ad$var$_resolve($db48ff1d57c620ad$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $db48ff1d57c620ad$var$needsSubResolver(prop, value) ? $db48ff1d57c620ad$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $db48ff1d57c620ad$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $db48ff1d57c620ad$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $db48ff1d57c620ad$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $db48ff1d57c620ad$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $db48ff1d57c620ad$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($db48ff1d57c620ad$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $db48ff1d57c620ad$var$EPSILON = Number.EPSILON || 1e-14;
const $db48ff1d57c620ad$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $db48ff1d57c620ad$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $db48ff1d57c620ad$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $db48ff1d57c620ad$export$cf2f7c5792f80b46(current, previous);
    const d12 = $db48ff1d57c620ad$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $db48ff1d57c620ad$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $db48ff1d57c620ad$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $db48ff1d57c620ad$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($db48ff1d57c620ad$export$23ebac1979863676(deltaK[i], 0, $db48ff1d57c620ad$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $db48ff1d57c620ad$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $db48ff1d57c620ad$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $db48ff1d57c620ad$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $db48ff1d57c620ad$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $db48ff1d57c620ad$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $db48ff1d57c620ad$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $db48ff1d57c620ad$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $db48ff1d57c620ad$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $db48ff1d57c620ad$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $db48ff1d57c620ad$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $db48ff1d57c620ad$var$monotoneAdjust(points, deltaK, mK);
    $db48ff1d57c620ad$var$monotoneCompute(points, mK, indexAxis);
}
function $db48ff1d57c620ad$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $db48ff1d57c620ad$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $db48ff1d57c620ad$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $db48ff1d57c620ad$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $db48ff1d57c620ad$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $db48ff1d57c620ad$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $db48ff1d57c620ad$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $db48ff1d57c620ad$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $db48ff1d57c620ad$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $db48ff1d57c620ad$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $db48ff1d57c620ad$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $db48ff1d57c620ad$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $db48ff1d57c620ad$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $db48ff1d57c620ad$export$fef3dfd9bad05307(el, property) {
    return $db48ff1d57c620ad$var$getComputedStyle(el).getPropertyValue(property);
}
const $db48ff1d57c620ad$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $db48ff1d57c620ad$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $db48ff1d57c620ad$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $db48ff1d57c620ad$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $db48ff1d57c620ad$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($db48ff1d57c620ad$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $db48ff1d57c620ad$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $db48ff1d57c620ad$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $db48ff1d57c620ad$var$getPositionedStyle(style, 'padding');
    const borders = $db48ff1d57c620ad$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $db48ff1d57c620ad$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $db48ff1d57c620ad$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $db48ff1d57c620ad$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $db48ff1d57c620ad$var$getComputedStyle(container);
            const containerBorder = $db48ff1d57c620ad$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $db48ff1d57c620ad$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $db48ff1d57c620ad$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $db48ff1d57c620ad$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $db48ff1d57c620ad$export$53c86fa97d611818,
        maxHeight: maxHeight || $db48ff1d57c620ad$export$53c86fa97d611818
    };
}
const $db48ff1d57c620ad$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $db48ff1d57c620ad$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $db48ff1d57c620ad$var$getComputedStyle(canvas);
    const margins = $db48ff1d57c620ad$var$getPositionedStyle(style, 'margin');
    const maxWidth = $db48ff1d57c620ad$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $db48ff1d57c620ad$export$53c86fa97d611818;
    const maxHeight = $db48ff1d57c620ad$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $db48ff1d57c620ad$export$53c86fa97d611818;
    const containerSize = $db48ff1d57c620ad$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $db48ff1d57c620ad$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $db48ff1d57c620ad$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $db48ff1d57c620ad$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $db48ff1d57c620ad$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $db48ff1d57c620ad$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $db48ff1d57c620ad$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $db48ff1d57c620ad$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = $db48ff1d57c620ad$var$round1(chart.height * pixelRatio);
    const deviceWidth = $db48ff1d57c620ad$var$round1(chart.width * pixelRatio);
    chart.height = $db48ff1d57c620ad$var$round1(chart.height);
    chart.width = $db48ff1d57c620ad$var$round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $db48ff1d57c620ad$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($db48ff1d57c620ad$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $db48ff1d57c620ad$export$b4171a6734a65d42(element, property) {
    const value = $db48ff1d57c620ad$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $db48ff1d57c620ad$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $db48ff1d57c620ad$export$6554612db691658e(p1, cp1, t);
    const b = $db48ff1d57c620ad$export$6554612db691658e(cp1, cp2, t);
    const c = $db48ff1d57c620ad$export$6554612db691658e(cp2, p2, t);
    const d = $db48ff1d57c620ad$export$6554612db691658e(a, b, t);
    const e = $db48ff1d57c620ad$export$6554612db691658e(b, c, t);
    return $db48ff1d57c620ad$export$6554612db691658e(d, e, t);
}
const $db48ff1d57c620ad$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $db48ff1d57c620ad$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $db48ff1d57c620ad$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $db48ff1d57c620ad$var$getRightToLeftAdapter(rectX, width) : $db48ff1d57c620ad$var$getLeftToRightAdapter();
}
function $db48ff1d57c620ad$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $db48ff1d57c620ad$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $db48ff1d57c620ad$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $db48ff1d57c620ad$export$ffb5f4729a158638,
        compare: $db48ff1d57c620ad$export$f074adc9fbd50943,
        normalize: $db48ff1d57c620ad$export$ab83b03e4111b1d0
    };
    return {
        between: $db48ff1d57c620ad$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $db48ff1d57c620ad$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $db48ff1d57c620ad$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $db48ff1d57c620ad$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $db48ff1d57c620ad$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $db48ff1d57c620ad$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $db48ff1d57c620ad$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($db48ff1d57c620ad$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($db48ff1d57c620ad$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $db48ff1d57c620ad$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $db48ff1d57c620ad$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $db48ff1d57c620ad$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $db48ff1d57c620ad$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $db48ff1d57c620ad$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $db48ff1d57c620ad$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $db48ff1d57c620ad$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $db48ff1d57c620ad$var$splitByStyles(line, $db48ff1d57c620ad$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $db48ff1d57c620ad$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $db48ff1d57c620ad$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $db48ff1d57c620ad$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $db48ff1d57c620ad$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $db48ff1d57c620ad$var$readStyle(segmentOptions.setContext($db48ff1d57c620ad$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($db48ff1d57c620ad$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $db48ff1d57c620ad$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $db48ff1d57c620ad$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$db48ff1d57c620ad$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $db48ff1d57c620ad$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $db48ff1d57c620ad$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $db48ff1d57c620ad$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $db48ff1d57c620ad$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $db48ff1d57c620ad$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $db48ff1d57c620ad$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $db48ff1d57c620ad$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $db48ff1d57c620ad$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $9d0943f78a3e28b3$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $db48ff1d57c620ad$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $9d0943f78a3e28b3$export$a424a0aa8f687495 = /* #__PURE__ */ new $9d0943f78a3e28b3$var$Animator();
const $9d0943f78a3e28b3$var$transparent = 'transparent';
const $9d0943f78a3e28b3$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $db48ff1d57c620ad$export$db3b6bfb95261072)(from || $9d0943f78a3e28b3$var$transparent);
        const c1 = c0.valid && (0, $db48ff1d57c620ad$export$db3b6bfb95261072)(to || $9d0943f78a3e28b3$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $9d0943f78a3e28b3$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $db48ff1d57c620ad$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $db48ff1d57c620ad$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $9d0943f78a3e28b3$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $db48ff1d57c620ad$export$f1e1789686576879)[cfg.easing] || (0, $db48ff1d57c620ad$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $db48ff1d57c620ad$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $db48ff1d57c620ad$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $9d0943f78a3e28b3$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $db48ff1d57c620ad$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $9d0943f78a3e28b3$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $9d0943f78a3e28b3$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $9d0943f78a3e28b3$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $9d0943f78a3e28b3$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $9d0943f78a3e28b3$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $9d0943f78a3e28b3$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $9d0943f78a3e28b3$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $9d0943f78a3e28b3$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $9d0943f78a3e28b3$var$scaleClip(xScale, allowedOverflow);
    const y = $9d0943f78a3e28b3$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $9d0943f78a3e28b3$var$toClip(value) {
    let t, r, b, l;
    if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $9d0943f78a3e28b3$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $9d0943f78a3e28b3$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $db48ff1d57c620ad$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $db48ff1d57c620ad$export$2408f22a0fab9ae5)(value) === (0, $db48ff1d57c620ad$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $9d0943f78a3e28b3$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $9d0943f78a3e28b3$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $9d0943f78a3e28b3$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $9d0943f78a3e28b3$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $9d0943f78a3e28b3$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $9d0943f78a3e28b3$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $9d0943f78a3e28b3$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $9d0943f78a3e28b3$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $9d0943f78a3e28b3$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $9d0943f78a3e28b3$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $9d0943f78a3e28b3$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $9d0943f78a3e28b3$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $9d0943f78a3e28b3$var$createDatasetContext(parent, index) {
    return (0, $db48ff1d57c620ad$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $9d0943f78a3e28b3$var$createDataContext(parent, index, element) {
    return (0, $db48ff1d57c620ad$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $9d0943f78a3e28b3$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $9d0943f78a3e28b3$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $9d0943f78a3e28b3$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $9d0943f78a3e28b3$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $9d0943f78a3e28b3$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $9d0943f78a3e28b3$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $9d0943f78a3e28b3$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $9d0943f78a3e28b3$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(dataset.xAxisID, $9d0943f78a3e28b3$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(dataset.yAxisID, $9d0943f78a3e28b3$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(dataset.rAxisID, $9d0943f78a3e28b3$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $db48ff1d57c620ad$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $9d0943f78a3e28b3$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $9d0943f78a3e28b3$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $db48ff1d57c620ad$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $9d0943f78a3e28b3$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $db48ff1d57c620ad$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $9d0943f78a3e28b3$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $9d0943f78a3e28b3$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $9d0943f78a3e28b3$var$updateStacks(this, meta._parsed);
            meta._stacked = $9d0943f78a3e28b3$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $9d0943f78a3e28b3$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $db48ff1d57c620ad$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $db48ff1d57c620ad$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $9d0943f78a3e28b3$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $9d0943f78a3e28b3$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $9d0943f78a3e28b3$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $9d0943f78a3e28b3$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $9d0943f78a3e28b3$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $db48ff1d57c620ad$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $db48ff1d57c620ad$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $9d0943f78a3e28b3$var$toClip((0, $db48ff1d57c620ad$export$90a7f3efeed30595)(this.options.clip, $9d0943f78a3e28b3$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $9d0943f78a3e28b3$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $9d0943f78a3e28b3$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $db48ff1d57c620ad$export$dda1d9f60106f0e9)(index);
        if (cached) return $9d0943f78a3e28b3$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $db48ff1d57c620ad$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($9d0943f78a3e28b3$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $9d0943f78a3e28b3$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $9d0943f78a3e28b3$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($9d0943f78a3e28b3$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$9d0943f78a3e28b3$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $9d0943f78a3e28b3$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $9d0943f78a3e28b3$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $db48ff1d57c620ad$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $9d0943f78a3e28b3$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $9d0943f78a3e28b3$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $db48ff1d57c620ad$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $9d0943f78a3e28b3$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $9d0943f78a3e28b3$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $9d0943f78a3e28b3$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $9d0943f78a3e28b3$var$parseValue(entry, item, vScale, i) {
    if ((0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(entry)) $9d0943f78a3e28b3$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $9d0943f78a3e28b3$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($9d0943f78a3e28b3$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $9d0943f78a3e28b3$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $9d0943f78a3e28b3$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $db48ff1d57c620ad$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $9d0943f78a3e28b3$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $9d0943f78a3e28b3$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $9d0943f78a3e28b3$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$9d0943f78a3e28b3$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$9d0943f78a3e28b3$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $9d0943f78a3e28b3$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $9d0943f78a3e28b3$var$swap(edge, a, b);
        edge = $9d0943f78a3e28b3$var$startEnd(edge, b, a);
    } else edge = $9d0943f78a3e28b3$var$startEnd(edge, a, b);
    return edge;
}
function $9d0943f78a3e28b3$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $9d0943f78a3e28b3$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $9d0943f78a3e28b3$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $9d0943f78a3e28b3$export$e97d5dc64e999004 extends $9d0943f78a3e28b3$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $9d0943f78a3e28b3$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $9d0943f78a3e28b3$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $db48ff1d57c620ad$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($9d0943f78a3e28b3$var$parseValue((0, $db48ff1d57c620ad$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $9d0943f78a3e28b3$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $db48ff1d57c620ad$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $9d0943f78a3e28b3$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $9d0943f78a3e28b3$var$setBorderSkipped(properties, options, stack, index);
            $9d0943f78a3e28b3$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $db48ff1d57c620ad$export$90a7f3efeed30595)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $9d0943f78a3e28b3$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $9d0943f78a3e28b3$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $db48ff1d57c620ad$export$2408f22a0fab9ae5)(value) !== (0, $db48ff1d57c620ad$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $9d0943f78a3e28b3$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $db48ff1d57c620ad$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $9d0943f78a3e28b3$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $9d0943f78a3e28b3$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $db48ff1d57c620ad$export$90a7f3efeed30595)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $9d0943f78a3e28b3$export$19b5c4773f17abe extends $9d0943f78a3e28b3$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $9d0943f78a3e28b3$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $db48ff1d57c620ad$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $db48ff1d57c620ad$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $db48ff1d57c620ad$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $db48ff1d57c620ad$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $db48ff1d57c620ad$export$56c0d5a1e737357d) + (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $9d0943f78a3e28b3$export$e04603e7d8b77172 extends $9d0943f78a3e28b3$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        const { labels: { pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                        if (data.labels.length && data.datasets.length) return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                fontColor: color,
                                hidden: !chart.getDataVisibility(i),
                                lineDash: style.borderDash,
                                lineDashOffset: style.borderDashOffset,
                                lineJoin: style.borderJoinStyle,
                                lineWidth: style.borderWidth,
                                strokeStyle: style.borderColor,
                                textAlign: textAlign,
                                pointStyle: pointStyle,
                                borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                                index: i
                            };
                        });
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $db48ff1d57c620ad$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $db48ff1d57c620ad$export$971d5caa766a69d7);
        let max = -(0, $db48ff1d57c620ad$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $db48ff1d57c620ad$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $9d0943f78a3e28b3$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $db48ff1d57c620ad$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $db48ff1d57c620ad$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $db48ff1d57c620ad$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $db48ff1d57c620ad$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $db48ff1d57c620ad$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $9d0943f78a3e28b3$export$3c9b5d28c11cbfd0 extends $9d0943f78a3e28b3$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $db48ff1d57c620ad$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $db48ff1d57c620ad$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $db48ff1d57c620ad$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $db48ff1d57c620ad$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $9d0943f78a3e28b3$export$2a270b3a0d973c85 extends $9d0943f78a3e28b3$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $db48ff1d57c620ad$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $db48ff1d57c620ad$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $db48ff1d57c620ad$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $9d0943f78a3e28b3$export$b21a3f1286706191 extends $9d0943f78a3e28b3$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $9d0943f78a3e28b3$export$48dbc6ac651bf8be extends $9d0943f78a3e28b3$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $db48ff1d57c620ad$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $9d0943f78a3e28b3$export$b2f2bae6713db87 extends $9d0943f78a3e28b3$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $db48ff1d57c620ad$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $db48ff1d57c620ad$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $db48ff1d57c620ad$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $db48ff1d57c620ad$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $9d0943f78a3e28b3$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $9d0943f78a3e28b3$export$e97d5dc64e999004,
    BubbleController: $9d0943f78a3e28b3$export$19b5c4773f17abe,
    DoughnutController: $9d0943f78a3e28b3$export$e04603e7d8b77172,
    LineController: $9d0943f78a3e28b3$export$3c9b5d28c11cbfd0,
    PieController: $9d0943f78a3e28b3$export$b21a3f1286706191,
    PolarAreaController: $9d0943f78a3e28b3$export$2a270b3a0d973c85,
    RadarController: $9d0943f78a3e28b3$export$48dbc6ac651bf8be,
    ScatterController: $9d0943f78a3e28b3$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $9d0943f78a3e28b3$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $9d0943f78a3e28b3$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($9d0943f78a3e28b3$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $9d0943f78a3e28b3$var$abstract();
    }
    parse() {
        return $9d0943f78a3e28b3$var$abstract();
    }
    format() {
        return $9d0943f78a3e28b3$var$abstract();
    }
    add() {
        return $9d0943f78a3e28b3$var$abstract();
    }
    diff() {
        return $9d0943f78a3e28b3$var$abstract();
    }
    startOf() {
        return $9d0943f78a3e28b3$var$abstract();
    }
    endOf() {
        return $9d0943f78a3e28b3$var$abstract();
    }
}
var $9d0943f78a3e28b3$export$f32766ea09ec8bc4 = {
    _date: $9d0943f78a3e28b3$var$DateAdapterBase
};
function $9d0943f78a3e28b3$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $db48ff1d57c620ad$export$ebd11618f299a286) : (0, $db48ff1d57c620ad$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $9d0943f78a3e28b3$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $9d0943f78a3e28b3$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $9d0943f78a3e28b3$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $9d0943f78a3e28b3$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $db48ff1d57c620ad$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $9d0943f78a3e28b3$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $9d0943f78a3e28b3$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $db48ff1d57c620ad$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $db48ff1d57c620ad$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $9d0943f78a3e28b3$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $9d0943f78a3e28b3$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $9d0943f78a3e28b3$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $9d0943f78a3e28b3$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $9d0943f78a3e28b3$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $9d0943f78a3e28b3$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $9d0943f78a3e28b3$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $9d0943f78a3e28b3$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $9d0943f78a3e28b3$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $9d0943f78a3e28b3$export$a13296960cae0384 = {
    evaluateInteractionItems: $9d0943f78a3e28b3$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $db48ff1d57c620ad$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $9d0943f78a3e28b3$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $9d0943f78a3e28b3$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $db48ff1d57c620ad$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $9d0943f78a3e28b3$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $9d0943f78a3e28b3$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $db48ff1d57c620ad$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $9d0943f78a3e28b3$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $db48ff1d57c620ad$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $9d0943f78a3e28b3$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $db48ff1d57c620ad$export$df995fae86a55f06)(e, chart);
            return $9d0943f78a3e28b3$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $db48ff1d57c620ad$export$df995fae86a55f06)(e, chart);
            return $9d0943f78a3e28b3$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $9d0943f78a3e28b3$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $9d0943f78a3e28b3$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $9d0943f78a3e28b3$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$9d0943f78a3e28b3$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $9d0943f78a3e28b3$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $9d0943f78a3e28b3$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $9d0943f78a3e28b3$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$9d0943f78a3e28b3$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $9d0943f78a3e28b3$var$setLayoutDims(layouts, params) {
    const stacks = $9d0943f78a3e28b3$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $9d0943f78a3e28b3$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $9d0943f78a3e28b3$var$wrapBoxes(boxes);
    const fullSize = $9d0943f78a3e28b3$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $9d0943f78a3e28b3$var$sortByWeight($9d0943f78a3e28b3$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $9d0943f78a3e28b3$var$sortByWeight($9d0943f78a3e28b3$var$filterByPosition(layoutBoxes, 'right'));
    const top = $9d0943f78a3e28b3$var$sortByWeight($9d0943f78a3e28b3$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $9d0943f78a3e28b3$var$sortByWeight($9d0943f78a3e28b3$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $9d0943f78a3e28b3$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $9d0943f78a3e28b3$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $9d0943f78a3e28b3$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $9d0943f78a3e28b3$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $9d0943f78a3e28b3$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $9d0943f78a3e28b3$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $9d0943f78a3e28b3$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $9d0943f78a3e28b3$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $9d0943f78a3e28b3$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $9d0943f78a3e28b3$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $9d0943f78a3e28b3$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $9d0943f78a3e28b3$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $9d0943f78a3e28b3$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $9d0943f78a3e28b3$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $9d0943f78a3e28b3$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $9d0943f78a3e28b3$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $9d0943f78a3e28b3$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $db48ff1d57c620ad$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $9d0943f78a3e28b3$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $9d0943f78a3e28b3$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $db48ff1d57c620ad$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $9d0943f78a3e28b3$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $9d0943f78a3e28b3$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $9d0943f78a3e28b3$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $9d0943f78a3e28b3$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $db48ff1d57c620ad$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $9d0943f78a3e28b3$var$updateMaxPadding(maxPadding, (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $9d0943f78a3e28b3$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $9d0943f78a3e28b3$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $9d0943f78a3e28b3$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($9d0943f78a3e28b3$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $9d0943f78a3e28b3$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $9d0943f78a3e28b3$var$handleMaxPadding(chartArea);
        $9d0943f78a3e28b3$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $9d0943f78a3e28b3$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $db48ff1d57c620ad$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $9d0943f78a3e28b3$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $9d0943f78a3e28b3$export$a40a96b24b46cf35 extends $9d0943f78a3e28b3$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $9d0943f78a3e28b3$var$EXPANDO_KEY = '$chartjs';
const $9d0943f78a3e28b3$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $9d0943f78a3e28b3$var$isNullOrEmpty = (value)=>value === null || value === '';
function $9d0943f78a3e28b3$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$9d0943f78a3e28b3$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($9d0943f78a3e28b3$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $db48ff1d57c620ad$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($9d0943f78a3e28b3$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $db48ff1d57c620ad$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $9d0943f78a3e28b3$var$eventListenerOptions = (0, $db48ff1d57c620ad$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $9d0943f78a3e28b3$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $9d0943f78a3e28b3$var$eventListenerOptions);
}
function $9d0943f78a3e28b3$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $9d0943f78a3e28b3$var$eventListenerOptions);
}
function $9d0943f78a3e28b3$var$fromNativeEvent(event, chart) {
    const type = $9d0943f78a3e28b3$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $db48ff1d57c620ad$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $9d0943f78a3e28b3$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $9d0943f78a3e28b3$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $9d0943f78a3e28b3$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$9d0943f78a3e28b3$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $9d0943f78a3e28b3$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $9d0943f78a3e28b3$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$9d0943f78a3e28b3$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $9d0943f78a3e28b3$var$drpListeningCharts = new Map();
let $9d0943f78a3e28b3$var$oldDevicePixelRatio = 0;
function $9d0943f78a3e28b3$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $9d0943f78a3e28b3$var$oldDevicePixelRatio) return;
    $9d0943f78a3e28b3$var$oldDevicePixelRatio = dpr;
    $9d0943f78a3e28b3$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $9d0943f78a3e28b3$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$9d0943f78a3e28b3$var$drpListeningCharts.size) window.addEventListener('resize', $9d0943f78a3e28b3$var$onWindowResize);
    $9d0943f78a3e28b3$var$drpListeningCharts.set(chart, resize);
}
function $9d0943f78a3e28b3$var$unlistenDevicePixelRatioChanges(chart) {
    $9d0943f78a3e28b3$var$drpListeningCharts.delete(chart);
    if (!$9d0943f78a3e28b3$var$drpListeningCharts.size) window.removeEventListener('resize', $9d0943f78a3e28b3$var$onWindowResize);
}
function $9d0943f78a3e28b3$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $db48ff1d57c620ad$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $db48ff1d57c620ad$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $9d0943f78a3e28b3$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $9d0943f78a3e28b3$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $9d0943f78a3e28b3$var$unlistenDevicePixelRatioChanges(chart);
}
function $9d0943f78a3e28b3$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $db48ff1d57c620ad$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($9d0943f78a3e28b3$var$fromNativeEvent(event, chart));
    }, chart);
    $9d0943f78a3e28b3$var$addListener(canvas, type, proxy);
    return proxy;
}
class $9d0943f78a3e28b3$export$f02da7f882cf6b2e extends $9d0943f78a3e28b3$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $9d0943f78a3e28b3$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$9d0943f78a3e28b3$var$EXPANDO_KEY]) return false;
        const initial = canvas[$9d0943f78a3e28b3$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$9d0943f78a3e28b3$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $9d0943f78a3e28b3$var$createAttachObserver,
            detach: $9d0943f78a3e28b3$var$createDetachObserver,
            resize: $9d0943f78a3e28b3$var$createResizeObserver
        };
        const handler = handlers[type] || $9d0943f78a3e28b3$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $9d0943f78a3e28b3$var$releaseObserver,
            detach: $9d0943f78a3e28b3$var$releaseObserver,
            resize: $9d0943f78a3e28b3$var$releaseObserver
        };
        const handler = handlers[type] || $9d0943f78a3e28b3$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $db48ff1d57c620ad$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $db48ff1d57c620ad$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $9d0943f78a3e28b3$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $db48ff1d57c620ad$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $9d0943f78a3e28b3$export$a40a96b24b46cf35;
    return $9d0943f78a3e28b3$export$f02da7f882cf6b2e;
}
class $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $db48ff1d57c620ad$export$d141bba7fdc215a3)(this.x) && (0, $db48ff1d57c620ad$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $9d0943f78a3e28b3$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $9d0943f78a3e28b3$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $9d0943f78a3e28b3$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $9d0943f78a3e28b3$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $9d0943f78a3e28b3$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $9d0943f78a3e28b3$var$skip(ticks, newTicks, spacing, (0, $db48ff1d57c620ad$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$9d0943f78a3e28b3$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $9d0943f78a3e28b3$var$skip(ticks, newTicks, spacing, last, (0, $db48ff1d57c620ad$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $9d0943f78a3e28b3$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $9d0943f78a3e28b3$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $9d0943f78a3e28b3$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $9d0943f78a3e28b3$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $db48ff1d57c620ad$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $9d0943f78a3e28b3$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $9d0943f78a3e28b3$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $9d0943f78a3e28b3$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $db48ff1d57c620ad$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $9d0943f78a3e28b3$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $9d0943f78a3e28b3$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $9d0943f78a3e28b3$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $9d0943f78a3e28b3$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $9d0943f78a3e28b3$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $9d0943f78a3e28b3$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $9d0943f78a3e28b3$var$garbageCollect(caches, length) {
    (0, $db48ff1d57c620ad$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $9d0943f78a3e28b3$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $9d0943f78a3e28b3$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $db48ff1d57c620ad$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $9d0943f78a3e28b3$var$createScaleContext(parent, scale) {
    return (0, $db48ff1d57c620ad$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $9d0943f78a3e28b3$var$createTickContext(parent, index, tick) {
    return (0, $db48ff1d57c620ad$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $9d0943f78a3e28b3$var$titleAlign(align, position, reverse) {
    let ret = (0, $db48ff1d57c620ad$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $9d0943f78a3e28b3$var$reverseAlign(ret);
    return ret;
}
function $9d0943f78a3e28b3$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $9d0943f78a3e28b3$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $9d0943f78a3e28b3$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd) : (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $9d0943f78a3e28b3$export$d60cfc58d3c358b6 extends $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(min, (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(max, min)),
            max: (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(max, (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $db48ff1d57c620ad$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $9d0943f78a3e28b3$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $9d0943f78a3e28b3$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $9d0943f78a3e28b3$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $9d0943f78a3e28b3$var$getTickMarkLength(options.grid) - tickOpts.padding - $9d0943f78a3e28b3$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $db48ff1d57c620ad$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $db48ff1d57c620ad$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $db48ff1d57c620ad$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $db48ff1d57c620ad$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $9d0943f78a3e28b3$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $9d0943f78a3e28b3$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $9d0943f78a3e28b3$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $9d0943f78a3e28b3$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $9d0943f78a3e28b3$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(label) && !(0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(label)) {
                width = (0, $db48ff1d57c620ad$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(nestedLabel) && !(0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $db48ff1d57c620ad$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $9d0943f78a3e28b3$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $db48ff1d57c620ad$export$71cec2538cb2c617)(this._alignToPixels ? (0, $db48ff1d57c620ad$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $9d0943f78a3e28b3$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $9d0943f78a3e28b3$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $9d0943f78a3e28b3$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $db48ff1d57c620ad$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $9d0943f78a3e28b3$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $db48ff1d57c620ad$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $9d0943f78a3e28b3$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $db48ff1d57c620ad$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $db48ff1d57c620ad$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $db48ff1d57c620ad$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $db48ff1d57c620ad$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $db48ff1d57c620ad$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $db48ff1d57c620ad$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $db48ff1d57c620ad$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $db48ff1d57c620ad$export$34aec0b863436764)(title.font);
        const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $9d0943f78a3e28b3$var$titleArgs(this, offset, position, align);
        (0, $db48ff1d57c620ad$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $9d0943f78a3e28b3$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $9d0943f78a3e28b3$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $db48ff1d57c620ad$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $9d0943f78a3e28b3$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($9d0943f78a3e28b3$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $9d0943f78a3e28b3$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $db48ff1d57c620ad$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $db48ff1d57c620ad$export$4368d992c4eafac0)[scope]) {
            delete (0, $db48ff1d57c620ad$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $db48ff1d57c620ad$export$6559d589eb85fbb6)[id];
        }
    }
}
function $9d0943f78a3e28b3$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $db48ff1d57c620ad$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $db48ff1d57c620ad$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $db48ff1d57c620ad$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $db48ff1d57c620ad$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $9d0943f78a3e28b3$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $db48ff1d57c620ad$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $9d0943f78a3e28b3$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $db48ff1d57c620ad$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $9d0943f78a3e28b3$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $9d0943f78a3e28b3$var$Registry {
    constructor(){
        this.controllers = new $9d0943f78a3e28b3$var$TypedRegistry($9d0943f78a3e28b3$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $9d0943f78a3e28b3$var$TypedRegistry($9d0943f78a3e28b3$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $9d0943f78a3e28b3$var$TypedRegistry(Object, 'plugins');
        this.scales = new $9d0943f78a3e28b3$var$TypedRegistry($9d0943f78a3e28b3$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $db48ff1d57c620ad$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $db48ff1d57c620ad$export$a8550f7dbe79f93a)(method);
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $9d0943f78a3e28b3$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $9d0943f78a3e28b3$var$Registry();
class $9d0943f78a3e28b3$var$PluginService {
    constructor(){
        this._init = undefined;
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) return;
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $9d0943f78a3e28b3$var$allPlugins(config);
        return options === false && !all ? [] : $9d0943f78a3e28b3$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $9d0943f78a3e28b3$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($9d0943f78a3e28b3$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($9d0943f78a3e28b3$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $9d0943f78a3e28b3$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $9d0943f78a3e28b3$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $9d0943f78a3e28b3$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $9d0943f78a3e28b3$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $9d0943f78a3e28b3$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $9d0943f78a3e28b3$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $db48ff1d57c620ad$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $9d0943f78a3e28b3$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $9d0943f78a3e28b3$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $9d0943f78a3e28b3$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $9d0943f78a3e28b3$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $9d0943f78a3e28b3$var$determineAxis(id, ...scaleOptions) {
    if ($9d0943f78a3e28b3$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $9d0943f78a3e28b3$var$axisFromPosition(opts.position) || id.length > 1 && $9d0943f78a3e28b3$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $9d0943f78a3e28b3$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $9d0943f78a3e28b3$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $9d0943f78a3e28b3$var$getAxisFromDataset(id, 'x', boundDs[0]) || $9d0943f78a3e28b3$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $9d0943f78a3e28b3$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $db48ff1d57c620ad$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $9d0943f78a3e28b3$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $9d0943f78a3e28b3$var$determineAxis(id, scaleConf, $9d0943f78a3e28b3$var$retrieveAxisFromDatasets(id, config), (0, $db48ff1d57c620ad$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $9d0943f78a3e28b3$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $db48ff1d57c620ad$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $9d0943f78a3e28b3$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $db48ff1d57c620ad$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $9d0943f78a3e28b3$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $db48ff1d57c620ad$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $db48ff1d57c620ad$export$555508cbc6add439)(scale, [
            (0, $db48ff1d57c620ad$export$4368d992c4eafac0).scales[scale.type],
            (0, $db48ff1d57c620ad$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $9d0943f78a3e28b3$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $9d0943f78a3e28b3$var$mergeScaleConfig(config, options);
}
function $9d0943f78a3e28b3$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $9d0943f78a3e28b3$var$initConfig(config) {
    config = config || {};
    config.data = $9d0943f78a3e28b3$var$initData(config.data);
    $9d0943f78a3e28b3$var$initOptions(config);
    return config;
}
const $9d0943f78a3e28b3$var$keyCache = new Map();
const $9d0943f78a3e28b3$var$keysCached = new Set();
function $9d0943f78a3e28b3$var$cachedKeys(cacheKey, generate) {
    let keys = $9d0943f78a3e28b3$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $9d0943f78a3e28b3$var$keyCache.set(cacheKey, keys);
        $9d0943f78a3e28b3$var$keysCached.add(keys);
    }
    return keys;
}
const $9d0943f78a3e28b3$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $db48ff1d57c620ad$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $9d0943f78a3e28b3$var$Config {
    constructor(config){
        this._config = $9d0943f78a3e28b3$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $9d0943f78a3e28b3$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $9d0943f78a3e28b3$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $9d0943f78a3e28b3$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $9d0943f78a3e28b3$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $9d0943f78a3e28b3$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $9d0943f78a3e28b3$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$9d0943f78a3e28b3$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$9d0943f78a3e28b3$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$9d0943f78a3e28b3$var$addIfFound(scopes, (0, $db48ff1d57c620ad$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$9d0943f78a3e28b3$var$addIfFound(scopes, (0, $db48ff1d57c620ad$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$9d0943f78a3e28b3$var$addIfFound(scopes, (0, $db48ff1d57c620ad$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($9d0943f78a3e28b3$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $db48ff1d57c620ad$export$6559d589eb85fbb6)[type] || {},
            (0, $db48ff1d57c620ad$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $db48ff1d57c620ad$export$4368d992c4eafac0),
            (0, $db48ff1d57c620ad$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $9d0943f78a3e28b3$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($9d0943f78a3e28b3$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $db48ff1d57c620ad$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $db48ff1d57c620ad$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $9d0943f78a3e28b3$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(context) ? (0, $db48ff1d57c620ad$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $9d0943f78a3e28b3$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $db48ff1d57c620ad$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $9d0943f78a3e28b3$var$hasFunction = (value)=>(0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $db48ff1d57c620ad$export$a93c5207d687da10)(value[key]));
function $9d0943f78a3e28b3$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $db48ff1d57c620ad$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $db48ff1d57c620ad$export$a93c5207d687da10)(value) || $9d0943f78a3e28b3$var$hasFunction(value)) || indexable && (0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $9d0943f78a3e28b3$var$version = "4.5.1";
const $9d0943f78a3e28b3$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $9d0943f78a3e28b3$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $9d0943f78a3e28b3$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $9d0943f78a3e28b3$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $9d0943f78a3e28b3$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $9d0943f78a3e28b3$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $9d0943f78a3e28b3$var$getCanvas(item) {
    if ((0, $db48ff1d57c620ad$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $9d0943f78a3e28b3$var$instances = {};
const $9d0943f78a3e28b3$var$getChart = (key)=>{
    const canvas = $9d0943f78a3e28b3$var$getCanvas(key);
    return Object.values($9d0943f78a3e28b3$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $9d0943f78a3e28b3$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $9d0943f78a3e28b3$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $9d0943f78a3e28b3$export$acaa6426d77a227e {
    static defaults = (0, $db48ff1d57c620ad$export$4368d992c4eafac0);
    static instances = $9d0943f78a3e28b3$var$instances;
    static overrides = (0, $db48ff1d57c620ad$export$6559d589eb85fbb6);
    static registry = $9d0943f78a3e28b3$export$4bb7493d241fd8a5;
    static version = $9d0943f78a3e28b3$var$version;
    static getChart = $9d0943f78a3e28b3$var$getChart;
    static register(...items) {
        $9d0943f78a3e28b3$export$4bb7493d241fd8a5.add(...items);
        $9d0943f78a3e28b3$var$invalidatePlugins();
    }
    static unregister(...items) {
        $9d0943f78a3e28b3$export$4bb7493d241fd8a5.remove(...items);
        $9d0943f78a3e28b3$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $9d0943f78a3e28b3$var$Config(userConfig);
        const initialCanvas = $9d0943f78a3e28b3$var$getCanvas(item);
        const existingChart = $9d0943f78a3e28b3$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $9d0943f78a3e28b3$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $db48ff1d57c620ad$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $9d0943f78a3e28b3$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $db48ff1d57c620ad$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $9d0943f78a3e28b3$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $9d0943f78a3e28b3$export$a424a0aa8f687495.listen(this, 'complete', $9d0943f78a3e28b3$var$onAnimationsComplete);
        $9d0943f78a3e28b3$export$a424a0aa8f687495.listen(this, 'progress', $9d0943f78a3e28b3$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $9d0943f78a3e28b3$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $db48ff1d57c620ad$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $db48ff1d57c620ad$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $9d0943f78a3e28b3$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$9d0943f78a3e28b3$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $db48ff1d57c620ad$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $db48ff1d57c620ad$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $9d0943f78a3e28b3$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $db48ff1d57c620ad$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $9d0943f78a3e28b3$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $9d0943f78a3e28b3$var$positionIsHorizontal(scaleOptions.position, axis) !== $9d0943f78a3e28b3$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $9d0943f78a3e28b3$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $db48ff1d57c620ad$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $db48ff1d57c620ad$export$d66501df72047452)(scales, (scale)=>{
            $9d0943f78a3e28b3$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $9d0943f78a3e28b3$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($9d0943f78a3e28b3$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $9d0943f78a3e28b3$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $9d0943f78a3e28b3$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $db48ff1d57c620ad$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $9d0943f78a3e28b3$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $9d0943f78a3e28b3$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $db48ff1d57c620ad$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $db48ff1d57c620ad$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($9d0943f78a3e28b3$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $db48ff1d57c620ad$export$d66501df72047452)(this.scales, (scale)=>{
            $9d0943f78a3e28b3$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $db48ff1d57c620ad$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $9d0943f78a3e28b3$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $db48ff1d57c620ad$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $db48ff1d57c620ad$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $db48ff1d57c620ad$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($9d0943f78a3e28b3$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$9d0943f78a3e28b3$export$a424a0aa8f687495.running(this)) $9d0943f78a3e28b3$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $9d0943f78a3e28b3$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $db48ff1d57c620ad$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $db48ff1d57c620ad$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $db48ff1d57c620ad$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $db48ff1d57c620ad$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $9d0943f78a3e28b3$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $db48ff1d57c620ad$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $db48ff1d57c620ad$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $9d0943f78a3e28b3$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $db48ff1d57c620ad$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $9d0943f78a3e28b3$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $db48ff1d57c620ad$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $db48ff1d57c620ad$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $db48ff1d57c620ad$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $db48ff1d57c620ad$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $db48ff1d57c620ad$export$3b513254972cfc9c)(e);
        const lastEvent = $9d0943f78a3e28b3$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $db48ff1d57c620ad$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $9d0943f78a3e28b3$var$invalidatePlugins() {
    return (0, $db48ff1d57c620ad$export$d66501df72047452)($9d0943f78a3e28b3$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $9d0943f78a3e28b3$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $db48ff1d57c620ad$export$ab83b03e4111b1d0)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $db48ff1d57c620ad$export$ab83b03e4111b1d0)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $db48ff1d57c620ad$export$ab83b03e4111b1d0)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) / 2, startAngle + (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $9d0943f78a3e28b3$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd), startAngle - (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $9d0943f78a3e28b3$var$toRadiusCorners(value) {
    return (0, $db48ff1d57c620ad$export$1a82df3d29112e01)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $9d0943f78a3e28b3$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $9d0943f78a3e28b3$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $9d0943f78a3e28b3$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $9d0943f78a3e28b3$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $db48ff1d57c620ad$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $9d0943f78a3e28b3$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $9d0943f78a3e28b3$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $9d0943f78a3e28b3$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $9d0943f78a3e28b3$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $9d0943f78a3e28b3$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $9d0943f78a3e28b3$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $9d0943f78a3e28b3$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $9d0943f78a3e28b3$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $9d0943f78a3e28b3$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $db48ff1d57c620ad$export$971d5caa766a69d7) || (0, $db48ff1d57c620ad$export$971d5caa766a69d7));
    }
    $9d0943f78a3e28b3$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $9d0943f78a3e28b3$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $9d0943f78a3e28b3$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $db48ff1d57c620ad$export$971d5caa766a69d7) || (0, $db48ff1d57c620ad$export$971d5caa766a69d7));
    }
    if (inner) $9d0943f78a3e28b3$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) && borderRadius === 0 && borderJoinStyle !== 'miter') $9d0943f78a3e28b3$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $9d0943f78a3e28b3$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $9d0943f78a3e28b3$export$d48203c759d6a1fc extends $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $db48ff1d57c620ad$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $db48ff1d57c620ad$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $db48ff1d57c620ad$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $db48ff1d57c620ad$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $db48ff1d57c620ad$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $db48ff1d57c620ad$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $db48ff1d57c620ad$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $9d0943f78a3e28b3$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $9d0943f78a3e28b3$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $9d0943f78a3e28b3$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $db48ff1d57c620ad$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $9d0943f78a3e28b3$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $9d0943f78a3e28b3$var$getLineMethod(options) {
    if (options.stepped) return 0, $db48ff1d57c620ad$export$493d36ec626b6698;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $db48ff1d57c620ad$export$1fbe638ecf81657e;
    return $9d0943f78a3e28b3$var$lineTo;
}
function $9d0943f78a3e28b3$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $9d0943f78a3e28b3$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $9d0943f78a3e28b3$var$pathVars(points, segment, params);
    const lineMethod = $9d0943f78a3e28b3$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $9d0943f78a3e28b3$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $9d0943f78a3e28b3$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $9d0943f78a3e28b3$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $9d0943f78a3e28b3$var$fastPathSegment : $9d0943f78a3e28b3$var$pathSegment;
}
function $9d0943f78a3e28b3$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $db48ff1d57c620ad$export$8a5498727ef6be21;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $db48ff1d57c620ad$export$d24c54395ce0c509;
    return 0, $db48ff1d57c620ad$export$6554612db691658e;
}
function $9d0943f78a3e28b3$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $9d0943f78a3e28b3$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $9d0943f78a3e28b3$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $9d0943f78a3e28b3$var$_getSegmentMethod(line);
    for (const segment of segments){
        $9d0943f78a3e28b3$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $9d0943f78a3e28b3$var$usePath2D = typeof Path2D === 'function';
function $9d0943f78a3e28b3$var$draw(ctx, line, start, count) {
    if ($9d0943f78a3e28b3$var$usePath2D && !line.options.segment) $9d0943f78a3e28b3$var$strokePathWithCache(ctx, line, start, count);
    else $9d0943f78a3e28b3$var$strokePathDirect(ctx, line, start, count);
}
class $9d0943f78a3e28b3$export$55e463fa7bcd3469 extends $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $db48ff1d57c620ad$export$306ddfe3a8403e2)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $db48ff1d57c620ad$export$7a38258bbe170828)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $db48ff1d57c620ad$export$2f6ca3d3b1f80bf5)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $9d0943f78a3e28b3$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $9d0943f78a3e28b3$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $9d0943f78a3e28b3$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $9d0943f78a3e28b3$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $9d0943f78a3e28b3$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $9d0943f78a3e28b3$export$bd159b522b230b7a extends $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $9d0943f78a3e28b3$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $9d0943f78a3e28b3$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $db48ff1d57c620ad$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $db48ff1d57c620ad$export$d66dc83d8cfc8dd)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $9d0943f78a3e28b3$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $9d0943f78a3e28b3$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(value, min, max);
}
function $9d0943f78a3e28b3$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $db48ff1d57c620ad$export$9fa96a7d116ea3ce)(value);
    return {
        t: $9d0943f78a3e28b3$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $9d0943f78a3e28b3$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $9d0943f78a3e28b3$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $9d0943f78a3e28b3$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $9d0943f78a3e28b3$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $db48ff1d57c620ad$export$28f7fcd39efa255)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $9d0943f78a3e28b3$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $9d0943f78a3e28b3$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $9d0943f78a3e28b3$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $9d0943f78a3e28b3$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $9d0943f78a3e28b3$var$boundingRects(bar) {
    const bounds = $9d0943f78a3e28b3$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $9d0943f78a3e28b3$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $9d0943f78a3e28b3$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $9d0943f78a3e28b3$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $9d0943f78a3e28b3$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $db48ff1d57c620ad$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $db48ff1d57c620ad$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $9d0943f78a3e28b3$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $9d0943f78a3e28b3$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $9d0943f78a3e28b3$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $9d0943f78a3e28b3$export$a16ed71bf4b07672 extends $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $9d0943f78a3e28b3$var$boundingRects(this);
        const addRectPath = $9d0943f78a3e28b3$var$hasRadius(outer.radius) ? (0, $db48ff1d57c620ad$export$92108d983e8ee699) : $9d0943f78a3e28b3$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $9d0943f78a3e28b3$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $9d0943f78a3e28b3$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $9d0943f78a3e28b3$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $9d0943f78a3e28b3$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $9d0943f78a3e28b3$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $9d0943f78a3e28b3$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $9d0943f78a3e28b3$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $9d0943f78a3e28b3$export$d48203c759d6a1fc,
    BarElement: $9d0943f78a3e28b3$export$a16ed71bf4b07672,
    LineElement: $9d0943f78a3e28b3$export$55e463fa7bcd3469,
    PointElement: $9d0943f78a3e28b3$export$bd159b522b230b7a
});
const $9d0943f78a3e28b3$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $9d0943f78a3e28b3$var$BACKGROUND_COLORS = /* #__PURE__ */ $9d0943f78a3e28b3$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $9d0943f78a3e28b3$var$getBorderColor(i) {
    return $9d0943f78a3e28b3$var$BORDER_COLORS[i % $9d0943f78a3e28b3$var$BORDER_COLORS.length];
}
function $9d0943f78a3e28b3$var$getBackgroundColor(i) {
    return $9d0943f78a3e28b3$var$BACKGROUND_COLORS[i % $9d0943f78a3e28b3$var$BACKGROUND_COLORS.length];
}
function $9d0943f78a3e28b3$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $9d0943f78a3e28b3$var$getBorderColor(i);
    dataset.backgroundColor = $9d0943f78a3e28b3$var$getBackgroundColor(i);
    return ++i;
}
function $9d0943f78a3e28b3$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$9d0943f78a3e28b3$var$getBorderColor(i++));
    return i;
}
function $9d0943f78a3e28b3$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$9d0943f78a3e28b3$var$getBackgroundColor(i++));
    return i;
}
function $9d0943f78a3e28b3$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $9d0943f78a3e28b3$export$e04603e7d8b77172) i = $9d0943f78a3e28b3$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $9d0943f78a3e28b3$export$2a270b3a0d973c85) i = $9d0943f78a3e28b3$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $9d0943f78a3e28b3$var$colorizeDefaultDataset(dataset, i);
    };
}
function $9d0943f78a3e28b3$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $9d0943f78a3e28b3$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $9d0943f78a3e28b3$var$containsDefaultColorsDefenitions() {
    return (0, $db48ff1d57c620ad$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $db48ff1d57c620ad$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $9d0943f78a3e28b3$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $9d0943f78a3e28b3$var$containsColorsDefinitions(datasets) || $9d0943f78a3e28b3$var$containsColorsDefinition(chartOptions) || elements && $9d0943f78a3e28b3$var$containsColorsDefinitions(elements) || $9d0943f78a3e28b3$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $9d0943f78a3e28b3$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $9d0943f78a3e28b3$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $9d0943f78a3e28b3$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(minIndex) && !(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $9d0943f78a3e28b3$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $9d0943f78a3e28b3$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $9d0943f78a3e28b3$var$cleanDecimatedDataset(dataset);
    });
}
function $9d0943f78a3e28b3$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $db48ff1d57c620ad$export$25ce5a424b770e84)((0, $db48ff1d57c620ad$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $db48ff1d57c620ad$export$25ce5a424b770e84)((0, $db48ff1d57c620ad$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $9d0943f78a3e28b3$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $9d0943f78a3e28b3$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $db48ff1d57c620ad$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $9d0943f78a3e28b3$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $9d0943f78a3e28b3$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $9d0943f78a3e28b3$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $9d0943f78a3e28b3$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $9d0943f78a3e28b3$var$cleanDecimatedData(chart);
    }
};
function $9d0943f78a3e28b3$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $9d0943f78a3e28b3$var$_findSegmentEnd(start, end, points);
        const bounds = $9d0943f78a3e28b3$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $db48ff1d57c620ad$export$2f6ca3d3b1f80bf5)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $9d0943f78a3e28b3$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $db48ff1d57c620ad$export$3d12bd131bb975d1)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $9d0943f78a3e28b3$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $9d0943f78a3e28b3$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $9d0943f78a3e28b3$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $db48ff1d57c620ad$export$ab83b03e4111b1d0)(start);
        end = (0, $db48ff1d57c620ad$export$ab83b03e4111b1d0)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $9d0943f78a3e28b3$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $9d0943f78a3e28b3$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $9d0943f78a3e28b3$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $9d0943f78a3e28b3$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $9d0943f78a3e28b3$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $9d0943f78a3e28b3$var$_pointsFromSegments(boundary, line);
    return points.length ? new $9d0943f78a3e28b3$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $9d0943f78a3e28b3$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $9d0943f78a3e28b3$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $db48ff1d57c620ad$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $9d0943f78a3e28b3$var$_decodeFill(line, index, count) {
    const fill = $9d0943f78a3e28b3$var$parseFillOption(line);
    if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $db48ff1d57c620ad$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $9d0943f78a3e28b3$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $9d0943f78a3e28b3$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $9d0943f78a3e28b3$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $9d0943f78a3e28b3$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $9d0943f78a3e28b3$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $9d0943f78a3e28b3$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $9d0943f78a3e28b3$var$getLinesBelow(scale, index);
    linesBelow.push($9d0943f78a3e28b3$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$9d0943f78a3e28b3$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $9d0943f78a3e28b3$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $9d0943f78a3e28b3$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $9d0943f78a3e28b3$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $9d0943f78a3e28b3$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $9d0943f78a3e28b3$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $db48ff1d57c620ad$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $9d0943f78a3e28b3$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $db48ff1d57c620ad$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $9d0943f78a3e28b3$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $db48ff1d57c620ad$export$39b482c5e57630a8)(fill)) return $9d0943f78a3e28b3$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $9d0943f78a3e28b3$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $9d0943f78a3e28b3$var$computeBoundary(source);
    if (boundary instanceof $9d0943f78a3e28b3$var$simpleArc) return boundary;
    return $9d0943f78a3e28b3$var$_createBoundaryLine(boundary, line);
}
function $9d0943f78a3e28b3$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $9d0943f78a3e28b3$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $9d0943f78a3e28b3$var$computeCircularBoundary(source);
    return $9d0943f78a3e28b3$var$computeLinearBoundary(source);
}
function $9d0943f78a3e28b3$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $9d0943f78a3e28b3$var$_getTargetPixel(fill, scale);
    if ((0, $db48ff1d57c620ad$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $9d0943f78a3e28b3$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $9d0943f78a3e28b3$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $9d0943f78a3e28b3$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $9d0943f78a3e28b3$var$_drawfill(ctx, source, area) {
    const target = $9d0943f78a3e28b3$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $db48ff1d57c620ad$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $db48ff1d57c620ad$export$8743009a87fcb00f)(ctx, area);
        $9d0943f78a3e28b3$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $db48ff1d57c620ad$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $9d0943f78a3e28b3$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $9d0943f78a3e28b3$var$clipVertical(ctx, target, area.top);
            $9d0943f78a3e28b3$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $9d0943f78a3e28b3$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $9d0943f78a3e28b3$var$clipHorizontal(ctx, target, area.left);
            $9d0943f78a3e28b3$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $9d0943f78a3e28b3$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $9d0943f78a3e28b3$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $9d0943f78a3e28b3$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$9d0943f78a3e28b3$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $9d0943f78a3e28b3$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$9d0943f78a3e28b3$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $9d0943f78a3e28b3$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $9d0943f78a3e28b3$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $9d0943f78a3e28b3$var$clipBounds(ctx, scale, clip, notShape && $9d0943f78a3e28b3$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $9d0943f78a3e28b3$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $9d0943f78a3e28b3$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $9d0943f78a3e28b3$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $9d0943f78a3e28b3$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $9d0943f78a3e28b3$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $9d0943f78a3e28b3$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $9d0943f78a3e28b3$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $9d0943f78a3e28b3$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $9d0943f78a3e28b3$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($9d0943f78a3e28b3$var$_shouldApplyFill(source)) $9d0943f78a3e28b3$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$9d0943f78a3e28b3$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $9d0943f78a3e28b3$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $9d0943f78a3e28b3$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $9d0943f78a3e28b3$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $9d0943f78a3e28b3$var$Legend extends $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $9d0943f78a3e28b3$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $9d0943f78a3e28b3$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $db48ff1d57c620ad$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $db48ff1d57c620ad$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $db48ff1d57c620ad$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $db48ff1d57c620ad$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $db48ff1d57c620ad$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $9d0943f78a3e28b3$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $db48ff1d57c620ad$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $db48ff1d57c620ad$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $db48ff1d57c620ad$export$28f7fcd39efa255)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $db48ff1d57c620ad$export$92108d983e8ee699)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $db48ff1d57c620ad$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $db48ff1d57c620ad$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $db48ff1d57c620ad$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $9d0943f78a3e28b3$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $db48ff1d57c620ad$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $db48ff1d57c620ad$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $db48ff1d57c620ad$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $db48ff1d57c620ad$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $db48ff1d57c620ad$export$21579262ef46735b)(x, this.left, this.right) && (0, $db48ff1d57c620ad$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $db48ff1d57c620ad$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $db48ff1d57c620ad$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$9d0943f78a3e28b3$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $9d0943f78a3e28b3$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $9d0943f78a3e28b3$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $9d0943f78a3e28b3$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $9d0943f78a3e28b3$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $9d0943f78a3e28b3$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $9d0943f78a3e28b3$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $9d0943f78a3e28b3$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $9d0943f78a3e28b3$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $9d0943f78a3e28b3$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $9d0943f78a3e28b3$export$ed247974535929c7 = {
    id: 'legend',
    _element: $9d0943f78a3e28b3$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $9d0943f78a3e28b3$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $9d0943f78a3e28b3$var$Title extends $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $db48ff1d57c620ad$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $db48ff1d57c620ad$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $db48ff1d57c620ad$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $db48ff1d57c620ad$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $db48ff1d57c620ad$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $9d0943f78a3e28b3$var$createTitle(chart, titleOpts) {
    const title = new $9d0943f78a3e28b3$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $9d0943f78a3e28b3$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $9d0943f78a3e28b3$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $9d0943f78a3e28b3$export$f99233281efd08a0 = {
    id: 'title',
    _element: $9d0943f78a3e28b3$var$Title,
    start (chart, _args, options) {
        $9d0943f78a3e28b3$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $9d0943f78a3e28b3$var$map = new WeakMap();
var $9d0943f78a3e28b3$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $9d0943f78a3e28b3$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.configure(chart, title, options);
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.addBox(chart, title);
        $9d0943f78a3e28b3$var$map.set(chart, title);
    },
    stop (chart) {
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.removeBox(chart, $9d0943f78a3e28b3$var$map.get(chart));
        $9d0943f78a3e28b3$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $9d0943f78a3e28b3$var$map.get(chart);
        $9d0943f78a3e28b3$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $9d0943f78a3e28b3$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $db48ff1d57c620ad$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $9d0943f78a3e28b3$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $9d0943f78a3e28b3$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $9d0943f78a3e28b3$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $9d0943f78a3e28b3$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $db48ff1d57c620ad$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $db48ff1d57c620ad$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $db48ff1d57c620ad$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $db48ff1d57c620ad$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $db48ff1d57c620ad$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $db48ff1d57c620ad$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $db48ff1d57c620ad$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $9d0943f78a3e28b3$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $9d0943f78a3e28b3$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $9d0943f78a3e28b3$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($9d0943f78a3e28b3$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $9d0943f78a3e28b3$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $9d0943f78a3e28b3$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $9d0943f78a3e28b3$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $9d0943f78a3e28b3$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $9d0943f78a3e28b3$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $9d0943f78a3e28b3$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $db48ff1d57c620ad$export$28f7fcd39efa255)(cornerRadius);
    let x = $9d0943f78a3e28b3$var$alignX(size, xAlign);
    const y = $9d0943f78a3e28b3$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $9d0943f78a3e28b3$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $9d0943f78a3e28b3$var$getBeforeAfterBodyLines(callback) {
    return $9d0943f78a3e28b3$var$pushOrConcat([], $9d0943f78a3e28b3$var$splitNewlines(callback));
}
function $9d0943f78a3e28b3$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $db48ff1d57c620ad$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $9d0943f78a3e28b3$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $9d0943f78a3e28b3$var$defaultCallbacks = {
    beforeTitle: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346),
    beforeBody: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346),
    beforeLabel: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346),
    afterBody: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346),
    beforeFooter: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346),
    footer: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346),
    afterFooter: (0, $db48ff1d57c620ad$export$53a70dd1ebbae346)
};
function $9d0943f78a3e28b3$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $9d0943f78a3e28b3$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $9d0943f78a3e28b3$var$Tooltip extends $9d0943f78a3e28b3$export$db77ccec0bb4ccac {
    static positioners = $9d0943f78a3e28b3$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $9d0943f78a3e28b3$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $9d0943f78a3e28b3$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $9d0943f78a3e28b3$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $9d0943f78a3e28b3$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $9d0943f78a3e28b3$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $9d0943f78a3e28b3$var$pushOrConcat(lines, $9d0943f78a3e28b3$var$splitNewlines(beforeTitle));
        lines = $9d0943f78a3e28b3$var$pushOrConcat(lines, $9d0943f78a3e28b3$var$splitNewlines(title));
        lines = $9d0943f78a3e28b3$var$pushOrConcat(lines, $9d0943f78a3e28b3$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $9d0943f78a3e28b3$var$getBeforeAfterBodyLines($9d0943f78a3e28b3$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $db48ff1d57c620ad$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $9d0943f78a3e28b3$var$overrideCallbacks(callbacks, context);
            $9d0943f78a3e28b3$var$pushOrConcat(bodyItem.before, $9d0943f78a3e28b3$var$splitNewlines($9d0943f78a3e28b3$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $9d0943f78a3e28b3$var$pushOrConcat(bodyItem.lines, $9d0943f78a3e28b3$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $9d0943f78a3e28b3$var$pushOrConcat(bodyItem.after, $9d0943f78a3e28b3$var$splitNewlines($9d0943f78a3e28b3$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $9d0943f78a3e28b3$var$getBeforeAfterBodyLines($9d0943f78a3e28b3$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $9d0943f78a3e28b3$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $9d0943f78a3e28b3$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $9d0943f78a3e28b3$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $9d0943f78a3e28b3$var$pushOrConcat(lines, $9d0943f78a3e28b3$var$splitNewlines(beforeFooter));
        lines = $9d0943f78a3e28b3$var$pushOrConcat(lines, $9d0943f78a3e28b3$var$splitNewlines(footer));
        lines = $9d0943f78a3e28b3$var$pushOrConcat(lines, $9d0943f78a3e28b3$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($9d0943f78a3e28b3$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $db48ff1d57c620ad$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $9d0943f78a3e28b3$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($9d0943f78a3e28b3$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($9d0943f78a3e28b3$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($9d0943f78a3e28b3$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $9d0943f78a3e28b3$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $9d0943f78a3e28b3$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $9d0943f78a3e28b3$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $9d0943f78a3e28b3$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $db48ff1d57c620ad$export$28f7fcd39efa255)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $db48ff1d57c620ad$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $9d0943f78a3e28b3$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(options.bodyFont);
        const colorX = $9d0943f78a3e28b3$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $db48ff1d57c620ad$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $db48ff1d57c620ad$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $db48ff1d57c620ad$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $db48ff1d57c620ad$export$28f7fcd39efa255)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $db48ff1d57c620ad$export$92108d983e8ee699)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $db48ff1d57c620ad$export$92108d983e8ee699)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $db48ff1d57c620ad$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $9d0943f78a3e28b3$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $db48ff1d57c620ad$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $db48ff1d57c620ad$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $db48ff1d57c620ad$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $db48ff1d57c620ad$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $db48ff1d57c620ad$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $9d0943f78a3e28b3$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $db48ff1d57c620ad$export$28f7fcd39efa255)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $9d0943f78a3e28b3$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $9d0943f78a3e28b3$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $9d0943f78a3e28b3$var$determineAlignment(chart, options, positionAndSize);
            const point = $9d0943f78a3e28b3$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $db48ff1d57c620ad$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $db48ff1d57c620ad$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $db48ff1d57c620ad$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $db48ff1d57c620ad$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $9d0943f78a3e28b3$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $9d0943f78a3e28b3$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $9d0943f78a3e28b3$var$Tooltip,
    positioners: $9d0943f78a3e28b3$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $9d0943f78a3e28b3$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $9d0943f78a3e28b3$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $9d0943f78a3e28b3$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $9d0943f78a3e28b3$export$c537fa0d021d010b,
    Decimation: $9d0943f78a3e28b3$export$be17f937e9aa7533,
    Filler: $9d0943f78a3e28b3$export$d19ba4d812bed757,
    Legend: $9d0943f78a3e28b3$export$ed247974535929c7,
    SubTitle: $9d0943f78a3e28b3$export$d5c56664638992a4,
    Title: $9d0943f78a3e28b3$export$f99233281efd08a0,
    Tooltip: $9d0943f78a3e28b3$export$28c660c63b792dea
});
const $9d0943f78a3e28b3$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $9d0943f78a3e28b3$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $9d0943f78a3e28b3$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $9d0943f78a3e28b3$var$validIndex = (index, max)=>index === null ? null : (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $9d0943f78a3e28b3$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $9d0943f78a3e28b3$export$29e663ba4d09fe7 extends $9d0943f78a3e28b3$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $9d0943f78a3e28b3$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $9d0943f78a3e28b3$var$findOrAddLabel(labels, raw, (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $9d0943f78a3e28b3$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $9d0943f78a3e28b3$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $9d0943f78a3e28b3$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $db48ff1d57c620ad$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $db48ff1d57c620ad$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $db48ff1d57c620ad$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $db48ff1d57c620ad$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $db48ff1d57c620ad$export$91477dc880baac21)(spacing), (0, $db48ff1d57c620ad$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $db48ff1d57c620ad$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $db48ff1d57c620ad$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $9d0943f78a3e28b3$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $db48ff1d57c620ad$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $9d0943f78a3e28b3$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $9d0943f78a3e28b3$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $9d0943f78a3e28b3$var$LinearScaleBase extends $9d0943f78a3e28b3$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $db48ff1d57c620ad$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $db48ff1d57c620ad$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $9d0943f78a3e28b3$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $db48ff1d57c620ad$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $db48ff1d57c620ad$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $9d0943f78a3e28b3$export$e7f4e5e8656f0b93 extends $9d0943f78a3e28b3$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $db48ff1d57c620ad$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $9d0943f78a3e28b3$var$log10Floor = (v)=>Math.floor((0, $db48ff1d57c620ad$export$faec65b429be379)(v));
const $9d0943f78a3e28b3$var$changeExponent = (v, m)=>Math.pow(10, $9d0943f78a3e28b3$var$log10Floor(v) + m);
function $9d0943f78a3e28b3$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $9d0943f78a3e28b3$var$log10Floor(tickVal));
    return remain === 1;
}
function $9d0943f78a3e28b3$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $9d0943f78a3e28b3$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $9d0943f78a3e28b3$var$log10Floor(range);
    while($9d0943f78a3e28b3$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($9d0943f78a3e28b3$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $9d0943f78a3e28b3$var$log10Floor(min));
}
function $9d0943f78a3e28b3$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $9d0943f78a3e28b3$var$log10Floor(min);
    let exp = $9d0943f78a3e28b3$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $9d0943f78a3e28b3$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $db48ff1d57c620ad$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $9d0943f78a3e28b3$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $9d0943f78a3e28b3$export$85295eaf7cb3ac3e extends $9d0943f78a3e28b3$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $db48ff1d57c620ad$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $9d0943f78a3e28b3$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $db48ff1d57c620ad$export$39b482c5e57630a8)(this._userMin)) this.min = min === $9d0943f78a3e28b3$var$changeExponent(this.min, 0) ? $9d0943f78a3e28b3$var$changeExponent(this.min, -1) : $9d0943f78a3e28b3$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($9d0943f78a3e28b3$var$changeExponent(min, -1));
                setMax($9d0943f78a3e28b3$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($9d0943f78a3e28b3$var$changeExponent(max, -1));
        if (max <= 0) setMax($9d0943f78a3e28b3$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $9d0943f78a3e28b3$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $db48ff1d57c620ad$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $db48ff1d57c620ad$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $db48ff1d57c620ad$export$faec65b429be379)(start);
        this._valueRange = (0, $db48ff1d57c620ad$export$faec65b429be379)(this.max) - (0, $db48ff1d57c620ad$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $db48ff1d57c620ad$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $9d0943f78a3e28b3$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $db48ff1d57c620ad$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $9d0943f78a3e28b3$var$measureLabelSize(ctx, font, label) {
    label = (0, $db48ff1d57c620ad$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $db48ff1d57c620ad$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $9d0943f78a3e28b3$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $9d0943f78a3e28b3$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(opts.font);
        const textSize = $9d0943f78a3e28b3$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $db48ff1d57c620ad$export$ab83b03e4111b1d0)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $db48ff1d57c620ad$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $9d0943f78a3e28b3$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $9d0943f78a3e28b3$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $9d0943f78a3e28b3$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $9d0943f78a3e28b3$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $9d0943f78a3e28b3$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $9d0943f78a3e28b3$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $db48ff1d57c620ad$export$3a6d5c9ae78a2c08)((0, $db48ff1d57c620ad$export$ab83b03e4111b1d0)(pointLabelPosition.angle + (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd))));
    const y = $9d0943f78a3e28b3$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $9d0943f78a3e28b3$var$getTextAlignForAngle(angle);
    const left = $9d0943f78a3e28b3$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $9d0943f78a3e28b3$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $db48ff1d57c620ad$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $db48ff1d57c620ad$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $db48ff1d57c620ad$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $db48ff1d57c620ad$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $9d0943f78a3e28b3$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $9d0943f78a3e28b3$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $db48ff1d57c620ad$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $9d0943f78a3e28b3$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $9d0943f78a3e28b3$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $9d0943f78a3e28b3$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $9d0943f78a3e28b3$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $9d0943f78a3e28b3$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $9d0943f78a3e28b3$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $db48ff1d57c620ad$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $db48ff1d57c620ad$export$28f7fcd39efa255)(opts.borderRadius);
        const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $db48ff1d57c620ad$export$92108d983e8ee699)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $9d0943f78a3e28b3$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $9d0943f78a3e28b3$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $db48ff1d57c620ad$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $9d0943f78a3e28b3$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $db48ff1d57c620ad$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $9d0943f78a3e28b3$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $9d0943f78a3e28b3$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $9d0943f78a3e28b3$var$createPointLabelContext(parent, index, label) {
    return (0, $db48ff1d57c620ad$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $9d0943f78a3e28b3$export$cfafc36d95386d38 extends $9d0943f78a3e28b3$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $db48ff1d57c620ad$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)($9d0943f78a3e28b3$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $9d0943f78a3e28b3$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $9d0943f78a3e28b3$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $9d0943f78a3e28b3$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $db48ff1d57c620ad$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $db48ff1d57c620ad$export$ab83b03e4111b1d0)(index * angleMultiplier + (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $9d0943f78a3e28b3$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $db48ff1d57c620ad$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $9d0943f78a3e28b3$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $9d0943f78a3e28b3$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $9d0943f78a3e28b3$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $db48ff1d57c620ad$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $db48ff1d57c620ad$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $db48ff1d57c620ad$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $9d0943f78a3e28b3$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $9d0943f78a3e28b3$var$UNITS = /* #__PURE__ */ Object.keys($9d0943f78a3e28b3$var$INTERVALS);
function $9d0943f78a3e28b3$var$sorter(a, b) {
    return a - b;
}
function $9d0943f78a3e28b3$var$parse(scale, input) {
    if ((0, $db48ff1d57c620ad$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $db48ff1d57c620ad$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $db48ff1d57c620ad$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $9d0943f78a3e28b3$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $9d0943f78a3e28b3$var$UNITS.length;
    for(let i = $9d0943f78a3e28b3$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $9d0943f78a3e28b3$var$INTERVALS[$9d0943f78a3e28b3$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $9d0943f78a3e28b3$var$UNITS[i];
    }
    return $9d0943f78a3e28b3$var$UNITS[ilen - 1];
}
function $9d0943f78a3e28b3$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $9d0943f78a3e28b3$var$UNITS.length - 1; i >= $9d0943f78a3e28b3$var$UNITS.indexOf(minUnit); i--){
        const unit = $9d0943f78a3e28b3$var$UNITS[i];
        if ($9d0943f78a3e28b3$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $9d0943f78a3e28b3$var$UNITS[minUnit ? $9d0943f78a3e28b3$var$UNITS.indexOf(minUnit) : 0];
}
function $9d0943f78a3e28b3$var$determineMajorUnit(unit) {
    for(let i = $9d0943f78a3e28b3$var$UNITS.indexOf(unit) + 1, ilen = $9d0943f78a3e28b3$var$UNITS.length; i < ilen; ++i){
        if ($9d0943f78a3e28b3$var$INTERVALS[$9d0943f78a3e28b3$var$UNITS[i]].common) return $9d0943f78a3e28b3$var$UNITS[i];
    }
}
function $9d0943f78a3e28b3$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $db48ff1d57c620ad$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $9d0943f78a3e28b3$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $9d0943f78a3e28b3$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $9d0943f78a3e28b3$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $9d0943f78a3e28b3$export$a894c72689ff3ec extends $9d0943f78a3e28b3$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $9d0943f78a3e28b3$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $db48ff1d57c620ad$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $9d0943f78a3e28b3$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $db48ff1d57c620ad$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $db48ff1d57c620ad$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $9d0943f78a3e28b3$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $9d0943f78a3e28b3$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $9d0943f78a3e28b3$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $9d0943f78a3e28b3$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $db48ff1d57c620ad$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $9d0943f78a3e28b3$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $db48ff1d57c620ad$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $db48ff1d57c620ad$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$9d0943f78a3e28b3$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $9d0943f78a3e28b3$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($9d0943f78a3e28b3$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $db48ff1d57c620ad$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $db48ff1d57c620ad$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $9d0943f78a3e28b3$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($9d0943f78a3e28b3$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $db48ff1d57c620ad$export$71511d61b312f219)(values.sort($9d0943f78a3e28b3$var$sorter));
    }
}
function $9d0943f78a3e28b3$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $db48ff1d57c620ad$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $db48ff1d57c620ad$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $9d0943f78a3e28b3$export$85df64a8eb6dc986 extends $9d0943f78a3e28b3$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $9d0943f78a3e28b3$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $9d0943f78a3e28b3$var$interpolate(table, this.min);
        this._tableRange = $9d0943f78a3e28b3$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($9d0943f78a3e28b3$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $9d0943f78a3e28b3$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $9d0943f78a3e28b3$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $9d0943f78a3e28b3$export$29e663ba4d09fe7,
    LinearScale: $9d0943f78a3e28b3$export$e7f4e5e8656f0b93,
    LogarithmicScale: $9d0943f78a3e28b3$export$85295eaf7cb3ac3e,
    RadialLinearScale: $9d0943f78a3e28b3$export$cfafc36d95386d38,
    TimeScale: $9d0943f78a3e28b3$export$a894c72689ff3ec,
    TimeSeriesScale: $9d0943f78a3e28b3$export$85df64a8eb6dc986
});
const $9d0943f78a3e28b3$export$e8959e79e3af550f = [
    $9d0943f78a3e28b3$export$a6506504f799c5d5,
    $9d0943f78a3e28b3$export$7a5d735b2ab6389d,
    $9d0943f78a3e28b3$export$8b3ca321c77fdea6,
    $9d0943f78a3e28b3$export$bcac1c16f1530ec2
];


(0, $9d0943f78a3e28b3$export$acaa6426d77a227e).register(...(0, $9d0943f78a3e28b3$export$e8959e79e3af550f));
var $47b57244afc354a9$export$2e2bcd8739ae039 = (0, $9d0943f78a3e28b3$export$acaa6426d77a227e);


function $1aedc2c2e170aecf$var$cssVar(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
function $1aedc2c2e170aecf$var$withAlpha(color, alpha) {
    const match = color.match(/rgba?\(([^)]+)\)/i);
    if (!match) return color;
    const [r, g, b] = match[1].split(",").map((part)=>part.trim());
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
class $1aedc2c2e170aecf$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "container"
    ];
    initialize() {
        const revenueData = JSON.parse(this.containerTarget.dataset.revenueData);
        const labels = revenueData.map((data)=>data.date);
        const revenueValues = revenueData.map((data)=>data.revenue);
        const formatType = this.containerTarget.dataset.chartFormatType || "currency";
        // If a chart already exists, remove it.
        const previousChart = this.containerTarget.getElementsByTagName("canvas")[0];
        if (previousChart) previousChart.parentElement.removeChild(previousChart);
        this.generateChart(labels, revenueValues, formatType);
    }
    generateChart(labels, revenueValues, formatType = "currency") {
        const line = $1aedc2c2e170aecf$var$cssVar("--thm-dashboard-chart-line");
        const shade1 = $1aedc2c2e170aecf$var$cssVar("--thm-dashboard-chart-shade1");
        const shade2 = $1aedc2c2e170aecf$var$cssVar("--thm-dashboard-chart-shade2");
        const dot = $1aedc2c2e170aecf$var$cssVar("--thm-dashboard-chart-dot");
        const text = $1aedc2c2e170aecf$var$cssVar("--thm-dashboard-chart-text");
        const subText = $1aedc2c2e170aecf$var$cssVar("--thm-dashboard-chart-sub-text");
        const box = $1aedc2c2e170aecf$var$cssVar("--thm-dashboard-chart-box");
        const canvas = document.createElement("canvas");
        canvas.classList.add("w-full", "h-[260px]", "xl:h-[310px]", "pr-3", "pt-2", "bg-thm-dashboard-chart-box", "border", "border-thm-dashboard-chart-box-border", "rounded-md");
        this.containerTarget.appendChild(canvas);
        new (0, $47b57244afc354a9$export$2e2bcd8739ae039)(canvas, {
            type: "line",
            data: {
                labels: labels,
                datasets: [
                    {
                        label: "Value",
                        data: revenueValues,
                        fill: true,
                        backgroundColor: (context)=>{
                            const ctx = context.chart.ctx;
                            const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                            gradient.addColorStop(0, $1aedc2c2e170aecf$var$withAlpha(shade1, 0.4));
                            gradient.addColorStop(0.55, $1aedc2c2e170aecf$var$withAlpha(shade1, 0.12));
                            gradient.addColorStop(1, shade2 || $1aedc2c2e170aecf$var$withAlpha(shade1, 0));
                            return gradient;
                        },
                        borderColor: line,
                        borderWidth: 2,
                        tension: 0.3,
                        pointRadius: 0,
                        pointHoverRadius: 4,
                        pointHoverBackgroundColor: dot,
                        pointHoverBorderColor: dot
                    }
                ]
            },
            options: {
                interaction: {
                    mode: "index",
                    intersect: false
                },
                scales: {
                    y: {
                        ticks: {
                            display: true,
                            maxTicksLimit: 4,
                            color: subText || text
                        },
                        grid: {
                            display: true,
                            color: $1aedc2c2e170aecf$var$withAlpha(line, 0.08),
                            drawBorder: false
                        },
                        border: {
                            width: 0
                        }
                    },
                    x: {
                        ticks: {
                            display: true,
                            maxTicksLimit: 4,
                            color: subText || text,
                            callback: function(value) {
                                const label = this.getLabelForValue(value);
                                const date = new Date(label);
                                if (isNaN(date.getTime())) return label;
                                const day = date.getDate();
                                const month = date.toLocaleString("default", {
                                    month: "short"
                                });
                                return `${day} ${month}`;
                            }
                        },
                        grid: {
                            display: false
                        },
                        border: {
                            width: 0
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: $1aedc2c2e170aecf$var$withAlpha(box, 0.85) || "rgba(0, 0, 0, 0.6)",
                        titleColor: line || text,
                        bodyColor: text || "#ffffff",
                        displayColors: false,
                        callbacks: {
                            title: function(tooltipItems) {
                                const label = tooltipItems[0].label;
                                const date = new Date(label);
                                if (isNaN(date.getTime())) return label;
                                const day = date.getDate();
                                const month = date.toLocaleString("default", {
                                    month: "short"
                                });
                                return `${day} ${month}`;
                            },
                            label: function(context) {
                                let label = context.dataset.label || "";
                                if (label) label += ": ";
                                if (context.parsed.y !== null) {
                                    if (formatType === "number") label += Math.round(context.parsed.y);
                                    else label += new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD"
                                    }).format(context.parsed.y);
                                }
                                return label;
                            }
                        }
                    }
                },
                layout: {
                    padding: 0
                },
                maintainAspectRatio: false
            }
        });
    }
}



class $4619a6b19a4dfd26$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        "input"
    ];
    connect() {
        window.addEventListener("keyup", this.keyHandler);
    }
    disconnect() {
        window.removeEventListener("keyup", this.keyHandler);
    }
    keyHandler = (event)=>{
        // numbers 0–9
        if (/^[0-9]$/.test(event.key)) this.addDigit(event.key);
        // backspace or delete
        if (event.key === "Backspace" || event.key === "Delete") this.backspace();
        // enter
        if (event.key === "Enter") this.submit();
    };
    add(event) {
        const digit = event.currentTarget.dataset.digit;
        if (digit) this.addDigit(digit);
    }
    addDigit(digit) {
        if (!this.hasInputTarget) return;
        const maxLength = this.inputTarget.max > 0 ? this.inputTarget.max : Infinity;
        if (this.inputTarget.value.length < maxLength) {
            this.inputTarget.value += digit;
            this.inputTarget.dispatchEvent(new Event("input", {
                bubbles: true
            }));
        }
    }
    backspace() {
        if (this.hasInputTarget) {
            this.inputTarget.value = this.inputTarget.value.slice(0, -1);
            this.inputTarget.dispatchEvent(new Event("input", {
                bubbles: true
            }));
        }
    }
    submit() {}
}



// debugUtils.js
function $119e1f035e10ad30$export$140d7860bc6d1e6e(...args) {
    console.log(...args);
}
function $119e1f035e10ad30$export$280f90b954565303(...args) {
    console.error(...args);
}


function $532af2730d4f81d8$export$179f5d628a6b9050() {
    const iconLink = document.querySelector('link[rel~="icon"]');
    let url = window.location.host + '/favicon.ico';
    url = url.includes("localhost") ? 'http://' + url : url;
    url = url.startsWith("http") ? url : 'https://' + url;
    return iconLink ? iconLink.href : url;
}
function $532af2730d4f81d8$var$valueCheck(functionName, value, expectedValue) {
    if (typeof value !== expectedValue) throw new Error(`${functionName} function expected ${expectedValue} as one of its parameters.`);
}
function $532af2730d4f81d8$export$4e80b7f9eaacb389() {
    return window.location.host.includes("coinsub.io");
}
function $532af2730d4f81d8$export$6b814e5b0ae65c19(value) {
    const inputValue = Number(value);
    $532af2730d4f81d8$var$valueCheck('countDecimals', inputValue, 'number');
    if (Math.floor(value) !== value) return value.toString().split(".")[1].length || 0;
    return 0;
}
function $532af2730d4f81d8$export$2a9472a6b44892b6(url) {
    return url.endsWith('/') ? url.slice(0, -1) : url;
}
function $532af2730d4f81d8$export$ccf64f7f116a94f(seconds) {
    if (!seconds || seconds < 0 || typeof seconds !== 'number') return "0:00";
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec.toString().padStart(2, '0')}`;
}
function $532af2730d4f81d8$export$18148d12c805c5b0(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
function $532af2730d4f81d8$export$705595419525bb37(address) {
    // Ethereum address regex: 0x followed by 40 hexadecimal characters
    const ethereumAddressRegex = /^0x[a-fA-F0-9]{40}$/;
    return ethereumAddressRegex.test(address);
}
function $532af2730d4f81d8$export$61fc7d43ac8f84b0(fn, timeout = 300) {
    let timer;
    return (...args)=>{
        if (!timer) fn.apply(this, args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, timeout);
    };
}


function $8e62fb6183f499d0$export$8cc545829c7461b0(errorBody) {
    if (!errorBody) return "";
    const envelope = errorBody.error;
    if (envelope && typeof envelope === "object" && envelope.message) return envelope.message;
    if (errorBody.message) return errorBody.message;
    if (typeof envelope === "string") return envelope;
    return "";
}
// codedError builds an Error carrying the envelope's code and request id so
// callers can branch on error.code and quote error.requestId to support.
function $8e62fb6183f499d0$var$codedError(message, errorBody) {
    const err = new Error(message);
    const envelope = errorBody && errorBody.error;
    if (envelope && typeof envelope === "object") {
        err.code = envelope.code;
        err.details = envelope.details;
        err.requestId = envelope.request_id;
    }
    return err;
}
class $8e62fb6183f499d0$var$HttpService {
    replacer(key, value) {
        if (typeof value === 'bigint') return value.toString();
        return value;
    }
    async get(url) {
        try {
            const response = await fetch(url);
            return await this.processResponse(response);
        } catch (error) {
            // Handle or throw the error as needed
            (0, $119e1f035e10ad30$export$280f90b954565303)('GET request error:', error.message);
            throw error;
        }
    }
    async post(url, data) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data, this.replacer)
            });
            return await this.processResponse(response);
        } catch (error) {
            // Handle or throw the error as needed
            (0, $119e1f035e10ad30$export$280f90b954565303)('POST request error:', error.message);
            throw error;
        }
    }
    async postWithTimeout(url, data, timeout = 1000) {
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeout);
        try {
            const response = await fetch(url, {
                method: 'POST',
                signal: controller.signal,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            clearTimeout(timeoutId);
            return await this.processResponse(response);
        } catch (error) {
            clearTimeout(timeoutId);
            // Handle or throw the error as needed
            (0, $119e1f035e10ad30$export$280f90b954565303)('POST request with timeout error:', error.message);
            throw error;
        }
    }
    async processResponse(response) {
        if (!response.ok) {
            const errorBody = await response.json();
            if (errorBody.type && errorBody.type == "html") return errorBody; //sent html error back
            const errorMessage = $8e62fb6183f499d0$export$8cc545829c7461b0(errorBody) || 'Unknown error occurred';
            throw $8e62fb6183f499d0$var$codedError(errorMessage, errorBody);
        }
        return await response.json();
    }
}
const $8e62fb6183f499d0$var$httpService = new $8e62fb6183f499d0$var$HttpService();
var $8e62fb6183f499d0$export$2e2bcd8739ae039 = $8e62fb6183f499d0$var$httpService;




// Enable pusher logging - don't include this in production
(0, (/*@__PURE__*/$parcel$interopDefault($a624709dd034fdf4$exports))).logToConsole = true;
class $cab85b4bb5c4653b$var$ChannelService {
    constructor(){
        if (!$cab85b4bb5c4653b$var$ChannelService.instance) {
            this.channels = {};
            this.pusher = new (0, (/*@__PURE__*/$parcel$interopDefault($a624709dd034fdf4$exports)))("59f509846634364760ef", {
                cluster: "us2"
            });
            $cab85b4bb5c4653b$var$ChannelService.instance = this;
            this.connect();
        }
    }
    connect() {
        let channel = this.getCookie("channel");
        if (channel) this.subscribeToChannel("stream", channel);
    }
    getCookie(name) {
        let cookieArray = document.cookie.split(";"); // Split the cookie string into individual name=value pairs
        for (let cookie of cookieArray){
            let [cookieName, cookieValue] = cookie.split("="); // Split each pair into name and value
            cookieName = cookieName.trim(); // Trim whitespace from the cookie name
            if (cookieName === name) return decodeURIComponent(cookieValue); // Return the value of the cookie
        }
        return null; // Return null if the cookie is not found
    }
    subscribeToChannel(type, identifier) {
        const channelName = identifier;
        if (this.channels[channelName]) return; // Already subscribed
        this.unsubscribeFromChannel(type); // Unsubscribe from previous channel of the same type
        // Subscribe to new channel
        let channel = this.pusher.subscribe(channelName);
        channel.bind("html", async function(data) {
            Turbo.renderStreamMessage(data);
        });
        this.channels[type] = {
            name: channelName,
            channel: channel
        };
    }
    unsubscribeFromChannel(type) {
        const channelInfo = this.channels[type];
        if (channelInfo && channelInfo.channel) {
            channelInfo.channel.unbind_all();
            channelInfo.channel.unsubscribe();
            delete this.channels[type];
        }
    }
}
const $cab85b4bb5c4653b$var$instance = new $cab85b4bb5c4653b$var$ChannelService();
var $cab85b4bb5c4653b$export$2e2bcd8739ae039 = $cab85b4bb5c4653b$var$instance;


class $b4559be34d47b192$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static targets = [
        'pagination'
    ];
    static values = {
        id: String,
        turboID: String,
        current: Number,
        total: Number,
        link: String
    };
    initialize() {
        // Check if pagination have been generated already.
        // When using browser back function, event handlers will no longer work.
        // So, we need to remove and recreate it.
        const previouslyGenerated = this.paginationTarget.getElementsByTagName("ul").length !== 0;
        if (previouslyGenerated) this.paginationTarget.innerHTML = "";
        this.idValue = this.paginationTarget.getAttribute('id');
        this.turboIDValue = this.paginationTarget.dataset.turboid;
        this.currentValue = Number(this.paginationTarget.dataset.current);
        this.totalValue = Number(this.paginationTarget.dataset.total);
        this.linkValue = this.paginationTarget.dataset.link;
        this.boundClickHandler = this.paginationClickHandler.bind(this);
        if (this.idValue && this.turboIDValue && this.currentValue && this.totalValue && this.linkValue) this.generatePaginationElements();
        else throw new Error('Pagination component needs a unique id, turboID, link, current and total number of pages!');
    }
    generatePaginationElements() {
        // Generate Pagination array as items.
        const current = this.currentValue;
        const total = this.totalValue;
        if (total === 1) return [];
        const items = [];
        function addPaginationItem(item) {
            if (!items.includes(item)) items.push(item);
        }
        const thirdPrevious = current - 3;
        const secondPrevious = current - 2;
        const previous = current - 1;
        const next = current + 1;
        const secondNext = current + 2;
        const thirdNext = current + 3;
        addPaginationItem(1);
        if (thirdPrevious > 1) addPaginationItem(thirdPrevious);
        if (secondPrevious > 1) addPaginationItem(secondPrevious);
        if (previous > 1) addPaginationItem(previous);
        addPaginationItem(current);
        if (next < total) addPaginationItem(next);
        if (secondNext < total) addPaginationItem(secondNext);
        if (thirdNext < total) addPaginationItem(thirdNext);
        addPaginationItem(total);
        // Generate HTML Elements.
        const paginationList = document.createElement('ul');
        let paginationElement;
        let paginationLink;
        for(let i = 0; i < items.length; i++){
            paginationElement = document.createElement('li');
            if (this.currentValue === items[i]) paginationElement.classList.add('active');
            paginationLink = document.createElement('a');
            paginationLink.setAttribute('href', `${this.linkValue}${items[i]}`);
            paginationLink.textContent = items[i];
            paginationLink.addEventListener('click', this.boundClickHandler);
            paginationElement.appendChild(paginationLink);
            paginationList.appendChild(paginationElement);
        }
        this.paginationTarget.appendChild(paginationList);
    }
    async paginationClickHandler(event) {
        this.showSpinner();
        event.preventDefault(); // Prevent default href behavior when element is clicked
        // Switch active state to new button.
        const currentlyActiveElement = this.paginationTarget.getElementsByClassName("active")[0];
        currentlyActiveElement.classList.remove("active");
        event.target.parentElement.classList.add("active");
        // Update pagination data with new current value.
        this.currentValue = Number(event.target.textContent);
        const url = event.target.href; // Get the href attribute
        try {
            const res = await (0, $8e62fb6183f499d0$export$2e2bcd8739ae039).get(url);
            (0, $cab85b4bb5c4653b$export$2e2bcd8739ae039).connect();
            this.generateNewPagination();
            await Turbo.renderStreamMessage(res.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    showSpinner() {
        const ele = document.getElementById(this.turboIDValue);
        if (!ele) return;
        const rect = ele.getBoundingClientRect();
        const prevH = Math.max(Math.ceil(rect.height || ele.scrollHeight || 0), 40);
        ele.innerHTML = `
    <div class="flex items-center justify-center" style="height:${prevH}px">
      <span class="pagination-spinner"></span>
    </div>
  `;
    }
    generateNewPagination() {
        const paginationElements = this.paginationTarget.getElementsByTagName("a");
        for(let i = 0; i < paginationElements.length; i++)paginationElements[i].removeEventListener("click", this.boundClickHandler);
        this.paginationTarget.innerHTML = "";
        this.generatePaginationElements();
    }
}



// Never used "stable-coin" key for tooltip content?
const $0413d9b98d9dc7e3$var$tooltipContent = {
    'stable-coin': 'Supported Networks: Polygon, Ethereum.<br>Supported Tokens: USDC, USDT, PYUSD.'
};
class $0413d9b98d9dc7e3$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    showTooltip(event) {
        const tooltip = event.currentTarget.querySelector(".tooltip");
        if (tooltip) {
            tooltip.classList.remove("invisible", "opacity-0");
            tooltip.classList.add("opacity-100");
        }
    }
    hideTooltip(event) {
        const tooltip = event.currentTarget.querySelector(".tooltip");
        if (tooltip) {
            tooltip.classList.add("invisible", "opacity-0");
            tooltip.classList.remove("opacity-100");
        }
    }
    stopPropagation(event) {
        event.stopPropagation();
    }
    // Only the first branch arrives expanded. Rendering every branch's children
    // up front would pay the full query and payload cost to then hide most of it,
    // so the rest are fetched the first time they are opened and cached in the
    // DOM afterwards.
    async toggleGroup(event) {
        if (event.target.closest("a, button")) return;
        const row = event.currentTarget;
        const group = row.dataset.robustTableGroupParam;
        if (!group) return;
        const caret = row.querySelector("[data-branch-caret]");
        let rows = this.element.querySelectorAll(`tr[data-group="${group}"]`);
        if (!rows.length) {
            const src = row.dataset.robustTableSrcParam;
            if (!src || row.dataset.loading === "true") return;
            row.dataset.loading = "true";
            if (caret) caret.classList.add("opacity-30");
            try {
                const response = await fetch(src, {
                    headers: {
                        "X-Requested-With": "fetch"
                    }
                });
                if (!response.ok) throw new Error(`status ${response.status}`);
                // Inserts HTML rendered by our own same-origin endpoint, the same trust level as a Turbo Stream.
                row.insertAdjacentHTML("afterend", await response.text()); // nosemgrep: typescript.react.security.audit.react-unsanitized-method.react-unsanitized-method
            } catch (error) {
                return;
            } finally{
                row.dataset.loading = "false";
                if (caret) caret.classList.remove("opacity-30");
            }
            if (caret) caret.classList.add("rotate-180");
            return;
        }
        const opening = rows[0].hidden;
        if (opening) rows.forEach((sub)=>{
            sub.hidden = false;
        });
        else this.collapseBranch(group);
        if (caret) caret.classList.toggle("rotate-180", opening);
    }
    // Descendants live in their own groups, so hiding only the direct children
    // would leave grandchildren on screen under no visible parent. Their carets
    // are reset too, otherwise reopening the branch shows a collapsed row still
    // pointing down.
    collapseBranch(group) {
        this.element.querySelectorAll(`tr[data-group="${group}"]`).forEach((row)=>{
            row.hidden = true;
            const caret = row.querySelector("[data-branch-caret]");
            if (caret) caret.classList.remove("rotate-180");
            const child = row.dataset.robustTableGroupParam;
            if (child) this.collapseBranch(child);
        });
    }
    openRowLink(event) {
        // Buttons inside a row are their own action, never the row's. The ⋯ menu
        // renders its trigger and every item as a button, so without this a click
        // on "Refund payment" fires the action AND bubbles to here — the modal
        // opens and the row link immediately navigates the page out from under
        // it. toggleGroup already guards the same way.
        if (event.target.closest('a, button')) return;
        const url = event.currentTarget.dataset.robustTableUrlParam;
        if (url) window.location = url;
        else console.error("Row link URL not found on the clicked element.", event.currentTarget);
    }
    async fetchHref(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const href = button.dataset.href;
        if (!href) {
            console.error("Href not found on button element.", button);
            return;
        }
        const wasDisabled = button.disabled;
        button.disabled = true;
        try {
            const response = await fetch(href, {
                method: "GET"
            });
            const contentType = response.headers.get("Content-Type") || "";
            if (contentType.includes("turbo-stream")) {
                const html = await response.text();
                Turbo.renderStreamMessage(html);
            } else if (contentType.includes("application/json")) {
                const json = await response.json();
                Turbo.renderStreamMessage(json.data);
            }
        } catch (error) {
            console.error("Error fetching href:", error);
        } finally{
            if (!wasDisabled) button.disabled = false;
        }
    }
}



class $bb4058271b3865d4$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    connect() {
        this.observer = new MutationObserver(this.enforceLimit.bind(this));
        this.observer.observe(this.element, {
            childList: true
        });
        this.enforceLimit();
    }
    disconnect() {
        this.observer.disconnect();
    }
    /**
     * This is the single, robust function that enforces the display limit.
     * It is called automatically whenever a toast is added OR removed.
     */ enforceLimit() {
        const limit = this.getLimit();
        const allToasts = Array.from(this.element.children);
        allToasts.forEach((toast, index)=>{
            if (index < limit) toast.classList.remove('hidden');
            else toast.classList.add('hidden');
        });
    }
    /**
     * This action is called by a child `toast_controller` when it is removed.
     * We don't need custom logic here, because the MutationObserver
     * will detect the removal and call enforceLimit() for us.
     */ toastRemoved() {
        this.enforceLimit();
    }
    getLimit() {
        // Tailwind's `sm` breakpoint is 640px.
        return window.innerWidth < 640 ? 2 : 3;
    }
}



class $c44f5fce0f233066$export$2e2bcd8739ae039 extends (0, $ffdf60ebf0144301$export$bd0bf19f25da8474) {
    static values = {
        duration: Number,
        redirectUrl: String,
        redirectDelay: Number,
        redirectAction: {
            type: String,
            default: "replace"
        },
        matchPath: Boolean
    };
    connect() {
        this.hideTimer = null;
        this.startX = 0;
        this.currentX = 0;
        this.isDragging = false;
        this.startHideTimer();
        this.startRedirectTimer();
        this.element.addEventListener("mouseenter", this.pauseHideTimer.bind(this));
        this.element.addEventListener("mouseleave", this.startHideTimer.bind(this));
        this.element.addEventListener("focusin", this.pauseHideTimer.bind(this));
        this.element.addEventListener("focusout", this.startHideTimer.bind(this));
        this.element.addEventListener("touchstart", this.dragStart.bind(this), {
            passive: true
        });
        this.element.addEventListener("touchmove", this.drag.bind(this), {
            passive: true
        });
        this.element.addEventListener("touchend", this.dragEnd.bind(this));
    }
    disconnect() {
        this.pauseHideTimer();
        clearTimeout(this.redirectTimer);
    }
    close() {
        this.pauseHideTimer();
        clearTimeout(this.redirectTimer);
        this.element.style.opacity = "0";
        const swipeDistance = this.currentX - this.startX;
        const direction = swipeDistance === 0 ? -1 : Math.sign(swipeDistance);
        this.element.style.transform = `translateX(${direction * 100}%)`;
        setTimeout(()=>{
            if (this.element && this.element.parentNode) this.element.remove();
        }, 300);
    }
    startHideTimer() {
        if (this.durationValue === 0) return;
        this.hideTimer = setTimeout(()=>{
            this.close();
        }, this.durationValue);
    }
    pauseHideTimer() {
        clearTimeout(this.hideTimer);
    }
    dragStart(event) {
        if (event.touches.length !== 1) return;
        this.isDragging = true;
        this.startX = event.touches[0].pageX;
        this.element.style.transition = "none";
    }
    drag(event) {
        if (!this.isDragging || event.touches.length !== 1) return;
        this.currentX = event.touches[0].pageX;
        const diff = this.currentX - this.startX;
        this.element.style.transform = `translateX(${diff}px)`;
    }
    dragEnd(event) {
        if (!this.isDragging) return;
        this.isDragging = false;
        const swipeThreshold = this.element.offsetWidth / 3;
        const diff = this.currentX - this.startX;
        if (Math.abs(diff) > swipeThreshold) this.close();
        else this.element.style.transform = "translateX(0px)";
    }
    startRedirectTimer() {
        if (!this.hasRedirectUrlValue) return;
        const delay = this.hasRedirectDelayValue ? this.redirectDelayValue : 1200;
        this.redirectTimer = setTimeout(()=>this.performRedirect(), delay);
    }
    performRedirect() {
        if (this.hasMatchPathValue && this.matchPathValue) {
            const currentPath = window.location.pathname.replace(/\/$/, "");
            const targetPath = this.redirectUrlValue.replace(/\/$/, "");
            if (currentPath !== targetPath) {
                console.log(`Path mismatch: staying on ${currentPath}`);
                return;
            }
        }
        this.close();
        if (window.Turbo?.visit) Turbo.visit(this.redirectUrlValue, {
            action: this.redirectActionValue
        });
        else // Fallback for non-turbo environments
        if (this.redirectActionValue === "replace") window.location.replace(this.redirectUrlValue);
        else window.location.assign(this.redirectUrlValue);
    }
}


var $35330220eba1dfe5$export$2e2bcd8739ae039 = [
    {
        name: "ActivityDetailsController",
        controller: (0, $0fe7b0a7d9b54c4f$export$2e2bcd8739ae039)
    },
    {
        name: "BottomSheetController",
        controller: (0, $0d2393a740ce2a5b$export$2e2bcd8739ae039)
    },
    {
        name: "CopyController",
        controller: (0, $2de639c5274864bf$export$2e2bcd8739ae039)
    },
    {
        name: "MenuController",
        controller: (0, $09dac291a2d3c419$export$2e2bcd8739ae039)
    },
    {
        name: "NoteLimitController",
        controller: (0, $d44da964cbbc9d19$export$2e2bcd8739ae039)
    },
    {
        name: "NotificationController",
        controller: (0, $2a866666cc7fe055$export$2e2bcd8739ae039)
    },
    {
        name: "PinController",
        controller: (0, $dfa73c3fc15fa86c$export$2e2bcd8739ae039)
    },
    {
        name: "ProcessTransferController",
        controller: (0, $48e235641eb2db9b$export$2e2bcd8739ae039)
    },
    {
        name: "PullToRefreshController",
        controller: (0, $67507a6d7a4c301d$export$2e2bcd8739ae039)
    },
    {
        name: "PwaController",
        controller: (0, $40a841ce98f90850$export$2e2bcd8739ae039)
    },
    {
        name: "PwaOpenerController",
        controller: (0, $fd1e3425a7cbbc5e$export$2e2bcd8739ae039)
    },
    {
        name: "QRCodeController",
        controller: (0, $e64d571cb2472c1b$export$2e2bcd8739ae039)
    },
    {
        name: "QrToggleController",
        controller: (0, $bd07b205d506109d$export$2e2bcd8739ae039)
    },
    {
        name: "SessionController",
        controller: (0, $489688dce298f7de$export$2e2bcd8739ae039)
    },
    {
        name: "SocketController",
        controller: (0, $d07f5c1731eecae9$export$2e2bcd8739ae039)
    },
    {
        name: "TransactionHistoryController",
        controller: (0, $90bb119766fab176$export$2e2bcd8739ae039)
    },
    {
        name: "WebviewController",
        controller: (0, $35747c473823bd1b$export$2e2bcd8739ae039)
    },
    {
        name: "actionDispatchController",
        controller: (0, $1fafb405e7e64de4$export$2e2bcd8739ae039)
    },
    {
        name: "addressBookController",
        controller: (0, $ace2e7fb53dfa262$export$2e2bcd8739ae039)
    },
    {
        name: "cardPreviewController",
        controller: (0, $223db6323b609d34$export$2e2bcd8739ae039)
    },
    {
        name: "cashOrderAmountController",
        controller: (0, $de9e13b2e36389b4$export$2e2bcd8739ae039)
    },
    {
        name: "cashPasskeyController",
        controller: (0, $482fa7740b66b7fb$export$2e2bcd8739ae039)
    },
    {
        name: "cashRevealController",
        controller: (0, $3d9d523c0a991033$export$2e2bcd8739ae039)
    },
    {
        name: "checkoutDepositEmbedController",
        controller: (0, $a1f594e67c215345$export$2e2bcd8739ae039)
    },
    {
        name: "createPasskeyController",
        controller: (0, $48d68d3a16ca0114$export$2e2bcd8739ae039)
    },
    {
        name: "cryptoSelectAssetController",
        controller: (0, $22532de6459e1986$export$2e2bcd8739ae039)
    },
    {
        name: "datePickerController",
        controller: (0, $4ff4204b59a5ca3a$export$2e2bcd8739ae039)
    },
    {
        name: "depositBestRouteController",
        controller: (0, $e5201a4290c704cf$export$2e2bcd8739ae039)
    },
    {
        name: "depositSuccessController",
        controller: (0, $0fa499a54af8a3e3$export$2e2bcd8739ae039)
    },
    {
        name: "depositWalletController",
        controller: (0, $5e3ea06fc0bbcc77$export$2e2bcd8739ae039)
    },
    {
        name: "embedController",
        controller: (0, $d5bf9e17054544c9$export$2e2bcd8739ae039)
    },
    {
        name: "feeBreakdownController",
        controller: (0, $a668f6ba336379e5$export$2e2bcd8739ae039)
    },
    {
        name: "formSubmitController",
        controller: (0, $9faadb2e87f40758$export$2e2bcd8739ae039)
    },
    {
        name: "formValidationController",
        controller: (0, $4ebef11e1590c665$export$2e2bcd8739ae039)
    },
    {
        name: "invoiceUploadController",
        controller: (0, $ac53d7f40e30149d$export$2e2bcd8739ae039)
    },
    {
        name: "loginController",
        controller: (0, $81d0eea0444ea03d$export$2e2bcd8739ae039)
    },
    {
        name: "maxAmountController",
        controller: (0, $55396f0c8de899b2$export$2e2bcd8739ae039)
    },
    {
        name: "meldCompareController",
        controller: (0, $a4855fc25d0b7643$export$2e2bcd8739ae039)
    },
    {
        name: "meldConfirmController",
        controller: (0, $0ba1a370a0e980c0$export$2e2bcd8739ae039)
    },
    {
        name: "meldDepositController",
        controller: (0, $b4a20be47a536640$export$2e2bcd8739ae039)
    },
    {
        name: "modalButtonController",
        controller: (0, $998045ec83f77af7$export$2e2bcd8739ae039)
    },
    {
        name: "modalController",
        controller: (0, $ee018b8705124014$export$2e2bcd8739ae039)
    },
    {
        name: "moneyController",
        controller: (0, $4fa0f36302d0d20e$export$2e2bcd8739ae039)
    },
    {
        name: "otpController",
        controller: (0, $af332ae9e5563cc0$export$2e2bcd8739ae039)
    },
    {
        name: "pasteWalletAddressController",
        controller: (0, $4b4aa57cfe6265c7$export$2e2bcd8739ae039)
    },
    {
        name: "pushToCardSendingController",
        controller: (0, $17565875cf361a46$export$2e2bcd8739ae039)
    },
    {
        name: "regionSelectController",
        controller: (0, $b8127b53e41c4c37$export$2e2bcd8739ae039)
    },
    {
        name: "removeBankAccountController",
        controller: (0, $e3566fe8e070b4b4$export$2e2bcd8739ae039)
    },
    {
        name: "removePasskeyController",
        controller: (0, $33e05a87bc3153cf$export$2e2bcd8739ae039)
    },
    {
        name: "rewardsTabsController",
        controller: (0, $a69a63ffbd70136d$export$2e2bcd8739ae039)
    },
    {
        name: "scanController",
        controller: (0, $3e64758101641bb9$export$2e2bcd8739ae039)
    },
    {
        name: "searchableSelectController",
        controller: (0, $4489ad58521d3dc3$export$2e2bcd8739ae039)
    },
    {
        name: "selectController",
        controller: (0, $38216c34aa0c2e48$export$2e2bcd8739ae039)
    },
    {
        name: "selectTriggerController",
        controller: (0, $fb154414b4c46189$export$2e2bcd8739ae039)
    },
    {
        name: "sendController",
        controller: (0, $09c8d1a5c6bda116$export$2e2bcd8739ae039)
    },
    {
        name: "signWithPasskeyController",
        controller: (0, $9fd18f8ea2bd2adf$export$2e2bcd8739ae039)
    },
    {
        name: "sumsubTestKycController",
        controller: (0, $412b74e4a616ebf1$export$2e2bcd8739ae039)
    },
    {
        name: "termsController",
        controller: (0, $f00701fdd67d1d43$export$2e2bcd8739ae039)
    },
    {
        name: "themeToggleController",
        controller: (0, $ad0bfd9e8d70f11c$export$2e2bcd8739ae039)
    },
    {
        name: "toastController",
        controller: (0, $19f69a9debbb50a9$export$2e2bcd8739ae039)
    },
    {
        name: "toggleController",
        controller: (0, $02dff06d0b373d99$export$2e2bcd8739ae039)
    },
    {
        name: "tooltipController",
        controller: (0, $4cdae2730ff5bd03$export$2e2bcd8739ae039)
    },
    {
        name: "withdrawCryptoConfirmationController",
        controller: (0, $926ec5fd96f10e22$export$2e2bcd8739ae039)
    },
    {
        name: "withdrawInitiatedController",
        controller: (0, $3ba8da1c856eaebf$export$2e2bcd8739ae039)
    },
    {
        name: "utility_ActiveLinkController",
        controller: (0, $890c481d0dd5b4c3$export$2e2bcd8739ae039)
    },
    {
        name: "utility_AnalyticsController",
        controller: (0, $bec33484964d7d36$export$2e2bcd8739ae039)
    },
    {
        name: "utility_BackgroundImageController",
        controller: (0, $d24155e38ad10359$export$2e2bcd8739ae039)
    },
    {
        name: "utility_BackgroundVideoController",
        controller: (0, $ba126a5df74935f5$export$2e2bcd8739ae039)
    },
    {
        name: "utility_ExpirationTimerController",
        controller: (0, $bd9cad85a6ad6d01$export$2e2bcd8739ae039)
    },
    {
        name: "utility_PageTransitionController",
        controller: (0, $0ceb68875daaca9b$export$2e2bcd8739ae039)
    },
    {
        name: "utility_PlatformController",
        controller: (0, $88ff8688ffe8c653$export$2e2bcd8739ae039)
    },
    {
        name: "utility_TimezoneController",
        controller: (0, $5169b9f8bbbce1c9$export$2e2bcd8739ae039)
    },
    {
        name: "ChartController",
        controller: (0, $1aedc2c2e170aecf$export$2e2bcd8739ae039)
    },
    {
        name: "NumpadController",
        controller: (0, $4619a6b19a4dfd26$export$2e2bcd8739ae039)
    },
    {
        name: "PaginationController",
        controller: (0, $b4559be34d47b192$export$2e2bcd8739ae039)
    },
    {
        name: "RobustTableController",
        controller: (0, $0413d9b98d9dc7e3$export$2e2bcd8739ae039)
    },
    {
        name: "ToastManagerController",
        controller: (0, $bb4058271b3865d4$export$2e2bcd8739ae039)
    },
    {
        name: "ToasterController",
        controller: (0, $c44f5fce0f233066$export$2e2bcd8739ae039)
    }
];



const $beccd9964712ac42$var$WELCOME_TEMPLATE_ID = "welcome-bottomsheet-template";
const $beccd9964712ac42$var$SHOW_DELAY_MS = 1000;
function $beccd9964712ac42$var$triggerWelcomeBottomsheet() {
    const template = document.getElementById($beccd9964712ac42$var$WELCOME_TEMPLATE_ID);
    if (!template) return;
    const streamHtml = template.innerHTML.trim();
    // Remove template so it doesn't fire again on subsequent turbo:load events.
    template.remove();
    if (!streamHtml) return;
    setTimeout(()=>{
        if (window.Turbo && typeof window.Turbo.renderStreamMessage === "function") window.Turbo.renderStreamMessage(streamHtml);
    }, $beccd9964712ac42$var$SHOW_DELAY_MS);
}
document.addEventListener("turbo:load", $beccd9964712ac42$var$triggerWelcomeBottomsheet);




// A frame response with no frame in it (a Cloudflare error or challenge page,
// our empty 403 for an expired CSRF token) would leave Turbo's "Content missing"
// on screen. Tell the user and take them home instead.
const $0c5fb6530e9d6a23$export$3ba4d343ed4f8613 = "/home";
const $0c5fb6530e9d6a23$export$ddc78ab3828d4338 = 1500;
const $0c5fb6530e9d6a23$var$FALLBACK_MESSAGE = "Something went wrong. Please try again later";
function $0c5fb6530e9d6a23$export$af03fb36a6993fe4(event, { toast: toast, translate: translate, visit: visit, schedule: schedule = setTimeout, log: log = console }) {
    event.preventDefault();
    // cf-ray finds the request in Cloudflare; cf-mitigated marks a challenge.
    const response = event.detail?.response;
    log.warn("Frame response had no frame to render", {
        frame: event.target?.id,
        status: response?.status,
        url: response?.url,
        cfRay: response?.headers?.get("cf-ray") || undefined,
        cfMitigated: response?.headers?.get("cf-mitigated") || undefined
    });
    try {
        toast(translate({
            error: {
                code: "INTERNAL"
            }
        }, $0c5fb6530e9d6a23$var$FALLBACK_MESSAGE));
    } catch (err) {
        log.warn("Could not show the error toast", err);
    }
    schedule(()=>visit($0c5fb6530e9d6a23$export$3ba4d343ed4f8613, {
            action: "replace"
        }), $0c5fb6530e9d6a23$export$ddc78ab3828d4338);
}


document.addEventListener("turbo:frame-missing", (event)=>(0, $0c5fb6530e9d6a23$export$af03fb36a6993fe4)(event, {
        toast: (message)=>(0, $e4096da1729505e0$export$2e2bcd8739ae039)(message, "error"),
        translate: (0, $7fd6c3b3bdbaa3c1$export$dbb77d813a78f040),
        visit: (url, options)=>window.Turbo.visit(url, options)
    }));
// Early PWA install prompt capture
window._pwaDeferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e)=>{
    e.preventDefault();
    window._pwaDeferredPrompt = e;
});
window.Stimulus = (0, $ffdf60ebf0144301$export$16975c34e60e1e61).start();
window.Stimulus.state = {};
Stimulus.debug = "true";
for (const { name: name, controller: controller } of (0, $35330220eba1dfe5$export$2e2bcd8739ae039)){
    const cleanName = name.replace("Controller", "").replace(/_/g, "-");
    const identifier = $b91bd2edbf6b213d$var$toIdentifier(cleanName);
    Stimulus.register(identifier, controller);
}
Stimulus.handleError = (error, message, detail)=>{
    (0, $c0e0e410f6c5ef5d$export$280f90b954565303)(message, detail, error);
};
var $69f1b4d634261b53$exports = {};
$69f1b4d634261b53$exports = $parcel$resolve("ghWye");


if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    navigator.serviceWorker.register($69f1b4d634261b53$exports).then((reg)=>console.log('Service Worker registered:', reg.scope)).catch((err)=>console.error('Service Worker registration failed:', err));
});
function $b91bd2edbf6b213d$var$toIdentifier(segment) {
    return segment.replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").replace(/_/g, "-").toLowerCase();
}

})();
//# sourceMappingURL=app.js.map
